export default{
  "data":[{
    "course_name": "Accounting for Business Operations",
    "dept": "ACCTG",
    "num": "231",
    "desc": "Prerequisite: MATH 100 and GENBA 110 or sophomore standing.\nAn introduction to the operating activities of businesses and the roles that accounting information plays in planning, evaluating, and recording those activities. An introduction to financial statements is included.",
    "credits": "3"
  },
  {
    "course_name": "Accounting for Investing and Financing",
    "dept": "ACCTG",
    "num": "241",
    "desc": "Prerequisite: ACCTG 231.\nExtends the concepts of planning and evaluation to the business activities of acquiring, disposing, and financing productive assets. Financial statement analysis will be covered.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Accounting Processes",
    "dept": "ACCTG",
    "num": "331",
    "desc": "Prerequisite: ACCTG 241.\nThis course should increase the knowledge and the understanding about the intermediate accounting processes found in a business entity.",
    "credits": "3"
  },
  {
    "course_name": "Taxation I",
    "dept": "ACCTG",
    "num": "342",
    "desc": "Prerequisite: ACCTG 331, or ACCTG 241 and senior standing.\nFundamental concepts of income determination in federal and state income tax regulations; examination of the impact of tax regulation on business and personal financial planning and decision making.",
    "credits": "3"
  },
  {
    "course_name": "Accounting Information Systems",
    "dept": "ACCTG",
    "num": "413",
    "desc": "Prerequisite: ACCTG 241.\nThis course should increase the knowledge and th understanding of the flow of information through an enterprise, the sources and nature of documents, and the controls necessary to insure the accuracy and reliability of information. The course will also incorporate information technology controls, current computer systems, data analytics, and software applications into the course.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Accounting",
    "dept": "ACCTG",
    "num": "431",
    "desc": "Prerequisite: Background of courses needed for the problems undertaken in accounting and consent of instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Managerial Reporting",
    "dept": "ACCTG",
    "num": "432",
    "desc": "Prerequisite: ACCTG 331, MANGT 421.\nIdentifying relevant accounting data and organizing, summarizing, and analyzing that data into information useful for planning and budgeting, decision making, controlling, and evaluating functions of management.",
    "credits": "3"
  },
  {
    "course_name": "Financial Reporting",
    "dept": "ACCTG",
    "num": "433",
    "desc": "Prerequisite: ACCTG 331.\nAn introduction to the U.S. and international rules and regulations that govern current reporting to external entities by profit entities.",
    "credits": "3"
  },
  {
    "course_name": "Accounting for Not-For-Profit Entities",
    "dept": "ACCTG",
    "num": "434",
    "desc": "Prerequisite: ACCTG 641\nAn introduction to the source of authoritative guidance, rules and regulations that govern current reporting to external entities by not-for-profit entities.",
    "credits": "2"
  },
  {
    "course_name": "Auditing I",
    "dept": "ACCTG",
    "num": "442",
    "desc": "Prerequisite: ACCTG 433, For accounting majors only.\nAn introduction to the environment of auditing and the objectives and techniques of both financial and operational auditing.",
    "credits": "3"
  },
  {
    "course_name": "Financial Statement Analysis",
    "dept": "ACCTG",
    "num": "445",
    "desc": "Prerequisite: ACCTG 231 and ACCTG 241, and FINAN 450.\nThis course will develop a student’s skills and knowledge in the analysis and interpretation of corporate financial statements and their related footnotes.  The class will encourage the student to think logically and creatively about the strengths and weaknesses of accounting information available to investors and shareholders.  The main course objective is for the student to be capable of doing an in-depth analysis of a company’s financial and operating performance from several financial statements.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "ACCTG",
    "num": "490",
    "desc": "Prerequisite: Consent of Instructor.\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Law for Accountants",
    "dept": "ACCTG",
    "num": "494",
    "desc": "Prerequisite: Senior standing.\nAn intensive study of an accountant’s professional responsibilities to the public and the profession and the knowledge of the legal implications of business transactions, particularly as they relate to accounting and auditing.",
    "credits": "3"
  },
  {
    "course_name": "Accounting Internship",
    "dept": "ACCTG",
    "num": "631",
    "desc": "\nProvides a full semester of practical accounting experience prior to entering graduate accounting program.",
    "credits": "0-3"
  },
  {
    "course_name": "Accounting Theory and History",
    "dept": "ACCTG",
    "num": "641",
    "desc": "Prerequisite: ACCTG 331.\nThe theories which underlie the practice of accounting and financial reporting including a historical perspective on the evolution of the theories.",
    "credits": "3"
  },
  {
    "course_name": "Accounting Research and Communication",
    "dept": "ACCTG",
    "num": "642",
    "desc": "Prerequisite: ACCTG 342, 433, and 442.\nUse of the sources of authoritative guidance in resolving complex, professionally oriented problems that include auditing, financial reporting, and tax reporting. Students analyze numerous unstructured cases and present their conclusion with written reports and oral presentations.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Financial Reporting",
    "dept": "ACCTG",
    "num": "731",
    "desc": "Prerequisite: ACCTG 433.\nAn examination of the reporting requirements of large (often multinational) corporations, e.g., foreign currency translation, interim and segment reporting, and business combinations.",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Studies Lab",
    "dept": "AERO",
    "num": "099",
    "desc": "Prerequisite: Instructor permission.\nThe leadership laboratory for aerospace studies. Students will receive leadership training and experience as well as training in Air Force customs and courtesies. This course runs concurrently with AERO 100, 200, 300, and 400 level classes; is required for all cadets; and includes mandatory physical fitness training.",
    "credits": "0"
  },
  {
    "course_name": "Aerospace Studies 1A",
    "dept": "AERO",
    "num": "110",
    "desc": "\nA study of the mission and organization of the United States Air Force; United States general purpose and aerospace support forces.",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Studies 1B",
    "dept": "AERO",
    "num": "111",
    "desc": "\nUnited States strategic offensive and defensive forces; their mission, function, and employment.",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Studies 2A",
    "dept": "AERO",
    "num": "210",
    "desc": "\nThe development of air power from its beginnings to the end of World War II. It traces the development of various concepts of employment of air power.",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Studies 2B",
    "dept": "AERO",
    "num": "211",
    "desc": "\nThe development of air power from the close of World War II to the present. It focuses upon factors which have prompted research and technological change and stresses significant examples of the impact of air power on strategic thought.",
    "credits": "1"
  },
  {
    "course_name": "AFROTC Summer Program",
    "dept": "AERO",
    "num": "215",
    "desc": "\nProvides AFROTC cadets up to 13 options for practical leadership and specialized training through exposure to USAF functions, deployments, and employment operations.  Foreign language and cultural immersions also available/possible but overall emphasis remains on leadership development and practicum.  All programs conducted off-site at selected Air Forces bases and other locations in the USA and abroad.",
    "credits": "1-4"
  },
  {
    "course_name": "Officer Leadership Studies 3A",
    "dept": "AERO",
    "num": "310",
    "desc": "\nA study of USAF professionalism, leadership, and management includes the meaning of professionalism, professional responsibilities, leadership theory, functions and practices, management principles and functions, problem solving, and management tools, practices, and controls.",
    "credits": "3"
  },
  {
    "course_name": "Officer Leadership Studies 3B",
    "dept": "AERO",
    "num": "311",
    "desc": "\nContinuation of AERO 310.",
    "credits": "3"
  },
  {
    "course_name": "Regional Studies and Defense Policy",
    "dept": "AERO",
    "num": "410",
    "desc": "\nExamine the role of the professional officer in a democratic society; socialization processes within the armed services; the requisites for maintaining adequate national security forces; political, economic, and social constraints upon the overall defense policy-making process.",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Studies/Civil Military Relationships",
    "dept": "AERO",
    "num": "411",
    "desc": "\nFocusing on the armed forces as an integral element of society, this course provides an examination of the broad range of American civil-military relations and the environmental context in which defense policy is formulated. Communicative skills are stressed. The role of contemporary aerospace power, and current and future employment of aerospace forces will also be examined. The last portion of this course concentrates on preparation for active duty military service.",
    "credits": "3"
  },
  {
    "course_name": "Problem Solving in Aerospace Studies",
    "dept": "AERO",
    "num": "499",
    "desc": "Prerequisite: Instructor consent.\nWork offered in any of the AFROTC general or professional courses for students out of phase for graduation; material covered in a basic or advanced course.",
    "credits": "1-3"
  },
  {
    "course_name": "African Study Abroad",
    "dept": "AFRI",
    "num": "400",
    "desc": "\nThe study abroad educational trip will provide students the opportunity to apply their knowledge of an African language and to learn first hand about various African societies and cultures, farming systems, environment, health and other issues related to their host country.",
    "credits": "1-4"
  },
  {
    "course_name": "Seminar I",
    "dept": "AFRI",
    "num": "501",
    "desc": "\nEconomics of Poverty and Wealth Creation in Africa (social science component). Explores opportunities for breaking the cycle of poverty across the continent using strategic wealth creation techniques that overcome poverty. Focusing on the agriculture and food system, the environment and natural resources, and the health of the African people.",
    "credits": "3"
  },
  {
    "course_name": "Seminar II",
    "dept": "AFRI",
    "num": "502",
    "desc": "\nAfrican Development. Introduction to current political and economic conditions facing Africa from historical, social, economic, political, and human context. Solutions to the current problems confronting the African continent are analyzed.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Communications Orientation",
    "dept": "AGCOM",
    "num": "100",
    "desc": "\nOrientation to the agricultural communications and journalism industry, on-campus resources, and college-level skill building.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Agricultural Communications",
    "dept": "AGCOM",
    "num": "110",
    "desc": "\nIntroduction to agricultural communications programs, activities, careers, and trends. This course will cover audience analysis across media platforms, Associated Press writing style, and understanding target audiences.",
    "credits": "2"
  },
  {
    "course_name": "Layout and Design Principles",
    "dept": "AGCOM",
    "num": "210",
    "desc": "Prerequisite: AGCOM 110.\nThis course uses leading industry-adopted software to develop printed communications pieces to the point of being “printer ready”, addressing design concepts and layout aspects critical to successfully printing a project.  Assignments will integrate software functionality and design concepts with print production technology requirements.",
    "credits": "3"
  },
  {
    "course_name": "Careers in Agricultural Communications",
    "dept": "AGCOM",
    "num": "300",
    "desc": "Prerequisite: Sophomore standing AND AGCOM 110 or concurrent enrollment.\nThis course provides students with advanced knowledge regarding careers in agricultural communications. Students will learn about how to find, apply for, and manage a position in agricultural communications, including topics related to job search, professional development, workplace conflict, portfolio development, interview skills, writing in a professional environment, and salary negotiation. An emphasis in workplace ethics through case studies and service learning will be provided.",
    "credits": "3"
  },
  {
    "course_name": "Communicating in the Agricultural Industry",
    "dept": "AGCOM",
    "num": "310",
    "desc": "\nThe purpose of this course is to help students identify the influence of communication styles and theories on agricultural issues. Agricultural sales will provide the experiential component for application of communication theory and interpersonal interactions.",
    "credits": "3"
  },
  {
    "course_name": "Application of Layout and Printing Techniques in Agriculture and Natural Resources",
    "dept": "AGCOM",
    "num": "345",
    "desc": "Prerequisite: AGCOM 210 or MC 341.\nThis course advances students’ understanding of how industry-adopted software and hardware are used to develop printed communications pieces, going from individual application functionality to application integration for developing and managing production projects.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Business Communications",
    "dept": "AGCOM",
    "num": "400",
    "desc": "Prerequisite: ENGL 100 and sophomore standing or above.\nWritten communications as used in agricultural industries. A writing course emphasizing the tools and techniques of writing memos, letters, short and long reports, proposals, and presentations.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Student Magazine",
    "dept": "AGCOM",
    "num": "410",
    "desc": "Prerequisite: AGCOM 345 and MC 200, MC 221 or MC 280.",
    "credits": "1-5"
  },
  {
    "course_name": "Topics in Agricultural Communications",
    "dept": "AGCOM",
    "num": "420",
    "desc": "Prerequisite: Consent of instructor.\nDiscussions of topics, studies, and activities important to agricultural communications.",
    "credits": "1-3"
  },
  {
    "course_name": "Undergraduate Research in Agricultural Communications",
    "dept": "AGCOM",
    "num": "425",
    "desc": "Prerequisite: Instructor permission.\nThis course uses qualitative, quantitative or mixed methods to conduct an agricultural and environmental communications research project. A faculty coordinator will assist students through the stages of conducting a research project and reporting its outcomes.",
    "credits": "0-3"
  },
  {
    "course_name": "Video in Agriculture and Food",
    "dept": "AGCOM",
    "num": "435",
    "desc": "Prerequisite: Junior standing AND AGCOM 110 or concurrent enrollment.\nTheory of visual storytelling is combined with basic and intermediate video camera and non-linear editing instruction to produce TV documentaries, magazine-type stories, and personal videos for web and broadcast distribution.",
    "credits": "3"
  },
  {
    "course_name": "Internship in Agricultural Communications",
    "dept": "AGCOM",
    "num": "550",
    "desc": "Prerequisite: AGCOM 300 AND instructor permission.\nThe intern works in a professional capacity in areas such as print journalism, electronic media, advertising, photography, and public relations. Student is supervised by a professional and a faculty member. One hour of credit for each four weeks of supervised work. Internship report and presentation required.",
    "credits": "1-3"
  },
  {
    "course_name": "New Media Technology",
    "dept": "AGCOM",
    "num": "590",
    "desc": "Prerequisite: Junior standing AND AGCOM 110 or concurrent enrollment.\nThis course focuses on the study and application of emerging “new media” technologies to effectively communicate information and market products and programs to general and targeted audiences.  Students will study underlying communication theories such as Roger’s Theory of Innovation Diffusion to provide a context of how society adopts and incorporates new technology.",
    "credits": "3"
  },
  {
    "course_name": "Capstone Seminar in Agricultural Communications",
    "dept": "AGCOM",
    "num": "600",
    "desc": "Prerequisites: AGCOM 310, AGCOM 435, and AGCOM 590.\nA capstone experience and project for agricultural communications and journalism students. Includes analysis of trends and issues in the field and discussion of communications planning.",
    "credits": "3"
  },
  {
    "course_name": "Crisis Communication",
    "dept": "AGCOM",
    "num": "610",
    "desc": "Prerequisite: Junior standing AND AGCOM 110 or concurrent enrollment OR instructor permission.\nFocus is placed on the application of effective crisis communication practices and techniques.  Students will learn relevant interpersonal and organizational communication theory, assess/evaluate organizational risks, and develop a crisis communication plan. Students will partner with a community business to create and deliver a comprehensive crisis plan.",
    "credits": "3"
  },
  {
    "course_name": "Study Experience in Agricultural Communications and Journalism",
    "dept": "AGCOM",
    "num": "650",
    "desc": "Prerequisite: Instructor permission.\nSeminar and travel course to prepare students before and after the experience and for students to analyze, critique and report their experiences associated with study tours and short courses.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Communication",
    "dept": "AGCOM",
    "num": "712",
    "desc": "Prerequisite: Senior standing.\nCombines theoretical discussions with practical experience regarding communication about environmental issues and provides introduction to natural and applied science topics related to the communications plan.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Agricultural Communications",
    "dept": "AGCOM",
    "num": "786",
    "desc": "\nExamination of current topics in agricultural communications.",
    "credits": "1-3"
  },
  {
    "course_name": "Agricultural Economics and Agribusiness Orientation",
    "dept": "AGEC",
    "num": "105",
    "desc": "\nIntroduction to agricultural economics and agribusiness programs, activities, resources, and careers. Required of all freshmen in agricultural economics or agribusiness at K-State.",
    "credits": "1"
  },
  {
    "course_name": "Decision Tools for Agricultural Economics and Agribusiness",
    "dept": "AGEC",
    "num": "115",
    "desc": "\nDevelopment of foundational computer-based empirical skills that address economic and business issues in food and agriculture. Students will learn how to model information on an issue or problem using mathematical spreadsheets to find relevant answers for decision makers and stakeholders.",
    "credits": "2"
  },
  {
    "course_name": "Agricultural Economics and Agribusiness",
    "dept": "AGEC",
    "num": "120",
    "desc": "\nA course suggested for all students interested in the agricultural economy. A study of economic principles, with emphasis on their application to the solution of farm, agribusiness, and agricultural industry problems in relationship to other sectors of the United States economy and foreign countries.",
    "credits": "3"
  },
  {
    "course_name": "Honors Agricultural Economics and Agribusiness",
    "dept": "AGEC",
    "num": "121",
    "desc": "Prerequisite: Admitted to university honors or college scholars program or instructor permission and eligible for honors program.\nA course suggested for all honors students interested in the agricultural economy. A study of economic principles, with emphasis on their application to the solution of farm, agribusiness, natural resource and agricultural industry problems in relationship to other sectors of the United States economy and foreign countries. The course will include extensive discussion, writing, and computer assignments on application of economic principles to real-world problems and issues.",
    "credits": "3"
  },
  {
    "course_name": "Small Business Operations",
    "dept": "AGEC",
    "num": "202",
    "desc": "Prerequisite: ECON 110 or AGEC 120 or AGEC 121 or ECON 120.\nOpportunities in business ownership, principles governing the starting of a small enterprise; importance, status, problems, and management of a small business.",
    "credits": "3"
  },
  {
    "course_name": "Grain and Livestock Marketing Systems",
    "dept": "AGEC",
    "num": "220",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120.\nSurvey of the institutions and mechanisms that facilitate and regulate the sale and marketing of grain and livestock commodities. Topics include the physical and informational flows in the commodity supply chains, cash pricing, commodity grades to improve market efficiency and the governmental regulations and agencies influencing commodity trading.",
    "credits": "3"
  },
  {
    "course_name": "Farm and Ranch Management",
    "dept": "AGEC",
    "num": "308",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120.\nDecision-making process, cost concepts, farm records and financial management, budgeting, time value of money, and introduction to whole farm/ranch planning.",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Issues in Global Food and Agricultural Systems",
    "dept": "AGEC",
    "num": "315",
    "desc": "Prerequisite: AGEC 120, AGEC 121, ECON 110, or ECON 120.\nA survey of contemporary economic issues affecting world agricultural systems including population growth, trade, globalization, natural resource and environmental policy.",
    "credits": "3"
  },
  {
    "course_name": "Food and Agribusiness Management",
    "dept": "AGEC",
    "num": "318",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120; and MATH 100.\nA study of marketing, production, risk, human resource management, and financial management in agribusiness firms. Particular attention is given to the application of economic principles to the management of marketing and farm supply firms.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Policy",
    "dept": "AGEC",
    "num": "410",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120 or ECON 110.\nInstitutional and analytical treatment of historical and current economic problems, public policies and government programs affecting agriculture and rural America.",
    "credits": "3"
  },
  {
    "course_name": "Commodity Futures",
    "dept": "AGEC",
    "num": "420",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120.\nThis course is designed to introduce students to the purpose, operation, and use of commodity futures and options markets. The objectives are to: (1) understand why futures exchanges and commodity futures contracts exist; (2) understand and be able to forecast basis; (3) understand hedging and be able to design hedging strategies for various commodity producers and users; (4) understand both put and call options and their potential use in a commodity risk management program; and (5) understand the usefulness and shortcomings of fundamental and technical analysis.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Economics and Agribusiness Seminar",
    "dept": "AGEC",
    "num": "441",
    "desc": "\nSeminars of special interest will be offered upon sufficient demand in selected areas relating to agricultural economics and agribusiness or competitive teams qualifying for academic credit.",
    "credits": "1-18"
  },
  {
    "course_name": "Agribusiness Internship",
    "dept": "AGEC",
    "num": "445",
    "desc": "Prerequisite: Instructor permission.\nApproved and supervised work-study programs in various areas of agribusiness.",
    "credits": "1-3"
  },
  {
    "course_name": "Agricultural Economics and Agribusiness Problems",
    "dept": "AGEC",
    "num": "450",
    "desc": "Prerequisite: Instructor permission.",
    "credits": "1-18"
  },
  {
    "course_name": "International Food and Agribusiness Study Tour",
    "dept": "AGEC",
    "num": "460",
    "desc": "Prerequisite: Instructor permission.\nAn experiential learning course to prepare students for and to immerse them in an international study tour of selected food and agribusiness industries.  The topics vary by the tour and the industries studied.",
    "credits": "0-6"
  },
  {
    "course_name": "Cooperative Management",
    "dept": "AGEC",
    "num": "470",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120.\nThis course focuses on the unique aspects of the cooperative business model and its evolution over time. Students will utilize course material to gain a deeper understanding of the history and need for cooperatives by applying economic, finance, marketing, and management tools to cooperatives.",
    "credits": "3"
  },
  {
    "course_name": "Production Economics",
    "dept": "AGEC",
    "num": "500",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120 and MATH 205.\nApplication of economic principles to problems of agricultural production. Analysis of consumer demand for agricultural products and input and output decisions of the agricultural firm. AGEC 505 is a continuation of this course and they are intended to be taken in consecutive semesters.",
    "credits": "3"
  },
  {
    "course_name": "Data Analysis and Optimization",
    "dept": "AGEC",
    "num": "501",
    "desc": "Prerequisite: AGEC 115, AGEC 120 or AGEC 121 or ECON 120, MATH 205, STAT 350.\nAnalysis of agricultural business and economic data and optimization for decision making.  Study applications of regression, time series analysis and forecasting to agricultural and economic data. Introduction to mathematical programming to model optimization of problems commonly encountered in agricultural economics.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Market Structures",
    "dept": "AGEC",
    "num": "505",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120 and MATH 205 and AGEC 500.\nTheory and application of economic principles to marketing problems in agriculture. Pricing of agricultural output and productive services under various forms of economic organization and competition; regional specialization, location, and trade; determinants of economic change; evaluation of economic and consumer welfare.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Finance",
    "dept": "AGEC",
    "num": "513",
    "desc": "Prerequisite: AGEC 308 or AGEC 318 and ACCTG 231.\nAnalysis of capital investments, interpretation of financial statements, capital structure considerations for agricultural firms, and farm real estate pricing.",
    "credits": "3"
  },
  {
    "course_name": "Food and Agribusiness Marketing",
    "dept": "AGEC",
    "num": "515",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120.\nA broad view of marketing; food markets and consumption; marketing functions and institutions; prices, competition, and marketing costs; functional and organizational issues; food marketing regulations; commodity marketing.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Law and Economics",
    "dept": "AGEC",
    "num": "516",
    "desc": "Prerequisite: ECON 110 or AGEC 120 or AGEC 121 or ECON 120 and junior standing.\nThe legal framework for decision making by farm firms, families, and individuals; liabilities, real and personal property, contracts, uniform commercial code, organization of farm firms, intergeneration property transfers, water law, fence law, federal and state regulatory power, insurance, income tax, and social security.",
    "credits": "3"
  },
  {
    "course_name": "Market Fundamentals and Futures/Options Trading",
    "dept": "AGEC",
    "num": "520",
    "desc": "Prerequisite: AGEC 420.\nThis is an experiential course in the trading of commodity futures and options. Attention is focused on the study of market price determination, the implications of market efficiency notions, and on actual trading of futures and options. Students invest in a commodity educational trading fund. Class approves recommendations by vote, orders are placed with a broker, and the class monitors open trades. The pool balance at the end of the semester is redistributed to students.",
    "credits": "3"
  },
  {
    "course_name": "Natural Resource and Environmental Economics",
    "dept": "AGEC",
    "num": "525",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120 or ECON 110 and junior standing.\nEmphasis on the application of demand, supply, and price concepts in the study of natural resource use, policies, and management. Interdependence between environmental quality and economic actions are examined through discussion of property rights, economic incentives, externalities, and economic components of environmental policies.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Sales",
    "dept": "AGEC",
    "num": "535",
    "desc": "Prerequisite: AGEC 318 or AGEC 515.\nAgricultural Sales will introduce students to the role of sales and sales management in the agricultural industry.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Economics and Agribusiness Seminar",
    "dept": "AGEC",
    "num": "541",
    "desc": "\nSeminars of special interest will be offered upon sufficient demand in selected areas relating to agricultural economics and agribusiness.",
    "credits": "1-18"
  },
  {
    "course_name": "Undergraduate Research in Agricultural Economics",
    "dept": "AGEC",
    "num": "550",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120, and consent of instructor.\nMentored undergraduate research experience in agricultural economics and agribusiness.",
    "credits": "0"
  },
  {
    "course_name": "Data Analytics for Agricultural Economics",
    "dept": "AGEC",
    "num": "560",
    "desc": "Prerequisite: AGEC 501\nAdvanced collection and applied analysis of agricultural business and economics data for decision making.  Applied communication of results and implications.",
    "credits": "3"
  },
  {
    "course_name": "Food Manufacturing, Distribution, and Retailing Economics",
    "dept": "AGEC",
    "num": "570",
    "desc": "Prerequisite: AGEC 318 or MANGT 420.\nAdvanced study of the economic and business aspects of the food industry from processing to distribution to retailing. Emerging trends in nutrition, food consumption, food safety and supply chain arrangements along with management and marketing issues in the food industry will be studied.",
    "credits": "3"
  },
  {
    "course_name": "Farm Management Strategies",
    "dept": "AGEC",
    "num": "598",
    "desc": "Prerequisite: AGEC 308, AGEC 500, and AGEC 513 or FINAN 450.\nA study of management concepts, tools, and decision strategies applied to farm firms. Alternative measures of farm business performances, as well as planning and evaluation techniques for an uncertain environment, are examined.",
    "credits": "3"
  },
  {
    "course_name": "Food and Agribusiness Management Strategies",
    "dept": "AGEC",
    "num": "599",
    "desc": "Prerequisite: AGEC 318, AGEC 500, and either AGEC 513 or FINAN 450. Recommended prerequisite: AGEC 515.\nThis course integrates the risk, production, marketing, and financial management strategies of agribusiness firms. Special attention is given to the application of economic theory and quantitative analysis to business decision-making processes. In addition to case studies, a variety of analytical techniques will focus on both markets and firms involved in the production and marketing of food commodities.",
    "credits": "3"
  },
  {
    "course_name": "Price Analysis and Forecasting",
    "dept": "AGEC",
    "num": "605",
    "desc": "Prerequisite: A course in statistics; AGEC 501; AGEC 505 or ECON 520.\nThe analysis of selected agricultural prices; application of regression analysis to price analysis, the role of futures markets and market efficiency, optimal hedging strategies, commodity option pricing, and price forecasting.",
    "credits": "3"
  },
  {
    "course_name": "Current Agriculture and Natural Resource Policy Issues",
    "dept": "AGEC",
    "num": "610",
    "desc": "Prerequisite: AGEC 505 and either AGEC 525 or AGEC 410.\nCurrent issues in agricultural and natural resource policy from divergent perspectives. Classroom discussion, debate, writing assignments, and student presentations. Current events are analyzed and synthesized from both economic and noneconomic perspectives. Topics may include environmental issues, international agricultural development, the politics of farm programs, and the relationship between technology, agriculture, and society.",
    "credits": "3"
  },
  {
    "course_name": "Global Agricultural and Economic Development",
    "dept": "AGEC",
    "num": "615",
    "desc": "Prerequisite: AGEC 315 and AGEC 500.\nThis course covers contemporary challenges in global development, with an emphasis on agricultural issues. Students will analyze problems using economic models, and develop empirical skills by learning key data collection concepts, and working with survey data. Topics include poverty, technology adoption, agricultural policy, health, and program evaluation.",
    "credits": "3"
  },
  {
    "course_name": "International Agricultural Trade",
    "dept": "AGEC",
    "num": "623",
    "desc": "Prerequisite: AGEC 505.\nApplied economics of agricultural trade. Emphasis on why trade occurs, current agricultural trade patterns, the effects of agricultural policy on trade, and the institutions of trade.",
    "credits": "3"
  },
  {
    "course_name": "Agribusiness Logistics",
    "dept": "AGEC",
    "num": "632",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120, and junior standing.\nPlanning for efficient use of transportation, storage and processing facilities in the handling of raw materials and products for agribusiness firms, controlling shipments and inventory in coordination with warehouse and handling operations, and scientific selection of routes, schedules, and equipment.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Economics and Agribusiness Seminar",
    "dept": "AGEC",
    "num": "641",
    "desc": "Prerequisite: Junior standing and instructor permission.\nSeminars of special interest will be offered upon sufficient demand in selected areas relating to agricultural economics and agribusinesses.",
    "credits": "1-18"
  },
  {
    "course_name": "Risk Management",
    "dept": "AGEC",
    "num": "680",
    "desc": "Prerequisite: AGEC 420, AGEC 513 or FINAN 450, and a course in statistics.\nAnalytical concepts and quantitative tools to make better decisions in risky situations. Identifying various types of risk an operation faces, measuring the degree of risk, and exploring ways to manage risk. Includes portfolio analysis, futures and options, contracting, and insurance. Emphasis on computer applications. Topics are focused on agriculture but are applicable to other industries and household decisions.",
    "credits": "3"
  },
  {
    "course_name": "Comparative Food and Agriculture Systems",
    "dept": "AGEC",
    "num": "710",
    "desc": "Prerequisite: AGEC 120 or AGEC 121 or ECON 120.\nThis course provides a comparative analysis of the business and economic situation of the food and agriculture sector around the world. The course will cover the European Union, the Former Soviet Union, MERCORSUR, and Southeast Asia, Oceania and possibly other regions. The course will focus briefly on the historical development, the current situation, and the future outlook of the food and agriculture sector. Upon completion of this course, students will be able to evaluate the comparative advantage of the United States in the production of food and fiber.",
    "credits": "3"
  },
  {
    "course_name": "Optimization Techniques for Agricultural Economics",
    "dept": "AGEC",
    "num": "712",
    "desc": "Prerequisite: AGEC 500 and AGEC  501, or graduate standing.\nApplication of optimization techniques including linear programming and nonlinear programming for research and decision analysis in agricultural economics.",
    "credits": "3"
  },
  {
    "course_name": "Sales and Marketing in the Global Animal Health Industry",
    "dept": "AGEC",
    "num": "735",
    "desc": "\nThis course is designed to introduce students to marketing and sales in the complex world of animal health industry.  Understanding product life cycles; product development; forecasting; planning; positioning and branding; as well as promotion and compliance. Markets addressed include business to business food animal markets and companion animal consumer markets.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Agricultural Economics Analysis",
    "dept": "AGEC",
    "num": "740",
    "desc": "Prerequisite: Consent of instructor.\nSeminar on methods of economic analysis.",
    "credits": "1-18"
  },
  {
    "course_name": "Agricultural Economics and Agribusiness Problems",
    "dept": "AGEC",
    "num": "750",
    "desc": "Prerequisite: Junior standing and consent of the instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Risk Management Fellows Seminar",
    "dept": "AGEC",
    "num": "751",
    "desc": "Prerequisite: Junior standing, admitted to the Risk Management Fellows Program, and consent of the instructor.\nThis course serves as The Center for Risk Management Education and Research Student Fellows seminar course.  Students will conduct a risk management research project.",
    "credits": "1"
  },
  {
    "course_name": "Economics of the Global Animal Health Industry",
    "dept": "AGEC",
    "num": "780",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Equipment and Material Management",
    "dept": "AGED",
    "num": "210",
    "desc": "Prerequisite: Agricultural Education Major.\nProvides a foundation for teaching and managing laboratories related to power, structural and technical systems.  Laboratory safety procedures and practices will be applied to the instructional setting. Includes material selection &amp; management, project planning &amp; design and facility management.",
    "credits": "1"
  },
  {
    "course_name": "Emerging Technologies in Power, Structural, and Technical Systems",
    "dept": "AGED",
    "num": "212",
    "desc": "Prerequisite: AGED 210.\nThe continual evolution of the agricultural mechanics industry, necessitates the introduction of emerging practices and equipment to new teachers. The course includes demonstrations, hands-on activities, and field trips to be used in high school programs.",
    "credits": "1"
  },
  {
    "course_name": "Agricultural Construction",
    "dept": "AGED",
    "num": "260",
    "desc": "\nProvide students with the theory, knowledge and skills necessary for the construction/fabrication of metal projects. Emphasis will be placed on: laboratory safety, general laboratory measurements, metal identification/ characteristics, oxyacetylene welding and cutting, shielded metal arc welding (SMAW), gas metal arc welding (GMAW), gas tungsten arc welding (GTAW), plasma cutting, and project construction.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Structures",
    "dept": "AGED",
    "num": "262",
    "desc": "\nProvide students with the theory, knowledge and skills necessary for the construction/fabrication agricultural structure type projects. Emphasis will be placed on: laboratory safety, general laboratory measurements, material selection, basic construction techniques, electrical theory and operation, plumbing theory and operation, concrete theory and construction, and basic surveying.",
    "credits": "2"
  },
  {
    "course_name": "Agricultural Power",
    "dept": "AGED",
    "num": "264",
    "desc": "\nProvide students with the theory, knowledge and skills necessary for the repair and maintenance of small gas engines and basic hydraulic systems. Emphasis will be placed on: laboratory safety, general laboratory measurements, engine operation, compression, fuel, governor, electrical, cooling, lubrication systems, engine troubleshooting and basic hydraulics.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Agricultural Education",
    "dept": "AGED",
    "num": "300",
    "desc": "\nIntroduction to the program responsibilities, methodology, organization, current trends and issues, and future direction of programs in agricultural education. Students will be actively involved in the discussion and application of course material both in the classroom and in early field experiences conducted as a part of this course.",
    "credits": "1"
  },
  {
    "course_name": "Leadership and Professional Development in Agricultural Education",
    "dept": "AGED",
    "num": "400",
    "desc": "\nThis course provides an introduction to the leadership skills needed in the role of FFA advisor and professional agricultural educator including career, professional, and student leadership development and FFA chapter management.",
    "credits": "2"
  },
  {
    "course_name": "Undergraduate Research in Agricultural Education",
    "dept": "AGED",
    "num": "490",
    "desc": "Prerequisite: Instructor permission.\nThis course uses qualitative, quantitative or mixed methods to conduct an agricultural education research project. A faculty supervisor will assist students through the stages of identifying, conducting and reporting the results of a social science research project connected to an agricultural education topic.",
    "credits": "0-3"
  },
  {
    "course_name": "Methods of Teaching Agriculture in the Secondary and Middle Schools",
    "dept": "AGED",
    "num": "500",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDCI 320.  Concurrent enrollment required for EDSEC 455, 477, AGED 520, AGED 600, and EDCEP 525.\nPrinciples of teaching applied to content area instruction in the secondary and middle schools; motivation; organization of subject matter; lesson planning; evaluation and reporting; challenging the levels of ability; organization and management of the classroom; methodology and materials of the secondary schools.",
    "credits": "3"
  },
  {
    "course_name": "Teaching Adult Classes in Agriculture",
    "dept": "AGED",
    "num": "503",
    "desc": "Prerequisite: EDSEC 620.\nOrganization and preparation of materials and methods used in teaching adult classes in vocational education in agriculture for young farmers and adults. Departments are visited for evaluation of programs and results.",
    "credits": "2-3"
  },
  {
    "course_name": "Field Experience in Agricultural Education",
    "dept": "AGED",
    "num": "505",
    "desc": "Prerequisite: AGED 300 or concurrent enrollment.\nA course for prospective teachers to help bridge the gap between classroom theory and student teaching. Emphasis will be on observation of and participation in school and community organizations and programs.",
    "credits": "1"
  },
  {
    "course_name": "Block II Lab: Content Area Methods and Field Experience",
    "dept": "AGED",
    "num": "520",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDCI 320.  Concurrent enrollment required for EDSEC 455, 477, AGED 500 and EDCEP 525.\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate agricultural education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Senior Seminar in Agricultural Education",
    "dept": "AGED",
    "num": "600",
    "desc": "\nDiscussion and application of Block II learning outcomes in the student to professional educator transition. Topics will include professional development, licensure, professional opportunities and the community of Agricultural and Extension Education.",
    "credits": "0"
  },
  {
    "course_name": "Laboratory and Safety Techniques in Teaching Agriculture",
    "dept": "AGED",
    "num": "615",
    "desc": "Prerequisite: Concurrent enrollment in AGED 520.\nThe course is designed to provide students with the knowledge and skills necessary to design, organize, and conduct programs in agricultural laboratory instruction in secondary agricultural education programs. Students will gain experiences in the development of laboratory lesson plans, safety and technical demonstrations, student management in a laboratory setting, laboratory design, and laboratory curriculum development.",
    "credits": "3"
  },
  {
    "course_name": "Program Planning in Agricultural Education",
    "dept": "AGED",
    "num": "621",
    "desc": "Prerequisite: EDSEC 620.\nThe program development and planning process; development of guides for teaching and evaluating reimbursable secondary programs.",
    "credits": "3"
  },
  {
    "course_name": "Inquiry-Based Curriculum in Agricultural STEM and Biotechnology Education",
    "dept": "AGED",
    "num": "625",
    "desc": "Prerequisite: Junior Standing.\nProvides students with knowledge of inquiry-based techniques related to STEM and Biotechnology in the context of Agriculture. Students will experience activities, labs, and projects developed for inclusion in secondary agriculture classrooms. The learning environment will be grounded in specific agricultural content area, offered on a rotational basis (ex.comprehensive agriculture, animal systems, plant systems, ag power and technology, etc).",
    "credits": "3"
  },
  {
    "course_name": "Exploration of Global Agricultural Education",
    "dept": "AGED",
    "num": "630",
    "desc": "\nEducation Abroad for the exploration of the agriculture industry and agricultural education system in an international location.",
    "credits": "3"
  },
  {
    "course_name": "Extension Organization and Programs",
    "dept": "AGED",
    "num": "704",
    "desc": "Prerequisite: Senior standing.\nDevelopment and objectives of Cooperative Extension and other university adult education programs; with emphasis on programs and procedures.",
    "credits": "3"
  },
  {
    "course_name": "Organization Problems in Teaching Agricultural Mechanics",
    "dept": "AGED",
    "num": "705",
    "desc": "Prerequisite: EDSEC 586.\nAnalysis of the agricultural mechanics course of study; needs and interests of students; learning difficulties; skills and technical knowledge required; correlation with agriculture; application of laws of learning to the teaching process; determination of objectives.",
    "credits": "1-18"
  },
  {
    "course_name": "Principles of Teaching Adults in Extension",
    "dept": "AGED",
    "num": "706",
    "desc": "Prerequisite: Senior standing.\nMethods and principles of adult teaching with emphasis on Cooperative Extension Service; application to various adult education programs.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Agriculture-Related Occupations",
    "dept": "AGED",
    "num": "734",
    "desc": "Prerequisite: Consent of instructor.\nRelated occupational or professional experiences in approved industry, school, Cooperative Extension Service, or similar agency setting under faculty supervision.",
    "credits": "1-6"
  },
  {
    "course_name": "Practicum in Extension Education",
    "dept": "AGED",
    "num": "736",
    "desc": "Prerequisite: Consent of instructor.\nRelated occupational or professional experiences in approved industry, school, Cooperative Extension Service, or similar agency setting under faculty supervision.",
    "credits": "1-6"
  },
  {
    "course_name": "Topics in Agricultural Education",
    "dept": "AGED",
    "num": "786",
    "desc": "\nExamination of current topics in agricultural education.",
    "credits": "1-3"
  },
  {
    "course_name": "Agronomy Orientation",
    "dept": "AGRON",
    "num": "101",
    "desc": "\nIntroduction to agronomy options, activities, resources, and careers.  Required of all freshmen in agronomy at K-State.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Precision Ag Software",
    "dept": "AGRON",
    "num": "202",
    "desc": "\nIntroduction to software commonly used for the management and analysis of various forms of agronomic data pertaining to soils, crops, and weather for the purpose of generating site-specific recommendations in crop production.",
    "credits": "3"
  },
  {
    "course_name": "Crop Science",
    "dept": "AGRON",
    "num": "220",
    "desc": "\nPrinciples underlying practices used in the culture of grain and forage crops. Crop classification, structure, growth, and improvement. Crop response to environmental factors, soils, and pests and associated management practices. Laboratories will cover crop botany, crop development, and problem solving. A basic course for majors in agronomy and others interested in crop production.",
    "credits": "4"
  },
  {
    "course_name": "Agronomy International Study Tour",
    "dept": "AGRON",
    "num": "302",
    "desc": "\nAn experiential learning course to prepare students for and to immerse them in an international study tour of selected agronomic industries. The topics vary by the tour and the industries studied.",
    "credits": "0-6"
  },
  {
    "course_name": "Soils",
    "dept": "AGRON",
    "num": "305",
    "desc": "Prerequisite: CHM 110 or 210.\nFundamental chemical, physical, and biological properties of soils; their formation, fertility, and management.",
    "credits": "4"
  },
  {
    "course_name": "Weed Science",
    "dept": "AGRON",
    "num": "330",
    "desc": "Prerequisite: AGRON 220.\nFor those interested in crop production, crop protection, and agricultural education. Considers the origin of weeds, their relations to crops, and control systems emphasizing cultural, mechanical, biological, and chemical practices. Includes weed identification.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Quality",
    "dept": "AGRON",
    "num": "335",
    "desc": "\nAn examination and survey of topics in environmental quality. Includes classification of soil, air, and water pollutants and their interaction with the environment, including the human food chain. Discussion of remediation techniques, risk assessment, and environmental legislation.",
    "credits": "3"
  },
  {
    "course_name": "Grain Grading",
    "dept": "AGRON",
    "num": "340",
    "desc": "\nProcedures for grading grains, emphasizing soybeans, corn, wheat, and sorghum. Identification and evaluation of kernel damage and other conditions determining grades of these grains.",
    "credits": "2"
  },
  {
    "course_name": "Plant and Seed Identification",
    "dept": "AGRON",
    "num": "350",
    "desc": "\nIdentification of crops and weeds by seed and vegetative characteristics. Analysis of seed samples for impurities.",
    "credits": "2"
  },
  {
    "course_name": "Crop Growth and Development",
    "dept": "AGRON",
    "num": "360",
    "desc": "Prerequisite: CHM 110 or CHM 210. Recommended prerequisite: AGRON 220 and AGRON 305.\nComparative growth and development of warm- and cool-season monocot and dicot crops. Environmental influences on growth and development processes and management techniques to minimize stresses.",
    "credits": "3"
  },
  {
    "course_name": "Soil Fertility",
    "dept": "AGRON",
    "num": "375",
    "desc": "Prerequisite: AGRON 305. Recommended prerequisite: AGRON 220.\nDetailed information on the plant nutrition, soil fertility, and fertilizer management of the essential macro- and micronutrients. The influence of numerous soil biological, physical, and chemical properties on plant nutrient availability to crops will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Soil Fertility Laboratory",
    "dept": "AGRON",
    "num": "385",
    "desc": "Prerequisite: AGRON 375 or concurrent enrollment.\nDetailed information on (1) the chemical methods utilized in routine soil testing and plant analysis, (2) field soil sampling techniques, (3) fertilizer recommendations, and (4) fertilizer response functions. Soil chemistry and computer laboratory exercises are designed to reinforce the theoretical principles presented in lectures.",
    "credits": "2"
  },
  {
    "course_name": "Undergraduate Topics in Agronomy",
    "dept": "AGRON",
    "num": "400",
    "desc": "Prerequisite: Consent of instructor.\nSpecial topics in agronomy not completely treated in other courses.",
    "credits": "1-3"
  },
  {
    "course_name": "Internship in Agronomy",
    "dept": "AGRON",
    "num": "405",
    "desc": "Prerequisite: AGRON 220 and 305.\nIntern programs in various areas of agronomy. One hour credit for each four weeks of supervised and evaluated work experience with cooperating employers. A maximum of 3 hours may be applied to the major in agronomy.",
    "credits": "0-3"
  },
  {
    "course_name": "Soils Judging",
    "dept": "AGRON",
    "num": "415",
    "desc": "\nTechniques employed in writing descriptions of soil morphology and in classifying soils for intercollegiate soils judging.",
    "credits": "0-1"
  },
  {
    "course_name": "Crops Team",
    "dept": "AGRON",
    "num": "450",
    "desc": "\nGrain grading, seed and plant identification, and seed analysis. Studies lead to participation in intercollegiate crops contest.",
    "credits": "0-2"
  },
  {
    "course_name": "Range Management",
    "dept": "AGRON",
    "num": "501",
    "desc": "\nFundamental ecological principles of production, conservation, and use of grasslands. Application of these fundamental principles to management.",
    "credits": "3"
  },
  {
    "course_name": "International Experience in Agronomy",
    "dept": "AGRON",
    "num": "502",
    "desc": "Prerequisite: 14 hours in AGRON including AGRON 220 and AGRON 305.\nStudents will apply knowledge gained in their undergraduate curriculum in a culminating learning experience focused on international crops, soils, and agronomic systems. Topics vary by offering depending on the agronomic systems studied and locations visited.",
    "credits": "0-6"
  },
  {
    "course_name": "Emerging Topics in Agronomy",
    "dept": "AGRON",
    "num": "503",
    "desc": "\nThis course will provide a platform for in-depth discussion of emerging topics in the agronomic field. Topics that have immediate relevance in crop production, plant breeding, range science, soil fertility, soil management, and soil and water quality are discussed. Experts in fields outside of agronomy will often be guest facilitators in this course.",
    "credits": "3"
  },
  {
    "course_name": "Soil Genesis and Classification",
    "dept": "AGRON",
    "num": "515",
    "desc": "\nFactors and processes of soil formation, classification of soils according to soil taxonomy, and use of soil survey information. Practical field experience describing soil properties. Required field trips.",
    "credits": "3"
  },
  {
    "course_name": "Forage Management and Utilization",
    "dept": "AGRON",
    "num": "550",
    "desc": "\nProduction and utilization of forage crops. Development of forage programs for livestock production, including pasture and stored forages.",
    "credits": "3"
  },
  {
    "course_name": "Forage Management and Utilization Laboratory",
    "dept": "AGRON",
    "num": "551",
    "desc": "Prerequisite: Completion of or concurrent enrollment in AGRON 550.\nIdentification of forage species, techniques for estimating forage quality, forage physiology, and field trips.",
    "credits": "1"
  },
  {
    "course_name": "Field Identification of Range and Pasture Plants",
    "dept": "AGRON",
    "num": "560",
    "desc": "\nIdentification of range pasture plants through exposure to them in their natural environment.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research in Agronomy",
    "dept": "AGRON",
    "num": "598",
    "desc": "\nIndependent research experience guided by faculty in crop science, weed science, range science, or soil science.",
    "credits": "0-18"
  },
  {
    "course_name": "Crop Problems",
    "dept": "AGRON",
    "num": "600",
    "desc": "\nStudies may be chosen in: genetics, crop improvement, forages, ecology, weed control, plant physiology, or crop production.",
    "credits": "1-18"
  },
  {
    "course_name": "Agronomy Capstone Experience",
    "dept": "AGRON",
    "num": "602",
    "desc": "Prerequisite: Senior standing.\nA culminating learning experience to apply the knowledge gained by the student in the undergraduate curriculum, to apply the skills of problem-solving and critical thinking, and to develop the ability to work in teams and participate in civil discourses. Current issues in Agronomy will be discussed and a team project will be completed.",
    "credits": "3"
  },
  {
    "course_name": "Soil and Environmental Chemistry",
    "dept": "AGRON",
    "num": "605",
    "desc": "\nA study of inorganic and organic chemistry of soils with a detailed examination of the solid, liquid, and gaseous phases. Includes discussions of mineral solubility, electrochemical and adsorption phenomena, acidity, salinity, and fertility. Emphasis is placed on the biogeochemical cycling of plant nutrients and important soil contaminants.",
    "credits": "3"
  },
  {
    "course_name": "Biotechnology",
    "dept": "AGRON",
    "num": "610",
    "desc": "Prerequisite: ASI 500 or BIOL 450.\nThe use of biotechnology and molecular genetic approaches in plant and animal sciences. Emphasis is on the use of molecular techniques for plant and animal improvement.",
    "credits": "3"
  },
  {
    "course_name": "Soil Problems",
    "dept": "AGRON",
    "num": "615",
    "desc": "\nStudies may be chosen in: chemistry, physics, conservation, fertility, genesis, morphology, or classification.",
    "credits": "1-18"
  },
  {
    "course_name": "Applications of Nutrient Management",
    "dept": "AGRON",
    "num": "625",
    "desc": "\nPrinciples for developing plant nutrient management programs in the Great Plains. Topics include assessing crop nutrient needs, making fertilizer recommendations, applying application technology and products to enhance nutrient use efficiency, using sensing technology to assess in-season nutrient needs, quality control functions, and the use of waste products as nutrient sources.",
    "credits": "3"
  },
  {
    "course_name": "Crop Improvement and Biotechnology",
    "dept": "AGRON",
    "num": "630",
    "desc": "\nTechniques in basic plant breeding and biotechnology used to genetically improve crops and procedures to increase, distribute, and maintain breeding stocks and varieties.",
    "credits": "3"
  },
  {
    "course_name": "Soil and Water Conservation",
    "dept": "AGRON",
    "num": "635",
    "desc": "\nPrinciples, mechanics, and prediction of water and wind erosion. Influence of soil erosion on soil productivity and environmental quality. Conservation management technologies for erosion control, water management, and sustaining soil productivity. Legislation and land-use planning for soil conservation.",
    "credits": "3"
  },
  {
    "course_name": "Cropping Systems",
    "dept": "AGRON",
    "num": "640",
    "desc": "\nPrinciples for developing and managing cropping systems in the Great Plains for the efficient use of natural resources, primarily water. Emphasis on dryland cropping systems, management of crop rotations, and the plant/soil/environment interaction. Includes the efficient use of natural resources via an understanding of yield limiting factors, impact of crop rotations and cultural practices, climate, plant growth, and development.",
    "credits": "3"
  },
  {
    "course_name": "Bioenergy Feedstock Production",
    "dept": "AGRON",
    "num": "642",
    "desc": "\nOverview of production and characteristics of cultivated crops, perennial grasses, and woody species as feedstocks for bioenergy. Fundamentals of plant growth factors, culture, harvest and storage, quality and improvement, and introduction to environmental impact, modeling, and resource utilization. Knowledge of Microsoft-compatible word processing and spreadsheet programs including graphing is required.",
    "credits": "3"
  },
  {
    "course_name": "Soil Microbiology",
    "dept": "AGRON",
    "num": "645",
    "desc": "\nThe nature and function of soil microorganisms in the soil ecosystem. The role of soil microbial activity to soil organic matter, mineral transformations, plant nutrition, and environmental quality.",
    "credits": "3"
  },
  {
    "course_name": "Soil Microbiology Laboratory",
    "dept": "AGRON",
    "num": "646",
    "desc": "Prerequisite: AGRON 645 or concurrent enrollment.\nDiscuss and perform laboratory procedures for enumerating soil microorganisms, quantifying soil biological activities, and nutrient cycling.",
    "credits": "1"
  },
  {
    "course_name": "Integrated Weed Management",
    "dept": "AGRON",
    "num": "650",
    "desc": "Prerequisite: AGRON 330.\nThe development of weed management systems based on diagnosis of weed and crop problems, understanding crop-weed associations and interactions with the environment, and integrating weed control tactics such as chemical, biological, cultural, and mechanical practices into recommendations.",
    "credits": "3"
  },
  {
    "course_name": "Site Specific Agriculture",
    "dept": "AGRON",
    "num": "655",
    "desc": "\nIntroduction to spatial analysis and management of agricultural and environmental resources using Geographic Information Systems (GIS) technology. Emphasis on collecting, displaying, and analyzing spatial or georeferenced soil, crop, or other land surface data.",
    "credits": "3"
  },
  {
    "course_name": "Grassland Monitoring and Assessment",
    "dept": "AGRON",
    "num": "660",
    "desc": "\nVegetation sampling techniques used in rangeland research and for grassland monitoring and assessment. Use of statistics for sampling, analysis, and presentation of data.",
    "credits": "2"
  },
  {
    "course_name": "Grassland Monitoring and Assessment Lab",
    "dept": "AGRON",
    "num": "661",
    "desc": "Prerequisite: AGRON 660 or concurrent enrollment.\nA field laboratory course designed as a companion to AGRON 660. Labs will consist of methods used for determination of biomass, basal cover, frequency, and density. Additional time will be spent on basic statistics, experimental design, and use of the microcomputer in analyzing data sets.",
    "credits": "1"
  },
  {
    "course_name": "Rangeland Watershed Management",
    "dept": "AGRON",
    "num": "662",
    "desc": "\nStudy of the management of physical/biological settings and processes along with human activities on water and watersheds considering preventative and restorative strategies in a natural resource rangeland setting. Web-based distance AG*IDEA course.",
    "credits": "3"
  },
  {
    "course_name": "Range Management Problems",
    "dept": "AGRON",
    "num": "670",
    "desc": "",
    "credits": "1-18"
  },
  {
    "course_name": "Plant Genetics",
    "dept": "AGRON",
    "num": "680",
    "desc": "Prerequisite: ASI 500 or BIOL 450.\nConcepts and application of basic genetic principles in higher plants.",
    "credits": "3"
  },
  {
    "course_name": "Range Ecology",
    "dept": "AGRON",
    "num": "681",
    "desc": "\nApplication of ecological principles to range ecosystem management. Study of plant-soil-animal interactions with rangelands, and discussion of plant succession, environmental influences, and ecological concepts.",
    "credits": "3"
  },
  {
    "course_name": "Grassland Fire Ecology",
    "dept": "AGRON",
    "num": "682",
    "desc": "\nThe course is designed to describe the ecological effects of fire on grassland ecosystems. It also provides insight into the history of fires, the people who use them and why, the parts of a afire, how fires behave in relation to fuel and weather, and the conducting and safety of prescribed burns. Web-based distance AG*IDEA course.",
    "credits": "3"
  },
  {
    "course_name": "Tropical Soil Management",
    "dept": "AGRON",
    "num": "685",
    "desc": "\nCharacteristics of agriculture in tropical conditions with a focus on the environment and soils. Includes discussion of soil management systems in tropical agriculture that use conventional methods as well as methods that emphasize sustainability including no-till, crop rotation, and cover crops.",
    "credits": "3"
  },
  {
    "course_name": "Climate Change and Agriculture",
    "dept": "AGRON",
    "num": "695",
    "desc": "Prerequisite: Junior or senior standing.\nImpact of climate and climate change on agricultural systems and soil and water resources at global and regional scales. Discussion on adaptation and mitigation strategies including economics and policies that affect agriculture.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Meteorology",
    "dept": "AGRON",
    "num": "700",
    "desc": "Prerequisite: PHYS 113.\nFundamental concepts of meteorology and climatology and their applications to agriculture.",
    "credits": "3"
  },
  {
    "course_name": "Plant and Soil Chemometrics",
    "dept": "AGRON",
    "num": "722",
    "desc": "\nIntroduction to the field of remote sensing chemometrics for characterizing the chemical and physical properties of organic and inorganic materials using a spectroradiometer.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Plant Resistance to Pests",
    "dept": "AGRON",
    "num": "732",
    "desc": "Prerequisite: ENTOM 300 or PLPTH 500 or ENTOM 312, and one course in plant or animal genetics.\nBasic concepts of the biology, ecology, genetics and breeding for pest resistance in plants.",
    "credits": "2"
  },
  {
    "course_name": "Environmental Soil Physics",
    "dept": "AGRON",
    "num": "746",
    "desc": "\nA conceptual and quantitative introductory study of vadose zone soil physical properties and processes in relation to the main components of the hydrologic cycle and the soil surface energy balance.",
    "credits": "3"
  },
  {
    "course_name": "Range Grasses",
    "dept": "AGRON",
    "num": "762",
    "desc": "\nField and laboratory study of range and pasture plants, with special emphasis on grasses and their distinguishing characteristics.",
    "credits": "2"
  },
  {
    "course_name": "Ecology of Invasive Species",
    "dept": "AGRON",
    "num": "781",
    "desc": "\nEcological principles and their application to invasive species. Discussion of population, community and ecosystem level characteristics affecting a wide variety of invasive plant and animal species. Discussions will include current global consequences and governmental policies/programs designed to limit the spread of invasives. Web-based distance AG*IDEA course.",
    "credits": "3"
  },
  {
    "course_name": "Range Management Planning",
    "dept": "AGRON",
    "num": "790",
    "desc": "\nInventory and analysis of rangeland resources and development of detailed management plan. Emphasizes range management principles and practices useful in maximizing production from rangelands.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to American Ethnic Studies",
    "dept": "AMETH",
    "num": "160",
    "desc": "\nThis course introduces students to the major concepts related to ethnicity and to some of the major American ethnic groups.",
    "credits": "3"
  },
  {
    "course_name": "Intercultural Competence in Institutions",
    "dept": "AMETH",
    "num": "300",
    "desc": "\nPrepares students to understand and appreciate America’s race relations and its diverse histories. Emphasis on implementing cultural competency in various social settings.",
    "credits": "3"
  },
  {
    "course_name": "African American Perspectives",
    "dept": "AMETH",
    "num": "351",
    "desc": "\nA critical examination of African American experience in the context of U.S. society and institutions. The analysis will consider the interrelationships between and among various African American groups and “mainstream” America, and their corresponding nationalities and regions of origin.",
    "credits": "3"
  },
  {
    "course_name": "American Indian Perspectives",
    "dept": "AMETH",
    "num": "352",
    "desc": "\nA critical examination of American Indian experience in the context of U.S. society and institutions. The analysis will consider the interrelationships between and among various American Indians and “mainstream” America, American Indian nations and/or tribes.",
    "credits": "3"
  },
  {
    "course_name": "Latina/o Perspectives",
    "dept": "AMETH",
    "num": "353",
    "desc": "\nA critical examination of U.S. Latina/o experience in the context of American society and institutions.  The analysis will consider the interrelationships between and among various Latina/o groups, “mainstream” America, and their corresponding nationalities and regions of origins.",
    "credits": "3"
  },
  {
    "course_name": "Asian American Perspectives",
    "dept": "AMETH",
    "num": "354",
    "desc": "\nA critical examination of Asian American experience in the context of U.S. society and institutions. The analysis will consider the interrelationships between and among various Asian American groups, “mainstream” America, and their corresponding nationalities and regions of origin.",
    "credits": "3"
  },
  {
    "course_name": "Politics of Women of Color",
    "dept": "AMETH",
    "num": "370",
    "desc": "\nExplores the coalitional politics of women of color from its earliest formation as the “Third World Women’s Alliance” in the 1960s to its manifestation in present-day movements like “Incite! Women of Color Against Violence.”",
    "credits": "3"
  },
  {
    "course_name": "Comparative Ethnic Studies",
    "dept": "AMETH",
    "num": "450",
    "desc": "\nProvides a comparative framework for understanding both the specificities within and the differences between the situations of racially marginalized groups in the U.S. and beyond.",
    "credits": "3"
  },
  {
    "course_name": "Independent Reading and Research in American Ethnic Studies",
    "dept": "AMETH",
    "num": "460",
    "desc": "Prerequisite: AMETH 160, at least one other American ethnic studies course and permission of instructor.\nGuided reading and research on a specific topic of student interest, leading to preparation of a research paper or creative work.",
    "credits": "1-3"
  },
  {
    "course_name": "Transformative Thought",
    "dept": "AMETH",
    "num": "461",
    "desc": "\nEngages a range of advanced theories and critical concepts in American Ethnic Studies, including the intersections of race, ethnicity, gender, class, indigeneity, (dis)ability, citizenship, and sexuality.",
    "credits": "3"
  },
  {
    "course_name": "Senior Research Project in American Ethnic Studies",
    "dept": "AMETH",
    "num": "499",
    "desc": "Prerequisite: AMETH 160.\nGuided research in American ethnic studies. Students prepare a research paper on a relevant subject of their choice. Each student is responsible for arranging to work with a member of the American ethnic studies faculty.",
    "credits": "3"
  },
  {
    "course_name": "Recitation Leadership",
    "dept": "AMETH",
    "num": "501",
    "desc": "\nIntegrative review of concepts in American ethnic studies under faculty supervision. Preparation for leading discussions, workshops and reviews in American ethnic studies. Students attend two lecture sessions per week concurrent with AMETH 160, one additional seminar session focused on planning and preparation for recitations, and are responsible for leading discussions in one or more recitation sections in AMETH 160 per week.",
    "credits": "1-3"
  },
  {
    "course_name": "Practicing Social Justice",
    "dept": "AMETH",
    "num": "550",
    "desc": "Prerequisite: AMETH 160.\nStudents engage in a praxis-based social justice project with an organization, program, creative movement, or research project that engages and supports underrepresented communities. Students enhance their practical experience in ethnic studies by participating in an internship, or doing social justice performance art, or engaging in participatory action research, or conducting intercultural competence training.",
    "credits": "3"
  },
  {
    "course_name": "Multicultural Psychology",
    "dept": "AMETH",
    "num": "556",
    "desc": "\nTo introduce and familiarize students with the concept of multicultural.",
    "credits": "3"
  },
  {
    "course_name": "Topics in American Ethnic Studies",
    "dept": "AMETH",
    "num": "560",
    "desc": "\nSelected topics of special interest in American Ethnic Studies.",
    "credits": "1-4"
  },
  {
    "course_name": "Independent Reading and Research in American Ethnic Studies",
    "dept": "AMETH",
    "num": "660",
    "desc": "Prerequisite: Senior or graduate standing and permission of instructor.\nAdvanced guided reading and research on a specific topic of student interest, leading to preparation of a research paper or creative work.",
    "credits": "1-3"
  },
  {
    "course_name": "Advanced Topics in American Ethnic Studies",
    "dept": "AMETH",
    "num": "700",
    "desc": "\nProvides students the opportunity to investigate topics in American Ethnic Studies that enable greater depth and complexity of understanding of field’s methodological approaches and specializations.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Cultural Anthropology",
    "dept": "ANTH",
    "num": "200",
    "desc": "\nIntroduction to ethnology and ethnography; analysis and comparison of technological, social, and religious characteristics of cultural systems.",
    "credits": "3"
  },
  {
    "course_name": "A General Education Introduction to Cultural Anthropology",
    "dept": "ANTH",
    "num": "204",
    "desc": "\nIntroduction to ethnology and ethnography; analysis and comparison of technological, social, and religious characteristics of cultural systems.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Cultural Anthropology, Honors",
    "dept": "ANTH",
    "num": "210",
    "desc": "\nIntroduction to basic ethnology and ethnography; technological, social, and religious characteristics of cultural systems; discussion and independent study.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Linguistic Anthropology",
    "dept": "ANTH",
    "num": "220",
    "desc": "\nLanguage as a part of human behavior: its origins, uses and abuses, and ways of defining reality. Basic descriptive and ethnosemantic skills used by anthropologists to learn languages in the field.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Archeology",
    "dept": "ANTH",
    "num": "260",
    "desc": "\nBrief introduction to the field of anthropological archeology.  General survey of world prehistory revealing major cultural changes from the development of early foraging societies through the rise of agricultural and complex communities.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Biological Anthropology",
    "dept": "ANTH",
    "num": "280",
    "desc": "\nProvides knowledge regarding the scope of Biological Anthropology, and develop an understanding of: 1) evolutionary theory and evolutionary processes, 2) patterns of adaptation to the environment in primates, and 3) human evolution, human adaptation and human variation. Key concepts/perspectives will include: evolution, selection, adaptation genetics, population genetics, as well as variation and variability.",
    "credits": "4"
  },
  {
    "course_name": "Initiation to Anthropology",
    "dept": "ANTH",
    "num": "301",
    "desc": "Prerequisite: Declared Anthropology Major/Minor or Instructor permission.\nIdentify and apply the core elements of the anthropological perspective while learning professional and academic writing and presentation skills.",
    "credits": "3"
  },
  {
    "course_name": "Cultures of South Asia",
    "dept": "ANTH",
    "num": "305",
    "desc": "Prerequisite: ANTH 200, 204 or 210.\nProvides an interdisciplinary exploration of the disparate cultures and communities of the South Asian region.  We will examine thematic issues of colonization, religion, nationalism, modernity, sexuality, gender, globalization and social stratification in their various South Asian contexts.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Anthropology: Living with Change in the Anthropocene",
    "dept": "ANTH",
    "num": "310",
    "desc": "\nExplores anthropological and human science approaches to the complex causes and consequences of environmental change, including climate change, mass species extinction, industrial pollution, and deforestation.  Students learn about economic, cultural, and political drivers of environmental degradation and discuss solutions for a more sustainable future from the perspective of social and cultural theory.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the World’s Religions",
    "dept": "ANTH",
    "num": "314",
    "desc": "\nSurvey of religious beliefs, practices, and experiences from around the world. Emphasis is on religious practices and experiences in different cultural contexts.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Medical Anthropology",
    "dept": "ANTH",
    "num": "315",
    "desc": "\nExplores disease, illness, and medical systems from a cross-cultural perspective.  Includes the impacts of culture, gender, wealth inequality and other structural conditions on health and well-being.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Cultural Anthropology",
    "dept": "ANTH",
    "num": "318",
    "desc": "\nExploration of problems in cultural anthropology for both majors and non-majors.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Linguistic Anthropology",
    "dept": "ANTH",
    "num": "328",
    "desc": "\nExploration of problems in linguistic anthropology for both majors and non-majors.",
    "credits": "3"
  },
  {
    "course_name": "Topics for Educators",
    "dept": "ANTH",
    "num": "350",
    "desc": "\nExamination of selected topics in archaeology, cultural, or linguistic anthropology designed to address education standards in the social sciences.",
    "credits": "1-4"
  },
  {
    "course_name": "Special Studies in Anthropology",
    "dept": "ANTH",
    "num": "351",
    "desc": "\nExplores topics in anthropology through guided field trips (study abroad or domestic excursion).",
    "credits": "1-3"
  },
  {
    "course_name": "Archaeological Myths and Mysteries",
    "dept": "ANTH",
    "num": "364",
    "desc": "\nIntroduces evidence-based thinking and the scientific method in archaeology through evaluation of “mysteries” of our human past.  Explores social factors affecting interpretation of past cultures.  Case studies include who “discovered” the Americas, ancient alien intervention, Atlantis, myth of the mound builders, and more.",
    "credits": "3"
  },
  {
    "course_name": "Exploring Kansas Archaeology",
    "dept": "ANTH",
    "num": "365",
    "desc": "\nExploration of the archaeological record of past Native people of Kansas and the Central Plains and their diverse lifeways.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Archaeology",
    "dept": "ANTH",
    "num": "368",
    "desc": "\nExploration of problems in archaeology for both majors and non-majors.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Human Evolution",
    "dept": "ANTH",
    "num": "380",
    "desc": "\nSurvey of the human fossil record, including an introduction to evolutionary theory and a discussion of the place that humans occupy among the other primates.",
    "credits": "3"
  },
  {
    "course_name": "Plagues: The Co-Evolutionary History of Humans and Pathogens",
    "dept": "ANTH",
    "num": "383",
    "desc": "\nThe course will explore the proximate (mechanistic/physiological) and ultimate (evolutionary) causes of disease from a biocultural and historical perspective.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Physical Anthropology",
    "dept": "ANTH",
    "num": "388",
    "desc": "\nExploration of problems in physical anthropology for both majors and non-majors.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Anthropology",
    "dept": "ANTH",
    "num": "399",
    "desc": "\nReadings and discussion of selected topics.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "ANTH",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Proficiency Development",
    "dept": "ANTH",
    "num": "501",
    "desc": "Prerequisite: Consent of instructor and superior performance in relevant course.\nIntegrative review of anthropological concepts and skills under faculty supervision. For single students or groups of students. Not applicable to major field requirements.",
    "credits": "0-3"
  },
  {
    "course_name": "South Asian Civilizations",
    "dept": "ANTH",
    "num": "505",
    "desc": "Prerequisite: 3 hours of social science or junior standing.\nInterdisciplinary survey of the development of civilizations in India, Pakistan, Sri Lanka, Bangladesh, Nepal, Bhutan, and Afghanistan, including geography, philosophy, social, economic, political institution, and historical movements.",
    "credits": "3"
  },
  {
    "course_name": "Central America: Its Peoples and Problems",
    "dept": "ANTH",
    "num": "506",
    "desc": "Prerequisite: ANTH 200.\nAn anthropological perspective of the interactions of indigenous and foreign populations with an examination of the geographic, social, economic, political, and ideological bases of the problems facing Central America today. A look at the seven countries composing Central America in terms of their particular problems and unique solutions.",
    "credits": "3"
  },
  {
    "course_name": "Cultures of Africa",
    "dept": "ANTH",
    "num": "509",
    "desc": "\nFamily life, subsistence patterns, exchange systems, languages, religions, and development of the peoples of Africa.",
    "credits": "3"
  },
  {
    "course_name": "Political Anthropology",
    "dept": "ANTH",
    "num": "512",
    "desc": "Prerequisite: Sophomore standing.\nEthnological approaches to politics in societies around the world. Structural-functional, evolutionary, and conflict theories. A comparison of the political systems of small-scale and complex societies: political modernization.",
    "credits": "3"
  },
  {
    "course_name": "Immigrant America",
    "dept": "ANTH",
    "num": "513",
    "desc": "Prerequisite: ANTH 200, 204, or 210.\nDiscussion of post-1965 immigration to the United States with a focus on Asian and Latino newcomers. Immigrant adaptation, economic strategies and the reinterpretation of cultural identity. Implications for American society.",
    "credits": "3"
  },
  {
    "course_name": "Creativity and Culture",
    "dept": "ANTH",
    "num": "515",
    "desc": "Prerequisite: ANTH 200, 204, or 210.\nHow ethnologists view the expressive and creative aspects of culture. A cross-cultural survey of the verbal, visual, and performing arts.",
    "credits": "3"
  },
  {
    "course_name": "Ethnomusicology",
    "dept": "ANTH",
    "num": "516",
    "desc": "Prerequisite: ANTH 200, 204, or 210.\nEthnic, popular, and traditional musics from around the world. The course samples a wide range of stylistic traditions from Africa, Asia, Oceania, Europe, and the Americas. Emphasis is on understanding musical style in cultural context.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Cultural Anthropology",
    "dept": "ANTH",
    "num": "518",
    "desc": "Prerequisite: ANTH 200, 204, or 210.\nIntensive exploration of problems in cultural anthropology for both majors and non-majors with adequate background.",
    "credits": "1-4"
  },
  {
    "course_name": "Language and Culture",
    "dept": "ANTH",
    "num": "525",
    "desc": "Prerequisite: ANTH 220 or consent of instructor.\nStudy of language and dialect as aspects of social and ethnic group identities. Emphasis on analysis of conversational style in diverse cultural settings. Research project to be determined according to student interests.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Linguistic Anthropology",
    "dept": "ANTH",
    "num": "528",
    "desc": "Prerequisite: ANTH 220.\nIntensive exploration of problems in linguistic anthropology for both major and non-majors with adequate background.",
    "credits": "1-4"
  },
  {
    "course_name": "Archaeological Fact or Fiction: Applied Critical Thinking",
    "dept": "ANTH",
    "num": "560",
    "desc": "Prerequisite: ANTH 260 or equivalent.\nExplores and develops practical critical thinking and research skills using archaeological approaches and case studies. Examines impact of interpretation of the human past on past and present populations.",
    "credits": "3"
  },
  {
    "course_name": "Archaeological Field Methods",
    "dept": "ANTH",
    "num": "561",
    "desc": "Prerequisite: Instructor consent (application required).\nProvides hands-on training in archaeological field methods (i.e., data collection and documentation through archaeological survey and excavation) as part of a research project.",
    "credits": "1-9"
  },
  {
    "course_name": "Archaeological Laboratory Methods",
    "dept": "ANTH",
    "num": "562",
    "desc": "Prerequisite: ANTH 260 or equivalent.\nHands-on instruction in and application of professional principles of processing, analyzing, and interpreting artifacts and related archeological materials.",
    "credits": "3"
  },
  {
    "course_name": "Applied Archaeology",
    "dept": "ANTH",
    "num": "563",
    "desc": "Prerequisite: ANTH 260 or its equivalent.\nTraining in professional and ethical practice in cultural resource management and public archaeology.",
    "credits": "3"
  },
  {
    "course_name": "North American Archaeology",
    "dept": "ANTH",
    "num": "565",
    "desc": "Prerequisite: ANTH 260.\nThe prehistoric of native cultures of North America explored through the archaeological record from the peopling of the continent, to the spread of agriculture and village life, up to contact period.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Archaeology",
    "dept": "ANTH",
    "num": "568",
    "desc": "Prerequisite: ANTH 260.\nIntensive exploration of archaeological problems for both major and non-majors with adequate background.",
    "credits": "1-4"
  },
  {
    "course_name": "Topics in Physical Anthropology",
    "dept": "ANTH",
    "num": "588",
    "desc": "Prerequisite: ANTH 280 and 281.\nIntensive exploration of problems in physical anthropology for both major and non-majors with adequate background.",
    "credits": "1-4"
  },
  {
    "course_name": "Anthropological Theory",
    "dept": "ANTH",
    "num": "602",
    "desc": "Prerequisite: ANTH 200 or 210.\nReview and integration of the major theoretical approaches in the principal branches of anthropology.",
    "credits": "3"
  },
  {
    "course_name": "North American Indians",
    "dept": "ANTH",
    "num": "605",
    "desc": "Prerequisite: ANTH 200 or 210 or 260.\nDescription and comparison of native cultures of Canada and the United States; culture contact and change among surviving groups.",
    "credits": "3"
  },
  {
    "course_name": "South American Indians",
    "dept": "ANTH",
    "num": "606",
    "desc": "Prerequisite: ANTH 200 or 210 or 260.\nA survey of the nature and variability of the original cultures of Latin America. Analysis of sample cultures, stressing economic, social, political, and religious structures.",
    "credits": "3"
  },
  {
    "course_name": "Asian Religions",
    "dept": "ANTH",
    "num": "608",
    "desc": "Prerequisite: ANTH 200, ANTH 204, or ANTH 210.\nExplore religious beliefs and practices in major traditions of South, Southeast, Central, and East Asia, such as Hinduism, Buddhism, Jainism, Sikhism, Confucianism, Taoism, Shinto, and later Buddhist movements.",
    "credits": "3"
  },
  {
    "course_name": "Ethnohistory",
    "dept": "ANTH",
    "num": "612",
    "desc": "Prerequisite: ANTH 200 or 204 or equivalent.\nIntroduction to ethnohistory as an anthropological research method.",
    "credits": "3"
  },
  {
    "course_name": "Gender, Power, and International Development",
    "dept": "ANTH",
    "num": "613",
    "desc": "Prerequisite: SOCIO 211 or ANTH 200 or ANTH 210 and 3 additional hours in sociology or cultural anthropology.\nExamination of various models of development and their impact on various roles of woman and men in various cultures. Emphasis upon Africa, Asia, and Latin America. Comparisons of public, service, and economics sectors, including agriculture, marketing, and industry. Examination of policy issues.",
    "credits": "3"
  },
  {
    "course_name": "Race and Culture",
    "dept": "ANTH",
    "num": "615",
    "desc": "Prerequisite: ANTH 200, 210 or 280.\nThe biological meaning of race; the interrelationships of biological and cultural traits in human evolution; processes of racial formation of man; methods of classifying human races; cultural inheritance; the distinction of race, culture, personality, and intelligence; a review of modern racism; race as an evolutionary episode.",
    "credits": "3"
  },
  {
    "course_name": "Anthropology of the Future: Apocalypse, Prophecy, and Hope",
    "dept": "ANTH",
    "num": "616",
    "desc": "Prerequisite: ANTH 200, 204, or 210.\nThis seminar course will explore culturally construction notion of “the future” by exploring discourses of time, divination, utopia, prophecy, world-endings and world-renewals from various societies around the world.",
    "credits": "3"
  },
  {
    "course_name": "Religion in Culture",
    "dept": "ANTH",
    "num": "618",
    "desc": "Prerequisite: ANTH 200 or ANTH 210 or SOCIO 211.\nThe nature of religion in different cultural systems.",
    "credits": "3"
  },
  {
    "course_name": "Internship in Applied Anthropology",
    "dept": "ANTH",
    "num": "651",
    "desc": "Prerequisite: ANTH 519 and junior and consent of program coordinator.\nSupervised field experience of at least three weeks full time or 150 hours part time with an organization or institution in the application of anthropological approaches to problem solving and working in a professional setting. Emphasis is on anthropological skills in relation to the objectives and operations of an institution.",
    "credits": "3"
  },
  {
    "course_name": "Internship in Museology",
    "dept": "ANTH",
    "num": "652",
    "desc": "Prerequisite: ANTH 200 or 210 or 260.\nPractical professional museum experience of at least three weeks full time or 150 hours part time in the processing of collections, conservation, cataloging, archive and library maintenance, and/or planning and preparation of exhibits.",
    "credits": "3"
  },
  {
    "course_name": "Independent Reading and Research in Anthropology",
    "dept": "ANTH",
    "num": "659",
    "desc": "Prerequisite: Three hours of anthropology and consent of instructor.\nGuided reading and research on a specific anthropological topic of student interest, leading to preparation of a research paper.",
    "credits": "1-3"
  },
  {
    "course_name": "Andean Archaeology",
    "dept": "ANTH",
    "num": "663",
    "desc": "Prerequisite: ANTH 260.\nExamines the economic, social, and political development of the region, including the Tawantinsuya (Inca Empire). Covers the adoption of agriculture; the origin of the state; power; and the role of religion, cosmology, ideology, and art.",
    "credits": "3"
  },
  {
    "course_name": "European Archaeology",
    "dept": "ANTH",
    "num": "665",
    "desc": "Prerequisite: ANTH 260.",
    "credits": "3"
  },
  {
    "course_name": "Forensic Anthropology",
    "dept": "ANTH",
    "num": "680",
    "desc": "Prerequisite: A life science with laboratory requirement in the College of Arts and Sciences or the consent of the instructor.\nAnthropological survey of the predominantly biological areas of forensic science, their methods and techniques, as they pertain to the application of that science to the purpose of the law. Particular emphasis will be given to perspectives about the science itself, its application to anthropology, and the unique ways in which that science may be used by law.",
    "credits": "4"
  },
  {
    "course_name": "Primatology",
    "dept": "ANTH",
    "num": "681",
    "desc": "Prerequisite: ANTH 280 or consent of instructor.\nSurvey of the primate order including considerations of evolution, morphology, and behavior. Particular emphasis will be given to developing perspectives about the origin and evolution of hominids in the context of the primate order.",
    "credits": "3"
  },
  {
    "course_name": "Human Growth and Development",
    "dept": "ANTH",
    "num": "682",
    "desc": "Prerequisite: ANTH 280 or instructor’s permission.\nProvides an anthropological examination of the process of growth and development in humans that emphasizes both the biological, evolutionary, and cultural aspects that have shaped them through time. Emphasis is given to the evolution of the life cycle, as well as the social and environmental conditions that affect human growth.",
    "credits": "3"
  },
  {
    "course_name": "Osteology",
    "dept": "ANTH",
    "num": "683",
    "desc": "Prerequisite: ANTH 280 or consent of instructor.\nDetailed study of human skeleton, with special attention to health and demographic conditions in prehistoric cultures and the evaluation of physical characteristics and genetic relationships of prehistoric populations. Laboratory demonstration and exercise in working with skeletal material for analysis of sex, age, stature, and race. Complete metric and nonmetric analysis with consideration given to paleodemography, paleopathology in situ analysis and excavation, and preservation.",
    "credits": "4"
  },
  {
    "course_name": "Bioarchaeology",
    "dept": "ANTH",
    "num": "686",
    "desc": "Prerequisite: ANTH 280 or instructor’s consent.\nExplores how archaeologists and bioanthropologists approach the study of death, mortuary practices and skeletal remains, to reconstruct past lives and understand the associated behavior.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Osteology",
    "dept": "ANTH",
    "num": "687",
    "desc": "Prerequisite: ANTH 694 and 695.\nAnalysis of human and nonhuman skeletal remains including age, sex, stature, race, anomalities, pathologies, trauma, metric and nonmetric traits, cause of death, and time since death. This course allows greater breadth and depth of osteological analysis than either ANTH 694 or 695, and allows for more concentration on individual methods and techniques and case studies.",
    "credits": "2"
  },
  {
    "course_name": "Paleoanthropology",
    "dept": "ANTH",
    "num": "688",
    "desc": "Prerequisite: ANTH 200 or 280 or consent of instructor.\nHuman origins and evolution as indicated by fossil evidence; interpretation of man-apes, Pithecanthropus, Neanderthal, Cro-Magnon, and other major fossil groups within the context of evolutionary theory, primate comparisons, and cultural evolution.",
    "credits": "3"
  },
  {
    "course_name": "Writing Cultures: Ethnographic Methods",
    "dept": "ANTH",
    "num": "710",
    "desc": "Prerequisite: ANTH 200, 204, or 210.\nAn introduction to qualitative field methods and research ethics in cultural anthropology. Students will examine issues of truth, representation, and reflexivity in ethnographic writing.",
    "credits": "3"
  },
  {
    "course_name": "Research Methods in Digital Ethnography",
    "dept": "ANTH",
    "num": "715",
    "desc": "Prerequisite: Consent of instructor.\nA hands-on exploration of the uses of digital technology for ethnographic research and representation.",
    "credits": "3"
  },
  {
    "course_name": "Field Methods in Linguistics",
    "dept": "ANTH",
    "num": "720",
    "desc": "Prerequisite: ANTH 220 or LING 280.\nTechniques of collecting and analyzing linguistic data in the field. Work with language consultants in class, on languages such as Swahili.",
    "credits": "3"
  },
  {
    "course_name": "Cardiorespiratory Exercise Physiology",
    "dept": "AP",
    "num": "601",
    "desc": "Prerequisite: 6 hrs in Kinesiology 500 and above. Only 6 hours may be counted toward degree.\nIntensive study of a selected topic in kinesiology involving either great in-depth study, or application of theory presented in a related course.",
    "credits": "3"
  },
  {
    "course_name": "Cardiovascular Exercise Physiology",
    "dept": "AP",
    "num": "603",
    "desc": "Prerequisite: KIN 250 and 335.\nAn examination of the structure and function of the respiratory system and the manner in which oxygen passes from the atmosphere to its site of utilization in the mitochondria. Exercise and environmental stresses will form the basis for examining the capacity, plasticity and limitations to respiratory function.",
    "credits": "3"
  },
  {
    "course_name": "Gross Anatomy I",
    "dept": "AP",
    "num": "700",
    "desc": "Prerequisite: First-year standing in College of Veterinary Medicine or consent of the instructor.\nGross dissection of the dog with comparative aspects of the cat.",
    "credits": "5"
  },
  {
    "course_name": "Gross Anatomy II",
    "dept": "AP",
    "num": "705",
    "desc": "Prerequisite: AP 700.\nGross dissection of the horse and ruminant with comparative aspects of the pig, laboratory animals, and the chicken.",
    "credits": "5"
  },
  {
    "course_name": "Microscopic Anatomy I",
    "dept": "AP",
    "num": "710",
    "desc": "Prerequisite: First-year standing in College of Veterinary Medicine.\nOrigin, development, and microscopic structure and appearance of the cells and tissues of the animal body.",
    "credits": "5"
  },
  {
    "course_name": "Stem Cells and Comparative Biomedicine",
    "dept": "AP",
    "num": "711",
    "desc": "\nCharacteristics of major categories of stem cells. Applicable or potential clinical uses, including their utilization in tissue engineering or targeted delivery of therapeutics.",
    "credits": "2"
  },
  {
    "course_name": "Cross-Course Integration I",
    "dept": "AP",
    "num": "730",
    "desc": "Prerequisite: First-year standing in the College of Veterinary Medicine or consent of instructor.\nVertical and horizontal integration among semester courses to improve student cognitive retention and understanding of core content. Structure-function relationships will be emphasized to facilitate student assimilation and provide clinical relevance to basic science content.",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Physiology I",
    "dept": "AP",
    "num": "737",
    "desc": "Prerequisite: First-year standing in College of Veterinary Medicine or consent of instructor.\nFunction of the animal body at the cellular level, including nerve and muscle function. Basic pathophysiological mechanisms and intermediary metabolism will be emphasized and correlated with clinical topics.",
    "credits": "5"
  },
  {
    "course_name": "Cross-Course Integration II",
    "dept": "AP",
    "num": "740",
    "desc": "Prerequisite: AP 730 or consent of instructor.\nVertical and horizontal integration within and between semester courses to improve student cognitive retention and understanding of core content. Structure-function relationships will be emphasized to facilitate student assimilation and provide clinical relevance to basic science content.",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Physiology II",
    "dept": "AP",
    "num": "747",
    "desc": "Prerequisite: AP 737.\nFunction of the cardiovascular, endocrine, respiratory, renal, digestive, and reproductive systems of domestic animals with emphasis on physiologic control mechanisms, interrelationships of body systems, and criteria for evaluating animal health.",
    "credits": "6"
  },
  {
    "course_name": "Pharmacology I",
    "dept": "AP",
    "num": "770",
    "desc": "Prerequisite: AP 737 and 747 or equivalent.\nThe basic principles of pharmacology, the interactions of drugs and living systems including fundamental principles of pharmacokinetics, pharmacodynamics, receptor-coupling, and mechanisms of action. A systems-based approach to drug classes will be emphasized.",
    "credits": "4"
  },
  {
    "course_name": "Pharmacology II",
    "dept": "AP",
    "num": "772",
    "desc": "Prerequisite: Student must have a “C” or higher in AP 770, Pharmacology I and DMP 712. Veterinary Bacteriology and Mycology.\nThe basic principles of pharmacology, the relationship of drug actions and interactions on physiological principles and pathophysiological conditions. Pharmacokinetics, pharmacodynamics, and a systems-based approach to drug classes will be emphasized.",
    "credits": "2"
  },
  {
    "course_name": "Bioinstrumentation Laboratory",
    "dept": "AP",
    "num": "773",
    "desc": "Prerequisite: AP 747 or equivalent and concurrent enrollment in ECE 772.\nPractical experience with and evaluation of laboratory and clinical techniques related to electrodes, transducers, computer-based data acquisition and analysis.",
    "credits": "1"
  },
  {
    "course_name": "Practical Use and Interpretation of Veterinary Scientific Literature",
    "dept": "AP",
    "num": "780",
    "desc": "\nDesigned primarily for veterinary students in the first, second or third year of the DVM curriculum. The course is intended to teach literature search skills, organization of your own literature library, and critical evaluation of clinical reports and research literature.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Veterinary Medicine and Biomedical Research: Concepts and Values",
    "dept": "AP",
    "num": "785",
    "desc": "\nThis course is intended to provide first-year students an opportunity to experience the depth of veterinary/biomedical research required to advance the practice of veterinary medicine, and advance the field of medicine in general.  The students will examine the challenges of conducting 1) foundational and translation research (genetic/genomic and mechanistic research), 2) foundational and applications to clinical research 3) population and observational research (epidemiology, prospective clinical trials, retrospective studies), 4) pharmacologic research (the impact of pharmacology on the biomedical sciences).  The students will examine relevant connections, consider conceptual relationships, and critically evaluate integrative issues germane to both the practice of and the innovative progress of veterinary medicine.  Faculty members in the Departments of A&amp;P, DM/P, and CS, will present topical overviews, based on their professional experiences. This will be designed to connect and integrate fundamental principles and relationships between research and clinical application.  These presentations provide examples of the fundamental requirements for clinical therapies and also provide examples of how innovative science leads to new therapies for long standing clinical disease.  Additionally, students will learn the tools required to search relevant topic to their career paths within the medical literature.  Finally, drawing on the multidisciplinary literature presented by faculty, students will explore the challenges in conducting genetic/genomic research, using genomic information, implementing research results to clinical practice, as well as addressing the social, legal, and professional policies that are emerging from new research. Students will be expected to do reading and to complete online worksheets and present their findings/opinions in class. Class time will be devoted to presentations and to discussion of readings and related current events.",
    "credits": "1"
  },
  {
    "course_name": "Basic and Applied Pharmacokinetics",
    "dept": "AP",
    "num": "788",
    "desc": "\nThis course is designed to provide students with fundamental concepts and principles of absorption, distribution, metabolism and elimination of drugs, environmental chemicals, and nanomaterials by the body. The course also covers actual applications of the pharmacokinetic knowledge using case studies of commonly dosed drugs, common environmental contaminants, and nanomaterials.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Anatomy and Physiology",
    "dept": "AP",
    "num": "790",
    "desc": "Prerequisite: Consent of instructor.\nIntroduction of undergraduate and graduate students to research involving various anatomical and physiological systems.",
    "credits": "1-18"
  },
  {
    "course_name": "Topics in Exercise Physiology",
    "dept": "AP",
    "num": "796",
    "desc": "Prerequisite: KIN 335, KIN 336. Only 6 hours may be counted toward degree.\nIntensive study of a selected topic in Exercise Physiology involving either great in-depth study, or application of theory presented in a related course.",
    "credits": "1-4"
  },
  {
    "course_name": "Arabic I",
    "dept": "ARAB",
    "num": "101",
    "desc": "\nIntroduction to the structure of modern Arabic. Essentials of grammar, speaking, reading, and writing.",
    "credits": "4"
  },
  {
    "course_name": "Arabic II",
    "dept": "ARAB",
    "num": "102",
    "desc": "Prerequisite: ARAB 101 or equivalent.\nContinuation of Arabic I.",
    "credits": "4"
  },
  {
    "course_name": "Arabic III",
    "dept": "ARAB",
    "num": "300",
    "desc": "Prerequisite: ARAB 102 or equivalent.\nContinuation of ARAB 102; further development of four skills of listening, speaking, reading, and writing; with emphasis on building and applying basic language knowledge in communicative tasks; exercises in oral interactions and interactions involving text.",
    "credits": "5"
  },
  {
    "course_name": "Arabic IV",
    "dept": "ARAB",
    "num": "301",
    "desc": "Prerequisite: ARAB 201 or equivalent.\nContinuation of Arabic III.",
    "credits": "5"
  },
  {
    "course_name": "Arabic V",
    "dept": "ARAB",
    "num": "501",
    "desc": "Prerequisite: ARAB 282 or equivalent.\nFurther development of language and culture skills.",
    "credits": "4"
  },
  {
    "course_name": "Arabic VI",
    "dept": "ARAB",
    "num": "502",
    "desc": "Prerequisite: ARAB 501 or equivalent.\nA continuation of Arabic V, with further development of language and culture skills.",
    "credits": "4"
  },
  {
    "course_name": "Special Studies in Arabic",
    "dept": "ARAB",
    "num": "540",
    "desc": "Prerequisite: Consent of the department head and instructor involved.",
    "credits": "1-18"
  },
  {
    "course_name": "Science, Technology, and Architecture",
    "dept": "ARCH",
    "num": "240",
    "desc": "\nAn exploration of the interrelationships between architecture and various sciences including the technological applications of selected scientific theories.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Architectural Technology",
    "dept": "ARCH",
    "num": "248",
    "desc": "Prerequisite: PHYS 113 or 115 and admission to a professional program in the college.\nInstruction in the fundamentals of architectural technology with emphasis on the concepts and principles necessary for developing an integrated approach to building design.",
    "credits": "3"
  },
  {
    "course_name": "Basic Problems in Architectural Design",
    "dept": "ARCH",
    "num": "265",
    "desc": "\nStudy of specific architectural design problems under the direction of a member of the architecture faculty.",
    "credits": "1-18"
  },
  {
    "course_name": "Digital Architecture I",
    "dept": "ARCH",
    "num": "274",
    "desc": "Prerequisites: Second year standing or higher, or permission of the instructor.\nThis course will introduce students to digital management concepts, basic architectural digital representation, 3-dimensional computer modeling, raster, and vector graphics with an emphasis on conceptual development.",
    "credits": "1"
  },
  {
    "course_name": "Architecture Through the Ages",
    "dept": "ARCH",
    "num": "290",
    "desc": "\nAn introductory survey of the history of architecture worldwide from its prehistoric beginnings up to the present day.",
    "credits": "3"
  },
  {
    "course_name": "Appreciation of Architecture",
    "dept": "ARCH",
    "num": "301",
    "desc": "\nAn analysis of the evolution of architectural styles to determine the relation of architectural expression to the needs of society.",
    "credits": "3"
  },
  {
    "course_name": "Architectural Design Studio I",
    "dept": "ARCH",
    "num": "302",
    "desc": "Prerequisite: Admission to the architecture program and ENVD 202.\nInstruction in architectural design focusing on the application of elements and principles of form and space in design. Instruction in the use of techniques for visually representing design ideas.",
    "credits": "5"
  },
  {
    "course_name": "Architectural Design Studio II",
    "dept": "ARCH",
    "num": "304",
    "desc": "Prerequisite: ARCH 302 and no grade lower than a C in an architectural design studio course.\nInstruction in architectural design focusing on the synthesis of basic social, functional, technical, and aesthetic factors in design. Continued instruction in techniques for visually representing design ideas.",
    "credits": "5"
  },
  {
    "course_name": "Environmental Design and Society",
    "dept": "ARCH",
    "num": "325",
    "desc": "Prerequisite: Second-year standing or permission of instructor.\nInstruction in behavioral, cultural, and ecological factors that contribute to successful environmental design; considers how the design process is affected by a conceptual point of view. Case studies from architecture, landscape architecture, interior architecture, and interior design.",
    "credits": "3"
  },
  {
    "course_name": "Structural Systems in Architecture I",
    "dept": "ARCH",
    "num": "347",
    "desc": "Prerequisites: PHYS 113 or 115, MATH 100 or higher, ARCH 248, and admission to a professional program in the college.\nIntroduction to structure as a building system.  Overview of contemporary structural systems and their components, including wood, timber, steel, concrete, masonry, and hybrid structures.  Discussion of building code requirements for structure, general guidelines for building structures, including appropriate application, and methods for schematic estimation of structural member sizing.  Basic understanding of how gravity and lateral forces are propagated through a structural frame from load to building foundation.",
    "credits": "4"
  },
  {
    "course_name": "Structural Systems in Architecture I",
    "dept": "ARCH",
    "num": "348",
    "desc": "Prerequisite: PHYS 113 or 115, MATH 100 or higher.\nIntroduction to statics; force analysis and the study of forces in equilibrium; principles of statics as applied to the study of simple elemental structures; the origin, the nature, and the action of loads on structural systems. Instruction in the use of statics in the preliminary stages of building design. For ARCH and IAPD students.",
    "credits": "3"
  },
  {
    "course_name": "History of the Designed Environment III",
    "dept": "ARCH",
    "num": "350",
    "desc": "Prerequisite: ENVD 251 or permission of instructor.\nThe history of the designed environment from the mid-18th century through present.",
    "credits": "3"
  },
  {
    "course_name": "Digital Architecture II",
    "dept": "ARCH",
    "num": "373",
    "desc": "Prerequisite: Second year standing or higher, or permission of the instructor.\nThis course will introduce students to methods for digital 3-dimensional visualization, including rendering, animation, composting and analysis.",
    "credits": "1"
  },
  {
    "course_name": "Digital Architecture III",
    "dept": "ARCH",
    "num": "374",
    "desc": "Prerequisite: ARCH 274, ARCH 373, or permission of the instructor.\nThis course will introduce students to parametric and associative modeling methods for conceptual development, the design and representation of building assemblies and systems, and architectural documentation.",
    "credits": "1"
  },
  {
    "course_name": "Accelerated Architectural Design Studio I",
    "dept": "ARCH",
    "num": "401",
    "desc": "Prerequisite: Admission to the post-baccalaureate track of the Master of Architecture Program.\nAn introduction to the principles, processes and vocabularies of architectural design; basic architectural concerns (space/light/form and human factors); and techniques for visually representing design ideas (sketching/diagramming/instrument-aided drawings and model making).",
    "credits": "5"
  },
  {
    "course_name": "Accelerated Architectural Design Studio II",
    "dept": "ARCH",
    "num": "402",
    "desc": "Prerequisite: ARCH 401, and no grade lower than a C in an architectural design studio course.\nFurther development of the ideas skills and methodologies introduced in ARCH 401, and introduction to wider array of architectural concerns including social, functional, technical, contextual, and professional issues. The course will prepare students to enter the third-year architectural design studios.",
    "credits": "5"
  },
  {
    "course_name": "Architectural Design Studio III",
    "dept": "ARCH",
    "num": "403",
    "desc": "Prerequisite: ARCH 304 or ARCH 402, and no grade lower than a C in an architectural design studio course.\nRelation of structures to their environment; client and community restraint; development of building programs; synthesis of functional, technical, and aesthetic considerations in the design of structures for human use.",
    "credits": "5"
  },
  {
    "course_name": "Architectural Design Studio IV",
    "dept": "ARCH",
    "num": "404",
    "desc": "Prerequisite: ARCH 403 and no grade lower than a C in an architectural design studio course.\nRelation of structures to their environment; client and community restraint; development of building programs; synthesis of functional, technical, and aesthetic considerations in the design of structures for human use.",
    "credits": "5"
  },
  {
    "course_name": "Environmental Systems in Architecture I",
    "dept": "ARCH",
    "num": "413",
    "desc": "Prerequisite: ARCH 248 or IAPD 248 and enrollment in a professional program in the college.\nInstruction in environmental and building control systems of architecture, including bioclimatic and ecological design principles. Emphasis on integrated system design approach, with a focus on passive and natural strategies. Contemporary and developing approaches are explored.",
    "credits": "4"
  },
  {
    "course_name": "Building Construction Systems in Architecture I",
    "dept": "ARCH",
    "num": "433",
    "desc": "Prerequisite: ARCH 248 and admission to a professional program in the college.\nA lecture course that develops an understanding of how materials and systems assembly reinforce and extend the intentions of the designer as well as an understanding of the strategies and techniques for integration and coordination of the building components.  For ARCH and IAPD students.",
    "credits": "3"
  },
  {
    "course_name": "Building Construction Systems in Architecture II",
    "dept": "ARCH",
    "num": "434",
    "desc": "Prerequisite: ARCH 433.\nThis course develops a more sophisticated level of understanding of how materials and systems assembly reinforce and extend the intentions of the designer. Students will develop their ability to both analyze and employ building construction techniques and assemblies as a design generator in preparation for Architectural Design Studio V.",
    "credits": "3"
  },
  {
    "course_name": "Structural Systems in Architecture II",
    "dept": "ARCH",
    "num": "448",
    "desc": "Prerequisite: ARCH 347 and admission to a professional program in the college.\nInstruction in the quantitative analysis of structural systems and the forces they resist, proceeding from the design loads associated with building through the reactions of particular structural elements.  Overview of material strengths, and other properties of specific structural systems.  Instruction in structural system sizing, by hand calculation and computer analysis.",
    "credits": "4"
  },
  {
    "course_name": "Structural Systems in Architecture II",
    "dept": "ARCH",
    "num": "449",
    "desc": "Prerequisite: ARCH 348.\nInstruction in strength of materials focusing on the behavior of building materials under loading; their ability to resist deformation and failure. Instruction in sizing simple structural elements.  For ARCH and IAPD students.",
    "credits": "3"
  },
  {
    "course_name": "Structural Systems in Architecture III",
    "dept": "ARCH",
    "num": "452",
    "desc": "Prerequisite: ARCH 449.\nInstruction in the design of building structures as whole systems. Instruction in the principles of structural subsystem design; emphasis on the overall structural behavior and subsystems integrity required to achieve a variety of building forms.  Instruction in strategies for the use of approximation in the manipulation of key quantitative properties of whole systems and major subsystems in building design.",
    "credits": "3"
  },
  {
    "course_name": "Structural Systems in Architecture IV",
    "dept": "ARCH",
    "num": "453",
    "desc": "Prerequisite: ARCH 452.\nInstruction in the design of building structures as whole systems; overall-to-specific systems behavior and manipulative design of major subsystems. Emphasis on the design of subsystems and subsystem components as they are affected by structural material. Instruction in specialized issues associated with the analysis and design of high rise and long-span building structure, including foundation, constructive, and economic factors which affect building design.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Architectural Presentation",
    "dept": "ARCH",
    "num": "475",
    "desc": "Prerequisite: Second-year standing and approval of instructor.\nStudy of various methods of graphically representing architectural problems to develop professional office techniques.",
    "credits": "1-18"
  },
  {
    "course_name": "Internship Planning Seminar",
    "dept": "ARCH",
    "num": "503",
    "desc": "Prerequisite: ENGL 200 and 4th Year Standing.\nExploration and preparation for an architecture internship in the field of architecture.",
    "credits": "1"
  },
  {
    "course_name": "Architectural Internship, Part A",
    "dept": "ARCH",
    "num": "505",
    "desc": "Prerequisite: ARCH 503, ARCH 605, approval of the internship coordinator, and no grade lower than a C in an architectural design studio course.\nOff-campus work study program with an approved professional, building industry, government, or non-profit agency sponsor.",
    "credits": "9"
  },
  {
    "course_name": "Architectural Internship, Part B",
    "dept": "ARCH",
    "num": "506",
    "desc": "Prerequisite: ARCH 503, ARCH 605 and no grade lower than a C in an architectural design studio course.\nPreparation of internship journals and employer profiles, during the approved off-campus work-study program in ARCH 505.",
    "credits": "3"
  },
  {
    "course_name": "Architectural Internship, Part C",
    "dept": "ARCH",
    "num": "507",
    "desc": "Prerequisite: ARCH 505 and 506.\nA continuation of the approved off-campus internship of ARCH 505 and ARCH 506. Preparation of internship journals, employer profiles, and a final internship analysis paper based on the entire 30-week internship experience.",
    "credits": "2"
  },
  {
    "course_name": "Environmental Systems in Architecture II",
    "dept": "ARCH",
    "num": "514",
    "desc": "Prerequisite: ARCH 248 or IAPD 248 and enrollment in a professional program in the college.\nInstruction in criteria for selection and application of natural and mechanical environmental control systems in architecture. Focus on the integration of thermal, illumination, sanitary, movement, and acoustical systems within the building and the natural environment. Contemporary and developing approaches are explored.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Systems in Architecture III",
    "dept": "ARCH",
    "num": "515",
    "desc": "Prerequisite: ARCH 413.\nCriteria for selection and application of natural and mechanical environmental control systems in architecture. Focus on the integration of thermal, illumination, sanitary, movement, and acoustical systems with the building fabric and the natural environment. Contemporary and developing approaches are explored.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Architectural Design",
    "dept": "ARCH",
    "num": "565",
    "desc": "Prerequisite: Approval of instructor.\nStudy of specific design problems under the direct supervision of a member of the architecture faculty.",
    "credits": "1-18"
  },
  {
    "course_name": "Architectural Design Studio V",
    "dept": "ARCH",
    "num": "605",
    "desc": "Prerequisite: ARCH 404, ARCH 434, ARCH 448, ARCH 514, LAR 500 and no grade lower than a C in an architectural design studio course.\nA design studio that integrates a design project with design development, (including structural, mechanical, lighting and movement systems) and construction documentation.",
    "credits": "5"
  },
  {
    "course_name": "Architectural Design Studio VI",
    "dept": "ARCH",
    "num": "606",
    "desc": "Prerequisite: ARCH 605, and no grade lower than a C in an architectural design studio course.\nOn or off-campus advanced studio. Department and College approval required for off-campus studios, whether in a domestic or international studies program or university.",
    "credits": "5"
  },
  {
    "course_name": "Architectural Programming",
    "dept": "ARCH",
    "num": "650",
    "desc": "Prerequisite: Senior standing or permission of the instructor.\nAn introductory course surveying the basic philosophies and methodologies for architectural programming; emphasis on the comparative evaluation of different strategies and their integration within the process of design.",
    "credits": "3"
  },
  {
    "course_name": "Study Abroad Orientation",
    "dept": "ARCH",
    "num": "654",
    "desc": "\nPreparation for participation in study abroad with a focus on specific information pertaining to the design professions and the analysis of the built and natural environment.",
    "credits": "1-18"
  },
  {
    "course_name": "Topics in History of the Designed Environment",
    "dept": "ARCH",
    "num": "700",
    "desc": "Prerequisite: ARCH 350 or MS ARCH standing.\nSeminar on topics involving specific periods or subjects in the history of the built environment.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Aesthetics",
    "dept": "ARCH",
    "num": "703",
    "desc": "Prerequisite: Senior standing or permission of instructor.\nProblems involving aesthetics in areas related to student’s major field.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Environment and Behavior",
    "dept": "ARCH",
    "num": "704",
    "desc": "Prerequisite: ARCH 304 or IAPD 320 or LAR 320 or M. ARCH standing or junior standing if outside CAPD.\nSeminar on topics in human behavior as it relates to physical environments.",
    "credits": "3"
  },
  {
    "course_name": "Project Programming",
    "dept": "ARCH",
    "num": "705",
    "desc": "Prerequisite: ARCH 606, or ARCH 505/506, and approval of the faculty committee.\nThe development of a program for ARCH 707, Architectural Design VIII, under direction of a faculty member.",
    "credits": "2"
  },
  {
    "course_name": "Architectural Design Studio VII",
    "dept": "ARCH",
    "num": "706",
    "desc": "Prerequisite: Either ARCH 507 or ARCH 606; ARCH 434, ARCH 448, ARCH 515, and no grade lower than a C in any architectural design studio course.\nIntegration of the physiological, psychological, and sociological parameters in the design of environments. Analysis, programming, and planning problems, increased complexity of function and space definition systems. Relating environmental technology to total design.",
    "credits": "5"
  },
  {
    "course_name": "Architectural Design Studio VIII",
    "dept": "ARCH",
    "num": "707",
    "desc": "Prerequisite: ARCH 705, ARCH 706, and no grade lower than a C in an architectural design studio course.\nDevelopment of the student’s project programmed in ARCH 705, under the direction of a faculty committee. Project must demonstrate a high level of achievement in systematic and comprehensive thinking, application of resources, and communication of total process.",
    "credits": "5"
  },
  {
    "course_name": "Topics in Architectural Design Methods",
    "dept": "ARCH",
    "num": "711",
    "desc": "Prerequisite: ARCH 403 or IAPD 435 or LAR 320 or MS ARCH standing.\nIntensive review of selected design methodologies, including systematic and computer-based approaches to problem definition and project design; emphasis upon the comparative evaluation of problem-solving strategies within the architectural design process.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Architecture Seminar",
    "dept": "ARCH",
    "num": "715",
    "desc": "Prerequisite: ARCH 403 or permission of instructor.\nSeminar on topics in architecture with readings, class discussion, student presentations, research papers or projects.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Environmental Systems in Architecture",
    "dept": "ARCH",
    "num": "716",
    "desc": "Prerequisite: ARCH 413 or MS ARCH standing.\nA concentrated study of a particular subject related to the environmental systems of the built environment.",
    "credits": "3"
  },
  {
    "course_name": "Environment and Behavior",
    "dept": "ARCH",
    "num": "720",
    "desc": "Prerequisite: ARCH 325 or equivalent or permission of instructor.\nInvestigates the relationship between human behavior and design of the physical environment. Includes identification of psychological, social, cultural concepts which influence and are influenced by the built environment. Emphasizes applying this knowledge in design.",
    "credits": "3"
  },
  {
    "course_name": "Architecture Research Methods",
    "dept": "ARCH",
    "num": "725",
    "desc": "\nAn introductory course surveying the basic philosophies and methodologies of science and research as they apply to the field of architecture.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Building Construction Systems in Architecture",
    "dept": "ARCH",
    "num": "735",
    "desc": "Prerequisite: ARCH 434 or MS ARCH standing.\nAdvanced study of the relationship of conceptual and/or technological factors of building construction to architecture.",
    "credits": "1-4"
  },
  {
    "course_name": "Writing Intensive Architecture Seminar",
    "dept": "ARCH",
    "num": "750",
    "desc": "Prerequisite: ENGL 200 and ARCH 403.\nA writing intensive seminar shall be an Architecture Seminar where over half of the course grade is based on written assignments (including papers, assignments, quizzes and exams).",
    "credits": "3"
  },
  {
    "course_name": "Topics in Structural Systems in Architecture",
    "dept": "ARCH",
    "num": "752",
    "desc": "Prerequisite: ARCH 448 or MS ARCH standing.\nStudy of the relationship of conceptual and/or technological factors of structure to architectural design.",
    "credits": "3"
  },
  {
    "course_name": "Professional Practice",
    "dept": "ARCH",
    "num": "753",
    "desc": "Prerequisite: ARCH 433.\nStudies of conventional and newly developing methods of professional design practice. Instruction in the relationships of architects, landscape architects, interior architects and other professions to users, clients, construction industry, society, government, and one another.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Problems in Architecture",
    "dept": "ARCH",
    "num": "765",
    "desc": "\nStudy of specific architectural problems under the direct supervision of a member of the architecture faculty.",
    "credits": "1-18"
  },
  {
    "course_name": "Practicum",
    "dept": "ARCH",
    "num": "790",
    "desc": "\nPractical application of studies related to a student’s area focus.",
    "credits": "1-18"
  },
  {
    "course_name": "Topics in History of the Designed Environment",
    "dept": "ARCH",
    "num": "801",
    "desc": "Prerequisite: ARCH 350.\nSeminar on topics involving specific periods or subjects in the history of the built environment.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Aesthetics",
    "dept": "ARCH",
    "num": "803",
    "desc": "\nProblems involving aesthetics in areas related to student’s major field.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Environment and Behavior",
    "dept": "ARCH",
    "num": "804",
    "desc": "\nSeminar on topics in human perceptions, reactions, and behavior as they relate to physical environments.",
    "credits": "3"
  },
  {
    "course_name": "Project Programming",
    "dept": "ARCH",
    "num": "805",
    "desc": "Prerequisite: Either ARCH 606 or ARCH 507.\nDevelopment of an architectural program for ARCH 807. Identify evaluation criteria and prepare statement of objectives; perform appropriate research and analysis; and create programming document.",
    "credits": "3"
  },
  {
    "course_name": "Architectural Design Studio VII",
    "dept": "ARCH",
    "num": "806",
    "desc": "Prerequisite: Either ARCH 507 or ARCH 606, ARCH 433, ARCH 448, ARCH 515, an no grade lower than a C in an architectural design studio course.\nIntegration of the physiological, psychological, and sociological parameters in the design of environments. Analysis, programming, and planning problems, increased complexity of function and space definition systems. Relating environmental technology to total design.",
    "credits": "5"
  },
  {
    "course_name": "Architectural Design Studio VIII",
    "dept": "ARCH",
    "num": "807",
    "desc": "Prerequisite: ARCH 805 and 806.\nFinal design studio course in the professional curriculum in architecture. Using the program established in ARCH 805, students demonstrate mastery in systematic and comprehensive thinking, project research, application of resources, architectural design, and communication of total process.",
    "credits": "5"
  },
  {
    "course_name": "Architectural Design Communication",
    "dept": "ARCH",
    "num": "808",
    "desc": "Prerequisite: ENGL 200-Expository Writing II and concurrent enrollment with ARCH 807-Architectural Design Studio VIII.\nInstruction in design communication with emphasis on concepts, principles, strategies and skills for effectively combining writing with images and other products of design; focuses on ideas, processes and proposals developed during the final year of architectural design studio.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Architectural Design Methods",
    "dept": "ARCH",
    "num": "811",
    "desc": "Prerequisite: ARCH 304.\nIntensive review of selected design methodologies, including systematic and computer-based approaches to problem definition and project design; emphasis upon the comparative evaluation of problem-solving strategies within the architectural design process.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Architecture",
    "dept": "ARCH",
    "num": "815",
    "desc": "Prerequisite: ARCH 304.\nSeminar on topics in architecture with readings, class discussion, student presentations, research papers or projects.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Environmental Systems in Architecture",
    "dept": "ARCH",
    "num": "816",
    "desc": "Prerequisite: ARCH 413.\nA concentrated study of a particular subject related to the environmental systems of the built environment.",
    "credits": "3"
  },
  {
    "course_name": "Environment and Behavior",
    "dept": "ARCH",
    "num": "820",
    "desc": "\nInvestigates the relationship between human behavior and design of the physical environment. Includes identification of psychological, social, cultural factors which influence and are influenced by the built environment. Emphasizes applying this knowledge in design.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Architectural Design",
    "dept": "ARCH",
    "num": "830",
    "desc": "\nStudies related to the area of focus of a M.ARCH student in the non-thesis option. Preparation of a non-thesis proposal and a non-thesis project which may include a design project, synthesis paper, portfolio of written work, series of case studies, or other project.",
    "credits": "1-18"
  },
  {
    "course_name": "Topics in Building Construction Systems in Architecture",
    "dept": "ARCH",
    "num": "835",
    "desc": "Prerequisite: ARCH 433.\nAdvanced study of the relationship of conceptual and/or technological factors of building construction to architecture.",
    "credits": "1-4"
  },
  {
    "course_name": "Topics in Structural Systems in Architecture II",
    "dept": "ARCH",
    "num": "852",
    "desc": "Prerequisite: ARCH 453.\nStudy of the relationship of conceptual and/or technological factors of structure to architectural design.",
    "credits": "3"
  },
  {
    "course_name": "Professional Practice: Professional Responsibility",
    "dept": "ARCH",
    "num": "853",
    "desc": "\nInterdisciplinary course addresses the connections between allied design professions and the larger community. It helps students to understand and appreciate their professional legal and ethical responsibilities.",
    "credits": "1"
  },
  {
    "course_name": "Professional Practice: Office Practices",
    "dept": "ARCH",
    "num": "854",
    "desc": "\nInterdisciplinary course addresses practice-based issues concerning professional relationships in the design and delivery process, management of projects, communication practices, and fiscal concerns.",
    "credits": "1"
  },
  {
    "course_name": "Professional Practice: Discipline-Specific Topics",
    "dept": "ARCH",
    "num": "855",
    "desc": "\nCovers discipline-specific concerns, focusing on issues specific to architecture, interior architecture and product design, landscape architecture or regional and community planning.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Problems in Architectural Design",
    "dept": "ARCH",
    "num": "865",
    "desc": "\nStudy of specific architectural design problems under the direct supervision of a member of the architecture faculty.",
    "credits": "1-18"
  },
  {
    "course_name": "Thesis",
    "dept": "ARCH",
    "num": "899",
    "desc": "\nStudy in architecture and related fields leading to thesis.",
    "credits": "1-18"
  },
  {
    "course_name": "Architectural Engineering Seminar",
    "dept": "ARE",
    "num": "020",
    "desc": "\nPresentation of professional problems and practices by students, faculty, and professionals associated with the career of architectural engineering.",
    "credits": "0"
  },
  {
    "course_name": "Architectural Engineering Orientation",
    "dept": "ARE",
    "num": "100",
    "desc": "\nIntroduction to architectural engineering. Promotion of interaction and connection with the department as well as a network of academic and professional networks through the use of learning communities. Familiarize entering students with the nature of the architectural, engineering, and construction industry with an emphasis on terminology and professionalism.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Building Systems",
    "dept": "ARE",
    "num": "295",
    "desc": "Prerequisite: CNS 220.\nAn introduction to building systems including: structural, electrical, mechanical, and plumbing. An emphasis will be made on the importance of these systems to the success of building function and operation. The course will not only expose the students to each system but the criticalness of integration between the systems as well as the architecture and construction of the facility.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to AutoCAD",
    "dept": "ARE",
    "num": "310",
    "desc": "Prerequisite: CNS 321.\nAn introduction to the basics of AutoCAD.",
    "credits": "1"
  },
  {
    "course_name": "CAD in Engineering and Construction",
    "dept": "ARE",
    "num": "311",
    "desc": "Prerequisite: CNS 200.\nBasics of CAD and the applications to the engineering and construction industry.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Building Information Modeling",
    "dept": "ARE",
    "num": "312",
    "desc": "Prerequisite or Concurrent: ARE 310.\nIntroduction to building information modeling as a technology tool related to the engineering and construction industry.",
    "credits": "1"
  },
  {
    "course_name": "Plan Reading & Systems Communications",
    "dept": "ARE",
    "num": "421",
    "desc": "Prerequisite: CNS 321\nThe integration of architectural, structural, mechanical, electrical and plumbing building systems, the impact of codes/standards on design, plan reading, and drawing creation.",
    "credits": "3"
  },
  {
    "course_name": "ARE Professional Practice",
    "dept": "ARE",
    "num": "460",
    "desc": "Prerequisite: Must be taken concurrent with ARE 551, ARE 552, ARE a553, and CE 537.\nGeneral business, management and contractual procedures in professional practice. Personal development of skills needed to enter and be accepted in industry today.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "ARE",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Honors Research in Architectural Engineering",
    "dept": "ARE",
    "num": "499",
    "desc": "\nIndividual research problem selected with approval of faculty advisor. Open to students in the college of engineering honors program. A report is presented orally and in writing during the last semester.",
    "credits": "1-18"
  },
  {
    "course_name": "Computer Aided Architectural Engineering",
    "dept": "ARE",
    "num": "521",
    "desc": "\nAn introduction to the use of computer software for the design and integration of building systems. The course is intended to complement and enhance the content of the concurrent system courses (Mechanical II, Electrical II, and Structures II). The computer software used will represent the standard practices of the building construction industry.",
    "credits": "2"
  },
  {
    "course_name": "Acoustic Systems",
    "dept": "ARE",
    "num": "537",
    "desc": "Prerequisite: PHYS 113 or 213.\nHearing and the ear, sound generation, acoustical correction, noise reduction, and sound transmission all as integral parts of architectural design.",
    "credits": "2"
  },
  {
    "course_name": "Electrical System I",
    "dept": "ARE",
    "num": "551",
    "desc": "Prerequisite: PHYS 214. Must be taken concurrent with ARE 552, ARE 553, ARE 460, and CE 537.\nAn introduction and study of the basic human needs in lighting and lighting sources, and the basic concepts and components of building electrical distribution systems, including circuit design.",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Systems I",
    "dept": "ARE",
    "num": "552",
    "desc": "Prerequisite: ME 513. Must be taken concurrent with ARE 551, ARE 553, ARE 460, and CE 537.\nAn introduction to building HVAC and plumbing system terminology, principles, and practices of design and layout specifically for applications of human comfort and safety.",
    "credits": "3"
  },
  {
    "course_name": "Structural Systems I",
    "dept": "ARE",
    "num": "553",
    "desc": "Prerequisite: CE 533. Must be taken concurrent with ARE 551, ARE 552, ARE 460, and CE 537.\nAn introduction to building structural system terminology, principles, and practices of design and layout specifically for applications of buildings.",
    "credits": "3"
  },
  {
    "course_name": "Electrical Systems II",
    "dept": "ARE",
    "num": "561",
    "desc": "Prerequisite: ARE 551\nThe study and application of luminaires, lighting systems design and control, circuit and utilization component design, and design of building electrical systems distribution and service equipment.",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Systems 2",
    "dept": "ARE",
    "num": "562",
    "desc": "Prerequisite: ARE 552\nThe study of building HVAC system selection and application including load calculations, space coordination, system design and layout, and scheduling of equipment and materials.",
    "credits": "3"
  },
  {
    "course_name": "Structural Systems II",
    "dept": "ARE",
    "num": "563",
    "desc": "\nThe study of timber, reinforced concrete, and steel building structural systems including analysis and design.",
    "credits": "3"
  },
  {
    "course_name": "Systems Integration & Design",
    "dept": "ARE",
    "num": "571",
    "desc": "Prerequisites: ARE 421, ARE 521, ARE 561, ARE 562, ARE 563.\nAn analysis of structural, mechanical, electrical and plumbing systems design processes, budgeting and constructability that supports the Conceptual Design and Schematic Design phases of building projects.",
    "credits": "3"
  },
  {
    "course_name": "Integrated Building System Design",
    "dept": "ARE",
    "num": "590",
    "desc": "Prerequisite: ARE 524, 528, 532, 533, 536, and 540.\nMethods for integration and coordination of structural, mechanical, electrical, and lighting systems in the building architectural design process.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Architectural Engineering",
    "dept": "ARE",
    "num": "620",
    "desc": "Prerequisite: Approval of the department head.\nA study of specific design problems under the direct supervision of a member of the architectural engineering faculty.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to LEED",
    "dept": "ARE",
    "num": "630",
    "desc": "Prerequisite: Professional program standing.\nIntroduction to green building design and construction principles and practices based on the Leadership in Energy and Environmental Design (LEED) Green Building Rating System of the United States Green Building Council (USGBC).",
    "credits": "1-18"
  },
  {
    "course_name": "ARE Capstone",
    "dept": "ARE",
    "num": "671",
    "desc": "Prerequisite: ARE 571\nIn a studio fashion, student working individually or as part of a small team will prepare and present a design project of appropriate scope and complexity with emphasis on structural or mechanical/electrical/plumbing building systems.",
    "credits": "4"
  },
  {
    "course_name": "Senior Project",
    "dept": "ARE",
    "num": "690",
    "desc": "Prerequisite: ARE 590 and CE 522. Must be taken concurrent with ARE 539.\nStudent working individually with laboratory support will prepare and present a design project of appropriate scope and complexity with emphasis on structural or mechanical and electrical building systems.",
    "credits": "3"
  },
  {
    "course_name": "Building Energy Codes and Standards",
    "dept": "ARE",
    "num": "711",
    "desc": "Prerequisite: ARE 562.\nStudy of the background, importance, impact, and application of the energy codes to the mechanical and electrical systems design process.",
    "credits": "2"
  },
  {
    "course_name": "Energy Modeling Lab",
    "dept": "ARE",
    "num": "712",
    "desc": "Prerequisite: ARE 562.\nStudy of current building energy sources and trends, basic engineering economics applied to building energy use, energy calculations for building systems, and software-based whole building energy simulation using eQUEST.",
    "credits": "1"
  },
  {
    "course_name": "Problems in Architectural Engineering",
    "dept": "ARE",
    "num": "715",
    "desc": "Prerequisite: Approval of the department head.\nParticipation in student design competition teams under the direct supervision of a member of the architectural engineering faculty.",
    "credits": "1-18"
  },
  {
    "course_name": "Topics in Architectural Engineering",
    "dept": "ARE",
    "num": "720",
    "desc": "Prerequisite or concurrent enrollment: ARE 590.\nA study of specific design problems in architectural engineering.",
    "credits": "1-18"
  },
  {
    "course_name": "Building Loads and Computer Aided Structural Analysis and Design",
    "dept": "ARE",
    "num": "722",
    "desc": "Prerequisite or concurrent: ARE 563.\nFundamentals of building structural systems and design with the emphasis on building loads and load paths. Review of International Building Code’s structural loading requirements, applications, and determination of design loads by ASCE 7 - Minimum Design Loads and Associated Criteria for Buildings and Other Structures.  Introduction of building design and analysis software basics. Students will learn how to generate building structural models, and conduct analysis, design, and simulation using software applications.",
    "credits": "3"
  },
  {
    "course_name": "Timber Structures",
    "dept": "ARE",
    "num": "723",
    "desc": "Prerequisite: CE 537.\nAnalysis and design of timber structures including dimension lumber, glu-lam members, and engineered wood products.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Steel Design",
    "dept": "ARE",
    "num": "724",
    "desc": "Prerequisite: ARE 553 or CE 542.\nStructural design computations for beams, girders, columns and beam-columns. Design of connections (bolted &amp; welded). Structural working drawings (plan, elevation and connection details). Overview of failure mechanisms and design procedures for plate girders. AISC requirements for prevention of various failure mechanisms.",
    "credits": "3"
  },
  {
    "course_name": "Cold-Formed Steel Design",
    "dept": "ARE",
    "num": "725",
    "desc": "Prerequisite: ARE 553 or CE 542.\nPrinciples of behavior, design, fabrication, and construction of cold-formed steel structures.",
    "credits": "3"
  },
  {
    "course_name": "Masonry Structural Design",
    "dept": "ARE",
    "num": "726",
    "desc": "Prerequisite: ARE 528 or CE 544.\nIntroduction to masonry materials, specifications, testing and construction methods. The design of unreinforced and reinforced masonry structures according to applicable building codes.",
    "credits": "3"
  },
  {
    "course_name": "Building Seismic Design",
    "dept": "ARE",
    "num": "729",
    "desc": "Prerequisite: ARE 553 or CE 542 and ARE 563.\nContinuation of ARE 553 and ARE 563 with special emphasis on seismic design as applied to a complete structure.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Lighting Design",
    "dept": "ARE",
    "num": "731",
    "desc": "Prerequisite: ARE 561.\nDesign and application of lighting systems for commercial buildings, using current industry practices and computer-assisted analysis.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Mechanical Hydronic Systems Design",
    "dept": "ARE",
    "num": "733",
    "desc": "Prerequisite: ARE 562.\nDesign and application of mechanical systems for buildings, focusing on hydronic and steam systems, expanding on the material and topics presented in prior HVAC courses.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Mechanical Air Systems Design",
    "dept": "ARE",
    "num": "734",
    "desc": "Prerequisite: ARE 562.\nDesign and application of mechanical systems for buildings, focusing on air systems, expanding on the material and topics presented in prior HVAC courses.",
    "credits": "3"
  },
  {
    "course_name": "Electrical Systems Design",
    "dept": "ARE",
    "num": "735",
    "desc": "Prerequisite: ARE 561.\nDesign and application of various electrical distribution system for commercial buildings. The course uses the National Electrical Code in conjunction with current industry practices.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Plumbing Design",
    "dept": "ARE",
    "num": "736",
    "desc": "Prerequisite: ARE 561.\nDesign and application of domestic water and waste systems, storm water systems, fuel gas systems, medical gas systems and fire protections systems.",
    "credits": "3"
  },
  {
    "course_name": "Building Communication Systems",
    "dept": "ARE",
    "num": "741",
    "desc": "Prerequisite: ARE 561.\nDetailed design and analysis of special electrical systems for buildings including, fire alarm, and communication systems.",
    "credits": "3"
  },
  {
    "course_name": "Ceramics for Non-majors",
    "dept": "ART",
    "num": "102",
    "desc": "\nA foundational survey in ceramic processes covering sculptural and vessel-based making as well as nontraditional practices in ceramic art. Students learn the basic origins of clay, its physical properties, and working characteristics. Surface expression is emphasized through the use of colored slips and glazes and atypical applications.",
    "credits": "3"
  },
  {
    "course_name": "Jewelry Design and Processes for Non-majors",
    "dept": "ART",
    "num": "103",
    "desc": "\nStudents without a background in art will be introduced to basic forming and construction techniques and design principles for jewelry and small-scale metal objects.",
    "credits": "3"
  },
  {
    "course_name": "Art Careers Seminar",
    "dept": "ART",
    "num": "105",
    "desc": "\nIntroduction to art concentrations and professions.",
    "credits": "1"
  },
  {
    "course_name": "Art Appreciation",
    "dept": "ART",
    "num": "106",
    "desc": "\nIntroduction for non-art majors to basic elements (line, color, form, etc.) and principles (balance, repetition, proportion, etc.) of composition and explore some of the purposes (political, spiritual, philosophical, etc.) of art. Explore the relationship of art to historical contexts and examine the concept of style.",
    "credits": "3"
  },
  {
    "course_name": "2- Dimensional Design",
    "dept": "ART",
    "num": "180",
    "desc": "\nIntroduction to and laboratory practice in the principles and elements of design. Emphasis is placed on organizational command of the two-dimensional picture plane and issues of illusion.",
    "credits": "3"
  },
  {
    "course_name": "Drawing I",
    "dept": "ART",
    "num": "190",
    "desc": "\nFundamental principles of drawing skills based on observation through the introduction of basic materials and techniques.",
    "credits": "3"
  },
  {
    "course_name": "Survey of Western Art History I",
    "dept": "ART",
    "num": "195",
    "desc": "\nHistorical development of art from pre-history through the Middle Ages.",
    "credits": "3"
  },
  {
    "course_name": "Survey of Western Art History II",
    "dept": "ART",
    "num": "196",
    "desc": "\nHistorical development of art from the Renaissance to the nineteenth century.",
    "credits": "3"
  },
  {
    "course_name": "3- Dimensional Design",
    "dept": "ART",
    "num": "200",
    "desc": "\nIntroduction to laboratory practice in the principles and elements of design. Emphasis is placed on the perceptions and use of spatial properties as related to components of 3-D art and design. Students will develop design vocabulary, methodology and judgment skills that will implement further study in the visual arts.",
    "credits": "3"
  },
  {
    "course_name": "Type and Design Principles",
    "dept": "ART",
    "num": "290",
    "desc": "Prerequisite: ART 180.\nApplication of design and type principles to the development of letterforms and to principles of symbology. Selected topics in design, i.e., perception, figure/ground; shape, visual dynamics, Gestalt principle; fundamentals of the design process: research, thumbnails/roughs, comprehensive, presentation, paste-up, and digital fines.",
    "credits": "3"
  },
  {
    "course_name": "Portfolio Review",
    "dept": "ART",
    "num": "298",
    "desc": "\nThe preparation and display of a student’s own creative work, upon completion of the Department of Art 24-credit-hour core. The concentration admission procedure occurs after student selection of an area of concentration within the BFA art major format.",
    "credits": "0"
  },
  {
    "course_name": "Special Studies in Art",
    "dept": "ART",
    "num": "300",
    "desc": "\nSpecialized workshops or seminars conducted in studio, art therapy, art education, or art history.",
    "credits": "1-3"
  },
  {
    "course_name": "Human Form and Composition",
    "dept": "ART",
    "num": "301",
    "desc": "Prerequisite: ART 180, 190.\nBuilding stylization and expressive image making of the human form with experimental methods: use of color, mono-print, mixed media. A connected and sustained studio time available during intersession only, providing students a working rhythm without interruption from other course work.",
    "credits": "3"
  },
  {
    "course_name": "Art and Insects",
    "dept": "ART",
    "num": "302",
    "desc": "\nProvides a framework for examining arts and insects in which students consider evolution, genetics, behavior, and biodiversity, while also learning aesthetic interpretation, analysis of color and shape, perception, and the role of insect representations in the arts and humanities.",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Techniques",
    "dept": "ART",
    "num": "303",
    "desc": "\nThis course is a hands-on course intended to introduce non-majors to the visual and critical thinking skills that graphic designers use when creating print-based communication using text and image.",
    "credits": "3"
  },
  {
    "course_name": "Digital Illustration",
    "dept": "ART",
    "num": "304",
    "desc": "\nIntroductory survey of digital drawing and illustration techniques whereby students are introduced to digital illustration software, illustration generes, methods, and materials.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Museum Studies",
    "dept": "ART",
    "num": "305",
    "desc": "\nFundamentals of museum work including specific museum functions, role of professional personnel, and proper care and handling of art works.",
    "credits": "3"
  },
  {
    "course_name": "Basic Digital Photography for Non-majors",
    "dept": "ART",
    "num": "306",
    "desc": "\nIntroduction to digital photography including the use of DSLR camera, Adobe Lightroom, and Adobe Photoshop.",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Studio I",
    "dept": "ART",
    "num": "310",
    "desc": "Prerequisite: ART 290, acceptance to Graphic Design concentration through ART 298–Concentration Admission Procedure.\nDevelopment and preparation of basic graphic design projects and practices, concept development and design process.",
    "credits": "3"
  },
  {
    "course_name": "Drawing II",
    "dept": "ART",
    "num": "311",
    "desc": "Prerequisite: ART 190.\nExtension of Drawing I, observational drawing enhanced by composition, expanded materials and techniques.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Fiberart and Material Studies.",
    "dept": "ART",
    "num": "313",
    "desc": "\nIntroduction to fiberart processes and innovative material as an art form in methods such as small scale tapestry weaving; fabric dye techniques; dye discharge techniques; fabric pigment applications of painting, stamping, printing; and non-loom basketry coiling or felting.",
    "credits": "3"
  },
  {
    "course_name": "Basic 3D Modeling & Printing",
    "dept": "ART",
    "num": "315",
    "desc": "\nExplores the potential and limitation of 3D Printing through a build-intensive design project.  Projects use industry standard 3D hardware and software.",
    "credits": "3"
  },
  {
    "course_name": "Water Media I",
    "dept": "ART",
    "num": "320",
    "desc": "Prerequisite: ART 180, 190.\nIntroduction to painting with water-based media through a variety of techniques. Emphasis is placed on learning transparent watercolor.",
    "credits": "3"
  },
  {
    "course_name": "Figure Drawing I",
    "dept": "ART",
    "num": "325",
    "desc": "Prerequisite: ART 311.\nSustained drawings of the human figure using a variety of media; introduction to human anatomy used by artists.",
    "credits": "3"
  },
  {
    "course_name": "Digital Techniques in Visual Art",
    "dept": "ART",
    "num": "330",
    "desc": "Prerequisite:None.\nSurvey of the most frequently used programs in the studio arts and equipment necessary for successful navigation on the digital arena.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Interactive Art",
    "dept": "ART",
    "num": "331",
    "desc": "Prerequisite: ART 330 or permission of instructor.\nExplores interactive media and technology for artistic production including use of computers for graphics, sound, electronics, and interactive programming.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Printmaking",
    "dept": "ART",
    "num": "335",
    "desc": "Prerequisite: ART 180.\nExploration and experimentation with traditional printmaking processes and technology for image production, idea development, and creative expression.",
    "credits": "3"
  },
  {
    "course_name": "Sculpture I",
    "dept": "ART",
    "num": "340",
    "desc": "Prerequisite: ART 200 or instructor permission.\nAn introduction to the problems of sculptural form; fundamental techniques and theory in woodcarving, clay modeling, mold making, casting, oxy/acetylene welding, and metal casting.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Oil Painting",
    "dept": "ART",
    "num": "345",
    "desc": "Prerequisite: ART 180, 190.\nTechnical aspects of oil painting materials, including preparation of grounds and use of limited color palettes.",
    "credits": "3"
  },
  {
    "course_name": "Drawing III",
    "dept": "ART",
    "num": "350",
    "desc": "Prerequisite: ART 325.\nContinuation of Drawing II, emphasizing exploration in mixed media.",
    "credits": "3"
  },
  {
    "course_name": "Ceramics I",
    "dept": "ART",
    "num": "365",
    "desc": "Prerequisite: ART 200.\nIntroduction to the spectrum of ceramics processes. Students learn foundational techniques that include hand building and slip casting; use found objects to make both vessel and sculptural ceramic work; and explore new genres in clay. Students create a multitude of surface treatments from traditional glazing, image and pattern transfer, as well as nontraditional surfaces.",
    "credits": "3"
  },
  {
    "course_name": "Metalsmithing I",
    "dept": "ART",
    "num": "370",
    "desc": "Prerequisite: ART 200 or instructor permission.\nDesign and execution of small-scale, three-dimensional objects, involving the basic processes of raising, forging, and fabrication in semi-precious metals. The techniques of centrifugal and vacuum casting of precious metals will also be introduced as well as soldering and piercing.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Sound Art: electronics, digital, and acoustic sound within the visual arts",
    "dept": "ART",
    "num": "380",
    "desc": "\nIncludes basic digital, electronic, environmental, and acoustic sound in the visual arts context. Sound as component of a studio practice; fundamentals of recording, digital sound editing, electronics, time-based structures, and innovative presentation methods. Includes a short history of sound art beginning with Dada, up to the present day fusion of art, electronics and technology.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Digital Photography",
    "dept": "ART",
    "num": "395",
    "desc": "Prerequisite: ART 180 or instructor’s consent.\nUnderstanding of Photography as an art form. DSLR operation, composition and Photoshop, historical perspectives and contemporary photography as art practice. Cameras can be rented.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Art",
    "dept": "ART",
    "num": "399",
    "desc": "Prerequisite: For students in the honors program only.\nSelected topics in art.",
    "credits": "3"
  },
  {
    "course_name": "Computer Imaging in Graphic Design",
    "dept": "ART",
    "num": "400",
    "desc": "Prerequisite: ART 290, acceptance to Graphic Design concentration through ART 298-Concentration Admission Procedure.\nExploration of computer imaging through the use of image processing, page layout, and design concept.",
    "credits": "3"
  },
  {
    "course_name": "Minor in Art - Capstone",
    "dept": "ART",
    "num": "404",
    "desc": "Prerequisite: 15 credit hours of Art that fulfills the Art minor.\nStudents prepare an essay of 1,600-2,000 words explaining the focus of their program of study in Art, and reflecting on how their classes came together to meet or enhance their core educational objectives.",
    "credits": "0"
  },
  {
    "course_name": "BFA Exhibition or Portfolio Presentation",
    "dept": "ART",
    "num": "410",
    "desc": "\nCourse builds an awareness of professional practices and emphasizes the production and exhibition of a final portfolio of the student’s art work. Development of evaluative skills involved in the resolution and presentation of a body of individual work.",
    "credits": "2"
  },
  {
    "course_name": "Undergraduate Art Studio Assistant in Faculty Research",
    "dept": "ART",
    "num": "415",
    "desc": "\nStudents will assist faculty with creative research. Students will gain invaluable firsthand skills and insight of professional art practices. Research activities include but are not limited to production of artwork, preparation of art making materials, exhibition and curatorial research, and professional practice.",
    "credits": "1-3"
  },
  {
    "course_name": "Graphic Design Studio II",
    "dept": "ART",
    "num": "420",
    "desc": "Prerequisite: ART 310, ART 400.\nMid-level studio course in communication design practice. Experience and training in critical thinking, conceptual, technological, and aesthetic execution-related design skills.",
    "credits": "3"
  },
  {
    "course_name": "Independent Study-Ceramics",
    "dept": "ART",
    "num": "430",
    "desc": "\nHands-on experience in studio workflow and project management.",
    "credits": "1-3"
  },
  {
    "course_name": "Independent Study-Crafts",
    "dept": "ART",
    "num": "435",
    "desc": "\nWork in crafts after competency has been achieved. Personal development is emphasized.",
    "credits": "1-5"
  },
  {
    "course_name": "Independent Study-Drawing",
    "dept": "ART",
    "num": "440",
    "desc": "\nWork in drawing after competency has been achieved. Personal development is emphasized.",
    "credits": "1-5"
  },
  {
    "course_name": "Independent Study-Graphic Design",
    "dept": "ART",
    "num": "445",
    "desc": "\nWork in graphic design after competency has been achieved. Personal development is emphasized.",
    "credits": "1-5"
  },
  {
    "course_name": "Independent Study-Metalsmithing",
    "dept": "ART",
    "num": "450",
    "desc": "\nWork in metalsmithing and jewelry after competency has been achieved. Personal development is emphasized.",
    "credits": "1-5"
  },
  {
    "course_name": "Independent Study-Painting",
    "dept": "ART",
    "num": "455",
    "desc": "\nWork in painting after competency has been achieved. Personal development is emphasized.",
    "credits": "1-5"
  },
  {
    "course_name": "Independent Study-Printmaking",
    "dept": "ART",
    "num": "460",
    "desc": "\nWork in printmaking after competency has been achieved. Personal development is emphasized.",
    "credits": "1-5"
  },
  {
    "course_name": "Independent Study-Water Color",
    "dept": "ART",
    "num": "470",
    "desc": "\nWork in water color after competency has been achieved. Personal development is emphasized.",
    "credits": "1-5"
  },
  {
    "course_name": "Independent Study in Photography",
    "dept": "ART",
    "num": "475",
    "desc": "Prerequisite: ART 180 or instructor consent.\nAdvanced course in photography with an emphasis on developing personal expression using photographic media, under the mentorship of the instructor.",
    "credits": "1-3"
  },
  {
    "course_name": "Independent Study/Research Computer Art and Design",
    "dept": "ART",
    "num": "480",
    "desc": "Prerequisite: ART 400. Corequisite: ART 575.\nThis course is intended to provide students an opportunity to focus on a specific visual project/problem that will be solved using computers to focus on as the primary tool/medium.",
    "credits": "1-5"
  },
  {
    "course_name": "Digital/Experimental Media Special Topics",
    "dept": "ART",
    "num": "523",
    "desc": "Prerequisite: ART 330 or permission of instructor.\nSpecialized studio art course exploring technology and experimental media in the context of contemporary fine art production. Topics may include community art practice, systems art, ecology-based art, interactive media, code-based art and locative media. This course will engage grant writing for the arts as well as both formal and experimental models for contemporary art exhibition. Topics include: New Media &amp; Community; Systems Art; DX Media Lab; Code Electronics and Sensors; Interactive Time-Based Media.",
    "credits": "3"
  },
  {
    "course_name": "Color Printmaking Workshop",
    "dept": "ART",
    "num": "529",
    "desc": "Prerequisite: ART 335.\nIndividual and collaborative studio work in intaglio (etching), lithography, relief printing (woodcut), screen printing, or monoprint printmaking processes. Color theory, experimental and practical techniques provide experience in multicolor and intermedia graphic production.",
    "credits": "3"
  },
  {
    "course_name": "Color Printmaking",
    "dept": "ART",
    "num": "530",
    "desc": "Prerequisite: ART 335.\nIndividual and collaborative studio work in intaglio (etching), lithography, relief printing (woodcut), screen printing, or monoprint printmaking processes. Color theory, experimental and practical techniques provide experience in multicolor and intermedia graphic production.",
    "credits": "3"
  },
  {
    "course_name": "Twentieth Century Art History I: Post-Impressionism to Cubism",
    "dept": "ART",
    "num": "545",
    "desc": "Prerequisite: ART 195 or 196.\nOrigins and development of twentieth century western art from 1880 to 1914.",
    "credits": "3"
  },
  {
    "course_name": "Twentieth Century Art History II: Dada to Surrealism",
    "dept": "ART",
    "num": "550",
    "desc": "Prerequisite: ART 195 or 196.\nOrigins and development of twentieth century western art from 1914 to 1950.",
    "credits": "3"
  },
  {
    "course_name": "Oil Painting II",
    "dept": "ART",
    "num": "561",
    "desc": "Prerequisite: ART 320 and ART 345.\nContinuation of Introduction to Oil Painting, with emphasis on direct observation from still life and the human form.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Photography",
    "dept": "ART",
    "num": "563",
    "desc": "Prerequisite: ART 395.\nCreative exploration of hybrid digital and analog photographic processes including film, darkroom printing, large format digital ink jet printing, wet scanning, and studio lighting.  Cameras are provided.",
    "credits": "3"
  },
  {
    "course_name": "Ceramics II",
    "dept": "ART",
    "num": "565",
    "desc": "Prerequisite: ART 365 or ART 102.\nAdvanced work on potter’s wheel combined with hand-built forms. Consideration of simple kiln design, firing techniques, and procedures using various fuel burning kilns.",
    "credits": "3"
  },
  {
    "course_name": "Alternative Processes in Photography",
    "dept": "ART",
    "num": "568",
    "desc": "Prerequisite: ART 395, ART 563.\nIntroduction to a variety of historic processes in photographic image-making. Course will also include readings concerning history of photography.",
    "credits": "3"
  },
  {
    "course_name": "Mixed Media Painting Workshop",
    "dept": "ART",
    "num": "570",
    "desc": "Prerequisite: ART 345.\nExperimental approaches to painting within varied media. Focus on media, idea and composition, using traditional painting materials, including assemblage.",
    "credits": "3"
  },
  {
    "course_name": "Web Art",
    "dept": "ART",
    "num": "575",
    "desc": "Prerequisite: ART 330.\nIntroduction to interactive and network-based artistic practice. Topics covered: network art, interactive art, locative media, html, and code-based art. Explores the history of web and network-based art practice.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Typography",
    "dept": "ART",
    "num": "576",
    "desc": "Prerequisite: ART 290, ART 310, ART 400.\nTypographic theory and use exploring formal and informal structures with an analysis of historic styles. Multipage layouts emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Matrix Studio and Business Practices",
    "dept": "ART",
    "num": "577",
    "desc": "Prerequisite: ART 400 and must be a major.\nStudents are selected by portfolio review, design projects are completed to client specifications. Professional design management, ethics, setting up a business, client/designer relationships, and contractual options, billing practices, and operating procedures will be covered.",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Senior Studio",
    "dept": "ART",
    "num": "580",
    "desc": "Prerequisite: ART 420, ART 576.\nDirected senior thesis project, portfolio and resume preparation. Selected topics in design.",
    "credits": "3"
  },
  {
    "course_name": "Internships in Visual Art & Design",
    "dept": "ART",
    "num": "582",
    "desc": "Prerequisite: Instructor consent.\nEmphasis on problem solving and related skills in visual art, art history, and graphic design in a professional setting.",
    "credits": "0-3"
  },
  {
    "course_name": "Drawing Workshop I",
    "dept": "ART",
    "num": "600",
    "desc": "Prerequisite: ART 572 or ART 599.\nExpanded research with emphasis on proposing a self-directed drawing project.",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design History/Theory/Criticism",
    "dept": "ART",
    "num": "601",
    "desc": "\nStudy of significant works from late nineteenth century to the present to provide understanding of the development and character of graphic design, artists, and designers.",
    "credits": "3"
  },
  {
    "course_name": "Twentieth Century Art History III: Abstract Expressionism to Pop Art",
    "dept": "ART",
    "num": "602",
    "desc": "Prerequisite: ART 195 or 196.\nArt movements beginning with abstract expressions and continuing through pop, op, minimal, and conceptual art movements up to 1980.",
    "credits": "3"
  },
  {
    "course_name": "Twentieth Century Art History IV: Conceptual Art to Contemporary Art",
    "dept": "ART",
    "num": "603",
    "desc": "Prerequisite: ART 195 or 196.\nThe art movements of the 1980s beginning with photo-realism and continuing through pattern and decoration, new image art, neo-expressionisms, and neo-abstraction.",
    "credits": "3"
  },
  {
    "course_name": "Greek Art History",
    "dept": "ART",
    "num": "604",
    "desc": "Prerequisite: ART 195 or 196.\nThe art of classical Greece, from its Aegean origins through the Hellenistic period.",
    "credits": "3"
  },
  {
    "course_name": "Visual Art Administration & Leadership",
    "dept": "ART",
    "num": "606",
    "desc": "Prerequisite: Junior or Senior standing preferred.\nSurveys facets of management in the visual arts as preparation for work in non-profit museums, galleries or commercial galleries, and working within communities generating projects of impermanence such as performance, social practice and generosity works, pop-up exhibitions, and on-line art projects.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in Art",
    "dept": "ART",
    "num": "608",
    "desc": "Prerequisite: Three credit hours in the relevant area.\nSpecialized workshops or seminars conducted in studio, art therapy, art education, or art history.",
    "credits": "3"
  },
  {
    "course_name": "Figure Drawing II",
    "dept": "ART",
    "num": "610",
    "desc": "Prerequisite: ART 325.\nContinuation of Figure Drawing I, with emphasis on individual expression.",
    "credits": "3"
  },
  {
    "course_name": "History of Italian Renaissance Art",
    "dept": "ART",
    "num": "612",
    "desc": "Prerequisite: ART 195 or ART 196.\nRenaissance art of Italy from the thirteenth through the sixteenth centuries.",
    "credits": "3"
  },
  {
    "course_name": "History of Northern Renaissance Art",
    "dept": "ART",
    "num": "613",
    "desc": "Prerequisite: ART 195 or 196.\nRenaissance Art of Northern Europe from the fourteenth through the sixteenth century.",
    "credits": "3"
  },
  {
    "course_name": "Italian Renaissance Architecture: Patronage and Construction",
    "dept": "ART",
    "num": "614",
    "desc": "Prerequisite: ART 195 or ART 196.\nRenaissance architecture of central Italy. A case-study approach with a focus on aesthetics, construction, function, and patronage.",
    "credits": "3"
  },
  {
    "course_name": "Motion Design",
    "dept": "ART",
    "num": "616",
    "desc": "Prerequisite: Instructor permission.\nSpecialized training in motion design.",
    "credits": "3-6"
  },
  {
    "course_name": "Advanced Concepts Digital Video",
    "dept": "ART",
    "num": "621",
    "desc": "Prerequisite: ART 395 is recommended.\nIntroduction to digital video and experimental practices related to moving images and storytelling.",
    "credits": "3"
  },
  {
    "course_name": "Baroque Art History",
    "dept": "ART",
    "num": "622",
    "desc": "Prerequisite: ART 195 or 196.\nThe development of the baroque period in northern and southern Europe, from its beginnings in the early seventeenth century to the rococo style of the eighteenth century.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Concepts in Digital/Experimental Media (DX MEDIA)",
    "dept": "ART",
    "num": "623",
    "desc": "Prerequisite: ART 523.\nStudio exploration of advanced concepts in Digital/Experimental Media artistic practice.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Study in Photography I",
    "dept": "ART",
    "num": "626",
    "desc": "Prerequisite: ART 395, ART 563.\nAdvanced work in photography with an emphasis on personal development. This is one of the two capstone courses that students will take in their senior year.",
    "credits": "3"
  },
  {
    "course_name": "Foreign Studies in Art History",
    "dept": "ART",
    "num": "628",
    "desc": "\nParticipation in art history study abroad.",
    "credits": "3-6"
  },
  {
    "course_name": "Foreign Studies in Studio Art",
    "dept": "ART",
    "num": "630",
    "desc": "Prerequisite: Instructor permission.\nParticipation in studio art study abroad.",
    "credits": "3-6"
  },
  {
    "course_name": "Contemporary Media Seminar",
    "dept": "ART",
    "num": "631",
    "desc": "Prerequisite: ART 575.\nA review of trends in contemporary media and visual communication.",
    "credits": "3"
  },
  {
    "course_name": "The Development of American Art",
    "dept": "ART",
    "num": "632",
    "desc": "Prerequisite: ART 195 or 196.\nAmerican art from the Colonial period to the beginnings of abstract expressionism in the early 1940s, with major emphasis on the late nineteenth and early twentieth century developments.",
    "credits": "3"
  },
  {
    "course_name": "History of Modern Sculpture",
    "dept": "ART",
    "num": "634",
    "desc": "Prerequisite: ART 195 or 196.\nDirections in sculpture since the time of Rodin.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Printmaking Workshop",
    "dept": "ART",
    "num": "635",
    "desc": "Prerequisite: ART 335.\nAdvanced level in individual and collaborative studio work in intaglio (etching), lithography, relief printing (woodcut), screen printing, or monoprint printmaking processes.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Printmaking Atelier",
    "dept": "ART",
    "num": "636",
    "desc": "Prerequisite: ART 335.\nAdvanced level individual and collaborative studio work in intaglio (etching), lithography, relief printing (woodcut), screen printing or monoprint printmaking processes.",
    "credits": "3"
  },
  {
    "course_name": "Nineteenth Century Art History",
    "dept": "ART",
    "num": "642",
    "desc": "Prerequisite: ART 195 or 196.\nPainting, sculpture, and architecture of the late eighteenth and nineteenth centuries, with emphasis on the art of France.",
    "credits": "3"
  },
  {
    "course_name": "Sculpture II",
    "dept": "ART",
    "num": "645",
    "desc": "Prerequisite: ART 340.\nEmphasis on artistic development through exploratory experiences in the various media. Advanced wood working processes, mold making, foundry techniques and welding processes.",
    "credits": "3"
  },
  {
    "course_name": "Advanced/Senior Painting Studio",
    "dept": "ART",
    "num": "650",
    "desc": "Prerequisite: ART 561 and ART 570.\nIndividualized studio work in varied painting media. Focus on strengths and exploration of media for personal expression. Emphasis for graduating seniors will be on producing a cohesive body of work in preparation of BFA exhibition.",
    "credits": "3-6"
  },
  {
    "course_name": "Women in Art",
    "dept": "ART",
    "num": "654",
    "desc": "Prerequisite: ART 195 or 196.\nThe work of women artists from early Middle Ages to the twentieth century, with emphasis on the contemporary period.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Studio in Metals& Jewelry",
    "dept": "ART",
    "num": "655",
    "desc": "Prerequisite: ART 375.\nExplore concepts and processes in contemporary metal art and jewelry field. Develop individual research projects through assignments, individual meetings, presentations and group critiques. Students in capstone section will focus on creating a unique body of work for BFA show and portfolio.",
    "credits": "3"
  },
  {
    "course_name": "Sculpture III",
    "dept": "ART",
    "num": "660",
    "desc": "Prerequisite: ART 340, ART 645.\nContinuation of Sculpture II. Further exploration of media and technique, emphasizing the development of individual direction and expression. Primarily for undergraduate sculpture majors.",
    "credits": "3"
  },
  {
    "course_name": "Southwestern Indian Arts and Culture",
    "dept": "ART",
    "num": "662",
    "desc": "Prerequisite: ART 195 or 196.\nThe development of southwestern Indian silversmithing, weaving, pottery, basketry, and painting from the prehistoric period through the twentieth century.",
    "credits": "3"
  },
  {
    "course_name": "Ceramics III",
    "dept": "ART",
    "num": "665",
    "desc": "Prerequisite: ART 565.\nIndividual exploration and further development of ceramic design and glaze technology; continuation of kiln design and construction.",
    "credits": "3"
  },
  {
    "course_name": "History of Ceramics",
    "dept": "ART",
    "num": "675",
    "desc": "Prerequisite: ART 195 or 196.\nHistory and development of ceramics; study of the use of pottery and other aspects of ceramics from earliest known records to present day. Use of slides and other visual materials.",
    "credits": "3"
  },
  {
    "course_name": "Color Experiments, Theory and Application",
    "dept": "ART",
    "num": "679",
    "desc": "Prerequisite: ART 180.\nExplores the interaction of color through a variety of exercises, both practical and experimental. Emphasis on visual perception and the relative use of color. Color’s potential in illusionist structures and visual communication, color systems.",
    "credits": "3"
  },
  {
    "course_name": "Metals Workshop",
    "dept": "ART",
    "num": "680",
    "desc": "Prerequisite: ART 655.\nIndependent study designed for advanced level students to research and master metalsmithing and jewelry techniques through individual concentration as well as to develop a personal artistic language to create a unique body of work for BFA show.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Independent Study Design",
    "dept": "ART",
    "num": "685",
    "desc": "Prerequisite: Full sequence of courses related to problem subject matter.\nAdvanced work in design-related subjects.",
    "credits": "1-18"
  },
  {
    "course_name": "Techniques in Teaching Art",
    "dept": "ART",
    "num": "690",
    "desc": "Prerequisite: Twelve hours in art or consent of instructor.\nLectures and class discussion of methods, consideration of suitable laboratory equipment, use of illustrative material, and preparation of courses of study.",
    "credits": "1-18"
  },
  {
    "course_name": "Drawing Workshop II",
    "dept": "ART",
    "num": "692",
    "desc": "Prerequisite: ART 572 or ART 599.\nThe senior capstone course, dedicated to refining individually determined drawing portfolio.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Art History",
    "dept": "ART",
    "num": "695",
    "desc": "Prerequisite: Twelve hours art history.\nIndependent exploration in selected problems in art history.",
    "credits": "1-18"
  },
  {
    "course_name": "Foundations in Animal Sciences & Industry",
    "dept": "ASI",
    "num": "101",
    "desc": "Prerequisite: Freshman in ASI or PRVAG.\nIntroduction to the animal sciences &amp; industry programs, activities, resources, faculty and career opportunities.",
    "credits": "1"
  },
  {
    "course_name": "Principles of Animal Science",
    "dept": "ASI",
    "num": "102",
    "desc": "\nBasic principles which apply to animal agriculture; survey of the industry; types, purposes, and products of livestock; principles of breeding, selection, nutrition, lactation, reproduction, management, and marketing.",
    "credits": "3"
  },
  {
    "course_name": "Animal Sciences and Industry",
    "dept": "ASI",
    "num": "105",
    "desc": "\nA study of the breeding and market types and classes of livestock including a comparison of the live animal and carcass evaluation.",
    "credits": "1"
  },
  {
    "course_name": "Dairy and Poultry Science",
    "dept": "ASI",
    "num": "106",
    "desc": "\nIntroduction to the dairy and poultry industries.",
    "credits": "1"
  },
  {
    "course_name": "Companion Animal and Horse Lab",
    "dept": "ASI",
    "num": "107",
    "desc": "\nAn introduction to the companion animal and equine industries. Career opportunities in the companion animal and equine industries. The use of companion animals in society, their value, and production systems. Basic biology, breed identification, health, handling, training, and selection.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Research in Animal Science",
    "dept": "ASI",
    "num": "200",
    "desc": "\nAn introduction to research with agricultural animals.  The breadth of research activities in animal science will be covered. Research careers in academic, government, and private sector settings will be emphasized. Types of research, ethical considerations in research, animal care, and regulatory issues will be addressed. Student team projects are integral.",
    "credits": "1"
  },
  {
    "course_name": "Intro to Animal Biotechnology",
    "dept": "ASI",
    "num": "210",
    "desc": "Prerequisite: Freshman or Sophomore Standing\nThis course is designed to provide undergraduates in the College of Agriculture hands-on experience in molecular biology and associated problem-solving for applications in agriculture. Students will learn the basics of laboratory book maintenance, pipetting, dilution and concentration calculations, DNA and RNA extraction and amplification, and protein isolation and quantification.",
    "credits": "3"
  },
  {
    "course_name": "Microcomputer Applications in Animal Sciences and Industry",
    "dept": "ASI",
    "num": "290",
    "desc": "\nApplications of microcomputer techniques to the solutions of problems in animal science and related food industries. Includes use of existing software packages for breakeven analysis, animal identification and health records, feed ration analysis, farm/ranch accounting, and electronic communication.",
    "credits": "3"
  },
  {
    "course_name": "Poultry and Poultry Product Evaluation",
    "dept": "ASI",
    "num": "310",
    "desc": "\nApplied knowledge of physical and anatomical characteristics for evaluating poultry for egg and meat production. Evaluation of ready-to-cook poultry products as well as eggs on their exterior, interior, and broken-out appearance according to the latest USDA standards.",
    "credits": "2"
  },
  {
    "course_name": "Livestock and Meat Evaluation",
    "dept": "ASI",
    "num": "315",
    "desc": "Prerequisite: ASI 105.  Recommended prerequisite: ASI 102 or instructor consent.\nEvaluation of slaughter livestock and their carcasses as related to economically efficient production of red meat. Evaluation of breeding livestock on visual appraisal and performance records. A study of growth and the effects of nutrition, environment, and hormones on growth patterns. Breeds of livestock and performance programs will be studied.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Nutrition",
    "dept": "ASI",
    "num": "318",
    "desc": "Prerequisite: CHM 110.  Recommended prerequisite: BIOL 198.\nElementary principles of comparative nutrition of farm animals.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Feeding",
    "dept": "ASI",
    "num": "320",
    "desc": "Prerequisite: MATH 100. Recommended prerequisite: ASI 318.\nApplication of basic nutrition principles to the feeding of beef cattle, sheep, and swine; feedstuff evaluation; nutrient requirements; ration formulation and practical feeding problems.",
    "credits": "3"
  },
  {
    "course_name": "Beginning Horse Evaluation",
    "dept": "ASI",
    "num": "325",
    "desc": "\nEvaluation of conformation and athletic performance of horses. The use of records in selection and the influence of heredity, environment, and training on conformation and performance is addressed.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Horse Evaluation",
    "dept": "ASI",
    "num": "326",
    "desc": "Prerequisite: ASI 325.\nIn-depth study of horse conformation and performance horse evaluation. Theories from various equine disciplines are covered with emphasis placed on interpreting horse industry standards, and abilities to communicate those ideals effectively.",
    "credits": "2"
  },
  {
    "course_name": "Equine Enterprise Management",
    "dept": "ASI",
    "num": "333",
    "desc": "Prerequisite: Enrollment in Equine Science Certificate Program (CEQSC) and sophomore standing.\nEmphasis will be placed on management issues affecting the successful development and operation of an equine facility. Topics covered include health care, diet formulation, equipment needs, facility design and management, and equine business considerations.",
    "credits": "1"
  },
  {
    "course_name": "Beginning Horse Training and Management",
    "dept": "ASI",
    "num": "345",
    "desc": "Prerequisite: Enrollment in Equine Science Certificate Program (CEQSC).\nInherited and learned behavior of the horse. Development of methods to communicate with the horse. Emphasis on handling and safety techniques. Opportunities to observe and practice advanced training techniques used in saddling and riding.",
    "credits": "2"
  },
  {
    "course_name": "Meat Science",
    "dept": "ASI",
    "num": "350",
    "desc": "\nAn introduction to the red meat industry relating the fundamental properties of muscle structure, chemistry, and physiology to meat quality, composition, processing, nutritional value, and marketing. The laboratory will demonstrate the conversion of animals to meat and by-products, and meat processing technology.",
    "credits": "3"
  },
  {
    "course_name": "Meat Animal Processing",
    "dept": "ASI",
    "num": "361",
    "desc": "Prerequisite: Sophomore standing.\nA student participation course in processing live animals into meat and by-products. Interrelates all phases of modern slaughter and processing techniques, inspection and processing, and related operations.",
    "credits": "2"
  },
  {
    "course_name": "Principles of Meat Evaluation",
    "dept": "ASI",
    "num": "370",
    "desc": "\nThe use of subjective and objective standards to evaluate beef, lamb, and pork carcasses and wholesale cuts for both quality and yield of edible portion as they relate to value and consumer acceptance.",
    "credits": "2"
  },
  {
    "course_name": "Wool Grading and Evaluation",
    "dept": "ASI",
    "num": "385",
    "desc": "\nA study of factors determining the commercial grades of wool and the desired fleece qualities of sheep, practice in judging and grading wool.",
    "credits": "1"
  },
  {
    "course_name": "Intermediate Horse Training & Management",
    "dept": "ASI",
    "num": "395",
    "desc": "Prerequisite: Enrollment in Equine Science Certificate Program (CEQSC).\nApplication of training techniques used to start young horses under saddle. Emphasis is placed on developing groundwork skills needed to prepare horses for riding, including longeing, introduction to the saddle and bridle, and driving.",
    "credits": "2"
  },
  {
    "course_name": "Dairy Cattle Judging",
    "dept": "ASI",
    "num": "396",
    "desc": "\nAn introduction to the principles of evaluating dairy cattle on the basis of their physical characteristics. Interpretation of the official dairy cow unified score card. Training includes preparation and presentation of oral defense on one’s placing of four cow classes.",
    "credits": "2"
  },
  {
    "course_name": "ASI Quadrathalon",
    "dept": "ASI",
    "num": "399",
    "desc": "\nActive participation in the ASI Quadrathalon involving oral presentations, written exams, practical application of animal knowledge, and a quiz bowl.",
    "credits": "0-1"
  },
  {
    "course_name": "Farm Animal Reproduction",
    "dept": "ASI",
    "num": "400",
    "desc": "Prerequisite: ASI 102, BIOL 198 and Sophomore standing.\nBasic reproductive anatomy and physiology of cattle, horses, pigs, poultry, and sheep during the first half of the semester provides a solid basis for reproduction management topics which occupy the second half of the course.",
    "credits": "3"
  },
  {
    "course_name": "Farm Animal Reproduction Laboratory",
    "dept": "ASI",
    "num": "401",
    "desc": "Prerequisite: ASI 400 or concurrent enrollment.\nLaboratory exercises with reproductive specimens of farm species. Will include adult male and female reproductive tracts, anatomical changes associated with estrous cycles and anestrus, pregnancy, fetal and placental development, semen characteristics, and ultrasonography.",
    "credits": "1"
  },
  {
    "course_name": "Calving",
    "dept": "ASI",
    "num": "402",
    "desc": "\nEmphasis will be placed on various aspects of managing parturition in cattle. Focus on stages of parturition, dystocia, and calf care.",
    "credits": "1"
  },
  {
    "course_name": "Foaling",
    "dept": "ASI",
    "num": "403",
    "desc": "Prerequisite: Enrollment in Equine Science Certificate Program (CEQSC) and sophomore standing.\nEvents associated with late gestation, parturition, and the early postpartum period in the horse. Emphasis will be placed on the important aspects of caring for and monitoring a pregnant/lactating mare and her newborn foal.",
    "credits": "1"
  },
  {
    "course_name": "Lambing",
    "dept": "ASI",
    "num": "404",
    "desc": "\nTheoretical and practical experience in lambing. Management of the ewe and lambs at parturition, physiology of parturition, and common problems encountered by ewes and lambs during parturition.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Milk Processing",
    "dept": "ASI",
    "num": "405",
    "desc": "Prerequisite: BIOL 198.\nA study of fundamentals of processing, quality assurance, inspection, and marketing of fluid milk and related products in a modern market milk enterprise.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Dairy Cattle Judging",
    "dept": "ASI",
    "num": "420",
    "desc": "Prerequisite: ASI 396.",
    "credits": "1"
  },
  {
    "course_name": "Livestock Sales Management",
    "dept": "ASI",
    "num": "422",
    "desc": "\nHands-on experience in the planning, promotion, and production of a purebred livestock sale.",
    "credits": "0-1"
  },
  {
    "course_name": "Equine Health",
    "dept": "ASI",
    "num": "444",
    "desc": "Prerequisite: Enrollment in Equine Science Certificate Program (CEQSC) and sophomore standing.\nFundamentals of equine health care and practical experience with the procedures routinely performed by horse owners in the overall management of their horse’s well-being. Topics covered include basic anatomy and physiology, recognizing and managing disease conditions and emergency situations, and preventative management strategies and treatment options for a variety of health-related issues.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Horse Training and Management",
    "dept": "ASI",
    "num": "445",
    "desc": "\nStudents will further develop skills acquired in ASI 345. Students will learn how to utilize advanced training practices and applications to enhance the training and performance of horses.",
    "credits": "2"
  },
  {
    "course_name": "Principles of Livestock Selection",
    "dept": "ASI",
    "num": "450",
    "desc": "\nOrigin, development, characteristics, and adaptation of different breeds of livestock, with special emphasis on the selection of market and breeding animals.",
    "credits": "2"
  },
  {
    "course_name": "Form and Function in Livestock",
    "dept": "ASI",
    "num": "470",
    "desc": "Prerequisite: ASI 450.\nA detailed study of animal form and type; influence of type related to function; special training in presenting orally the relative merits of beef cattle, sheep, swine, and horses.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Meat Evaluation",
    "dept": "ASI",
    "num": "495",
    "desc": "Prerequisite: ASI 370.\nAdvanced study in the evaluation of carcasses, wholesale cuts, and retail cuts of beef, lamb, and pork. Application of grade standards and specifications to beef, lamb, and pork carcasses and subprimal cuts.",
    "credits": "2"
  },
  {
    "course_name": "Genetics",
    "dept": "ASI",
    "num": "500",
    "desc": "Prerequisite: BIOL 198, MATH 100 and Sophomore Standing.\nAn introduction to Mendelian, molecular, quantitative, and population genetics.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Equine Reproductive Management",
    "dept": "ASI",
    "num": "502",
    "desc": "Prerequisite: Junior standing.\nAn overview of the physiological mechanisms involved in equine reproduction and the scientific reasoning for breeding management decisions. Recent advances in equine reproductive technology will be highlighted and relevant research will be incorporated into the presentations.",
    "credits": "2"
  },
  {
    "course_name": "Equine Reproduction Management",
    "dept": "ASI",
    "num": "504",
    "desc": "Prerequisite: Junior standing.  Recommended prerequisite: ASI 400.\nOverview of the physiological mechanisms involved in equine reproduction and the scientific reasoning behind breeding management decisions.  Recent advances in equine reproductive technology will be highlighted.  Lab exercises focus on learning breeding techniques including semen collection and processing, and artificial insemination.",
    "credits": "3"
  },
  {
    "course_name": "Animal Breeding Principles",
    "dept": "ASI",
    "num": "510",
    "desc": "Prerequisite: ASI 102 and ASI 500.\nThe genetic principles of evaluation, selection and mating systems used in beef, dairy, sheep, swine, poultry, horse and companion animal breeding. Intended for ASI majors and minors.",
    "credits": "3"
  },
  {
    "course_name": "Bovine Reproductive Technologies",
    "dept": "ASI",
    "num": "512",
    "desc": "Prerequisite: ASI 400, senior standing and consent of instructor.\nReproductive technologies used in management of cattle including the physiology of the estrous cycle, embryo viability, and fetal development. Practical training in reproductive management technique.",
    "credits": "2"
  },
  {
    "course_name": "Beef Science",
    "dept": "ASI",
    "num": "515",
    "desc": "Prerequisite: Junior or senior standing.\nA comprehensive course covering all phases of the beef cattle industry. Practical application of nutrition, breeding, physiology of reproduction, merchandising, risk management and related areas. Special emphasis on management systems of raising, growing and finishing beef cattle.",
    "credits": "3"
  },
  {
    "course_name": "Companion Animal Management",
    "dept": "ASI",
    "num": "520",
    "desc": "Prerequisite: Junior standing.  Recommended prerequisite: ASI 107.\nGeneral biology and management of pets in zoos, kennels and at home. Working safely with companion animals. Management of animals in kennels, shelters, research facilities and zoos. Regulatory issues of small animals used as companion pets and in laboratory research. Interactive discussion and written skills will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Horse Science",
    "dept": "ASI",
    "num": "521",
    "desc": "Prerequisite: Junior standing.\nA study of the horse industry in the United States, breed profiles, anatomy and evaluation, nutrition, reproduction, growth and development, health, exercise physiology, facilities and equipment, business considerations.",
    "credits": "3"
  },
  {
    "course_name": "Sheep  and Meat Goat Science",
    "dept": "ASI",
    "num": "524",
    "desc": "Prerequisite: Junior standing.\nApplication of scientific management principles to the sheep and meat goat industries. Breeding, reproduction, nutrition, health, management and economic aspects as related to sheep and meat goat production.",
    "credits": "3"
  },
  {
    "course_name": "Anatomy and Physiology",
    "dept": "ASI",
    "num": "533",
    "desc": "Prerequisite: BIOL 198.\nGeneral anatomy and physiology of the domestic animals.",
    "credits": "4"
  },
  {
    "course_name": "Swine Science",
    "dept": "ASI",
    "num": "535",
    "desc": "Prerequisite: Junior or senior standing.\nApplication of basic scientific principles to the economical production of pork. Recommendations are made in breeding, reproduction, nutrition, health, housing, marketing, and management of swine production units of varying sizes.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Animal Disease Control",
    "dept": "ASI",
    "num": "540",
    "desc": "Prerequisite: Junior Standing.\nA study of the factors that influence animal health and disease control for students majoring in agriculture and other fields.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research in Animal Sciences & Industry",
    "dept": "ASI",
    "num": "561",
    "desc": "Prerequisite: Consent of instructor.\nMentored undergraduate research experience in animal or food sciences.",
    "credits": "0-3"
  },
  {
    "course_name": "Animal Sciences and Industry Career Preparation",
    "dept": "ASI",
    "num": "580",
    "desc": "Prerequisite: ASI major and Junior Standing.\nCareer exploration and life skill development. Assist students with internship development, interviewing skills, and professional communication formats.",
    "credits": "1"
  },
  {
    "course_name": "Contemporary Issues in Animal Science and Agriculture",
    "dept": "ASI",
    "num": "595",
    "desc": "\nThe development and management of current issues affecting animal agriculture and science in three primary areas: 1) how do issues develop; 2) the political aspects of issues; and 3) the development of expertise based on objective assessment. Current issues such as animal welfare/rights, environment, genetic engineering, etc., will be used to provide students with practical learning experiences.",
    "credits": "3"
  },
  {
    "course_name": "Bioscience Internship in Animal Science",
    "dept": "ASI",
    "num": "598",
    "desc": "\nSupervised professional experience in bioscience realm of animal sciences. One credit hour per one month full-time supervised and evaluated work hours. Internship proposal, evaluation by supervisor, self-assessment, and presentation of internship required.",
    "credits": "1-6"
  },
  {
    "course_name": "Animal Science Internship",
    "dept": "ASI",
    "num": "599",
    "desc": "Prerequisite: Permission of supervising faculty member.\nSupervised professional experience in animal science related field. One credit hour per month full-time supervised and evaluated work hours. Internship proposal, evaluation by supervisor, self-assessment and presentation of internship required.",
    "credits": "1-6"
  },
  {
    "course_name": "Applied Animal Biotechnology",
    "dept": "ASI",
    "num": "600",
    "desc": "Prerequisite: ASI BI Students, Junior Standing and ASI 500 or BIOL 450.\nThe objective of this course is to provide insight into the use of large animals in areas of biotechnology.  The course will emphasize the use of livestock in food production as well as human medicine applications.  A two-hour lecture per week will include topics such as marker assisted selection of livestock, in-vitro fertilization, transgenics, cloning and stem cell technology. A two-hour lab per week will complement material from lectures including PCR, DNA isolation and oocyte collection.",
    "credits": "3"
  },
  {
    "course_name": "Endocrinology and Lactation",
    "dept": "ASI",
    "num": "601",
    "desc": "Prerequisite: BIOL 198 and junior standing.\nProvides an overview of the endocrine systems that regulate mammalian lactation and other related physiological processes. Topics include structure and function of important endocrine glands and their hormones, receptors, target tissues and physiological mechanisms of action. Emphasis will be placed on whole animal hormonal interactions that regulate nutrient availability for production of milk in dairy cattle and other dairy species. Upon completion of the course students should be able to identify important endocrine organs and hormones and apply their understanding to problems in dairy production.",
    "credits": "3"
  },
  {
    "course_name": "Equine Breeding and Genetics",
    "dept": "ASI",
    "num": "602",
    "desc": "Prerequisite: Junior standing.\nApplication of genetic and animal breeding principles to the horse.  Emphasis on inheritance of color and diseases, as well as selection and mating programs.",
    "credits": "2"
  },
  {
    "course_name": "Dairy Foods Processing & Technology",
    "dept": "ASI",
    "num": "608",
    "desc": "Prerequisite: BIOL 455.\nThe fundamental technologies used to process high quality dairy foods using freezing, heat membrane and pressure technologies. Changes in milk chemistry, microbiology and structure will be emphasized during the processing of butter, soft and hard cheeses, concentrated milks, ice cream and yogurt.",
    "credits": "3"
  },
  {
    "course_name": "Processed Meat Operations",
    "dept": "ASI",
    "num": "610",
    "desc": "Prerequisite: ASI 350.\nAn intensive course in processed meats, relating the science, technology and quality control of curing, smoking and sausage manufacture.",
    "credits": "2"
  },
  {
    "course_name": "Beef Systems Management",
    "dept": "ASI",
    "num": "620",
    "desc": "Prerequisite: ASI 515\nDevelopment of beef enterprise business plans and analysis of breeding, nutrition, health and management programs for beef operations.",
    "credits": "2"
  },
  {
    "course_name": "Dairy Cattle Management",
    "dept": "ASI",
    "num": "621",
    "desc": "Prerequisite: Junior or senior standing.\nIntegration of biologic and economic aspects of dairy production with dairy farm organization, planning, operation and analysis. Field trips, dairy farm analysis and case studies will be used to supplement lecture material.",
    "credits": "3"
  },
  {
    "course_name": "Gamebird Production and Management",
    "dept": "ASI",
    "num": "635",
    "desc": "\nPrinciples and practices of upland game bird production including incubation and hatching, flight pen construction, nutritional management, predation control, disease management and meat processing.",
    "credits": "3"
  },
  {
    "course_name": "Poultry Products Technology",
    "dept": "ASI",
    "num": "640",
    "desc": "\nEmphasis on the technical problems that exist between production and consumption during the processing and marketing of poultry meat and egg products. A study of the microbiology of shell eggs, meat and manufactured products and the basic principles of quality assurance. Food manufacturing and product development are discussed.",
    "credits": "3"
  },
  {
    "course_name": "Poultry Management",
    "dept": "ASI",
    "num": "645",
    "desc": "Prerequisite: Junior or senior standing.\nA detailed study of the production and management practices involved in commercial poultry and game bird enterprises.",
    "credits": "3"
  },
  {
    "course_name": "Identification and Data Management of Food Animals",
    "dept": "ASI",
    "num": "650",
    "desc": "Prerequisite: Junior standing.\nProcedures and the conventions required to accomplish individual identification for farm animals. Principles of sound data collection and management. Principles of automatic information and data capture technologies for transforming data into information. Guest lectures from allied industry and livestock producers will illustrate various products, services and applications.",
    "credits": "2"
  },
  {
    "course_name": "Behavior of Domestic Animals",
    "dept": "ASI",
    "num": "655",
    "desc": "Prerequisite: BIOL 198 and junior standing.\nBehavior associated with domestication. Effects of selective breeding, physical and social environments, and developmental stage on social organization, aggressive behavior, sexual behavior, productivity and training of domestic animals. Physiology of behavior and abnormal behavior considered briefly.",
    "credits": "3"
  },
  {
    "course_name": "Animal Growth and Development",
    "dept": "ASI",
    "num": "658",
    "desc": "Prerequisite: ASI 533 and a course in biochemistry.\nThe molecular and endocrine mechanisms of prenatal and postnatal growth and development of muscle, bone, and adipose tissue will be discussed. Historical and current scientific literature will be reviewed and utilized to reinforce the topics covered.",
    "credits": "3"
  },
  {
    "course_name": "International Study Experience in Animal Science",
    "dept": "ASI",
    "num": "660",
    "desc": "Prerequisite: Instructor permission.\nSeminar and travel course designed to prepare students before the experience and for students to analyze, critique, and report their experiences of an international experience associated with study tours or short courses. Course will focus on appropriate oral and written documentation of the student learning objectives for course experience. The academic topics will vary with each international activity.",
    "credits": "0-6"
  },
  {
    "course_name": "Animal Sciences and Industry Problems",
    "dept": "ASI",
    "num": "661",
    "desc": "Prerequisite: Consent of instructor.\nIndependent guided studies in any of the many fields associated with animals and animal products.",
    "credits": "1-18"
  },
  {
    "course_name": "Special Topics in Animal Science",
    "dept": "ASI",
    "num": "662",
    "desc": "\nSeminars of special interest. Will be offered upon sufficient demand in selected areas relating to animal science.",
    "credits": "0-6"
  },
  {
    "course_name": "Meat Selection and Utilization",
    "dept": "ASI",
    "num": "671",
    "desc": "Prerequisite: CHM 110 and 111.\nEmphasis on meat cut identification, muscle and bone anatomy, grades, fabricated meat, institutional cuts, specification writing, processing, meat preparation and shrinkage costs.",
    "credits": "2"
  },
  {
    "course_name": "Monogastric Nutrition",
    "dept": "ASI",
    "num": "675",
    "desc": "Prerequisite: ASI 320.\nAn overview of the nutritional principles involved with feeding nonruminants. Topics will include digestive anatomy and the metabolism of carbohydrates, lipids, amino acids, vitamins, and minerals.",
    "credits": "1"
  },
  {
    "course_name": "Avian Nutrition",
    "dept": "ASI",
    "num": "676",
    "desc": "Prerequisite: ASI 675 or concurrent enrollment.\nNutritional requirements of game birds, caged birds, exotics, and commercial poultry. Interactive discussion will be emphasized.",
    "credits": "1"
  },
  {
    "course_name": "Companion Animal Nutrition",
    "dept": "ASI",
    "num": "677",
    "desc": "Prerequisite: ASI 675 or concurrent enrollment.\nThis course is intended to be taken in sequence following Monogastric Nutrition ASI 675. The course will cover the unique nature of nutrition for companion animals with an emphasis on the nutrition of dogs and cats. Details regarding dentition, digestion, metabolism and nutritional requirements will be covered. In addition, an overview of the nutrition of other minor companion species will be provided. Besides standard assessments methods students will be expected to review current research publications on the topic and provide written and oral presentations germane to the topic.",
    "credits": "1"
  },
  {
    "course_name": "Equine Nutrition",
    "dept": "ASI",
    "num": "678",
    "desc": "Prerequisite: ASI 675 or concurrent enrollment.\nEquine digestive anatomy and physiology. Nutrient requirements of the equine as they relate to growth, work, reproduction and lactation, as well as the relationship of nutrition to disease and environment. Practical management considerations and current equine nutrition research will be reviewed.",
    "credits": "1"
  },
  {
    "course_name": "Swine Nutrition",
    "dept": "ASI",
    "num": "679",
    "desc": "Prerequisite: ASI 675 or concurrent enrollment.\nA study of the nutrient requirements of swine for various stages of production. Discussion of the interrelationships among nutrition and other factors (environment, management, and health) that affect performance.",
    "credits": "1"
  },
  {
    "course_name": "Ruminant Nutrition",
    "dept": "ASI",
    "num": "680",
    "desc": "Prerequisite: ASI 320.\nAdvanced study of nutritional management of different species of ruminant livestock. Topics covered include ruminal function, post-ruminal digestion and absorption, utilization of key nutrients, and discussion of select metabolic disorders.",
    "credits": "1"
  },
  {
    "course_name": "Dairy Cattle Nutrition",
    "dept": "ASI",
    "num": "681",
    "desc": "Prerequisite: ASI 680 or concurrent enrollment.\nNutritional management of dairy calves, replacement heifers, dry and lactating dairy cows. Diet formulation, feeding systems and current concepts in dairy cattle nutrition.",
    "credits": "1"
  },
  {
    "course_name": "Formulation of Livestock and Poultry Diets",
    "dept": "ASI",
    "num": "682",
    "desc": "\nDiet formulation for the major species of livestock and poultry. Major topics include hand formulation of diets: ingredient/nutrient cost comparisons; dry matter manipulation; computerized diet formulation; developing specifications for diets, supplements, basemixes and premixes; projecting animal performance; and feed labeling.",
    "credits": "1"
  },
  {
    "course_name": "Grazing Livestock Nutrition",
    "dept": "ASI",
    "num": "683",
    "desc": "Prerequisite: ASI 680 or concurrent enrollment.\nNutritional management of grazing beef cattle. Nutrition of beef cows and stocker cattle maintained under grazing conditions. Major topics to be covered include nutrient requirements, forage intake, forage quality, and supplementation.",
    "credits": "1"
  },
  {
    "course_name": "Nutrition of Feedlot Cattle",
    "dept": "ASI",
    "num": "684",
    "desc": "Prerequisite: ASI 680 or concurrent enrollment.\nNutritional management of growing and finishing beef cattle maintained under confined feeding conditions. Utilization of cereal grains and byproducts in the production of beef. Major topics include nutrient requirements, feed processing, growing-finishing systems, feed additives, metabolic disturbances, and nutrient management.",
    "credits": "1"
  },
  {
    "course_name": "Stored Forage Systems for Ruminant Animals",
    "dept": "ASI",
    "num": "685",
    "desc": "Prerequisite: ASI 680 or concurrent enrollment.\nA study of nutrient conservation in various stored forage systems including storage facilities and equipment, nutrient loss, aerobic deterioration, chemical and physical analysis. Discussions will also include the impact of stored forage systems on forage quality and the subsequent effects on digestion and utilization in ruminant animals.",
    "credits": "1"
  },
  {
    "course_name": "Principles of Equine Exercise Physiology",
    "dept": "ASI",
    "num": "695",
    "desc": "\nPhysiological systems reactions and adaption to exercise and training in the equine athlete.  Additional topics addressed will include biomechanics, injury prevention and rehabilitation.",
    "credits": "3"
  },
  {
    "course_name": "Physiology of Reproduction in Farm Animals",
    "dept": "ASI",
    "num": "710",
    "desc": "Prerequisite: ASI 400.\nThe physiological aspects of reproduction in farm animals including endocrine inter-relationships controlling reproductive cycles and gamete production. Periodic demonstrations deal with specialized reproductive anatomy of farm animals, experimental techniques used in animal reproduction, and contemporary animal production practices.",
    "credits": "3"
  },
  {
    "course_name": "Anaerobic Bacteriology",
    "dept": "ASI",
    "num": "720",
    "desc": "Prerequisite: BIOL 455.\nStudy of anaerobic bacteria, anaerobiosis, description of anaerobic techniques, and physiology and biochemistry of anaerobes of natural environment including gastrointestinal tract, and of veterinary, medical, and industrial importance.",
    "credits": "2"
  },
  {
    "course_name": "Quantitative Genetics Applications of Matrix Algebra",
    "dept": "ASI",
    "num": "741",
    "desc": "\nThe goal of this course is development of skills in matrix algebra to describe and solve problems in the agricultural and life sciences, with particular focus on quantitative genetics. The course is designed for students with no prior knowledge of matrix algebra, and whose formal training in mathematics may be somewhat limited. It will consider the vocabulary, concepts, application and, to a lesser extent, theory of matrix algebra that is relevant to graduate students in the agricultural and life sciences. Application exercises will consider ecological systems, genotypic transition matrices, selection indices, and the numerator relationship matrix. Application of methods such as least squares, and canonical transformation to solve problems in the biological sciences using matrix algebra will also be introduced.",
    "credits": "1"
  },
  {
    "course_name": "Cybersheep: A Genetic Simulation Game",
    "dept": "ASI",
    "num": "742",
    "desc": "\nThe goal of this course is for students to be able to make informed and effective decisions in a livestock breeding program. In order to accomplish this goal, the course will provide hands-on experience with selection and mating decisions, and their consequences through a genetic simulation. Genetic gains require time to achieve and there is very little opportunity for students to witness the consequences of breeding decisions in a course. The simulation is designed to offer an opportunity to see in real-time, the outcome of decision-making, and to experience the stochastic (chance) elements of a breeding program.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Animal Breeding",
    "dept": "ASI",
    "num": "749",
    "desc": "\nApplication of genetic principles to livestock improvement, selection methods, mating systems, heritability estimates and methods of analyzing genetic data.",
    "credits": "3"
  },
  {
    "course_name": "Meat Industry Technology",
    "dept": "ASI",
    "num": "776",
    "desc": "Prerequisite: ASI 350.\nApply concepts and information about meat composition, product safety and spoilage, quality; formulation, processing and evaluation of cured, pre-cooked, and sausage packaging, troubleshooting, and plant organization.",
    "credits": "3"
  },
  {
    "course_name": "Fresh Meat Technology",
    "dept": "ASI",
    "num": "777",
    "desc": "Prerequisite: ASI 350 and senior standing.\nFresh meat properties, value, marketing, and appropriate handling procedures. Current meat technology and pertinent aspects of the domestic and international meat industries will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Graduate Internship in Animal Sciences and Industry",
    "dept": "ASI",
    "num": "799",
    "desc": "Prerequisite: Permission of supervising faculty member.\nIn-depth work-study experiences on beef cattle, sheep, dairy cattle, swine, horse or poultry production operations or in animal food products plants.",
    "credits": "1-4"
  },
  {
    "course_name": "New Student Seminar",
    "dept": "AT",
    "num": "110",
    "desc": "\nOrientation for incoming first year and transfer students designed to acquaint them with matters related to the Department of Apparel, Textiles, and Interior Design, the apparel and textiles major, to promote active involvement, and to enhance the university experience.",
    "credits": "1"
  },
  {
    "course_name": "Apparel and Textile Industry",
    "dept": "AT",
    "num": "245",
    "desc": "\nSurvey of the organization and operation of the U.S. apparel and textile industry; examination of the principles and processes required to meet the needs of the apparel/textile consumer; particular emphasis on sustainability challenges and opportunities pertaining to the industry.",
    "credits": "3"
  },
  {
    "course_name": "Textiles",
    "dept": "AT",
    "num": "265",
    "desc": "\nFundamentals of textiles as related to the production, sale, and use of soft goods. Understanding of the environmental impacts of fiber, yarn, and fabric production. Laboratory experiences related to the identification of fibers, yarns, and fabrics and to the care and performance of textile products.",
    "credits": "3"
  },
  {
    "course_name": "Apparel Production I",
    "dept": "AT",
    "num": "300",
    "desc": "Prerequisite: Instructor’s Permission.\nFundamentals of apparel production; introduction to garment sizing and fit.",
    "credits": "3"
  },
  {
    "course_name": "Apparel and Textiles Retailing",
    "dept": "AT",
    "num": "325",
    "desc": "Prerequisite: AT 245.\nIntroduction to the strategic role of retailing in the value chain; analyzing components, processes, and controls involved in managing a soft goods retailing organization while exploring the impetus for triple bottom line thinking in an industry transitioning toward sustainability.",
    "credits": "3"
  },
  {
    "course_name": "Dress and Human Behavior",
    "dept": "AT",
    "num": "330",
    "desc": "Prerequisite: SOCIO 211 or PSYCH 110 and sophomore standing.\nCultural, social, psychological, and economic aspects related to dress and human behavior of individuals and groups; focus on market segmentation.",
    "credits": "3"
  },
  {
    "course_name": "Aesthetics of Apparel and Textiles",
    "dept": "AT",
    "num": "340",
    "desc": "\nUnderstanding and application of aesthetics as it relates to the roles of the apparel industry professional and the development, selection, and promotion of apparel and textile products.",
    "credits": "3"
  },
  {
    "course_name": "Our Sustainable World: Current Challenges and Future Opportunities",
    "dept": "AT",
    "num": "350",
    "desc": "\nSustainability has become one of the most pressing scientific and social challenges of the modern era. This course introduces students to the theory, principles, and practices of sustainability - by focusing on environmental, social, and economic sustainability perspectives, behaviors, policies, and customs on a global level. It includes discussions on creating ecological health, economic welfare, and social justice.",
    "credits": "3"
  },
  {
    "course_name": "Computer Technologies for Merchandising",
    "dept": "AT",
    "num": "375",
    "desc": "Prerequisite: AT 340.\nStudies in computer-based advertising and promotional strategies for the apparel and textile industry. Students will apply skills to graphic presentation and current industry technologies.",
    "credits": "3"
  },
  {
    "course_name": "Fashion Illustration",
    "dept": "AT",
    "num": "400",
    "desc": "Prerequisite: Instructor’s permission. Recommended prerequisite: ART 180.\nFashion illustration, technical apparel drawings, and line development by hand and computer methods.",
    "credits": "3"
  },
  {
    "course_name": "Apparel Production II",
    "dept": "AT",
    "num": "410",
    "desc": "Prerequisite: AT 300; instructor permission.\nIntermediate level apparel production focused on increasing knowledge of garment construction and fit; use of challenging fabrics.",
    "credits": "3"
  },
  {
    "course_name": "History of Apparel Fashion: Renaissance to Present",
    "dept": "AT",
    "num": "430",
    "desc": "Prerequisite: HIST elective course, and AT 330 or concurrent enrollment in AT 330.\nInterrelationship of costume and social, cultural, political, and economic environments from the Renaissance to present day.",
    "credits": "3"
  },
  {
    "course_name": "Professional Development",
    "dept": "AT",
    "num": "445",
    "desc": "Prerequisite: Junior standing and AT 375 or AT 400.\nPreparation for internship and professional development in apparel and textile industry.",
    "credits": "3"
  },
  {
    "course_name": "Showcase of Excellence Event Planning",
    "dept": "AT",
    "num": "450",
    "desc": "Prerequisite: Instructor permission required.\nPlanning, promotion, and production of apparel and textile runway event and static exhibit.",
    "credits": "3"
  },
  {
    "course_name": "Apparel and Textile Evaluation",
    "dept": "AT",
    "num": "460",
    "desc": "Prerequisite: AT 265 and AT 350.\nIdentification and evaluation of apparel product quality and serviceability from the standpoint of fiber, fabric, and construction performance, material and product standards and specifications, and cost.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Apparel and Textiles",
    "dept": "AT",
    "num": "498",
    "desc": "Prerequisite: Instructor permission.\nNew content, technology or theory related to apparel and textiles.",
    "credits": "1-6"
  },
  {
    "course_name": "Problems in Apparel and Textiles",
    "dept": "AT",
    "num": "499",
    "desc": "Prerequisite: Instructor’s permission.\nIndependent study.",
    "credits": "1-18"
  },
  {
    "course_name": "Apparel and Textile Internship",
    "dept": "AT",
    "num": "550",
    "desc": "Prerequisite: AT 445; AT 655 or 575; junior standing; and instructor’s permission.\nPre-planned and supervised off-campus work experience in the apparel industry.",
    "credits": "4"
  },
  {
    "course_name": "Principles of Forecasting",
    "dept": "AT",
    "num": "575",
    "desc": "Prerequisite: AT 340 and AT 430; and AT 375 or AT 400.\nIntroduction of the processes and methods used by the textile and apparel industry to conduct short-term and long-term forecasts. Application of fashion theory and principles, sources of information, knowledge, techniques and skills for planning and implementing fashion projection.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Buying",
    "dept": "AT",
    "num": "576",
    "desc": "Prerequisite: AT 325, CIS 102, and ACCTG 231.\nIntroduction to the processes and methods used by apparel buyers to purchase merchandise assortments. Application of fashion theory and principles, sources of information, knowledge, techniques and skills for assortment planning, buying, vendor negotiations, and profit planning. Emphasis on merchandising mathematics.",
    "credits": "3"
  },
  {
    "course_name": "Global Apparel and Textile Supply Chain Management",
    "dept": "AT",
    "num": "600",
    "desc": "Prerequisite: AT 245 and ECON 110.\nAnalysis of global fiber, textile, and apparel production and distribution; structure of industry and distribution channels; impact of culture, economics, and government regulations on production and distribution.",
    "credits": "3"
  },
  {
    "course_name": "Computer-Aided Design of Apparel",
    "dept": "AT",
    "num": "610",
    "desc": "Prerequisite: AT 400.\nOverview of computer-aided design as it relates to the apparel industry; development and presentation of apparel and textile design using visual graphic software.",
    "credits": "3"
  },
  {
    "course_name": "Apparel and Textile Business Strategy",
    "dept": "AT",
    "num": "625",
    "desc": "Prerequisite: AT 576, and senior or graduate standing.\nApplication of marketing principles to the apparel and textile industry. Focus on development of marketing, promotional, and merchandising plans.",
    "credits": "3"
  },
  {
    "course_name": "Private Label Apparel Product Development",
    "dept": "AT",
    "num": "645",
    "desc": "Prerequisite: AT 460. Corequisite: AT 575 or AT 610.\nCapstone course using a team approach to synthesize and perform activities used by apparel retailers to create a line of private label merchandise for a targeted consumer market.",
    "credits": "3"
  },
  {
    "course_name": "Apparel and Textiles Study Tour",
    "dept": "AT",
    "num": "650",
    "desc": "Prerequisite: Instructor’s permission.\nSupervised off-campus tour of facilities or equivalent experience where textile products are designed, manufactured, tested, marketed, exhibited, and/or conserved.",
    "credits": "1-3"
  },
  {
    "course_name": "Apparel Pattern Development I",
    "dept": "AT",
    "num": "655",
    "desc": "Prerequisite: AT 400 and AT 410.\nApparel design through flat pattern methods.",
    "credits": "3"
  },
  {
    "course_name": "Apparel Pre-Production Processes",
    "dept": "AT",
    "num": "670",
    "desc": "Prerequisite: AT 655.\nComputer application of pattern drafting, pattern grading, and marker layout for apparel pre-production processes. Computer applications for design development.",
    "credits": "3"
  },
  {
    "course_name": "Apparel Pattern Development II",
    "dept": "AT",
    "num": "695",
    "desc": "Prerequisite: AT 655.\nApparel design by draping; line development for a variety of markets; senior project.",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Sustainability in Apparel and Textiles",
    "dept": "AT",
    "num": "700",
    "desc": "\nIntroduction to the theory, principles, and practices of sustainability. Examination of the challenges to environmental, social, and economic sustainability on both a global and apparel and textile industry scale. Exploration of innovative practices and social change strategies for furtherance of sustainability.",
    "credits": "3"
  },
  {
    "course_name": "Professional Advancement in Merchandising",
    "dept": "AT",
    "num": "720",
    "desc": "\nAnalysis of leadership in a merchandising form and how it affects organizational culture and change. Various leadership styles will be examined and a personal leadership philosophy will be developed.",
    "credits": "3"
  },
  {
    "course_name": "Theory and Practice of Apparel/Textile Marketing and Distribution",
    "dept": "AT",
    "num": "725",
    "desc": "\nTheoretical and applied analysis of apparel/textile marketing and distribution strategies, with an emphasis on the effectiveness of a market-oriented approach for decision-making; assessment of environmental forces affecting strategic decisions by firms in the apparel/textile distribution channel; synthesis of past and present trends in order to forecast probable future patterns.",
    "credits": "3"
  },
  {
    "course_name": "Promotional Strategies in Merchandising",
    "dept": "AT",
    "num": "735",
    "desc": "\nExamination of promotional strategies and techniques used by merchandising firms, emphasizing cultural and global awareness, social responsibility, and ethical decision making.",
    "credits": "3"
  },
  {
    "course_name": "Textile Surface Manipulations",
    "dept": "AT",
    "num": "780",
    "desc": "\nApplication and analysis of textile surface manipulations to include color and image addition and removal through wet processes and stitched surface manipulations.",
    "credits": "3"
  },
  {
    "course_name": "Varsity Baseball",
    "dept": "ATHM",
    "num": "101",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Varsity Basketball",
    "dept": "ATHM",
    "num": "102",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Varsity Track Instructor",
    "dept": "ATHM",
    "num": "103",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Varsity Football",
    "dept": "ATHM",
    "num": "104",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Varsity Golf",
    "dept": "ATHM",
    "num": "105",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Basketball",
    "dept": "ATHW",
    "num": "150",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Track",
    "dept": "ATHW",
    "num": "152",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Tennis",
    "dept": "ATHW",
    "num": "154",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Volleyball",
    "dept": "ATHW",
    "num": "155",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Rowing",
    "dept": "ATHW",
    "num": "156",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Golf",
    "dept": "ATHW",
    "num": "157",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Biological and Agricultural Engineering and Technology",
    "dept": "ATM",
    "num": "101",
    "desc": "Prerequisite: Open to ATM majors only.\nIntroduction to discipline, department, university, and profession.  Exploration of career options.  Gain skills through application-oriented problem solving.",
    "credits": "1"
  },
  {
    "course_name": "Engineered Systems and Technology in Agriculture",
    "dept": "ATM",
    "num": "160",
    "desc": "Prerequisite: Not open to seniors.\nAn introductory course designed for non-engineering majors. This course introduces engineering principles and problem solving associated with energy resources and power systems for agriculture, machinery systems, natural resources and environmental management, and food and fiber processing and storage.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Injury Prevention",
    "dept": "ATM",
    "num": "240",
    "desc": "\nThis is an overview course that will cover a variety of safety and health topics focusing on injury prevention in the home, motor vehicle, public, and work environments. The enduring understanding that forms the basis for every discussion and activity in this course is all of us make decisions every day that impact our safety as well as the safety of those around us.",
    "credits": "3"
  },
  {
    "course_name": "Chemical Application Systems",
    "dept": "ATM",
    "num": "250",
    "desc": "\nSystems, components, operation practices, and safety procedures used in the chemical application industry.  Liquid and granular application systems and respective components will be studied along with procedures for equipment sizing and maintenance, minimizing drift, systems calibration, and safe handling, transporting, storage, disposal and spill clean-up of agrichemicals.",
    "credits": "2"
  },
  {
    "course_name": "Chemical Application Systems Laboratory",
    "dept": "ATM",
    "num": "251",
    "desc": "Prerequisite: Must be taken concurrent with ATM 250.\nLaboratory and hands-on activities on pumps, valves, nozzles, drift measurement, and application technology used in the home and garden, turf, private and commercial agricultural, aerial, and research industries.",
    "credits": "1"
  },
  {
    "course_name": "Occupational Safety",
    "dept": "ATM",
    "num": "340",
    "desc": "Prerequisite: ATM 240.\nThis is a survey course that identifies safety and health risks in industrial work environments. The enduring understanding that forms the basis for every discussion and activity in this course is as a manager or supervisor; you are responsible for the safety of all employees under you.",
    "credits": "3"
  },
  {
    "course_name": "Biorenewable Systems",
    "dept": "ATM",
    "num": "370",
    "desc": "Prerequisite: ECON 110, MATH 100, CHEM 210.\nConverting biorenewable resources into bioenergy and bio-based products. Biorenewable concepts as they relate to drivers of change, feedstock production, processes, products, co-products, economics, transportation/logistics, and marketing.",
    "credits": "3"
  },
  {
    "course_name": "Sensors and Controls for Agricultural and Biological Systems",
    "dept": "ATM",
    "num": "450",
    "desc": "Prerequisite: PHYS 113 or PHYS 115, ATM 160 or MATH 100.\nApplications of instrumentation. Sensors used in agricultural machines and processes for measurement of voltage, force, torque, pressure, displacement, velocity, acceleration, flow, temperature, humidity, etc. Analog and digital signal conditioning and processing. Feedback controls concept. Computer interface.",
    "credits": "3"
  },
  {
    "course_name": "Engines and Power Transfer",
    "dept": "ATM",
    "num": "455",
    "desc": "Prerequisite: BAE 350.\nPrinciples, operation, and analysis of engine thermodynamics, fuel and combustion, engine components, engine cycles, engine power transfer and efficiencies, and exhaust gas emissions. Mechanism and selection of bearings, belt drives, chain drives, gear drives, and shaft drives. Operation and performance analysis of hydraulic power transfer components and systems, fluid mechanics, and hydraulic motors.",
    "credits": "3"
  },
  {
    "course_name": "Internship in Agricultural Technology Management",
    "dept": "ATM",
    "num": "460",
    "desc": "Prerequisite: Junior standing.\nIntern programs in agricultural technology management.",
    "credits": "1-3"
  },
  {
    "course_name": "Agricultural Building Systems",
    "dept": "ATM",
    "num": "511",
    "desc": "Prerequisite: ATM 160 or PHYS 113 or 115.\nEnvironmental control systems for agricultural buildings; structural members and systems for agricultural buildings; farmstead planning concepts.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Agricultural Technology Management",
    "dept": "ATM",
    "num": "515",
    "desc": "Prerequisite: Approval of instructor.\nProblems in the application of technical principles to agricultural technology management.",
    "credits": "1-18"
  },
  {
    "course_name": "Processing and Storage of Grains",
    "dept": "ATM",
    "num": "545",
    "desc": "Prerequisite: ATM 160 or PHYS 113 or 115, and senior standing.\nPrinciples of grain and forage conditioning and storage.  Structures and equipment for quality preservation.",
    "credits": "3"
  },
  {
    "course_name": "Precision Agriculture Technologies",
    "dept": "ATM",
    "num": "550",
    "desc": "Prerequisite: MATH 150 or equivalent, PHYS 113 or PHYS 115, and STAT 325 or 340 or 350.\nApplication of precision technologies for gathering information to assist decision making for production systems. Topics will include global positioning systems, vehicle guidance systems, crop yield monitors, variable rate control systems for applicators, and the communication among these devices.",
    "credits": "3"
  },
  {
    "course_name": "Hydrology and Soil Erosion Management",
    "dept": "ATM",
    "num": "558",
    "desc": "Prerequisite: AGRON 305.\nWatershed hydrology, soil erosion, erosion control, water management, and land surveying and mapping. Includes rainfall-runoff relationships; determination of watershed characteristics; terraces, waterways, vegetative filters, and residue management; ponds, wetlands, non-point source pollution control, and water conservation; profile and topographic surveying.",
    "credits": "3"
  },
  {
    "course_name": "Water Management and Irrigation Systems",
    "dept": "ATM",
    "num": "653",
    "desc": "Prerequisite: ATM 160 or PHYS 113, AGRON 305, and junior standing or higher.\nManagement of water in crop production systems, crop water use, and irrigation scheduling. Fundamentals of water flow in pipe networks, pumping plants, and irrigation systems.",
    "credits": "2"
  },
  {
    "course_name": "Water Management and Irrigation Systems Lab",
    "dept": "ATM",
    "num": "654",
    "desc": "Prerequisite: Must be taken concurrent with ATM 653, and junior standing or higher.\nLaboratory and hands-on activities on soil water balance characteristics, crop water use, water flow in pipe networks, pump hydraulics, sprinkler nozzles, drip irrigation systems, water filtration systems, and chemigation systems.",
    "credits": "1"
  },
  {
    "course_name": "Watershed Assessment and Management",
    "dept": "ATM",
    "num": "661",
    "desc": "Prerequisite: CHM 110 or 210 and BIOL 198.\nOverview of water legislation and policies (e.g. Clean Water Act, NPDES, TMDL). Principles of watershed pollutant sources, fate, and transport. Impacts of watershed protection and restoration strategies on water and environmental quality.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Agricultural Technology",
    "dept": "ATM",
    "num": "702",
    "desc": "Prerequisite: ATM 659.\nThe selection, operational theory, repair, maintenance, adjustment, and application of equipment and materials for agricultural systems.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Aircraft Materials and Tooling Standards",
    "dept": "AVM",
    "num": "101",
    "desc": "\nSkills and techniques essential to understanding aircraft material properties and fabrication techniques. Emphasizes knowledge and practical experiences involving: shop safety, organization and human factors associated with shop practices, basic aircraft structural materials and hardware familiarization, fluid lines and fittings, hand tool selection and use, and aviation-specific dimensional inspection tools and techniques, aircraft hardware identification and applications, cleaning and corrosion control, aircraft metal selection an applications, welding techniques and procedures and aircraft material inspection fundamentals.",
    "credits": "3"
  },
  {
    "course_name": "Aviation Regulations, Compliance and Operations",
    "dept": "AVM",
    "num": "102",
    "desc": "\nA review of the role and organizational structure of the Federal Aviation Administration (FAA) as it relates to the certification and continued airworthiness of aircraft and its operation in general, business, and commercial aviation environments. Emphasis on the privileges and limitations of certificated personnel who maintain aircraft systems in the context of the FAA regulations. Includes practical applications of aircraft weight and balance, effective completion of maintenance record entries, accurate use of graphs and charts to determine critical performance values, and the servicing, staring, ground operations, and security of aircraft. Students demonstrate the ability to read, comprehend, and apply information contained in FAA and manufacturers’ aircraft maintenance specifications, data sheets, manuals, publications, and related Federal Aviation Regulations, Airworthiness Directives, and Advisory material. Includes laboratory activities involving student flight of aircraft.",
    "credits": "2"
  },
  {
    "course_name": "Basic Aircraft Electricity",
    "dept": "AVM",
    "num": "111",
    "desc": "\nA basic concept of DC/AC circuits, with basic laws relating to the following: measuring voltage, current, resistance, continuity and leakage; relationship of voltage, current and resistance in electrical circuits; reading and interpretation of electrical circuit diagrams; electrical devices and inspection and servicing of batteries. Introduction to digital numbering systems and digital logic functions.",
    "credits": "4"
  },
  {
    "course_name": "Aircraft Welding",
    "dept": "AVM",
    "num": "112",
    "desc": "\nTheory and skill development in aircraft welding processes. Exercises in gas welding processes as applied to ferrous and nonferrous materials. Oxygen/acetylene, inert gas, and resistance welding processes are to be studied.",
    "credits": "2"
  },
  {
    "course_name": "Aircraft Drawings",
    "dept": "AVM",
    "num": "121",
    "desc": "\nThe course is designed to teach the student how to recognize and identify each kind of line as it appears in aircraft drawings and to interpret the meaning of the lines as they relate to surfaces and details in drawings.",
    "credits": "1"
  },
  {
    "course_name": "Aircraft Standards",
    "dept": "AVM",
    "num": "131",
    "desc": "\nA survey of the organization of the Federal Aviation Administration. Emphasis will be placed on regulations, standards, specifications, procedures and the practice of using charts, graphs and drawings. Also included are the introduction to air transport maintenance procedures, weight and balance procedures, aircraft ground operations and the introduction to flight training to include several flights.",
    "credits": "4"
  },
  {
    "course_name": "Aircraft Fluid Power",
    "dept": "AVM",
    "num": "132",
    "desc": "\nA study of basic fluid mechanics as it applies to practical applications in aircraft systems. Compressible and incompressible fluid systems will be studied.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Science",
    "dept": "AVM",
    "num": "141",
    "desc": "\nThis is a study of applied mathematics and basic physics. Section one: mathematics will provide the learner with the tools needed to perform the calculations normally confronted by the aviation maintenance technician. Section two: the study of basic science will enable the student to better understand the operation of aircraft and the many complex systems needed to sustain safe flight.",
    "credits": "3"
  },
  {
    "course_name": "Airframe Systems",
    "dept": "AVM",
    "num": "142",
    "desc": "\nA study of the airframe systems and components to include: pressurization, heating and cooling, and structural device.",
    "credits": "4"
  },
  {
    "course_name": "Aviation Maintenance Fundamentals",
    "dept": "AVM",
    "num": "151",
    "desc": "\nThis course is designed to permit the student to learn and practice those skills and techniques essential to the career development of the aviation maintenance technician. The subjects included are: shop safety, aircraft general familiarization, fluid lines and fittings, hand tools and measuring devices, aircraft hardware, cleaning and corrosion control, aircraft metals, inspection fundamentals, ground operation and servicing, and support equipment.",
    "credits": "3"
  },
  {
    "course_name": "Airframe Structures and Repair",
    "dept": "AVM",
    "num": "152",
    "desc": "\nA study of materials commonly used in airframe structures and the associated study of making structural repairs according to recommended procedures. Skills in sheet metal are stressed.",
    "credits": "5"
  },
  {
    "course_name": "Airframe Electrical Systems",
    "dept": "AVM",
    "num": "162",
    "desc": "Prerequisite: AVM 111 or ECET 100.\nAn advanced study of DC/AC circuits law relating to circuit analysis and a detailed study of measuring instruments. Advanced study of relays, switches, alternators, and other devices encountered in circuit analysis, troubleshooting, and repair. Theory of operation and fault isolation on solid-state devices in aircraft circuitry. Inspection of aircraft electrical systems, including wire inspections and the types of repairs allowed, using appropriate technical manuals.",
    "credits": "4"
  },
  {
    "course_name": "Aircraft Metallic Primary Structures",
    "dept": "AVM",
    "num": "201",
    "desc": "Prerequisite: AVM 101 or MET 121.\nA study of aircraft metal primary structures and materials commonly used in the design and construction of airframes including fuselages, wings, and control surfaces. Students gain theoretical knowledge and practical experience associated with the structural properties of materials used in the manufacturing process as well as the methods used to fabricate and repair those structures. Students practice structural metal repairs according to FAA approved data and manufacturer’s recommended procedures. Skills in aluminum sheet metal fabrication and repairs are stressed.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Environmental and Fire Protection Systems",
    "dept": "AVM",
    "num": "203",
    "desc": "\nAn in-depth study in small and large air vehicle environmental and fire detection and extinguishing systems. Emphasis on cabin pressurization and temperature climate control, supplemental oxygen, airframe and propulsion fire detection and extinguishing systems, crew visibility enhancement, and air toxicity detection. Students gain extensive practical experiences related to system design, operation, inspection, maintenance methodology, and fault analysis for both airframe and powerplant systems using manufacturer’s technical instructions.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Landing Gear and Fluid Power Systems",
    "dept": "AVM",
    "num": "205",
    "desc": "\nA study of the design and application of compressible and incompressible fluid power systems used in both simple and complex aircraft flight control, auxiliary, emergency, and landing gear systems. Emphasis on landing gear and deceleration systems to include components, structures, operation, and fault analysis of shock struts, position and warning, single and multiple disk brakes, anti-skid, wheel assemblies, retraction and extension systems and methods of emergency landing gear extension. Topics include landing gear door operation and sequencing. Students practice inspection, servicing, repair and troubleshooting of key fluid power and landing gear systems necessary to ensure continued airworthiness of these systems.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Electrical Systems",
    "dept": "AVM",
    "num": "207",
    "desc": "Prerequisite: ECET 100 or AVM 111.\nA review and advanced study of DC/AC circuits, and laws relating to circuit analysis and a detailed study of measuring instruments applied to aircraft. Study of relays, switches, alternators, and other devices encountered in circuit analysis, troubleshooting, and repair. Theory of operation and fault isolation on solid-state devices in aircraft circuitry. Inspection of aircraft electrical systems, including wire inspections and the types of repairs allowed using appropriate technical manuals. A study of battery, magneto high and low tension ignition systems, including turbine igniters. Also a study of powerplant starting ad charging systems and related components. Emphasis on effective fault diagnostics, repair, and timing of aircraft ignition systems.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Aircraft Propulsion Theory, Design and Systems",
    "dept": "AVM",
    "num": "214",
    "desc": "\nA broad introductory study in the theory of operation of heat engines utilizing principles of the Otto and Brayton cycles found in aircraft reciprocating and gas turbine powerplants. Students gain a solid understanding of the basic principles of the construction, design, lubrication, cooling, and exhaust systems, including maintenance practices of reciprocating and gas turbine powerplants installed in aircraft. Thrust reverser operation of gas turbine engines is also included. The course has a practical component that includes the inspection, fault analysis, servicing and repair of key engines systems covered in the course.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Propulsion Drive Systems",
    "dept": "AVM",
    "num": "216",
    "desc": "\nA detailed study of aircraft propulsion drive systems that convert engine power to thrust necessary for sustained flight. Drive systems include propellers, unducted fans (open rotor), and rotor-blades found on small, medium, and large fixed, and rotary-wing aircraft. Emphasis on fixed and controllable-pitch propellers applications as well as rotor-blades, and rotor-hubs assemblies found on helicopters. Topics include theory of operation, dynamic and static balancing, vibration analysis, design characteristics, materials, and maintenance practices. Students practice inspection, servicing, balance, maintenance and repair of propeller and rotor systems.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Finish and Fabrication",
    "dept": "AVM",
    "num": "231",
    "desc": "\nThis course is designed to acquaint the student with the wood and fabric coverings and procedures used on aircraft, and methods used in preparation for and application of paint finishes to aircraft surfaces.",
    "credits": "3"
  },
  {
    "course_name": "Navigational Aids and Communication Systems",
    "dept": "AVM",
    "num": "241",
    "desc": "Prerequisite: AVM 111 or ECET 100.\nA survey study of the aids to navigation and communications used in light and intermediate class aircraft. Operation and installation of the various types of equipment will be stressed.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Inspection and Assembly",
    "dept": "AVM",
    "num": "261",
    "desc": "Prerequisite: AVM 121, 131.\nA study of assembly and manufacturing procedures and inspection of aircraft components. This course also covers in detail annual and 100-hour inspections.",
    "credits": "5"
  },
  {
    "course_name": "Problems in Aviation",
    "dept": "AVM",
    "num": "290",
    "desc": "Prerequisite: Consent of instructor.\nAdvanced study in a specific area chosen by the instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Advanced Reciprocating Powerplant Technology",
    "dept": "AVM",
    "num": "301",
    "desc": "Prerequisite: AVM 214.\nAdvanced study in the theory, operation, construction, design, and maintenance of reciprocating powerplants installed in aircraft. Topics include emerging trends in the design and application of reciprocating heat engines including aviation diesel engines. Emphasize the disassembly and inspection of modern reciprocating engines found in single and twin engine aircraft using visual, dimensional and non-destructive techniques. Maintenance tasks including engine removal, installation and troubleshooting to an airworthy standard.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Aircraft Composite Structures",
    "dept": "AVM",
    "num": "303",
    "desc": "\nIntroduces composite materials used in the design and production of legacy and modern aircraft. Topics include material characteristics, fabrication, and inspection; repair of non-metallic primary and secondary structures and materials using manufacturers’ instructions. Materials include fabric, wood, fiberglass, plastics, honeycomb, and others. Students practice the selection, installation, application of protective coatings, and removal of special fasteners used in these structures. Laboratory exercises emphasize the fabrication and inspection of modern composite structures.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Fuel Management and Metering Systems",
    "dept": "AVM",
    "num": "304",
    "desc": "Prerequisite: AVM 214.\nA comprehensive study of airframe and propulsion engine fuel systems associated with fuel storage, management, transfer and metering as applied to both reciprocating and turbine powered aircraft. Lecture topics include systems operation, maintenance methods, procedures and safety precautions associated with aircraft fueling and defueling for over-the-wing and pressure fueling systems. Fuel quantity, pressure and temperature indicating and warning systems, fuel dump, and detail reciprocating and turbine engine fuel metering systems including carburetor overhaul, electronic engine fuel controls (EEC and FADEC) are covered. Students practice the inspection, check, service, troubleshooting and repair of the various fuel systems found on board the aircraft to a level that assures continued airworthiness and safety.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Aircraft Avionics and Instrument Systems",
    "dept": "AVM",
    "num": "305",
    "desc": "Prerequisite: ECET 100 or AVM 111.\nIntroduces basic flight instrument systems and navigation/communication electronic aids installed on General Aviation aircraft that weigh less than 12,500 lbs. The course includes both lecture and practical applications of these systems to include operation, inspection, fault analysis and repair. The student will be exposed to mechanical and electronic airframe and powerplant indication equipment including flight instrument systems for heading, speed, altitude, temperature, pressure, RPM, and position indicating. Emphasis will be placed on NAV/COMM systems found in modern light aircraft and associated antenna applications and installation methods. Pitot/Static instruments and systems are also discussed. Students practice inspection, service, fault analysis, installation and repair of these systems.",
    "credits": "3"
  },
  {
    "course_name": "Rotary and Fixed Wing Aircraft Design and Assembly",
    "dept": "AVM",
    "num": "306",
    "desc": "Prerequisite: AVM 101 and MET 111.\nA detailed study of the purpose of fixed-wing and rotary-wing aircraft designs and aerodynamic characteristics, their construction methods and assembly procedures. The course provides an insight critical maintenance tasks performed that impact the safe operation of the aircraft as well as exposure to the manufacture and assembly of aircraft. Students practice the rigging, assembly, jacking, weighing, and balancing of aircraft and flight control surfaces according to manufacturer’s technical manuals; and making accurate record entries for tasks performed in accordance with FARs.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Propellers",
    "dept": "AVM",
    "num": "312",
    "desc": "\nA study of the use, maintenance, and inspection of propellers and their related control systems.",
    "credits": "2"
  },
  {
    "course_name": "Powerplant Fundamentals",
    "dept": "AVM",
    "num": "321",
    "desc": "Prerequisite: AVM 131.\nA study of the principles of operation, design features, and operating characteristics of reciprocating aircraft engines. Includes overhaul inspection procedures on current horizontal opposed and radial engines.",
    "credits": "4"
  },
  {
    "course_name": "Powerplant Operation and Troubleshooting",
    "dept": "AVM",
    "num": "322",
    "desc": "Prerequisite: AVM 214 or AVM 321.\nExperience in installation, operation, and removal of aircraft engines. Engine analysis and diagnosis of malfunctions, including methods of remedy, are performed on airworthy engines.",
    "credits": "3"
  },
  {
    "course_name": "Gas Turbine Powerplant",
    "dept": "AVM",
    "num": "332",
    "desc": "Prerequisite: AVM 321.\nAdvanced study of the fundamentals of gas turbine powerplants including operation, studies of supporting systems and inspection methods are fundamental to this course.",
    "credits": "5"
  },
  {
    "course_name": "Powerplant Induction and Fuel Systems",
    "dept": "AVM",
    "num": "342",
    "desc": "Corequisite: AVM 321.\nA study of aircraft induction and fuel metering systems including fuels, carburetors, fuel injection systems, superchargers, and other induction system components used to ensure a dependable and accurate fuel supply at any flight configuration and attitude.",
    "credits": "4"
  },
  {
    "course_name": "Powerplant Ignition and Electrical Systems",
    "dept": "AVM",
    "num": "351",
    "desc": "Prerequisite: AVM 111.\nA study of battery, magneto high and low tension ignition systems, including turbine igniters for today’s aircraft. Also a study of powerplant starting and charging systems and related components. Emphasis will be placed on troubleshooting, repair, and timing of aircraft ignition systems.",
    "credits": "3"
  },
  {
    "course_name": "Powerplant Overhaul",
    "dept": "AVM",
    "num": "352",
    "desc": "Prerequisite: AVM 321.\nPractical experience in overhauling reciprocating engines. Engines are assembled and operationally checked in lab.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Aircraft Avionics and Instrument Systems",
    "dept": "AVM",
    "num": "370",
    "desc": "Prerequisite: AVM 305.\nAdvanced study of flight instrument systems and navigation/communication electronic aids installed on large Corporate and Transport Category aircraft. The course includes both lecture and practical applications of these systems to include operation, inspection, fault analysis and repair. The course includes flight management systems, and GPWS, TAWS, laser gyro and advanced Comm/Nav applications.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Aviation",
    "dept": "AVM",
    "num": "390",
    "desc": "Prerequisite: Consent of instructor.\nProvides the student the opportunity for advanced study in a specific topic area or to apply aviation education to the improvement of skills previously learned.",
    "credits": "1-18"
  },
  {
    "course_name": "Aircraft Airworthiness, Conformity, and Quality Assurance",
    "dept": "AVM",
    "num": "401",
    "desc": "Prerequisite: Senior standing and instructor consent.\nA capstone course requiring students to tie all previous coursework associated with airframe and powerplant systems maintenance and operations together to perform an effective and safe inspection of the entire aircraft in compliance with manufacturer’s recommendations and FAR requirements. This course emphasizes practical experiences necessary to inspect the aircraft for continued airworthiness. Aircraft is weighed and conformity inspections are performed. All work and inspection status is recorded and documented using approved maintenance entries. Part 145 operational requirements are included in the course experience and work team scheduling and coordination is emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Gas Turbine Powerplant Technology",
    "dept": "AVM",
    "num": "402",
    "desc": "Prerequisite: AVM 214.\nAdvanced study in the theory, operation, construction, design, and maintenance of small and large gas turbine powerplants installed in corporate and transport category aircraft. Topics include emerging trends in the design and application of gas turbine engines as well as engine test cell operations. Practical experiences emphasize the disassembly and inspection of small turboprop/turboshaft engines commonly found on turbine twin-engine aircraft and helicopters. Maintenance tasks include engine removal, installation and troubleshooting to an airworthy standard. This course has a research and presentation requirement.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Aircraft Avionics and Instrument Systems",
    "dept": "AVM",
    "num": "403",
    "desc": "Prerequisite: AVM 305.\nAdvanced study of flight instrument systems and navigation/communication electronic aids installed on large Corporate and Transport Category aircraft. The course includes both lecture and practical applications of these systems to include operation, inspection, fault analysis and repair. The course includes flight management systems, and GPWS, TAWS, laser gyro and advanced Comm/Nav applications.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Aviation",
    "dept": "AVT",
    "num": "100",
    "desc": "\nThis course examines the history of aviation and a look at the future. Students discuss the attributes of an aviation professional, careers, career planning, and pilot certification. Students consider historical events and their relationship to current aviation aspects. The interdependency and synergy in the development of military aircraft, the space program, as well as the growth of commercial and general aviation is discussed. Students use the Internet for various research projects concerning the past, present, and future of aviation.",
    "credits": "3"
  },
  {
    "course_name": "Aeronautical Programs Flight Familiarization",
    "dept": "AVT",
    "num": "120",
    "desc": "Corequisite: PPIL 111.\nAn introduction to the fundamentals of flight in various types and categories of aircraft. A familiarization of piloting skills and knowledge, a demonstration of aircraft capabilities, and the National Airspace System.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Air Traffic Control",
    "dept": "AVT",
    "num": "240",
    "desc": "Prerequisite: PPIL 111.\nAn introductory air traffic control (ATC) course that focuses on Terminal, Enroute, and FSS ATC procedures. The course examines the role of an air traffic controller at the various operational positions throughout the ATC system. The course gives an overview of the current U.S. National Airspace System as it relates to ATC procedures. In addition, the course looks at the use of future technologies and how they enhance the ATC system. Off-campus trips contribute to experiential learning.",
    "credits": "3"
  },
  {
    "course_name": "Aviation Meteorology",
    "dept": "AVT",
    "num": "242",
    "desc": "\nBasic aviation-related meteorology concepts through the study of atmospheric elements and how they generally affect the weather: introduction to the subject, water in the atmosphere, variables which cause local weather changes, specific aviation-associated hazards, understanding meteorological reports and forecasts, meteorological techniques used in predicting weather patterns.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Electrical, Navigational, and Communication Systems",
    "dept": "AVT",
    "num": "243",
    "desc": "Prerequisite: AVM 111.\nProvides students the basic knowledge of aircraft electrical systems, including navigation, communications, instruments, and power systems.",
    "credits": "3"
  },
  {
    "course_name": "Safety and Security of Airport Ground Operations",
    "dept": "AVT",
    "num": "250",
    "desc": "\nThis course discusses general aviation airport ground operations, particularly from the mechanic, pilot, and ramp worker perspective. Focus will be on increasing awareness of airport operations. Attention will be given to improving airport safety by creating an enhanced awareness of rules, policies, procedures, and potential hazards that affect all individuals working in and around the airport ground operations environment. Some topics included are: aircraft marshalling procedures, airfield security issues, ground vehicle operations, and security and accident/incident response reporting.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Avionics",
    "dept": "AVT",
    "num": "315",
    "desc": "Corequisite: AVM 241 or AVM 242.\nThis course covers the latest developments and trends in navigation and communication systems. Topics include Future Aviation Navigation Systems (FANS), fiber optics, enhanced vision, ADS-B, the FAA’s NextGen, as well as other advancements in avionics.",
    "credits": "3"
  },
  {
    "course_name": "AET and FCC Training",
    "dept": "AVT",
    "num": "316",
    "desc": "\nThis course is a self-paced lab that allows students to study for their Aviation Electronics Technician certificate and their Federal Communication Commission license in Elements 1, 3 and 8.",
    "credits": "1"
  },
  {
    "course_name": "Composites I",
    "dept": "AVT",
    "num": "317",
    "desc": "\nIntroduction to composite materials used in a broad range of industries with an emphasis on aero structure. Topics include defining a composite, understanding the materials, safety aspects, and shop layouts that are used to produce composite parts. An overview of the construction methods, understanding how to inspect components for damage, and procedures to perform the actual repair used in industry today. Students develop an understanding of how to design/source industrial composite fasteners and install into the composite structure and the science of coatings for the protection of both the composite materials as well as metallic components adjacent to composites. The labs support the lectures with projects designed to give the student hands on application.",
    "credits": "3"
  },
  {
    "course_name": "Composites I Laboratory",
    "dept": "AVT",
    "num": "318",
    "desc": "Corequisite: AVT 317.\nAn optional laboratory course introducing the use of equipment and materials utilized in the advanced composites industry.",
    "credits": "2"
  },
  {
    "course_name": "Avionics Repair",
    "dept": "AVT",
    "num": "327",
    "desc": "\nAn in depth overview of aircraft wiring. Procedures in terminating, repairing, testing and troubleshooting of aircraft wiring, as well as aging wiring inspections.",
    "credits": "3"
  },
  {
    "course_name": "Avionics Troubleshooting",
    "dept": "AVT",
    "num": "330",
    "desc": "Prerequisite: AVT 327.\nAn in-depth troubleshooting project, requiring critical thinking to analyze the problem and provide the correct repairs.",
    "credits": "4"
  },
  {
    "course_name": "Human Factors in Aviation",
    "dept": "AVT",
    "num": "340",
    "desc": "Prerequisite: PPIL 111 or AVT 100, or junior standing.\nExplores the physical environment and physiology limitations imposed on the aviation professional. Health, fatigue, human behavior and errors, communication, team building, leadership, situation awareness, crew resource management, judgment, and aeronautical decision making are studied to achieve safe and efficient operation.",
    "credits": "3"
  },
  {
    "course_name": "Airport Law",
    "dept": "AVT",
    "num": "360",
    "desc": "Prerequisite: Junior standing.\nA study of how the U.S. regulatory and legal systems work in relation to airport management. This course emphasizes contract law related to the Federal Aviation Administration Airport covenants and restrictions, Federal Aviation Regulation compliance and airport operator liability.",
    "credits": "3"
  },
  {
    "course_name": "Airport Environmental Studies",
    "dept": "AVT",
    "num": "361",
    "desc": "Prerequisite: MATH 100, “B” or better in ENGL 100 and ENGL 200.\nIntroduction to responsibilities, liabilities and public relations when dealing with environmental issues in day-to-day airport operations.  Includes strategies for addressing airport and aircraft noise, wildlife hazard mitigation, compatible land use, wetlands, historical properties and impacts of construction.  Federal regulations and enforcement are studied with emphasis on the Clean Water Act, Clean Air Act, Resource Conservation and Recovery Act, Pollution Prevention ACT, and National Historic Preservation Act as they apply to airports.",
    "credits": "3"
  },
  {
    "course_name": "Airport Operations",
    "dept": "AVT",
    "num": "380",
    "desc": "Prerequisite: “B” or better in ENGL 100 and ENGL 200, or Airport Management Program Lead Approval for transfer students.\nA study of the daily operations of an airfield in compliance with regulatory agencies, understanding the role of liaison to airport staff regarding operations, development of department budgets, knowledge of effective supervisory practices and principles, ability to plan and carry out airport operations and development programs under airport management matrix.",
    "credits": "3"
  },
  {
    "course_name": "Aerodynamics",
    "dept": "AVT",
    "num": "386",
    "desc": "Prerequisite: MATH 100; and PPIL 111 or AVM 141.\nThis course covers incompressible flow theory and wing theory as well as calculations of stall speed, drag, and basic performance criteria. This course also examines configuration changes, high and low speed conditions, and special flight operations. Stability and control, weight and balance, and operational data are also examined. Aerodynamic performance of aircraft powered by reciprocating, turboprop, and jet turbine engines are considered. The student will be introduced to aircraft design and high-speed aerodynamics.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Aviation",
    "dept": "AVT",
    "num": "389",
    "desc": "\nProvides the student an opportunity to apply their aviation education to the improvement of skills previously learned as designated by the instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Composites II",
    "dept": "AVT",
    "num": "400",
    "desc": "Prerequisite: AVM 303 or AVT 317.\nContinued study of the mechanical properties of several composite materials along with strengths and limitations. Topics include gelcoats for tooling and part production, layup of semi complex composite parts using wet layup and vacuum bagging techniques, simple mold development, construction, and repair. Additionally, students are introduced to compression composite molding compounds and tooling required for production, and composite facility layout and outfitting. The lab will support the lectures with projects designed to give the student the hands on application.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Non-destructive Testing",
    "dept": "AVT",
    "num": "405",
    "desc": "Prerequisite: MET 121, or MET 231 and MET 245.\nIntroduction to non-destructive testing (NDT) and inspection methods commonly used to detect material anomalies in diverse industries. NDT methods used in aviation/mechanical structures and components is emphasized. Students gain practice using Visual, x-ray (radiographic, magnetic particle, ultra-sound, eddy current and dye penetrant), NDT methods and techniques on test samples. Serviceability of the components is determined using approved manufacturers service limits.",
    "credits": "2"
  },
  {
    "course_name": "Aviation  Maintenance Management",
    "dept": "AVT",
    "num": "410",
    "desc": "\nProvides students with an understanding of general aviation and commercial aviation maintenance programs. Includes regulations, maintenance levels, technical publications, quality assurance, inspections, human factors, and unions. It also provides an understanding of the difficulties in managing a line operation. Case studies of maintenance scenarios are used.",
    "credits": "3"
  },
  {
    "course_name": "Composites III",
    "dept": "AVT",
    "num": "417",
    "desc": "Corequisite: AVT 400.\nContinued study of the highly complex composite parts and associated molding technologies used to produce these parts. Topics include the construction of resin infusion parts and mold construction, resusable vacuum bagging materials, application of preimpregnated materials and tooling designed to withstand oven cure cycles, discussion of advanced materials and techniques new to the industry. The lab will support the lectures with projects designed to give the student the hands on application in a relative environment.",
    "credits": "3"
  },
  {
    "course_name": "Aviation Accident Investigation",
    "dept": "AVT",
    "num": "420",
    "desc": "Prerequisite: AVT 340 and junior standing.\nThis course is designed to provide a general understanding of the methods and procedures used in aviation accident investigation. Students in this course will learn methods used to gather and analyze facts of accidents as well as determine probable cause and contributing factors. Procedures and techniques used to determine accident causes will also be analyzed. Historical accident reports from National Transportation Safety Board (NTSB) and other organizations will be examined.",
    "credits": "3"
  },
  {
    "course_name": "Avionics Maintenance",
    "dept": "AVT",
    "num": "429",
    "desc": "Prerequisite: AVM 305.\nProvides the basic knowledge to repair and install pitot-static systems. Practical experience in troubleshooting and using maintenance test equipment.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Avionics Installation",
    "dept": "AVT",
    "num": "430",
    "desc": "Prerequisite: AVT 327.\nProvides practical knowledge of avionics suite installation, to include Garmin. Students will gain additional experience in operational checks, troubleshooting and software loading on the Garmin G1000/900X. This course is an individual semester long project.",
    "credits": "3"
  },
  {
    "course_name": "Air Transportation",
    "dept": "AVT",
    "num": "435",
    "desc": "Prerequisite: Junior standing.\nThis interactive course examines the development of the United States air transportation system, current issues, and the competitive strategies of past and present airline executives; examines the many attributes of starting and operating a successful airline in a competitive market; and explores the role of airport operations and the commercial and corporate aircraft that challenge the air transportation system.",
    "credits": "3"
  },
  {
    "course_name": "Air Carrier Operations",
    "dept": "AVT",
    "num": "440",
    "desc": "Prerequisite: PPIL 111 or AVT 100, and junior standing.\nA study of Federal Aviation Regulations that influence air carrier and commercial operators. Students will gain an appreciation of the variety of regulatory issues involved in air carrier operations such as certification, training, and operational safety and security requirements. Students will also gather the background information necessary to correlate and apply relevant regulations to daily aviation operations. The course focuses on FAR Part 61, 91, 119, 121, and 135.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Air Traffic Control",
    "dept": "AVT",
    "num": "442",
    "desc": "Prerequisite: AVT 240, PPIL 112.\nAn in-depth study of tower, TRACON, and enroute procedures. Also examines the FAA’s future air navigation system concept.",
    "credits": "3"
  },
  {
    "course_name": "Aviation Law",
    "dept": "AVT",
    "num": "445",
    "desc": "Prerequisite: Junior standing.\nA study of how the U.S. regulatory and legal systems work in relation to aviation activities. It is designed to help those in the aviation industry understand their rights, liabilities, and responsibilities and avoid common legal pitfalls. Emphasis will also be placed on aircraft ownership, registration, and insurance.",
    "credits": "3"
  },
  {
    "course_name": "Corporate and Business Aviation Management",
    "dept": "AVT",
    "num": "446",
    "desc": "Prerequisite: Junior standing.\nA study of the history of corporate and business aviation, the regulation of the industry, and the operation and management of corporate and business flight departments. Students will receive an overview of the social, economic, and political effects of business aviation. Aircraft selection and utilization, maintenance responsibilities, fiscal considerations, fractional ownership, and passenger and crew safety and security measures will also be studied.",
    "credits": "3"
  },
  {
    "course_name": "Aviation Legislation",
    "dept": "AVT",
    "num": "448",
    "desc": "Prerequisite: Junior standing.\nStudents are required to take part in the University Aviation Association’s Annual Seminar on Establishing Aviation Policy during the first full week of January in Washington, D.C.  Students prepare for the seminar with required reading assignments.",
    "credits": "3"
  },
  {
    "course_name": "Aviation Safety Management",
    "dept": "AVT",
    "num": "450",
    "desc": "Prerequisite: Junior standing.\nA course designed to assist the student to develop an attitude and philosophy for accident prevention. The course includes ideal and practical, personal and organizational safety procedures and goals; safety philosophies; aircraft accident reports; human factors; principles of accident investigation; accident prevention program and accident statistics; current events; NTSB special studies. The safety program is analyzed from the theoretical and philosophic points of view. A safety program is developed with an examination of safety concepts, the human elements of accidents, managing a safety office in an organization, and current events.",
    "credits": "3"
  },
  {
    "course_name": "System Safety",
    "dept": "AVT",
    "num": "451",
    "desc": "Prerequisite: AVT 450.\nThis course is designed to provide an understanding of the system safety discipline. Students will learn how the system safety process is used in accident prevention and examine its role in management. Students will also examine various aircraft systems for overall safety of operation.",
    "credits": "3"
  },
  {
    "course_name": "Current Trends and Issues in Aviation",
    "dept": "AVT",
    "num": "455",
    "desc": "Prerequisite: Senior standing.\nThis course explores current trends and issues in the aviation industry. Emphasis is placed on discussing current issues that are impacting the world aviation marketplace. Students will address these issues and trends from the standpoint of application to their career, relevance to the economic viability of the industry, and the impact such trends place on aircraft operators and manufacturers.",
    "credits": "3"
  },
  {
    "course_name": "Airport Management",
    "dept": "AVT",
    "num": "461",
    "desc": "Prerequisite: PPIL 111 and “B” or better in ENGL 100 or Airport Management Program Lead approval for transfer students.\nAn in depth study of both landside and airside airport business management, utilizing the American Association of Airport Executives’ Body of Knowledge modules. Includes a study of the role of the airport in community development.",
    "credits": "3"
  },
  {
    "course_name": "Airport Planning",
    "dept": "AVT",
    "num": "462",
    "desc": "Prerequisite: AVT 461.\nA study of airport planning and practices to understand FAR Regulation part 139 airport design standard as well as a study of both landside and airside planning issues utilizing the American Association of Airport Executive’s Body of Knowledge modules.",
    "credits": "4"
  },
  {
    "course_name": "Airport Certified Manager",
    "dept": "AVT",
    "num": "464",
    "desc": "Prerequisite: AVT 250, AVT 360, AVT 462.\nThe study and preparation for various forms of certification within the AAAE realm including the opportunity to study and take the Airport Certified Employee (ACE) exams and the Certified Member (CM) exam.",
    "credits": "1"
  },
  {
    "course_name": "Airport Global Networks",
    "dept": "AVT",
    "num": "480",
    "desc": "Prerequisite: AVT 380 and Junior Standing and “B” or better in ENGL 302 or Airport Management Program Lead Approval for transfer students.\nAn introduction to the economic, political, and civic challenges that impact the profitability of airports worldwide and the steps being taken by the airport industry and international governing bodies to address them.",
    "credits": "3"
  },
  {
    "course_name": "Aviation Ethics and Leadership",
    "dept": "AVT",
    "num": "482",
    "desc": "\nStudents acquire an understanding of core leadership values demanded by the aviation industry, understand leadership challenges facing the aviation industry, and identify personal leadership styles and their most effective implementation within industry.",
    "credits": "3"
  },
  {
    "course_name": "Helicopter Maintenance",
    "dept": "AVT",
    "num": "485",
    "desc": "Prerequisite: AVM 111, 121, 131, 141, 151 or consent of instructor.\nAn advanced study of the major components of rotary-winged aircraft to include airframe, rotor, transmission and engine components of turbine and reciprocating engine helicopters. Also includes a detailed study and validation of all Federal Aviation Administration required documentation related to maintenance, historical records, and inspection of components.",
    "credits": "3"
  },
  {
    "course_name": "Senior Capstone",
    "dept": "AVT",
    "num": "497",
    "desc": "Prerequisite: Senior standing and instructor consent.\nThis culminating experience is a sustained occasion when students will put into independent practice the intellectual, creative, and expressive skills/knowledge they have cultivated in their undergraduate curriculum. In this course students integrate discipline-specific knowledge in addition to communication and inquiry methods to solve problems and communicate mastery of their respective area of interest.",
    "credits": "3"
  },
  {
    "course_name": "Research Project",
    "dept": "AVT",
    "num": "498",
    "desc": "Prerequisite: Junior or senior standing.\nResearch, scholarly and creative activities in the aviation field. Working with faculty on a current research project.",
    "credits": "1-9"
  },
  {
    "course_name": "Airport Design",
    "dept": "AVT",
    "num": "560",
    "desc": "Prerequisite: AVT 360, AVT 361, and AVT 462.\nStudent teams with faculty and industry advisors prepare to enter their work in the Airport Cooperative Research Program’s (ACRP) national design competition for universities addressing issues relating to airports and the National Airspace System. The competition focuses on design solutions in the following broad areas: Airport Operation and Maintenance, Runway Safety/Runway Incursions/ Runway Excursions, Airport Environmental Interactions, and Airport Management and Planning.",
    "credits": "4"
  },
  {
    "course_name": "Engineering Assembly",
    "dept": "BAE",
    "num": "020",
    "desc": "\nPresentation of professional problems and practices by students, faculty, and professionals associated with the career of biological and agricultural engineering.",
    "credits": "0"
  },
  {
    "course_name": "Introduction to Biological and Agricultural Engineering and Technology",
    "dept": "BAE",
    "num": "101",
    "desc": "\nIntroduction to discipline, department, university, and profession. Exploration of career option. Gain skills through application-oriented problem solving.",
    "credits": "1"
  },
  {
    "course_name": "Biological Systems Engineering Project I",
    "dept": "BAE",
    "num": "131",
    "desc": "Prerequisite or concurrent enrollment: MATH 220.\nTeam-oriented design project, with an emphasis on applying computer tools to problem solving in biological systems engineering.",
    "credits": "1"
  },
  {
    "course_name": "Biological Systems Engineering Project II",
    "dept": "BAE",
    "num": "231",
    "desc": "Prerequisite: BAE 131.\nTeam-design project presented by biological and agricultural engineers from industry and student engineering design teams with an emphasis on problem definition, information search, idea generation, concept development, and written oral communication.",
    "credits": "1"
  },
  {
    "course_name": "Solid Modeling",
    "dept": "BAE",
    "num": "250",
    "desc": "Prerequisite or concurrent enrollment: ME 212.\nBasics of solid modeling with the PTC software Pro Engineer/Creo. Modeling parts, creating assemblies, and creating drawing based on modeled parts and assemblies.",
    "credits": "1"
  },
  {
    "course_name": "Professional Practice for Biological Systems Engineering Design",
    "dept": "BAE",
    "num": "331",
    "desc": "Prerequisite: BAE 231.\nA preparatory course for BSE Senior Design class. Topics will include professionalism, project management, intellectual property, organizational behavior and ethics. Students will explore potential design project ideas, build design teams, and chose a project to complete for senior design in the following semester.",
    "credits": "1"
  },
  {
    "course_name": "Properties of Biological Materials",
    "dept": "BAE",
    "num": "345",
    "desc": "Prerequisite: CHM 210 or CHM 220.\nCharacterization and application of material properties (physical, chemical, hygroscopic, rheological, and thermal) that affect the engineering design and analysis of biological processes and systems.",
    "credits": "2"
  },
  {
    "course_name": "Properties of Biological Materials Laboratory",
    "dept": "BAE",
    "num": "346",
    "desc": "Prerequisite: Must be concurrently enrolled in BAE 345.\nLaboratory evaluation of biological material properties (physical, chemical, rheological, and thermal) that affect biological processes and systems, data analysis and interpretation",
    "credits": "1"
  },
  {
    "course_name": "Off Road Machinery Systems",
    "dept": "BAE",
    "num": "350",
    "desc": "Prerequisite: CHM 210.\nBasic power and energy concepts. Machinery systems for tillage, planting, and harvesting crops. Impact of these systems on the environment and natural resources.",
    "credits": "2"
  },
  {
    "course_name": "Machinery Systems Lab",
    "dept": "BAE",
    "num": "351",
    "desc": "Prerequisite: Must be taken concurrent with BAE 350.\nBasic power and energy concepts. Machinery systems for tillage, planting, and harvesting crops. Impact of these systems on the environment and natural resources.",
    "credits": "1"
  },
  {
    "course_name": "Biological Engineering Fundamentals",
    "dept": "BAE",
    "num": "445",
    "desc": "Prerequisite: BIOL 198 and BAE 345 or CE 533 or CHE 354 and CHE 355.\nIntegration of biochemistry, microbiology, and biology principles into engineering with topics such as chemistry of biomolecules, material and energy balances, enzyme kinetics, biochemical reactions, unit operations, reactor engineering, and application of biological engineering principles in industrial processes.",
    "credits": "3"
  },
  {
    "course_name": "Off Road Machine Power Components",
    "dept": "BAE",
    "num": "450",
    "desc": "Prerequisite: PHYS 213.\nEngine thermodynamics, fuel and combustion, engine components, engine cycles, engine power transfer and efficiencies, exhaust gas emissions. Mechanical power transfer mechanisms: bearings, belt drives, chain drives, gear drives, shaft drives. Hydraulic power transfer components and systems, fluid mechanics, hydraulic motors.",
    "credits": "3"
  },
  {
    "course_name": "Computational & Statistical Tools for Engineers",
    "dept": "BAE",
    "num": "460",
    "desc": "Prerequisite: MATH 221 and sophomore standing.\nApplication of statistical tools for analyzing engineering data. Practice of introductory to intermediate programming to develop problem-solving techniques for a wide variety of engineering applications.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "BAE",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Honors Research in Biological Systems Engineering",
    "dept": "BAE",
    "num": "499",
    "desc": "Prerequisite: Instructor approval.\nIndividual research problem selected with approval of faculty advisor. Open to students in the college of engineering honors program. A report is presented orally and in writing during the last semester.",
    "credits": "1-18"
  },
  {
    "course_name": "Structures and Environment Engineering",
    "dept": "BAE",
    "num": "535",
    "desc": "Prerequisite or concurrent enrollment: ME 513 and CE 333 or CE 530.\nEnvironmental control for agricultural buildings and structures; analysis and design of structural systems and members for agricultural structures.",
    "credits": "3"
  },
  {
    "course_name": "Biological Systems Engineering Senior Design",
    "dept": "BAE",
    "num": "536",
    "desc": "Prerequisite: BAE 331 and one of the following courses: ME 533, BAE 545, BAE 560.\nTeam-oriented design laboratory, with projects selected to address design of equipment or systems to produce or process food, fiber, and energy, or to preserve environmental quality, remediate damage, and conserve natural resources.",
    "credits": "3"
  },
  {
    "course_name": "Biological Process Engineering",
    "dept": "BAE",
    "num": "545",
    "desc": "Prerequisite or concurrent enrollment: CHE 320 or ME 571.\nAnalysis and design of biological and agricultural processes.",
    "credits": "3"
  },
  {
    "course_name": "Hydraulics and Mechatronics",
    "dept": "BAE",
    "num": "550",
    "desc": "Prerequisite: PHYS 213.\nBasic hydraulic, mechatronic, and hybrid drive system concepts and design. Application of these technologies to agriculture, construction, and other off road equipment applications.",
    "credits": "3"
  },
  {
    "course_name": "Hydrology for Biological Systems",
    "dept": "BAE",
    "num": "560",
    "desc": "Prerequisite or concurrent enrollment: ME 571 and either STAT 510 or BAE 460.\nComponents of water cycle including precipitation, infiltration, evapotranspiration. Principles and measures for controlling storm water runoff and soil erosion including hydrology and surface water flow; design of water handling structures for land drainage, flood protection, and irrigation.",
    "credits": "3"
  },
  {
    "course_name": "Natural Resources/Environmental Sciences Project (NRES)",
    "dept": "BAE",
    "num": "582",
    "desc": "Prerequisite: ENGL 415, COMM 105.\nA comprehensive project in NRES. Requires integration of information and understanding acquired in NRES secondary major courses. Students must prepare and present written and oral reports.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Biological Systems Engineering",
    "dept": "BAE",
    "num": "620",
    "desc": "Prerequisite: Approval of instructor.\nEngineering topics for the design, understanding, and/or application of biological systems. Topics announced when offered.",
    "credits": "1-18"
  },
  {
    "course_name": "Biological Systems Engineering Design Project",
    "dept": "BAE",
    "num": "636",
    "desc": "Prerequisite: BAE 536 or other approved capstone design course.\nA continuation of BAE 536. Completion of a team-oriented design project, with emphasis on construction, evaluation, documentation, and presentation of the design.",
    "credits": "1-3"
  },
  {
    "course_name": "Instrumentation and Control for Biological Systems",
    "dept": "BAE",
    "num": "640",
    "desc": "Prerequisite: ECE 410 or ECE 519, and MATH 340.\nFundamentals of instrumentation and control engineering applied in biological and agricultural systems and processes. Time-domain analysis and frequency response methods. Sensors and actuators in feedback control systems. Control system design. Case studies.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Conversion of Bio-renewable Resources",
    "dept": "BAE",
    "num": "642",
    "desc": "Prerequisite: MATH 220 and CHM 230.\nAn introduction to the conversion of biorenewable resources into biobased products and biofuels.",
    "credits": "3"
  },
  {
    "course_name": "Life Cycle Assessment",
    "dept": "BAE",
    "num": "643",
    "desc": "Prerequisite: MATH 220 and CHM 230.\nExamination of the process and methodologies associated with life cycle analysis. Application of the methods developed in the course to a project to gain experience in defining and quantifying uncertainty associated with human perturbation, management and utilization of biofuels and other complex processes.",
    "credits": "3"
  },
  {
    "course_name": "Bioenvironmental Reaction Engineering",
    "dept": "BAE",
    "num": "645",
    "desc": "Prerequisites: BAE 345 or CHE 354 and CHE 355 and BAE 445.\nBioreaction engineering principles with an emphasis on biological and environmental engineering with topics such as mass transfer, homogenous and heterogenous reactions, enzyme and cell growth kinetics, bioreactor configurations and operation, and sustainable bioprocessing.",
    "credits": "3"
  },
  {
    "course_name": "Energy and Biofuel Engineering",
    "dept": "BAE",
    "num": "650",
    "desc": "Prerequisite or concurrent enrollment: ME 513.\nEnergy use and production in agriculture and related industries. Energetics of primary production, including crop energy conversion. Energy and material balances of biomass energy production and processing systems, including energy embodied in fertilizers and pesticides. Review of the role of fossil fuels in agricultural and forestry operations, including opportunities for energy conservation. Impact of alternative fuels on internal combustion engine emissions.",
    "credits": "3"
  },
  {
    "course_name": "Air Pollution Engineering",
    "dept": "BAE",
    "num": "651",
    "desc": "Prerequisite: ME 513, 571.\nAir pollution legislation, standards, measurement, and terminology. Design and economics of particulate pollution control systems including cyclones, fabric filters, wet scrubbers, and electrostatic precipitators. Abatement of gas and vapor pollution using VOC incineration, gas adsorption and gas absorption. Meteorology and atmospheric dispersion modeling.",
    "credits": "3"
  },
  {
    "course_name": "Hydraulic Transport in Biological Systems",
    "dept": "BAE",
    "num": "660",
    "desc": "Prerequisite: CE 530 or ME 512.\nIntroduction to fluid mechanics, fluid properties non-Newtonian fluids in biological systems, fluid dynamics, balances of mass, momentum and energy, pipe flow for Newtonian (e.g., water) and non-Newtonian (e.g., blood) fluids, dimensional analysis, and compressible flows. Applications to biosystems engineering.",
    "credits": "3"
  },
  {
    "course_name": "Environmental and Ecological Risk Assessment",
    "dept": "BAE",
    "num": "663",
    "desc": "Prerequisite: MATH 221 and BIOL 455.\nExamination of processes and methodologies associated with human environmental and ecological risk assessments. Application of the methods learned to a project to gain experience in defining and quantifying uncertainty associated with human perturbation, management and restoration of environmental and ecological processes.",
    "credits": "3"
  },
  {
    "course_name": "Green Stormwater Infrastructure Design and Assessment",
    "dept": "BAE",
    "num": "664",
    "desc": "Prerequisite: BAE 560 or CE 550.\nTopics covered including engineering design of green infrastructure systems, including bioretention, stormwater wetlands, permeable pavement, and green roofs; methods for assessing the hydrologic and water quality performance at the site- and watershed scales.",
    "credits": "3"
  },
  {
    "course_name": "Ecological Engineering Design",
    "dept": "BAE",
    "num": "665",
    "desc": "Prerequisite: MATH 221 and one of the following courses: BAE 560, CE 563, BIOL 529, BIOL 612,\nDefinition, classification, and practice of ecological engineering. Course describes ecological systems, ecosystem restoration, and the utilization of natural processes to provide societal services and benefits to nature.",
    "credits": "3"
  },
  {
    "course_name": "Watershed Modeling",
    "dept": "BAE",
    "num": "669",
    "desc": "Prerequisite: GEOG 508 and one of the following courses: BAE 560, CE 550, ATM 661.\nStudy and evaluation of process equations used in watershed-scale, water-quality models. Use and application of watershed models.",
    "credits": "3"
  },
  {
    "course_name": "Biomaterials Processing",
    "dept": "BAE",
    "num": "740",
    "desc": "Prerequisite: BAE 345 or BAE 545 or GRSC 602.\nTechnologies of bio-based material processing including starch extraction (wet milling), plant oil extraction and refining, plant protein extraction and processing, cellulose processing, biofuel production, chemicals bioconversion, and drying technologies or biomaterials.",
    "credits": "3"
  },
  {
    "course_name": "Analysis and Design of Off-Highway Vehicles",
    "dept": "BAE",
    "num": "750",
    "desc": "Prerequisite: BAE 536 or ME 574.\nAnalytical study of design, testing, construction, and operating characteristics of off-highway vehicles and machinery. Includes human factors, mobility, and precision agriculture.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Engineering Seminar",
    "dept": "BAE",
    "num": "760",
    "desc": "\nDiscussion of current advances in research and practice of environmental engineering.",
    "credits": "0"
  },
  {
    "course_name": "Geoenvironmental Engineering Design",
    "dept": "BAE",
    "num": "768",
    "desc": "Prerequisite one of the following: AGRON 605, AGRON 746, BAE 690, CE 625, CE 654, CHE 531, or GEOL 611.\nA capstone design project in geoenvironmental engineering focused on resolving issues related to containment of pollutants and remediation of soil and groundwater.",
    "credits": "3"
  },
  {
    "course_name": "Biochemistry Orientation",
    "dept": "BIOCH",
    "num": "100",
    "desc": "\nDiscussion of biochemistry as a discipline in the life sciences.",
    "credits": "1"
  },
  {
    "course_name": "Biochemistry and Society",
    "dept": "BIOCH",
    "num": "110",
    "desc": "\nBiochemically oriented topics related to aspects of daily living. Development of knowledge and skills for understanding bioscience information in news media and the Internet. Selected biochemical concepts with applications to humans, such as: chemical principles and biomolecules, nutrition/diets, growth and aging, disease, fermentation, drug action, medical diagnostics and forensics, and bioethics.",
    "credits": "3"
  },
  {
    "course_name": "Biochemistry and Society Laboratory",
    "dept": "BIOCH",
    "num": "111",
    "desc": "Prerequisite: BIOCH 110 or concurrent enrollment.\nExperiments to promote understanding of chemicals and reactions in living systems.",
    "credits": "1"
  },
  {
    "course_name": "Introductory Organic and Biochemistry",
    "dept": "BIOCH",
    "num": "265",
    "desc": "Prerequisite: CHM 110.\nFor students in health and human sciences, nursing, and other areas desiring an integrated organic and biochemistry course to provide an understanding of carbohydrates, proteins, lipids, and digestive and metabolic systems.",
    "credits": "5"
  },
  {
    "course_name": "Elementary Organic and Biochemistry with Home and Virtual laboratory",
    "dept": "BIOCH",
    "num": "266",
    "desc": "Prerequisite or Corequisite - CHM 110\nProvides an understanding of carbohydrates, proteins, lipids, and digestive metabolic systems.",
    "credits": "5"
  },
  {
    "course_name": "Biochemistry Seminar",
    "dept": "BIOCH",
    "num": "290",
    "desc": "Prerequisite: BIOCH 100.\nLectures and discussions on basic topics in biochemistry.",
    "credits": "2"
  },
  {
    "course_name": "Honors Seminar in Biochemistry",
    "dept": "BIOCH",
    "num": "399",
    "desc": "Prerequisite: Freshman Honors Seminar.\nLecture, guided reading, and discussion of topics of general interest in biochemistry. Topics will vary depending on the interests and backgrounds of students enrolled.",
    "credits": "3"
  },
  {
    "course_name": "Honors Project",
    "dept": "BIOCH",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "General Biochemistry",
    "dept": "BIOCH",
    "num": "521",
    "desc": "Prerequisite: CHM 350.\nA basic study of the chemistry and metabolism of carbohydrates, lipids, proteins, and nucleic acids.",
    "credits": "3"
  },
  {
    "course_name": "General Biochemistry Laboratory",
    "dept": "BIOCH",
    "num": "522",
    "desc": "Prerequisite: CHM 351 and BIOCH 521 or concurrent enrollment.\nA one-semester laboratory course encompassing a connected series of experiments that span biochemical chromatographic techniques, PCR- cloning into plasmids by restriction fragment exchange, protein expression and purification by His-tag affinity chromatography, spectroscopic analysis of ligand binding, enzyme kinetics and inhibition.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Biochemical Methods",
    "dept": "BIOCH",
    "num": "523",
    "desc": "Prerequisites:  CHM 350, CHM 351; BIOCH 521 or concurrent enrollment.\nA one-semester virtual laboratory course encompassing a connected series of experiments that span biochemical chromatographic techniques, PCR- cloning into plasmids by restriction fragment exchange, protein expression and purification by His-tag affinity chromatography, spectroscopic analysis of ligand binding, enzyme kinetics and inhibition.",
    "credits": "2"
  },
  {
    "course_name": "Medical Biochemistry",
    "dept": "BIOCH",
    "num": "571",
    "desc": "Prerequisite: PHYS 114, CHM 350/351, BIOCH 521.\nCovers medically related concepts, structures, pathways and mechanisms in biochemistry. Addresses the fundamental biochemistry behind veterinary, medical or dental topics and issues. Instructs in the fundamental principles of protein structure and function, enzymology, carbohydrate and lipid metabolism, hormones, biochemical energetics, membranes, nucleic acid and protein metabolism, information transfer and the genetic code, genomic and proteomic analyses, the interdependence of biochemical pathways, pathogenesis and additional new topics.",
    "credits": "3"
  },
  {
    "course_name": "Research Training in Biochemistry",
    "dept": "BIOCH",
    "num": "599",
    "desc": "Prerequisite: Background adequate for relevant techniques.\nProvides laboratory experience for majors and nonmajors in research techniques contributing to ongoing biochemical research.",
    "credits": "1-3"
  },
  {
    "course_name": "Biochemistry I",
    "dept": "BIOCH",
    "num": "755",
    "desc": "Prerequisite: Chemical analysis, one year of organic chemistry, differential and integral calculus.\nAn introduction to physical methods, kinetics, and thermodynamics of biochemical reactions and bioenergetics, chemistry of proteins and amino acids, carbohydrate chemistry, and metabolism. BIOCH 755 and 765 are for students interested in a two-semester comprehensive coverage of biochemistry. For a one-semester course, enroll in BIOCH 521.",
    "credits": "3"
  },
  {
    "course_name": "Biochemistry I Laboratory",
    "dept": "BIOCH",
    "num": "756",
    "desc": "Prerequisite: *BIOCH 755 or concurrent enrollment.\nAn intensive laboratory course to accompany BIOCH 755. BIOCH 756 and 766 are sequential courses for students interested in a two-semester comprehensive coverage of experiments in biochemistry. For a one-semester laboratory course, enroll in BIOCH 522.",
    "credits": "2"
  },
  {
    "course_name": "NMR Laboratory",
    "dept": "BIOCH",
    "num": "757",
    "desc": "Prerequisite: BIOCH 755.\nBasic methods and strategies of nuclear magnetic resonance used in the study of biological molecules. Principles and applications of simple one-dimensional and two-dimensional NMR experiments.",
    "credits": "1"
  },
  {
    "course_name": "Protein Structure Laboratory",
    "dept": "BIOCH",
    "num": "758",
    "desc": "Prerequisite: BIOCH 755.\nPrinciples and uses of computational and experimental approaches for studying peptide and protein structure and dynamics: computer modeling and simulation techniques, fluorescence and circular dichroism spectroscopies, microcalorimetry, and analytical ultracentrifugation.",
    "credits": "1"
  },
  {
    "course_name": "Biochemistry II",
    "dept": "BIOCH",
    "num": "765",
    "desc": "Prerequisite: BIOCH 755.\nContinuation of BIOCH 755; lipid chemistry and metabolism, amino acid metabolism, nutrition, nucleic acid chemistry and metabolism, integration of biochemical pathways and metabolic control mechanisms.",
    "credits": "3"
  },
  {
    "course_name": "Recombinant DNA Laboratory I",
    "dept": "BIOCH",
    "num": "766",
    "desc": "Prerequisite: BIOCH 522. Recommended.\nBiochemical manipulation of nucleic acids. Isolation of plasmid and chromosomal DNA, restriction enzyme digestions, gel electrophoresis. In vitro and in vivo plasmid assembly techniques, polymerase chain reaction, and DNA sequencing analysis.  CRISPR/Cas gene editing in live cells.",
    "credits": "1"
  },
  {
    "course_name": "Recombinant DNA Laboratory II",
    "dept": "BIOCH",
    "num": "767",
    "desc": "Prerequisite: BIOCH 522.\nApproaches to study genetic interactions and protein-protein interactions using DNA techniques. Genomic integration of exogenous DNA, CRISPR/Cas editing, and yeast two-hybrid methods. Site directed mutagenesis, protein domain analysis, and protein interaction detection methodologies.",
    "credits": "1"
  },
  {
    "course_name": "Molecular Biophysics",
    "dept": "BIOCH",
    "num": "775",
    "desc": "Prerequisite: CHM 350/351, MATH 221, PHYS 114, BIOCH 755, 756, 765.\nSurvey if the biophysical methods most frequently encountered in biochemistry and related disciplines. It summarized concepts and techniques of physical science used in studying the structure and function of biomacromolecules such as proteins and DNA. Applications include classical equilibrium thermodynamics and analytical methods like mass spectrometry and circular dichroism (CD), fluorescence, EPR and nuclear magnetic resonance (NMR) spectroscopy. The class emphasizes the underlying principles and techniques used in determining the molecular weight and shape of biopolymers, biochemical mechanisms of action, and observation of conformational changes in macromolecules.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Biochemistry",
    "dept": "BIOCH",
    "num": "799",
    "desc": "Prerequisite: *Background adequate for problem undertaken.\nProblem may include laboratory and/or library work in various phases of biochemistry, agricultural chemistry, or nutrition.",
    "credits": "1-18"
  },
  {
    "course_name": "Concepts of Biology",
    "dept": "BIOL",
    "num": "101",
    "desc": "\nFundamental concepts in evolutionary biology, ecology, cell biology, genetics, biodiversity, and the scientific method.  The role of biology in society and the development of skills aimed at differentiation of biological fact from fiction are emphasized and explored.",
    "credits": "4"
  },
  {
    "course_name": "Principles of Biology",
    "dept": "BIOL",
    "num": "198",
    "desc": "\nAn introductory course for majors and non-majors focusing on plants, animals and microbes. Specific areas covered include biological molecules, cells, genetics, energy flow, physiology, ecology, and evolution.",
    "credits": "4"
  },
  {
    "course_name": "Organismic Biology",
    "dept": "BIOL",
    "num": "201",
    "desc": "Prerequisite: BIOL 198 or equivalent.\nA study of the structure and function of organisms with special attention paid to the phylogenetic origins of taxonomic groups and the integration of their structural systems.",
    "credits": "5"
  },
  {
    "course_name": "Ecology of Environmental Problems",
    "dept": "BIOL",
    "num": "303",
    "desc": "Prerequisite: Two courses in natural science.\nPrinciples of ecology and their application to such problems as pollution, human population growth, and land-use planning.",
    "credits": "3"
  },
  {
    "course_name": "Public Health Biology",
    "dept": "BIOL",
    "num": "330",
    "desc": "Prerequisite: BIOL 198.\nFundamental concepts of human infectious and organic diseases with emphasis on disease etiology and mechanisms, collection of epidemiological data, and the influences upon, and consequences of, governmental public health policy.",
    "credits": "3"
  },
  {
    "course_name": "Human Body I",
    "dept": "BIOL",
    "num": "341",
    "desc": "Prerequisite:  BIOL 198 taken at K-State (with a B or better) plus all of the following 3:\nHuman anatomy with an introduction to human physiology. Examination of cadavers, dissection of specimens, use and interpretation of EKGs, myelograms, and radiographs.",
    "credits": "4"
  },
  {
    "course_name": "Human Body II",
    "dept": "BIOL",
    "num": "342",
    "desc": "Prerequisite: C or better in BIOL 341 (Human Body I).\nHuman physiology with a review of anatomy from Human Body I.",
    "credits": "4"
  },
  {
    "course_name": "Practicum in Biology",
    "dept": "BIOL",
    "num": "365",
    "desc": "Prerequisite: Permission of instructor and credit with superior performance in the course in which the student will be involved.\nSupervised experience as a teaching assistant in biology courses. Approximately 3 hours of commitment per week is expected for each credit hour earned.  One hour recitation a week plus three to nine hours lab a week.",
    "credits": "1-4"
  },
  {
    "course_name": "Topics in Biology",
    "dept": "BIOL",
    "num": "397",
    "desc": "\nSpecial course offering in an area of faculty expertise and/or supervised independent study project.",
    "credits": "1-6"
  },
  {
    "course_name": "Honors Seminar in Biology",
    "dept": "BIOL",
    "num": "399",
    "desc": "\nSelected topics.",
    "credits": "1-3"
  },
  {
    "course_name": "Biology of the Cancer Cell",
    "dept": "BIOL",
    "num": "410",
    "desc": "Prerequisite: Two courses in biology (BIOL 450 recommended).\nCurrent concepts of cancer biology including roles of mutation, cell division, apoptosis, stem cells, microbes, and the immune system in promoting and/or inhibiting cancer.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Fisheries, Wildlife and Conservation Biology",
    "dept": "BIOL",
    "num": "433",
    "desc": "Prerequisite: BIOL 201.\nAn introduction to the ecological and management principles associated with the fields of fisheries, wildlife, and conservation biology. Topics include population ecology and assessment, resource management, and environmental legislation.",
    "credits": "3"
  },
  {
    "course_name": "Modern Genetics",
    "dept": "BIOL",
    "num": "450",
    "desc": "Prerequisite: BIOL 198, CHM 230, MATH 100.\nAn introduction to the principles and mechanisms of inheritance at both the organismic and molecular levels. Provides an integrated approach to transmission genetics and the fundamentals of molecular biology. Topics covered include Mendelian inheritance, DNA and chromosome structure, gene expression, mutation, recombinant DNA, quantitative inheritance, population, and evolutionary genetics.",
    "credits": "4"
  },
  {
    "course_name": "General Microbiology",
    "dept": "BIOL",
    "num": "455",
    "desc": "Prerequisite: BIOL 198 and one course in chemistry.\nMicroorganisms; their handling, morphology, growth, and importance.",
    "credits": "4"
  },
  {
    "course_name": "Topics in Biology",
    "dept": "BIOL",
    "num": "495",
    "desc": "Prerequisite: Consent of instructor.\nSupervised independent study project and/or special course offering in an area of faculty expertise.",
    "credits": "1-6"
  },
  {
    "course_name": "Honors Tutorial in Biology",
    "dept": "BIOL",
    "num": "496",
    "desc": "Prerequisite: Sophomore standing, membership in the honors program of the College of Arts and Sciences, and permission of instructor.\nIndividual directed research and study of a topic in biology, normally as a prerequisite to writing a senior honor thesis.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "BIOL",
    "num": "497",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Plant Physiology",
    "dept": "BIOL",
    "num": "500",
    "desc": "Prerequisite: BIOL 198 and BIOCH 265 or another course in organic chemistry.\nDetailed consideration of physiological processes of higher plants.",
    "credits": "3"
  },
  {
    "course_name": "Plant Physiology Lab",
    "dept": "BIOL",
    "num": "501",
    "desc": "Prerequisite: Concurrent or previous enrollment in BIOL 500.\nLab related to physiological processes of higher plants.",
    "credits": "1"
  },
  {
    "course_name": "Plant Ecology",
    "dept": "BIOL",
    "num": "504",
    "desc": "Prerequisite: BIOL 198 and BIOL 201 or equivalent.\nStudy of the diversity and distribution of vegetation, relationships of plants to their physical environment, plant-animal-microbe interactions, population structure and dynamics, and plant community structure diversity, and succession. Field exercises focusing on methods of grassland and forest vegetation sampling and analysis.",
    "credits": "3"
  },
  {
    "course_name": "Developmental Biology",
    "dept": "BIOL",
    "num": "510",
    "desc": "Prerequisite: BIOL 450.\nIntroduction to the stages and mechanisms of embryonic animal development. Integrated approach that includes classic experimental embryology and the genetic and molecular regulation of invertebrate and vertebrate animal development.",
    "credits": "3"
  },
  {
    "course_name": "Developmental Biology Laboratory",
    "dept": "BIOL",
    "num": "511",
    "desc": "Prerequisite: BIOL 510 or concurrent enrollment.",
    "credits": "1"
  },
  {
    "course_name": "Physiological Adaptations of Animals",
    "dept": "BIOL",
    "num": "513",
    "desc": "Prerequisite: BIOL 201; and a course in organic chemistry or biochemistry.\nIntegration of physiological mechanisms as the basis for adaptive responses of animals to different environments.",
    "credits": "4"
  },
  {
    "course_name": "Behavioral Ecology",
    "dept": "BIOL",
    "num": "515",
    "desc": "Prerequisite: BIOL 201.\nStudy of the social, environmental, genetic, and evolutionary processes that affect animal behavior. Topics include: evolution of social organization, spacing and group behavior, mating systems and parental care, sexual selection, communication, aggression, habitat selection, and foraging. Research project required.",
    "credits": "3"
  },
  {
    "course_name": "Evolution",
    "dept": "BIOL",
    "num": "520",
    "desc": "Prerequisite: BIOL 450 or a course in genetics.\nA study of the theory of evolution including its historical and social implications.",
    "credits": "3"
  },
  {
    "course_name": "Ecology",
    "dept": "BIOL",
    "num": "529",
    "desc": "Prerequisite: BIOL 198 and CHM 210.\nInterdisciplinary examination of organisms and their interaction with the environment, ecosystem structure and function, population ecology and demography, community structure and dynamics, and basic ecological principles and their relevance to contemporary environmental issues.",
    "credits": "3"
  },
  {
    "course_name": "Pathogenic Microbiology",
    "dept": "BIOL",
    "num": "530",
    "desc": "Prerequisite: BIOL 455.\nEtiology and descriptions of major infectious diseases of humans within the perspective of host defenses.",
    "credits": "3"
  },
  {
    "course_name": "Cell Biology",
    "dept": "BIOL",
    "num": "541",
    "desc": "Prerequisite: BIOL 450 and CHM 350.\nStructure and function of cells and subcellular components. A molecular understanding of membranes and cellular physiology will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Ichthyology",
    "dept": "BIOL",
    "num": "542",
    "desc": "Prerequisite: BIOL 201.\nSystematics, morphology, physiology, distribution, and natural history of fishes.",
    "credits": "3"
  },
  {
    "course_name": "Ornithology",
    "dept": "BIOL",
    "num": "543",
    "desc": "Prerequisite: BIOL 201.\nClassification, morphology, physiology, distribution, and natural history of birds.",
    "credits": "3"
  },
  {
    "course_name": "Mammalogy",
    "dept": "BIOL",
    "num": "544",
    "desc": "Prerequisite: BIOL 201.\nCharacteristics, evolution, life histories, and ecology of mammals, especially North American game species.",
    "credits": "3"
  },
  {
    "course_name": "Human Parasitology",
    "dept": "BIOL",
    "num": "545",
    "desc": "Prerequisite: BIOL 198.\nProtozoan and helminth parasites of humans with lesser emphasis on ectoparasitic arthropods. Emphasis on life cycles, control, and laboratory diagnosis.",
    "credits": "3"
  },
  {
    "course_name": "Human Parasitology Laboratory",
    "dept": "BIOL",
    "num": "546",
    "desc": "Prerequisite: Concurrent enrollment in BIOL 545.\nExamination of prepared materials and identification of internal parasites of man.",
    "credits": "1"
  },
  {
    "course_name": "Taxonomy of Flowering Plants",
    "dept": "BIOL",
    "num": "551",
    "desc": "Prerequisite: BIOL 201.\nMorphology, taxonomy, and biogeography of the vascular plants.",
    "credits": "4"
  },
  {
    "course_name": "Biology of the Fungi",
    "dept": "BIOL",
    "num": "604",
    "desc": "Prerequisite: BIOL 198.\nAn introduction to fungal structure, function, physiology, ecology, and genetics. Importance of fungi as disease organisms, as saprotrophs, and in industry. Techniques of isolation, cultivation, and as experimental organisms.",
    "credits": "3"
  },
  {
    "course_name": "Cellular and Molecular Biology of Human Diseases",
    "dept": "BIOL",
    "num": "609",
    "desc": "Prerequisite: BIOL 450 and BIOCH 521.\nFundamental basis of the major common non-infectious diseases and disorders affecting our society, with emphasis on the biochemical and molecular biological mechanisms by which the structures and functions of specific human tissues, organs and systems are altered.",
    "credits": "3"
  },
  {
    "course_name": "Freshwater Ecology",
    "dept": "BIOL",
    "num": "612",
    "desc": "Prerequisite: BIOL 201 and CHM 110 or 210.\nBasic ecological principles of aquatic environments and environmental applications. Plants and animals of local streams, rivers, ponds, and reservoirs are used to demonstrate the interaction of biological processes with the chemical and physical features of natural aquatic environments.",
    "credits": "4"
  },
  {
    "course_name": "Ecology Laboratory",
    "dept": "BIOL",
    "num": "632",
    "desc": "Prerequisite: BIOL 529 and STAT 340 or equivalent.\nLaboratory and field experiences with ecological problems.",
    "credits": "1"
  },
  {
    "course_name": "Population Biology",
    "dept": "BIOL",
    "num": "640",
    "desc": "Prerequisite: BIOL 450 and 529 and STAT 340.\nAn introduction to the theories of quantitative population biology including dynamics, demography and genetics. Emphasis on spatio-temporal variation within and among populations and species.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Conservation Biology",
    "dept": "BIOL",
    "num": "642",
    "desc": "Prerequisite: BIOL 450 and 529.\nBiological diversity and the factors contributing to loss of biodiversity. Scientific principles of biological conservation emphasizing the application of ecological theory and population genetics to the conservation of threatened populations, species and ecosystems.",
    "credits": "3"
  },
  {
    "course_name": "Immunology",
    "dept": "BIOL",
    "num": "670",
    "desc": "Prerequisite: BIOCH 521 and BIOL 450 or ASI 500 with a C or better. BIOL 541 and senior standing are highly recommended.\nChemical, genetic, and biological properties of the immune response, acquired immunity, and antibody production.",
    "credits": "4"
  },
  {
    "course_name": "Immunology Lab",
    "dept": "BIOL",
    "num": "671",
    "desc": "Prerequisite: BIOL 670 or concurrent enrollment.\nLaboratory exercises in immunology.",
    "credits": "2"
  },
  {
    "course_name": "Genetics of Microorganisms",
    "dept": "BIOL",
    "num": "675",
    "desc": "Prerequisite: BIOL 450 and 455.\nThe genetics of bacteria, viruses, and other microorganisms. Both the use of genetics in microbiological studies and the use of microbial systems to investigate basic genetic problems will be covered.",
    "credits": "3"
  },
  {
    "course_name": "Molecular Genetics Laboratory",
    "dept": "BIOL",
    "num": "676",
    "desc": "Prerequisite: BIOL 675 or concurrent enrollment.\nAn advanced course in the techniques of molecular genetics and recombinant DNA technology, including molecular cloning, library screening, polymerase chain reaction, and RFLP and DNA sequence analysis. A number of projects will be completed during the semester.",
    "credits": "3"
  },
  {
    "course_name": "Fish Ecology",
    "dept": "BIOL",
    "num": "682",
    "desc": "Prerequisite: BIOL 529.\nThe interaction between fish and their environment. Exploring fundamental ecological processes in aquatic systems at individual, population, community and ecosystem scales.",
    "credits": "3"
  },
  {
    "course_name": "Wildlife Management and Techniques",
    "dept": "BIOL",
    "num": "684",
    "desc": "Prerequisite: BIOL 433.\nConcepts and techniques of wildlife ecology and management with emphasis on North American game species. Applied population dynamics as they relate to historical and recent developments in wildlife management, habitat improvement, and related material.",
    "credits": "4"
  },
  {
    "course_name": "Microbial Ecology",
    "dept": "BIOL",
    "num": "687",
    "desc": "Prerequisite: BIOL 455 or BIOL 529.\nThe ecology of aquatic, terrestrial, animal and plant host-associated microorganisms in their natural environments.",
    "credits": "3"
  },
  {
    "course_name": "Fisheries Management and Techniques",
    "dept": "BIOL",
    "num": "696",
    "desc": "Prerequisite: BIOL 201 and BIOL 433.\nHistorical and contemporary issues in the management and conservation of exploited fishes. Methods for managing fisheries resources in streams, lakes, and ponds including estimating abundances, quantifying age and growth, manipulating populations, modeling population dynamics, culturing fishes, and improving aquatic habitat.",
    "credits": "4"
  },
  {
    "course_name": "Topics in Biology",
    "dept": "BIOL",
    "num": "697",
    "desc": "Prerequisite: Consent of instructor.\nSpecial course offering in an area of faculty expertise and/or supervised independent study project.",
    "credits": "1-6"
  },
  {
    "course_name": "Problems in Biology",
    "dept": "BIOL",
    "num": "698",
    "desc": "Prerequisite: Consent of instructor.\nUndergraduate research project pursued under the direction of a faculty mentor. A minimum of 45 hours of research effort is expected over the semester for each credit hour the student is enrolled.",
    "credits": "1-8"
  },
  {
    "course_name": "Undergraduate Seminar in Biology",
    "dept": "BIOL",
    "num": "699",
    "desc": "Prerequisite: Consent of instructor.\nAttendance at seminars or journal clubs with topics of a biological nature. A summary and personal reflection on each meeting is submitted for course credit.",
    "credits": "1"
  },
  {
    "course_name": "Radiation Safety in the Research Laboratory",
    "dept": "BIOL",
    "num": "702",
    "desc": "Prerequisite: BIOL 198 or 455; and CHM 210 or PHYS 113.\nPrinciples of radioactive safety and isotope handling, licensing procedures, and laboratory techniques.",
    "credits": "1"
  },
  {
    "course_name": "Eukaryotic Genetics",
    "dept": "BIOL",
    "num": "705",
    "desc": "Prerequisite: BIOL 450 and BIOCH 521.\nAn integrated exploration of transmission genetics and molecular genetics of eukaryotic organisms. The focus will be on genetic model organisms and their contributions to our understanding of mechanisms of genetic transmission and exchange, mutagenesis, gene expression, and regulation of cell division and development. Modern approaches to genomic analysis will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Cell Biology",
    "dept": "BIOL",
    "num": "707",
    "desc": "Prerequisite: BIOL 541.\nSelected current topics in cell biology which reflect recent advances in the field. Major topics include membranes and transport, protein sorting, signal transduction, cell adhesion and motility, cell cycle, apoptosis, and specialized cell functions.",
    "credits": "3"
  },
  {
    "course_name": "General Virology",
    "dept": "BIOL",
    "num": "730",
    "desc": "Prerequisite: Twelve hours of biological sciences, including BIOL 450 and 455; and BIOCH 521 or equivalent; consent of instructor.\nTheoretical and experimental basis of virology, with emphasis on how viruses manipulate cells to insure their own survival, mechanisms of virus replication, principles of virus host interactions including how viruses cause disease, and selected medically relevant viruses.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Genomics and Bioinformatics",
    "dept": "BIOL",
    "num": "734",
    "desc": "Prerequisite: BIOL 450 or CIS 575.\nA problem solving approach to understanding genomics and bioinformatics. Practical use of databases and web-based tools used to study biological problems. Introduction to the algorithms behind these tools.",
    "credits": "4"
  },
  {
    "course_name": "Cancer Therapy",
    "dept": "BIOL",
    "num": "736",
    "desc": "Prerequisite: BIOL 450 and BIOCH 521.\nCurrent methods of cancer management with emphasis on the kinetic principles of chemotherapy and radiation therapy; diagnosis; surgical oncology; oncologic emergencies; adverse effects of cancer therapy; and the new therapies.",
    "credits": "3"
  },
  {
    "course_name": "New Student Assembly",
    "dept": "BME",
    "num": "001",
    "desc": "\nThis course addresses the emphasis areas in the KSU biomedical engineering (BME) curriculum and facilitates the formation of a community consisting of BME students and faculty. Students learn about biomedical research pursued by KSU faculty and become aware of BME experiential learning programs, professional societies, and job/internship opportunities.",
    "credits": "0"
  },
  {
    "course_name": "Introduction to Biomedical Engineering",
    "dept": "BME",
    "num": "200",
    "desc": "\nBiomedical engineering addresses the application of engineering principles to challenges faced by the health care and life science communities. This course introduces students to the areas of study that comprise this broad field and provides students with guidance toward biomedical career opportunities. Topics of interest include the history of biomedical technology, medical devices, medical imaging, biomedical optics, biomechanics, biomaterials, tissue engineering, rehabilitation engineering, neural interfacing, prosthetics, assistive technology, telemedicine, home care, wearable devices, health care information technology, considerations for diverse populations, and medical ethics.",
    "credits": "3"
  },
  {
    "course_name": "Biomaterials",
    "dept": "BME",
    "num": "430",
    "desc": "Prerequisite: BIOL 198, CHM 230.\nThis course will provide an overview of interactions between materials and biological systems, techniques to assess biomaterial characteristics, and the role of biomaterial selection during the design of medical devices for select applications.",
    "credits": "3"
  },
  {
    "course_name": "Biomechanical Engineering",
    "dept": "BME",
    "num": "451",
    "desc": "Prerequisite: BIOL 198, MATH 222, PHYS 213.\nThis course provides an introduction to the mechanics of biological tissues and systems at the macroscopic scale. It covers the structure and mechanics of biological tissue based on the principles of statics and dynamics, with an emphasis on bone, muscle, and connective tissue.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate BME Design Experience I",
    "dept": "BME",
    "num": "490",
    "desc": "Prerequisite: PHYS 214, BME 200 and Corequisite: BIOL 340 or KIN 360.\nThe undergraduate design courses are intended to be taken during the fall and spring semesters of each BME student’s junior year. The first semester is designed for project selection and planning, and it includes a lecture component to cover important considerations such as human subject protections and electrical safety. The follow-on course, BME 491, will focus on the implementation of the design selected in BME 490.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate BME Design Experience II",
    "dept": "BME",
    "num": "491",
    "desc": "Prerequisite: BME 490 and (BIOL 340 or KIN 360).\nThe undergraduate design courses are intended to be taken during the fall and spring semesters of each BME student’s junior year. Students will participate in the guided design of a BME project selected in the previous semester. The course includes a lecture/meeting once per week, as well as a scheduled three-hour lab time for students to work on their design.",
    "credits": "2"
  },
  {
    "course_name": "Clinical Systems Engineering",
    "dept": "BME",
    "num": "575",
    "desc": "Prerequisite: ECE 540 or equivalent.\nThis course addresses the creation and use of biomedical “systems of systems” as applied in various health care delivery scenarios, including hospitals, home care settings, and environments that employ personalized wearable systems. The material focuses on technical areas typically associated with the field of “clinical engineering,” emphasizing the use of design standards that promote system interoperability and reconfiguration. Hardware/software interfacing and information management will be addressed from the sensor level to the level of the clinical enterprise. The course will also address human elements related to such systems (e.g., human factors, safety, medical ethics, training, etc.) as well as global technical, political, and sociological issues that may promote or hinder their use in different countries and cultures.",
    "credits": "3"
  },
  {
    "course_name": "Senior Design Experience I",
    "dept": "BME",
    "num": "590",
    "desc": "Prerequisite: BME 491, ECE 540, and ENGL 415\nThe two-semester BME senior design experience is a culminating design sequence intended for the last two semesters of each BME student’s degree program. BME 590-the first course in that sequence-integrates practice in verbal/written communication skills with the initiation of a collaborative design project to emulate a professional technical environment. The course addresses engineering ethics, design theory, project management, team dynamics, and socio-economic considerations related to design.",
    "credits": "3"
  },
  {
    "course_name": "Senior Design Experience II",
    "dept": "BME",
    "num": "591",
    "desc": "Prerequisite: BME 590.\nThe two-semester BME senior design experience is a culminating design sequence intended for the last two semesters of each BME student’s degree program. BME 591-the second course in that sequence-addresses the implementation and demonstration of the project design initiated in BME 590. The course includes oral presentations for design reviews and technical documentation, where the latter addresses project plans; design operations, analyses, architecture, and requirements; design descriptions; and a user manual.",
    "credits": "2"
  },
  {
    "course_name": "Medical Imaging",
    "dept": "BME",
    "num": "674",
    "desc": "Prerequisite: ECE 512.\nThis course addresses various modalities of medical imaging as an extension of biomedical instrumentation. Methods for image data acquisition, processing, and display form the core for this course, which also addresses industry standards for image storage and transmission. Diagnostic applications for medical images are emphasized along with safety and ethics issues that relate to the acquisition and management of biomedical image data.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Business",
    "dept": "BUS",
    "num": "110",
    "desc": "\nThis course surveys the objectives, decisions, and activities within a business organization. Topics include a study of management responsibilities and controls, organizational structures, and marketing activities.",
    "credits": "3"
  },
  {
    "course_name": "Financial Accounting",
    "dept": "BUS",
    "num": "251",
    "desc": "\nStudy of business topics such as alternative forms of business organizations; typical business practices; legal instruments such as notes, bonds, and stocks; and financial statements and analysis. The main objective is to develop the ability to provide information to stockholders, creditors, and others who are outside an organization.",
    "credits": "3"
  },
  {
    "course_name": "Managerial Accounting",
    "dept": "BUS",
    "num": "252",
    "desc": "Prerequisite: BUS 251.\nThis course outlines the use of internal accounting data by managers in directing the affairs of business and non-business organizations.",
    "credits": "3"
  },
  {
    "course_name": "Supervisory Management",
    "dept": "BUS",
    "num": "315",
    "desc": "Prerequisite: ENGL 100; and COMM 105 or COMM 106.\nAn analysis of the responsibilities and work environment of a supervisor, with an examination of skills, practices, and concepts helpful in developing effective relations with people in today’s changing environment.",
    "credits": "3"
  },
  {
    "course_name": "Total Quality Management for Technology",
    "dept": "BUS",
    "num": "320",
    "desc": "\nThis course addresses the commitment of management and the organization as a whole to the cultural changes necessary to implement quality improvements throughout the organization. Topics include quality organization and philosophy, quality audit and ISO 9000 series, integration of functional areas, team building, management principles, quality costs, and other associated interactive facets of Total Quality Management. The main concern is to provide the student with a working knowledge of conventional TQM tools.",
    "credits": "3"
  },
  {
    "course_name": "Management with Information Technology",
    "dept": "BUS",
    "num": "366",
    "desc": "Prerequisite: Experience with PC software.\nA comprehensive view of the role of information technology in satisfying organizations’ information requirements. Problems and techniques concerning the management of responsive information systems with special attention to managers’ use of systems outputs. Cases and hands-on exercises emphasizing the use of information systems in decision making, information gathering and organizing, use of modeling techniques, and presentation of information.",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Business Law",
    "dept": "BUS",
    "num": "390",
    "desc": "Prerequisite: Junior standing.\nA study of law as it relates to business, including court procedures and systems, contracts, torts, agency and employment law, and business crimes.",
    "credits": "3"
  },
  {
    "course_name": "Marketing Techniques and Applications",
    "dept": "BUS",
    "num": "400",
    "desc": "Prerequisite: ECON 110 or ECON 120.\nA general study of marketing principles which lead to the development of marketing strategy. A review of environmental influences and key analytical tools used in formulating marketing plans. Product or service design, distribution, pricing, and promotional programs.",
    "credits": "3"
  },
  {
    "course_name": "Managerial and Project Economics",
    "dept": "BUS",
    "num": "410",
    "desc": "Prerequisite: MATH 100.\nEconomic analysis of problems as applied to managerial decision making. Students consider the economic viability of solutions in engineering and a variety of other kinds of projects common in technology-oriented businesses.",
    "credits": "3"
  },
  {
    "course_name": "Management Perspectives",
    "dept": "BUS",
    "num": "420",
    "desc": "\nProvides an introduction to the four basic managerial functions of planning, organizing, leading and controlling and their application to today’s complex work environment. An emphasis is placed on the roles and responsibilities of managers that help them to successfully meet organizational objectives by effectively leading employees and optimizing processes.",
    "credits": "3"
  },
  {
    "course_name": "Applied Operations Management",
    "dept": "BUS",
    "num": "421",
    "desc": "Prerequisite: STAT 325.\nDescription and analysis of problems related to the output of goods and services, operations planning and control, and systems management.",
    "credits": "3"
  },
  {
    "course_name": "Integrated Finance",
    "dept": "BUS",
    "num": "450",
    "desc": "Prerequisite: BUS 251.\nStudy of the basic principles of finance, including discounted cash flow analysis, risk-return tradeoff, asset pricing models, and financial and real asset valuation. Applications of these concepts to the firm’s investment and financing decisions and performance analysis will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Integrated Technology Management Capstone",
    "dept": "BUS",
    "num": "520",
    "desc": "Prerequisite: Senior Standing.\nA capstone course which integrates the functional areas of business, including management, marketing, finance, accounting, operations and production. The course uses business strategy simulation and case studies to apply acquired knowledge across various areas of concentration for successful business management.",
    "credits": "3"
  },
  {
    "course_name": "Practices of Industrial and Labor Relations",
    "dept": "BUS",
    "num": "530",
    "desc": "Prerequisite: Junior standing.\nBasic course in industrial and labor relations. Broad coverage of the institution of collective bargaining and its environment, the goals and operation of labor unions, the impact of unions on management, and labor relations law.",
    "credits": "3"
  },
  {
    "course_name": "Strategic Human Resource Management",
    "dept": "BUS",
    "num": "531",
    "desc": "Prerequisite: BUS 420.\nThis course provides an overview of the human resource systems and processes needed to achieve organizational effectiveness and strategic success. All key functional areas including human resource planning, staffing, performance management, employee development, and compensation are addressed.",
    "credits": "3"
  },
  {
    "course_name": "Personal Selling and Sales Management",
    "dept": "BUS",
    "num": "542",
    "desc": "Prerequisite: Concurrent enrollment: BUS 400.\nFocuses on interpersonal communications between buyers and sellers, both oral and written. The mechanics and intricacies of personal sales presentations, which will be developed through practice.",
    "credits": "3"
  },
  {
    "course_name": "Fundamental Computer Programming Concepts",
    "dept": "CC",
    "num": "210",
    "desc": "Prerequisite: CIS 111 or CIS 115.\nBasic concepts in developing computer programs: program structure and syntax, primitive data types, variables, control flow, iteration, simple algorithms, debugging, and good software development practices. Introduction to object-oriented programming.",
    "credits": "4"
  },
  {
    "course_name": "Data Structures and Algorithms I",
    "dept": "CC",
    "num": "310",
    "desc": "Prerequisite: MATH 100.\nExploration of data structures &amp; related algorithms in computer programming. Basic concepts of complexity analysis. Object-oriented design concepts.&amp;nbsp;",
    "credits": "3"
  },
  {
    "course_name": "Data Structures and Algorithms II",
    "dept": "CC",
    "num": "315",
    "desc": "\nAdvanced data structures and related algorithms. Formal software development methods and software engineering fundamentals. Introduction to requirements analysis processes that provide the specification of algorithmic requirements.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Programming",
    "dept": "CC",
    "num": "410",
    "desc": "Prerequisite or concurrent: CC 315.\nAdvanced programming techniques and projects. Concepts from simulation and modeling, media applications, secure design, information management, parallelism, and networking. Software development methodologies, processes, and design patterns. Practical experience with professional communication and collaboration.",
    "credits": "4"
  },
  {
    "course_name": "Introduction to Native Community Development",
    "dept": "CDPLN",
    "num": "610",
    "desc": "\nThis course is a base knowledge course for students currently working with native communities. Students taking this course will develop a basic understanding within the context of community development of the diversity of tribal structures and cultures and the unique history and jurisdictional considerations of these nations.",
    "credits": "3"
  },
  {
    "course_name": "Building Native Communities and Economic Capacity",
    "dept": "CDPLN",
    "num": "611",
    "desc": "Prerequisite: CDPLN 610.\nThis course will focus on non-western approaches to helping native communities build their capacity. Students will learn to take a participatory, culture-centered, and strength-based approach to development.",
    "credits": "3"
  },
  {
    "course_name": "Indian Country Agriculture and Natural Resources",
    "dept": "CDPLN",
    "num": "612",
    "desc": "Prerequisite: CDPLN 610.\nAn introduction to the historical and contemporary issues related to natural resource management on Native American lands. Study will include a variety of ecological settings across Native American lands, along with an analysis of tribal sovereignty as it relates to land tenure and water rights. Arguments concerning natural resource conservation, preservation and extraction will be explored.",
    "credits": "3"
  },
  {
    "course_name": "Youth Development in Native Communities",
    "dept": "CDPLN",
    "num": "613",
    "desc": "Prerequisite: CDPLN 610.\nFocus on contemporary issues impacting native youth including: Demographics (Criminal justice, early parenting, poverty, education, suicide and morbidity), identity formation (risky behavior and achievement opportunities), health care (diabetes, obesity, fetal alcohol), prevention activities (4H, BGC, horse clubs, running strong), and influx of youth leadership (youth-elder connections).",
    "credits": "1"
  },
  {
    "course_name": "Wellness in Native Communities: Challenges and Opportunities",
    "dept": "CDPLN",
    "num": "614",
    "desc": "Prerequisite: CDPLN 610.\nHealthcare issues challenging Native communities, and strategies and practices to address those challenges. Focus on the impact of the Indian Health System, other bureaucratic systems, and current consumer practices that impact healthcare for Native peoples and the ways tribes are working to create healthier communities and improve the lifestyle of Indian people.",
    "credits": "1"
  },
  {
    "course_name": "Role of Tribal Colleges in Economic Development",
    "dept": "CDPLN",
    "num": "615",
    "desc": "\nFocus: the role of tribally-chartered colleges/universities in economic development within Native communities. Topics include the use of bonding/bridging social capital, the historical and contemporary case for tribally-chartered higher education, the economic impact of tribal colleges on their local economies, and opportunities/challenges of broad and diverse collaborative networks.",
    "credits": "1"
  },
  {
    "course_name": "Ecological Economics",
    "dept": "CDPLN",
    "num": "620",
    "desc": "\nSynthesis across the notion of “utility” as represented in environmental/natural resource economics, as well as the notion of “ecology” in ecological economics. Focus will be on the influence the community and ecosystem have on one another, and the potential for complementarity between the two.",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Communities",
    "dept": "CDPLN",
    "num": "621",
    "desc": "\nThe management of natural capital as linked to other community-based actions around resource allocation and the impacts on quality of life. The literature on community-based natural resource management will be examined and alternative ways of valuing natural capital will be assessed. Contrasting theories of the role of natural capital in communities.",
    "credits": "3"
  },
  {
    "course_name": "Impact Analysis",
    "dept": "CDPLN",
    "num": "622",
    "desc": "\nThe basics of economics and fiscal impact analysis are explored, including the scenario construction, basics of input-output analysis, careful use of multipliers, estimations of local revenues and expenditures and discounting.",
    "credits": "1"
  },
  {
    "course_name": "Local Economic Analysis",
    "dept": "CDPLN",
    "num": "623",
    "desc": "\nThis course teaches economic base theory, a theory of regional economics, multipliers and how local economics are affected by external events. Basic methods for the analysis of a local economy are covered, including trend analysis, location quotients, shift share analysis and retail trade analysis.",
    "credits": "1"
  },
  {
    "course_name": "Community Developer as Community Educator",
    "dept": "CDPLN",
    "num": "624",
    "desc": "\nA graduate level course on education strategies and tools for use in community development. This course will develop students’ identities as community educators and provide knowledge on appropriate methodologies for working with adults in community settings as well as develop their creativity and critical thinking skills. Students will engage in peer-to-peer teaching and critical analysis of community education activities.",
    "credits": "3"
  },
  {
    "course_name": "Participatory Action Research Methods (PAR)",
    "dept": "CDPLN",
    "num": "625",
    "desc": "\nA graduate level course to develop participatory action research knowledge and skills through real-world applications. PAR is a method of collecting information by community members in collaboration with a researcher that respects, places community central to, and reflects the experiences and culture of the people most directly impacted by the issue under consideration.",
    "credits": "3"
  },
  {
    "course_name": "Governance and the Community Development Process",
    "dept": "CDPLN",
    "num": "630",
    "desc": "\nCourse focus is on the understanding of the various levels of government and the diversity of governmental forms across the states, reservations, and among nations. Students will compare roles of governments in international settings in relation to community development, and study strategies of evaluating policies that impact community development opportunities.",
    "credits": "3"
  },
  {
    "course_name": "Leadership for Change",
    "dept": "CDPLN",
    "num": "631",
    "desc": "\nCourse focus is on the role of leadership in community development and change, including situating leadership in the community development process, reviewing the effectiveness of different leadership styles, and relating leadership to community. Skills and processes that facilitate effective shared leadership, including facilitation, conflict resolution, use of participatory techniques, etc, are explained.",
    "credits": "3"
  },
  {
    "course_name": "Nonprofit Management",
    "dept": "CDPLN",
    "num": "632",
    "desc": "\nManaging nonprofits including the role of nonprofit organizations in addressing various social problems. Focus: growth of the nonprofit sector and impact on the community as a source of citizen empowerment. Topics include individual giving/volunteering, board and executive leadership, government and nonprofit relationship, ethics and accountability, and issues and challenges in nonprofit management.",
    "credits": "3"
  },
  {
    "course_name": "Grantwriting",
    "dept": "CDPLN",
    "num": "633",
    "desc": "\nThe intricacies of grantsmanship provide the focus of this course. Topics covered will include identification of fund sources, procedures for proposal preparation, composition of grants, and the effects of organizational and personal linkages. Students will prepare a grant application based upon an RFP or to a continuous funding source.",
    "credits": "3"
  },
  {
    "course_name": "Community Leadership and Capacity Building",
    "dept": "CDPLN",
    "num": "635",
    "desc": "\nExplorations of the various approaches to leadership and leadership development, evaluation of leadership projects and the relationship of leadership to community capacity building. Topics include defining leadership and applying it to the workplace, and understanding the potential link between leadership and community capacity, as well as identifying strategies for leadership development in communities.",
    "credits": "3"
  },
  {
    "course_name": "Immigrants in Communities",
    "dept": "CDPLN",
    "num": "640",
    "desc": "\nInternational migration has historically impacted rural and urban communities around the world. Taking a comparative approach, this course examines community-immigrant interactions and influences on community development and immigrant inclusion. Readings relate theories of immigrant and community change to case studies. Students will gather primary data to assess the capacity of communities to include new international immigrants.",
    "credits": "3"
  },
  {
    "course_name": "Community Economic Development for the 21st Century",
    "dept": "CDPLN",
    "num": "650",
    "desc": "\nStudy of the basic theories, concepts, and skills necessary to be a part of a productive community economic development team. Focus is on the importance of organizational values, mission and vision, as well as six approaches to development. The course will cover the five community functions, development strategies, action planning, and organizing for action.",
    "credits": "3"
  },
  {
    "course_name": "Economic Development Strategies and Programs",
    "dept": "CDPLN",
    "num": "651",
    "desc": "\nCourse explores theories of local economic development and addresses the development issues faced by communities in the 21st century. Students will understand and apply concepts from economic development planning, economic analysis, business development, human resource development, community-based development, and high-technology development.",
    "credits": "3"
  },
  {
    "course_name": "Land Development Planning",
    "dept": "CDPLN",
    "num": "655",
    "desc": "\nAn examination of the process of land development in the United States, and its impacts from the perspective of developers, financial institutions, community planners, and city administrators. Focus is on the understanding of the land development process in meeting community goals, and shaping land development to meet community expectations for the improvement of the community.",
    "credits": "3"
  },
  {
    "course_name": "Policy and Politics of Coastal Areas",
    "dept": "CDPLN",
    "num": "660",
    "desc": "\nOne half of the world’s population lives on a coast and two-thirds of the world’s largest cities are located on a coast. This course addresses the environmental, land use, and other critical issues affecting these areas worldwide.",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Community Development",
    "dept": "CDPLN",
    "num": "700",
    "desc": "\nThis course introduces the online Master of Science degree in Community Development. Initial topics include getting comfortable in the online learning environment and succeeding in graduate school. Students will be expected to develop concrete plans for succeeding in the program and to demonstrate graduate level writing and communication skills in assignments related to community development. The bulk of the course will provide foundations to community development as: (1) an academic discipline; (2) a science-based profession; and (3) a skills and knowledge-based practice.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in Community Development",
    "dept": "CDPLN",
    "num": "701",
    "desc": "\nIndependent study on special topics of interest in community development.",
    "credits": "1-3"
  },
  {
    "course_name": "Applied Community Development",
    "dept": "CDPLN",
    "num": "703",
    "desc": "Prerequisite: Admission to the MSCD program and instructor permission.\nThis course provides students the opportunity to apply knowledge to professional practice. Students will produce a written report on a project of focus, which they have worked on directly, relating their experience to concepts and skills learned through the community development curriculum. Projects must exist at the time of the course and may consist of activities via internships, coursework or capstones outside of the community development curriculum, or personal interests.",
    "credits": "1"
  },
  {
    "course_name": "Organizing for Community Change",
    "dept": "CDPLN",
    "num": "705",
    "desc": "\nExamination of the role of society in community planning efforts. Focus on change within communities and the roles of government, planners, and citizens in reacting to or shaping change. Dimensions of social capital and the context of change and the implications of economic and demographic shifts on strategies and tactics for change will be explored.",
    "credits": "3"
  },
  {
    "course_name": "Community Analysis",
    "dept": "CDPLN",
    "num": "710",
    "desc": "Prerequisite: CDPLN 705 or concurrent enrollment.\nAn introduction to research methods relevant to community development. Topics include how to formulate and begin a research effort, methods of data collection and how conceptual frameworks are used to develop the questions and analyze data. Also included are strategies for reporting findings and applying findings in community action.",
    "credits": "3"
  },
  {
    "course_name": "Principles and Strategies of Community Change",
    "dept": "CDPLN",
    "num": "715",
    "desc": "\nAn analysis of the principles and practices of community change and development, using case studies and the students’ communities of reference. the course will relate Community Development approaches to conceptual models from diverse disciplines. Conceptual models include conflict, neo-classical economic growth, participatory democracy, and others.",
    "credits": "3"
  },
  {
    "course_name": "Community and Regional Economic Analysis",
    "dept": "CDPLN",
    "num": "720",
    "desc": "\nThe course introduces concepts of communities and regions, theories of economic growth, drivers of economic growth, the economic base of a community, sources of growth or decline in the community, roles of local government and institutions, analytical tools, and strategies for local economic development.",
    "credits": "3"
  },
  {
    "course_name": "Community and Regional Economic Analysis II",
    "dept": "CDPLN",
    "num": "721",
    "desc": "\nThis course will develop a substantive grounding in the theories and practice of measuring community economic dynamics plus build solid foundation skills for applied community economic analysis. Elements include basic descriptive tools of community economic analysis, such as economic base evaluation, industrial mix analysis, trade area assessment, and industrial and occupational composition analysis, input-output industrial accounting for economic impact analysis and the development of fiscal impact assessment techniques, and measures of public policy effectiveness.",
    "credits": "3"
  },
  {
    "course_name": "Community and Natural Resource Management",
    "dept": "CDPLN",
    "num": "725",
    "desc": "\nAn introduction to the breadth of consideration involved in community resource management. Included are theoretical frameworks, methodological investigation and applied practices to enhance the ability of community development professionals to work with their communities to plan, develop, and monitor the conversion and development of natural resources with multiple functions.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Community Development",
    "dept": "CDPLN",
    "num": "880",
    "desc": "\nIndependent study of selected concepts and trends in community development. Students electing this course offering will be preparing a specialization paper as their final project.",
    "credits": "1-3"
  },
  {
    "course_name": "Research in Community Development",
    "dept": "CDPLN",
    "num": "899",
    "desc": "Prerequisite: CDPLN 880.\nOriginal research and advanced study in community development, and related fields for the master’s report.",
    "credits": "0-18"
  },
  {
    "course_name": "Engineering Assembly",
    "dept": "CE",
    "num": "015",
    "desc": "",
    "credits": "0"
  },
  {
    "course_name": "Introduction to Civil Engineering",
    "dept": "CE",
    "num": "101",
    "desc": "\nIntroduction to careers in civil engineering (construction, environmental geotechnical, structures, transportation, and water resources). Overview of CE educational requirements. History of the CE profession. Engineering ethics.",
    "credits": "1"
  },
  {
    "course_name": "Civil Engineering Graphics",
    "dept": "CE",
    "num": "202",
    "desc": "\nThis course will include drafting, technical sketching, projective geometry, multiview drawings, reading and interpreting drawings, sectioning, dimensioning, and computer aided design (CAD) including 3D to produce basic civil engineering drawings.",
    "credits": "3"
  },
  {
    "course_name": "Elementary Surveying Engineering",
    "dept": "CE",
    "num": "212",
    "desc": "Prerequisite: MATH 150.\nCoordinates, directions, distances, and elevation. transverses. boundary surveys. Leveling, national rectangular coordinate systems. property descriptions: public land subdivision and metes and bounds. Topographic surveys. surveying, planning, and estimating.",
    "credits": "3"
  },
  {
    "course_name": "Strength of Materials and Analysis",
    "dept": "CE",
    "num": "331",
    "desc": "Prerequisite: CNS 231.\nStudy of behavior of materials subjected to tension, compression, shear, and bending; analysis of beams and columns.",
    "credits": "3"
  },
  {
    "course_name": "Strength of Materials Laboratory",
    "dept": "CE",
    "num": "332",
    "desc": "Prerequisite or concurrent enrollment: CE 331.\nTests to determine the physical properties of various structural materials. Analysis and interpretation of test data.",
    "credits": "1"
  },
  {
    "course_name": "Statics",
    "dept": "CE",
    "num": "333",
    "desc": "Prerequisite: MATH 221 and PHYS 213.\nComposition and resolution of forces; equilibrium of force systems; application of general laws of statics to engineering problems, including use of vector algebra, friction and force analyses of simple structures, cables, and machine elements; center of gravity; moments of inertia.",
    "credits": "3"
  },
  {
    "course_name": "Route Location and Design",
    "dept": "CE",
    "num": "411",
    "desc": "Prerequisite: CE 212, MATH 221, and PHYS 213.\nHighway location and the geometric design of highways considering the driver-vehicle-roadway system characteristics; curves and earthwork; and surveying pertaining to the alignment of highways.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "CE",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Honors Research in Civil Engineering",
    "dept": "CE",
    "num": "499",
    "desc": "\nIndividual research problem selected with approval of faculty advisor. A report is presented orally and in writing during the last semester.",
    "credits": "1-18"
  },
  {
    "course_name": "Soil Mechanics I",
    "dept": "CE",
    "num": "522",
    "desc": "Prerequisite: “C” or better in CE 533.\nIdentification, classification, and engineering properties of soils; theory and application of consolidation, compressibility, and strength of soils; ground water retention and movement; slope stability and lateral earth pressures; stress distribution in soil.",
    "credits": "3"
  },
  {
    "course_name": "Foundation Engineering",
    "dept": "CE",
    "num": "528",
    "desc": "Prerequisite: “C” or better in CE 522.\nPrediction of soil variation, soil investigations; stress distribution and bearing capacity; dewatering analysis and procedures; retaining structures and lateral earth pressures; shallow foundations, pile foundations; underpinning and grouting.",
    "credits": "3"
  },
  {
    "course_name": "Statics and Dynamics",
    "dept": "CE",
    "num": "530",
    "desc": "Prerequisite: MATH 222 and PHYS 213.\nA shortened combined course in (1) statics, including a study of force systems, free-body diagrams, and problems in equilibrium, friction, centroids, and moments of inertia; and (2) dynamics, including a study of the kinematics and kinetics of particles and rigid bodies using the method of force-mass acceleration.",
    "credits": "3"
  },
  {
    "course_name": "Mechanics of Materials",
    "dept": "CE",
    "num": "533",
    "desc": "Prerequisite: “C” or better in CE 333 or “C” or better in CE 530. Prerequisite or concurrent enrollment: MATH 222.\nElementary theories of stress and strain, behavior of materials, and applications of these theories and their generalizations to the study of stress distribution, deformation, and instability in the simple structural forms which occur most frequently in engineering practice.",
    "credits": "3"
  },
  {
    "course_name": "Mechanics of Materials Laboratory",
    "dept": "CE",
    "num": "534",
    "desc": "Prerequisite or concurrent enrollment: CE 533.\nDetermination of selected mechanical properties of several engineering materials, including iron-carbon alloys, aluminum alloys, concrete, wood, and plastics; relationship between structure and mechanical properties of these materials; elementary problems in experimental stress analysis and structural behavior; test procedures, instrumentation, and interpretation of results.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Structural Analysis",
    "dept": "CE",
    "num": "537",
    "desc": "Prerequisite: “C” or better in CE 533.\nElastic analysis of determinate and indeterminate beams, frames, and trusses; construction of shear and moment diagrams and influence lines; calculation of deflections using conjugate beam and virtual work; solution of indeterminate structures by slope-deflection, moment distribution, and matrix stiffness method; with microcomputer applications.",
    "credits": "3"
  },
  {
    "course_name": "Structural Engineering in Steel",
    "dept": "CE",
    "num": "542",
    "desc": "Prerequisite: “C” or better in CE 537.\nIntroduction to design of steel structures. Theoretical, experimental and practical bases for proportioning members and their connections.",
    "credits": "3"
  },
  {
    "course_name": "Structural Engineering in Concrete",
    "dept": "CE",
    "num": "544",
    "desc": "Prerequisite: “C” or better in CE 537.\nA study of the theories of reinforced concrete and of its characteristics as a construction material; design of reinforced concrete structures.",
    "credits": "3"
  },
  {
    "course_name": "Water Resources Engineering",
    "dept": "CE",
    "num": "550",
    "desc": "Prerequisite: “C” or better in STAT 510, and PHYS 213.\nIntroduction to: surface water hydrology, design of water handling structures, flood protection, pipe flow hydraulics, pump selection, and flow in soils.",
    "credits": "3"
  },
  {
    "course_name": "Hydraulic Engineering",
    "dept": "CE",
    "num": "552",
    "desc": "Prerequisite: “C” or better in ME 571. Prerequisite or concurrent enrollment: “C” or better in CE 550.\nApplications of the principles of fluid mechanics to control and use of water; reservoir, dam, and spillway design; enclosed conduit and open-channel design; hydraulic machinery and hydro-power development; principles of fluid measurement; laboratory-flow and velocity metering, hydraulic models, pipe losses, open-channel flow.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Engineering Fundamentals",
    "dept": "CE",
    "num": "563",
    "desc": "Prerequisite: “C” or better in CHM 230, and MATH 222.\nBasic physical, chemical, and biological concepts and the applications to the protection of the environment with emphasis on techniques used in water and wastewater treatment.",
    "credits": "3"
  },
  {
    "course_name": "Water and Wastewater Engineering",
    "dept": "CE",
    "num": "565",
    "desc": "Prerequisite: CE 550, “C” or better in CE 563, PHYS 214 and ME 571.\nDesign of municipal water and wastewater treatment systems.",
    "credits": "3"
  },
  {
    "course_name": "Highway Engineering, Planning and Management",
    "dept": "CE",
    "num": "572",
    "desc": "Prerequisite: “C” or better in CE 411, and CE 522.\nApplications of the principles of traffic engineering and capacity analysis techniques to analyze, design and maintain street and highway systems. Fundamentals of transportation planning; site planning and design; traffic impact studies; fundamentals of pavement design and management.",
    "credits": "3"
  },
  {
    "course_name": "Civil Engineering Project",
    "dept": "CE",
    "num": "585",
    "desc": "Prerequisite: ENGL 415 and “C” or better in two 3-hour CE design electives. Prerequisite or concurrent enrollment in the remaining required CE design electives.  Students take CE 585 during thier last planned semester of their B.S. program.\nA comprehensive civil engineering project, to be taken in the last semester of the B.S. program. Requires integration of skills acquired in civil engineering elective courses. Students must prepare and present written and oral design reports.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Geoenvironmental Engineering",
    "dept": "CE",
    "num": "625",
    "desc": "Prerequisite: CE 522.\nIntroduction to soil formation, structure, flow and mass transport in soils, mass transfer principles, waste containment and isolation, and physical, chemical, and biological remediation principles.",
    "credits": "3"
  },
  {
    "course_name": "Civil Engineering Materials I",
    "dept": "CE",
    "num": "641",
    "desc": "Prerequisite: CE 534 and ENGL 415.\nProperties and behavior of structural metals, timber, portland cement concrete, and bituminous concrete; standard specification and methods of test; inspection and control; long-term protection and durability.",
    "credits": "3"
  },
  {
    "course_name": "Design of Groundwater Flow Systems",
    "dept": "CE",
    "num": "654",
    "desc": "Prerequisite: ME 571.\nIntroduction to fundamental, mathematical and physical concepts of groundwater flow; application of simple analytic models; introduction to field methods; application of computer modeling tools to address design with practical significance.",
    "credits": "3"
  },
  {
    "course_name": "Unit Operations and Processes in Environmental Engineering",
    "dept": "CE",
    "num": "663",
    "desc": "Prerequisite or concurrent enrollment: CE 565 and CE 552.\nA laboratory study of various physical, chemical and biological operations and processes used in the professional practice of environmental engineering. Topics covered will be selected from reactor hydrodynamics, oxidation-reduction, coagulation-flocculation, chemical precipitation, ion exchange, adsorption processes, biological oxidation, anaerobic digestion and the activated-sludge process.",
    "credits": "2"
  },
  {
    "course_name": "Economics of Design and Construction",
    "dept": "CE",
    "num": "680",
    "desc": "Prerequisite: Senior standing in engineering or graduate standing for non-engineering majors.\nSelection of alternative engineering design and construction solutions through study of unit cost determination, cost estimating, and financing procedures. Introduction to construction scheduling.",
    "credits": "3"
  },
  {
    "course_name": "Selected Topics in Civil Engineering",
    "dept": "CE",
    "num": "690",
    "desc": "Prerequisite: Approval of instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Responsibility in Engineering: Codes & Professionalism",
    "dept": "CE",
    "num": "703",
    "desc": "Prerequisite: Graduate standing or senior with instructor approval.\nCourse designed to help engineers, scientists, and technical managers to: understand fundamental “canons” of professional societies, establish or revitalize personal ethical standards using these canons, realize when situations are ethical dilemmas, and to develop a process to solving dilemmas. Key activities are: interviewing peers, analyzing current environment for potential challenges, developing ethics workshops, and writing individual code of ethics.",
    "credits": "3"
  },
  {
    "course_name": "Responsibility in Engineering: Leadership & Diversity",
    "dept": "CE",
    "num": "704",
    "desc": "Prerequisite: Graduate standing or instructor approval.\nCourse designed to help engineers, scientists, and technical managers to: understand leadership approaches that promote high ethical conduct, and to understand the ethical value and challenges associated with a diverse workplace. Key activities are: interviewing peers; analyzing current environment for potential challenges; developing a workshop related to ethics, leadership and diversity; and writing individual code of ethics.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Photo Interpretation",
    "dept": "CE",
    "num": "718",
    "desc": "Prerequisite: Senior standing and consent of instruction.\nPhoto interpretation techniques, types of aerial photographic film and their uses; application in land use studies, land surveying, site selection, rainfall runoff and stream flow, location of construction materials, and in the determination of soil properties; other applications.",
    "credits": "3"
  },
  {
    "course_name": "Designing with Geosynthetics",
    "dept": "CE",
    "num": "723",
    "desc": "Prerequisite: CE 522.\nHistory of geosynthetics; overview of geosynthetic functions, applications and properties; relationship between testing and applications. Designing with geotextiles, geogrids, geonets, geomembranes, geosynthetic clay liners and geocomposites.",
    "credits": "3"
  },
  {
    "course_name": "Seepage in Permeable Materials",
    "dept": "CE",
    "num": "725",
    "desc": "Prerequisite: CE 522 and CE 552.\nAnalysis of seepage; groundwater movement in slopes, embankments, dams, and earth-supporting structures; construction of flow nets; dewatering systems; filter and drain design.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Geotechnical Design",
    "dept": "CE",
    "num": "728",
    "desc": "Prerequisite: CE 528.\nAdvanced studies of soil investigations; design of retaining structures and reinforced earth walls, sheet piles, anchored bulkheads, underground conduits and tunnels; analysis and repair of failed structures.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Structural Analysis I",
    "dept": "CE",
    "num": "732",
    "desc": "Prerequisite: “C” or better in CE 537.\nPlane truss and frame analysis by direct stiffness method; equivalent nodal forces; thermal and settlement effects; stiffness by energy methods; analysis of space frames and trusses; grid structures; advanced topics.",
    "credits": "3"
  },
  {
    "course_name": "Civil Engineering Materials II",
    "dept": "CE",
    "num": "741",
    "desc": "Prerequisite: CE 641 or CHE 350.\nAdvanced study of civil engineering materials including concrete, steel and bituminous concrete.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Steel Design",
    "dept": "CE",
    "num": "742",
    "desc": "Prerequisite: CE 542.\nPlastic design of steel structures; stability problems in plastic design; design of complex steel structures.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Reinforced Concrete Theory",
    "dept": "CE",
    "num": "743",
    "desc": "Prerequisite: CE 544.\nAdvanced theories and methods of design and analysis of reinforced concrete structures.",
    "credits": "3"
  },
  {
    "course_name": "Structural Dynamics",
    "dept": "CE",
    "num": "745",
    "desc": "Prerequisite: MATH 340, ME 512, CE 537 or equivalent.\nIntroduction to fundamental concepts in structural dynamics; free and forced vibration of single and multiple degrees of freedom systems with and without damping, numerical methods for linear and non-linear dynamic analysis, and basics of the earthquake response and design of structures.",
    "credits": "3"
  },
  {
    "course_name": "Hydraulics of Open Channels",
    "dept": "CE",
    "num": "751",
    "desc": "Prerequisite: CE 552.\nProperties of open-channel flow; types of open channels; conservation of mass, momentum, and energy; critical, uniform, and gradually varied flow; design of erodible channels; rapidly varied flow.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Hydrology",
    "dept": "CE",
    "num": "752",
    "desc": "Prerequisite: CE 550.\nReview of basic principles; point and regional rainfall and flood frequency analyses; hydrologic and hydraulic flood routing; drainage and flood control facilities design; hydrologic modeling and simulation flood plain analysis and planning.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Engineering Seminar",
    "dept": "CE",
    "num": "760",
    "desc": "\nDiscussion of current advances in research and practice of environmental engineering.",
    "credits": "0"
  },
  {
    "course_name": "Water Treatment Processes",
    "dept": "CE",
    "num": "762",
    "desc": "Prerequisite: CE 565.\nPhysical and chemical process principles and their application to water treatment plant design.",
    "credits": "3"
  },
  {
    "course_name": "Wastewater Engineering: Biological Processes",
    "dept": "CE",
    "num": "766",
    "desc": "Prerequisite: CE 565.\nBiological process principles and their application to the design of wastewater treatment plants.",
    "credits": "3"
  },
  {
    "course_name": "Geoenvironmental Engineering Design",
    "dept": "CE",
    "num": "768",
    "desc": "Prerequisite: One of the following: AGRON 605, AGRON 746, BAE 690, CE 625, CE 654, CHE 531 or GEOL 611.\nA team design project in geoenvironmental engineering focused on resolving interdisciplinary issues related to containment of pollutants and remediation of soil and groundwater.",
    "credits": "3"
  },
  {
    "course_name": "Travel Demand Modeling",
    "dept": "CE",
    "num": "771",
    "desc": "Prerequisite: CE 572 or consent of instructor.\nHistorical development and current status of techniques used in urban transportation planning and travel demand forecasting; trip generation, trip distribution, mode choice, and traffic assignment.",
    "credits": "3"
  },
  {
    "course_name": "Pavement Design",
    "dept": "CE",
    "num": "774",
    "desc": "Prerequisite: “C” or better in CE 522.\nMethods of evaluating the load-carrying capacity of soil subgrade, subbase, and base courses; critical analysis of the methods of design for flexible and rigid pavements; methods of increasing the load-carrying capacity of highway and airport pavements.",
    "credits": "3"
  },
  {
    "course_name": "Traffic Engineering",
    "dept": "CE",
    "num": "775",
    "desc": "Prerequisite: “C” or better in CE 572.\nTraffic operations of roads, streets, and highways; traffic engineering studies; use of signs, signals, and pavement markings as traffic control devices; highway and intersection capacity, design and operations of traffic signals; current microcomputer models and applications.",
    "credits": "3"
  },
  {
    "course_name": "Portland Cement Concrete Pavements",
    "dept": "CE",
    "num": "777",
    "desc": "Prerequisite: CE 641.\nPortland cement concrete mix design and production. Paving operations. Saw and seal operations. Subgrade preparation. Base selection. Drainage selection, design and construction. Bonded and unbonded concrete overlays. Whitetopping and ultra-thin whitetopping. Concrete pavement restoration; quality assurance and quality control in concrete pavement construction.",
    "credits": "3"
  },
  {
    "course_name": "Land Development for Civil Engineers and Planners",
    "dept": "CE",
    "num": "786",
    "desc": "Prerequisite: CE 572 or consent of instructor.\nEngineering problems involved in site planning and design. The comprehensive planning process, zoning and subdivision regulations; design and location of streets and highways, water supply and sanitary facilities, drainage and public utilities.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Civil Engineering",
    "dept": "CE",
    "num": "790",
    "desc": "Prerequisite: Approval of instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Research in Civil Engineering",
    "dept": "CE",
    "num": "791",
    "desc": "Prerequisite: Approval of department head.\nOriginal investigation or advanced study in some field related to the practice of civil engineering.",
    "credits": "1-18"
  },
  {
    "course_name": "Materials Sampling and Testing",
    "dept": "CET",
    "num": "120",
    "desc": "\nA course in the proper use of aggregates and concrete materials (Portland cement and asphalt) in construction. Sampling and testing methods conform with current testing standards.",
    "credits": "2"
  },
  {
    "course_name": "Plane Surveying",
    "dept": "CET",
    "num": "130",
    "desc": "Prerequisite: MATH 151.\nA beginning course in the theory and practice of field measurements and notes for surveying. Emphasis is placed on accuracy and avoidance of common errors and mistakes.",
    "credits": "4"
  },
  {
    "course_name": "Problem Solving with Computer Applications",
    "dept": "CET",
    "num": "210",
    "desc": "Prerequisite: MATH 151 and CMST 108.\nIn depth preparation with computer operating systems, spreadsheets, scheduling software and Visual Basic for construction applications.",
    "credits": "2"
  },
  {
    "course_name": "Soils and Foundations",
    "dept": "CET",
    "num": "220",
    "desc": "Prerequisite: MATH 100.\nA course in the identification and classification of soils by the Unified method and the American Association of State Highway and Transportation Officials method. Routine field tests are covered and used in the laboratory.",
    "credits": "2"
  },
  {
    "course_name": "Construction Safety",
    "dept": "CET",
    "num": "222",
    "desc": "\nHow to maintain safe working areas within unsafe working conditions. Particularly the recognition and prevention of unsanitary, dangerous, or hazardous conditions to workers in the construction industry. Instruction focuses on federal safety standards related to construction.",
    "credits": "2"
  },
  {
    "course_name": "Construction Methods and Estimating",
    "dept": "CET",
    "num": "241",
    "desc": "Prerequisite: MATH 100.\nA study of the basic equipment needs, usage, costs, and quantity determinations for planning and estimating construction projects. Field trips through construction sites and visitations with inspectors assist in developing reporting procedures and inspection responsibilities.",
    "credits": "2"
  },
  {
    "course_name": "Topics in Construction Engineering Technology",
    "dept": "CET",
    "num": "299",
    "desc": "Prerequisite: Consent of instructor.\nProvides an opportunity for faculty to present construction engineering technology topics.",
    "credits": "1-18"
  },
  {
    "course_name": "Transportation Systems",
    "dept": "CET",
    "num": "312",
    "desc": "Prerequisite: CET 130.\nA study of transportation systems with emphasis on traffic operations and control, planning, design, and drainage for highways, and urban roadways.",
    "credits": "3"
  },
  {
    "course_name": "Structural Design",
    "dept": "CET",
    "num": "313",
    "desc": "Prerequisite: MET 245.\nA course combining design of components of structures in steel and reinforced concrete. Basic stress calculations and design concepts are studied for use in either a simplified design, detailing, or inspection role.",
    "credits": "3"
  },
  {
    "course_name": "Construction Materials",
    "dept": "CET",
    "num": "320",
    "desc": "Prerequisite: MET 111.\nStudy and analysis of construction materials, their properties, selection and use.",
    "credits": "2"
  },
  {
    "course_name": "Route Location Surveying",
    "dept": "CET",
    "num": "323",
    "desc": "Prerequisite: CET 130.\nA course in the geometric methods of horizontal and vertical curve alignment. In addition, transitional spirals are examined and calculated. The laboratory portion provides a grounding of these concepts in the field by actual calculation and staking of control for roads, streets, and various types of routes.",
    "credits": "3"
  },
  {
    "course_name": "Mechanical and Electrical Systems",
    "dept": "CET",
    "num": "340",
    "desc": "\nThe study of the use of mechanical and electrical systems within constructed buildings. Students develop skills related to plumbing, heating, air conditioning, wiring, power, and lighting systems.",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Systems",
    "dept": "CET",
    "num": "341",
    "desc": "Prerequisite: MATH 151 and PHYS 113. Corequisite: CET 241.\nThe way mechanical systems, including plumbing, heating, ventilation, and air conditioning are used by contractors to construct a building.",
    "credits": "3"
  },
  {
    "course_name": "Electrical Systems",
    "dept": "CET",
    "num": "342",
    "desc": "Prerequisite: MATH 151 and PHYS 113. Corequisite: CET 241.\nThe way electrical systems, including design and wiring, and power and lighting systems are used by contractors to construct a building.",
    "credits": "3"
  },
  {
    "course_name": "Site Construction",
    "dept": "CET",
    "num": "350",
    "desc": "Prerequisite: MET 111, CET 130, PHYS 113, and CMST 108.\nStudy of site construction problems and procedures, site survey and investigations, review of site plans, construction layouts, earthwork calculation, excavation/shoring methods, and computer applications.",
    "credits": "3"
  },
  {
    "course_name": "Construction Techniques and Detailing",
    "dept": "CET",
    "num": "351",
    "desc": "Prerequisite: MET 111 and CET 320.\nStudy of construction methods and procedures in the assembly of building materials.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Assembly",
    "dept": "CHE",
    "num": "015",
    "desc": "",
    "credits": "0"
  },
  {
    "course_name": "Current Topics in Chemical Engineering",
    "dept": "CHE",
    "num": "110",
    "desc": "\nRecent advances in chemical engineering and the impact of the profession on society.",
    "credits": "1"
  },
  {
    "course_name": "Chemical Process Analysis",
    "dept": "CHE",
    "num": "320",
    "desc": "Prerequisite or concurrent: CHM 230 or 250 and MATH 222.\nAn introduction to chemical engineering with emphasis on material and energy balances.",
    "credits": "3"
  },
  {
    "course_name": "Basic Concepts in Materials Science and Engineering",
    "dept": "CHE",
    "num": "354",
    "desc": "Prerequisite: CHM 210, prerequisite or corequisite: PHYS 213.\nStructure of materials with crystal structures of metals and their defects emphasized.  Two component phase diagrams, multiphase equilibrium, and the microstructures that result.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Mechanical Properties",
    "dept": "CHE",
    "num": "355",
    "desc": "Prerequisite: CHE 354.\nOverview of the mechanical properties of materials, especially metals, and the modification of these properties through changes in microstructure.  Effect of heat treatment on microstructure and mechanical properties.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Electrical Properties",
    "dept": "CHE",
    "num": "356",
    "desc": "Prerequisite: CHE 354.\nOverview of the electrical properties of materials including conductors, semiconductors, and dielectrics, and their basis in the band theory of solids.  Multiphase equilibrium and modification of properties through changes in microstructure.",
    "credits": "1"
  },
  {
    "course_name": "Computational Techniques in Chemical Engineering",
    "dept": "CHE",
    "num": "416",
    "desc": "Prerequisite: CHE 320.\nUse of computational techniques in chemical engineering.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "CHE",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research project.",
    "credits": "0-3"
  },
  {
    "course_name": "Honors Research in Chemical Engineering",
    "dept": "CHE",
    "num": "499",
    "desc": "\nIndividual research problem selected with approval of faculty advisor.  Open to students in the College of Engineering honors program. A report is presented orally and in writing during the last semester.",
    "credits": "1-6"
  },
  {
    "course_name": "Chemical Engineering Thermodynamics I",
    "dept": "CHE",
    "num": "520",
    "desc": "Prerequisite: A grade of C or better in CHE 320.\nA study of the first and second laws of thermodynamics, real gases, heat of solution and reaction.",
    "credits": "2"
  },
  {
    "course_name": "Chemical Engineering Thermodynamics II",
    "dept": "CHE",
    "num": "521",
    "desc": "Prerequisite or concurrent enrollment: CHE 416.  Prerequisite: CHE 520.\nA continuation of the study of the second law, thermodynamic analysis of processes, phase equilibrium, chemical reaction equilibrium.",
    "credits": "3"
  },
  {
    "course_name": "Transport Phenomena I",
    "dept": "CHE",
    "num": "530",
    "desc": "Prerequisite: A grade of C or better in CHE 320 and MATH 340.\nA unified treatment of the basic principles of momentum, energy, and mass transport.",
    "credits": "3"
  },
  {
    "course_name": "Transport Phenomena II",
    "dept": "CHE",
    "num": "531",
    "desc": "Prerequisite or concurrent enrollment: CHE 416.  Prerequisite: CHE 530.\nContinuation of Transport Phenomena I with special emphasis on mass transfer.",
    "credits": "3"
  },
  {
    "course_name": "Transport Phenomena Laboratory",
    "dept": "CHE",
    "num": "535",
    "desc": "Prerequisite or concurrent enrollment: CHE 531.\nLaboratory experiments in momentum, heat, and mass transfer.",
    "credits": "3"
  },
  {
    "course_name": "Unit Operations Laboratory",
    "dept": "CHE",
    "num": "542",
    "desc": "Prerequisite: CHE 535, 550 and 560.  Prerequisite or concurrent enrollment: CHE 561.\nLaboratory experiments on classical unit operations, e.g., distillation, absorption, extraction, and on chemical kinetics and process dynamics.",
    "credits": "3"
  },
  {
    "course_name": "Chemical Reaction Engineering",
    "dept": "CHE",
    "num": "550",
    "desc": "Prerequisite: CHE 521 and 531.\nApplied chemical kinetics and catalysis including the analysis and design of tubular, packed bed, stirred tank, and fluidized bed chemical reactors.",
    "credits": "3"
  },
  {
    "course_name": "Separational Process Design",
    "dept": "CHE",
    "num": "560",
    "desc": "Prerequisite: CHE 521 and 531.\nDevelopment of the basic theory and design of separational processes such as distillation, gas absorption, liquid extraction, adsorption, and ion exchange.",
    "credits": "3"
  },
  {
    "course_name": "Chemical Process Dynamics and Control",
    "dept": "CHE",
    "num": "561",
    "desc": "Prerequisite: CHE 550 and 416.\nA study of the unsteady state behavior and control of chemical processes.",
    "credits": "3"
  },
  {
    "course_name": "Health and Safety in Chemical Engineering",
    "dept": "CHE",
    "num": "565",
    "desc": "Corequisite: CHE 570.\nFundamentals of chemical process safety, particularly as they apply to process design. Topics will include toxicology and industrial hygiene, fires and explosions, runaway reactions, relief systems, process hazards identification, risk assessment, and inherently safer design.",
    "credits": "3"
  },
  {
    "course_name": "Chemical Engineering Systems Design I",
    "dept": "CHE",
    "num": "570",
    "desc": "Corequisite: CHE 550 and 560.\nBasic concepts of process economics and process optimization with application to the synthesis and design of chemical processing systems.",
    "credits": "3"
  },
  {
    "course_name": "Chemical Engineering Systems Design II",
    "dept": "CHE",
    "num": "571",
    "desc": "Prerequisite: CHE 550, 560, and 570.  Corequisite: CHE 561.\nThe solution of comprehensive systems design problems.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Chemical Engineering or Materials Science",
    "dept": "CHE",
    "num": "580",
    "desc": "Prerequisite: Approval of department head.\nAn introduction to chemical engineering research.",
    "credits": "1-18"
  },
  {
    "course_name": "Bioseparations",
    "dept": "CHE",
    "num": "626",
    "desc": "Prerequisite: CHE 531 or BAE 545.\nStudy of separations important in food and biochemical engineering such as leaching, extraction, expression, absorption, ion exchange, filtration, centrifugation, membrane separation, and chromatographic separations.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Conversion of Biorenewable Resources",
    "dept": "CHE",
    "num": "642",
    "desc": "Prerequisite: MATH 220 and CHM 230.\nAn introduction to the conversion of biorenewable resources into biobased products and biofuels.",
    "credits": "3"
  },
  {
    "course_name": "Life Cycle Assessment",
    "dept": "CHE",
    "num": "643",
    "desc": "Prerequisite: MATH 220 and CHM 230.\nExamination of the process and methodologies associated with life cycle analysis. Application of the methods developed in the course to a project to gain experience in defining and quantifying uncertainty associated with human perturbation, management and utilization of biofuels and other complex processes.",
    "credits": "3"
  },
  {
    "course_name": "Hazardous Waste Engineering Seminar",
    "dept": "CHE",
    "num": "650",
    "desc": "Prerequisite: CHM 230.\nTopics in hazardous materials management and control, waste reduction and minimization, hazardous substance tracking, and hazardous waste engineering.",
    "credits": "1"
  },
  {
    "course_name": "Polymer Science and Engineering",
    "dept": "CHE",
    "num": "656",
    "desc": "Prerequisite: CHM 531.\nAn introduction to polymeric materials, including chemistry, structure and formation; physical states and transitions; and, basic physical and mechanical properties.",
    "credits": "3"
  },
  {
    "course_name": "Processing of Materials for Solid State Devices",
    "dept": "CHE",
    "num": "661",
    "desc": "Prerequisite: CHE 350 or 352.\nStructure, properties and processing of materials for solid state devices. Crystal growth, epitaxy, oxidation, diffusion, lithography, and etching as applied to device fabrication.",
    "credits": "3"
  },
  {
    "course_name": "Environmental and Ecological Risk Assessment",
    "dept": "CHE",
    "num": "663",
    "desc": "Prerequisite: MATH 221 and BIOL 455.\nExamination of processes and methodologies associated with human environmental and ecological risk assessments. Application of the methods learned to a project to gain experience in defining and quantifying uncertainty associated with human perturbation, management and restoration of environmental and ecological processes.",
    "credits": "3"
  },
  {
    "course_name": "Sustainability Seminar",
    "dept": "CHE",
    "num": "670",
    "desc": "Prerequisite: CHM 230.\nTopics in environmental sustainability, green engineering, life cycle analysis, sustainable development, and sustainability science.",
    "credits": "1"
  },
  {
    "course_name": "Engineering Materials II",
    "dept": "CHE",
    "num": "681",
    "desc": "Prerequisite: CHE 350 or 352.\nThe structure and bonding in crystalline and amorphous materials; crystallography; thermodynamic stability in materials; equilibrium diagrams and the phase rule; rate theory and kinetics of solid-state transformations; mechanical behavior of engineering materials; dislocations; failure mechanisms.",
    "credits": "3"
  },
  {
    "course_name": "Surface Phenomena",
    "dept": "CHE",
    "num": "682",
    "desc": "Prerequisite: CHE 520, CHM 585, ME 513, or PHYS 664.\nPrinciples and applications of interfacial phenomena, including capillarity, colloids, porosity, adsorption, and catalysis.",
    "credits": "3"
  },
  {
    "course_name": "Biochemical Engineering",
    "dept": "CHE",
    "num": "715",
    "desc": "Prerequisite or concurrent enrollment: CHE 550.\nThe analysis and design of biochemical processing systems with emphasis on fermentation kinetics, continuous fermentations, aeration, agitation, scale up, sterilization, and control.",
    "credits": "3"
  },
  {
    "course_name": "Biotransport Phenomena",
    "dept": "CHE",
    "num": "725",
    "desc": "Prerequisite: CHE 530.\nPrinciples of transport phenomena applied to biological and physiological processes. Membrane transport processes, circulatory system transport phenomena, transport and distribution of drugs.",
    "credits": "3"
  },
  {
    "course_name": "Chemical Engineering Analysis I",
    "dept": "CHE",
    "num": "735",
    "desc": "Prerequisite: CHE 530.\nThe mathematical formulation of problems in chemical engineering using partial differential equations, vector and tensor notation. Solution of these problems by analytical and numerical methods.",
    "credits": "3"
  },
  {
    "course_name": "Air Quality Seminar",
    "dept": "CHE",
    "num": "750",
    "desc": "Prerequisite: CHEM 230.\nTopics in air quality including health effects, toxicology, measurement, characterization, modeling, management, and control.",
    "credits": "1"
  },
  {
    "course_name": "Chinese I",
    "dept": "CHINE",
    "num": "101",
    "desc": "\nIntroduction to the fundamental linguistics and cultural characteristics of the Chinese language and its writing systems.",
    "credits": "4"
  },
  {
    "course_name": "Chinese II",
    "dept": "CHINE",
    "num": "102",
    "desc": "Prerequisite: CHINE 101.\nContinuation of Chinese I.  Development of functional skills for familiar situations.",
    "credits": "4"
  },
  {
    "course_name": "Chinese III",
    "dept": "CHINE",
    "num": "300",
    "desc": "Prerequisite: CHINE 102.\nContinuation of CHINE 102;  further development of four skills of listening, speaking, reading, and writing; intensive practice of spoken and written Chinese.",
    "credits": "5"
  },
  {
    "course_name": "Chinese IV",
    "dept": "CHINE",
    "num": "301",
    "desc": "Prerequisite: CHINE 201.\nContinuation of Chinese III.  Presentation of more advanced elements of the Chinese language, with intensive practice of spoken and written Chinese.",
    "credits": "5"
  },
  {
    "course_name": "Chinese V",
    "dept": "CHINE",
    "num": "501",
    "desc": "Prerequisite: CHINE 202 or equivalent.\nDevelopment of communication skills through application activities. Enhancement of vocabulary and intensive practice in grammatical structures and their usage.",
    "credits": "4"
  },
  {
    "course_name": "Chinese VI",
    "dept": "CHINE",
    "num": "502",
    "desc": "Prerequisite: CHINE 501 or equivalent.\nContinuation of Chinese V.  Development of functional skills for general situations. Further enhancement of vocabulary and intensive practice in grammatical structures and their usage.",
    "credits": "4"
  },
  {
    "course_name": "Special Studies in Chinese",
    "dept": "CHINE",
    "num": "599",
    "desc": "Prerequisite: Consent of department head and instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "General Chemistry",
    "dept": "CHM",
    "num": "110",
    "desc": "Prerequisite: MATH 010 or at least one year of high school algebra.\nPrinciples, laws, and theories of chemistry; important metallic and nonmetallic substances.",
    "credits": "3"
  },
  {
    "course_name": "General Chemistry Laboratory",
    "dept": "CHM",
    "num": "111",
    "desc": "Prerequisite: CHM 110 or concurrent enrollment.\nA laboratory course to supplement the material of CHM 110.",
    "credits": "1"
  },
  {
    "course_name": "Frontiers in Chemistry",
    "dept": "CHM",
    "num": "200",
    "desc": "\nAn undergraduate seminar designed to introduce students to research being carried out within the Kansas State University Chemistry Department and to offer perspectives on other issues of interest to chemistry majors and those considering chemistry as a major.",
    "credits": "0"
  },
  {
    "course_name": "Chemistry I",
    "dept": "CHM",
    "num": "210",
    "desc": "Prerequisite: One year of high school chemistry and MATH 100 (or two years of high school algebra).\nFirst course of a two-semester study of the principles of chemistry and the properties of the elements and their compounds.",
    "credits": "4"
  },
  {
    "course_name": "Chemistry I Recitation",
    "dept": "CHM",
    "num": "211",
    "desc": "\nAn optional recitation class that requires concurrent enrollment in CHM 210 Chemistry I. The objective is the development of skills for solving chemical problems.",
    "credits": "1"
  },
  {
    "course_name": "Honors Chemistry I",
    "dept": "CHM",
    "num": "220",
    "desc": "Prerequisite: One year of high school chemistry and MATH 100 (or two years of high school algebra); ACT Composite of 26 or higher.\nFirst course of a two-semester study of chemical principles.  Intended for students with a strong background in chemistry.",
    "credits": "5"
  },
  {
    "course_name": "Chemistry II",
    "dept": "CHM",
    "num": "230",
    "desc": "Prerequisite: CHM 210 or CHM 220.\nSecond course of a two-semester study of the principles of chemistry and the properties of the elements and their compounds.",
    "credits": "4"
  },
  {
    "course_name": "Chemistry II Recitation",
    "dept": "CHM",
    "num": "231",
    "desc": "\nAn optional recitation class that requires concurrent enrollment in CHM 230 Chemistry II. The objective is the development of skills for solving chemical problems.",
    "credits": "1"
  },
  {
    "course_name": "Honors Chemistry II",
    "dept": "CHM",
    "num": "250",
    "desc": "Prerequisite: CHM 220.\nContinuation of CHM 220, covering the principles of chemistry.",
    "credits": "5"
  },
  {
    "course_name": "Environmental Science: A Chemistry Perspective",
    "dept": "CHM",
    "num": "315",
    "desc": "Prerequisite: CHM 230 or 250.\nAn analysis of important technological developments and their impact on society and on the earth’s environment; ethical issues raised by technological advances. History, matter and energy, ecosystems, population issues, air pollution, water pollution, hazardous substances, environmental policies, and decision making are discussed.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Science: A Chemistry Perspective Laboratory",
    "dept": "CHM",
    "num": "316",
    "desc": "Corequisite: CHM 315.\nA laboratory course to supplement the material of CHM 315.",
    "credits": "1"
  },
  {
    "course_name": "General Organic Chemistry",
    "dept": "CHM",
    "num": "350",
    "desc": "Prerequisite: CHM 230 or CHM 250.\nA survey of types of organic reactions important to biological science, including pre-veterinary and certain agriculture and health and human sciences programs.",
    "credits": "3"
  },
  {
    "course_name": "General Organic Chemistry Laboratory",
    "dept": "CHM",
    "num": "351",
    "desc": "Prerequisite or concurrent enrollment: CHM 350.",
    "credits": "2"
  },
  {
    "course_name": "Chemical Analysis",
    "dept": "CHM",
    "num": "371",
    "desc": "Prerequisite: CHM 230.\nPrinciples of chemical equilibria and quantitative analysis: gravimetric, titrimetric, spectrophotometric, electroanalytical, and separations methods.",
    "credits": "4"
  },
  {
    "course_name": "Forensic Chemistry and Criminalistics",
    "dept": "CHM",
    "num": "372",
    "desc": "Prerequisite: CHM 110.\nIntroduction of forensic science and chemistry. Collecting physical evidence at a crime scene and examining it in the laboratory. Soils, glass, hair, fibers, drugs, explosives, poisons, castings, inks, and arson and rape situations are investigated.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar",
    "dept": "CHM",
    "num": "399",
    "desc": "\nOpen to students in the arts and sciences honors program.",
    "credits": "3"
  },
  {
    "course_name": "Research in Undergraduate Chemistry",
    "dept": "CHM",
    "num": "497",
    "desc": "Prerequisite: Consent of instructor.\nUndergraduate research in the chemical sciences.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "CHM",
    "num": "498",
    "desc": "\nOpen only to non-Chemistry Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Undergraduate Chemistry",
    "dept": "CHM",
    "num": "499",
    "desc": "Prerequisite: Consent of instructor.\nProblems may include classroom and/or lab work.",
    "credits": "1-18"
  },
  {
    "course_name": "General Physical Chemistry",
    "dept": "CHM",
    "num": "500",
    "desc": "Prerequisite: CHM 230 or CHM 250 and MATH 210 or MATH 220, and PHYS 114 or PHYS 213.\nElementary principles of physical chemistry.",
    "credits": "3"
  },
  {
    "course_name": "Organic Chemistry I",
    "dept": "CHM",
    "num": "531",
    "desc": "Prerequisite: CHM 230 or 250.\nTopics to be covered include fundamental concepts in organic chemistry such as hybridization, molecular orbitals, structure and bonding, acids and bases, kinetics and thermodynamics, stereochemistry and chirality, and conformational analysis. The basic knowledge will be used to study the syntheses, reactions, and mechanisms of functional groups such as alkanes, haloalkanes, and alkenes. Structural determination using infrared spectroscopy and nuclear magnetic resonance will also be included.",
    "credits": "3"
  },
  {
    "course_name": "Organic Chemistry Laboratory",
    "dept": "CHM",
    "num": "532",
    "desc": "Prerequisite: Previous or concurrent enrollment in CHM 531.\nA laboratory exploring the synthesis and characterization of organic compounds.",
    "credits": "2"
  },
  {
    "course_name": "Chemical Separations",
    "dept": "CHM",
    "num": "545",
    "desc": "Prerequisite: CHM 250 or 371, CHM 532 and CHM 550.\nPrinciples of modern separation techniques.",
    "credits": "2"
  },
  {
    "course_name": "Organic Chemistry II",
    "dept": "CHM",
    "num": "550",
    "desc": "Prerequisite: CHM 531.\nA continuation of Organic Chemistry I (CHM 531). CHM 550 represents the second semester of a two-semester survey of organic chemistry. Topics to be discussed include syntheses, reactions, and mechanisms of alkynes, aldehydes and ketones, carboxylic acids and their derivatives, amines, benzene and its derivatives, organometallic chemistry, conjugated unsaturated systems and pericyclic reactions, polymers, carbohydrates, lipids, amino acids, proteins, and nucleic acids. Structural identification will be studied using various spectroscopic methods.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Organic Laboratory",
    "dept": "CHM",
    "num": "551",
    "desc": "Prerequisite: CHM 550 and CHM 532.",
    "credits": "2"
  },
  {
    "course_name": "Instrumental Methods of Analysis",
    "dept": "CHM",
    "num": "566",
    "desc": "Prerequisite: CHM 250 or 371; CHM 531; and CHM 500 or CHM 585.\nIntroduction to theory and practice of electrochemical methods, molecular and atomic spectroscopy, surface science, mass spectrometry, separation methods, and electronics in analytical chemistry.",
    "credits": "3"
  },
  {
    "course_name": "Physical Chemistry I",
    "dept": "CHM",
    "num": "585",
    "desc": "Prerequisite: CHM 350 or CHM 531, MATH 222, and PHYS 214.\nElementary chemical thermodynamics and kinetic theory of gases.",
    "credits": "3"
  },
  {
    "course_name": "Physical Chemistry II",
    "dept": "CHM",
    "num": "595",
    "desc": "Prerequisite: CHM 350 or CHM 531, MATH 222, and PHYS 214.\nElementary quantum chemistry, spectroscopy, statistical thermodynamics, and chemical kinetics.",
    "credits": "3"
  },
  {
    "course_name": "Physical Methods Laboratory",
    "dept": "CHM",
    "num": "596",
    "desc": "Prerequisite: CHM 566 and MATH 221 and PHYS 114 or PHYS 214.\nExperiments that relate to physical and instrumental methods.",
    "credits": "1-2"
  },
  {
    "course_name": "Senior Thesis Research",
    "dept": "CHM",
    "num": "599",
    "desc": "Prerequisite: Consent of instructor.\nA final written report and oral presentation are required.",
    "credits": "1-3"
  },
  {
    "course_name": "Scientific Glassblowing",
    "dept": "CHM",
    "num": "600",
    "desc": "Prerequisite: Senior or graduate standing in physical sciences.\nThe basic techniques of bending, sealing, and blowing glass used to fabricate scientific glassware.",
    "credits": "1"
  },
  {
    "course_name": "Safe Chemical Laboratory Practices",
    "dept": "CHM",
    "num": "601",
    "desc": "Prerequisite: Consent of instructor.\nA general safety course for persons working or teaching in a chemical laboratory.",
    "credits": "1"
  },
  {
    "course_name": "History of Chemistry",
    "dept": "CHM",
    "num": "650",
    "desc": "Prerequisite: CHM 230 or CHM 250.\nTraces the beginnings of chemistry from 3500 B.C. to 1920 A.D. Early metallurgy, Greek thought about atoms, alchemy, atomic theory, discovery of gases; definition of elements, chemical bonds, organic, inorganic, and physical chemistry.",
    "credits": "2"
  },
  {
    "course_name": "Inorganic Techniques",
    "dept": "CHM",
    "num": "657",
    "desc": "Prerequisite: CHM 585.\nThe preparation, characterization, and study of transition metal, main group, and organometallic compounds using techniques commonly encountered in industrial and academic research.",
    "credits": "1-2"
  },
  {
    "course_name": "Practicum in Teaching Chemistry",
    "dept": "CHM",
    "num": "700",
    "desc": "Prerequisite: Senior standing in chemistry or consent of instructor.\nPrinciples and methods of instruction in laboratories and recitation classes in chemistry, including one semester of supervised experience as an instructor in a chemical laboratory. This is a required course of all teaching assistants in the Department of Chemistry.",
    "credits": "1"
  },
  {
    "course_name": "Inorganic Chemistry I",
    "dept": "CHM",
    "num": "711",
    "desc": "Prerequisite: CHM 550.\nAtomic and molecular structure, bonding concepts used in the practice of inorganic chemistry. Applications of symmetry and group theory to structure, bonding, and spectra.",
    "credits": "3"
  },
  {
    "course_name": "Inorganic Chemistry II",
    "dept": "CHM",
    "num": "712",
    "desc": "Prerequisite: CHM 550, CHM 595.\nStructure, reactivity, and mechanistic aspects of main group and transition metal complexes. Organometallic reactions, catalysis, and bioinorganic chemistry.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Organic Chemistry",
    "dept": "CHM",
    "num": "752",
    "desc": "Prerequisite: CHM 532, CHM 550 and CHM 595.\nAdvanced study of organic compounds and fundamental types of reactions.",
    "credits": "3"
  },
  {
    "course_name": "Case Studies in Green Chemistry",
    "dept": "CHM",
    "num": "766",
    "desc": "Prerequisite: CHM 350 or 531, or graduate standing in chemistry or chemical engineering, or by consent of instructor.\nThis is an interdisciplinary course that looks at concepts and issues in green chemistry by examining case studies in which polluting processes have been transformed to reduce their environmental impact. Focus will be on understanding the chemistry involved and the green principles that have been applied.",
    "credits": "2"
  },
  {
    "course_name": "Practical NMR Spectroscopy",
    "dept": "CHM",
    "num": "777",
    "desc": "Prerequisite: Senior or graduate standing in the physical sciences, or by consent of the instructor.\nFundamental aspects of 1D and 2D nuclear magnetic resonance (NMR) spectroscopy, as applied to the Chemistry Department’s Varian 200- and 400-MHz spectrometers.",
    "credits": "1"
  },
  {
    "course_name": "Problems in Chemistry",
    "dept": "CHM",
    "num": "799",
    "desc": "Prerequisite: Consent of instructor.\nProblems may include classroom or laboratory work. Not for thesis research.",
    "credits": "1-18"
  },
  {
    "course_name": "Undergraduate Seminar",
    "dept": "CIS",
    "num": "015",
    "desc": "\nPresentation of professional problems and practices by students, faculty, and industry professionals associated with computing and information sciences.",
    "credits": "0"
  },
  {
    "course_name": "Computer Science Professional Development Seminar",
    "dept": "CIS",
    "num": "018",
    "desc": "Prerequisite: Admission to the Computer Science professional program.\nParticipation in various professional development activities. Credit in this course is required each semester a student is in the Computer Science professional program.",
    "credits": "0"
  },
  {
    "course_name": "CIS Scholars Seminar",
    "dept": "CIS",
    "num": "090",
    "desc": "Prerequisite: Admission into the CIS Scholars Program.\nPresentation of professional problems and practices by students, faculty, and professionals associated with computing science.",
    "credits": "0"
  },
  {
    "course_name": "Introduction to Computing Systems",
    "dept": "CIS",
    "num": "101",
    "desc": "\nIntroduction to computer hardware, securing your system, networking, understanding application and system software, and effective use of the Internet as a resource including website evaluation and use of search tool and techniques.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Spreadsheet Applications",
    "dept": "CIS",
    "num": "102",
    "desc": "\nDesigning, building, modifying and formatting spreadsheets. Use of formulas, functions and charts. Editing document properties and printing. Using large spreadsheets as management, decision and goal seeking tools.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Database Applications",
    "dept": "CIS",
    "num": "103",
    "desc": "\nDesign, create, modify, and maintain relational databases. Creating and modifying tables, relationships, queries, and forms. Add and modify data to the tables. Database backup and recovery. Search, sort and query database. Database maintenance.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Word Processing Applications",
    "dept": "CIS",
    "num": "104",
    "desc": "\nBasic features of word processing that include creating, formatting, and editing a document. Inserting and formatting pictures within a document. Revise, update, and rearrange text. Changing document properties and printing the document. Creating a research paper and a business letter.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Computer Programming",
    "dept": "CIS",
    "num": "111",
    "desc": "Prerequisite: MATH 100.  Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nIntroduction to programming. Principles and applications of programming fundamentals: state, control structures, methods, and arrays. Programming projects.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computing Science",
    "dept": "CIS",
    "num": "115",
    "desc": "\nA survey of the discipline of Computing Science and its interaction with other disciplines, incorporating historical development, theories, and tools of Computing Science (algorithm design and programming). Topics include: mechanical computers, digital computers, bioinformatics, microcontrollers, robotics, security, scientific computing, simulation, and web technologies.",
    "credits": "3"
  },
  {
    "course_name": "Web Page Development",
    "dept": "CIS",
    "num": "125",
    "desc": "Prerequisite or concurrent enrollment: CIS 115.\nThe Internet, web browsers, and web-page-development technology: web-page design and implementation with Hypertext Markup Language (HTML), and CSS. Integration of program script into web pages. Introduction to graphics design, animation, and server utilization.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Seminar in Computing and Information Sciences",
    "dept": "CIS",
    "num": "190",
    "desc": "\nTopics of special interest in computing and information sciences.",
    "credits": "1-3"
  },
  {
    "course_name": "Programming Fundamentals",
    "dept": "CIS",
    "num": "200",
    "desc": "Prerequisite: CIS 115 or ECE 241.\nPrinciples of algorithm design and their application to procedural programming: state, control structures, methods. Patterns of conditional and iterative control structure.  Program testing. Introduction to arrays, classes, and objects.  Programming projects.",
    "credits": "4"
  },
  {
    "course_name": "C Programming for Engineers",
    "dept": "CIS",
    "num": "209",
    "desc": "Prerequisite: MATH 220. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nApplication of computers to engineering problems. Abstraction and problem solving; algorithms; control structures; input/output; functions; arrays and array processing.",
    "credits": "3"
  },
  {
    "course_name": "Data and Program Structures",
    "dept": "CIS",
    "num": "300",
    "desc": "Prerequisite: CIS 200 and either MATH 205 or MATH 220.\nA study of common data and program structures together with associated algorithms. Topics include interfaces, design patterns, arrays, stacks, queues, lists, trees, hash tables, recursion, binary search, and tree traversals. Experience with both use and implementation of these structures and algorithms using a modern programming language. Discussion of tradeoffs involving performance and software maintainability.",
    "credits": "3"
  },
  {
    "course_name": "Logical Foundations of Programming",
    "dept": "CIS",
    "num": "301",
    "desc": "Prerequisite: CIS 200. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nLogical formalisms used to model and reason about computer systems. Propositional and predicate logic, syntax, semantics, and proof theory; soundness and completeness issues. Mathematical induction. Program verification: invariants and program logics.",
    "credits": "3"
  },
  {
    "course_name": "C Language Laboratory",
    "dept": "CIS",
    "num": "308",
    "desc": "Prerequisite: CIS 300. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nFundamentals of programming in C.",
    "credits": "1"
  },
  {
    "course_name": "Cyber Defense Basics",
    "dept": "CIS",
    "num": "351",
    "desc": "\nKnowledge and skills needed to administer and defend computer networks and systems. Topics include the basics of computer networks, intelligence gathering, network scanning and sniffing, password security and cracking, vulnerability exploitation, distributed denial of service, logging and auditing, and wireless network security and cracking. Practice using an isolated computing network.",
    "credits": "1"
  },
  {
    "course_name": "Honors Seminar in Computer Science",
    "dept": "CIS",
    "num": "397",
    "desc": "",
    "credits": "1-3"
  },
  {
    "course_name": "Object-Oriented Design, Implementation, and Testing",
    "dept": "CIS",
    "num": "400",
    "desc": "Prerequisite: CIS 300.\nA study of concepts and techniques used to produce quality software programs. Object-oriented concepts, models, execution environments, design and testing techniques. Extensive application of these concepts and techniques to the development of non-trivial software programs.",
    "credits": "3"
  },
  {
    "course_name": "Ethics and Conduct for Computing Professionals",
    "dept": "CIS",
    "num": "415",
    "desc": "Prerequisite: CIS 300 and junior standing. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nA study of the ethical issues raised by computing technologies and the impact on society. Exploration of how one might justify actions in regard to ethical dilemmas within the fields of technology, computer science, information security, and artificial intelligence. Other topics include an examination of terminology used, Profession Codes of Conduct for computer science professionals, ethics of software development, and ethical issues relating to privacy and intellectual property in cyberspace.",
    "credits": "3"
  },
  {
    "course_name": "Computer Architecture and Operations",
    "dept": "CIS",
    "num": "450",
    "desc": "Prerequisite: ECE 241 and CIS 308. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nIntroduction to modern computer architectures: register transfer abstraction, addressing modes, basic operations (data transfer, arithmetic/logic, and control operations). Basic Operating System concepts and operations. Understanding relationships of higher-level language constructs to corresponding assembly instruction sequences generated by compilers. Introduction to interrupts and low-level I/O operations.",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Computer Science",
    "dept": "CIS",
    "num": "490",
    "desc": "Prerequisite: Varies with the announced topic.\nCurrent topics in computer science.",
    "credits": "2-4"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "CIS",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Honors Research/Thesis",
    "dept": "CIS",
    "num": "499",
    "desc": "\nIndividual research problem selected with approval of faculty advisor. A report/thesis is presented orally and in writing during the last semester.",
    "credits": "2-4"
  },
  {
    "course_name": "Software Architecture and Design",
    "dept": "CIS",
    "num": "501",
    "desc": "Prerequisite: CIS 400.  Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nPrinciples and patterns for design and structure of software, development of object-oriented models, examples of software architecture.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Programming Languages",
    "dept": "CIS",
    "num": "505",
    "desc": "Prerequisite: CIS 300, CIS 301. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nHistory, programming language concepts including type, scope and extent, abstraction mechanisms and control; programming paradigms, including one or more of logic, functional, and object-oriented programming, and programming languages supporting the selected paradigms; interpreters, compilers and virtual machines for the selected languages; storage management and garbage collection; type checking and type inference.",
    "credits": "3"
  },
  {
    "course_name": "Operating Systems I",
    "dept": "CIS",
    "num": "520",
    "desc": "Prerequisite: CIS 450 or ECE 431; CIS 308, and CIS 400 or CIS 501. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nOperating systems concepts, services, and implementation: interrupt processing, processes, concurrency, deadlocks, resource scheduling and system structure; resource management: real and virtual storage, input/output systems, disk scheduling and file systems; design and construction of concurrent programs.",
    "credits": "3"
  },
  {
    "course_name": "Real-Time Programming Laboratory",
    "dept": "CIS",
    "num": "521",
    "desc": "Prerequisite: ECE 241 and CIS 350, concurrent enrollment CIS 520. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nProject-oriented introduction to asynchronous processes and related systems software: device drivers, event-driven operations, hierarchical and time-sliced process scheduling, spooling operations, interjob and intermachine communications. Projects will be built on a single-use environment.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Data Structures",
    "dept": "CIS",
    "num": "522",
    "desc": "Prerequisite: C, or C++ programming.\nIntroduction to basic data structures such as stacks, queues, lists, and priority queues, and algorithmic techniques for sorting, searching and hashing. Emphasis on modularity and reuse. Introduction to the concept of object-oriented design and interface specifications.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Concurrent Programming",
    "dept": "CIS",
    "num": "523",
    "desc": "Prerequisite: C, or C++ programming and CIS 300 or CIS 522. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nIntroduction to concurrent programming techniques based on message passing primitives (send/receive) and shared memory (semaphore based P/V operations and monitor-based wait/signal operations).",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Network Programming",
    "dept": "CIS",
    "num": "525",
    "desc": "Prerequisite: CIS 300 and either CIS 209 or CIS 308.\nBasic inter-process communication and network programming concepts including client-server and peer-to-peer, communication protocol use and specification, reliable and secure communication, and network applications including web technologies, electronic mail, and file transfer with a focus on application and implementation.",
    "credits": "3"
  },
  {
    "course_name": "Web Application Development",
    "dept": "CIS",
    "num": "526",
    "desc": "Prerequisite: CIS 501 and either CMST 135 or equivalent experience in HTML, CSS, and JavaScript. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nFundamental principles and best practices of web development, user interface design, web API design, advanced web interfaces, web development frameworks, single-page web applications, web standards and accessibility issues.",
    "credits": "3"
  },
  {
    "course_name": "Enterprise Systems Administration",
    "dept": "CIS",
    "num": "527",
    "desc": "Prerequisite: CIS 300.\nAdministration of the Linux operating system, including installation, configuration, distributed file systems, firewalls and security, shell scripting, and user account management.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Artificial Intelligence",
    "dept": "CIS",
    "num": "530",
    "desc": "Prerequisite: CIS 300, CIS 301 and MATH 312 or 510.  Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nFundamental background in intelligent systems for undergraduate students. Intelligent agents, problem-solving, uninformed and informed (heuristic) search, game tree search, foundations of knowledge representation and reasoning using logic and probability, and a first introduction to planning and machine learning. AI topics include the problem areas of natural language processing (NLP) and perception and methodologies such as artificial neural networks and genetic and evolutionary computation. Applications to practical design and development of intelligent systems will be emphasized, leading to individual projects on current topics and applications in AI.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Programming Techniques for Data Science and Analytics",
    "dept": "CIS",
    "num": "531",
    "desc": "Prerequisite: Either CIS 200, CIS 209, or CC 210; and either STAT 325 or STAT 510. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nIntroduction to programming techniques for working with big data. Survey of programming concepts that underlie the MapReduce architecture, their implementation, and specific tools for data integration and data transformation. Basic databases and query processing in the context of real-world problems.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computer Graphics",
    "dept": "CIS",
    "num": "536",
    "desc": "Prerequisite: CIS 308 and either MATH 205 or MATH 220. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nIntroduction to computer graphics for undergraduate students. Mathematical foundations (e.g., linear, affine, and projective transformations) and fundamental topics in realistic rendering: view normalization, clipping and culling, scan conversion of lines and polygons, shading and illumination, texture mapping, user interfaces, picking, and collision handling. Intermediate topics include shaders, procedural textures, particle systems, basics of animation, fractals, color theory, and ray tracing.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Software Design and Development",
    "dept": "CIS",
    "num": "544",
    "desc": "Prerequisite: CIS 501.  Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nAdvanced concepts and practicum in object-oriented analysis, modeling, design, implementation, testing, and use of CASE tools; relationships among structural, static, and dynamic models; relationship among conceptual, system, and implementation models.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Computer and Information Security",
    "dept": "CIS",
    "num": "551",
    "desc": "Prerequisite: CIS 450 or CIS 520.  Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nAn introduction to computer and information security, including common attack techniques, application of cryptography in security, authentication and authorization, network security, enterprise network defense, web security, and analysis of design flaws that render a system vulnerable. Course projects provide hands-on experience on both the defense and offense aspects in cyberspace.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Cryptography",
    "dept": "CIS",
    "num": "553",
    "desc": "Prerequisite: CIS 300, MATH 510.  Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nIntroduction to the fundamentals of cryptography, including mathematical background, classical ciphers, public key encryption, block and stream ciphers, cryptographic hash functions, digital signatures, common attacks, and basic security protocols.",
    "credits": "3"
  },
  {
    "course_name": "Database System Concepts",
    "dept": "CIS",
    "num": "560",
    "desc": "Prerequisite: CIS 300 and CIS 301. Prerequisite or concurrent: MATH 312 or 510. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nConcepts, approaches, and techniques in database management. Representation of information as data, data storage techniques, foundations of logical data models, data retrieval, database design, transaction management, integrity and security.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Formal Language Theory",
    "dept": "CIS",
    "num": "570",
    "desc": "Prerequisite: MATH 510. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nFormal languages, automata, regular expressions, grammars, introduction to computability theory. Reading and writing informal mathematical proofs pertaining to these topics.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Algorithm Analysis",
    "dept": "CIS",
    "num": "575",
    "desc": "Prerequisite: CIS 300, CIS 301, and MATH 510.\nAn introduction to mathematical analysis of time- and space-complexity of algorithms, including worst-case, average-case, and amortized complexity. An examination of various algorithmic designs, such as greedy algorithms, divide-and-conquer algorithms, and dynamic programming algorithms. Techniques for proving correctness of algorithms.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Game Programming",
    "dept": "CIS",
    "num": "580",
    "desc": "Prerequisite: CIS 501 and MATH 221.\nFundamental principles of programming games. Foundational game algorithms and data structures. Two-dimensional graphics and game world simulation. Development for multiple platforms. Utilization of game programming libraries. Design of multiple games incorporating topics covered.",
    "credits": "3"
  },
  {
    "course_name": "Game Engine Design",
    "dept": "CIS",
    "num": "585",
    "desc": "Prerequisite: CIS 580 and MATH 551.\nCurrent practices of game engine development. The game engine as a soft real-time multi-agent simulation.  Three-dimensional graphics and animation techniques, scene management, physics simulation, event systems, resource management, and network game architectures.  Design and prototyping of a general use game engine.",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Computer Science",
    "dept": "CIS",
    "num": "590",
    "desc": "Prerequisite: Permission of instructor.\nSelected topics in computer science.",
    "credits": "1-4"
  },
  {
    "course_name": "Entrepreneurial Computer Science Project",
    "dept": "CIS",
    "num": "596",
    "desc": "Prerequisite: CIS 560, ENTRP 340 and senior standing in computer science. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nDirected studies: selection, investigation and report on some topic not covered in prior courses; may include an implementation and/or experimentation component; may be done in collaboration with other students. Completion of a final report with literature review and project evaluation.",
    "credits": "3"
  },
  {
    "course_name": "Computer Science Project",
    "dept": "CIS",
    "num": "598",
    "desc": "Prerequisite: CIS 560 and senior standing in computer science.  Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nDirected studies: selection, investigation and report on some topic not covered in prior courses; may include an implementation and/or experimentation component; may be done in collaboration with other students. Completion of a plan, two reviews, and a final report with literature review and project evaluation.",
    "credits": "3"
  },
  {
    "course_name": "Cybersecurity Project",
    "dept": "CIS",
    "num": "599",
    "desc": "Prerequisite: CIS 551 and senior standing in computer science. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nDirected studies: selection, investigation and report on some topic not covered in prior security courses; may include an implementation and/or experimentation component; may be done in collaboration with other students. Completion of a final report with literature review and project evaluation.",
    "credits": "3"
  },
  {
    "course_name": "Set Theory and Logic for CS",
    "dept": "CIS",
    "num": "604",
    "desc": "Prerequisite: Graduate standing.\nInformal and axiomatic set theory, propositional and predicate logic, proof techniques.",
    "credits": "3"
  },
  {
    "course_name": "Real-Time Programming Fundamentals",
    "dept": "CIS",
    "num": "621",
    "desc": "Prerequisite: C or C ++ programming, and CIS 523 and either CIS 300 or CIS 522. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nRelationship between C/C++ constructs and corresponding assembly code generated by compilers. Introduction to special techniques used to implement micro-controllers, such as initialization of programmable CPU modules/peripheral devices, techniques to link assembly and C/C++ codes, producing ROM-able code, and EPROM burning/Flash programming.",
    "credits": "1"
  },
  {
    "course_name": "Real-Time Operating Systems",
    "dept": "CIS",
    "num": "622",
    "desc": "Prerequisite: CIS 621. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nBasic real-time operating systems concepts and services; interrupt processing; process and thread models; real-time software architectures and development environments. Detailed study of design and implementation of real-time applications using real-time operating systems.",
    "credits": "1"
  },
  {
    "course_name": "Concurrent Software Systems",
    "dept": "CIS",
    "num": "625",
    "desc": "Prerequisite: Either CIS 450 or ECE 431; and either CIS 400 or CIS 501.\nArchitecture, design, modeling, implementation, and verification of concurrent, parallel, and distributed software; aspects such as real-time programming, parallel simulation; fault-tolerant programming; grid computing, embedded systems control.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computer-Based Knowledge Systems",
    "dept": "CIS",
    "num": "635",
    "desc": "Prerequisite: CIS 300. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nIntroduction to the applications of artificial intelligence concepts to solving knowledge-dependent tasks. Review of knowledge-representation ideas. Survey of expert system design. Introduction to existing knowledge-based tools available on personal computers. Development of an intelligent system.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computer Graphics",
    "dept": "CIS",
    "num": "636",
    "desc": "Prerequisite: CIS 300. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nDevices and software for graphics display and user interaction, development of software for direct graphic manipulation applications.",
    "credits": "3"
  },
  {
    "course_name": "Multimedia Systems",
    "dept": "CIS",
    "num": "638",
    "desc": "Prerequisite: CIS 300, senior standing. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nIntroduction to computer graphics devices, user interaction; history and scope; multimedia structure, encoding methods and standards, mark-up and scripting languages, software tools, and applications; readings in current literature; class presentation; multimedia project.",
    "credits": "3"
  },
  {
    "course_name": "Software Testing Techniques",
    "dept": "CIS",
    "num": "640",
    "desc": "Prerequisite: CIS 301 and CIS 501. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nSurvey of software testing methodologies; evaluation of software testing strategies; experience in a variety of software testing practices.",
    "credits": "3"
  },
  {
    "course_name": "Software Engineering Design Project",
    "dept": "CIS",
    "num": "641",
    "desc": "Prerequisite: CIS 308 and CIS 501.\nCurrent practices of software development, requirements, design, prototyping, measures and evaluations. Specification, design, and prototyping of a software system.",
    "credits": "3"
  },
  {
    "course_name": "Software Engineering Project I",
    "dept": "CIS",
    "num": "642",
    "desc": "Prerequisite: CIS 308 and CIS 501.\nThe first semester of a two-semester capstone course. Current practices of software development, requirements, design, prototyping, measures and evaluation. Specification, design, and prototyping of a software system.",
    "credits": "3"
  },
  {
    "course_name": "Software Engineering Project II",
    "dept": "CIS",
    "num": "643",
    "desc": "Prerequisite: CIS 642 (which must be taken in the preceding semester).\nContinuation of CIS 642. Final implementation, integration, and testing of a software system. Introduction to configuration management, project management, and software maintenance.",
    "credits": "3"
  },
  {
    "course_name": "Software Development Environments",
    "dept": "CIS",
    "num": "645",
    "desc": "Prerequisite: CIS 501. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nSurvey of current development environments and/or an in-depth study of one development environment.",
    "credits": "3"
  },
  {
    "course_name": "Security and Reliability of Computing Systems",
    "dept": "CIS",
    "num": "655",
    "desc": "Prerequisites: CIS 450 (Computer Architecture and Operations) OR ECE 441 (Design of Digital Systems); recommended MATH 221 (Analytic Geometry and Calculus II); recommended prior or concurrent CIS 553/753 (Introduction to Cryptography). Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nFundamentals of security and reliability of computing systems from both hardware and software perspectives. Topics include symmetric and asymmetric cryptography, artificial intelligence (AI) safety and security, selected topics from hardware-based security, introduction to reliability and fault tolerance, hardware fault tolerance, and software fault tolerance.",
    "credits": "3"
  },
  {
    "course_name": "Implementation Project",
    "dept": "CIS",
    "num": "690",
    "desc": "Prerequisite: Junior standing.\nThe department will suggest various design or implementation projects for individuals or groups in areas such as translators, interpreters, microprogramming, minicomputer operating systems, graphics, numerical software, etc.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Computer Science",
    "dept": "CIS",
    "num": "697",
    "desc": "Prerequisite: Junior standing.",
    "credits": "1-3"
  },
  {
    "course_name": "Programming Languages",
    "dept": "CIS",
    "num": "705",
    "desc": "Prerequisite: CIS 505 and MATH 510. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nProgramming language concepts, including typing, scoping, abstraction and exceptions; programming paradigms, including one or more of logic, functional, object-oriented and concurrent programming, and programming languages supporting the selected paradigms; introduction to programming language semantics; programming language design; development environments.",
    "credits": "3"
  },
  {
    "course_name": "Translator Design I",
    "dept": "CIS",
    "num": "706",
    "desc": "Prerequisite: CIS 501, and CIS 605. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nCompilers and interpreters, including description of languages, finite state scanners. LL(1) parsing, symbol tables, syntax-directed semantics, simple code generation. Constructing a simple compiler.",
    "credits": "3"
  },
  {
    "course_name": "Computer Simulation Experiments",
    "dept": "CIS",
    "num": "710",
    "desc": "Prerequisite: CIS 300. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nPrinciples of digital computer simulation; discrete simulation method, statistics of simulations; implementations.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Operating Systems",
    "dept": "CIS",
    "num": "720",
    "desc": "Prerequisite: CIS 520. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nProcess synchronization and communication, distributed programming primitives, transactions and concurrency control, distributed scheduling, distributed storage, deadlock, security.",
    "credits": "3"
  },
  {
    "course_name": "Real-Time Systems",
    "dept": "CIS",
    "num": "721",
    "desc": "Prerequisite: CIS 520 or both CIS 622 and ECE 633. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nThe design of hard real-time embedded systems, including language and operating system support, scheduling, schedulability analysis, fault tolerance, and design tools.",
    "credits": "3"
  },
  {
    "course_name": "Operating System Practices",
    "dept": "CIS",
    "num": "722",
    "desc": "Prerequisite: CIS 520. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nStructure and functions of modern operating systems. Emphasis on reading and modifying the source code of a working operating system. This includes memory management, input/output, process management, file systems, and network interconnection software construction.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Computer Networks",
    "dept": "CIS",
    "num": "725",
    "desc": "Prerequisite: CIS 520, and CIS 525. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nNetwork algorithms; routing and congestion control; protocol engineering; protocol decomposition, specification and verification, synthesis; protocols for high speed networks; parallel implementations, light-weight protocols.",
    "credits": "3"
  },
  {
    "course_name": "Advanced World Wide Web Technologies",
    "dept": "CIS",
    "num": "726",
    "desc": "Prerequisite: CIS 520, CIS 525. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nAn advanced course on the technologies that make up the World Wide Web. WWW site designs and analysis, WWW software architecture, server-side technologies, dynamic executable scheduling, digital libraries, WWW security.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Artificial Intelligence",
    "dept": "CIS",
    "num": "730",
    "desc": "Prerequisite: CIS 501. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nIntroduction to the fundamental concepts and techniques of AI: problem solving, search and planning, knowledge representation and qualitative reasoning, expert systems, natural language processing and cognitive modeling, computer vision, and machine learning.",
    "credits": "3"
  },
  {
    "course_name": "Programming Techniques for Data Science and Analytics",
    "dept": "CIS",
    "num": "731",
    "desc": "Prerequisite: Either CIS 200 or CIS 209, and either STAT 325 or STAT 510.\nIntermediate programming techniques for data science. Survey of programming concepts that underlie MapReduce, Apache Hadoop, and Spark, along with related tools. NoSQL, search tools, graph databases, and visualization presented in the context of real-world problems involving data integration and transformation.",
    "credits": "3"
  },
  {
    "course_name": "Machine Learning and Pattern Recognition",
    "dept": "CIS",
    "num": "732",
    "desc": "Prerequisite: CIS 501 or CIS 575.\nTheory and methodology of inductive learning, including decision trees, artificial neural networks, probabilistic and instance-based learning, and inductive logic programming; unsupervised and reinforcement learning, bagging and boosting; genetic algorithms and genetic programming; and applications to data mining.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Genomics and Bioinformatics",
    "dept": "CIS",
    "num": "734",
    "desc": "Prerequisite: Either BIOL 450 or CIS 300, and instructor permission.  Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nA problem solving approach to understanding genomics and bioinformatics. Practical use of databases and web-based tools used to study biological problems. Introduction to the algorithms behind these tools.",
    "credits": "4"
  },
  {
    "course_name": "Computer Graphics",
    "dept": "CIS",
    "num": "736",
    "desc": "Prerequisite: CIS 308. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nTopics in computer representation and display of images and graphic interaction.",
    "credits": "3"
  },
  {
    "course_name": "Software Engineering",
    "dept": "CIS",
    "num": "740",
    "desc": "Prerequisite: CIS 641 or CIS 642.\nSoftware life cycle, requirements, specifications, design, validation, measures, and maintenance.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Software Analysis and Design",
    "dept": "CIS",
    "num": "744",
    "desc": "Prerequisite: CIS 641 or CIS 642.\nAdvanced concepts and practicum in object-oriented analysis, modeling, design, implementation, testing, and use of CASE tools; relationships among structural, static, and dynamic models; relationship among conceptual, system, and implementation models.",
    "credits": "3"
  },
  {
    "course_name": "Software Measurement",
    "dept": "CIS",
    "num": "746",
    "desc": "Prerequisite: CIS 641 or CIS 642.\nMeasurement theory; development, validation and use of software measures; software measures in the life cycle, including cost estimation, design measures, software complexity and software reliability.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Software Management",
    "dept": "CIS",
    "num": "748",
    "desc": "Prerequisite: CIS 740 or CIS 744. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nTopics related to the management of software, including organization, project planning, process models, life cycle models, TQM, software quality assurance, cost estimation, configuration management.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Computer Architecture",
    "dept": "CIS",
    "num": "750",
    "desc": "Prerequisite: CIS 450. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nFundamentals of quantitative design of computer architectures, memory hierarchy design, instruction-level parallelism, data-level parallelism, thread-level parallelism, parallel programming, parallel performance analysis, and warehouse-scale computers.",
    "credits": "3"
  },
  {
    "course_name": "Computer and Information Security",
    "dept": "CIS",
    "num": "751",
    "desc": "Prerequisite: CIS 450 or 520. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nA comprehensive coverage of computer and information security. Basic cryptography, access control, authentication, authorization, network security, software security, and social aspects of security. The lectures discuss when and where things can go wrong and how design flaws in a system can be exploited to compromise security. Common attack techniques are introduced, and students have the opportunity to work on course projects that cover both the defense and offense aspects in cyberspace.",
    "credits": "3"
  },
  {
    "course_name": "Applied Cryptography",
    "dept": "CIS",
    "num": "753",
    "desc": "Prerequisite: CIS 300, MATH 510, or equivalent. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nFundamentals of cryptography, including mathematical background, classical ciphers, public key encryption, block and stream ciphers, cryptographic hash functions, digital signatures, common attacks, and basic network security.",
    "credits": "3"
  },
  {
    "course_name": "Systems Security",
    "dept": "CIS",
    "num": "755",
    "desc": "Prerequisites: CIS 551 or CIS 751. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nIn-depth coverage of advanced theoretical and practical security techniques with emphasis on construction of new systems and auditing and repair of existing security-critical systems using rigorous design, risk analysis, and engineering methods and application of state-of-art theoretical tools.",
    "credits": "3"
  },
  {
    "course_name": "Data Base Management Systems",
    "dept": "CIS",
    "num": "761",
    "desc": "Prerequisite: CIS 560, CIS 604. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nData models and languages, hierarchical, network, relational systems; implementation and operational requirements; programming projects using data base management systems.",
    "credits": "3"
  },
  {
    "course_name": "Office Automation",
    "dept": "CIS",
    "num": "762",
    "desc": "Prerequisite: CIS 525, 560. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nCharacteristics of information work; modeling systems for characterizing aspects of office environment; form-based systems; office automation and description languages, ergonomics, local area networks and tools used in the automation of offices.",
    "credits": "3"
  },
  {
    "course_name": "Database Design",
    "dept": "CIS",
    "num": "764",
    "desc": "Prerequisite: CIS 501. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nConceptual, logical, physical, and user interface design for database management systems.",
    "credits": "3"
  },
  {
    "course_name": "Formal Language Theory",
    "dept": "CIS",
    "num": "770",
    "desc": "Prerequisite: MATH 510. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nRegular languages, finite automata, context-free languages, pushdown automata, context-sensitive languages, linear bounded automata, recursively enumerable languages, Turing machines.",
    "credits": "3"
  },
  {
    "course_name": "Software Specification",
    "dept": "CIS",
    "num": "771",
    "desc": "Prerequisite: CIS 301. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nFormal logic or specification of software components; algebraic vs. model-based specifications; common abstract types; verification of properties of specifications; introduction to specification of concurrent systems.",
    "credits": "3"
  },
  {
    "course_name": "Analysis of Algorithms",
    "dept": "CIS",
    "num": "775",
    "desc": "Prerequisite: CIS 575. Students may enroll in CIS courses only if they have earned a grade of C or better for each prerequisite to those courses.\nStudy and application of techniques and procedures used in the analysis of algorithms including the worst and average cases of both time and space. Study of the P and NP classes.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Computer Science",
    "dept": "CIS",
    "num": "798",
    "desc": "Prerequisite: Prerequisite varies with the announced topic.",
    "credits": "1-18"
  },
  {
    "course_name": "Medical Terminology: Latin and Greek for Scientists",
    "dept": "CLSCS",
    "num": "105",
    "desc": "\nThis course provides students with the framework and experience required to understand and use scientific and medical terminology.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Classical Literature in Translation",
    "dept": "CLSCS",
    "num": "309",
    "desc": "\nIntroduction to the canonical works of Greek and Roman literature in translation. Discussion of classical texts in English translation with ample attention paid to material culture, visual media and classical culture.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Classical Mythology in Translation",
    "dept": "CLSCS",
    "num": "310",
    "desc": "\nIntroduction to the mythology of Greece and Rome through examinations of their literature (in English) and material culture.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Classical Literature in Translation",
    "dept": "CLSCS",
    "num": "501",
    "desc": "\nA detailed survey of Greek and/or Roman literature in translation.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Classical Studies",
    "dept": "CLSCS",
    "num": "502",
    "desc": "\nFocuses on different aspects of ancient Greek and Roman culture. Greek society and culture, Roman society and culture, Greco-Roman religion, and ancient ethnography are among the potential topics of this course.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in Classics",
    "dept": "CLSCS",
    "num": "549",
    "desc": "Prerequisite: Instructor consent.\nIndependent study in Classics, Latin, or Greek.",
    "credits": "1-5"
  },
  {
    "course_name": "Computing Principles",
    "dept": "CMST",
    "num": "103",
    "desc": "Prerequisite: Experience with PC software.\nFundamental concepts of computer science and computational thinking. Topics include the use of abstraction, problem analysis, data representation, algorithms and programming. Students learn to use creative processes to develop computational artifacts. Student activities are designed to appeal to a broad audience, including those underrepresented in computing.",
    "credits": "3"
  },
  {
    "course_name": "Database Management",
    "dept": "CMST",
    "num": "104",
    "desc": "\nAn introduction to using a database management system on a personal computer. Students begin with elementary database commands and progress to more sophisticated database applications. Students are required to complete assignments on the computer, some of which are completed outside of class.",
    "credits": "2"
  },
  {
    "course_name": "PC Desktop Software",
    "dept": "CMST",
    "num": "108",
    "desc": "\nThe use and application of popular software application packages. Topics include word processors, electronic spreadsheets, database management systems, and presentation software. Students are required to complete assignments on the computer, some of which are completed outside of class.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Visual Basic",
    "dept": "CMST",
    "num": "110",
    "desc": "Corequisite: MATH 100.",
    "credits": "3"
  },
  {
    "course_name": "Graphics Software Applications",
    "dept": "CMST",
    "num": "115",
    "desc": "Prerequisite: Experience with PC software.\nIntroduction to popular graphics software application packages. Emphasis is on design concepts, color usage, image and concept development and creative problem solving using graphics software. Students are required to complete assignments on the computer, some of which are completed outside of class.",
    "credits": "3"
  },
  {
    "course_name": "Web Fundamentals",
    "dept": "CMST",
    "num": "135",
    "desc": "Prerequisite: Experience with PC software.\nConcepts of communications across the Internet, and the technology required to create web pages. Topics include ethical use of the web and accessibility issues for disabled visitors. In-depth coverage of web page construction and styling.",
    "credits": "3"
  },
  {
    "course_name": "Digital Photography",
    "dept": "CMST",
    "num": "146",
    "desc": "Prerequisite: Experience with PC software.\nIntroduces basic photographic techniques and computer assisted image manipulation. Topics include: basic camera functions, basic digital image processing, visualization and design skills and digital manipulation techniques needed in today’s market place. Students have opportunities to create portfolio pieces.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Database Systems",
    "dept": "CMST",
    "num": "180",
    "desc": "Prerequisite: Experience with PC software.\nAn introduction to properties and design principles of relational databases. Topics include database terms, E-R Modeling, relational table design and normalization, the relational algebra, Structured Query Language, and the database life cycle. Laboratory work includes the design and implementation of a database.",
    "credits": "3"
  },
  {
    "course_name": "Computer Systems Studio I",
    "dept": "CMST",
    "num": "183",
    "desc": "Corequisite: CMST 103 and CMST 135.\nStudents begin a portfolio of projects that connect the topics covered in CMST 103, CMST 135, required general education courses, and other relevant subjects.",
    "credits": "1"
  },
  {
    "course_name": "Computer Systems Studio II",
    "dept": "CMST",
    "num": "185",
    "desc": "Prerequisite: CMST 183.\nStudents add to their portfolios projects that connect the topics covered in CMST 250, CMST 247, past required CMST and general education courses, and other relevant subjects.",
    "credits": "1"
  },
  {
    "course_name": "Digital Media I",
    "dept": "CMST",
    "num": "216",
    "desc": "Prerequisite: CMST 115 and CMST 137.\nHands-on experience dealing with the elements and principles of digital communications working with industry standard software for photo editing, illustration and page layout. Students have the opportunity to produce portfolio pieces.",
    "credits": "3"
  },
  {
    "course_name": "Programming I",
    "dept": "CMST",
    "num": "247",
    "desc": "Prerequisite: CMST 103.\nThe syntax and semantics of a modern programming language. Topics include expressions, control statements, objects, classes, methods, event handling, arrays, inheritance, and polymorphism. Students are expected to apply the computational thinking and creative processes learned in CMST 103 to the development of computer programs.",
    "credits": "3"
  },
  {
    "course_name": "Hardware and Network Fundamentals",
    "dept": "CMST",
    "num": "250",
    "desc": "Prerequisite: Experience with PC software.\nAn introduction to computer systems with an emphasis on the internal workings of computer and network hardware. Hardware topics include data representation in binary, digital logic and the Von-Neumann architecture. Network topics include local-area and wide-area networks, topology, protocols and transmission media. Student activities include proper hardware configurations for various applications.",
    "credits": "3"
  },
  {
    "course_name": "System and Software Fundamentals",
    "dept": "CMST",
    "num": "252",
    "desc": "Prerequisite: CMST 250.\nAn introduction to computer systems with an emphasis on systems software. Systems topics include operating systems, low-level and high-level programming languages, virtualization and an introduction to the theory of computation.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Unix",
    "dept": "CMST",
    "num": "270",
    "desc": "Prerequisite: CMST 102 and CMST 247.\nAn introduction to using the Unix operating system for programming and system administration. Topics include using the Unix command line interface, file attributes, editing text files, and programming with shell script and other interpreted languages.",
    "credits": "3"
  },
  {
    "course_name": "Computer Systems Studio III",
    "dept": "CMST",
    "num": "283",
    "desc": "Prerequisite: CMST 185.\nStudents add to their portfolios projects that connect the topics covered in CMST 180, CMST 335, past required CMST and general education courses, and other relevant subjects.",
    "credits": "1"
  },
  {
    "course_name": "Topics in Computer Systems Technology",
    "dept": "CMST",
    "num": "299",
    "desc": "Prerequisite: Consent of instructor.\nProvides an opportunity for faculty to present computer systems technology topics.",
    "credits": "1-18"
  },
  {
    "course_name": "Applications in C Programming for Engineering Technology",
    "dept": "CMST",
    "num": "302",
    "desc": "Prerequisite: Experience with PC software.\nAn introduction to structured program design and implementation using the C programming language. Topics include use of the C language in calculations, input, output, and file handling. Students design, implement, and test programs applicable to engineering technology majors.",
    "credits": "3"
  },
  {
    "course_name": "Robotics Programming",
    "dept": "CMST",
    "num": "305",
    "desc": "Prerequisite: CMST 247 or CMST 302.\nConcepts and practices related to programming robotic systems emphasizing the unique input/output (I/O) and concurrency requirements of robotics. Students learn about sensors, actuators, kinematics, control systems, teleoperated operation and autonomous algorithms. Students write programs that run on a robot as well as a drive station computer with network communication to a robot.",
    "credits": "3"
  },
  {
    "course_name": "Visual Basic Programming",
    "dept": "CMST",
    "num": "310",
    "desc": "Prerequisite: CMST 180; and CMST 247 or equivalent.\nAn in-depth study of Visual Basic as an object-oriented language for students having had previous college-level computer programming courses. Topics include advanced database manipulation, MDI programming, creation of controls, web forms, and help files. Assignments focus on large programming projects. Students design, implement, and present a final capstone course project.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to System Administration",
    "dept": "CMST",
    "num": "315",
    "desc": "\nAn in-depth study of network and server administration. Topics include network design, hardware and software selection, server and client installation, management of network services, file and network resource administration, configuration of permissions and policies, and server monitoring and tuning.",
    "credits": "3"
  },
  {
    "course_name": "C# Programming",
    "dept": "CMST",
    "num": "317",
    "desc": "Prerequisite: CMST 247.\nAn in-depth study of the Microsoft C# language and its applications. C# is a development tool within the .NET framework. Students use the language to develop a wide variety of applications including stand-alone applications and those providing access to databases and Web services.",
    "credits": "3"
  },
  {
    "course_name": "Game Programming",
    "dept": "CMST",
    "num": "323",
    "desc": "Prerequisite: CMST 247 and PHYS 113.\nAn introduction to computer game programming.  Topics include game mathematics and physics, tile-based virtual worlds, artificial intelligence,and game graphics. Students design, develop, and present a functioning computer game as a capstone course project.",
    "credits": "3"
  },
  {
    "course_name": "Page Layout and Type",
    "dept": "CMST",
    "num": "326",
    "desc": "Prerequisite: CMST 216.\nAn intermediate course dealing with typographic design concepts, color usage, image development, idea development, and creative problem solving. Addresses typographic principles, techniques and development of a personal style to create typographic designs that are technically sound and visually interesting.",
    "credits": "3"
  },
  {
    "course_name": "Web Development Project",
    "dept": "CMST",
    "num": "332",
    "desc": "Prerequisite: CMST 335.\nEach student implements a major web site. Students apply system analysis concepts to design a working website using graphics, security, and information processing.",
    "credits": "3"
  },
  {
    "course_name": "Computer Systems Portfolio Defense",
    "dept": "CMST",
    "num": "333",
    "desc": "Prerequisite: CMST 283.\nEach student must orally present and defend his or her portfolio of projects to the faculty.",
    "credits": "0"
  },
  {
    "course_name": "Programming II",
    "dept": "CMST",
    "num": "335",
    "desc": "Prerequisite: CMST 135 and CMST 247.\nClient/server programming used in web development. Students create web applications, some of which include database components.",
    "credits": "3"
  },
  {
    "course_name": "Digital Media Project",
    "dept": "CMST",
    "num": "336",
    "desc": "Prerequisite: CMST 216 and sophomore standing.\nProvides sophomores with the capstone experience of developing a professional quality project in digital media. Students learn problem solving through the design process used in digital media development.",
    "credits": "3"
  },
  {
    "course_name": "C++ Programming",
    "dept": "CMST",
    "num": "341",
    "desc": "Prerequisite: CMST 247.\nAn in-depth study of C++ as an object-oriented programming language for students having had previous college level computer programming courses. Students write Windows applications using classes,  MFC, and managed and unmanaged code. Programs involve Windows interfacing, exception handling, database access, COM and the creation of DLLs. Each student individually completes a final capstone course project.",
    "credits": "3"
  },
  {
    "course_name": "Internetworking",
    "dept": "CMST",
    "num": "344",
    "desc": "Prerequisite: CMST 250.\nConcepts and principles of internetworking with TCP/IP. Topics include IP addressing, subnetting, transport services, internet architecture, routing strategies, and TCP/IP applications. Students implement and analyze various internet topologies and router configurations through hands-on activities.",
    "credits": "3"
  },
  {
    "course_name": "Java Programming II",
    "dept": "CMST",
    "num": "347",
    "desc": "Prerequisite: CMST 247.\nAn in-depth study of Java as a web programming language. Topics include exception handling, file I/O, advanced programming techniques and data structures, Java applets, multithreaded programming, client/server communication, and database and web connectivity. Students design, implement, and present a final capstone course project.",
    "credits": "3"
  },
  {
    "course_name": "Unix Administration",
    "dept": "CMST",
    "num": "350",
    "desc": "Prerequisite: CMST 250 and 270.\nThe essentials of administering the Unix operating system. Topics include Unix installation and loading, an in-depth look at its file system, software installation, user configuration, handling security, modems, networking, and configuration of network services.",
    "credits": "3"
  },
  {
    "course_name": "Network Programming",
    "dept": "CMST",
    "num": "355",
    "desc": "Prerequisite: CMST 247 and CMST 250.\nConcepts and techniques of developing computer programs that communicate over a network using the TCP/IP and UDP/IP protocols. The course examines the use of sockets to communicate between a client and a server focusing on application-layer protocols commonly used on the Internet.  Application layer topics and protocols studied include DNS, web (HTTP, HTML, and XML), electronic mail (SMTP, MIME, POP, and IMAP) and secure communication (SSL and TLS). Asynchronous and multithreaded programming technologies are studied as client and server applications are developed.",
    "credits": "3"
  },
  {
    "course_name": "Motion Graphics Technology",
    "dept": "CMST",
    "num": "356",
    "desc": "Prerequisite: CMST 336.\nA continuation of previous digital media courses. Includes an exploration of the various tools and processes associated with creating digital video, animation, and motion graphics. Students the the opportunity to produce portfolio pieces.",
    "credits": "3"
  },
  {
    "course_name": "Machine Vision",
    "dept": "CMST",
    "num": "357",
    "desc": "Prerequisite: ETB 310, or CMST 302, or CMST 247.\nIntroduction to practical concepts and techniques for image processing and computer vision emphasizing the fundamental algorithms applicable to robotics, automation and unmanned aerial systems. Major topics covered include: MATLAB programming, image acquisition, geometric and intensity transformations, spatial and frequency domain filtering, image enhancement and restoration, morphological transformations, edge detection, segmentation, compression, feature extraction, and pattern recognition.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Business Programming",
    "dept": "CMST",
    "num": "363",
    "desc": "\nAn in-depth study of the COBOL language. Topics include table processing, Sort, Search, and Merge features, the Balanced Line algorithm, indexed file processing, database access, interactive processing, screen handling, and the use of Windows forms. Students use the Microsoft .NET framework to integrate COBOL with other language program modules.",
    "credits": "3"
  },
  {
    "course_name": "Applied Data Structures",
    "dept": "CMST",
    "num": "370",
    "desc": "Prerequisite: CMST 247.\nA systematic study of data structures and algorithms organized around the unifying concept of data abstraction. Topics include abstract data types, stacks, queues, linked lists, trees, hash tables, heaps, sorting, and searching. The implementations of these data types using object-based constructs are studied and compared with respect to algorithms running times.",
    "credits": "3"
  },
  {
    "course_name": "Programming and Data Structures Studio",
    "dept": "CMST",
    "num": "383",
    "desc": "Prerequisite: CMST 333.\nStudents complete projects that tie together topics related to large application programming. Content topics include tools and methodologies for large program development, testing strategies, data structures and other relevant subjects.",
    "credits": "3-6"
  },
  {
    "course_name": "Systems and Database Administration Studio",
    "dept": "CMST",
    "num": "385",
    "desc": "Prerequisite: CMST 383.\nStudents complete projects that tie together topics related to systems and database administration. Content topics include advanced database, network infrastructure, security, multi-platform support, systems integration and other relevant subjects.",
    "credits": "3-6"
  },
  {
    "course_name": "Operating Systems",
    "dept": "CMST",
    "num": "410",
    "desc": "Corequisite: CMST 370.\nAn in-depth study of the concepts of basic operating systems and the services they provide. Topics include memory and file management, process control, input, output, and control of computer hardware. The features of modern, popular operating systems are highlighted.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Database Systems",
    "dept": "CMST",
    "num": "420",
    "desc": "Prerequisite: CMST 180 and level 2 programming language elective.\nAn in-depth study of the theoretical foundations of database design, implementation, and management as well as social and ethical issues associated with database design. Topics include the enhanced E-R model, object-oriented model, distributed databases, advanced SQL, security, data warehousing and mining. Students design, implement, and present a capstone course project.",
    "credits": "3"
  },
  {
    "course_name": "Network Security",
    "dept": "CMST",
    "num": "445",
    "desc": "Prerequisite: CMST 315 or 350.\nAn in-depth study of the information and skills needed to design, install, configure, secure, and administer the interface between a LAN and the Internet. Emphasis is on designing and implementing secure systems communicating within a TCP/IP environment.",
    "credits": "3"
  },
  {
    "course_name": "Software Engineering",
    "dept": "CMST",
    "num": "460",
    "desc": "Prerequisite: CMST 383; and senior standing.\nAn in-depth study of software engineering methodologies for the analysis, design, and implementation of software systems. Topics include project management, structured analysis and design, object-oriented analysis and design, implementation and testing strategies, and software principles and metrics.",
    "credits": "3"
  },
  {
    "course_name": "Applied Algorithm Design",
    "dept": "CMST",
    "num": "470",
    "desc": "Prerequisite: CMST 370 and level 2 programming language elective.\nTechniques of algorithm design including greedy, divide and conquer, dynamic programming, backtracking and branch-and-bound. Covers algorithmic solutions to problems from a variety of application areas including games, graphs and encryption. Emphasis is on programming assignments that enable students to develop their problem solving and algorithm design skills.",
    "credits": "3"
  },
  {
    "course_name": "Emerging Technologies Studio",
    "dept": "CMST",
    "num": "483",
    "desc": "Prerequisite: Senior standing.\nStudents practice life-long learning and research methods by completing projects that combine previously learned material with newly emerging technologies that the students must research and analyze.",
    "credits": "3-6"
  },
  {
    "course_name": "Computer Systems Senior Capstone Project",
    "dept": "CMST",
    "num": "485",
    "desc": "Prerequisite: CMST 460.\nA sequel to CMST 460 in which students work individually or in teams to develop a significant project in their area of interest. Students are expected to apply the software engineering methodologies from CMST 460, write project documentation, and make verbal presentations. Whenever feasible, real-world projects are solicited from local businesses.",
    "credits": "6"
  },
  {
    "course_name": "Advanced Topics in Computer Systems Technology",
    "dept": "CMST",
    "num": "499",
    "desc": "Prerequisite: Consent of instructor.\nProvides an opportunity for faculty to present advanced computer systems technology topics.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to Conflict Resolution",
    "dept": "CNRES",
    "num": "300",
    "desc": "\nThis course is a survey of conflict resolution strategies that will provide students with the knowledge and applicable skills to be better classmates, friends, and co-workers in their future careers. It is applicable for a wide array of majors and disciplines. Emphasis will be given equally to foundational concepts of how to manage conflict more effectively, as well as in-class exercises that allow students to practice these new skills.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Conflict Resolution and Trauma Studies",
    "dept": "CNRES",
    "num": "500",
    "desc": "\nIndependent study on topics in conflict resolution and trauma studies.",
    "credits": "1-3"
  },
  {
    "course_name": "Trauma and Traumatic Stress",
    "dept": "CNRES",
    "num": "529",
    "desc": "\nThis course will introduce and review the theoretical and historical beginnings of the concept of trauma, which includes the inclusion of post-traumatic stress disorder (PTSD) as a diagnosis in the DSM III.  It will highlight the other forms of recognized traumatic events and stressors that have more recently been brought to light. It will discuss various trauma reactions, effects of stressful events, as well as the treatment of trauma. Resilience and transcendence of trauma will be outlined, with an emphasis on the importance of self-care for clinicians and helping professional working in this area.",
    "credits": "3"
  },
  {
    "course_name": "Coping with Life Crises",
    "dept": "CNRES",
    "num": "530",
    "desc": "\nThe purpose of this course is to provide students with resources related to managing stress and coping with crises across the lifespan that can be utilized in both their own lives and in the lives of those families they serve. Students will be introduced to the biopsychosocial nature of stress; methods of coping with stress, anxiety, and conflict; models of effective family functioning in the presence of stress and crises; and the current literature on how families cope with a variety of life transitions and crises.",
    "credits": "3"
  },
  {
    "course_name": "Core Conflict Resolution",
    "dept": "CNRES",
    "num": "531",
    "desc": "\nThis course focuses on a set of core skills and strategies for managing and resolving disputes. It is designed to (1) help individuals deal with differences and address conflict on a personal level, and (2) provide detailed knowledge of a structured approach for third party conflict resolvers.",
    "credits": "3"
  },
  {
    "course_name": "Conflict Resolution across Cultures & Contexts",
    "dept": "CNRES",
    "num": "532",
    "desc": "\nThe course explores the cultural components of conflict by examining the dynamics of interpersonal beliefs and socialization, cross cultural conflict theory, and issues related to application in a variety of settings. This course is designed to be an exercise in critical thinking, cultural exploration, and self-reflection.",
    "credits": "3"
  },
  {
    "course_name": "Prevention & Intervention of Violence",
    "dept": "CNRES",
    "num": "533",
    "desc": "\nThis course includes an introduction to a range of violence intervention and prevention approaches developed for use as the interpersonal, intergroup, and societal level. Various theories of human aggression and violence and their underlying assumptions about human nature and the causes of violence will be examined.",
    "credits": "3"
  },
  {
    "course_name": "Conflict in Organizations",
    "dept": "CNRES",
    "num": "534",
    "desc": "\nThis course focuses on the causes and sources of conflict within organizations and groups, dispute systems assessment and design, and how conflict resolution professionals work as interveners and agents of change. Students will also explore and identify their own professional consultation strengths and interests.",
    "credits": "3"
  },
  {
    "course_name": "Divorce and Child Custody Mediation",
    "dept": "CNRES",
    "num": "535",
    "desc": "Prerequisite: CNRES 531\nThis course focuses on mediation as an approach for couples wishing to create divorce settlements through a cooperative, confidential, and private process. Divorce and child-custody is considered as a family problem and not a legal problem. It addresses the psychological, financial, and legal dimensions of divorce in conflict resolution settings.",
    "credits": "3"
  },
  {
    "course_name": "Conflict and Trauma in International Settings",
    "dept": "CNRES",
    "num": "536",
    "desc": "\nThis course study will examine the historical, political, and religious roots of conflict in an international setting. The focus of study will also include an analysis of the area’s cultural traditions and exploration into the ways in which divided societies cope with attendant political, economic, and social problems. Prospects for continued and sustainable peace in this region, as well as how progress is being made will also be examined.",
    "credits": "3"
  },
  {
    "course_name": "Elder and Family Decision Making",
    "dept": "CNRES",
    "num": "537",
    "desc": "\nThis course focuses on the specialized skills and techniques for successfully facilitating adult family conversations around issues such as living arrangements, caregiving, driving, medical decisions, family communication, financial planning, inheritance/personal property distribution, trusts and estates.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Trauma and Traumatic Stress",
    "dept": "CNRES",
    "num": "538",
    "desc": "\nThis course will examine a broad range of traumatic experiences and their associated biopsychosocial outcomes. A variety of topics including military trauma, childhood abuse, sexual assault, intimate partner violence, human trafficking, natural disasters, and terrorism, among others, will be addressed. We will also discuss various mental, emotional, and interpersonal reactions to traumatic life events, as well as traditional and alternative treatment approaches for trauma-related diagnoses. Factors that contribute to posttraumatic growth will be highlighted, with an emphasis on examining effective community-based resources for the successful treatment of traumatic stress.",
    "credits": "3"
  },
  {
    "course_name": "Grief and Loss Across the Lifespan",
    "dept": "CNRES",
    "num": "539",
    "desc": "\nThis course offers an introduction to theories of grief and loss as well as an overview of how loss affects individuals and families according to their developmental stages. Theoretical bases of study would include both individual and family-based models. Another component covers coping and treatment approaches, with a special emphasis on working with families coping with grief in the professional sphere.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Conflict Resolution and Trauma Studies",
    "dept": "CNRES",
    "num": "700",
    "desc": "\nIndependent study on topics in conflict resolution and trauma studies.",
    "credits": "1-18"
  },
  {
    "course_name": "Crises Across the Lifespan",
    "dept": "CNRES",
    "num": "750",
    "desc": "\nThe purpose of this course is to provide students with resources related to managing stress and coping with crises across the lifespan that can be utilized in both their own lives and the lives of those families they serve.  Students will be introduced to the biopsychosocial nature of stress; methods of coping with stress, anxiety, and conflict; models of effective family functioning in the presence of stress and crises; and the current literature on how families cope with a variety of life transitions and crises.",
    "credits": "3"
  },
  {
    "course_name": "Conflict Resolution: Core Skills and Strategies",
    "dept": "CNRES",
    "num": "751",
    "desc": "\nThis course presents communication theories and interpersonal skills relevant to conflict resolution, including the understanding of, analysis of, and management of conflict. Completion of the course meets the Kansas Office of Dispute Resolution’s training requirements for state approval in core mediation [K.S.A. 5-501 and Rule 902(e)].",
    "credits": "3"
  },
  {
    "course_name": "Culture and Conflict",
    "dept": "CNRES",
    "num": "752",
    "desc": "\nThis course is an exercise in critical thinking, cultural exploration, and self-reflection. It explores the cultural dimensions of conflict, including the role of culture in defining conflict for individuals and groups. The dynamics of interpersonal beliefs and socialization, cross cultural conflict theory, and issues related to application are also examined.",
    "credits": "3"
  },
  {
    "course_name": "Violence Prevention and Intervention",
    "dept": "CNRES",
    "num": "753",
    "desc": "\nThis course examines various theories of human aggression and violence, exploring their underlying assumptions about human nature, and the causes of violence. Included is an introduction to a range of violence intervention and prevention approaches developed for use at the interpersonal, intergroup, and societal level.",
    "credits": "3"
  },
  {
    "course_name": "Organizational Conflict",
    "dept": "CNRES",
    "num": "754",
    "desc": "\nThis course provides an overview of the theories, methods, and practice issues involved in identifying and assessing sources of conflict. Students will learn about organizations, organizational development, causes and sources of conflict within organizations, dispute systems design, and how conflict resolution professionals work as interveners and agents of change.",
    "credits": "3"
  },
  {
    "course_name": "Family Mediation",
    "dept": "CNRES",
    "num": "755",
    "desc": "Prerequisite: CNRES 751\nThis course addresses the multi-dimensional aspects of divorce, including the legal divorce, the psychological divorce, and children of divorce. The second half of the semester focuses on how mediation can empower families, teens, and parents to resolve their interpersonal conflicts using a neutral third party.",
    "credits": "3"
  },
  {
    "course_name": "Elder and Family Decision Making",
    "dept": "CNRES",
    "num": "757",
    "desc": "\nThis course focuses on the specialized skills and techniques for successfully facilitating adult family conversations and around issues such as living arrangements, caregiving, driving, medical decisions, family communication, financial planning, inheritance/personal property distribution, trusts and estates.",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Trauma and Traumatic Stress",
    "dept": "CNRES",
    "num": "759",
    "desc": "\nThis course will introduce and review the theoretical and historical beginnings of the concept of trauma, which includes the inclusion of post traumatic stress disorder (PTSD) as a diagnosis in the DSM III. It will highlight the other forms of recognized traumatic events and stressors that have more recently been brought to light. It will discuss various trauma reactions, effects of stressful events, as well as the treatment of trauma. Resilience and transcendence of trauma will be outlined, with an emphasis on the importance of self-care for clinicians and helping professionals working in this area.",
    "credits": "3"
  },
  {
    "course_name": "International Conflict & Trauma",
    "dept": "CNRES",
    "num": "761",
    "desc": "\nThis course study will examine the historical, political, and religious routs of conflict in an international setting.  The focus of study will also include an analysis of the area’s cultural traditions and exploration into the ways in which divided societies cope with the attendant political, economic and social problems.  Prospects for continued and sustainable peace in the region, as well as how progress is being made will also be examined.",
    "credits": "3"
  },
  {
    "course_name": "Construction Seminar",
    "dept": "CNS",
    "num": "016",
    "desc": "\nPresentation of professional problems and practices by students, faculty, contractors, architects, and various organizations associated with the building industry.",
    "credits": "0"
  },
  {
    "course_name": "Construction Science and Management Orientation",
    "dept": "CNS",
    "num": "100",
    "desc": "\nIntroduction to construction science and management. Promotion of interaction and connection with the department as well as a network of academic and professional networks through the use of learning communities. Familiarize entering students with the nature of the architectural, engineering, and construction industry with an emphasis on terminology and professionalism.",
    "credits": "2"
  },
  {
    "course_name": "History of Building and Construction",
    "dept": "CNS",
    "num": "110",
    "desc": "\nAn introduction to the art and science of building. Historical review from ancient to contemporary including related construction methods, equipment, and systems.",
    "credits": "3"
  },
  {
    "course_name": "Computer Applications in Engineering and Construction",
    "dept": "CNS",
    "num": "200",
    "desc": "Prerequisite: Sophomore standing and MATH 150, or equivalent course in trigonometry.\nFundamental applications of computer programming and software using engineering and construction problems, primarily advanced use of spreadsheets with macros, data tables, embedded graphics, and presentations.",
    "credits": "2"
  },
  {
    "course_name": "Graphic Communication I",
    "dept": "CNS",
    "num": "210",
    "desc": "Prerequisite or concurrent enrollment: CNS 220\nIntroduction to graphic communication and methods using orthographic projections, isometrics, and perspective drawings and sketches and their application to the engineering, design, and construction industry.",
    "credits": "1"
  },
  {
    "course_name": "Construction Materials",
    "dept": "CNS",
    "num": "220",
    "desc": "\nStudy and analysis of construction materials, their properties, selection, and use.",
    "credits": "2"
  },
  {
    "course_name": "Statics A",
    "dept": "CNS",
    "num": "231",
    "desc": "Prerequisite: MATH 150 or equivalent, PHYS 113, and MATH 205.\nComposition and resolution of forces; equilibrium of force systems; application of the principles of statics to problems, including force analyses of simple structures.  Centroids; moments of inertia.",
    "credits": "3"
  },
  {
    "course_name": "Graphic Communications II",
    "dept": "CNS",
    "num": "321",
    "desc": "Prerequisite: CNS 210 and professional program standing in ARE or CNSM.\nStudy of construction methods and procedures in the assembly of building materials.",
    "credits": "3"
  },
  {
    "course_name": "Construction Documents",
    "dept": "CNS",
    "num": "325",
    "desc": "Prerequisite: CNS 321.\nA study of reading, understanding, and analysis of documents used in construction: building codes, accessibility standards, specifications, drawings, shop drawing submittals and other related documents.",
    "credits": "3"
  },
  {
    "course_name": "Site Construction",
    "dept": "CNS",
    "num": "330",
    "desc": "Prerequisite: CE 212, CNS 200, and PHYS 113.\nStudy of site construction problems and procedures, site survey and investigations, review of site plans, construction layouts, earthwork calculation, excavation/shoring methods, computer applications.",
    "credits": "3"
  },
  {
    "course_name": "Construction Methods and Equipment",
    "dept": "CNS",
    "num": "440",
    "desc": "Prerequisite: CNS 321, 330, and prerequisite or concurrent CE 331.\nOperations, costs, productivity of construction equipment. Investments/life cycle costing of the equipment. Equipment selection criteria and analysis. Construction methods.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "CNS",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Honors Research in Construction Science",
    "dept": "CNS",
    "num": "499",
    "desc": "\nIndividual research problem selected with approval of faculty advisor. A report is presented orally and in writing during the last semester.",
    "credits": "1-18"
  },
  {
    "course_name": "Technology for Management of the Construction Process",
    "dept": "CNS",
    "num": "510",
    "desc": "Prerequisite: ARE 312, CNS 641, and CNS 645.\nFundamentals and application of computer aided technology in the management of the construction process.",
    "credits": "2"
  },
  {
    "course_name": "Steel and Timber Construction",
    "dept": "CNS",
    "num": "524",
    "desc": "Prerequisite: CE 331.\nPrinciples of design, fabrication, and erection of structural steel and timber structures in conformance with codes.",
    "credits": "3"
  },
  {
    "course_name": "Concrete and Masonry Construction",
    "dept": "CNS",
    "num": "528",
    "desc": "Prerequisite: CE 331.\nPrinciples of design, fabrication, and erection of concrete and masonry structures.",
    "credits": "3"
  },
  {
    "course_name": "Heating and Air Conditioning",
    "dept": "CNS",
    "num": "534",
    "desc": "Prerequisite: CNS 321.\nPrinciples of designing, applying, and installing heating and air conditioning systems for buildings.",
    "credits": "3"
  },
  {
    "course_name": "Electrical and Lighting",
    "dept": "CNS",
    "num": "535",
    "desc": "Prerequisite: CNS 321.\nBasic design and construction of building electrical, lighting, and distribution systems with emphasis on the National Electrical Code and installation.",
    "credits": "3"
  },
  {
    "course_name": "Water Supply and Plumbing",
    "dept": "CNS",
    "num": "536",
    "desc": "Prerequisite: CNS 321.\nPrinciples and practices of the design and layout of plumbing and fire protection, and individual waste treatment systems for buildings including code requirements and estimating.",
    "credits": "3"
  },
  {
    "course_name": "Ethics and Professional Standards",
    "dept": "CNS",
    "num": "542",
    "desc": "Prerequisite or Concurrent: CNS 440.\nAn application of the concepts of ethics as applied to the professional standards of the design and construction industry.",
    "credits": "1"
  },
  {
    "course_name": "Problems in Construction Science",
    "dept": "CNS",
    "num": "544",
    "desc": "Prerequisite: Junior standing.\nA study of specific design problems under the direct supervision of a member of the construction science faculty.",
    "credits": "1-18"
  },
  {
    "course_name": "Heavy Construction Methods",
    "dept": "CNS",
    "num": "545",
    "desc": "Prerequisite: CNS 325, 440.\nPrinciples of asphalt, asphalt and concrete paving operations, concrete batch plant operations, heavy construction equipment and applications.",
    "credits": "3"
  },
  {
    "course_name": "Construction Safety",
    "dept": "CNS",
    "num": "550",
    "desc": "Prerequisite or concurrent enrollment: CNS 535 and CNS 440.\nIntroduction to safety and safety programs, workers’ compensation, OSHA organization and structure, safety policies and record keeping, safety standards. Emphasis will be on communication and job-site safety management. On-site safety inspections will be required within class presentation and written reports to be submitted.",
    "credits": "2"
  },
  {
    "course_name": "Pre-Engineered Metal Buildings",
    "dept": "CNS",
    "num": "610",
    "desc": "Prerequisite: Professional program standing in construction science and management or graduate student in architectural engineering.\nPre-engineered metal building systems: history, components, erection procedures and sequencing, delivery considerations, quality control, safety, and quantity surveying and plan reading.",
    "credits": "2"
  },
  {
    "course_name": "Tilt-up Concrete Structures in Construction Management",
    "dept": "CNS",
    "num": "629",
    "desc": "Prerequisite: CNS 220.\nBasics of concrete, principles of tilt-up concrete, construction operations of tilt-up projects, planning procedures for job site erection, and safety procedures.",
    "credits": "2"
  },
  {
    "course_name": "Building Systems Commissioning",
    "dept": "CNS",
    "num": "634",
    "desc": "Prerequisite: Either CNS 534, 535, and 536 or ARE 561 and ARE 562.\nPrinciples and methods of proper procedures for installing, commissioning and maintaining efficient performance of building envelope and support systems including mechanical and electrical systems.",
    "credits": "2"
  },
  {
    "course_name": "Construction Estimating",
    "dept": "CNS",
    "num": "641",
    "desc": "Prerequisite: CNS 325 and 440.\nUnderstanding estimating procedures, quantity surveying, specification reviews, pricing of an estimate, market analysis, subcontractor and supplier solicitation, and risk management, following the CSI format.",
    "credits": "3"
  },
  {
    "course_name": "Construction Management",
    "dept": "CNS",
    "num": "642",
    "desc": "Prerequisite: CNS 440.\nAn introduction to the business of construction; study of legal considerations, contract documents, bonds and insurance. Evaluation of the characteristics of the construction firm, organization structure, and financial performance.",
    "credits": "3"
  },
  {
    "course_name": "Preconstruction Services/Design Build",
    "dept": "CNS",
    "num": "643",
    "desc": "Prerequisite: CNS 641, CNS 642, and CNS 645.\nApplication of Value Engineering to the construction process, Conceptual Estimating, Onscreen take-off quantity surveying, Design-Build. Other project delivery types and their impact on the preconstruction efforts including general contractor pricing, fees, contingencies, risk, and schedule impacts.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Construction Management",
    "dept": "CNS",
    "num": "644",
    "desc": "Prerequisite or concurrent enrollment: CNS 642.\nTopical material of importance in the management of construction such as marketing, ethics, personnel management, etc.",
    "credits": "1-18"
  },
  {
    "course_name": "Construction Scheduling and Cost Control",
    "dept": "CNS",
    "num": "645",
    "desc": "Prerequisite: CNS 440 and concurrent enrollment in CNS 641.\nConstruction cost reporting and control. Construction planning, both long-term and short-interval, construction scheduling, monitoring, and controlling. Computer application.",
    "credits": "3"
  },
  {
    "course_name": "Construction Financial Management",
    "dept": "CNS",
    "num": "646",
    "desc": "Prerequisite: CNS 641, CNS 642, and CNS 645.\nPrinciples and applications of financial management for the construction professional. Includes financial statements, cost control, cash flow, and risk management.",
    "credits": "2"
  },
  {
    "course_name": "Current Trends in Construction",
    "dept": "CNS",
    "num": "655",
    "desc": "Prerequisite: CNS 641.\nBroad overview of relevant topics in the construction industry in the areas of project management, field supervision, estimating, contracting, and various other special topics, taught by industry professionals who specialize in their area of expertise.",
    "credits": "2"
  },
  {
    "course_name": "Construction Operations",
    "dept": "CNS",
    "num": "660",
    "desc": "Prerequisite: CNS 542, CNS 641, CNS 642, and CNS 645.\nShop drawing and submittal processes, field and office practices, change orders, construction safety standards and practice, pre-construction planning, expediting, short-interval planning.",
    "credits": "3"
  },
  {
    "course_name": "Mechanical and Electrical Estimating",
    "dept": "CNS",
    "num": "738",
    "desc": "Prerequisite: CNS 534 or ARE 562, CNS 536 or ARE 561, and prerequisite or concurrent enrollment: CNS 535.\nPrinciples and practices of mechanical and electrical building systems estimating. Procedure for evaluating relative costs of different plumbing, HVAC, and electrical/lighting systems.",
    "credits": "2"
  },
  {
    "course_name": "Public Speaking IA",
    "dept": "COMM",
    "num": "105",
    "desc": "\nAlternate to COMM 106. Principles and practice of message preparation, audience analysis, presentational skills, and speech criticism.",
    "credits": "2"
  },
  {
    "course_name": "Public Speaking I",
    "dept": "COMM",
    "num": "106",
    "desc": "\nPrinciples and practice of message preparation, audience analysis, presentational skills, and speech criticism permitting greater practice in oral presentation.",
    "credits": "3"
  },
  {
    "course_name": "Public Speaking 1A, Honors",
    "dept": "COMM",
    "num": "109",
    "desc": "\nHonors speech preparation and delivery; a survey of topics basic to rhetoric, communication, and linguistics.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Human Communication",
    "dept": "COMM",
    "num": "120",
    "desc": "\nAn introduction to the traditions, foundations and contexts of human communication that are studied and practiced in society.",
    "credits": "3"
  },
  {
    "course_name": "Forensics Participation",
    "dept": "COMM",
    "num": "210",
    "desc": "Prerequisite: Consent of director of the activity.\nIntercollegiate debate or individual events.",
    "credits": "1-2"
  },
  {
    "course_name": "Introduction to Trial Advocacy",
    "dept": "COMM",
    "num": "260",
    "desc": "Prerequisite: Instructor permission.\nA hands-on introduction to communication in the legal process, with a primary focus on basic techniques attorneys use to develop and present a persuasive case.",
    "credits": "3"
  },
  {
    "course_name": "Business and Professional Speaking",
    "dept": "COMM",
    "num": "311",
    "desc": "Prerequisite: COMM 105 or 106.\nPrinciples and practice of speaking in an organizational setting. Areas of emphasis will be oral reports, interviewing, interpersonal communication, and working in groups.",
    "credits": "3"
  },
  {
    "course_name": "Intercollegiate Forensics",
    "dept": "COMM",
    "num": "319",
    "desc": "Prerequisite: Consent of director of the activity.\nCurrent practices and theories for competitive intercollegiate forensics activity.",
    "credits": "3"
  },
  {
    "course_name": "Theories of Human Communication",
    "dept": "COMM",
    "num": "320",
    "desc": "\nSurvey of basic theories of human communication focusing on sending, receiving, and responding to messages face-to-face.",
    "credits": "3"
  },
  {
    "course_name": "Public Speaking II",
    "dept": "COMM",
    "num": "321",
    "desc": "Prerequisite: COMM 105 or 106.\nAdvanced principles and practice of speech composition, audience adaptation, and delivery.",
    "credits": "3"
  },
  {
    "course_name": "Interpersonal Communication",
    "dept": "COMM",
    "num": "322",
    "desc": "Prerequisite: COMM 105 or 106.\nExamination of the dynamics of face-to-face interpersonal interaction. Focus is on applying principles of relational communication.",
    "credits": "3"
  },
  {
    "course_name": "Nonverbal Communication",
    "dept": "COMM",
    "num": "323",
    "desc": "\nAnalysis of nonverbal communication in human interaction; theory and research in kinesics, proxemics, and paralinguistics.",
    "credits": "3"
  },
  {
    "course_name": "Argumentation and Debate",
    "dept": "COMM",
    "num": "325",
    "desc": "Prerequisite: COMM 105 or 106.\nBasic theories of argumentation with emphasis on the construction and criticism of well reasoned and supported positions.",
    "credits": "3"
  },
  {
    "course_name": "Small Group Discussion Methods",
    "dept": "COMM",
    "num": "326",
    "desc": "Prerequisite: COMM 105 or 106.\nBasic concepts of small group decision making. Projects emphasize participation in and analysis of communication in the small group.",
    "credits": "3"
  },
  {
    "course_name": "Professional Interviewing",
    "dept": "COMM",
    "num": "328",
    "desc": "Prerequisite: COMM 105 or 106.\nInvestigation of interviewing as it occurs in a variety of situations, including journalistic, diagnostic, persuasive, and managerial. Emphasis on developing practical skills in planning, managing interviews, and interpreting data in the professional context.",
    "credits": "3"
  },
  {
    "course_name": "Rhetoric in Western Thought",
    "dept": "COMM",
    "num": "330",
    "desc": "\nAn introduction to the figures, concepts, and trends in the development of rhetorical theory from classical to modern times.",
    "credits": "3"
  },
  {
    "course_name": "Communication and Technology",
    "dept": "COMM",
    "num": "332",
    "desc": "\nFocus on social and interpersonal topics, including how emerging media technologies are understood and the history of forms of communication technology via the Internet and mobile devices. Additional topics include diversity, political and civic engagement, intercultural communication, impression formation and management in online contexts, and relational maintenance.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar Small Group Communication",
    "dept": "COMM",
    "num": "399",
    "desc": "\nOpen only to qualified students in the arts and sciences honors program.",
    "credits": "3"
  },
  {
    "course_name": "Gender Communication",
    "dept": "COMM",
    "num": "420",
    "desc": "\nA study of gender as a variable in interpersonal, organizational, and public communication processes.",
    "credits": "3"
  },
  {
    "course_name": "Theories of Organizational Communication",
    "dept": "COMM",
    "num": "425",
    "desc": "\nReview the literature and develop research projects regarding basic variables of communication in organizational contexts.",
    "credits": "3"
  },
  {
    "course_name": "Coaching and Directing Speech Activities",
    "dept": "COMM",
    "num": "426",
    "desc": "Prerequisite: Six hours of general communication or theatre courses that are 200 level or above, COMM 325, and THTRE 263.\nCurrent practices in coaching curricular and extra-curricular speech activities with practical experience in the problems and procedures of directing a forensic program.",
    "credits": "3"
  },
  {
    "course_name": "Freedom of Speech",
    "dept": "COMM",
    "num": "430",
    "desc": "Prerequisite: COMM 105 or 106.\nA study of communication and legal principles pertaining to freedom of expression, and an examination of their implications for competing interests such as public order, national security, morality, civil rights, and fairness.",
    "credits": "3"
  },
  {
    "course_name": "Criticism of Public Discourse",
    "dept": "COMM",
    "num": "431",
    "desc": "\nAn examination of public influence based on study of historical and contemporary models of rhetorical criticism. The students’ critical experiences will focus on a broad array of public discourse including political, social, and cultural messages.",
    "credits": "3"
  },
  {
    "course_name": "The Rhetoric of the American Presidency",
    "dept": "COMM",
    "num": "432",
    "desc": "\nAn examination of the American presidency from a rhetorical perspective, emphasizing the symbolic resources and duties of the office and those who hold it. Special attention paid to the public discourse of recent presidents during moments of national crisis.",
    "credits": "3"
  },
  {
    "course_name": "Communication Research Methods",
    "dept": "COMM",
    "num": "433",
    "desc": "\nThis course provides an overview of the concepts, methods, and tools by which communication research is designed and conducted.  Methods covered in this course include: focus groups, surveys, experiments, and content analysis.  By the end of this term, students should be able to critically consume communication research, understand the process of using social science to solve communication problems, and have experience in conducting your own research project.",
    "credits": "3"
  },
  {
    "course_name": "Rhetoric and Social Movements",
    "dept": "COMM",
    "num": "434",
    "desc": "\nA study of the scope and functions of persuasive communication in contemporary social movements.",
    "credits": "3"
  },
  {
    "course_name": "Political Communication",
    "dept": "COMM",
    "num": "435",
    "desc": "Prerequisite: None.\nA study of political discourse. Attention is directed to theory that encompasses political discourse as it affects political behavior.",
    "credits": "3"
  },
  {
    "course_name": "Collaborative Communication and Event Planning",
    "dept": "COMM",
    "num": "440",
    "desc": "\nStudy of the role communication plays in collaborative interactions, including program/conference/event planning and civic commemorations. Application of organizational communication theory through planning, analysis, deconstruction, and critique of various collaborative events.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in Human Discourse",
    "dept": "COMM",
    "num": "450",
    "desc": "\nA study of selected subjects in the analysis in human communication.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Trial Advocacy",
    "dept": "COMM",
    "num": "460",
    "desc": "Prerequisite: COMM 260 and/or instructor permission.\nAdvanced study in theory and techniques of courtroom persuasion, emphasizing the complexities of case analysis, courtroom procedures, theme development, and the use of evidence.",
    "credits": "3"
  },
  {
    "course_name": "Communication and Conflict",
    "dept": "COMM",
    "num": "465",
    "desc": "\nTheoretical and applied research in communication and conflictual situations.",
    "credits": "3"
  },
  {
    "course_name": "Rhetoric of Community Building",
    "dept": "COMM",
    "num": "470",
    "desc": "\nAn examination of the symbolic processes of community building. Specifically, the study of the role language plays in sustaining the viability of rural community.",
    "credits": "3"
  },
  {
    "course_name": "Legal Communication",
    "dept": "COMM",
    "num": "475",
    "desc": "Prerequisite: COMM 105 or 106, and instructor permission.\nAn examination of the vital role communication plays in the practice of law, with an emphasis on communication in the courtroom.",
    "credits": "3"
  },
  {
    "course_name": "Intercultural Communication",
    "dept": "COMM",
    "num": "480",
    "desc": "\nA study of the relationship between language and culture and its impact on human communication. Examines how language and culture differ among people and how differences are handled through the process of communication.",
    "credits": "3"
  },
  {
    "course_name": "Honors Project",
    "dept": "COMM",
    "num": "499",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Argumentation Theory",
    "dept": "COMM",
    "num": "525",
    "desc": "\nAn advanced study of prominent argumentation theorists, with an in-depth examination of special topics concerning the philosophy, theory, and practice of argumentation.",
    "credits": "3"
  },
  {
    "course_name": "Persuasion",
    "dept": "COMM",
    "num": "526",
    "desc": "\nThe study of communication as persuasion; examination of contemporary approaches to persuasion.",
    "credits": "3"
  },
  {
    "course_name": "Communication and Leadership",
    "dept": "COMM",
    "num": "535",
    "desc": "\nA study of the ways in which leadership in differing contexts is defined and exercised through communication. Constructs examined include: credibility, charisma, vision, power, myth, and public memory.",
    "credits": "3"
  },
  {
    "course_name": "Negotiation and Communication",
    "dept": "COMM",
    "num": "537",
    "desc": "\nDevelops conceptual knowledge and skill in negotiation in multiple contexts and examines the constitutive nature of communication in the negotiation process.",
    "credits": "3"
  },
  {
    "course_name": "Relational Communication",
    "dept": "COMM",
    "num": "542",
    "desc": "Prerequisite: COMM 311, 320, 322, 323, 326, 328, or 480.\nA survey of theories and research on the role of communication in social and personal relationships. Emphasis is on observing and evaluating communication behaviors using real-life media examples.",
    "credits": "3"
  },
  {
    "course_name": "Communication and Democracy",
    "dept": "COMM",
    "num": "545",
    "desc": "\nA study of the ways in which democratic citizenship and participation in the public sphere are defined and enacted through communication.",
    "credits": "3"
  },
  {
    "course_name": "Senior Colloquium",
    "dept": "COMM",
    "num": "550",
    "desc": "Prerequisite: Senior standing.\nA demonstration of the mastery of vocabulary, theory, and the ability to make practical applications of the study of rhetoric and communication will be required of all senior communication studies majors. Mastery will be demonstrated by completing a senior capstone project and presenting the result of that project to the assembled communication studies faculty and majors in a required colloquium.",
    "credits": "3"
  },
  {
    "course_name": "Senior Honors Thesis",
    "dept": "COMM",
    "num": "551",
    "desc": "\nHonors Thesis Colloquium.",
    "credits": "3"
  },
  {
    "course_name": "Internship in Communication Studies",
    "dept": "COMM",
    "num": "575",
    "desc": "\nStudents will work for/within an organization during the course of a semester. Interns must complete a minimum of 100 work hours to earn course credit. The internship work experience is intended to help apply formal classroom education to “real World” work experience. Ideally internships are pre-professional and project based experiences allowing students the opportunity to make meaningful contributions to the organization. Each intern will complete a series of deliverables to the internship director as well as work under a site supervisor at the host organization. Prior to registration, the internship director must approve all internships.",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Rhetoric and Communication",
    "dept": "COMM",
    "num": "630",
    "desc": "Prerequisite: Instructor permission.\nIntensive study of selected topics in communication and rhetoric.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Communication Research Methods",
    "dept": "COMM",
    "num": "710",
    "desc": "\nIntroduction to descriptive and experimental methodologies in communication, including conceptualization and operationalization of communication concepts, strategies of research design, and logic of inquiry.",
    "credits": "3"
  },
  {
    "course_name": "Perspectives on Communication",
    "dept": "COMM",
    "num": "720",
    "desc": "Prerequisite: COMM 320.\nAnalysis of current perspectives on the communication process. Materials cover assumptions, principles, implications and selected research within each perspective.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Persuasion",
    "dept": "COMM",
    "num": "726",
    "desc": "Prerequisite: Junior standing.\nSurvey and analysis of advanced theory and experimental studies in persuasion.",
    "credits": "3"
  },
  {
    "course_name": "Classical Rhetorical Theory",
    "dept": "COMM",
    "num": "730",
    "desc": "\nStudy of rhetorical theory and criticism from early Greek to Roman times.",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Rhetorical Theory",
    "dept": "COMM",
    "num": "732",
    "desc": "Prerequisite: COMM 730.\nStudy of major European and American contributors to rhetorical theory in the twentieth century.",
    "credits": "3"
  },
  {
    "course_name": "Rhetorical Criticism",
    "dept": "COMM",
    "num": "733",
    "desc": "\nStudy of traditional and contemporary approaches to the analysis of public discourse.",
    "credits": "3"
  },
  {
    "course_name": "Deliberation & Dialogue Theory",
    "dept": "COMM",
    "num": "790",
    "desc": "\nExplores the conceptual and theoretical underpinnings of the Dialogue, Deliberation, and Public Engagement field, including group theory, civic space, and deliberative democracy.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Speech",
    "dept": "COMM",
    "num": "799",
    "desc": "Prerequisite: Junior standing and consent of instructor.\nOpen to students in any communication studies area.",
    "credits": "1-18"
  },
  {
    "course_name": "University Honors Program",
    "dept": "COT",
    "num": "020",
    "desc": "\nThis course is for record keeping purposes to allow the University Honors Program and the College of Technology and Aviation to monitor and track students who are a part of the Honors Program.",
    "credits": "0"
  },
  {
    "course_name": "Mastering Academic Conversations",
    "dept": "COT",
    "num": "105",
    "desc": "Prerequisite: Freshman or instructor consent.\nActively engage students in the process of becoming successful students, scholars, and citizens. Introduction to a successful university experience through participation in interactive seminar classes and co-curricular events. Events and topics include a broad survey of the humanities, examining the impact on culture, society, and the human condition.",
    "credits": "3"
  },
  {
    "course_name": "The Humanities Through the Arts",
    "dept": "COT",
    "num": "150",
    "desc": "\nA general introduction to the humanities, focusing on what they are and their basic importance. Painting, sculpture, architecture, literature, drama, music, dance, film, and photography will be explored. Emphasis will be on participation, involvement, guest speakers, tours, and appreciation.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to University Honors Program",
    "dept": "COT",
    "num": "189",
    "desc": "Prerequisite: Acceptance into the Honors Program.\nAn overview of the University Honors Program including directions, goals and student requirements for completion of the program.",
    "credits": "1"
  },
  {
    "course_name": "Introductory Industrial Internship",
    "dept": "COT",
    "num": "295",
    "desc": "Prerequisite: Approval of faculty internship advisor and sponsoring company.\nIntroductory experiential learning program in an off-campus setting. Written documentation and oral presentation of project goals, experiences, and accomplishments.",
    "credits": "0-6"
  },
  {
    "course_name": "Problems in Arts, Sciences, and Business",
    "dept": "COT",
    "num": "299",
    "desc": "Prerequisite: Consent of instructor.\nOpportunity for advanced independent study in specific subject areas in Department of Arts, Sciences, and Business.",
    "credits": "1-18"
  },
  {
    "course_name": "Methods of Problem Solving for Integrated Professional Studies",
    "dept": "COT",
    "num": "405",
    "desc": "Prerequisite: Junior Standing.\nPractice in applying creative problem solving methods to a selection of problems solicited from multiple disciplines. Analysis of student solutions will examine similarities and difference between disciplines with regard to strategic exploration, identifying and validating constraints, testing assumptions, defending choices and approaches, and making decisions. Cases are deliberately chosen such that conventional solutions are not immediately apparent, where procedural algorithms and instructional troubleshooting scripts are inadequate or unavailable, and for which exact solutions might not actually exist.",
    "credits": "3"
  },
  {
    "course_name": "Polytechnic International Experience",
    "dept": "COT",
    "num": "450",
    "desc": "Prerequisite: Instructor consent.\nSeminar and travel course including faculty-led international field experience focused on Polytechnic Campus students’ area of interest, with travel followed by a final project. The course is designed to enhance students’ global and cultural awareness while adding knowledge and skill in topical issues. In addition, students will be introduced to and immersed in historical components, both disciplinary and cultural.",
    "credits": "0-6"
  },
  {
    "course_name": "Professional Conduct, Ethics, and Analysis",
    "dept": "COT",
    "num": "480",
    "desc": "Prerequisite: Sophomore standing.\nExamines the ethical foundations of professional conduct and decision-making in the workplace. Through reading and discussing ethical works, case studies, and contemporary ethical policies/procedures, students will develop the skills necessary for analysis, discourse, and ethical decision-making in a professional work setting.",
    "credits": "3"
  },
  {
    "course_name": "Survey of Cryptography Development, Principles and Practice",
    "dept": "COT",
    "num": "490",
    "desc": "\nA practical survey of the principles and practice of cryptography with respect to business / government / private applications and commercial computer security systems. Benefits of cryptography as a strategic and tactical tool for effective computer security in the commercial theater of operations. Addresses current topics such as personal privacy, cryptocurrency and blockchain. Students interact with selected cryptographic machines, codes, hand-techniques and computer products developed since the beginning of writing.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Industrial Internship",
    "dept": "COT",
    "num": "495",
    "desc": "Prerequisite: Approval of faculty internship advisor and sponsoring company.\nAdvanced experiential learning program in an off-campus setting. Written documentation and oral presentation of project goals, experiences, and accomplishments.",
    "credits": "0-6"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "COT",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Advanced Problems in Arts, Sciences and Business",
    "dept": "COT",
    "num": "499",
    "desc": "Prerequisite: Consent of instructor.\nOpportunity for advanced independent study in specific subject areas in the Department of Arts, Sciences, and Business.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to and Overview of Aircraft Certification",
    "dept": "COT",
    "num": "611",
    "desc": "\nProvides an overview of the FAA certification process relating how the certification process contributes to a safe National Airspace System. Application of relevant Federal Aviation Regulations. Covers both aircraft type and production certification to include airframe, engine, and component certification.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Type Certification",
    "dept": "COT",
    "num": "622",
    "desc": "\nA detailed examination of the type conformity certification process leading to the issuance of airworthiness certification. Covers FAA and international conformity standards and regulating bodies as well as relevant Minimum Operating Performance Standards to include DO 160, 178, and 254. Presents the supplemental type certification process.",
    "credits": "3"
  },
  {
    "course_name": "Radio Frequency Technology for Unmanned Systems",
    "dept": "COT",
    "num": "632",
    "desc": "Prerequisite: Consent of instructor.\nAn introduction to the theory and design of electronic circuits for communications emphasizing the implementation and analysis of common radio-frequency (RF) building blocks. Topics include s-parameters, the Smith chart, component behavior, RF test equipment, computer simulation, filter design, impedance matching, amplifiers, oscillators, mixers, and demodulators.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Production Certification",
    "dept": "COT",
    "num": "634",
    "desc": "Prerequisite: COT 611.\nA detailed examination of the elements of the aircraft production certification process; including FAA surveillance designations, the application and approval process, the parts manufacturer approval process, production approval procedures, certificate management of production approval holders, and the technical standard order program.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Certification Project",
    "dept": "COT",
    "num": "636",
    "desc": "Prerequisite: COT 611 and COT 622.\nAn applied project focused on aircraft type or production certification. This course is designed to improve the demonstration of professional knowledge of aircraft certification processes.",
    "credits": "3"
  },
  {
    "course_name": "Analytical and Computational Tools for Unmanned Systems",
    "dept": "COT",
    "num": "650",
    "desc": "Prerequisite: One previous calculus course and consent of instructor.\nOrdinary differential equations, vector algebra, vector calculus, partial differential equations and the separation of variables technique for solving wave equations. Students also perform simulation and analysis using software tools including MATLAB and MATHCAD applied to Unmanned Systems.",
    "credits": "3"
  },
  {
    "course_name": "Airport Law",
    "dept": "COT",
    "num": "660",
    "desc": "\nA detailed study of how the U.S. regulatory and legal systems work in relation to airport management. This course emphasizes contract law related to the Federal Aviation Administration Airport covenants and restrictions, Federal Aviation Regulation compliance, and airport operator liability.",
    "credits": "3"
  },
  {
    "course_name": "Airport Planning and Management",
    "dept": "COT",
    "num": "661",
    "desc": "Prerequisite: Consent of instructor.\nAn overview of the Federal Aviation Regulation part 139 airport design standard and airport master planning process. Includes a study of the role of the airport in community development.",
    "credits": "3"
  },
  {
    "course_name": "UAS Flight Operations Management",
    "dept": "COT",
    "num": "663",
    "desc": "\nBest practices for managing complex operations of Unmanned Aircraft Systems (UAS) in the National Airspace System (NAS) including topics on: personnel and training, regulatory/policy considerations, airspace access, operating procedures, mission planning, system acquisitions, safety, customer relations, application-specific considerations, and data handling. Emphasis on the handling of unexpected delays and challenges to normal operations.",
    "credits": "3"
  },
  {
    "course_name": "UAS Program Management",
    "dept": "COT",
    "num": "664",
    "desc": "\nBest practices for top-level management of an Unmanned Aircraft Systems (UAS) program, including topics on: strategic planning, business model development, proposals, marketing, customer and government relations, personnel management, data handling and security, export control, regulatory environment, and operating procedures.",
    "credits": "3"
  },
  {
    "course_name": "Processing Techniques for Low-Altitude Remotely Sensed Data",
    "dept": "COT",
    "num": "674",
    "desc": "Prerequisite: AVT 460 or AVT 463 or consent of instructor.\nStudents learn techniques for exploring remotely sensed data using geographic information systems and image processing software. Topics include manipulation of vector and raster data, management of spatial databases, image stitching, georeferencing, orthorectification, the use and interpretation of metadata and “best practices” in data management techniques.",
    "credits": "3"
  },
  {
    "course_name": "Acquisition and Advanced Processing of LARS Data",
    "dept": "COT",
    "num": "675",
    "desc": "Prerequisite: COT 674.\nTopics begun in COT 674 are further developed. Advanced topics include: multi-spectral data acquisition and processing, exploitation of full-motion video, interpretation of geospatial and remotely sensed data, geostatistical methods of data analysis, photogrammetric measurements, and an introduction to big data concepts.",
    "credits": "3"
  },
  {
    "course_name": "Low-Altitude Remote-Sensing Product/Project Development",
    "dept": "COT",
    "num": "676",
    "desc": "Prerequisite: COT 675.\nBuilding on the skills acquired in COT 674 and 675, students fly a low-altitude remote-sensing mission to obtain geospatial data to process, manipulate, and analyze as the means of developing a finished product in areas of interest to the student. Potential areas of investigation include: precision agriculture, environmental remediation, fire management, wildlife studies, or stewardship of managed ecosystems.",
    "credits": "3"
  },
  {
    "course_name": "Unmanned Aircraft Systems and Risk Analysis",
    "dept": "COT",
    "num": "680",
    "desc": "\nAn introductory course in Unmanned Aircraft Systems (UAS) history, elements, US Aviation regulations, operations, use of geospatial data; automation, safety issues; detect and avoid systems; sensors and payloads, human factors, and future. Special attention to UAS Cyber Security Risks, Threats, Impact, Vulnerabilities, and Countermeasures will be identified. The Ryan-Nichols Risk Assessment equations will be used for qualitative risk analysis of Threats so identified.",
    "credits": "3"
  },
  {
    "course_name": "Open Source Cyber Surveillance",
    "dept": "COT",
    "num": "682",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Cyber Data Fusion",
    "dept": "COT",
    "num": "684",
    "desc": "\nThis course is scenario-based applying cyber surveillance techniques and analysis of collected data, to realistic, terrain-oriented problems. Topics include the digital soldier and sailor, 360-degree battlefield awareness and the use of unmanned, semiautonomous technologies. Risk Assessment and Cyber Security countermeasures are the “glue” to successful implementation of data fusion techniques. The Ryan-Nichols Risk Assessment equations and other methods will be used for qualitative risk analysis of identified Cyber Threats.",
    "credits": "3"
  },
  {
    "course_name": "Risk Management for UAS Operators, Pilots, and Ground Personnel",
    "dept": "COT",
    "num": "686",
    "desc": "\nUAS Operators, Pilots, and Ground Personnel must be committed to safety if the goal of UAS integration into NAS is to be accomplished. The best tool for assessment and determination of safest possible flight is Risk Management. This course introduces three risk assessment tools for UAS Operators, Pilots, and Ground Personnel to manage the workloads associated with each phase of flight.",
    "credits": "3"
  },
  {
    "course_name": "Sense and Avoid Technologies in UAS",
    "dept": "COT",
    "num": "688",
    "desc": "\nAn advanced course in Sense and Avoid (SAA) technologies for UAS. SAA is an extremely important concept and is the main obstacle for wider application of UAS in non-segregated airspace related to traffic safety in civilian and military/defense domains. This course presents the state-of-the-art research results from British, American, Australian and European universities, as well as corporate organizations such as Boeing and MITRE.",
    "credits": "3"
  },
  {
    "course_name": "Conduct and Ethics for Cybersecurity and UAS Professionals",
    "dept": "COT",
    "num": "689",
    "desc": "\nExplores the constitutional, legal, personal and public policy fundamentals associated with the field of cyber data collection, fusion, integration, and UAV surveillance.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Technical Communication",
    "dept": "COT",
    "num": "701",
    "desc": "Prerequisite: Consent of instructor.\nIntensive writing practice, applying rhetorical principles to a number of genres common to non-academic professions and workplaces, including oral presentations. Introduction to allied topics such as document design and editing, crafting technical presentations. Application of global information literacy and research methods, culminating in the preparation of a master’s project proposal.",
    "credits": "3"
  },
  {
    "course_name": "Applied Research Skills and Methods",
    "dept": "COT",
    "num": "702",
    "desc": "\nSurvey of qualitative and quantitative research methods; use of a range of tools to develop applied research skills focusing on literature reviews. Examines applied research concepts, methods, and skills to foster enlightened decision making in professional practice.",
    "credits": "3"
  },
  {
    "course_name": "Project Management for Professionals",
    "dept": "COT",
    "num": "703",
    "desc": "\nThis course focuses on applied project management methodology, tools, and techniques. Topics include career aspects of project management; business factors affecting the project; project organization, planning, execution, and communications; the project life cycle; risk analysis; and best practices in project management.",
    "credits": "3"
  },
  {
    "course_name": "Managerial Finances, Metrics, and Analytics",
    "dept": "COT",
    "num": "704",
    "desc": "\nProvides an overview of an organization’s financial statements, with an emphasis on the interaction between people in management positions and those statements, as well as an examination of the business investment decision-making process. Explores the use of metrics and analytics to measure and improve managerial performance.",
    "credits": "3"
  },
  {
    "course_name": "Transformational Leadership for Technology",
    "dept": "COT",
    "num": "705",
    "desc": "\nStudy and application of leadership styles and common leader traits skills and behaviors needed in technology industries and dynamic environments where innovation is a key success factor. Includes application in virtual team environments, and introduces concepts of transformational leadership. This course enables students to build group vision, values, and commitment and to make connections between diverse organizational cultures, leadership styles, and business strategies that enable success in a rapidly changing technology world. Students develop lifelong learning networks and information sources that enable them to continue to grow as leaders.",
    "credits": "3"
  },
  {
    "course_name": "Informatics and Technology Management",
    "dept": "COT",
    "num": "706",
    "desc": "\nProvides theoretical and practical experience in using information technology to support organizational decision-making processes. Provides tools in areas such as statistics, research methods, data mining, and information technology to develop solutions tailored to business problems.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Aviation Safety Management",
    "dept": "COT",
    "num": "713",
    "desc": "Prerequisite: Consent of instructor.\nThis course examines the development of safety and provides the student with an understanding of how safety management has become an important part of any company. Discussions emphasize Safety Management Systems and how this blueprint is becoming an integral part of most organizations. Various governmental and corporate programs will be discussed. Students will be exposed to various management tools and techniques to aid in systematically controlling risk and developing a safety culture mind-set.",
    "credits": "3"
  },
  {
    "course_name": "Application of Lean Six Sigma Methods",
    "dept": "COT",
    "num": "720",
    "desc": "Prerequisite: Consent of instructor.\nSix sigma and lean tools within an enterprise to improve product and process development, production operations, and service activities.",
    "credits": "3"
  },
  {
    "course_name": "Electromagnetics for Unmanned Systems",
    "dept": "COT",
    "num": "731",
    "desc": "Prerequisite: Consent of instructor.\nFundamentals of electromagnetic wave phenomena primarily using transmission line theory to study practical applications such as antennas, cables, and waveguides. Includes a treatment of EMI and related issues.",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Manufacturing and Materials",
    "dept": "COT",
    "num": "741",
    "desc": "Prerequisite: Consent of instructor.\nAn introduction to aerospace manufacturing and materials processes that focus on understanding manufacturing applied to the production of   aerospace vehicles and associated materials.",
    "credits": "3"
  },
  {
    "course_name": "Professional Master of Technology International Experience",
    "dept": "COT",
    "num": "750",
    "desc": "Prerequisite: Instructor Consent.\nSeminar and travel course including faculty-led international field experience focused on Professional Master of Technology students’ area of interest, with travel followed by a final project. The course is designed to enhance students’ global and cultural awareness while adding knowledge and skill in topical issues.  In addition, students will be introduced to and immersed in historical components, both disciplinary and cultural.",
    "credits": "0-6"
  },
  {
    "course_name": "Material Properties of Bulk Solids",
    "dept": "COT",
    "num": "770",
    "desc": "Prerequisite: Industry experience or consent of instructor.\nCovers material properties related to bulk solids handling such as particle density, bulk density, particle hardness, surface area, particle size and shape and its distribution, porosity and permeability. Additional material property topics include moisture content, temperatures, RH, explosiveness, cohesion and adhesion, angle of internal friction, wall friction, angle of repose, time consolidation, unconfined yield strength, shear strength and more.  Sampling and measurement techniques of materials are also included.",
    "credits": "3"
  },
  {
    "course_name": "Storage and Flow of Bulk Solids",
    "dept": "COT",
    "num": "771",
    "desc": "Prerequisite: Industry experience or consent of instructor.\nCovers topics related to storage and flow of bulk solids which include design of hopper , bin, chute, and feeders.  A study of solid flow problems such as cohesive arching, ratholing, bridging, and shear tester operational principles is included.",
    "credits": "3"
  },
  {
    "course_name": "Pneumatic Conveying of Bulk Solids",
    "dept": "COT",
    "num": "772",
    "desc": "Prerequisite:  Industry experience or consent of instructor.\nCovers topics such as types and components of pneumatic conveying systems and its design principles. Trouble shooting, pipe wear and attrition, dust control are included.",
    "credits": "3"
  },
  {
    "course_name": "Instrumentation and Safety of Bulk Solids Handling",
    "dept": "COT",
    "num": "773",
    "desc": "Prerequisite:  Industry experience or consent of instructor.\nExamines various instrumentation used in bulk solids handling operation such as measurement of airflow, pressure, temperature, level and measuring techniques. Different type valves, PLC control and safety are included.",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Conveying of Bulk Solids",
    "dept": "COT",
    "num": "774",
    "desc": "Prerequisite: Industry experience or consent of instructor.\nCovers topics such as types and components of bucket elevator, screw conveyor, drag and belt conveying systems and their design principles. Different aspects of designing each component of these systems with examples and troubleshooting will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "UAS and High Altitude Platforms (HAPS) for Wireless Communications",
    "dept": "COT",
    "num": "780",
    "desc": "Prerequisite: Graduate Status.\nAn introductory course to HAPS technology applied in the civilian UAS sector. Covers technologies, communications, and protection of those computer communications from hostile intent. HAPS technology provides wireless narrowband and broadband telecommunications and broadcasting services to users using either aircraft (unmanned (UAS/UAV) or manned) or lighter-than-airships (LTA). Research indicates UAS to be the best alternative. These platforms are reusable and positioned at stratospheric altitudes, from approximately 12.4 miles to 31 miles (20 to 50 km).",
    "credits": "3"
  },
  {
    "course_name": "Capstone Experience for Professional Master of Technology",
    "dept": "COT",
    "num": "781",
    "desc": "Prerequisite: Consent of instructor.\nStudents formulate, research and execute a project for industry partners to gain hands-on experience under expert guidance while integrating knowledge to solve complex problems. Students write a convincing proposal for a capstone experience, gather and analyze data, draw conclusions and present results. Teams of first- and second-year students may form to work on real-world projects.",
    "credits": "1-6"
  },
  {
    "course_name": "Problems in Professional Master of Technology",
    "dept": "COT",
    "num": "792",
    "desc": "Prerequisite: Consent of instructor.\nOpportunity for advanced independent study of a specific topic in one of the following areas: Aviation safety, engineering technology, or technology management. Topics selected jointly by student and the instructor.",
    "credits": "0-3"
  },
  {
    "course_name": "Special Topics in Professional Master of Technology",
    "dept": "COT",
    "num": "799",
    "desc": "Prerequisite:  Varies with announced topic.\nAdvanced topics in Professional Master of Technology.",
    "credits": "0-6"
  },
  {
    "course_name": "Medicine I",
    "dept": "CS",
    "num": "709",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nConsideration of medical and pathophysiologic aspects of diseases affecting the urinary, endocrine, integumentary, respiratory, hemic and neuromuscular systems.",
    "credits": "4"
  },
  {
    "course_name": "Medicine III",
    "dept": "CS",
    "num": "710",
    "desc": "Prerequisite: CS 709.\nA study of the etiology, clinical signs, diagnosis, treatment, and control of common diseases which affect horses.",
    "credits": "3"
  },
  {
    "course_name": "Medicine II",
    "dept": "CS",
    "num": "711",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nConsideration of the medical and pathophysiological aspects of diseases affecting the gastrointestinal, cardiovascular, and ophthalmic systems, oncology, and dentistry.",
    "credits": "4"
  },
  {
    "course_name": "Food Animal Medicine",
    "dept": "CS",
    "num": "712",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nA study of the etiology clinical signs, diagnosis, treatment and control of diseases which affect cattle, swine, and sheep.",
    "credits": "4"
  },
  {
    "course_name": "Beef Production Medicine",
    "dept": "CS",
    "num": "713",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nThe role of the veterinarian in livestock production units, including interactions with producers, nutritionists, investors and others in decision analysis. Emphasis is on the professional services that veterinarians provide to beef production systems.",
    "credits": "1"
  },
  {
    "course_name": "Clinical Nutrition",
    "dept": "CS",
    "num": "714",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine or graduate student.\nA focus on practical aspects of nutrition as it relates to performance, health and animal well-being of food-producing animals and, programs designed for health and well-being of small animals including exotic animals. Nutritional aspects of the mechanisms of health and disease are taught primarily at the individual and population level with some molecular and cellular aspects included. Designed for all students to be able to properly nourish animals in their care during their career.",
    "credits": "2"
  },
  {
    "course_name": "Radiology",
    "dept": "CS",
    "num": "715",
    "desc": "Prerequisite: Second-year standing in the College of Veterinary Medicine.\nThe theory and principles of x-rays, production and interpretation of radiographs and exposure factors, special radiographic methods, film storage and handling, processing, safety measures, and biologic effects of radiation.",
    "credits": "3"
  },
  {
    "course_name": "Supplemental Equine Theriogenolgy",
    "dept": "CS",
    "num": "720",
    "desc": "Prerequisite: Fourth year standing in the College of Veterinary Medicine.\nAn in-depth exposure to methods of maximizing reproductive efficiency in the mare and the stallion. Advanced equine reproductive physiology, diagnostics, and therapeutics are emphasized.",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Surgery I Laboratory",
    "dept": "CS",
    "num": "721",
    "desc": "Prerequisite: Concurrent with or successful completion of CS 729.\nIntroduction to the basics of veterinary anesthesia, surgical techniques, and patient management by a systems design.  Problems common to all species of domestic animals will be presented to provide foundations of surgical knowledge and experience.",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Surgery II Laboratory",
    "dept": "CS",
    "num": "722",
    "desc": "\nA continuation of Veterinary Surgery I Lab. Introduction to the basics of veterinary anesthesia, surgical techniques, and patient management by a systems design. Problems common to all species of domestic animals will be presented to provide foundations of surgical knowledge and experience.",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Diagnostic Imaging I",
    "dept": "CS",
    "num": "724",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nRadiographic, ultrasonographic and nuclear imaging in the clinical setting, with emphasis on making/identifying images of diagnostic quality, interpretation, indications for imaging, and radiation safety.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Anesthesia",
    "dept": "CS",
    "num": "725",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nPractical instruction in the skills and techniques used in the practice of clinical veterinary anesthesia of both large and small animals.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Externship and/or Programmed Study",
    "dept": "CS",
    "num": "726",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine and the approval of the externship or program of study by the course coordinator.\nProvides the professional student with the opportunity to study with specialists not available at Kansas State University or in unique areas of veterinary medical practice or research.",
    "credits": "1-3"
  },
  {
    "course_name": "Ophthalmology",
    "dept": "CS",
    "num": "727",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nThe study of the surgery and medical diagnosis and treatment of ocular disease in animals in the setting of the Veterinary Health Center. Problem solving, differential diagnosis, diagnostic procedures and medical and surgical therapy will be emphasized using veterinary patients.",
    "credits": "2"
  },
  {
    "course_name": "Theriogenology",
    "dept": "CS",
    "num": "728",
    "desc": "Prerequisite: Third-year standing in College of Veterinary Medicine or graduate student.\nConsideration of prevention, diagnosis, and treatment of disease, and maintenance of health and productivity of the genital tract of domestic animals.",
    "credits": "3"
  },
  {
    "course_name": "Veterinary Surgery I",
    "dept": "CS",
    "num": "729",
    "desc": "Prerequisite: Satisfactory completion of all required second year veterinary courses.\nIntroduction to the basics of veterinary anesthesia, surgical techniques, and patient management by a systems design. Problems common to all species of domestic animals will be presented to provide foundations of surgical knowledge and experience.",
    "credits": "4"
  },
  {
    "course_name": "Veterinary Surgery II",
    "dept": "CS",
    "num": "730",
    "desc": "\nA continuation of Veterinary Surgery I. Introduction to the basics of veterinary anesthesia, surgical techniques, and patient management by a systems design. Problems common to all species of domestic animals will be presented to provide foundations of surgical knowledge and experience.",
    "credits": "3"
  },
  {
    "course_name": "Diagnostic Techniques in Equine Medicine",
    "dept": "CS",
    "num": "732",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nThis elective course emphasizes the techniques needed for internal medicine. Lectures and labs covering endoscopy, bronchoalveolar lavage, transtracheal wash, ultrasound, spinal tap, dentistry and epidural will emphasize skills, indications, and complications.",
    "credits": "1"
  },
  {
    "course_name": "Pleasure Horse Medicine",
    "dept": "CS",
    "num": "736",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nThis course is intended to present topics of interest to equine interested veterinary students. The objectives of the course will focus on diagnosis and clinical management as will be performed in practice. The primary goal of the course is to supplement the equine interested veterinary student with topics that are not offered in the core curriculum, yet will be encountered in an equine or mixed practice setting. The format will use a case and problem-based discussion to present and apply clinically relevant information.",
    "credits": "1"
  },
  {
    "course_name": "Exotic Pet Medicine",
    "dept": "CS",
    "num": "737",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nEntry-level knowledge base for the species likely to be encountered in a private practice setting including snakes/small reptiles, caged birds, and small mammals (ferrets, gerbils, hamsters, chinchillas).",
    "credits": "2"
  },
  {
    "course_name": "Clinical Oncology",
    "dept": "CS",
    "num": "738",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nThe approach to diagnosis and treatment of cancer-bearing patients will be emphasized. Skills to master include fine needle aspirates and basic cytology, biopsy techniques (punch, wedge, pinch and tru-cut), bone marrow aspirate and core biopsy procedures and chemotherapy administration. A greater depth of understanding of the biologic behavior and treatment options of commonly seen tumor types (lymphoma, mast cell tumors, hemangiosarcoma, osteosarcoma, etc.) and chemotherapy safety will be emphasized. Medical management of cancer-related problems as well as treatment of therapy-induced side effects will also be covered.",
    "credits": "2"
  },
  {
    "course_name": "Dermatology/Medicine",
    "dept": "CS",
    "num": "739",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nDesigned to emphasize dermatology diagnostic work-up and management of dermatologic cases. May include proper techniques for performing procedures such as skin scraping, bacterial and fungal culturing, performing cytology, obtaining skin biopsies, ear clearing and trichography.",
    "credits": "2"
  },
  {
    "course_name": "Topics in Emergency Medicine",
    "dept": "CS",
    "num": "740",
    "desc": "Prerequisite: Third year standing in the College of Veterinary Medicine and CS 811 “Basic Concepts in Emergency and Critical Care Medicine.”\nPresentations of cases in the ICU or cases that were recently seen on emergency. Current literature that is relevant to the case will be discussed.",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Practice Management",
    "dept": "CS",
    "num": "741",
    "desc": "\nThis course provides a foundation in business management and marketing to prepare veterinary students for success in private veterinary practice. Lectures include personal marketing, business organizational structure, gauging and monitoring production, management practice finance, recruitment, personnel management, effective practice marketing (internal and external), achieving better client satisfaction and retention, and the road to practice ownership.",
    "credits": "1"
  },
  {
    "course_name": "Clinical Skills",
    "dept": "CS",
    "num": "742",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nDemonstration, instruction and experience in physical examination and diagnostic skills necessary for routine veterinary practice.",
    "credits": "0-1"
  },
  {
    "course_name": "Clinical Equine Theriogenology",
    "dept": "CS",
    "num": "746",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nStudents will participate in routine procedures that develop skills in handling horses, rectal exams, ultrasonography, semen collection, artificial insemination, uterine therapies and minor surgical procedures.",
    "credits": "2"
  },
  {
    "course_name": "Livestock Local Practice",
    "dept": "CS",
    "num": "748",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nA study of the role of the veterinarian in the practice of clinical medicine in livestock production units. Students will work under faculty supervision in ambulatory and local practice settings.",
    "credits": "2"
  },
  {
    "course_name": "Livestock Medicine & Surgery",
    "dept": "CS",
    "num": "749",
    "desc": "Prerequisite: Fourth-year standing in College of Veterinary Medicine.\nA study of individual livestock medicine and surgery. Students will work under faculty supervision in an in-house setting.",
    "credits": "2"
  },
  {
    "course_name": "Equine Medicine",
    "dept": "CS",
    "num": "750",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nThis course will offer general exposure to equine internal medicine and theriogenology. Students will be responsible for diagnoses, treatment and nursing care of out-patients, in-patients, and emergency duties.",
    "credits": "2"
  },
  {
    "course_name": "Equine Surgery",
    "dept": "CS",
    "num": "751",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nThis course will offer general exposure to equine surgery and theriogenology. Students will be responsible for diagnoses, treatment, and nursing care of out-patients, in-patients, and emergency duties.",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Internal Medicine",
    "dept": "CS",
    "num": "752",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nThe study of internal medicine in the setting of the Veterinary Medical Teaching Hospital. Students will be engaged in the diagnosis and management of complex cases referred to the internal medicine service.",
    "credits": "3"
  },
  {
    "course_name": "Small Animal General Medicine",
    "dept": "CS",
    "num": "753",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nThe study of preventative medicine, general practice medicine, and specialty medicine. Students spend three weeks with the Pet Health Center learning the various aspects of outpatient services.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Small Animal Soft Tissue Surgery",
    "dept": "CS",
    "num": "754",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nThis course is designed to train senior or elective veterinary students in the diagnosis and treatment of small animal soft tissue and general surgical diseases through participation in the Small Animal Soft Tissue Service of the Veterinary Health Center.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Small Animal Orthopedic Surgery",
    "dept": "CS",
    "num": "755",
    "desc": "Prerequisite: Fourth-year standing in College of Veterinary Medicine.\nCourse is designed to train senior or elective veterinary students in the diagnosis/treatment of small animal orthopedic surgical diseases though the Orthopedic Service of the Veterinary Health Center.",
    "credits": "3"
  },
  {
    "course_name": "Comparative Cardiology",
    "dept": "CS",
    "num": "756",
    "desc": "Prerequisite: Fourth-year standing in College of Veterinary Medicine.\nDesigned to expose students to the cardiovascular system of domestic animals, emphasizing clinical management and understanding of common congenital and acquired cardiac diseases.",
    "credits": "2"
  },
  {
    "course_name": "Equine Lameness I",
    "dept": "CS",
    "num": "757",
    "desc": "Prerequisite: Satisfactory completion of all required second year veterinary courses.\nLectures will cover common causes of lameness emphasizing specific portions of the lameness exam providing the foundation for diagnosis and treatment of specific equine musculoskeletal diseases.  Students will perform lameness exams including diagnostic imaging to correctly diagnose the “unknown lameness” and prescribe appropriate therapeutic options.",
    "credits": "1"
  },
  {
    "course_name": "Equine Lameness II",
    "dept": "CS",
    "num": "758",
    "desc": "Prerequisite: CS 757.\nA continuation of Equine Lameness I. This course will complete the review of the most common lameness problems in horses.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Exotic Pet Medicine",
    "dept": "CS",
    "num": "759",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nAdvanced study of the diseases, medicine, and captive management of non-traditional species including companion birds, reptiles, rabbits, ferrets, and rodents.",
    "credits": "1"
  },
  {
    "course_name": "Topics in Global Veterinary Medicine",
    "dept": "CS",
    "num": "760",
    "desc": "Prerequisite: 1st or 2nd year standing in the College of Veterinary Medicine, or enrolled as a graduate student with instructor permission.\nAn overview of the role of veterinarians around the world. Topics include international uses and attitudes about animals, problems the world faces pertaining to livestock production, and social tensions.",
    "credits": "1"
  },
  {
    "course_name": "Supplemental Small Animal Emergency",
    "dept": "CS",
    "num": "762",
    "desc": "Required Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nAn opportunity to pursue additional training in the management of small animal patients presented to the emergency services.  Evaluation, management, and monitoring of small animal patients in the intensive care unit.",
    "credits": "2-4"
  },
  {
    "course_name": "Laboratory Animal Medicine",
    "dept": "CS",
    "num": "763",
    "desc": "Prerequisite: DMP 759 or requires coordinator approval. Fourth-year standing in the College of Veterinary Medicine.\nThe study of laboratory animal medicine or comparative medicine to include colony health monitoring, preventive medicine, surgery, investigator support, and regulatory oversight.",
    "credits": "2"
  },
  {
    "course_name": "Beef Cattle Breeding Evaluation",
    "dept": "CS",
    "num": "764",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nFemale breeding soundness and pregnancy detection in beef cattle through rectal palpation with and without ultrasound technology. Some discussions of infectious diseases that impair reproduction.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Food Animal Practice",
    "dept": "CS",
    "num": "765",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nAdvanced food animal medicine, surgery, reproduction, and herd health in an integrated format. Students are placed into a practice setting where individual food animal practice is placed in context with production medicine/herd health activities. Field trips and problem-solving exercises applying concepts of production analysis, disease prevention and feedlot management.",
    "credits": "3"
  },
  {
    "course_name": "Pre-Clinical Food Animal (Mixed) Practice Mentorship",
    "dept": "CS",
    "num": "766",
    "desc": "Prerequisite: First, second, or third year standing in the College of Veterinary Medicine.\nStructured one week (45 contact hours) mentorship in a large animal (bovine) practice designed to promote clinical skills training in a private practice setting with practitioners who have expressed an interest in training and mentoring veterinary students.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Clinical Small Animal Practice Mentorship",
    "dept": "CS",
    "num": "767",
    "desc": "Prerequisite: First, second, or third year standing in the College of Veterinary Medicine.\nStructured one week (45 contact hours) mentorship in a small animal practice designed to promote clinical skills training in a private practice setting with practitioners who have expressed an interest in training and mentoring veterinary students.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Clinical Non-Traditional Practice Mentorship",
    "dept": "CS",
    "num": "768",
    "desc": "Prerequisite: First, second, third year standing in the College of Veterinary Medicine.\nStructured one week (45 contact hours) mentorship in a nontraditional veterinary setting designed to promote skills training and awareness of nontraditional or exclusive practice experiences in a private or public practice setting with veterinarians who have expressed an interest in training and mentoring veterinary students.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Feedlot Production Management",
    "dept": "CS",
    "num": "769",
    "desc": "Prerequisite: Fourth-year standing in College of Veterinary Medicine.\nStudents desiring feedlot/stocker production training. Focus on effects of nutrition, preventative medicine, environment, personnel training and other issues on the health of growing/finishing cattle.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Cow-Calf Production Management",
    "dept": "CS",
    "num": "770",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nFor students desiring in-depth cow-calf production training including management and assessment of production data, nutrition and ration balancing, reproductive strategies, quality assurance and economic and Standardized Performance Analysis of cow-calf enterprises.",
    "credits": "2"
  },
  {
    "course_name": "General Dentistry",
    "dept": "CS",
    "num": "771",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nSkills and concepts common to general dentistry practice in the feline and canine, pre-operative exams, day-long wet lab to take and interpret digital intraoral radiographs, extract teeth, and perform dental nerve blocks. Also may participate in the evaluation, diagnosis, and treatment of primary care patients.",
    "credits": "1"
  },
  {
    "course_name": "Equine Field Service",
    "dept": "CS",
    "num": "772",
    "desc": "Prerequisite: Fourth-year standing in College of Veterinary Medicine.\nThis course will offer general exposure to equine field service and theriogenology. Students will be responsible for diagnoses, treatment, and nursing care of out-patients, in-patients and emergency duties.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Veterinary Phytotherapy",
    "dept": "CS",
    "num": "773",
    "desc": "Prerequisite: AP 770, DMP 801, third-year standing in College of Veterinary Medicine.\nFundamentals of phytotherapy: traditions of herbal medicine, evaluating research, regulation of products, interactions with conventional drugs, introduction to medical botany, conserving medicinal plant species, issues using medicinal plants within evidence-based veterinary medicine.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Rural Food Animal Business Management",
    "dept": "CS",
    "num": "774",
    "desc": "Prerequisite: Fourth-year standing in College of Veterinary Medicine.\nAn elective course that incorporates economic and food animal practice management skills. Course will focus on business aspects of agricultural industries and skills to manage a food animal practice.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Urinary",
    "dept": "CS",
    "num": "776",
    "desc": "Prerequisite: Third year standing in the College of Veterinary Medicine.\nThis elective builds on the case-based urinary section of CS 711.  Focus of the class will be on the disease pathophysiology and treatment.",
    "credits": "1"
  },
  {
    "course_name": "Practicing Veterinary Medicine in a Multicultural Society",
    "dept": "CS",
    "num": "777",
    "desc": "Prerequisite: First, second or third year standing in the College of Veterinary Medicine.\nDiversity in the broadest sense of the word (cultural, racial, sexual, gender, age, religious, etc.) will be explored in the context of the practice of veterinary medicine. Understanding diversity issues can positively affect the bottom line of nearly every veterinary practice.",
    "credits": "1"
  },
  {
    "course_name": "The Basics of Bovine Theriogenology",
    "dept": "CS",
    "num": "778",
    "desc": "Prerequisite: First, second or third year standing in the College of Veterinary Medicine.\nThis class is designed to provide students enrolled in the veterinary curriculum a very practical knowledge base regarding bovine reproduction.",
    "credits": "1"
  },
  {
    "course_name": "Clinical Pharmacology",
    "dept": "CS",
    "num": "779",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nCourse focuses on the clinical application of drugs in veterinary species. Clinical pharmacologists and clinicians from multiple clinical specialties will focus on commonly used drugs. Students will be expected to review and build upon their previous pharmacology and medicine courses. Emphasis will be placed on administration (including routes, dosing calculations, and methods), avoiding adverse drug reactions and interactions, evaluating patient response, written and verbal client communication, and utilizing reference resources to select and properly use veterinary therapeutics.",
    "credits": "2"
  },
  {
    "course_name": "Food Animal Reproduction",
    "dept": "CS",
    "num": "780",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nStudents will get hands-on experience and become competent performing a complete Breeding Soundness Exam. Other reproductive topics will be covered.",
    "credits": "2"
  },
  {
    "course_name": "Shelter Medicine",
    "dept": "CS",
    "num": "781",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nThe rotation will be a combination of in-class and laboratory exercises in Manhattan, and hands-on experiences at regional shelters. Topics include population medicine, infectious disease recognition and control, surgical sterilization, behavioral testing, and legal issues common to shelter settings.",
    "credits": "2"
  },
  {
    "course_name": "Equine Medicine Elective",
    "dept": "CS",
    "num": "782",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nThis course is designed to be complementary to CS 710. The material presented in this class will focus on diagnostic procedures and case presentations that will not be covered in the core curriculum.",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Care and Management of South American Camelids",
    "dept": "CS",
    "num": "785",
    "desc": "Prerequisite: First, second or third year standing in the College of Veterinary Medicine.\nThis course will provide detailed information regarding nutrition, herd health, breeding management, medicine, neonatal care, and surgical problems of llamas and alpacas.",
    "credits": "3"
  },
  {
    "course_name": "The Learning Curve of Equine Practice",
    "dept": "CS",
    "num": "786",
    "desc": "Prerequisite: Second or third-year standing in the College of Veterinary Medicine.\nElective will cover various aspects of equine practice, not usually covered in traditional didactic lectures. Topics include equine husbandry, communication issues and insurance, horse colors, genetics, and genetic related diseases, aspects of equine practice and practice management, drug and medication rules for performance horses, and preventative medicine.",
    "credits": "1"
  },
  {
    "course_name": "Pain Management",
    "dept": "CS",
    "num": "787",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nDiscussion of the mechanisms of pain, certain pain syndromes, and the drugs and techniques available to provide analgesia.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Equine Studies",
    "dept": "CS",
    "num": "788",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nStudents will have opportunities for routine and advanced clinical skills training and case management. Course discussions and case presentations will be targeted for the equine interested student and will therefore present advanced material; case discussion and rounds materials.",
    "credits": "4"
  },
  {
    "course_name": "Surgical Skills",
    "dept": "CS",
    "num": "793",
    "desc": "Prerequisite: CS 721 - Surgery I Laboratory and 3rd year standing in the College of Veterinary Medicine.\nManual surgical skills will be taught using surgical models and cadaver tissues. Students will be taught the following skills and techniques: instrument handling, speed and efficiency, hand ties, ligature under tension, suture patters, closure under tension, anastomosis and enterotomy technique and excision of circular lesions.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Concepts in Veterinary Clinical Anesthesia",
    "dept": "CS",
    "num": "794",
    "desc": "Prerequisite: CS 729 - Veterinary Surgery I and third-year standing in the College of Veterinary Medicine.\nThe lectures will be divided among topics to enhance student preparation for practical clinical application of anesthetic principles in both small and large animal environments. Topics: anesthetic implications for certain disease states, management of intraoperative complications, and special topics in large animal anesthesia.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Surgical Experience",
    "dept": "CS",
    "num": "795",
    "desc": "Prerequisite: Fourth-standing in the College of Veterinary Medicine; CS 754.\nDesigned to increase exposure to soft tissue surgical theories and techniques by providing both hands-on surgical experience on cadavers and literature review skills.",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Emergency Rotation",
    "dept": "CS",
    "num": "796",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nEnhanced training in the management of small animal patients presented to the emergency service. Evaluation, management, and monitoring of small animal patients in the intensive care unit.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Bovine Palpation",
    "dept": "CS",
    "num": "799",
    "desc": "Prerequisite: 4th year standing in the College of Veterinary Medicine.\nProvide numerous opportunities for the student to learn how to identify the different structures of the bovine reproductive tract through rectal palpation and transrectal ultrasound, accurately diagnose pregnancy both manually and via ultraonography, and to identify various bovine reproductive abnormalities.",
    "credits": "2"
  },
  {
    "course_name": "Communication Sciences and Disorders",
    "dept": "CSD",
    "num": "343",
    "desc": "\nA survey of normal communication processes and communication disorders and an introduction to the fields of speech pathology and audiology that are responsible for the clinical management of these disorders.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Phonetics",
    "dept": "CSD",
    "num": "347",
    "desc": "Prerequisite: CSD major, completion of 57 credit hours and an overall 3.0 GPA, including both K-State and transfer course work.\nBasic information about speech sounds and their use in human languages, including physiological, perceptual, and acoustic phonetics. Transcription of English will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Anatomy of the Speech Mechanism",
    "dept": "CSD",
    "num": "360",
    "desc": "Prerequisite: CSD major, completion of 57 credit hours and an overall 3.0 GPA, including both K-State and transfer course work.\nAnatomy of the structures involved in speech production. The course includes histology of the larynx and an overview of speech physiology.",
    "credits": "4"
  },
  {
    "course_name": "Hearing Science",
    "dept": "CSD",
    "num": "361",
    "desc": "Prerequisite: CSD major, completion of 57 credit hours and an overall 3.0 GPA, including both K-State and transfer course work.\nAn introduction to hearing science concepts. Areas of focus include anatomy and physiology of the hearing mechanism, quantification of sound, sound generation, and sound transmission. Information on the role of the auditory system in the encoding and processing of simple and complex signals is also presented.",
    "credits": "3"
  },
  {
    "course_name": "Developmental Psycholinguistics",
    "dept": "CSD",
    "num": "442",
    "desc": "Prerequisite: CSD major, completion of 57 credit hours and an overall 3.0 GPA, including both K-State and transfer course work.\nReview of research and theory of early development of language comprehension and production, involving vocalization, phonology, morphology, syntax, semantics, and pragmatics. Includes discussion of the relationship between cognition and language, as well as other variables influencing language acquisition.",
    "credits": "3"
  },
  {
    "course_name": "Language Assessment and Intervention I",
    "dept": "CSD",
    "num": "443",
    "desc": "Prerequisite: CSD major, completion of 57 credit hours and an overall 3.0 GPA, including both K-State and transfer course work.\nThe characteristics and nature of language disorders in the preschool-age populations, as well as general principles of language assessment and intervention are presented. Specific language assessment and intervention procedures for individuals 0-8 years of age are reviewed. Communication profiles associated with a variety of language impairments are examined.",
    "credits": "3"
  },
  {
    "course_name": "Disorders of Articulation and Phonology",
    "dept": "CSD",
    "num": "446",
    "desc": "Prerequisite: CSD major, completion of 57 credit hours and an overall 3.0 GPA, including both K-State and transfer course work.\nTheory, research, and principles of (a) normal/abnormal phonetic and phonologic development, (b) transcription of speech sound disorders, (c) assessment of speech sound disorders, and (d) intervention for speech sound disorders.",
    "credits": "4"
  },
  {
    "course_name": "Laboratory in Acoustic Phonetics",
    "dept": "CSD",
    "num": "515",
    "desc": "Prerequisite: CSD 347 and senior standing.\nThe study of speech perception and production through acoustic analysis. Laboratory experience in the use of computer-based speech analysis systems.",
    "credits": "1"
  },
  {
    "course_name": "Clinical Procedures in Communication Disorders",
    "dept": "CSD",
    "num": "549",
    "desc": "Prerequisite: Senior, CSD major,  CSD 443, CSD 446.\nOrientation to clinical practicum. Opportunities for clinical observation of speech, language, and hearing evaluation and treatment. Study of diagnostic tools, treatment materials, equipment, and clincial procedures.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Research in Communication Sciences and Disorders",
    "dept": "CSD",
    "num": "560",
    "desc": "Prerequisite: STAT 325 or equivalent, CSD 443 and 446 or instructor permission.\nLogic and methods of clinical research with emphasis on those most frequently used in speech-language pathology and audiology. Experience reading, planning, and evaluating research.",
    "credits": "3"
  },
  {
    "course_name": "Basic Audiology",
    "dept": "CSD",
    "num": "567",
    "desc": "Prerequisite: CSD major, completion of 57 credit hours and an overall 3.0 GPA, including both K-State and transfer course work.\nAn introduction to audiology concepts and basic audiology testing procedures. Areas covered include disorders of the auditory system, testing procedures, and audiometric interpretation.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Topics in Communication Sciences and Disorders",
    "dept": "CSD",
    "num": "591",
    "desc": "Prerequisite: Consent of instructor.\nReview of current topics in speech-language pathology and/or audiology.",
    "credits": "0-3"
  },
  {
    "course_name": "Practicum in Speech-Language Pathology",
    "dept": "CSD",
    "num": "705",
    "desc": "Prerequisite: CSD 549.\nSupervised practice in the use of the methods and materials of speech-language pathology.",
    "credits": "1-3"
  },
  {
    "course_name": "Practicum in Audiology",
    "dept": "CSD",
    "num": "706",
    "desc": "Prerequisite: CSD 567.\nSupervised practice in the use of equipment, materials, and methods of audiology.",
    "credits": "1-3"
  },
  {
    "course_name": "Augmentative and Alternative Communication",
    "dept": "CSD",
    "num": "725",
    "desc": "Prerequisite: CSD 360 and CSD 549.\nThis course examines the area of augmentative and alternative communication (AAC) for people across the lifespan. The etiologies and communicative needs of current and prospective users of AAC, as well as procedures for evaluation are addressed. The course includes strategies and procedures for implementing AAC systems for people who are permanently or temporarily severely communicatively impaired.",
    "credits": "2"
  },
  {
    "course_name": "Fluency Disorders",
    "dept": "CSD",
    "num": "741",
    "desc": "Prerequisite: CSD 560.\nResearch and theory concerning etiology, characteristics, assessment, and treatment of individuals with disfluency problems.",
    "credits": "3"
  },
  {
    "course_name": "Language Assessment and Intervention II",
    "dept": "CSD",
    "num": "742",
    "desc": "Prerequisite: CSD 443.\nTheory and research concerning language disorders in school-aged children are presented. Specific language assessment and intervention methodologies for this population are reviewed. Dialectal and bilingual considerations for assessment and intervention are addressed.",
    "credits": "3"
  },
  {
    "course_name": "Communication Impairments in Autism Spectrum Disorders",
    "dept": "CSD",
    "num": "743",
    "desc": "Prerequisite: CSD 443.\nThis course provides an overview of Autism Spectrum Disorders (ASD), including characteristics, diagnosis, and etiologies. Interventions used by speech-language pathologists for enhancing the communication of individuals with ASD across the lifespan will be presented, with a focus on using evidence-based practice guidelines to determine programs of treatment. Current developments and research findings related to assessment and intervention will be discussed.",
    "credits": "2"
  },
  {
    "course_name": "Aural Rehabilitation",
    "dept": "CSD",
    "num": "744",
    "desc": "Prerequisite: CSD 567.\nThe study of habilitation and rehabilitation techniques for individuals diagnosed with a hearing disorder. Specific areas of interest include hearing evaluation techniques, speech and language development for the hearing impaired, hearing aid amplification, cochlear implants, and central auditory processing.",
    "credits": "2"
  },
  {
    "course_name": "Neuromotor Speech Disorders",
    "dept": "CSD",
    "num": "745",
    "desc": "Prerequisite: CSD 360 and CSD 446.\nAn introduction to motor speech disorders including an overview of the neurological system. Research and practical knowledge concerning etiologies, evaluation, and principles of treatment are addressed.",
    "credits": "3"
  },
  {
    "course_name": "Cleft Palate",
    "dept": "CSD",
    "num": "748",
    "desc": "Prerequisite: CSD 360 and CSD 446.\nAn overview of communicative disorders related to cleft palate and other structurally-based conditions affecting velopharyngeal function. Research and practical knowledge related to the characteristics, assessment, and treatment of these communicative problems are addressed.",
    "credits": "1"
  },
  {
    "course_name": "Voice Disorders",
    "dept": "CSD",
    "num": "750",
    "desc": "Prerequisite: CSD 360.\nThe etiologies and characteristics of voice disorders, as well as general principles of assessment, prevention, and treatment of these disorders, are presented. The role of the speech-language pathologist in rehabilitation planning following treatment for laryngeal cancer is also addressed.",
    "credits": "3"
  },
  {
    "course_name": "Instrumental Measurement for Clinical Application",
    "dept": "CSD",
    "num": "780",
    "desc": "Prerequisite: CSD 360, 748, 750.\nThis course addresses instrumentation and measurement procedures for clinical purposes. Particular emphasis is placed on measurement of physiological aspects of speech breathing and acoustic and physiological aspects of phonation and resonance.",
    "credits": "2"
  },
  {
    "course_name": "Czech for Travelers",
    "dept": "CZECH",
    "num": "101",
    "desc": "\nIntroduction to the Czech language with emphasis on everyday expressions and vocabulary. History, social life, politics and other cultural issues are also introduced.",
    "credits": "2"
  },
  {
    "course_name": "Modern Dance I",
    "dept": "DANCE",
    "num": "120",
    "desc": "\nIntroduction to principles of modern dance. Emphasis on correct body alignment, movement efficiency, and creative potential of the individual.",
    "credits": "2"
  },
  {
    "course_name": "Ballet I",
    "dept": "DANCE",
    "num": "165",
    "desc": "\nIntroduction to basics of classical ballet training includes terminology, body positions, movement vocabulary, and principles of body alignment.",
    "credits": "2"
  },
  {
    "course_name": "Jazz Dance I",
    "dept": "DANCE",
    "num": "171",
    "desc": "\nA basic course in jazz technique and style, focusing on isolations, rhythmic articulation, and the control and release of energy.",
    "credits": "2"
  },
  {
    "course_name": "Tap I",
    "dept": "DANCE",
    "num": "181",
    "desc": "\nDesigned for beginning dancers, this course develops skills, knowledge, vocabulary, and appreciation of tap dance as an art form through the presentation of fundamental tap techniques.",
    "credits": "2"
  },
  {
    "course_name": "Improvisational Structures",
    "dept": "DANCE",
    "num": "195",
    "desc": "\nExploration of personal creative sources for spontaneous movement through improvisational structures. Emphasis on solo and group problem-solving in creating a performance work.",
    "credits": "2"
  },
  {
    "course_name": "Anatomy for Dancers",
    "dept": "DANCE",
    "num": "200",
    "desc": "\nAnalysis of human skeletal structure. Application and implication for performance, teaching, and injury prevention.",
    "credits": "1"
  },
  {
    "course_name": "Dance as an Art Form",
    "dept": "DANCE",
    "num": "205",
    "desc": "\nDance in its religious, social, and artistic forms. Film, slides, demonstrations, and lectures will trace the function of dance in society, the influence of society on dance, how dance relates to other art forms, and current trends in the dance world.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Dance Technology",
    "dept": "DANCE",
    "num": "220",
    "desc": "\nExamination and application of computer, audio, and video technology to dance. Includes instruction and use in performance, choreography, education and research.",
    "credits": "1-3"
  },
  {
    "course_name": "Rhythmic Notation for Dance",
    "dept": "DANCE",
    "num": "225",
    "desc": "\nIntroduction to basic elements of meter, tempo, rhythm, and notation. Application and practice to dance pedagogy, performance, and choreography.",
    "credits": "1"
  },
  {
    "course_name": "Performance Styles",
    "dept": "DANCE",
    "num": "250",
    "desc": "\nStudy and practice of technique and performance of specific period/historical, character, or ethnic/specialty dance styles.",
    "credits": "1"
  },
  {
    "course_name": "Pointe Techniques",
    "dept": "DANCE",
    "num": "265",
    "desc": "\nCovers classical ballet pointe technique. Focuses on the development of both technique and artistic expression.",
    "credits": "1"
  },
  {
    "course_name": "Dance Composition I",
    "dept": "DANCE",
    "num": "295",
    "desc": "Prerequisite: DANCE 195.\nIntroduction to the principles of the choreographic craft. Practical experience in development of movement phrases. Culminating presentation and critique of work.",
    "credits": "3"
  },
  {
    "course_name": "Modern Dance II",
    "dept": "DANCE",
    "num": "323",
    "desc": "Prerequisite: DANCE 120 and consent of instructor.\nOnly 2 of these hours may be applied toward humanities requirements.",
    "credits": "2"
  },
  {
    "course_name": "Modern Dance III",
    "dept": "DANCE",
    "num": "324",
    "desc": "Prerequisite: DANCE 323 and consent of instructor.",
    "credits": "2"
  },
  {
    "course_name": "Ballet II",
    "dept": "DANCE",
    "num": "325",
    "desc": "Prerequisite: DANCE 165 or consent of instructor.",
    "credits": "2"
  },
  {
    "course_name": "Ballet III",
    "dept": "DANCE",
    "num": "326",
    "desc": "Prerequisite: DANCE 325 or consent of instructor.",
    "credits": "2"
  },
  {
    "course_name": "West African Styles of Social Dance and Music",
    "dept": "DANCE",
    "num": "350",
    "desc": "\nExplores several styles of dancing and drumming from West Africa. Instruction includes technique in the traditional social dances, drumming/musical skills, and songs for the social dances. History, traditions, and social context of the dances.",
    "credits": "2"
  },
  {
    "course_name": "Jazz Dance II",
    "dept": "DANCE",
    "num": "371",
    "desc": "Prerequisite: DANCE 171.\nIntermediate course in jazz technique and style focusing on development of isolations, rhythmic articulation, and the control and release of energy.",
    "credits": "2"
  },
  {
    "course_name": "Jazz Dance III",
    "dept": "DANCE",
    "num": "372",
    "desc": "Prerequisite: DANCE 371 or consent of instructor.\nAdvanced course in jazz technique and style focusing on development of isolations, rhythmic articulation, and the control and release of energy.",
    "credits": "2"
  },
  {
    "course_name": "Musical Theatre Dance",
    "dept": "DANCE",
    "num": "380",
    "desc": "Prerequisite: DANCE 120, 165, or 171.\nHistory, technique and performance of musical theatre dance. Rehearsal and performance of selected examples of Broadway choreography.",
    "credits": "2"
  },
  {
    "course_name": "Tap II",
    "dept": "DANCE",
    "num": "381",
    "desc": "\nDesigned as an intermediate dance class that targets the development of skills, knowledge, and appreciation of tap dance through the presentation of fundamental techniques and other movement experiences. Topics include: concert, rhythm, and fundamental tap dance.",
    "credits": "2"
  },
  {
    "course_name": "Tap III",
    "dept": "DANCE",
    "num": "382",
    "desc": "\nDesigned as an advanced dance class that targets the development of skills, knowledge, and appreciation of tap dance through the presentation of techniques and other movement experiences. Topics include: Broadway and concert dance, rhythm, and Funk Tap dance.",
    "credits": "2"
  },
  {
    "course_name": "Honors Seminar",
    "dept": "DANCE",
    "num": "399",
    "desc": "\nOpen only to qualified students in the arts and sciences honors program.",
    "credits": "3"
  },
  {
    "course_name": "Applied Movement Fundamentals",
    "dept": "DANCE",
    "num": "405",
    "desc": "Prerequisite: DANCE 200.\nStudy, analysis, and application of movement theories to dance training, education, creation, and performance. Scientific and somatic principles are emphasized in the art form and body therapies.",
    "credits": "3"
  },
  {
    "course_name": "Movement Exploration and Creative Dance for Children",
    "dept": "DANCE",
    "num": "455",
    "desc": "Prerequisite: KIN 320, 330, and 335 (or any two and concurrent enrollment in the third).\nApplication of scientific principles to the teaching of basic movement concepts and creative dance for grades K-6. Emphasis upon a guided discovery and problem-solving approach.",
    "credits": "3"
  },
  {
    "course_name": "Dance History I",
    "dept": "DANCE",
    "num": "459",
    "desc": "Prerequisite: Sophomore standing.\nCovers dance, particularly ballet and modern dance, from beginnings until the turn of 20th century.",
    "credits": "3"
  },
  {
    "course_name": "Dance History II",
    "dept": "DANCE",
    "num": "460",
    "desc": "Prerequisite: DANCE 459.\nHistory of Dance from the 20th Century until the present.",
    "credits": "3"
  },
  {
    "course_name": "Dance Composition II",
    "dept": "DANCE",
    "num": "495",
    "desc": "Prerequisite: DANCE 295.\nAdvanced training and directed experiences in dance composition. Development of theme, phrasing, and style with particular emphasis on group forms.",
    "credits": "3"
  },
  {
    "course_name": "Honors Tutorial in Dance",
    "dept": "DANCE",
    "num": "498",
    "desc": "Prerequisite: Sophomore standing, membership in the honors program of the College of Arts and Sciences, and permission of instructor.\nIndividually directed research/creative endeavor in dance, normally as a preliminary to writing a senior honors thesis.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "DANCE",
    "num": "499",
    "desc": "\nOpen only to Arts and Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Performance Production",
    "dept": "DANCE",
    "num": "502",
    "desc": "Prerequisite: Junior standing or consent of instructor.\nStudies in the techniques of dance production and performance. Emphasis is on practical application.",
    "credits": "0-1"
  },
  {
    "course_name": "K-State Tap Dance Ensemble",
    "dept": "DANCE",
    "num": "503",
    "desc": "\nA performing ensemble that dances for the K-State and Manhattan communities.",
    "credits": "0-1"
  },
  {
    "course_name": "Methods and Materials of Teaching Dance",
    "dept": "DANCE",
    "num": "505",
    "desc": "Prerequisite: DANCE 205, 405, and 504 or consent of instructor.\nAn in-depth survey of the development of dance education and a practical examination of dance for its educative, artistic, disciplinary, and therapeutic values.  Emphasis on role of dance education, pedagogy, and advocacy.",
    "credits": "2"
  },
  {
    "course_name": "Dance Education Fieldwork",
    "dept": "DANCE",
    "num": "506",
    "desc": "Prerequisite: DANCE 505.\nA semester of supervised fieldwork incorporating dance as an educative tool in the classroom, in a therapeutic setting, or in an advocacy position. Application of dance education theory under faculty supervision and conference.",
    "credits": "1"
  },
  {
    "course_name": "K-State African Dance and Music Ensemble",
    "dept": "DANCE",
    "num": "507",
    "desc": "\nA performing group that is open to all students and does not require an audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Senior Project",
    "dept": "DANCE",
    "num": "510",
    "desc": "Prerequisite: Senior standing and consent of instructor.\nStudent creates and presents major performance, choreographic or written project demonstrating advanced level of achievement.",
    "credits": "1"
  },
  {
    "course_name": "Independent Studies in Dance",
    "dept": "DANCE",
    "num": "599",
    "desc": "Prerequisite: Consent of department head.\nSelected topics in dance.",
    "credits": "1-3"
  },
  {
    "course_name": "Clinical Laboratory Science (Medical Technology)",
    "dept": "DAS",
    "num": "001",
    "desc": "Prerequisite: Completion of the 94 credit hours of undergraduate course work required for the clinical laboratory science (medical technology) degree.\nEnrollment in this course allows students attending a hospital-based clinical program to complete the 30 credit hours of clinical work required for the bachelor’s degree in clinical laboratory science (medical technology).",
    "credits": "1-18"
  },
  {
    "course_name": "University Honors Program",
    "dept": "DAS",
    "num": "020",
    "desc": "\nAll students participating in the University Honors Program and who are enrolled in the College of Arts &amp; Sciences must enroll each semester.",
    "credits": "0"
  },
  {
    "course_name": "Introduction to the English Language Program",
    "dept": "DAS",
    "num": "030",
    "desc": "\nThe purpose for DAS 030 is to provide a monitoring mechanism for English Language Program students.  It also allows the ELP, International Programs and International Pre-admissions to track new international students.",
    "credits": "0"
  },
  {
    "course_name": "Training in Organization, Wellness, Academics, Responsibilities and Discipline in the ELP",
    "dept": "DAS",
    "num": "032",
    "desc": "Prerequisite: Department placement.\nThis course is designed to engage English Language Program (ELP) students who are at risk due to repeated non-performance in ELP classes. Explores good study skills, healthy living habits, community involvement, self-discipline, and guided study sessions.",
    "credits": "1-2"
  },
  {
    "course_name": "National Student Exchange",
    "dept": "DAS",
    "num": "050",
    "desc": "\nEnrollment in this course would be required for students participating in the National Student Exchange program.  Enrollment in this course would serve primarily as a placeholder and enable the student to maintain full-time enrollment status at K-State. A grade of I (incomplete) would be posted at the end of each term (semester) of enrollment. Upon receipt of the transfer transcript from the chosen exchange institution, the DAS 050 course and would be removed from the student’s record and would be replaced by a text entry detailing participation in the National Student Exchange program. The actual hours earned would be reflected as transfer credit from the institution attended.",
    "credits": "1-15"
  },
  {
    "course_name": "Ambassador Service and Leadership in the College of Arts and Sciences",
    "dept": "DAS",
    "num": "080",
    "desc": "\nFor students who have been chosen as ambassadors for the College of Arts and Sciences. Students are required to enroll to be ambassadors.",
    "credits": "0-1"
  },
  {
    "course_name": "First Year Seminar in K-State Culture",
    "dept": "DAS",
    "num": "100",
    "desc": "\nAn overview of the intellectual and cultural life of the university. Students will attend a variety of events as a community and learn to reflect on and evaluate these events through writing, class discussion, and public speaking.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Student Governance",
    "dept": "DAS",
    "num": "102",
    "desc": "",
    "credits": "0-1"
  },
  {
    "course_name": "Orientation to Health Careers",
    "dept": "DAS",
    "num": "115",
    "desc": "\nAcquaints students whose career goals are in the health professions with the variety of options available and with the corresponding academic requirements. Discussion covers an introduction to the personal responsibilities that health-care workers assume and the impact of social and economic problems on our health-care delivery system. Includes an orientation to general requirements for success as a student at K-State and in professional health related programs.",
    "credits": "1"
  },
  {
    "course_name": "Careers in Science and Engineering",
    "dept": "DAS",
    "num": "130",
    "desc": "\nIntroduction to career opportunities with emphasis on gaining perspective from practicing professionals from multiple science and engineering disciplines through weekly seminars held throughout the semester.",
    "credits": "0-1"
  },
  {
    "course_name": "Special Studies in English",
    "dept": "DAS",
    "num": "135",
    "desc": "\nIntroduction to basic English syntax, writing, reading, speaking, and listening for native speakers of other languages.",
    "credits": "1-12"
  },
  {
    "course_name": "Beginning English I",
    "dept": "DAS",
    "num": "136",
    "desc": "\nIntroduction to basic English syntax, writing, reading, speaking, and listening for native speakers of other languages.",
    "credits": "1-18"
  },
  {
    "course_name": "Beginning English II",
    "dept": "DAS",
    "num": "138",
    "desc": "\nIntroduction to basic English syntax, writing, reading, speaking, and listening for native speakers of other languages.",
    "credits": "1-18"
  },
  {
    "course_name": "Intermediate English I",
    "dept": "DAS",
    "num": "140",
    "desc": "\nIntermediate study of basic English sentence structure, writing, reading, speaking and listening for native speakers of other languages.",
    "credits": "1-18"
  },
  {
    "course_name": "Basic English Language Orientation",
    "dept": "DAS",
    "num": "148",
    "desc": "Prerequisite: Placement by the English Language Program.\nEmphasizes the basic cultural and academic understanding necessary for new international students to be successful in ELP and university classes at K-State. Introduction to cultural differences, campus resources, health and safety, study skills, housing issues, plagiarism, basic immigration rules, classroom expectations.",
    "credits": "1"
  },
  {
    "course_name": "Intermediate English II",
    "dept": "DAS",
    "num": "150",
    "desc": "\nIntermediate study of basic English sentence structure, writing, reading, speaking and listening for native speakers of other languages.",
    "credits": "1-18"
  },
  {
    "course_name": "Advanced English Speaking I for Non-native Speakers of English",
    "dept": "DAS",
    "num": "151",
    "desc": "Prerequisite: Placement by the English Language Program.\nComprehension and appropriate response to non-academic discourse; development of accurate pronunciation, oral grammar, and vocabulary usage. Development of fluency.",
    "credits": "3"
  },
  {
    "course_name": "Advanced English Writing I",
    "dept": "DAS",
    "num": "152",
    "desc": "\nReview of advanced grammatical structures; practice in writing using academic style, organization and rhetorical conventions; transition to an academic vocabulary in writing; introduction to conventions of research writing and citation.",
    "credits": "6"
  },
  {
    "course_name": "Advanced English Reading I for Non-native Speakers of English",
    "dept": "DAS",
    "num": "153",
    "desc": "Prerequisite: Placement by the English Language Program.\nIntroduction to advanced critical reading skills in at level reading passages; introduction to unsimplified academic readings; development of an academic vocabulary; increase of reading speed to approach that of U.S. undergraduates.",
    "credits": "6"
  },
  {
    "course_name": "Advanced English Listening I for Non-native Speakers of English",
    "dept": "DAS",
    "num": "154",
    "desc": "Prerequisite: Placement by the English Language Program.\nComprehension and note-taking of academic lectures at level; introduction to unsimplified academic lectures; comprehension of non-academic discourse at level; use of notes from lecture for test taking.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to American Academic Research Writing for International Students",
    "dept": "DAS",
    "num": "156",
    "desc": "Prerequisite: Permission by the English Language Program.\nIntroduction to American conventions of research paper writing with emphasis on American academic standards.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to American Academic Presentation for International Students",
    "dept": "DAS",
    "num": "157",
    "desc": "Prerequisite: Permission by the English Language Program.\nIntroduction to American rhetorical patterns of academic speaking, focusing specifically on deductive and inductive organization patterns and expectations of American audiences.",
    "credits": "1"
  },
  {
    "course_name": "Orientation to the American Higher Education System",
    "dept": "DAS",
    "num": "158",
    "desc": "\nDesigned to support English Language Program students as they transition to K-State, the English Language Program (ELP), and the Manhattan community. Introduction to the campus resources available.",
    "credits": "1"
  },
  {
    "course_name": "Advanced English Writing II for Non-native Speakers of English",
    "dept": "DAS",
    "num": "162",
    "desc": "Prerequisite: Placement by the English Language Program.\nUse of advanced grammatical structures and academic vocabulary in writing; practice in editing and revision with an eye to academic to academic style, organization and rhetorical conventions; use of conventions of research writing and citation.",
    "credits": "6"
  },
  {
    "course_name": "Advanced English Reading II for Non-native Speakers of English",
    "dept": "DAS",
    "num": "163",
    "desc": "Prerequisite: Placement by the English Language Program.\nDevelopment of advanced critical reading skills with unsimplified academic passages; active usage of an academic vocabulary; increase of reading speed equivalent to that of U.S. undergraduates.",
    "credits": "3"
  },
  {
    "course_name": "Advanced English Listening II for Non-native Speakers of English",
    "dept": "DAS",
    "num": "164",
    "desc": "Prerequisite: Placement by the English Language Program.\nComprehension and note-taking of non-simplified academic lectures; comprehension of non-lecture academic discourse; use of notes from lectures and other sources for test taking.",
    "credits": "3"
  },
  {
    "course_name": "Advanced English Speaking II for Non-native Speakers of English",
    "dept": "DAS",
    "num": "165",
    "desc": "Prerequisite: Placement by the English Language Program.\nComprehension and appropriate response to non-academic and academic discourse; development of accurate pronunciation, oral grammar, and vocabulary usage. Development of fluency.",
    "credits": "3"
  },
  {
    "course_name": "Advanced English Writing III for Non-native Speakers of English",
    "dept": "DAS",
    "num": "166",
    "desc": "Prerequisite: Placement by the English Language Program.\nMastery of independent editing and revision with an eye to academic style, organization, rhetorical conventions and register; mastery of conventions of research writing and citation.",
    "credits": "3"
  },
  {
    "course_name": "Basic Grammar in Writing",
    "dept": "DAS",
    "num": "167",
    "desc": "Prerequisite: Permission by the English Language Program.\nReview of basic English grammar; practice of basic grammar in writing; review of grammar usage in academic writing; practice in proofreading and editing of work.",
    "credits": "3"
  },
  {
    "course_name": "Technical Communication for International Students",
    "dept": "DAS",
    "num": "168",
    "desc": "Prerequisite: Placement by the English Language Program.\nAddresses the needs of non-native English speakers studying in the STEM fields. Introduces technical vocabulary, conventions, forms of documents, and practices of written, oral and online technical communication in the United States. Grammar and pronunciation support provided as needed. Student portfolio will include a resume, project proposal, memos, technical report, poster presentation, and personal website.",
    "credits": "3"
  },
  {
    "course_name": "Digital English for International Students",
    "dept": "DAS",
    "num": "169",
    "desc": "Corequisite: Advanced English II.\nInstruction in online language and communication for international students in order to develop strategies and skills for working effectively in academic digital interaction and collaboration. Includes study of function and use of different web 2.0 tools. Communication skills for intercultural collaboration, and the English language styles and rhetoric appropriate in specific online settings.",
    "credits": "2"
  },
  {
    "course_name": "Business Communications for Non-Native Speakers",
    "dept": "DAS",
    "num": "175",
    "desc": "\nThis course will introduce non-native English speakers to key U.S. business terminology, norms for written and oral communication, and business culture in the U.S. Students will practice business communication and teamwork skills in a hands-on setting.",
    "credits": "3"
  },
  {
    "course_name": "Reading Skills for Non-Native Speakers of English",
    "dept": "DAS",
    "num": "176",
    "desc": "\nAn advanced course designed to improve reading skills and increase academic vocabulary of non-native speakers of English engaged in academic classes.",
    "credits": "3"
  },
  {
    "course_name": "Written Communication for Non-Native Speakers of English",
    "dept": "DAS",
    "num": "177",
    "desc": "Prerequisite: Permission by the English Language Program.\nInstruction in academic reading and writing skills in order to develop reading skills, increase reading speed, and improve writing of reports, analyses, and summaries. Includes grammar review, the study of style, and development of an academic vocabulary.",
    "credits": "3"
  },
  {
    "course_name": "Listening Skills",
    "dept": "DAS",
    "num": "178",
    "desc": "Prerequisite: Permission by the English Language Program.\nInstruction to improve listening, comprehension, and note-taking skills. Instruction in conversational speaking, with an emphasis on developing oral fluency and the effective use of vocabulary and idioms. Includes pronunciation practice, group work, and short academic presentations.",
    "credits": "3"
  },
  {
    "course_name": "Pronunciation and Speaking Skills for Non-Native Speakers of English",
    "dept": "DAS",
    "num": "179",
    "desc": "Prerequisite: Placement by the English Language Program.\nIntroduction in speaking for non-native speakers of English to improve comprehension of non-simplified conversational English. Practice in asking for clarification, responding appropriately to requests, and encouraging interaction, as well as the pronunciation of troublesome English sounds and intonation patterns. Also brief introduction to American culture, especially the American educational system.",
    "credits": "2-3"
  },
  {
    "course_name": "Advanced Integrated Skills",
    "dept": "DAS",
    "num": "181",
    "desc": "\nAn advanced, combined-skills course to improve the reading, writing, and speaking skills of non-native speakers of English.",
    "credits": "3"
  },
  {
    "course_name": "Practical Training in ESL",
    "dept": "DAS",
    "num": "184",
    "desc": "Prerequisite: Permission by the English Language Program.\nIntroduction to practical classroom skills for the non-education major planning to teach ESL abroad as part of a study abroad or internship abroad experience.",
    "credits": "1-2"
  },
  {
    "course_name": "Teaching and Cultural Orientation for International Teaching Assistants",
    "dept": "DAS",
    "num": "185",
    "desc": "Prerequisite: Permission by English Language Program.\nIntroduction to American undergraduate education, American culture, and university policies. Discussion of effective teaching techniques, nonverbal language, and coping techniques. Practice focusing on pronunciation, vocabulary, grammar, and interactive speaking skills. Individual tutorials based on video-taped teaching presentations.",
    "credits": "3"
  },
  {
    "course_name": "Exploration of American Culture",
    "dept": "DAS",
    "num": "187",
    "desc": "Prerequisite: AMETH 160 or instructor permission.\nThis course explores America and the impressions that international students may have about American society and customs. Students will further their experience of American culture through readings, lectures, and films, allowing them to integrate and interpret their experiences inside and outside of the classroom during their stay here.",
    "credits": "3"
  },
  {
    "course_name": "CAT Community Connections",
    "dept": "DAS",
    "num": "195",
    "desc": "\nInterdisciplinary course that explores the connections among two different fields, courses, or disciplines.",
    "credits": "1-3"
  },
  {
    "course_name": "Selected Topics",
    "dept": "DAS",
    "num": "199",
    "desc": "\nIndependent Reading Program.",
    "credits": "1-3"
  },
  {
    "course_name": "Introduction to Arts & Sciences Education Theory and Practice",
    "dept": "DAS",
    "num": "214",
    "desc": "Prerequisite:  Permission of instructor.\nIntroduces learning theory and teaching practices for arts and sciences learning assistants. Presents theoretical issues such as conceptual development, questioning techniques, and cooperative learning. Students will read research literature on teaching and learning in arts and sciences and engage in classroom discussions. Students are expected to reflect on their own teaching practices throughout the semester as well.",
    "credits": "0-2"
  },
  {
    "course_name": "Fundamentals of Global Food Systems Leadership",
    "dept": "DAS",
    "num": "225",
    "desc": "\nAn interdisciplinary approach to the fundamental roles people, policies, and cultures play in the global food system enterprise as it relates to sustainable food production, processing, distribution, and availability. Students will explore complexities within self, others, and community related to leadership in the context of a rapidly increasing global population.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Pre-Health",
    "dept": "DAS",
    "num": "240",
    "desc": "Prerequisite: Sophomore standing, permission of the health professions advisor.\nForty hours spent observing the practice of dentistry, medicine, or optometry. Students are under the supervision and direction of individual dentists, physicians, or optometrists.",
    "credits": "1"
  },
  {
    "course_name": "The Great Conversation: Primary Texts Certificate Core Course",
    "dept": "DAS",
    "num": "300",
    "desc": "\nAn interdisciplinary, team-taught course, required for students enrolled in the Certificate in the Study of the Arts and Sciences Through Primary Texts.  This course can be taken by students not in the certificate, and for Honors credit.",
    "credits": "3"
  },
  {
    "course_name": "Creating a Competitive Health Professional School Application",
    "dept": "DAS",
    "num": "315",
    "desc": "\nFor students who are preparing to apply to health professional schools in the coming year. Assist in drafting a personal statement, obtaining letters of recommendation, preparing for the interview process, learning about the Centralized Application Services, as well as other preparation needed for their respective entrance examination. Addresses current trends and topics in health care such as interprofessional education, health care disparities, and cultural competence.",
    "credits": "1"
  },
  {
    "course_name": "Uncertainty in Global Food Systems Leadership",
    "dept": "DAS",
    "num": "325",
    "desc": "Prerequisite: LEAD 225, DAS 225, or GENAG 225.\nExplore technical and adaptive elements of grand challenges across disciplines. This course addresses the impact of cultural identity, life experience, and world views on leadership relationships as it relates to privilege and inclusion in the context of global food systems. Students will consider elements of community-engaged work.",
    "credits": "3"
  },
  {
    "course_name": "Origins",
    "dept": "DAS",
    "num": "333",
    "desc": "\nAn interdisciplinary general education course examining how scholars in the sciences and humanities approach knowledge about the universe, the planet earth, and life itself.  How did the universe begin?  How did life begin and how does it evolve?  How has the planet changed throughout its history?  How were answers to these questions discovered?  How do we construct narratives about these events, and how do those texts reveal our assumptions and values?",
    "credits": "3"
  },
  {
    "course_name": "Topics in the Humanities (Study Abroad)",
    "dept": "DAS",
    "num": "350",
    "desc": "Prerequisite: Permission of the director of the individual study abroad experience.\nThis is an umbrella course for numerous individual courses offered to students in the humanities in Italy program and other study abroad experiences.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to Nonviolence Studies",
    "dept": "DAS",
    "num": "355",
    "desc": "\nThe theory and practice of nonviolence as a method of social change and as a personal way of life. This class will engage students in the consideration of violence and nonviolence, from dynamics that occur within ourselves to those that affect the future of the Earth and its many life forms. Students will share with each other from their own lived experience and will learn from the writings of people who have practiced nonviolence in their lives and work.",
    "credits": "3"
  },
  {
    "course_name": "Honors Internship",
    "dept": "DAS",
    "num": "388",
    "desc": "Prerequisite: Concurrence of a faculty advisor and approval of the arts and sciences honor program advisory council.\nA scholarly investigation related to activities in a place of employment or in a volunteer situation.",
    "credits": "1-3"
  },
  {
    "course_name": "Undergraduate Research in Arts & Sciences",
    "dept": "DAS",
    "num": "400",
    "desc": "Prerequisite: Enrollment in an Arts &amp; Sciences degree program. Students must apply to the Arts &amp; Sciences Undergraduate Research Program and receive an award before enrolling.\nIndependent mentored research project.",
    "credits": "0-3"
  },
  {
    "course_name": "Clinical Microbiology",
    "dept": "DAS",
    "num": "401",
    "desc": "\nThe theory and laboratory study of pathogenic bacteria, viruses, richettsiae, fungi, and parasites. Includes morphology, physiology, taxonomy, and medical significance.",
    "credits": "6-8"
  },
  {
    "course_name": "Clinical Chemistry",
    "dept": "DAS",
    "num": "402",
    "desc": "\nTheory and laboratory study of analytical biochemistry, incorporating both routine and special chemical procedures.",
    "credits": "6-8"
  },
  {
    "course_name": "Clinical Hematology",
    "dept": "DAS",
    "num": "403",
    "desc": "\nStudy of blood cell derivation, maturation, and function, principles of hemastasis, and blood coagulation. Methodology used in routine and special hematology studies.",
    "credits": "4-6"
  },
  {
    "course_name": "Clinical Immunology",
    "dept": "DAS",
    "num": "404",
    "desc": "\nImmunohematology, the study of fundamentals of antigen-antibody reactions, blood groups and types, crossmatches, blood components, and the laboratory methods used in immunohematology studies; and serology, the theory of immunologic responses and procedures used in determination of serological studies.",
    "credits": "2-6"
  },
  {
    "course_name": "Topics in Clinical Laboratory Science (Medical Technology)",
    "dept": "DAS",
    "num": "405",
    "desc": "\nBasic principles and practices of the medical laboratory, techniques and special projects.",
    "credits": "3-6"
  },
  {
    "course_name": "Honors Colloquium",
    "dept": "DAS",
    "num": "450",
    "desc": "Prerequisite: Membership in the honors program; one honors course in addition to introduction to the honors Program in the College of Arts and Sciences.\nAn interdisciplinary colloquium in which topics vary by semester. Consistently incorporates perspectives from more than one discipline and area among the arts, humanities, social sciences, and sciences.",
    "credits": "3"
  },
  {
    "course_name": "Violence, Nonviolence and Social Change",
    "dept": "DAS",
    "num": "455",
    "desc": "Prerequisite: DAS 355.\nThis course reviews historical and contemporary responses to violence around the world by studying ideas, strategies, organizational approaches, and societal impacts on nonviolence and social change. Emphasis is placed on historical antecedents to recent violence and nonviolence, and on the analysis of up-to-date resources as they relate to social change.",
    "credits": "3"
  },
  {
    "course_name": "Nonviolence Studies: Women and Peace Movements",
    "dept": "DAS",
    "num": "475",
    "desc": "Prerequisite: DAS 355.\nAnalyzes women and girls as leaders of diverse peace movements in the present and recent past.",
    "credits": "3"
  },
  {
    "course_name": "Social Sciences Capstone",
    "dept": "DAS",
    "num": "498",
    "desc": "Prerequisite: Permission of social science advisor.\nIndividual exploration of the social science major to synthesize knowledge and skills acquired in social science courses.",
    "credits": "0-1"
  },
  {
    "course_name": "Physical Sciences Senior Report",
    "dept": "DAS",
    "num": "499",
    "desc": "Prerequisite: Permission of physical sciences advisor.\nIndividual exploration of an area of physical sciences culminating in a final formal written report. Capstone course required of physical sciences interdisciplinary major.",
    "credits": "1"
  },
  {
    "course_name": "Senior Research in Latin American Studies",
    "dept": "DAS",
    "num": "507",
    "desc": "\nIndependent research product under supervision by director of Latin American Studies.",
    "credits": "3"
  },
  {
    "course_name": "Senior Research in International Studies",
    "dept": "DAS",
    "num": "525",
    "desc": "\nA research paper or project on an international topic.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in the Humanities (Study Abroad)",
    "dept": "DAS",
    "num": "550",
    "desc": "Prerequisite: Permission of the director of the individual study abroad experience.\nThis is an umbrella course for numerous individual courses offered to students in the Humanities in Italy program and other study abroad experiences.",
    "credits": "1-18"
  },
  {
    "course_name": "Themes in Nonviolence Studies",
    "dept": "DAS",
    "num": "555",
    "desc": "\nExplores nonviolence from a national and global perspective, with particular emphasis on emergent techniques and themes in nonviolence studies with particular emphasis on conflict resolution, peacekeeping and peacebuilding, and intersections of gender, race, class, ethnicity, and religion.",
    "credits": "3"
  },
  {
    "course_name": "Peacebuilding",
    "dept": "DAS",
    "num": "575",
    "desc": "\nExplores how social problems, violence and war are generated and how people are working to build conditions that produce peace. Students will analyze peacebuilding efforts at home, in communities, in countries, in regions, and in the global social system.",
    "credits": "3"
  },
  {
    "course_name": "Natural Resources/Environmental Sciences Project (NRES)",
    "dept": "DAS",
    "num": "582",
    "desc": "Prerequisite: All writing and oral communications courses required for major.  Prerequisite or concurrent enrollment: Fifteen hours of approved courses in NRES secondary major.\nA comprehensive project in NRES. Requires integration of information and understanding acquired in NRES secondary major courses. Students must prepare and present written and oral reports.",
    "credits": "3"
  },
  {
    "course_name": "Applied Nonviolence",
    "dept": "DAS",
    "num": "590",
    "desc": "Prerequisite: DAS 355.\nThe capstone experience for the Undergraduate Certificate in Nonviolence Studies, includes field placement in a campus or community organization in which student will have a skill-and-research-based experience in nonviolence-related social change project. Projects can be local, regional, national, or international in scope.  Concurrently, students will engage in academic readings and class sessions that address feminist and nonviolent approaches to social change, program design, and participatory action research. This course will provide students with professional and academic skills that relate to employment and graduate work in diverse fields.",
    "credits": "3"
  },
  {
    "course_name": "Honors Program",
    "dept": "DED",
    "num": "020",
    "desc": "Prerequisite: Sophomore or higher standing, 3.5 cumulative grade point average, acceptance into the honors program.\nAll students accepted into the College of Education honors program must enroll each semester.",
    "credits": "0"
  },
  {
    "course_name": "Study Skills Laboratory",
    "dept": "DED",
    "num": "051",
    "desc": "\nHelps the student to learn effective study methods, analyze difficulties in reading and studying, and prepare for and improve performance in examinations.",
    "credits": "1-3"
  },
  {
    "course_name": "Orientation to Teacher Education at KSU",
    "dept": "DED",
    "num": "075",
    "desc": "\nThis course provides a general orientation to the university, the College of Education, and the teacher education program. Examines the unit’s conceptual framework, program requirements including the student portfolio, advising and enrollment procedures, and policies and resources.",
    "credits": "0"
  },
  {
    "course_name": "Pre-Professional Laboratory Experiences",
    "dept": "DED",
    "num": "100",
    "desc": "\nSupervised experiences in education designed to facilitate orientation and investigation of teaching through the teacher aide program.",
    "credits": "1"
  },
  {
    "course_name": "Topics in Education",
    "dept": "DED",
    "num": "150",
    "desc": "\nA study of topics in the field of education.",
    "credits": "0-12"
  },
  {
    "course_name": "Introduction to the University Honors Program",
    "dept": "DED",
    "num": "189",
    "desc": "\nOverview of the University Honors Program including directions, goals, and student requirements for completion of the program.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Seminar",
    "dept": "DED",
    "num": "320",
    "desc": "\nSelected topics in education.",
    "credits": "1"
  },
  {
    "course_name": "Problems in Education",
    "dept": "DED",
    "num": "350",
    "desc": "\nA study of topics in the field of education.",
    "credits": "0-12"
  },
  {
    "course_name": "Honors Project",
    "dept": "DED",
    "num": "420",
    "desc": "Prerequisite: Participation in COE Honors Program.\nIndividual projects under the supervision of a professor.",
    "credits": "0-3"
  },
  {
    "course_name": "Engineering Student Success Seminar",
    "dept": "DEN",
    "num": "015",
    "desc": "Prerequisite: General Engineering students only.\nSupports engineering students in identifying potential barriers to student success and gaining access to related campus resources. Students will participate in interactive small groups and discussions. This course will also assist students in developing effective academic skills including, but not limited to: time management, organization, learning styles, effective communication, academic planning and goal setting.",
    "credits": "0"
  },
  {
    "course_name": "University Honors Program",
    "dept": "DEN",
    "num": "020",
    "desc": "\nAll students participating in the University Honors Program and who are enrolled in the College of Engineering must enroll each semester.",
    "credits": "0"
  },
  {
    "course_name": "Reinstatement Support",
    "dept": "DEN",
    "num": "060",
    "desc": "\nStudents who have been reinstated into the College of Engineering must enroll in this course. This course will provide frequent communication and support in the areas of study skills and time management.",
    "credits": "0"
  },
  {
    "course_name": "Multicultural Engineering Enrichment Seminar",
    "dept": "DEN",
    "num": "120",
    "desc": "\nIntroduction to the academic and intellectual demands of an engineering curriculum from a multicultural perspective. Develop group cohesiveness and an attitude of mutual support by engaging in collaborative learning. Help students acquire effective study methods, analyze/compare learning/teaching styles, prepare for and improve examination performance, promote optimum utilization of campus resources, develop leadership and communication skills and enhance self-esteem.",
    "credits": "1"
  },
  {
    "course_name": "Careers in Science and Engineering",
    "dept": "DEN",
    "num": "130",
    "desc": "\nIntroduction to career opportunities with emphasis on gaining perspective from practicing professionals from multiple science and engineering disciplines through weekly seminars held throughout the semester.",
    "credits": "0-1"
  },
  {
    "course_name": "Engineering Orientation",
    "dept": "DEN",
    "num": "160",
    "desc": "Prerequisite: Freshmen or Sophomore only. B or better in MATH 100; OR C or better in MATH 150; OR Prerequisite or co-requisite: MATH 220.\nAn introduction to engineering; general orientation; policies; student organizations; study skills and time management; departmental degree programs and careers.",
    "credits": "1"
  },
  {
    "course_name": "Engineering Problem Solving",
    "dept": "DEN",
    "num": "161",
    "desc": "Prerequisite: Freshmen or Sophomore only. B or better in MATH 100; OR C or better in MATH 150; OR Prerequisite or co-requisite: MATH 220.\nIntroduction to application-oriented engineering problem solving skills using fundamental engineering problems specific to each discipline, teamwork, and communication skills.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to the University Honors Program",
    "dept": "DEN",
    "num": "189",
    "desc": "\nOverview of the University Honors Program, including directions, goals and student requirements for completion of the program.",
    "credits": "1"
  },
  {
    "course_name": "Kansas State Engineer Publications",
    "dept": "DEN",
    "num": "200",
    "desc": "\nOne hour recitation staff meeting a week.",
    "credits": "1"
  },
  {
    "course_name": "Amateur Radio Theory I",
    "dept": "DEN",
    "num": "201",
    "desc": "\nTheory and practice of amateur (“ham”) radio operation. Basics of radio electronics, antennas, FCC regulations, Morse code; successful completion of the course should ensure passing the FCC Novice and “no-code” technician examinations.",
    "credits": "1"
  },
  {
    "course_name": "Amateur Radio Theory II",
    "dept": "DEN",
    "num": "202",
    "desc": "Prerequisite: DEN 201 or FCC Novice or “no-code” technician.\nTheory and practice of amateur (“ham”) radio operation. More basics of radio electronics, antennas, FCC regulations, Morse code; successful completion of the course should ensure passing the FCC General class examination.",
    "credits": "1"
  },
  {
    "course_name": "Multicultural Engineering Colloquium",
    "dept": "DEN",
    "num": "220",
    "desc": "\nContinuation of DEN 120. Emphasis on career exploration and development, introduction to graduate school options, preparation and responsibility for advising process, tips on breaking the failure cycle, behavior modification strategies, and developing and utilizing leadership skills.",
    "credits": "1"
  },
  {
    "course_name": "Creative Problem Solving in Engineering",
    "dept": "DEN",
    "num": "301",
    "desc": "Prerequisite: Sophomore standing or consent of instructor.\nOverview of major topics related to creative thinking, including idea development, overcoming personal and professional obstacles, managing change, effective problem solving, and teamwork productivity.",
    "credits": "1"
  },
  {
    "course_name": "Engineering Professionalism and Decision Making",
    "dept": "DEN",
    "num": "325",
    "desc": "Prerequisite: Sophomore standing.\nAn introduction to the complexities of making decisions as an engineer.  Students will explore the relationship between ethics and engineering by applying classical moral theory and decision making concepts to evaluate engineering issues and decisions encountered in academic and professional careers.",
    "credits": "1"
  },
  {
    "course_name": "Problems in Engineering and Technology",
    "dept": "DEN",
    "num": "398",
    "desc": "Prerequisite: Approval of department head or dean.\nA study of problems or topics in a specialized area of engineering or technology.",
    "credits": "1-18"
  },
  {
    "course_name": "Honors Colloquium in Engineering",
    "dept": "DEN",
    "num": "399",
    "desc": "\nSelected topics of general interest.",
    "credits": "1"
  },
  {
    "course_name": "Impact of Technology on Society",
    "dept": "DEN",
    "num": "450",
    "desc": "Prerequisite: Sophomore standing or above.\nA study of social, economic, and environmental problems as a function of technology. Study of effect of various significant technological developments on present society and parallels with present developments. Study of current problems, detection of causes, and analysis of solutions. Implications for the future; governmental, industrial, and individual responsibility in detection of potential problems and methods of control or solution.",
    "credits": "3"
  },
  {
    "course_name": "Honors Research in Engineering",
    "dept": "DEN",
    "num": "499",
    "desc": "\nIndividual research problem selected with approval of faculty advisor.  Written report is presented at end of second semester.",
    "credits": "1"
  },
  {
    "course_name": "University Honors Program",
    "dept": "DHE",
    "num": "020",
    "desc": "\nAll students participating in the University Honors Program and who are enrolled in the College of Health and Human Sciences must enroll each semester.",
    "credits": "0"
  },
  {
    "course_name": "Honors Practicum in Research, Teaching, Administration, or Extension",
    "dept": "DHE",
    "num": "102",
    "desc": "Prerequisite: College of Health and Human Sciences honors program member and consent of honors program coordinator.\nPracticum completed in collaboration with a faculty member that enhances skills in research, teaching, administration, or extension programming.",
    "credits": "0-1"
  },
  {
    "course_name": "CAT Community Connections",
    "dept": "DHE",
    "num": "195",
    "desc": "\nInterdisciplinary course that explores the connections among two different fields, courses, or disciplines. For first-year students enrolled in a specific CAT Community linked to the College of Health and Human Sciences programs.",
    "credits": "1-3"
  },
  {
    "course_name": "Conducting Honors Research",
    "dept": "DHE",
    "num": "300",
    "desc": "\nThis one credit seminar provides an overview of the process of conducting an honors project, which could be undergraduate research or other scholarly project. The seminar is designed for a sophomore and junior participants in the University Honors Program.",
    "credits": "1"
  },
  {
    "course_name": "Honors Seminar in Human Ecology",
    "dept": "DHE",
    "num": "399",
    "desc": "Prerequisite: For students in honors program only.\nSelected topics in health and human services.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Visual Literacy",
    "dept": "DIGME",
    "num": "137",
    "desc": "Prerequisite: Experience with PC software.\nAn examination of the elements of visual design essential to communication with digital technology. Topics include design elements, color theory, graphics creation and optimization, and multimedia. Students receive hands-on experience with the elements and principles of visual literacy and working with 2-D organization.",
    "credits": "3"
  },
  {
    "course_name": "Digital Literacy",
    "dept": "DIGME",
    "num": "256",
    "desc": "Prerequisite: Experience with PC software.\nEffective digital communications using industry standard technologies to create and edit various media including photographs, videos, sound recordings, websites and other forms of print and online media. Students analyze, evaluate and participate in digital culture. Digital publishing topics include media access, censorship, copyright, fair use, mashups and remixes.",
    "credits": "3"
  },
  {
    "course_name": "Visual Communication Studio",
    "dept": "DIGME",
    "num": "366",
    "desc": "Prerequisite: CMST 333\nStudents complete portfolio projects that tie together topics related to visual communications design. Content topics include creating graphics, animations, photographs, videos and other relevant visual elements to be viewed in print and digital formats.",
    "credits": "3-6"
  },
  {
    "course_name": "Digital Rhetoric",
    "dept": "DIGME",
    "num": "376",
    "desc": "Prerequisite: ENGL 200\nProvides students with the theoretical and applied understanding of how rhetoric works in online environments. Rhetorical strategies employed in media are explored with a close analysis of genre, digital literacy and the basics of design. Topics include new media, genre, digital literacy and rhetoric.",
    "credits": "3"
  },
  {
    "course_name": "Digital Media Production Studio",
    "dept": "DIGME",
    "num": "386",
    "desc": "Prerequisite: CMST 333\nStudents complete portfolio projects that tie together topics related digital media production. Content topics include digital manipulation of media with audio editing, video editing, and photo editing tools and techniques.",
    "credits": "3-6"
  },
  {
    "course_name": "Social Media",
    "dept": "DIGME",
    "num": "406",
    "desc": "Prerequisite: Experience with PC software.\nAn exploration of the social media aspects of producing and consuming digital media content; including blogging, podcasting, and vodcasting. Diversity of the human condition is emphasized. Students will develop and publish an online portfolio of their best digital media work.",
    "credits": "3"
  },
  {
    "course_name": "Digital Media Senior Capstone Project",
    "dept": "DIGME",
    "num": "456",
    "desc": "Prerequisite: DIGME 386 and senior standing.\nProvides seniors with the capstone experience of developing a professional quality project in digital media. Students work individually or in teams to develop a significant project in their area of interest. Students are expected to apply the production techniques covered in previous digital media courses, write project documentation, and make verbal presentations. Whenever feasible, real-world projects are solicited from local businesses.",
    "credits": "3-6"
  },
  {
    "course_name": "Feedlot Health Systems",
    "dept": "DMP",
    "num": "610",
    "desc": "\nHealth of cattle in a commercial feedyard. Includes health risk assessment, cattle handling, processing, vaccination protocols, identification/treatment of sick cattle, necropsy techniques, using computer data to make management decisions for feeder cattle, other management issues. Discussion of disease syndromes and foreign diseases.",
    "credits": "2"
  },
  {
    "course_name": "Cow-Calf Health Systems",
    "dept": "DMP",
    "num": "611",
    "desc": "\nManagement of animal well-being and efficient production in a cow-calf system. Includes the areas of health, growth, nutrition, pharmaceutical management, and reproduction.",
    "credits": "2"
  },
  {
    "course_name": "Fundamentals of Public Health and Food Safety",
    "dept": "DMP",
    "num": "650",
    "desc": "Prerequisite: BIOL 198.\nOrganization and function of food inspection services; principles of disease transmission; diseases transmitted to humans through the food chain.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Pathobiology",
    "dept": "DMP",
    "num": "680",
    "desc": "",
    "credits": "1-5"
  },
  {
    "course_name": "Essential Practices for BSL-3 Research Settings",
    "dept": "DMP",
    "num": "690",
    "desc": "Corequisite: DMP 691.\nThis hands-on laboratory centered course will offer students functional skills training and an in-depth understanding of standard microbiological practices, principles and techniques necessary to safely conduct research in a Biosafety Level-3 setting. Trainees will be exposed to basic concepts such as: research project design, risk assessment, compliance issues, selection of appropriate methods, and introduction to new technologies based on their specific research project. Concurrent enrollment of DMP 691 Introduction to High Containment Research Topics and Techniques is required.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to High Containment Research Topics and Techniques",
    "dept": "DMP",
    "num": "691",
    "desc": "Corequisite: DMP 690.\nThis course examines the rationale behind the skills and techniques taught in DMP 690 Essential Practices for High Containment Research Settings.  Students will gain familiarity with case studies, scientific readings, and laboratory research papers to discuss best practices in the laboratory. Students review and discuss research papers, topics, and practices related to biological agents and toxins appropriate for research conducted in BSL-3, Animal BSL-3 (ABSL-3), and Large Animal BSL-3 (BSL-3Ag) facilities. Concurrent enrollment of DMP 690 Essential Practices for High Containment Research Settings is required.",
    "credits": "2"
  },
  {
    "course_name": "Principles of Veterinary Immunology",
    "dept": "DMP",
    "num": "705",
    "desc": "Prerequisite: BIOCH 521 and BIOL 455.\nInnate and adaptive defense mechanisms in domestic animals. Topics include vaccinology, immunopathology, autoimmunity, immunodeficiency, and immunomodulation.",
    "credits": "3"
  },
  {
    "course_name": "Veterinary Epidemiology",
    "dept": "DMP",
    "num": "708",
    "desc": "\nIntroduction to the principles and methods of veterinary epidemiology: emphasizing how diseases affect populations (and associated implications for individuals), and application to disease diagnosis, treatment, prevention, and control.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to One Health",
    "dept": "DMP",
    "num": "710",
    "desc": "Prerequisite: Two courses in biology.\nOne Health encompasses the complex interrelationships among humans, animals, and the environment. This online course provides a broad introduction to One Health, incorporating original videos of leading experts, case studies, and scientific readings. It addresses zoonotic diseases and environmental issues that impact human, animal, and ecosystem health.",
    "credits": "2"
  },
  {
    "course_name": "Veterinary Bacteriology and Mycology - Laboratory",
    "dept": "DMP",
    "num": "713",
    "desc": "Prerequisite: DMP 705 and BIOL 455.\nThis lab is designed to assist the 2nd year veterinary student with the basic knowledge and skills for isolation and identification of bacterial and fungal agents of veterinary significance, from clinical and non-clinical samples and is designed to provide adequate knowledge and necessary training for veterinarians in practice.",
    "credits": "1"
  },
  {
    "course_name": "General Pathology",
    "dept": "DMP",
    "num": "715",
    "desc": "Prerequisite: AP 700, AP 705 and AP 710.\nEtiology, pathogenesis, lesions, and termination of processes of disease, including inflammation, necrosis, regeneration, oncology, and disturbances of metabolism, circulation, and growth.",
    "credits": "4"
  },
  {
    "course_name": "Veterinary Parasitology",
    "dept": "DMP",
    "num": "718",
    "desc": "Prerequisite: AP 710, 737, 747 and DMP 705 and 708.\nStudy of helminth, arthropod, and protozoan parasites of companion and food animals. Emphases are on diagnosis, clinical signs, lesions, treatment, control, epidemiology, and public health aspects of parasitic disease.",
    "credits": "4"
  },
  {
    "course_name": "Herd Disease Outbreak Investigation Techniques",
    "dept": "DMP",
    "num": "719",
    "desc": "\nThis course is designed to provide the knowledge necessary, through a combination of lecture, discussion, and practical experience, for new graduate veterinarians to practice herd disease-outbreak investigation in cow-calf, feedlot, and dairy practices.",
    "credits": "2"
  },
  {
    "course_name": "Systemic Pathology",
    "dept": "DMP",
    "num": "720",
    "desc": "Prerequisite: DMP 715.\nPathology of the organ systems of domestic animals including gross and microscopic study of lesions.",
    "credits": "5"
  },
  {
    "course_name": "GIS (Geographic Information System) Applications in Animal and Public Health",
    "dept": "DMP",
    "num": "725",
    "desc": "Prerequisite: GEOG 508, GEOG 605 are recommended.\nExplores the relevance/benefits of applying GIS (Geographic Information System) and the concept of spatial thinking in animal/public health research and practice. Health relevant GIS concepts and terminologies, nature and sources of geospatial data, their manipulation methods in a GIS environment, and spatial analysis techniques will be presented.",
    "credits": "2"
  },
  {
    "course_name": "GIS (Geographic Information System) Applications in Animal and Public Health Lab",
    "dept": "DMP",
    "num": "726",
    "desc": "Prerequisite: DMP 725 is required.\nThrough hands-on laboratory exercises different technical methods of applying GIS for health data analysis, spatial analytical methods, model building, cartographic principles and geographic visualization are explored.",
    "credits": "1"
  },
  {
    "course_name": "Cross-Course Integration III",
    "dept": "DMP",
    "num": "730",
    "desc": "Prerequisite: Second-year standing in the College of Veterinary Medicine or consent of instructor.\nVertical and horizontal integration among semester courses to improve student cognitive retention and understanding of course content. Structured-function relationships will be emphasized to facilitate student assimilation and provide clinical relevance to basic science content.",
    "credits": "1"
  },
  {
    "course_name": "Cross-Course Integration IV",
    "dept": "DMP",
    "num": "740",
    "desc": "Prerequisite: Second-year standing in College of Veterinary Medicine or consent of the instructor.\nThe course activities will include interactive discussion sessions with pathologist, radiologist, clinical pathologist, and other veterinary specialists and will be aimed to integrate topics learned in courses taught during the first four semesters of the veterinary curriculum with special emphasis on the topics learned in the current (fourth) semester.",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Public Health",
    "dept": "DMP",
    "num": "753",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine and DMP 708.\nThe linkages between human health and animal health and production. Topics include zoonotic disease, emerging and exotic animal diseases, disaster preparedness, regulatory and community health issues focusing on the role of the veterinarian in all.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Epidemiology",
    "dept": "DMP",
    "num": "754",
    "desc": "\nThe purpose of this course is to introduce students to the basic principles and methods of epidemiology in order to recognize and understand how disease affects populations (and the associated implications for individuals).  This course will prepare students to use epidemiologic methods to solve current and future challenges to diagnose, treat, prevent, and control disease during their professional training and throughout their career.",
    "credits": "3"
  },
  {
    "course_name": "Laboratory Animal Science",
    "dept": "DMP",
    "num": "759",
    "desc": "Prerequisite: DMP 715.\nManagement and health of common species of laboratory animals.",
    "credits": "2"
  },
  {
    "course_name": "Emerging Diseases",
    "dept": "DMP",
    "num": "770",
    "desc": "Prerequisite: 3 hours of Biology above a 700 level.\nAn investigation into recently identified emerging diseases, the conditions that enable their emergence, and the human health implications of each disease.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Pathology",
    "dept": "DMP",
    "num": "775",
    "desc": "Prerequisite: DMP 705 and DMP 715.\nPrinciples, application, and interpretation of clinical laboratory procedures, and experience with applicable techniques.",
    "credits": "4"
  },
  {
    "course_name": "Laboratory Diagnosis",
    "dept": "DMP",
    "num": "777",
    "desc": "Prerequisite: Third-year standing in the College of Veterinary Medicine.\nLaboratory techniques in hematology, cytology, urology and quality control as applied to the diagnosis of animal diseases.",
    "credits": "2"
  },
  {
    "course_name": "Diagnostic Medicine",
    "dept": "DMP",
    "num": "785",
    "desc": "Prerequisite: Fourth-year standing in the College of Veterinary Medicine.\nPractical experience in necropsy procedures and laboratory findings.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Research in Laboratory Medicine",
    "dept": "DMP",
    "num": "790",
    "desc": "Prerequisite: DMP 705, DMP 720, and DMP 777.\nMethodology to conduct research in laboratory medicine. A laboratory study to introduce the procedures to plan, conduct, and evaluate research in clinical pathology, microbiology, parasitology, immunology, or epidemiology. Students will develop a research proposal, including preliminary data, following the guidelines of a peer-reviewed granting agency.",
    "credits": "6"
  },
  {
    "course_name": "New Student Assembly",
    "dept": "ECE",
    "num": "015",
    "desc": "\nAssemblies are held once a month for new electrical engineering and computer engineering students to provide them information on the department. The students get an opportunity to meet student leaders, department faculty, and learn about department activities.",
    "credits": "0"
  },
  {
    "course_name": "New Student Design Project",
    "dept": "ECE",
    "num": "115",
    "desc": "\nStudents work in teams to design, develop, test, and present a solution to an appropriate engineering problem.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Electrical Engineering",
    "dept": "ECE",
    "num": "210",
    "desc": "Prerequisite or concurrent enrollment: MATH 220.\nBasic circuit theory including voltage, current, Kirchoff’s laws, and Ohm’s law. Introduction to circuit elements, application circuits, complex impedance and power, and additional theory fundamental and the EE curriculum. Includes laboratory work (e.g., with multimeters and oscilloscopes) and circuit construction techniques.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computer Engineering",
    "dept": "ECE",
    "num": "241",
    "desc": "\nNumber Systems and their impact on programming language data types. Data operations, addition and logicals (and, or, not).  Introduction to embedded programming in C language. Course will help the student understand coding on an embedded computer and basic hardware interfacing.",
    "credits": "3"
  },
  {
    "course_name": "Circuit Theory I",
    "dept": "ECE",
    "num": "410",
    "desc": "Prerequisite: MATH 221 and ECE 210.\nAn introduction to linear circuit theory; analysis of linear circuits containing resistance, inductance, and capacitance. Mutual inductance and transformers.",
    "credits": "3"
  },
  {
    "course_name": "Microcontrollers",
    "dept": "ECE",
    "num": "431",
    "desc": "Prerequisite: ECE 241; and CIS 200 or 209.\nArchitecture, assembly language programming, serial and parallel input/output, interface circuits, and applications.",
    "credits": "3"
  },
  {
    "course_name": "Design of Digital Systems",
    "dept": "ECE",
    "num": "441",
    "desc": "Prerequisite: ECE 210 and ECE 241.\nDesign of combinational and sequential systems including asynchronous circuits; testing of digital systems. Emphasis is placed on hardware description languages, computer-aided design tools, and simulations.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "ECE",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Honors Research in Electrical and Computer Engineering",
    "dept": "ECE",
    "num": "499",
    "desc": "\nIndividual research problem selected with approval of faculty advisor. Open to students in the College of Engineering honors program. A report is presented orally and in writing during the last semester.",
    "credits": "1-18"
  },
  {
    "course_name": "Electronics Laboratory",
    "dept": "ECE",
    "num": "502",
    "desc": "Prerequisite: ECE 511 and 526.\nDesign, simulation, construction and testing of electronic circuits.",
    "credits": "2"
  },
  {
    "course_name": "Circuit Theory II",
    "dept": "ECE",
    "num": "511",
    "desc": "Prerequisite: MATH 340 and ECE 410.\nTime-domain transient response of second-order circuits. Circuit analysis using Laplace transforms. Frequency response, filters, transfer functions, two-port networks, and convolution.",
    "credits": "3"
  },
  {
    "course_name": "Linear Systems",
    "dept": "ECE",
    "num": "512",
    "desc": "Prerequisite: ECE 511 and 540.\nTime- and frequency-domain analysis of signals and systems. Concepts include signal classification, convolution, Fourier series, Fourier transforms, filters, signal sampling, and discrete transforms.",
    "credits": "3"
  },
  {
    "course_name": "Electric Circuits and Control",
    "dept": "ECE",
    "num": "519",
    "desc": "Prerequisite: PHYS 214.\nPrinciples of direct-current circuits and machines, alternating-current circuits and machines, electronics, and application to instrumentation and control.",
    "credits": "4"
  },
  {
    "course_name": "Electronics I",
    "dept": "ECE",
    "num": "525",
    "desc": "Prerequisite: ECE 410 or 519.\nFundamentals of electronic components (e.g., diodes, MOSFETs, BJTs, op amps) and electronic circuits.",
    "credits": "3"
  },
  {
    "course_name": "Electronics II",
    "dept": "ECE",
    "num": "526",
    "desc": "Prerequisite: ECE 511 and 525.\nContinuation of Electronics I, with emphasis on performance measures, including frequency response. Additional topics include Miller’s theorem, cascoding, and the application of negative feedback.",
    "credits": "3"
  },
  {
    "course_name": "Control Systems Design",
    "dept": "ECE",
    "num": "530",
    "desc": "Prerequisite: MATH 340 and ECE 512.\nModeling, analysis, and design of control systems. Topics include feedback control; time response and stability of dynamic systems; introduction to root locus and frequency response design.",
    "credits": "3"
  },
  {
    "course_name": "Applied Scientific Computing for Engineers",
    "dept": "ECE",
    "num": "540",
    "desc": "Prerequisite: STAT 510 and CIS 209 or CIS 200.\nMathematical and programming techniques for solving various classes of numerical problems.  General topics, such as the precision of floating point numbers are also discussed. Statistics, linear algebra and optimization are the primary classes of numerical problems addressed.",
    "credits": "3"
  },
  {
    "course_name": "Computer Networking",
    "dept": "ECE",
    "num": "542",
    "desc": "Prerequisite: ECE 241, high-level programming language.\nIntroduction to application, transport, network and link layer protocols, with emphasis to Internet TCP/IP protocols.",
    "credits": "3"
  },
  {
    "course_name": "Electromagnetic Theory I",
    "dept": "ECE",
    "num": "557",
    "desc": "Prerequisite: PHYS 214, ECE 410, and MATH 222.\nVector analysis, electrostatics, magnetostatics, Faraday’s Law, Maxwell’s Equations, transmission line analysis, plane waves, Poynting’s theorem, and applications.",
    "credits": "4"
  },
  {
    "course_name": "Introduction to Biomedical Engineering",
    "dept": "ECE",
    "num": "571",
    "desc": "Prerequisite: MATH 222 and PHYS 214.\nOverview of engineering applied to clinical medicine and the life sciences. Topics include sensors and instrumentation to acquire physiologic data, imaging techniques, biomechanics, health care information technology, assistive technology, telemedicine, home care, emergency services, battlefield medicine, and biomedical career opportunities.",
    "credits": "3"
  },
  {
    "course_name": "Energy Conversion I",
    "dept": "ECE",
    "num": "581",
    "desc": "Prerequisite: ECE 410 or 519.\nThree-phase systems, magnetic circuits, transformers, and DC and AC machines.",
    "credits": "3"
  },
  {
    "course_name": "Wind Energy Research",
    "dept": "ECE",
    "num": "582",
    "desc": "Prerequisite: Instructor permission.\nThis course provides an opportunity to pursue one or more longer-term research questions related to wind engineering, including small-wind siting and installation and meteorological-tower installation and data analysis.",
    "credits": "1"
  },
  {
    "course_name": "Senior Design Experience I",
    "dept": "ECE",
    "num": "590",
    "desc": "Prerequisite: ECE 511, ECE 525, ECE 540 and ENGL 415.\nIntegrates communications, both verbal and written, with ethics and a collaborative design project to emulate a technical professional environment. Introduces design theory, project management, team dynamics, and socio-economic context to design.",
    "credits": "3"
  },
  {
    "course_name": "Senior Design Experience II",
    "dept": "ECE",
    "num": "591",
    "desc": "Prerequisite: ECE 590.\nSecond semester of the senior design experience that implements and demonstrates the project design begun in ECE 590. It includes oral presentations for design reviews and technical documentation such as Project Plan, Concept of Operations, Analyses, Architecture and Requirements, Design Descriptions, and User Manual.",
    "credits": "2"
  },
  {
    "course_name": "Power Electronics",
    "dept": "ECE",
    "num": "624",
    "desc": "Prerequisite: ECE 511, 525.\nDesign and analysis of semiconductor-based circuits such as AC-DC converters (rectifiers), DC-DC converters and DC-AC converters (inverters), and their applications in adjustable speed motor-drives, power supplies, and renewable energy conversion systems.",
    "credits": "3"
  },
  {
    "course_name": "Electronic Instrumentation",
    "dept": "ECE",
    "num": "628",
    "desc": "Prerequisite: ECE 502 and 526.\nApplications of electronics in the design of analog and digital systems for the measurement of physical variables and in the transduction of these variables into a useful form for both recording and control.",
    "credits": "3"
  },
  {
    "course_name": "Microcomputer Systems Design",
    "dept": "ECE",
    "num": "631",
    "desc": "Prerequisite: CIS 308 or 209 or ME 400; ECE 431; ECE 525 or 519.\nDesign and engineering application of 32-bit microcomputers to instrumentation and control. Investigate the relationship of the C language and assembly language. Timing and other interfacing problems will be covered.",
    "credits": "3"
  },
  {
    "course_name": "Real-Time Embedded Systems",
    "dept": "ECE",
    "num": "633",
    "desc": "Prerequisite: CIS 621 and CIS 622.\nInterconnection of peripherals, such as CAN networks, DA/AD converters, and Timers. Implementation of device drivers on top of micro-kernels. Build a simple real time distributed embedded system.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Computer Graphics",
    "dept": "ECE",
    "num": "636",
    "desc": "Prerequisite: CIS 308 or 209; CIS 300; and MATH 222 or 551.\nAn introduction to the software, hardware, and algorithmic aspects of graphics generation. Programming assignments will provide experience in implementing interactive interfaces via application-level graphics libraries.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Digital Design using Logic Synthesis",
    "dept": "ECE",
    "num": "641",
    "desc": "Prerequisite: ECE 441.\nApplications of hardware description languages (HDLs) for the design of complex digital systems. Topics include designing and simulating using HDLs, logic synthesis into FPGAs and ASICs, optimization techniques, timing issues, hardware verification, and design for testability.",
    "credits": "3"
  },
  {
    "course_name": "Computer Engineering Design Lab",
    "dept": "ECE",
    "num": "643",
    "desc": "Prerequisite: CIS 308 or 209; and ECE 441.  Prerequisite or concurrent enrollment: ECE 649.\nThe Design and construction of simple I/O devices and a microcomputer system using simple to complex programmable devices.",
    "credits": "3"
  },
  {
    "course_name": "Digital Electronics",
    "dept": "ECE",
    "num": "645",
    "desc": "Prerequisite: ECE 511, 525, and 441.\nDesign of high-performance digital electronics and systems. Topics include design metrics, device modeling, transmission-line models for wiring, signaling conventions, transmitter and receiver circuits, noise analysis and management, power distribution, timing and synchronization techniques.",
    "credits": "3"
  },
  {
    "course_name": "Digital Signal Processing",
    "dept": "ECE",
    "num": "647",
    "desc": "Prerequisite: ECE 512.\nDifference equation characterization of digital signal processing systems, transient and steady-state analysis of digital filters using the Z-transform, spectral analysis of digital signals, and design and implementation of digital filters.",
    "credits": "3"
  },
  {
    "course_name": "Multimedia Compression",
    "dept": "ECE",
    "num": "648",
    "desc": "Prerequisite: ECE 512 or MATH 551; CIS 308 or 209.\nIntroduction to multimedia creation and representation. Design of multimedia systems, which incorporate audio, image and video. Topics will include the analysis and design of multimedia compression, streaming, delivery, security and authoring. Emphasis will be placed on current multimedia standards and applications.",
    "credits": "3"
  },
  {
    "course_name": "Computer Design I",
    "dept": "ECE",
    "num": "649",
    "desc": "Prerequisite: ECE 441.\nConcepts of computer design.  Information representation, instruction sets and addressing modes.  Arithmetic and logic unit design for fixed and floating point operations. Hardwired and microprogrammed control design. Concepts of pipelining, CISC and RISC architecture. Memory system design including virtual memory, caches and interleaved memories. I/O design methods, interrupt mechanisms, DMA and system integration.",
    "credits": "3"
  },
  {
    "course_name": "Communication Systems I",
    "dept": "ECE",
    "num": "660",
    "desc": "Prerequisite or concurrent enrollment: ECE 512.\nIntroduction to the analysis and design of analog and digital communication systems. Topics include analog and digital modulation schemes, digital encoding of messages, mathematical modeling of communications systems, noise in communication links and calculation of performance measures for practical links.",
    "credits": "3"
  },
  {
    "course_name": "Communication Systems II",
    "dept": "ECE",
    "num": "661",
    "desc": "Prerequisite: ECE 660.\nError-correction code design and analysis with emphasis on block and convolutional coding and decoding; Trellis-coded modulation. Modeling of bandlimited systems and pulse-shape design, optimal receiver design for bandlimited systems, linear and nonlinear equalization. Multiple-access techniques, orthogonal frequency-division multiplexing and receiver design for CDMA schemes. Simulation of practical digital transmission systems.",
    "credits": "3"
  },
  {
    "course_name": "Design of Communication Circuits",
    "dept": "ECE",
    "num": "662",
    "desc": "Prerequisite: ECE 526 and 502.\nThe design of communication circuits and systems operating from baseband to UHF frequencies. Topics include tuned-RF amplifiers, oscillators, mixers, LC and ceramic bandpass filters, and demodulators. Projects involve the design, construction, and performance testing of a complete radio receiver.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Applications of Machine Intelligence",
    "dept": "ECE",
    "num": "670",
    "desc": "Prerequisite: CIS 200 or 209, and PHYS 214.\nStudy of machine intelligence and fuzzy logic concepts and applications in engineering problem domains. As a term project, develop a fuzzy expert system for a specific problem domain that runs on a personal computer and develop the supporting documentation.",
    "credits": "3"
  },
  {
    "course_name": "Wind and Solar Engineering",
    "dept": "ECE",
    "num": "681",
    "desc": "Prerequisite: ECE 525 or 519.\nWind and solar energy resource assessment, operation of renewable-energy systems, photovoltaic and wind-turbine physics, and design of complete systems.",
    "credits": "3"
  },
  {
    "course_name": "Power Laboratory",
    "dept": "ECE",
    "num": "684",
    "desc": "Prerequisite: ECE 624 and ECE 581.\nIntroduction to energy and power converters. Course includes lecture and laboratory experience in aspects of modeling and analysis of electric machines (synchronous and induction machines as well as transformers), power quality (harmonic measurement), control of DC-DC and DC-AC converters, and motor-drive systems.",
    "credits": "3"
  },
  {
    "course_name": "Power Systems Design",
    "dept": "ECE",
    "num": "685",
    "desc": "Prerequisite: ECE 581.\nA comprehensive study of modeling of the electric power system components and computer simulation of interconnected power systems in steady state. Vector-matrix descriptions are emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Power Systems Protection",
    "dept": "ECE",
    "num": "686",
    "desc": "Prerequisite: ECE 581.\nAnalysis of symmetrical and unsymmetrical faults on power systems using symmetrical components technique. Study of protective relaying for protection of power systems against faults. Vector-matrix descriptions and computer solutions are emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Electrical and Computer Engineering",
    "dept": "ECE",
    "num": "690",
    "desc": "",
    "credits": "1-18"
  },
  {
    "course_name": "Optoelectronics",
    "dept": "ECE",
    "num": "694",
    "desc": "Prerequisite: ECE 525, 557, and CHE 356.\nApplied geometric and physical optics, optical radiation, and the interaction of light and matter. The theory and application of photodetectors, lasers, and other photoemitters. Introduction to fiber optical waveguides, sensors, and systems.",
    "credits": "3"
  },
  {
    "course_name": "Integrated Circuit Design",
    "dept": "ECE",
    "num": "696",
    "desc": "Prerequisite: ECE 241 and 525.\nStudy of silicon integrated circuits with emphasis on CMOS analog and digital applications. The course covers basic device structure and modeling, circuit analysis, system design, IC design methodology and economics plus IC fabrication processes. Computer-aided tools are used to simulate and layout circuits designed by student groups.",
    "credits": "3"
  },
  {
    "course_name": "Electroacoustics",
    "dept": "ECE",
    "num": "715",
    "desc": "Prerequisite: ECE 511.\nBasic principles of sound; modeling of, and analogous circuits for, mechanical and acoustical systems; microphones and loudspeakers; Thiele-Small parameters; the analysis and design of, and measurements on, common loudspeaker systems and crossover networks. Projects involve the design, simulation, construction and performance-testing of a complete loudspeaker-and-enclosure system.",
    "credits": "3"
  },
  {
    "course_name": "Audio Engineering",
    "dept": "ECE",
    "num": "722",
    "desc": "Prerequisite: ECE 525. Recommended prerequisite: ECE 526.\nSolid-state and hollow-state analog electronics applicable to high-fidelity audio. Emphasis is on the analysis, design and construction of audio amplifiers. Projects include design, implementation, and performance-evaluation of a reference-quality audio power amplifier.",
    "credits": "3"
  },
  {
    "course_name": "Analog Electronics",
    "dept": "ECE",
    "num": "724",
    "desc": "Prerequisite: ECE 502, ECE 526.\nAnalysis, design, and evaluation of BJT and CMOS operational amplifiers. Core topics include frequency compensation and closed-loop stability, slew-rate optimization, wide-bandwidth design, low-noise design, and macromodeling for simulation.",
    "credits": "3"
  },
  {
    "course_name": "Integrated Circuit Devices and Processes",
    "dept": "ECE",
    "num": "725",
    "desc": "Prerequisite: ECE 525 and CHE 356.\nIntegrated circuit fabrication processes including oxidation, diffusion, ion implantation, lithography, etching, crystal growth, process monitoring, and device characterization. Design of discrete and IC devices through laboratory experiments and computer simulations.",
    "credits": "3"
  },
  {
    "course_name": "Mixed Signal Measurements",
    "dept": "ECE",
    "num": "728",
    "desc": "Prerequisite: ECE 512 or graduate standing.\nSignal classification, noise and uncertainty, TRMS conversion, quantization and ADCs, repetitive sampling and signal recovery techniques, vector voltmeters, basic network analyzers.",
    "credits": "3"
  },
  {
    "course_name": "Control Systems Analysis and Design",
    "dept": "ECE",
    "num": "730",
    "desc": "Prerequisite: ECE 530 or ME 640; ME 730.\nUse of classical analysis techniques for control system compensation. State space control theory fundamentals are presented in addition to an introductory treatment of several major systems areas.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Microcomputer System Design",
    "dept": "ECE",
    "num": "731",
    "desc": "Prerequisite: ECE 631.\nDesign and engineering applications of 16 and 32 bit microprocessors. Utilization of peripheral and co-processor chips.",
    "credits": "3"
  },
  {
    "course_name": "Real-Time Embedded Systems Design",
    "dept": "ECE",
    "num": "733",
    "desc": "Prerequisite or concurrent enrollment: CIS 721.\nDesign and implementation of a comprehensive team project of a complete embedded real-time system.",
    "credits": "3"
  },
  {
    "course_name": "Discrete-Time and Computer-Control Systems",
    "dept": "ECE",
    "num": "736",
    "desc": "Prerequisite: ECE 530 or ME 640.\nAnalysis and design of discrete-time, sampled-data, and computer-control systems using discrete-state equations and Z-transforms.",
    "credits": "3"
  },
  {
    "course_name": "Fault Diagnosis in Digital Systems",
    "dept": "ECE",
    "num": "746",
    "desc": "Prerequisite or concurrent enrollment: ECE 541 or 631.\nHazards, fault detection in combinational circuits, and sequential machines using path sensitizing and fault-matrix methods, state table analysis, etc.; system reliability through logical redundance.",
    "credits": "3"
  },
  {
    "course_name": "Computer Design II",
    "dept": "ECE",
    "num": "749",
    "desc": "Prerequisite: ECE 649.\nStudy of alternate computer hardware structures. Investigation of engineering tradeoffs in implementation of alternative instruction sets and computing structures. Emphasis will be placed on a quantitative approach to cost/performance evaluations including simulation of hardware structures.",
    "credits": "3"
  },
  {
    "course_name": "Electromagnetic Theory II",
    "dept": "ECE",
    "num": "758",
    "desc": "Prerequisite: ECE 557.\nContinuation of ECE 557.",
    "credits": "3"
  },
  {
    "course_name": "Wireless Communications",
    "dept": "ECE",
    "num": "760",
    "desc": "Prerequisite: ECE 660.\nThis course exposes seniors and first year graduate students to important physical layer concepts in wireless communications. Topics include: cellular architecture, large scale and small scale fading channel models, diversity receivers, DS-CDMA transmitter and receiver design, multi-user detection, multi-carrier CDMA and OFDM performance analysis.",
    "credits": "3"
  },
  {
    "course_name": "Antennas and Microwave Circuits",
    "dept": "ECE",
    "num": "764",
    "desc": "Prerequisite: ECE 502, 512, 526, and 557.\nThe design of communication circuits and systems operating at microwave frequencies. Topics include antennas, transmission lines, microstrip matching networks, S-parameters, frequency synthesizers, and downconverter components such as LNAs, mixers, and microstrip bandpass filters. Projects involve design, simulation with electronic design automation tools, and laboratory measurements.",
    "credits": "3"
  },
  {
    "course_name": "Control Theory Applied to Bioengineering",
    "dept": "ECE",
    "num": "771",
    "desc": "Prerequisite or concurrent: ECE 530 or ME 640, and a basic physiology course.\nDevelopment of mathematical models used in the study and analysis of physiological control systems providing techniques for varying pertinent biological parameters.",
    "credits": "3"
  },
  {
    "course_name": "Theory and Techniques of Bioinstrumentation",
    "dept": "ECE",
    "num": "772",
    "desc": "Prerequisite: Concurrent enrollment in ECE 773 (ECE majors only) and AP 773.\nTheoretical aspects of biological signals, electrodes, transducers, digital imaging and computer-based data acquisition directed toward ECE and other science department majors.",
    "credits": "2"
  },
  {
    "course_name": "Bioinstrumentation Design Laboratory",
    "dept": "ECE",
    "num": "773",
    "desc": "Prerequisite: ECE 502 and concurrent enrollment in ECE 772.\nDesign and testing of hardware and software for acquiring and analyzing biological signals.",
    "credits": "1"
  },
  {
    "course_name": "Power Seminar",
    "dept": "ECE",
    "num": "780",
    "desc": "Prerequisite: Junior standing.\nSpeakers from industry, academia, and government present topics related to power systems engineering.",
    "credits": "1"
  },
  {
    "course_name": "Problems in Early Childhood Education",
    "dept": "ECED",
    "num": "300",
    "desc": "Prerequisite: Consent of instructor.\nIndependent or small group study of early childhood development and education.",
    "credits": "1-9"
  },
  {
    "course_name": "Early Childhood",
    "dept": "ECED",
    "num": "310",
    "desc": "Prerequisite: FSHS 110 or PSYCH 110.\nPrinciples of growth and development of children from conception across the early childhood years, including familial, societal, and other ecological factors affecting young children’s development.",
    "credits": "3"
  },
  {
    "course_name": "Infant Observation Lab",
    "dept": "ECED",
    "num": "312",
    "desc": "\nObservation of the behavior and development of children from infancy through toddlerhood.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Professional Experiences in Early Childhood Unified",
    "dept": "ECED",
    "num": "313",
    "desc": "Corequisite: ECED 310.\nObservation and participation in diverse early childhood settings serving children with and without disabilities, aged birth through kindergarten.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Early Childhood Education",
    "dept": "ECED",
    "num": "410",
    "desc": "Prerequisite: ECED 310 and 313.\nExamination of the diversity in contemporary early childhood roles and settings, awareness of professional competencies and standards of practice, and recognition of philosophical and historical foundations of the profession.",
    "credits": "3"
  },
  {
    "course_name": "Interaction Techniques with Young Children",
    "dept": "ECED",
    "num": "420",
    "desc": "Prerequisite: ECED 310 and ECED 313. Early Childhood Education majors only or instructor permission.\nA developmental approach to the acquisition of interaction techniques conducive to healthy emotional and self-concept growth in the child from birth through kindergarten.",
    "credits": "3"
  },
  {
    "course_name": "Exceptional Development in Early Childhood",
    "dept": "ECED",
    "num": "428",
    "desc": "Prerequisite: ECED 310.\nExceptional development in early childhood (birth through kindergarten), including developmental delays, physical and sensory impairments, communication disorders, mental retardation, learning and behavioral disorders, and health related concerns: emphasis on IEPs and IFSPs and the family’s role in the assessment/referral/intervention process.",
    "credits": "3"
  },
  {
    "course_name": "Environments in Early Childhood",
    "dept": "ECED",
    "num": "450",
    "desc": "Prerequisite: ECED 310.\nPlanning, promoting, and maintaining physically and psychologically safe and healthy learning environments for young children. Fostering active, healthy lifestyles and enhanced quality of life for young children through understanding major concepts for nutrition and health education, human movement and physical activity.",
    "credits": "3"
  },
  {
    "course_name": "Language Development",
    "dept": "ECED",
    "num": "466",
    "desc": "Prerequisite: ECED 310.\nSurvey of the development of speech and language skills in children.",
    "credits": "3"
  },
  {
    "course_name": "Professional Seminar in Early Childhood Education",
    "dept": "ECED",
    "num": "524",
    "desc": "Prerequisite: ECED 310 or PSYCH 280.\nExamination of programs for young children, including philosophical and theoretical foundations. Implementation and evaluation of program models and related issues and research.",
    "credits": "3"
  },
  {
    "course_name": "Research and Inquiry in Early Childhood Education",
    "dept": "ECED",
    "num": "528",
    "desc": "Corequisites: ECED 553 or ECED 554.\nStudy and application of fundamental concepts, principles, and methods of educational research in early childhood education with focus on preparing students to become reflective practitioners of action research and critical consumers of research.",
    "credits": "3"
  },
  {
    "course_name": "Teaching & Learning in Early Childhood Education",
    "dept": "ECED",
    "num": "530",
    "desc": "Prerequisite: ECED 310 and ECED 313. Corequisite: ECED 531.\nApplication of developmental and educational theories to teaching and learning in early childhood education programs serving children aged birth through kindergarten, including children with special needs.",
    "credits": "3"
  },
  {
    "course_name": "Developmental Curriculum in Early Childhood Education",
    "dept": "ECED",
    "num": "531",
    "desc": "Prerequisites: ECED 310 and ECED 313. Corequisite: ECED 530.\nThe planning and application of developmental curriculum across the content areas to enhance the development and learning of young children.",
    "credits": "3"
  },
  {
    "course_name": "Reflective Practice: Infants and Toddlers",
    "dept": "ECED",
    "num": "543",
    "desc": "\nApplication of developmental principles and evidenced-based practice to the diverse learning environments for infants and toddlers with and without special needs across content areas including the integration of the family and community and public policies that affect programs for young children.",
    "credits": "3"
  },
  {
    "course_name": "Reflective Practice: Preschoolers and Kindergartners",
    "dept": "ECED",
    "num": "544",
    "desc": "Prerequisite: ECED 554 and 555 required.\nApplication of developmental principles and evidenced-based practice to the diverse learning environments for preschoolers and kindergarteners with and without special needs across content areas including the integration of the family and community and public policies that affect programs for young children.",
    "credits": "3"
  },
  {
    "course_name": "Early Childhood Program Lab II",
    "dept": "ECED",
    "num": "546",
    "desc": "Corequisite: FSHS 545 and admission into teacher education.\nAdvanced application of principles and techniques for developmentally-appropriate programs for young children. Planning, implementing, and evaluating activities in a supervised lab setting.",
    "credits": "2"
  },
  {
    "course_name": "Early Childhood Practicum I: Infants and Toddlers",
    "dept": "ECED",
    "num": "553",
    "desc": "Corequisite: ECED 543.\nDevelopment and implementation of developmentally and functionally appropriate learning experiences, in a variety of formats, addressing content in the areas of early language and literacy, mathematics, science, social studies, the arts, and technology for infants and toddlers.",
    "credits": "1"
  },
  {
    "course_name": "Early Childhood Practicum II: Preschoolers",
    "dept": "ECED",
    "num": "554",
    "desc": "Corequisite: ECED 544.\nDevelopment and implementation of developmentally and functionally appropriate learning experiences, in a variety of formats, addressing content in the areas of early language and literacy, mathematics, science, social studies, the arts, and technology for the preschool child.",
    "credits": "1"
  },
  {
    "course_name": "Early Childhood Practicum III: Kindergartners",
    "dept": "ECED",
    "num": "555",
    "desc": "Corequisite: ECED 544.\nDevelopment and implementation of developmentally and functionally appropriate learning experiences, in a variety of formats, addressing content in the areas of early language and literacy, mathematics, science, social studies, the arts, and technology for the kindergarten child.",
    "credits": "1"
  },
  {
    "course_name": "Early Childhood Practicum 4: Home Visiting",
    "dept": "ECED",
    "num": "556",
    "desc": "Prerequisite: ECED 543.\nDevelopment and implementation of developmentally and functionally appropriate experiences, within the context of an individualized family plan, addressing development and content in the areas of early language and literacy, mathematics, science, social studies, the arts, and technology for infants and toddlers in home based settings.  Admission to teacher education required.",
    "credits": "1"
  },
  {
    "course_name": "Emergent Literacy",
    "dept": "ECED",
    "num": "566",
    "desc": "Prerequisite: ECED 466.\nExploration of literacy development from birth through kindergarten, including concepts relevant to pre-emergent, emergent, and developing literacy; procedures for designing developmentally and culturally appropriate experiences; factors impacting literacy acquisition and assessment; and intervention procedures for children at-risk for reading and writing problems.",
    "credits": "3"
  },
  {
    "course_name": "Home, School, and Community Partnerships",
    "dept": "ECED",
    "num": "597",
    "desc": "Prerequisite: FSHS 350 and ECED 428 or permission of instructor.\nStrategies to enhance home-school communication with specific focus on families as the primary decision-makers for young children, with or without special needs. Emphasis on the development of family focused and culturally sensitive collaborations involving parents, schools, and the community to support child development, learning, and well-being.",
    "credits": "3"
  },
  {
    "course_name": "Student Teaching in Early Childhood Unified",
    "dept": "ECED",
    "num": "598",
    "desc": "Prerequisite: ECED 543, 544, 553, 554, 555 and admission to teacher education.\nDesign, implementation, assessment of developmentally and individually appropriate evidence-based curriculum for children with and without disabilities birth through kindergarten.",
    "credits": "9"
  },
  {
    "course_name": "Problems in Early Childhood Education",
    "dept": "ECED",
    "num": "700",
    "desc": "Prerequisite: Consent of instructor.\nIndependent study of relevant aspects of early childhood development and education.",
    "credits": "1-6"
  },
  {
    "course_name": "Seminar in Early Childhood Education",
    "dept": "ECED",
    "num": "704",
    "desc": "Prerequisite: Consent of instructor.\nInterpretation and evaluation of information on varied topics relating to early childhood education and development.",
    "credits": "1-6"
  },
  {
    "course_name": "Topics in Early Childhood Education",
    "dept": "ECED",
    "num": "708",
    "desc": "Prerequisite: Consent of instructor.\nReview of recent research and theory related to early childhood education and development.",
    "credits": "1-3"
  },
  {
    "course_name": "Child Care: Components and Issues",
    "dept": "ECED",
    "num": "710",
    "desc": "Prerequisite: Fifteen (15) credit hours of either social science and/or FSHS.\nProfessional development and leadership; skills, services, and resources supporting quality early childhood care and education.",
    "credits": "3"
  },
  {
    "course_name": "Challenging Behaviors in Early Childhood",
    "dept": "ECED",
    "num": "720",
    "desc": "Prerequisite: ECED 428.\nThe application of developmental principles and evidence-based practices to design and implement a positive learning environment for young children, including children with disabilities. Creating an environment that supports young children’s social emotional competence, teaches social skills, and promotes self-regulation is emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Assessment of Young Children",
    "dept": "ECED",
    "num": "728",
    "desc": "Prerequisite: FSHS 310, FSHS 428, and FSHS 540.\nTheory and practice of individual assessment of handicapped and normal children, infancy to age eight, including cognitive, language, fine and gross motor, social, and self-help skills. Focus on selection, administration, interpretation, and evaluation of screening and comprehensive evaluation instruments for assessment and individual program planning.",
    "credits": "3"
  },
  {
    "course_name": "Early Childhood Program Administration",
    "dept": "ECED",
    "num": "730",
    "desc": "Prerequisite: FSHS 450 or consent of instructor.\nProfessional practice and organizational management of early childhood care and education programs; financial and personnel management, program development, and community relations.",
    "credits": "3"
  },
  {
    "course_name": "Play Facilitation",
    "dept": "ECED",
    "num": "740",
    "desc": "Prerequisite: FSHS 540 or consent of instructor.\nThe emphasis of this course is the empirical study and practice of play as an educational, evaluative, and therapeutic intervention with young children.",
    "credits": "3"
  },
  {
    "course_name": "Home Visiting Programs for Young Children and Families",
    "dept": "ECED",
    "num": "797",
    "desc": "Prerequisites: ECED 543.\nExamination of the empirical literature that supports the provision of early intervention and education services to families with young children through a home visitation model; focus on programs that use home visitation; an understanding of the key principles in early intervention; and the development of skills necessary to implement a coaching model of service delivery to enhance family and child outcomes.",
    "credits": "3"
  },
  {
    "course_name": "Basic Electronics",
    "dept": "ECET",
    "num": "100",
    "desc": "Corequisite: MATH 100 or consent of instructor.\nA survey course designed to provide an overview of basic direct and alternating current circuits and an introduction to linear and digital electronics. Laboratory exercises reinforce circuit theory and provide skills in the use of common electronic instruments.",
    "credits": "4"
  },
  {
    "course_name": "Direct Current Circuits",
    "dept": "ECET",
    "num": "101",
    "desc": "Prerequisite: ECET 100.\nAn introductory course in basic circuit theory emphasizing the analysis of passive circuit networks containing resistance, capacitance, and inductance operating in direct current conditions. Topics include equivalent circuits, network theorems, capacitance, RC-circuit response, inductance, RL-circuit response, and computer simulation.",
    "credits": "3"
  },
  {
    "course_name": "Semiconductor Electronics",
    "dept": "ECET",
    "num": "110",
    "desc": "Prerequisite: MATH 100.\nAn introductory course in electronic devices. Topics include PN-junction theory, diodes, transistors, transistor biasing, transistor modeling, operational amplifiers, voltage regulators, and field-effect transistors (FET).",
    "credits": "4"
  },
  {
    "course_name": "Alternating Current Circuits",
    "dept": "ECET",
    "num": "201",
    "desc": "Prerequisite: ECET 100 and MATH 150.\nAnalysis of passive networks containing resistance, capacitance, and inductance operating in alternating current conditions. Includes sinusoidal waveforms, polar and rectangular complex algebra, inductive and capacitive reactance, impedance networks, power factor correction, resonance, magnetic circuits, and an introduction to three-phase power distribution.",
    "credits": "4"
  },
  {
    "course_name": "Linear Circuit Applications",
    "dept": "ECET",
    "num": "210",
    "desc": "Prerequisite: ECET 110. Corequisite: ECET 201.\nAnalysis and design of analog circuits including differential amplifiers, oscillators, linear and switching power amplifiers, applications of operational amplifiers, advanced semiconductor devices, and heat sinks.",
    "credits": "4"
  },
  {
    "course_name": "Electronic Manufacturing",
    "dept": "ECET",
    "num": "240",
    "desc": "Prerequisite: ECET 110.\nA practical course in the details of electronic system design and fabrication. Topics include 2D CAD; printed-circuit board design, layout, and fabrication; electronic-system design principles; fabrication, packaging and assembly techniques for electronic systems; and through-hole and surface-mount technologies.",
    "credits": "3"
  },
  {
    "course_name": "Digital Logic",
    "dept": "ECET",
    "num": "250",
    "desc": "Corequisite: ECET 100.\nStudy of basic logic elements including gates, flip-flops, counters, and registers. Includes Boolean algebra, logic reduction methods, and digital logic applications. Emphasis on computer simulation and PLD implementation of logic circuits.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Electronic and Computer Engineering Technology",
    "dept": "ECET",
    "num": "299",
    "desc": "Prerequisite: Consent of instructor.\nProvides an opportunity for faculty to present electronic and computer engineering technology topics.",
    "credits": "1-18"
  },
  {
    "course_name": "Electric Power and Devices",
    "dept": "ECET",
    "num": "304",
    "desc": "Prerequisite: ECET 100 and MATH 150.\nIndustrial applications of direct and alternating power, devices, and systems. Topics include electrical and electronic power devices, controllers, servomechanisms, and actuators; DC and AC motors and generators, motor speed control and drive systems; electrical power distribution, and industrial electronics applications.",
    "credits": "3"
  },
  {
    "course_name": "Electronic Communication Systems",
    "dept": "ECET",
    "num": "320",
    "desc": "Prerequisite: ECET 110, ECET 201, and MATH 220.\nA survey of analog and digital communication techniques and systems including modulation, transmission line concepts, radio-wave propagation, antenna theory, and the effects of noise.",
    "credits": "4"
  },
  {
    "course_name": "Industrial Controls",
    "dept": "ECET",
    "num": "330",
    "desc": "Corequisite: ECET 350.\nA study of electronic circuits and systems encountered in industrial environments. Topics include power control devices and applications, power system design, sensors, transducers, PLCs, computer-based data acquisition, and automatic control concepts.",
    "credits": "4"
  },
  {
    "course_name": "Industrial Control Topics",
    "dept": "ECET",
    "num": "335",
    "desc": "Prerequisite: ECET 100.\nStudy of the applications of electronic circuits and systems in industrial environments. Topics include control systems and devices, control system modeling and simulation.",
    "credits": "1"
  },
  {
    "course_name": "Microprocessor Fundamentals",
    "dept": "ECET",
    "num": "350",
    "desc": "Prerequisite: ECET 250.\nConcepts of microprocessor architecture, programming, and interfacing. Topics include assembly language programming, data conversion methods, and microprocessor-based system development tools.",
    "credits": "4"
  },
  {
    "course_name": "Digital Circuits and Systems",
    "dept": "ECET",
    "num": "352",
    "desc": "Prerequisite: ECET 350.\nStudy of digital circuits and systems, i.e., systems controlled by microprocessors and microcontrollers. Students design and build digital circuits for the solution of engineering problems. Digital circuit design, interfacing techniques, and embedded systems programming are emphasized.",
    "credits": "4"
  },
  {
    "course_name": "Programmable Logic Controllers",
    "dept": "ECET",
    "num": "385",
    "desc": "Prerequisite: ECET 100 and ECET 335 or MET 230.\nStudy of the applications of programmable logic controllers (PLCs) in industrial environments. Topics include hardware, wiring, configurations, programming, documentation, troubleshooting, and maintenance of PLC systems.",
    "credits": "3"
  },
  {
    "course_name": "Electromagnetic Applications",
    "dept": "ECET",
    "num": "414",
    "desc": "Prerequisite: ECET 320 and MATH 220.\nEmphasizes the physical understanding and visualization of Maxwell’s Equations leading to the design of linear bilateral circuit components, waveguides and passive sensors for use in the radio-frequency (RF) regime.",
    "credits": "4"
  },
  {
    "course_name": "Communication Circuits Design",
    "dept": "ECET",
    "num": "420",
    "desc": "Prerequisite: ECET 320.\nAn introduction to the theory and design of electronic circuits for communications emphasizing the implementation and analysis of common radio-frequency (RF) building blocks. Topics include s-parameters, the Smith chart, component behavior, RF test equipment, computer simulation, filter design, impedance matching, amplifiers, oscillators, mixers, and demodulators.",
    "credits": "4"
  },
  {
    "course_name": "Telecommunication Systems",
    "dept": "ECET",
    "num": "421",
    "desc": "Prerequisite: ECET 320, CMST 250, and MATH 221.\nAn introduction to data communications and a survey of modern communication systems. Topics include Fourier analysis, data encoding, data link control, fiber-optic systems, cellular systems, satellite systems, and the modern telephone system.",
    "credits": "4"
  },
  {
    "course_name": "Signals and Systems",
    "dept": "ECET",
    "num": "430",
    "desc": "Prerequisite: ECET 330 or MET 382.\nA study of various network topics including Laplace transforms, signal flow graph models, transfer functions, network response, and differential equations and linear approximations of physical systems. The theory of control systems and their applications are discussed.",
    "credits": "3"
  },
  {
    "course_name": "Digital Systems and Computer Architecture",
    "dept": "ECET",
    "num": "450",
    "desc": "Prerequisite: ECET 350.\nDevelopment of advanced digital design techniques. Topics include VHDL-based design, simulation, and synthesis; testing and validation; system-level interfacing; and computer architecture.",
    "credits": "4"
  },
  {
    "course_name": "Electronic Design I",
    "dept": "ECET",
    "num": "480",
    "desc": "Prerequisite: ECET 320 and ECET 352 and ENGL 302.\nApplication of electronic principles and the design methodology to solving a significant design problem in a team context. Includes determining customer requirements, exploring and choosing design alternatives, scheduling, and project management. Significant milestones are the project’s conceptual, preliminary, and critical design reviews, which require written and oral presentations.",
    "credits": "1"
  },
  {
    "course_name": "Electronic Design II",
    "dept": "ECET",
    "num": "481",
    "desc": "Prerequisite: ECET 480.\nA continuation of ECET 480. Includes the implementation, testing, and delivery of the project initiated in ECET 480 Electronic Design I. Significant milestones are the project prototype, design report, and final presentation.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Topics in Electronic and Computer Engineering Technology",
    "dept": "ECET",
    "num": "499",
    "desc": "Prerequisite: Consent of instructor.\nProvides an opportunity for faculty to present advanced electronic and computer engineering technology topics.",
    "credits": "1-18"
  },
  {
    "course_name": "Principles of Macroeconomics",
    "dept": "ECON",
    "num": "110",
    "desc": "Prerequisite: Probability of a grade of C or higher (PROB ≥ C) of at least 40 percent according to the economics component if the ACT Student Profile, a score of 18 or higher on the Math placement exam, or a Grade of B or higher in MATH 010.\nBasic facts, principles, and problems of economics; determination of the level of output, employment, and the price level; the monetary and banking system; problems and policies of economic instability, inflation, and growth; principles of economic development; other economics systems.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Macroeconomics - Honors",
    "dept": "ECON",
    "num": "111",
    "desc": "Prerequisite: Participation in honors program and consent of instructor.\nBasic facts, principles, and problems of economics; determination of the level of output, employment, and the price level; the monetary and banking system; problems and policies of economic instability, inflation, and growth; principles of economic development; other economics systems.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Microeconomics",
    "dept": "ECON",
    "num": "120",
    "desc": "Prerequisite: Probability of a grade of C or higher (PROB ≥ C) of at least 40 percent according to the economics component of the ACT Student Profile, a score of 18 or higher on the Math Placement Exam, or a grade of B or higher in MATH 010.\nBasic facts, principles, and problems of economics including study of the determination of prices; the determination of wages, rent, interest, and profit; theory of the firm; monopoly and government regulation; international economic relations.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Economics",
    "dept": "ECON",
    "num": "399",
    "desc": "\nFor sophomores in honors program-scheduled irregularly. Readings and discussions.",
    "credits": "3"
  },
  {
    "course_name": "Sophomore/Junior Seminar in Economics",
    "dept": "ECON",
    "num": "401",
    "desc": "Prerequisite: ECON 110 and ECON 120.\nAn introduction to economics as a science and a profession. The course introduces students to the skills and tools that make economics an attractive and enjoyable field as well as an overview of economic data and current debates.",
    "credits": "1"
  },
  {
    "course_name": "Honors Project",
    "dept": "ECON",
    "num": "499",
    "desc": "\nOpen only to Arts and Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "South Asian Civilizations",
    "dept": "ECON",
    "num": "505",
    "desc": "Prerequisite: Three hours of social science or junior standing.\nInterdisciplinary survey of the development of civilization in India, Pakistan, Sri Lanka, Bangladesh, and Afghanistan, including geography, history, religion, culture, language, literature, current economy, and significant social movements.",
    "credits": "3"
  },
  {
    "course_name": "The Japanese Economy",
    "dept": "ECON",
    "num": "507",
    "desc": "Prerequisite: ECON 110.\nAnalyzes Japan’s growth, productivity change, income distribution, government policies, agriculture, industrial structure, labor relations education and technology, and international trade and finance. Emphases will be on U.S.-Japanese competition and comparisons.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Macroeconomics",
    "dept": "ECON",
    "num": "510",
    "desc": "Prerequisite: ECON 110, and one of the following, ECON 120 or AGEC 120 or AGEC 121.\nAn examination of the behavior of the economy as a whole, including an analysis of the national income account, consumption, investment, money, interest, the price, level, the level of employment, monetary and fiscal policy, and economic growth.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Microeconomics",
    "dept": "ECON",
    "num": "520",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121.\nAn examination of the theories of consumer behavior and demand, and the theories of production, cost, and supply. The determination of product prices and output in various market structures, and an analysis of factor pricing. Introduction to welfare economics.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Microeconomic Theory",
    "dept": "ECON",
    "num": "521",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121; and MATH 205 or 220.\nA mathematical approach to intermediate microeconomics. Emphasis is placed on the use of optimization techniques to examine consumer demand, production and cost, behavior of the firm, market structure and welfare.",
    "credits": "3"
  },
  {
    "course_name": "Human Resource Economics",
    "dept": "ECON",
    "num": "523",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121.\nAn introduction to the economic forces influencing wage and employment determination, income differentials, unemployment, and the production and acquisition of human capital. Emphasis on public policy, labor unions, and other relevant institutions.",
    "credits": "3"
  },
  {
    "course_name": "Sports Economics",
    "dept": "ECON",
    "num": "524",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121.\nAn economic analysis of professional and amateur sports. Pay determination of professional athletes, monopsony power of owners, discrimination, the importance of leagues, competitive balance, antitrust issues, collective bargaining, the financing of sports stadiums, and current economic issues in sports.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Economics",
    "dept": "ECON",
    "num": "527",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121.\nEconomics of environmental market failure and the efficient use of exhaustible and renewable resources. Topics include the application of markets and government policies to greenhouse warming, air and water pollution, and recycling.",
    "credits": "3"
  },
  {
    "course_name": "Money and Banking",
    "dept": "ECON",
    "num": "530",
    "desc": "Prerequisite: ECON 110.\nNature, principles, and functions of money; development and operation of financial institutions in the American monetary system, with emphasis on processes, problems, and policies of commercial banks in the United States.",
    "credits": "3"
  },
  {
    "course_name": "Fiscal Operation of State and Local Government",
    "dept": "ECON",
    "num": "532",
    "desc": "Prerequisite: ECON 110 and permission of instructor.\nDesigned for students who plan careers related to state or local government. Selected topics in state and local taxation and expenditure.",
    "credits": "3"
  },
  {
    "course_name": "Comparative Economics",
    "dept": "ECON",
    "num": "536",
    "desc": "Prerequisite: ECON 110 or ECON 120 or AGEC 120 or AGEC 121.\nThe transition by Russia, Ukraine, Eastern and Central Europe, and Central Asia to market economics; economic reform in China, India, and other countries; and Marxian critiques of capitalism.",
    "credits": "3"
  },
  {
    "course_name": "Managerial Economics",
    "dept": "ECON",
    "num": "540",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121; and an introductory-level statistics course (STAT 325, STAT 340, or STAT 350); and MATH 205 or MATH 220.\nMicroeconomic topics applicable to understanding and analyzing firm behavior: optimization, demand, estimation, production, and cost theory. Applications to business problems.",
    "credits": "3"
  },
  {
    "course_name": "Urban and Regional Economics",
    "dept": "ECON",
    "num": "555",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121.\nAn examination of the determinants of the economic performance of urban and regional economies, including theory, problems, and policy.",
    "credits": "3"
  },
  {
    "course_name": "Senior Seminar in Economics",
    "dept": "ECON",
    "num": "580",
    "desc": "Prerequisite: ECON 510; and ECON 520 or ECON 521; and STAT 351, or STAT 511 or STAT 705 or concurrent enrollment in one of the three. ECON majors only.\nTopics for class discussion include history of economic thought, research methods in economics, and current economic issues. Students will prepare and present papers written with faculty guidance.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Economics",
    "dept": "ECON",
    "num": "595",
    "desc": "\nIndividual study is offered in international trade, labor relations, money and banking, public finance, transportation, general economics.",
    "credits": "1-18"
  },
  {
    "course_name": "Topics in Economics",
    "dept": "ECON",
    "num": "599",
    "desc": "Prerequisite: To be set for each topic.\nCourses on special topics to be taught on demand.",
    "credits": "1-3"
  },
  {
    "course_name": "Economic Applications of Game Theory and Strategic Behavior",
    "dept": "ECON",
    "num": "605",
    "desc": "Prerequisite: ECON 520 or 521; and MATH 205 or MATH 220.\nBasic principles of game theory including Nash equilibria, repeated games, and strategy with incomplete information.",
    "credits": "3"
  },
  {
    "course_name": "Labor Economics",
    "dept": "ECON",
    "num": "620",
    "desc": "Prerequisite: ECON 520 or ECON 521.\nEconomics of the labor market–theory and empirical evidence. Labor force composition and trends, labor supply, labor demand, human capital, wage differentials, migration, trade unions, and current issues.",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Labor Problems",
    "dept": "ECON",
    "num": "627",
    "desc": "Prerequisite: ECON 620 or consent of instructor.\nEmphasis on current research and public policies dealing with such matters as full employment, poverty, discrimination, social security, unemployment insurance, health care, minimum wages, training, and education.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Econometrics",
    "dept": "ECON",
    "num": "630",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121; and MATH 205 or 220; and STAT 351 or AGEC 501 or STAT 511 or STAT 705.\nAn introduction to the analytical and quantitative methods used in economics. Applications to specific problems with an emphasis on computer analyses.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Transportation",
    "dept": "ECON",
    "num": "631",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121.\nExamines the transportation market from the shippers’ point of view by examining the impact of transportation on business firm decisions such as location, markets, and prices. Also covers the costs, prices, and service characteristics of railroads, motor carriers, water carriers, oil pipelines and airlines. The role and impact of government in the transportation market is examined from both a promotion and regulation perspective.",
    "credits": "3"
  },
  {
    "course_name": "Public Finance",
    "dept": "ECON",
    "num": "633",
    "desc": "Prerequisite: ECON 110, and ECON 120 or AGEC 120 or AGEC 121.\nCourse seeks answers to questions such as: Which goods should be provided by the private sector and which by the public sector (government)? With what criteria are public expenditures evaluated? What is an equitable and efficient tax system? Who bears the tax burden? What aspects of existing taxes need reform?",
    "credits": "3"
  },
  {
    "course_name": "Industrial Organization and Public Policy",
    "dept": "ECON",
    "num": "640",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121.\nAn examination of measures and determinants of industrial concentration, and an analysis of market structure, conduct, and performance, and policies related to performance.",
    "credits": "3"
  },
  {
    "course_name": "International Trade",
    "dept": "ECON",
    "num": "681",
    "desc": "Prerequisite: ECON 110 and one of the following: ECON 120 or AGEC 120 or AGEC 121.\nPrinciples of international trade, determinants of the value of trade between any pair of countries, sources of gains from trade, main factors determining the pattern of trade, commercial policy, the political economy of trade and strategic trade policy.",
    "credits": "3"
  },
  {
    "course_name": "Development Economics",
    "dept": "ECON",
    "num": "682",
    "desc": "Prerequisite: ECON 110.\nFactors affecting the economic modernization of the less-developed countries. Emphasis on capital formation, human capital, investment allocation, technical progress, income distribution, population growth, and the international economics of development.",
    "credits": "3"
  },
  {
    "course_name": "International Finance and Open Economy Macroeconomics",
    "dept": "ECON",
    "num": "684",
    "desc": "Prerequisite: ECON 110; and ECON 120 or AGEC 120 or AGEC 121; and ECON 510.\nIntroduction to international finance and open-economy macroeconomics, including the foreign exchange market, the balance of payments, international financial markets, and recent and ongoing financial crises. Covers core theoretical material, the course will examine current policy issues.",
    "credits": "3"
  },
  {
    "course_name": "Economics Forecasting",
    "dept": "ECON",
    "num": "686",
    "desc": "Prerequisite: ECON 110; and ECON 120 or AGEC 120 or AGEC 121.\nFocus on forecasting macroeconomic variables such as sales activity, tax revenues and other important variables. Techniques of forecasting using econometrics.",
    "credits": "3"
  },
  {
    "course_name": "Health Economics",
    "dept": "ECON",
    "num": "688",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121.\nThis course applies the tools of microeconomics to the health-care sector. It analyzes the behavior of consumers and providers of medical care, the functioning of insurance markets, and the roles of government and the private sector. International comparisons are made.",
    "credits": "3"
  },
  {
    "course_name": "Monetary, Credit, and Fiscal Policies",
    "dept": "ECON",
    "num": "690",
    "desc": "Prerequisite: ECON 530.\nGoals of aggregative economic policy, conflicts among goals, and measures to resolve conflicts; money markets; targets of central bank control; the relative strength of monetary and fiscal policies; rational expectations hypothesis and policy ineffectiveness debate; terms structure of interest rates.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Methods in Economics",
    "dept": "ECON",
    "num": "695",
    "desc": "Prerequisite: ECON 110; and ECON 120 or AGEC 120 or AGEC 121; and ECON 630.\nDevelopment of a research proposal and completion of a research project under the guidance of a faculty member. Instruction in research design, methods and data. The independent-work phase of the course will be structured with weekly targets for completing economic theory, data/case study description, methods description and analysis and interpretation.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Economics",
    "dept": "ECON",
    "num": "699",
    "desc": "Prerequisite: ECON 120 or AGEC 120 or AGEC 121.\nSeminars of special interest will be offered on demand.",
    "credits": "1-3"
  },
  {
    "course_name": "History of Economic Thought",
    "dept": "ECON",
    "num": "710",
    "desc": "Prerequisite: ECON 510.\nDevelopment of economic ideas and doctrines and the relation of these to conditions existing when they were formulated.",
    "credits": "3"
  },
  {
    "course_name": "Microeconomic Theory",
    "dept": "ECON",
    "num": "720",
    "desc": "Prerequisite: ECON 520 or ECON 521; and MATH 205 or MATH 220.\nDemand, cost, and production theories; price and output determination in different market structures; the theory of factor market pricing; an introduction to general equilibrium and welfare analysis.",
    "credits": "3"
  },
  {
    "course_name": "Applied Econometrics",
    "dept": "ECON",
    "num": "730",
    "desc": "\nEmphasis on applied econometrics methods. Topics include simple and multiple linear regression as well as other econometric models used in economics. Diagnosis and remedies of potential problems with linear models and data, leading to quantitative answers to empirical questions.",
    "credits": "3"
  },
  {
    "course_name": "Mathematical Economics",
    "dept": "ECON",
    "num": "735",
    "desc": "Prerequisite: ECON 520; and MATH 205 or MATH 220.\nApplication of mathematical tools of concrete problems in micro- and macro-economics; mathematical treatment of models of consumption, production, market equilibrium, and aggregate growth.",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Adult Learning and Leadership",
    "dept": "EDACE",
    "num": "502",
    "desc": "Prerequisite: Consent of department chair.\nSelected topics in professional education.",
    "credits": "1-3"
  },
  {
    "course_name": "International Education",
    "dept": "EDACE",
    "num": "714",
    "desc": "\nContemporary overview of the field of international education and an introduction to three of its parts. Comparative education, intercultural education, and development education.",
    "credits": "3"
  },
  {
    "course_name": "Adult Basic Education Techniques",
    "dept": "EDACE",
    "num": "725",
    "desc": "\nEmphasis on providing students with an understanding of the selection, utilization, and development of adult basic education reference, resources, and other materials.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Adult Learning and Leadership",
    "dept": "EDACE",
    "num": "733",
    "desc": "Prerequisite: Consent of instructor.\nRelated occupational or professional experiences in approved industry, school, Cooperative Extension Service, or similar agency setting under faculty supervision.",
    "credits": "1-6"
  },
  {
    "course_name": "Women, Education, Leadership, and Work",
    "dept": "EDACE",
    "num": "750",
    "desc": "\nEmphasizes the collective and individual educational needs of women in and out of the work force and the part that occupational/educational preparation contributes to their participation in the work force.",
    "credits": "3"
  },
  {
    "course_name": "Adult Basic Education",
    "dept": "EDACE",
    "num": "754",
    "desc": "Prerequisite: Adult teaching experience or consent of instructor.\nEvolving adult basic and high school equivalency education concepts will be examined. Program implementation, supervision, methods, and materials are emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Adult Learners and Integrating Technology into Curriculum",
    "dept": "EDACE",
    "num": "765",
    "desc": "\nThis course includes an in-depth study of methods for integrating innovative technologies into the curriculum for adult learners. With an indepth understanding of adult learners, students will analyze learning theories and appropriate technologies for revlevance, effectiveness, and alignment with course curriculum.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Adult Learning and Leadership",
    "dept": "EDACE",
    "num": "775",
    "desc": "Prerequisite: Consent of instructor.\nReadings in research and application in specialized areas in education.",
    "credits": "1-3"
  },
  {
    "course_name": "Introduction to Adult Learning and Leadership",
    "dept": "EDACE",
    "num": "780",
    "desc": "Prerequisite: Consent of instructor.\nA survey of adult learning and leadership field. Consideration given to articulation with other levels of education. Identification of changing needs within the field are reviewed.",
    "credits": "3"
  },
  {
    "course_name": "Educational Gerontology",
    "dept": "EDACE",
    "num": "782",
    "desc": "\nFor both the practitioner and those interested in educational gerontology as a field of inquiry. It will examine education for and about aging, with particular reference to the role, needs, and ability of persons in the later years as learners.",
    "credits": "3"
  },
  {
    "course_name": "Designing Classroom Instruction and Curriculum for Adult Learners",
    "dept": "EDACE",
    "num": "785",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Topics in Adult Learning and Leadership",
    "dept": "EDACE",
    "num": "786",
    "desc": "\nExamination of current topic in area of specialization of faculty.",
    "credits": "1-3"
  },
  {
    "course_name": "Characteristics of the Adult Learner",
    "dept": "EDACE",
    "num": "790",
    "desc": "\nFor teachers and administrators in adult and occupational programs who need a familiarity with the major characteristics of adulthood which affect the adult as a learner.",
    "credits": "3"
  },
  {
    "course_name": "Hospital and Industry Adult Learning and Leadership",
    "dept": "EDACE",
    "num": "792",
    "desc": "\nAn introduction to principles, roles, organization, procedures, and problems of adult learning and leadership in hospitals, industry, and related agencies.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Adult Learning and Leadership",
    "dept": "EDACE",
    "num": "795",
    "desc": "Prerequisite: Consent of instructor.\nIndependent study of specific problems in the areas of adult learning and leadership.",
    "credits": "1-18"
  },
  {
    "course_name": "Healthful and Safe College Life",
    "dept": "EDCEP",
    "num": "103",
    "desc": "\nAddresses pertinent health education topics that impact college students and explores the effect of lifestyle choices on academic achievement. Topics include sexual health, mental health, nutrition and fitness, alcohol/drugs/tobacco, injury and illness prevention education.",
    "credits": "3"
  },
  {
    "course_name": "Supplemental Instruction",
    "dept": "EDCEP",
    "num": "109",
    "desc": "\nPeer-facilitated supplemental instruction that supports learning in affiliated course. Practice and development of study skills, learning strategies, and specific learning goals.",
    "credits": "1"
  },
  {
    "course_name": "Study Skills and Strategies",
    "dept": "EDCEP",
    "num": "110",
    "desc": "\nAssists first-year students in developing effective study skills, collaboration skills, and multicultural competencies. Prepares students for the independent learning and decision-making skills needed for their sophomore year and beyond.",
    "credits": "1-3"
  },
  {
    "course_name": "The University Experience",
    "dept": "EDCEP",
    "num": "111",
    "desc": "Prerequisite: New students or instructor consent.\nIntroduction to the university experience through participation interactive seminar classes and co-curricular events. Study of topics such as academic skills, including communication and critical thinking, time management, academic and career planning and goal setting, and community building.",
    "credits": "1-2"
  },
  {
    "course_name": "Academic and Career Decisions",
    "dept": "EDCEP",
    "num": "120",
    "desc": "\nAddresses general principles of academic and career choice through lectures, class discussions, and individual research. Topics include decision-making models and principles; exploration of interests, abilities, and values through career assessments; and academic and career investigation using interactive software, library materials, online resources, and experiential learning opportunities.",
    "credits": "1"
  },
  {
    "course_name": "Development and Integrity",
    "dept": "EDCEP",
    "num": "160",
    "desc": "\nProvides a general overview of ethics and ethical decision making in academia and professional life.  It is designed to help students better understand issues about academic misconduct, as well as several approaches to thinking about and resolving ethical dilemmas.",
    "credits": "1"
  },
  {
    "course_name": "Career and Life Planning",
    "dept": "EDCEP",
    "num": "202",
    "desc": "\nApplies theory research concerning assessment interest and career choice-making to individual’s planning and decision-making. Focuses on increasing understanding of the complexities of the world of work and on skills of integrating such understanding with each person’s planning experience, characteristics, motives, and values in the career exploration process. Reviews resume writing, interviewing skills, and job search techniques.",
    "credits": "2"
  },
  {
    "course_name": "Leadership Training Seminar",
    "dept": "EDCEP",
    "num": "211",
    "desc": "Prerequisite: Sophomore standing and consent of instructor.\nGeneral principles of leadership as applied to small groups. Study of the role of the leader, group processes and interaction, defining group goals, and techniques of observation. Workshop and supervision in small group leadership.",
    "credits": "2"
  },
  {
    "course_name": "Interaction and Guidance for the Paraprofessional",
    "dept": "EDCEP",
    "num": "311",
    "desc": "Prerequisite: Junior standing or sophomore standing and consent of instructor.\nApplication of a systematic approach to interaction skills in a paraprofessional helping relationship. Includes background knowledge of listening skills and practice in emitting skills which influence interaction quality.",
    "credits": "3"
  },
  {
    "course_name": "Educational Psychology",
    "dept": "EDCEP",
    "num": "315",
    "desc": "Prerequisite: Admission to teacher education, and FSHS 110.\nThe application of psychological principles to the teaching-learning process with special emphasis on principles of learning, motivation, information processing, individual differences, and assessment.",
    "credits": "3"
  },
  {
    "course_name": "Peer Health Education and Leadership",
    "dept": "EDCEP",
    "num": "360",
    "desc": "Prerequisite: WellCAT Ambassadors Application and Informational Interview is required to enroll.\nThis course is intended as an academic exploration of social health and wellness concerns pertinent to the college student population. Using the principles of public health, peer educators will explore the importance of health-promoting behaviors in the prevention of disease. Students will examine social factors that may influence behaviors between their peers and obtain background knowledge in listening and communication skills.",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Counseling and Educational Psychology",
    "dept": "EDCEP",
    "num": "502",
    "desc": "Prerequisite: Consent of department chair.\nSelected topics in professional education.",
    "credits": "1-3"
  },
  {
    "course_name": "Interpersonal Relations in the Schools",
    "dept": "EDCEP",
    "num": "525",
    "desc": "Prerequisite: EDSEC 376, EDSP 323, EDCEP 315. Concurrent enrollment required for EDSEC 455, 477.\nA didactic and experiential course designed to develop an understanding of human relations skills in the schools. Provides knowledge and skills necessary to work effectively with students, parents, and school personnel. Particular emphasis is on the basis for interpersonal relations in education, communication skills, the facilitative relationship, working with students in groups, and conducting meetings with parents and school personnel.",
    "credits": "1"
  },
  {
    "course_name": "Middle School Classroom Guidance",
    "dept": "EDCEP",
    "num": "711",
    "desc": "Prerequisite: EDCEP 315.\nTechniques of integrating guidance principles for pre- and early teens into a middle school concept; investigation of classroom dynamics for middle school teachers as members of the guidance team; involvement of teachers in model guidance programs.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Assessment",
    "dept": "EDCEP",
    "num": "715",
    "desc": "Prerequisite: EDCEP 315.\nPrinciples of development, administration, evaluation, and constructive instructional use of paper-pencil, product, and performance assessments. Focus on norm-and criterion-referenced uses of teacher-made and published measures as an integral part of effective decision making in education.",
    "credits": "3"
  },
  {
    "course_name": "The Teacher and Child Abuse",
    "dept": "EDCEP",
    "num": "725",
    "desc": "Prerequisite: Junior standing.\nAn exploration of child abuse and neglect with specific references to legal and moral responsibilities of teaching. Suggestions for detection, reporting, and responsive instruction for suspected cases of child abuse and neglect.",
    "credits": "3"
  },
  {
    "course_name": "Drug Abuse Education",
    "dept": "EDCEP",
    "num": "737",
    "desc": "\nEmphasis on the development of effective drug abuse education programs with attention given to the role delineation for schools and teachers. Materials and procedures for developing values and attitudes in an education setting.",
    "credits": "3"
  },
  {
    "course_name": "College Student Athletes",
    "dept": "EDCEP",
    "num": "752",
    "desc": "\nStudy of college student athletes. Topics include the role of intercollegiate athletics, pressures and challenges on student athletes, student development theory, life skills programming, National Collegiate Athletic Association policy, diversity, and gender issues.",
    "credits": "3"
  },
  {
    "course_name": "Intercollegiate Athletics and the College Student Athlete",
    "dept": "EDCEP",
    "num": "761",
    "desc": "\nExamines policies and procedures of the NCAA, roles and responsibilities within a department of intercollegiate athletics. Topics include marketing, fundraising, external relations, sports information, coaching, academic support, among others.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Counseling and Educational Psychology",
    "dept": "EDCEP",
    "num": "775",
    "desc": "Prerequisite: FSHS 110.\nReadings in research and application in specialized areas in education.",
    "credits": "1-3"
  },
  {
    "course_name": "Topics in Counseling and Educational Psychology",
    "dept": "EDCEP",
    "num": "786",
    "desc": "Prerequisite: FSHS 110.\nExamination of current topic in specialization of faculty.",
    "credits": "1-3"
  },
  {
    "course_name": "Problems in Counseling and Educational Psychology",
    "dept": "EDCEP",
    "num": "795",
    "desc": "Prerequisite: Background of courses necessary for the problem undertaken and consent of instructor.\nSelected students are permitted to secure specialized training appropriate to the needs of the individual.  The student’s project may involve intensive library investigation in a special field or the collection and analysis of data pertinent to a given problem.  All work is done independently under the direction of a faculty member.  As many conferences are held as necessary to assure successful completion of a project.",
    "credits": "1-18"
  },
  {
    "course_name": "Teaching as a Career",
    "dept": "EDCI",
    "num": "200",
    "desc": "Prerequisite: Concurrent enrollment required in EDEL 230 and sophomore standing.\nExamines the roles, responsibilities, and dispositions of effective teachers; characteristics of the teaching/learning environment; the design of K-State’s teacher education program; ways teachers change during their careers; and self-assessment about the commitment to teaching and preferences to grade levels or subject areas. An overview of the teacher education program is provided, the unit’s conceptual framework is discussed, and the portfolio requirements are initiated. The skills of reflection and the dimensions of caring and ethical practice are introduced.",
    "credits": "1"
  },
  {
    "course_name": "Early Field Experience",
    "dept": "EDCI",
    "num": "230",
    "desc": "Prerequisite: Concurrent enrollment in EDEL 200 and sophomore standing.\nIncludes 40 hours of supervised field experiences examining selected aspects of teaching and the learning environment, including students and learning, content and pedagogy, planning, instruction, and professionalism. Requires written reports, analyses, and reflections for each weekly school visit.",
    "credits": "1"
  },
  {
    "course_name": "Principles of Coaching",
    "dept": "EDCI",
    "num": "300",
    "desc": "\nPhysiological, psychological, and kinesiological principles of coaching. Topics include training and conditioning, motivation, psychological factors affecting sport skill in performance, and mechanical principles underlying sport performance.",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Education",
    "dept": "EDCI",
    "num": "310",
    "desc": "\nExamines the historical, political, philosophical, and sociological foundations of education in the United States including the evolution of career and technical education and changing demographics; ethical and legal issues; governance and financial support; and contemporary curriculum issues. Includes critical thinking and reflective decision making about educational issues.",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Education: Global Perspective",
    "dept": "EDCI",
    "num": "311",
    "desc": "Prerequisite: EDCI 310 Foundations of Ed, OR Equivalent.\nExamines current issues in K-12 education from a global perspective. Introduction to the concept of global education and explore values, beliefs, behaviors, policies and customs from around the World.",
    "credits": "3"
  },
  {
    "course_name": "Educational Technology for Teaching and Learning",
    "dept": "EDCI",
    "num": "318",
    "desc": "Prerequisite: Admission to teacher education.\nIntroduces pre-service teachers to the use of contemporary instructional technologies to enhance instruction and to facilitate professional productivity. Attention is given to issues of access and diversity.",
    "credits": "1"
  },
  {
    "course_name": "Core Teaching Skills and Lab",
    "dept": "EDCI",
    "num": "320",
    "desc": "Prerequisite: Admission to teacher education. Concurrent enrollment in EDCI 318, EDCEP 315, and EDSP 324.\nExamines instructional planning, differentiating instruction, direct and indirect instructional strategies, strategies to promote student understanding, managing lesson delivery, classroom management, assessing student performance, and working with colleagues and parents.",
    "credits": "3"
  },
  {
    "course_name": "New Literacies in Contemporary Classrooms",
    "dept": "EDCI",
    "num": "400",
    "desc": "\nThis course introduces general concepts of new literacies (i.e., the skills, strategies and dispositions needed to adapt to constantly changing information and communication technologies) along with innovative approaches to literacy instruction. In particular, the course will focus on the use of digital tools and multimodal texts to support reading comprehension, written and oral communication, visual literacy, global competence, and creative thinking/ problem solving in K-6 classrooms.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Online Teaching and Learning",
    "dept": "EDCI",
    "num": "505",
    "desc": "Prerequisite: Admission to Teacher Education or valid K-12 teaching license.\nProvides an overview of the history, current status, and anticipated future directions of online teaching and learning (OTL). Examines the impact of OTL within K-12 contexts.",
    "credits": "3"
  },
  {
    "course_name": "Online Instructional Design and Development I",
    "dept": "EDCI",
    "num": "506",
    "desc": "Prerequisite: Admission to Teacher Education or valid K-12 teaching license; EDCI 505.\nThis course introduces participants to key instructional systems design approaches to design and prototype online lessons for diverse learners and contexts, and technology tools to develop and implement these lessons.",
    "credits": "3"
  },
  {
    "course_name": "Online Instructional Design and Development II",
    "dept": "EDCI",
    "num": "507",
    "desc": "Prerequisite: Admission to Teacher Education or valid K-12 teaching license; EDCI 505; EDCI 506.\nParticipants develop online teaching and learning modules employing a variety of technology tools.",
    "credits": "3"
  },
  {
    "course_name": "Online Teaching and Learning Practicum",
    "dept": "EDCI",
    "num": "508",
    "desc": "Prerequisite: Admission to Teacher Education or valid K-12 teaching license; EDCI 505; EDCI 506; EDCI 507.\nParticipants create a full-fledged, multi-module online course that is ready to implement in a real-life instructional setting related to their current or prospective work contexts.",
    "credits": "3"
  },
  {
    "course_name": "Schooling and Popular Culture",
    "dept": "EDCI",
    "num": "550",
    "desc": "\nAn examination of the symbiotic relationship of American public schools and American popular culture.  The course will consider how schools are reflected in the popular culture and how the representation of schooling in popular culture affects public opinion, public policy, and schools themselves.",
    "credits": "3"
  },
  {
    "course_name": "Internship in Educational Studies",
    "dept": "EDCI",
    "num": "580",
    "desc": "",
    "credits": "6-9"
  },
  {
    "course_name": "Supervised Practicum for Athletic Coaches",
    "dept": "EDCI",
    "num": "588",
    "desc": "Prerequisite: EDCI 300.\nObservation and coaching participation under the direction of selected coaches in public school, club, city recreation, or other nonpublic school sport settings.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Bilingual/ESL Education",
    "dept": "EDCI",
    "num": "700",
    "desc": "Prerequisite: Junior standing.\nThis course focuses on the history and foundations of bilingual education, as well as an in-depth examination of contemporary programming models and trends in bilingual education. The dynamics of bilingualism at the individual, system, and societal levels will also be an emphasis of study.",
    "credits": "3"
  },
  {
    "course_name": "Administration and Supervision of Vocational Education",
    "dept": "EDCI",
    "num": "701",
    "desc": "Prerequisite: Teaching experience.\nEmphasis on the duties and responsibilities of administrative and supervisory personnel responsible for the promotion, development, and coordination of comprehensive vocational-technical education programs at the local level.",
    "credits": "2-3"
  },
  {
    "course_name": "Curriculum, Instruction, and Assessment",
    "dept": "EDCI",
    "num": "702",
    "desc": "\nDevelops core concepts and skills necessary for effective teaching in elementary and secondary schools. The course examines curriculum, pedagogy, and assessment techniques.",
    "credits": "3"
  },
  {
    "course_name": "Math Methods and Practicum for Teaching and Learning",
    "dept": "EDCI",
    "num": "703",
    "desc": "\nPrinciples of teaching applied to mathematics instruction in the secondary and middle school including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Science Methods and Practicum for Teaching and Learning",
    "dept": "EDCI",
    "num": "704",
    "desc": "\nThis course addresses principles of teaching applied to science instruction in the secondary school. These principles include: motivation, organization of subject matter, lesson planning for direct, inquiry, and social/personal instructional emphases; assessment, meeting the needs of individual students; organization and management of the classroom; and methodology and materials of the secondary school science curriculum.",
    "credits": "3"
  },
  {
    "course_name": "MAT Social Studies Methods",
    "dept": "EDCI",
    "num": "705",
    "desc": "\nPrinciples of teaching applied to social studies instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "English, Speech/Theater, and Journalism Methods ad Practicum for Teaching and Learning",
    "dept": "EDCI",
    "num": "706",
    "desc": "\nPrinciples of teaching applied to language arts instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "FACS Methods and Practicum for Teaching and Learning",
    "dept": "EDCI",
    "num": "707",
    "desc": "\nThis course focuses on the principles of teaching applied to Family and Consumer Sciences instruction; organization of subject matter, unit and lesson planning, evaluation and assessment, classroom management, motivation, learning styles, methodology and materials related to teaching Family and Consumer Sciences in the middle school and secondary classroom.",
    "credits": "3"
  },
  {
    "course_name": "Business Methods and Practicum for Teaching and Learning",
    "dept": "EDCI",
    "num": "708",
    "desc": "\nPrinciples of teaching applied to business education instruction in the secondary and middle schools including:  motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Education Methods and Practicum for Teaching and Learning",
    "dept": "EDCI",
    "num": "709",
    "desc": "\nPrinciples of teaching applied to agriculture education instruction in the secondary and middle schools including:  motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Social Foundations of K-12 Education",
    "dept": "EDCI",
    "num": "710",
    "desc": "\nExamines the historical, political, philosophical, economic, legal, and sociological intersections of public education in the United States of America; emphasizes freedom, democracy, truth, power, and choice as core concepts of social change and social justice.",
    "credits": "3"
  },
  {
    "course_name": "Art Methods and Practicum for Teaching and Learning",
    "dept": "EDCI",
    "num": "711",
    "desc": "\nPrinciples of teaching applied to art instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools. Field-based experience to help the pre-professional teacher practice the incorporation of art with reading methods and demonstrate application of technology into teaching and assessment in the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "MAT Foreign Language Methods",
    "dept": "EDCI",
    "num": "712",
    "desc": "\nPrinciples of teaching applied to modern language instruction in the secondary and middle schools including:  motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Occupational Analysis",
    "dept": "EDCI",
    "num": "713",
    "desc": "Prerequisite: Prior or concurrent enrollment in EDSEC 620.\nAn introduction to various techniques used in analyzing occupations and jobs. Emphasis on developing and organizing related instructional materials and content.",
    "credits": "2-3"
  },
  {
    "course_name": "Reading and the Bilingual Child",
    "dept": "EDCI",
    "num": "714",
    "desc": "Prerequisite: Junior standing/target language proficiency.\nThe course will focus on appropriate instructional literacy and reading skill development among second language learners. A particular emphasis will be the development of literacy skills among students whose dominant language is other than English.",
    "credits": "3"
  },
  {
    "course_name": "Literacy and Diverse Learners in the Content Areas",
    "dept": "EDCI",
    "num": "715",
    "desc": "\nAn examination of contemporary literacy and diverse learners in the secondary school content areas in light of learning theory and adolescents’ stages of development.",
    "credits": "3"
  },
  {
    "course_name": "Teaching Diverse Learners",
    "dept": "EDCI",
    "num": "716",
    "desc": "\nExamines teaching in a culturally diverse society. Emphasizes historically underrepresented students, culturally and linguistically diverse learners, abilities, exceptionalities, gender, religion, socioeconomic status, sexual orientation and preference. Additionally, this course explores environments that are healthy, respectful, supportive, and challenging for all students.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Educational Technology",
    "dept": "EDCI",
    "num": "718",
    "desc": "\nThis course examines the roles that technology, teachers, and learners may take in any educational context: ways of integrating technology into teaching and learning; and issues involved in using technology in K-12 settings.",
    "credits": "3"
  },
  {
    "course_name": "ESL/Dual Language Methods",
    "dept": "EDCI",
    "num": "720",
    "desc": "Prerequisite: Junior standing.\nAn exploration of contemporary approaches, methods, and strategies for the appropriate instruction of second language learners. Also provided is a foundational perspective on ESL/Dual Language approaches, including the communicative, cognitive, and grammatical.",
    "credits": "3"
  },
  {
    "course_name": "Learning Strategies and Study Skills",
    "dept": "EDCI",
    "num": "721",
    "desc": "Prerequisite: Senior standing or greater.\nAn exploration of research-based strategies for empowering learners and connecting contemporary youth with the skills needed to develop mental stamina and engage in cross-disciplinary academic tasks.",
    "credits": "3"
  },
  {
    "course_name": "Computer Applications in Subject Areas",
    "dept": "EDCI",
    "num": "723",
    "desc": "Prerequisite: Junior standing.\nTheory and practice of using computer software to enhance teaching and learning in specific subject areas. Subjects covered will vary.",
    "credits": "1-3"
  },
  {
    "course_name": "Fundamentals of Teaching Music",
    "dept": "EDCI",
    "num": "724",
    "desc": "\nTechniques, materials, and experiences for a variety of music classes will be examined through discovery. Furthermore, lesson plan development, writing, and implementation will be examined in detail.",
    "credits": "1"
  },
  {
    "course_name": "Music Methods for Elementary Schools",
    "dept": "EDCI",
    "num": "725",
    "desc": "\nThe study of the musical characteristics of children and development of appropriate curriculum, instructional materials and techniques, and related technology for teaching musical understanding, literacy, multicultural connections, and creative improvisation in grades K-6 instrumental, vocal, and general music.",
    "credits": "1"
  },
  {
    "course_name": "Music Program in Middle and Secondary Schools",
    "dept": "EDCI",
    "num": "726",
    "desc": "\nOrganization and administration of the comprehensive music program in middle and secondary high schools; including the study of vocal and instrumental ensemble development, as well as techniques, materials and appropriate instructional technologies.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Methods in Music Education",
    "dept": "EDCI",
    "num": "727",
    "desc": "\nAdvanced instructional methods and technologies related to the teaching of music in grades preK-12 implemented through field experiences.",
    "credits": "1"
  },
  {
    "course_name": "Middle-Level Mathematics for Teachers",
    "dept": "EDCI",
    "num": "729",
    "desc": "\nThis course reviews math concepts, problems and applications to help prepare teachers to pass the Middle School Mathematics Praxis Exam. The course helps teachers gain pedagogical content knowledge in relation to teaching mathematics.",
    "credits": "3"
  },
  {
    "course_name": "Education of the Disadvantaged",
    "dept": "EDCI",
    "num": "730",
    "desc": "Prerequisite: Junior standing.\nConsideration of the life-space of the disadvantaged learner and its relationship to curriculum, organization, and interpersonal relationships in schools. The development of realistic, relevant goals for the teacher of the disadvantaged.",
    "credits": "3"
  },
  {
    "course_name": "ESL/Dual Language Linguistics",
    "dept": "EDCI",
    "num": "731",
    "desc": "Prerequisite: Junior standing.\nExplores the theoretical underpinnings of language acquisition and linguistics that educators need to understand, in order to better plan appropriately adapted curriculum and instruction for second language learners. The course encompasses problematic aspects of English language learning, the ways in which languages may differ, and certain universal aspects of languages.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Career Education",
    "dept": "EDCI",
    "num": "732",
    "desc": "\nRelated occupational or professional experiences in approved industry, school, Cooperative Extension Service, or similar agency setting under faculty supervision.",
    "credits": "1-6"
  },
  {
    "course_name": "Curriculum Materials for Ethnic Diversity",
    "dept": "EDCI",
    "num": "733",
    "desc": "Prerequisite: Junior standing.\nAn examination and analysis of recent materials and practices of schools serving multiethnic student bodies, particularly minorities from disadvantaged backgrounds. Materials include any items used by the school in implementing the curriculum.",
    "credits": "3"
  },
  {
    "course_name": "Gender Implications for Education",
    "dept": "EDCI",
    "num": "735",
    "desc": "\nImplications of the research based on sex-role stereotyping in educational institutions. Examination of resource materials, teaching strategies, and policies intended to facilitate non-sexist educational environments.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Business and Office Occupations",
    "dept": "EDCI",
    "num": "737",
    "desc": "Prerequisite: Consent of instructor.\nRelated occupational or professional experiences in approved industry, school, Cooperative Extension Service, or similar agency setting under faculty supervision.",
    "credits": "1-6"
  },
  {
    "course_name": "Coordination of Cooperative Vocational Education",
    "dept": "EDCI",
    "num": "739",
    "desc": "\nEmphasis on legal aspects and other minimum requirements essential to conducting cooperative vocational education programs at the secondary and postsecondary levels.",
    "credits": "2-3"
  },
  {
    "course_name": "Culture and Language in Classroom Practice",
    "dept": "EDCI",
    "num": "740",
    "desc": "Prerequisite: Junior standing.\nExamines ways teachers can address diversity in their classrooms with attention to issues such as critical reflection on practice; effective collaboration with families; diversification of the learning environment; use and adaptation of the grade-level curriculum; the differentiation of classroom instruction for cultural and linguistic diversity; and advocacy skill development.",
    "credits": "3"
  },
  {
    "course_name": "ESL/Dual Language Assessment",
    "dept": "EDCI",
    "num": "742",
    "desc": "Prerequisite: Junior standing.\nAn in-depth examination of key issues/challenges in the appropriate language assessment of culturally and linguistically diverse students. Among focal topics in theory, research and practice discussed will be: pre-and post-instructional assessment, authentic and alternative assessment, language testing and placement for programming in ESL/Dual language classrooms.",
    "credits": "3"
  },
  {
    "course_name": "ESL/Dual Language Elementary Practicum",
    "dept": "EDCI",
    "num": "745",
    "desc": "Prerequisite: EDCI 720, 731, 742, and 733 or 740.\nThe practicum is a portfolio-based experience providing the student with application experiences in ESL/Dual Language methods, assessment, and multicultural competence as well as the opportunity to demonstrate understanding of second language acquisition. Students will be required to spend 60 hours in a school setting where they can practice and implement ESL/BE lessons/methodology.",
    "credits": "3"
  },
  {
    "course_name": "ESL/Dual Language Secondary Practicum",
    "dept": "EDCI",
    "num": "746",
    "desc": "Prerequisite: EDCI 720, 731, 742, and 733 or 740.\nThe practicum is a portfolio-based experience providing the student with application experiences in ESL/Dual Language methods, assessment, and multicultural competence as well as the opportunity to demonstrate understanding of second language acquisition. Students will be required to spend 60 hours in a school setting where they can practice and implement ESL/BE lessons/methodology.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Education",
    "dept": "EDCI",
    "num": "749",
    "desc": "\nThe selection, adaptation, and development of environmental education K-12 curriculum materials: procedures for an integrated curricular implementation; the selection of appropriate instructional strategies. Background in environmental studies recommended.",
    "credits": "1-3"
  },
  {
    "course_name": "Multicultural Issues in Teaching",
    "dept": "EDCI",
    "num": "755",
    "desc": "Prerequisite: Senior standing.\nExamines the socio-cultural forces that influence the American educational system. Considers curriculum and instruction implications of human differences, and analyzes ways to promote equitable, quality education.",
    "credits": "3"
  },
  {
    "course_name": "Tradebooks across the Curriculum",
    "dept": "EDCI",
    "num": "756",
    "desc": "Prerequisite: EDEL 585, EDSEC 586, or EDSEC 582.\nThis course examines the use of children’s literature in the K-8 literacy classroom. It focuses on recently published books in several literary genres across curricular areas.",
    "credits": "3"
  },
  {
    "course_name": "Reading/Writing Connections",
    "dept": "EDCI",
    "num": "758",
    "desc": "Prerequisite: EDEL 585, EDSEC 586, or EDSEC 582.\nThis course examines teaching language arts in an integrated manner, exploring the relationships between reading and writing from a developmental perspective. Teaching methods for a holistic environment are highlighted.",
    "credits": "3"
  },
  {
    "course_name": "Action Research in Education",
    "dept": "EDCI",
    "num": "760",
    "desc": "\nThis course introduces the theoretical and practical dimensions of school-based action research about curriculum and instruction topics, and students conduct an action research project. Access to the research site is required.",
    "credits": "3"
  },
  {
    "course_name": "Methods for Second Language Acquisition/Learning",
    "dept": "EDCI",
    "num": "770",
    "desc": "Prerequisite: EDSEC 500 and 520.\nThe study of contemporary approaches, methods, and research-based best practices for world language instruction. Provides a venue to analyze and discuss programmatic and curricular decisions and how that impacts teaching and learning.",
    "credits": "3"
  },
  {
    "course_name": "Assessment in World Language Education",
    "dept": "EDCI",
    "num": "771",
    "desc": "Prerequisite: EDCI 770\nThe course will study how to create, implement, and analyze world language assessments to enhance instruction and support learning",
    "credits": "3"
  },
  {
    "course_name": "Current Trends and Research in World Language Education",
    "dept": "EDCI",
    "num": "772",
    "desc": "\nAnalyze current trends in world language education. Recent research will be stressed. Explore how this applies to curricular and instructional decisions.",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Technology in World Language Education",
    "dept": "EDCI",
    "num": "773",
    "desc": "\nThe course will study pedagogical implications of instructional technologies to enhance and support world language education. There will be a focus on the constant evolution of technology and how it can enhance the teaching and learning of world language education.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Curriculum and Instruction",
    "dept": "EDCI",
    "num": "775",
    "desc": "Prerequisite: Junior standing.\nReadings in research and application in specialized areas in education.",
    "credits": "1-3"
  },
  {
    "course_name": "Teaching in Middle Schools",
    "dept": "EDCI",
    "num": "776",
    "desc": "Prerequisite: EDCEP 315.\nSeveral instructional approaches consistent with the characteristics of the emerging adolescent student (grades 5-9) will be examined in relation to current research. Direct development of alternative curricular programs. Appropriate use of interdisciplinary activities and nontraditional materials will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Primary School Education",
    "dept": "EDCI",
    "num": "779",
    "desc": "Prerequisite: Senior standing.\nA course for those interested in the kindergarten and primary school child. Emphasis will be placed on curriculum development, pertinent research, and innovative practices in early education.",
    "credits": "3"
  },
  {
    "course_name": "Kindergarten Education",
    "dept": "EDCI",
    "num": "780",
    "desc": "Prerequisite: Senior standing.\nA specialized study of the kindergarten in the American school: methods and materials for working with the kindergarten child, including communication and explanation skills and readiness for reading.",
    "credits": "3"
  },
  {
    "course_name": "Teaching the Theoretical Foundations of Constitutional Government",
    "dept": "EDCI",
    "num": "781",
    "desc": "\nExamines the theories (e.g., natural rights, classical republicanism, and constitutionalism) and theorists (e.g., Aristotle, Locke, Hobbes, and Montesquieu) that most influenced constitutional thinking in the United States.  Explores how to teach effectively about these theories and theorists.",
    "credits": "1"
  },
  {
    "course_name": "Teaching the Historical Origins of Constitutional Government",
    "dept": "EDCI",
    "num": "782",
    "desc": "\nExamines seminal ideas, documents, and events in the creation of the United States Constitution such as problems with the Articles of Confederation, the characteristics of good government, the debates at the Philadelphia Convention, the Federalist Papers, and the Antifederalist Papers.  Explores how to teach effectively these ideas, document, and events.",
    "credits": "1"
  },
  {
    "course_name": "Teaching the Development of Constitutional Principals",
    "dept": "EDCI",
    "num": "783",
    "desc": "\nExamines the development of political ideas and constitutional thinking since the Founding.  Focuses on how the Bill of Rights, the amendment process, judicial review, and the Fourteenth Amendment are used to empower and limit government.  Explores how to teach effectively about developments in constitutional thought.",
    "credits": "1"
  },
  {
    "course_name": "Teaching the Institutions of Government",
    "dept": "EDCI",
    "num": "784",
    "desc": "\nExamines the powers, limits, and development of political institutions such as Congress, the President, the Supreme Court, and political parties.  Explores how to teach effectively about these institutions.",
    "credits": "1"
  },
  {
    "course_name": "Teaching the Bill of Rights",
    "dept": "EDCI",
    "num": "785",
    "desc": "\nExamines the rights protected by the United States Constitution and the ways that rights protected by the United States Constitution and the ways that rights empower citizens, limit government, and contribute to constitutional government.  Explores how to teach effectively about rights.",
    "credits": "1"
  },
  {
    "course_name": "Topics in Curriculum and Instruction",
    "dept": "EDCI",
    "num": "786",
    "desc": "Prerequisite: Junior standing.\nExamination of current topic in area of specialization of faculty.",
    "credits": "1-3"
  },
  {
    "course_name": "Teaching Citizenship",
    "dept": "EDCI",
    "num": "787",
    "desc": "\nExamines development of the rights, responsibilities, and challenges of citizenship in the United States.  Explores how to teach effectively about citizenship.",
    "credits": "1"
  },
  {
    "course_name": "Teaching the Constitutional Principles of America’s Founders",
    "dept": "EDCI",
    "num": "788",
    "desc": "\nDevelops constitutional principles; explores perspectives of constitutional interpretation, change, and preservation; raises questions about the immediate and enduring significance of America’s founding principles and documents; and introduces sound pedagogical practices to teach about them.",
    "credits": "3"
  },
  {
    "course_name": "Methods and Materials in Civic Education",
    "dept": "EDCI",
    "num": "789",
    "desc": "\nFocuses on the pedagogical aspects of civic education and engagement such as research-based approaches to concept attainment, skill development, discussion, and deliberation as well as analysis of curriculum materials and programs that apply these pedagogies.",
    "credits": "3"
  },
  {
    "course_name": "Engaged Citizens: Public Policy Issues and Processes",
    "dept": "EDCI",
    "num": "790",
    "desc": "\nExamines the teaching of the workings of constitutional government through the lens of the public policy making processes and the roles of individual voters, organized public, the media, and state and local governments in that process.",
    "credits": "3"
  },
  {
    "course_name": "Teaching Science and Mathematics in the Elementary School",
    "dept": "EDCI",
    "num": "791",
    "desc": "Prerequisite: Admission to MAT Program and corequisite: EDCI 800.\nDevelops knowledge, skills, and dispositions to effectively teach elementary science and mathematics. Introduces content, methods, and materials. Explores curriculum integration.",
    "credits": "4"
  },
  {
    "course_name": "Teaching Social Studies, Reading, and Literacy in the Elementary School",
    "dept": "EDCI",
    "num": "792",
    "desc": "Prerequisite: Admission to MAT Program.\nDevelops knowledge, skills, and dispositions to effectively teach elementary social studies, reading, and language arts. Introduces content, methods, and materials. Explores curriculum integration.",
    "credits": "4"
  },
  {
    "course_name": "Teaching Health, Movement, and Fine Arts in Elementary Schools",
    "dept": "EDCI",
    "num": "793",
    "desc": "Prerequisite: Admission to MAT Program.\nDevelops knowledge, skills, and dispositions to effectively teach health, movement, and fine arts. Introduces content, methods, and materials. Explores curriculum integration.",
    "credits": "4"
  },
  {
    "course_name": "Advanced Methods of Teaching",
    "dept": "EDCI",
    "num": "794",
    "desc": "\nExamines popular theories, important principles, research-based strategies, and best practices associated with effective teaching.  Provides a venue to apply theory to practice; connect ideas and action; and link content and pedagogy.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Curriculum and Instruction",
    "dept": "EDCI",
    "num": "795",
    "desc": "Prerequisite: Junior standing.\nIndependent study of a specific problem in curriculum or instruction.",
    "credits": "1-18"
  },
  {
    "course_name": "Brain-Based Literacy Instruction",
    "dept": "EDCI",
    "num": "796",
    "desc": "\nThis course provides advanced study of theory and research regarding literacy acquisition related to brain development and function. The intended audience includes K-12 regular classroom teachers, reading teachers, resource room teachers, teacher aides, and other professionals concerned with meeting the literacy needs of children and young adults. The following topics are covered in the course: Cognitive functions, memory systems, sensitive/critical periods for brain development related to literacy, implications for classroom environment and stress upon student performance, executive functions and research-based instructional strategies found to increase student performance.",
    "credits": "3"
  },
  {
    "course_name": "Secondary Content Field Colloquium I",
    "dept": "EDCI",
    "num": "797",
    "desc": "\nThis course is designed to explore key concepts within the secondary content field. Focus will be on advancing the development of disciplinary content knowledge and pedagogical content knowledge.",
    "credits": "2"
  },
  {
    "course_name": "Secondary Content Field Colloquium II",
    "dept": "EDCI",
    "num": "798",
    "desc": "\nThis course is designed to explore additional key concepts within the secondary content field.  Focus will be on advancing the development of disciplinary content knowledge and pedagogical content knowledge.",
    "credits": "2"
  },
  {
    "course_name": "Secondary Content Field Colloquium III",
    "dept": "EDCI",
    "num": "799",
    "desc": "\nClass explores the content knowledge of the candidate in regards to the middle and secondary content curriculum, identifies areas of strength and weakness in content knowledge, and provides enrichment and remediation to prepare the candidate for the internship experience.",
    "credits": "2"
  },
  {
    "course_name": "Health and Movement Education in Elementary Classrooms",
    "dept": "EDEL",
    "num": "250",
    "desc": "Prerequisite: Sophomore standing. Prior or concurrent enrollment in EDEL 200.\nAddresses major concepts of health education, human movement, and physical activities to enable elementary teachers to promote healthy lifestyles for all students in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Arts for Elementary Schools",
    "dept": "EDEL",
    "num": "270",
    "desc": "\nMethods, materials, and educational philosophy of the fine arts for elementary school teaching. Students will explore art and design media, techniques, and concepts including drama, movement, music, and visual arts. Emphasis will be placed on designing, implementing, and evaluating arts experiences.",
    "credits": "3"
  },
  {
    "course_name": "Middle-Level Education",
    "dept": "EDEL",
    "num": "405",
    "desc": "Prerequisite: Admission to teacher education.\nThis course provides an overview of the characteristics of middle schools; the social, psychological, and physical characteristics of early adolescent development; middle-level curriculum; ways to organize for instruction; and the teacher’s role in the guidance of students at the middle level.",
    "credits": "3"
  },
  {
    "course_name": "Block B Practicum: K-6",
    "dept": "EDEL",
    "num": "410",
    "desc": "Prerequisite: EDCI 318, EDCEP 315, EDSP 324, and EDEL 320.\nA field experience designed to give students opportunities in applying teaching methods in literacy and science in elementary grades. Includes using technologies to enhance instruction and facilitate professional productivity.",
    "credits": "2"
  },
  {
    "course_name": "Teaching Literacy: K-2",
    "dept": "EDEL",
    "num": "411",
    "desc": "Prerequisite: EDCI 318, EDCEP 315, EDSP 324, and EDEL 320. Concurrent enrollment in EDEL 410, 412, 413, and 414.\nThis course provides emergent literacy theory to foster language development, create optimal learning environments, assess and evaluate literacy learning, and provide differentiation and interventions for all learners. Comprehensive, evidence-based primary literacy programs include modeled, guided, and direct instruction; skill and strategy teaching; integration of reading/writing, listening/speaking, and viewing/visual representation. Includes using technologies to enhance instruction and facilitate professional productivity.",
    "credits": "3"
  },
  {
    "course_name": "Teaching Science: K-6",
    "dept": "EDEL",
    "num": "412",
    "desc": "Prerequisite: EDCI 318, EDCEP 315, EDSP 324, and EDEL 320. Concurrent enrollment in EDEL 410, 411, 413, and 414.\nAn introduction to the principles and methods of teaching science in elementary grades, including the nature of science, student learning, curriculum, instructional methods and activities, equity issues, and student assessment. Includes using technologies to enhance instruction and facilitate professional productivity.",
    "credits": "3"
  },
  {
    "course_name": "Classroom Assessment: K-6",
    "dept": "EDEL",
    "num": "413",
    "desc": "Prerequisite: EDCI 318, EDCEP 315, EDSP 324, and EDEL 320. Concurrent enrollment in EDEL 410, 411, 412, and 414.\nExamines the role of assessment in elementary classrooms in teaching; characteristics of high-quality assessments; diagnostic, formative, and summative assessments; preparation of classroom tests and test items; performance and portfolio assessments; affective traits; assessment of students with special needs and characteristics; grading and reporting; and standardized tests.",
    "credits": "1"
  },
  {
    "course_name": "Teaching Culturally and Linguistically Diverse Learners",
    "dept": "EDEL",
    "num": "414",
    "desc": "Prerequisite: EDCI 318, EDCEP 315, EDSP 324, and EDEL 320. Concurrent enrollment in EDEL 410, 411, 412, and 413.\nExamines multicultural education and the characteristics of diverse learners in the classroom, including culturally and linguistically diverse learners. Curricular and instructional implications of these differences are examined in an effort to differentiate instruction to meet the needs of all learners.",
    "credits": "3"
  },
  {
    "course_name": "Art Methods for Elementary Schools",
    "dept": "EDEL",
    "num": "450",
    "desc": "Prerequisite: Admission to Teacher Education, EDART Teaching field.\nPrinciples of teaching applied to art instruction in elementary schools including: motivation, child-development and mark making, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of elementary school art.",
    "credits": "3"
  },
  {
    "course_name": "Art Practicum for Elementary Schools",
    "dept": "EDEL",
    "num": "451",
    "desc": "Prerequisite: Admission to Teacher Education, EDART Teaching Field.\nField-based experience to help the pre-professional teacher practice the incorporation of art methods, strategies, and techniques in teaching and assessment in the elementary school.",
    "credits": "1"
  },
  {
    "course_name": "Block C Practicum: K-6",
    "dept": "EDEL",
    "num": "460",
    "desc": "Prerequisite: EDEL 410, 411, 412, 413, and 414. Concurrent enrollment in EDEL 461, 462, 463, and 464.\nA field experience designed to give students opportunities in applying teaching methods in literacy, social studies, and mathematics in elementary grades. Includes using technologies to enhance instruction and facilitate professional productivity.",
    "credits": "2"
  },
  {
    "course_name": "Teaching Literacy: Grades 3-6",
    "dept": "EDEL",
    "num": "461",
    "desc": "Prerequisite: EDEL 410, 411, 412, 413, and 414. Concurrent enrollment in EDEL 460, 462, 463, and 464.\nThis course extends literacy theory to the intermediate grades to focus on language development, create optimal learning environments, assess and evaluate literacy learning, and provide differentiation and interventions for all learners. Comprehensive, evidence-based intermediate literacy programs include modeled, guided, and direct instruction; skill and strategy teaching; content area literacy; integration of reading/writing, listening/speaking, and viewing/visual representation. Includes using technologies to enhance instruction and facilitate professional productivity.",
    "credits": "3"
  },
  {
    "course_name": "Teaching Social Studies: K-6",
    "dept": "EDEL",
    "num": "462",
    "desc": "Prerequisite: EDEL 410, 411, 412, 413, and 414. Concurrent enrollment in EDEL 460, 461, 463, and 464.\nMethods and resources for teaching social studies in elementary grades with the goal of helping students develop the ability to make informed and reasoned decisions for the public good as citizens of a culturally diverse, democratic society in an independent world. Includes using technologies to enhance instruction and facilitate professional productivity.",
    "credits": "3"
  },
  {
    "course_name": "Teaching Mathematics: K-6",
    "dept": "EDEL",
    "num": "463",
    "desc": "Prerequisite: EDEL 410, 411, 412, 413, and 414. Concurrent enrollment in EDEL 460, 461, 462, and 464.  Prior or concurrent enrollment in MATH 320.\nThe teaching of mathematics in elementary grades, including the nature of mathematical processes, curriculum, methods of instruction, instructional materials, and the evaluation of outcomes. Includes using technologies to enhance instruction and facilitate professional productivity.",
    "credits": "3"
  },
  {
    "course_name": "Classroom Management and Discipline: K-6",
    "dept": "EDEL",
    "num": "464",
    "desc": "Prerequisite: EDEL 410, 411, 412, 413, and 414. Concurrent enrollment in EDEL 460, 461, 462, and 463.\nExamines ways to establish and maintain a positive learning environment in elementary classrooms and specific strategies to address misbehavior. Emphasis is placed on creating an effective management system, establishing a positive learning environment, addressing individual and group motivation, and preparing to deal with misbehavior.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "EDEL",
    "num": "490",
    "desc": "Prerequisite: Requires consent of instructor.\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Independent Study in Elementary Education",
    "dept": "EDEL",
    "num": "502",
    "desc": "Prerequisite: Consent of department chair.\nSelected topics in professional education. Maximum of 3 hours applicable toward degree requirements.",
    "credits": "1-3"
  },
  {
    "course_name": "Physical Education/Health Methods for PK-6 Schools",
    "dept": "EDEL",
    "num": "520",
    "desc": "Prerequisite: Admission to Teacher Education and corequisite: EDSEC 376, EDEL 521.\nThis class includes both theoretical and practical guidelines for analysis and implementation of children’s physical education/health. The course focuses on applications of the Kansas standards for elementary educators PK-6 grades.",
    "credits": "3"
  },
  {
    "course_name": "Physical Education/Health Practicum for PK-6 Schools",
    "dept": "EDEL",
    "num": "521",
    "desc": "Corequisite: EDEL 520.\nThis course will provide an opportunity for students to plan, teach, and evaluate Physical Education/Health lessons within a placement at the PK-6 school level.",
    "credits": "1"
  },
  {
    "course_name": "Teaching Internship in Elementary Schools",
    "dept": "EDEL",
    "num": "585",
    "desc": "Prerequisite: Admission to Professional Semester.\nObservation and teaching participation under the direction of selected elementary teachers.",
    "credits": "1-15"
  },
  {
    "course_name": "Foreign Language Elementary School Methods",
    "dept": "EDEL",
    "num": "620",
    "desc": "Prerequisite or corequisite: EDCEP 315. Concurrent enrollment required for EDEL 621.\nMethods of teaching and organization for the foreign language program in the elementary school. A score of “2” or “Advanced” on the Oral Proficiency Interview (OPI) is required.",
    "credits": "3"
  },
  {
    "course_name": "Foreign Language Elementary School Practicum",
    "dept": "EDEL",
    "num": "621",
    "desc": "Prerequisite: Concurrent enrollment required for EDEL 620.\nA teaching experience to apply the methods of teaching and organization for the foreign language program in the elementary school.",
    "credits": "1"
  },
  {
    "course_name": "Applied Leadership Skills",
    "dept": "EDLEA",
    "num": "213",
    "desc": "\nThis course provides opportunities for all interested students to be introduced to leadership skills application, with emphasis on practice in supervised clinical settings.",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Educational Leadership",
    "dept": "EDLEA",
    "num": "502",
    "desc": "Prerequisite: Consent of department chair.\nSelected topics in professional education.",
    "credits": "1-3"
  },
  {
    "course_name": "Educational Change and Technology",
    "dept": "EDLEA",
    "num": "770",
    "desc": "Prerequisite: Teaching experience.\nThis course deals with educational change, teaming, and information literacy. Three thrusts are considered: the emerging technologies and educational change, shaping change with technology, and the use of technology/information literacy to transform teaching and learning.",
    "credits": "2"
  },
  {
    "course_name": "Readings in Educational Leadership",
    "dept": "EDLEA",
    "num": "775",
    "desc": "Prerequisite: Consent of department chair.\nReadings in research and application in specialized areas in education.",
    "credits": "1-3"
  },
  {
    "course_name": "Topics in Educational Leadership",
    "dept": "EDLEA",
    "num": "786",
    "desc": "Prerequisite: Consent of department chair.\nExamination of current topic in area of specialization of faculty.",
    "credits": "1-3"
  },
  {
    "course_name": "Problems in Educational Leadership",
    "dept": "EDLEA",
    "num": "795",
    "desc": "Prerequisite: Consent of instructor.\nSelected students are permitted to secure specialized training appropriate to the needs of the individual. The student’s project may involve intensive library investigation in a special field or the collection and analysis of data pertinent to a given problem. All work is done independently under the direction of a faculty member. As many conferences are held as necessary to assure successful completion of a project.",
    "credits": "1-18"
  },
  {
    "course_name": "Coaching and Officiating Basketball",
    "dept": "EDSEC",
    "num": "302",
    "desc": "\nStudy of rules, theory, and practices; methods of coaching.",
    "credits": "2"
  },
  {
    "course_name": "Coaching and Umpiring Baseball",
    "dept": "EDSEC",
    "num": "303",
    "desc": "\nStudy of rules, theory, and practices; methods of coaching.",
    "credits": "2"
  },
  {
    "course_name": "Coaching and Officiating Track and Field",
    "dept": "EDSEC",
    "num": "304",
    "desc": "\nStudy of rules, theory, and practices; methods of coaching.",
    "credits": "2"
  },
  {
    "course_name": "Coaching and Officiating Football",
    "dept": "EDSEC",
    "num": "305",
    "desc": "\nStudy of rules, theory, and practices; methods of coaching.",
    "credits": "2"
  },
  {
    "course_name": "Coaching and Officiating Volleyball",
    "dept": "EDSEC",
    "num": "306",
    "desc": "\nStudy of rules, theory, and practices; methods of coaching.",
    "credits": "2"
  },
  {
    "course_name": "Technology in the Business Classroom",
    "dept": "EDSEC",
    "num": "315",
    "desc": "\nDevelopment of competencies in the usage of integrated software packages as they apply to the automated business environment.",
    "credits": "3"
  },
  {
    "course_name": "Social Studies Colloquium I",
    "dept": "EDSEC",
    "num": "328",
    "desc": "\nApplication and integration of theories and practices of social studies education. Emphasis on rudimentary knowledge of content disciplines and how they can be incorporated in education.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Physical Education/Health",
    "dept": "EDSEC",
    "num": "360",
    "desc": "Corequisite: EDSEC 200.\nThis course includes identification of competency-based, goal-oriented activities appropriate to PK-12 physical education/health. Emphasis on foundations of physical education/health including: exercise science, sport, careers, and challenges for the future.",
    "credits": "3"
  },
  {
    "course_name": "Adaptive Physical Education",
    "dept": "EDSEC",
    "num": "380",
    "desc": "Prerequisite: EDSEC 360.\nEmphasizes the principles and practices involved in providing activities for individuals who have disabilities or temporary limitations and cannot participate in or benefit from the regular activity program. This course is designed to prepare physical education teachers to provide safe, appropriate, and individualized accommodations to children with disabilities who are included in general physical education programs.",
    "credits": "2"
  },
  {
    "course_name": "Middle-Level Education",
    "dept": "EDSEC",
    "num": "405",
    "desc": "Prerequisite: Admission to teacher education.\nThis course provides an overview of the characteristics of middle schools; the social, psychological, and physical characteristics of early adolescent development; middle-level curriculum; ways to organize for instruction; and the teacher’s role in the guidance of students at the middle level.",
    "credits": "2"
  },
  {
    "course_name": "World Wide Web-Based Searching/ Researching",
    "dept": "EDSEC",
    "num": "407",
    "desc": "Prerequisite: Introductory computer course.\nThe main topics of this course are formulating search strategies; critically evaluating information; using and evaluating major search engines, search tools, and other sources; and assessing the impact of the web on self and society, particularly with regard to how people learn and interact with others in this environment.",
    "credits": "3"
  },
  {
    "course_name": "Social Studies Colloquium II",
    "dept": "EDSEC",
    "num": "428",
    "desc": "Prerequisite: EDSEC 328.\nContinuation of application and integration of theories and practices of social studies education. Emphasis on rudimentary pedagogical strategies and how they can be incorporated in social studies education.",
    "credits": "1"
  },
  {
    "course_name": "Teaching in a Multicultural Society",
    "dept": "EDSEC",
    "num": "455",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376. Concurrent enrollment required for EDSEC 477, EDCEP 525 and subject area methods and corresponding practicum.\nApplication of multicultural understandings to teaching in a multicultural society. Strategies for working effectively with students to achieve educational equity.",
    "credits": "1"
  },
  {
    "course_name": "Office Systems and Procedures",
    "dept": "EDSEC",
    "num": "471",
    "desc": "\nDevelops competencies needed for careers in the business office, evaluates and utilizes automated office systems and procedures, and applies technical knowledge and decision-making skills.",
    "credits": "3"
  },
  {
    "course_name": "Content Area Literacies and Diverse Learners",
    "dept": "EDSEC",
    "num": "477",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376. Concurrent enrollment required for EDSEC 455, EDCEP 525 and subject area methods and corresponding practicum.\nDevelopment of content area literacies to include concern for culturally and linguistically diverse learners.",
    "credits": "2"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "EDSEC",
    "num": "490",
    "desc": "Prerequisite: Requires consent of instructor.\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Content Area Methods in the Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "500",
    "desc": "Prerequisite: EDCI 315, EDSP 323 and EDSEC 376.\nPrinciples of teaching applied to content area instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Secondary Education",
    "dept": "EDSEC",
    "num": "502",
    "desc": "Prerequisite: Consent of department chair.\nSelected topics in professional education.",
    "credits": "1-3"
  },
  {
    "course_name": "Career Pathways in Family and Consumer Sciences Education",
    "dept": "EDSEC",
    "num": "510",
    "desc": "Prerequisite: EDSEC 376 or Graduate standing.\nPrinciples and procedures in planning and organizing family and consumer sciences-related career pathways are explored. The course includes curriculum design elements and instructional methods unique to programs that emphasize technical skill proficiency, competency-based applied learning, and preparation for education and training beyond the secondary education classroom.",
    "credits": "2"
  },
  {
    "course_name": "Block II Lab: Content Area Methods and Field Experience",
    "dept": "EDSEC",
    "num": "520",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376. Concurrent enrollment required for EDSEC 455, 477, 500, and EDCEP 525.\nField-based experience to help the pre-professional teacher practice the incorporation of specific content area with reading methods and demonstrate application of technology into teaching and assessment in the secondary and middle schools.",
    "credits": "2"
  },
  {
    "course_name": "Social Studies Colloquium III",
    "dept": "EDSEC",
    "num": "528",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376. Concurrent enrollment required for EDSEC 455, EDSEC 544 and EDSEC 545, and EDCEP 525.\nApplication and integration of theories and practices of content disciplines into instruction. Emphasis on design and presentation of lessons through lenses of social studies disciplines.",
    "credits": "3"
  },
  {
    "course_name": "Art Methods for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "530",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376. Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 531, and EDCEP 525.\nPrinciples of teaching applied to art instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Art Methods Practicum",
    "dept": "EDSEC",
    "num": "531",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376. Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 530, and EDCEP 525.\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate art education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Business Methods for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "532",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 533, and EDCEP 525.\nPrinciples of teaching applied to business instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Business Methods Practicum",
    "dept": "EDSEC",
    "num": "533",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 532, and EDCEP 525.\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate business education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Family and Consumer Science Methods for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "534",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 535, and EDCEP 525.\nPrinciples of teaching applied to family and consumer sciences instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Family and Consumer Science Methods Practicum",
    "dept": "EDSEC",
    "num": "535",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 534, and EDCEP 525.\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate family and consumer science education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Language Arts Methods for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "536",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 537, and EDCEP 525.\nPrinciples of teaching applied to language arts instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Language Arts Methods Practicum",
    "dept": "EDSEC",
    "num": "537",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 536, and EDCEP 525.\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate language arts education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Mathematics Methods for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "538",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 539, and EDCEP 525.\nPrinciples of teaching applied to mathematics instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Mathematics Methods Practicum",
    "dept": "EDSEC",
    "num": "539",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 538, and EDCEP 525.\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate mathematics education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Modern Language Methods for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "540",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 541, and EDCEP 525.\nPrinciples of teaching applied to modern languages instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Modern Language Methods Practicum",
    "dept": "EDSEC",
    "num": "541",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 540, and EDCEP 525.\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate modern language education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Science Methods for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "542",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 543, and EDCEP 525.\nPrinciples of teaching applied to science instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Science Methods Practicum",
    "dept": "EDSEC",
    "num": "543",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 542, and EDCEP 525.\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate science education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Social Studies Methods for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "544",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 545, and EDCEP 525.\nPrinciples of teaching applied to social studies instruction in the secondary and middle schools including: motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools.",
    "credits": "3"
  },
  {
    "course_name": "Social Studies Methods Practicum",
    "dept": "EDSEC",
    "num": "545",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376.  Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 544, and EDCEP 525.\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate social studies education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Physical Education/Health Methods for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "546",
    "desc": "Prerequisite: EDSEC 376 and corequisite: EDSEC 477, EDSEC 547.\nThis course provides students opportunities to study, discuss, organize, and practice instructional methods designed specifically for secondary and middle school physical education/health programs. Emphasis will be placed on understanding of the objectives, characteristics, and activities available to satisfy student growth and development. The course addresses movement education, rhythm games of low organization, body manipulative, object manipulative, and specific sport skills.",
    "credits": "3"
  },
  {
    "course_name": "Physical Education/Health Practicum for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "547",
    "desc": "Prerequisite: EDCEP 315, EDSP 323, and EDSEC 376. Concurrent enrollment required for EDSEC 455, EDSEC 477, EDSEC 546, and EDCEP 525.\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate physical education/health education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Technology Education Methods for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "548",
    "desc": "\nThis course addressed the principles of teaching applied to technology education instruction in the secondary and middle schools including motivation, organization of subject matter, lesson/unit planning, assessment and reporting, organization and management of the classroom, and methodology and materials of the secondary and middle schools. This course will also address the technology education curriculum, instructional practices for individual learners and learning, and college and career readiness practices for students.",
    "credits": "3"
  },
  {
    "course_name": "Technology Education Practicum for Secondary and Middle Schools",
    "dept": "EDSEC",
    "num": "549",
    "desc": "\nThis field-based experience provides the opportunity for students to plan, teach, and evaluate technology education lessons within a placement at the middle or secondary level. This practicum also requires students to incorporate reading methods and apply instructional technology in their instruction.",
    "credits": "2"
  },
  {
    "course_name": "Art for Exceptional Children",
    "dept": "EDSEC",
    "num": "560",
    "desc": "Prerequisite: PSYCH 110.\nUse of art courses and activities to meet the needs of the mentally retarded, physically impaired, emotionally disturbed, or gifted child.",
    "credits": "3"
  },
  {
    "course_name": "Teaching Internship in Music",
    "dept": "EDSEC",
    "num": "582",
    "desc": "Prerequisite: Admission to Professional Semester.\nObservation and teaching under the direction of selected music teachers in elementary, middle level, and secondary school music programs.",
    "credits": "6-12"
  },
  {
    "course_name": "Teaching Internship in Secondary Schools",
    "dept": "EDSEC",
    "num": "586",
    "desc": "Prerequisite: Admission to Professional Semester.\nObservation and teaching participation under the direction of selected secondary teachers.",
    "credits": "1-12"
  },
  {
    "course_name": "Coordination Techniques",
    "dept": "EDSEC",
    "num": "611",
    "desc": "Prerequisite: EDSEC 620.\nAcquaints students with techniques in selecting, implementing, and coordinating occupational programs between the school and the business community.",
    "credits": "1"
  },
  {
    "course_name": "Job Analysis",
    "dept": "EDSEC",
    "num": "612",
    "desc": "Prerequisite: EDSEC 620.\nAcquaints students with techniques of analyzing jobs and tasks related to occupations.",
    "credits": "1"
  },
  {
    "course_name": "Laboratory Techniques in Teaching Science",
    "dept": "EDSEC",
    "num": "614",
    "desc": "Prerequisite: Concurrent enrollment recommended for EDSEC 542 and EDSEC 543.\nRationale for laboratory in secondary school science. The design and implementation of laboratory activities and demonstrations in a high school science program.",
    "credits": "3"
  },
  {
    "course_name": "Principles and Philosophy of Career and Technical Education",
    "dept": "EDSEC",
    "num": "620",
    "desc": "\nPrinciples of career and technical education in Kansas and other states and countries; principles and philosophy underlying such education, relation of career and technical education to school objectives and community, state, and national needs.",
    "credits": "2-3"
  },
  {
    "course_name": "Program Planning in Career and Technical Education",
    "dept": "EDSEC",
    "num": "621",
    "desc": "Prerequisite: EDSEC 620.\nThe program development and planning process; development of guides for teaching and evaluating reimbursable secondary programs.",
    "credits": "2-3"
  },
  {
    "course_name": "Exceptional Students in the Secondary School",
    "dept": "EDSP",
    "num": "323",
    "desc": "Prerequisite: Admission to teacher education and FSHS 110.\nDesigned for regular classroom teachers in meeting the needs of exceptional adolescents. Support strategies for teachers and exceptional students in the mainstream of education.",
    "credits": "2"
  },
  {
    "course_name": "Exceptional Child in the Regular Classroom",
    "dept": "EDSP",
    "num": "324",
    "desc": "Prerequisite: Admission to teacher education.\nDesigned for general education teachers in meeting the needs of exceptional children. Support strategies for teachers and exceptional children in the mainstream of education will be explored.",
    "credits": "3"
  },
  {
    "course_name": "Manual Communications I",
    "dept": "EDSP",
    "num": "415",
    "desc": "\nManual Communications I is a sign language course. Approximately 700 vocabulary words along with the manual alphabet and numbers are taught. Lessons also include information about the various signing systems used in the United States as well as information about Deaf Culture.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Human Exceptionality",
    "dept": "EDSP",
    "num": "500",
    "desc": "\nSurvey of history and legal aspects of service, etiologies, characteristics, and special needs of exceptional individuals.",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Special Education",
    "dept": "EDSP",
    "num": "502",
    "desc": "Prerequisite: Consent of department chair.\nSelected topics in professional education. Maximum of three hours applicable toward degree requirements.",
    "credits": "1-3"
  },
  {
    "course_name": "Introduction to Autism Spectrum Disorder",
    "dept": "EDSP",
    "num": "509",
    "desc": "\nDesigned to prepare teacher candidates with the ability to recognize and build upon the strengths and needs of students with autism spectrum disorders (ASD). Employ various instructional strategies and locate appropriate educational materials for students with ASD.",
    "credits": "3"
  },
  {
    "course_name": "Manual Communications",
    "dept": "EDSP",
    "num": "615",
    "desc": "Prerequisite: Manual Communications I or equivalent.\nThis course is a continuation in the instruction of American Sign Language. This will include approximately 400 additional signs. There will be further discussion about the grammar and syntax of American Sign Language. Research will be conducted in the use of various manual communication systems with special populations, including aphasic, developmentally disabled, and others.",
    "credits": "3"
  },
  {
    "course_name": "Autism Spectrum Disorder",
    "dept": "EDSP",
    "num": "709",
    "desc": "\nDesigned to prepare teacher candidates with the ability to recognize and build upon the strengths and needs of students with autism spectrum disorders (ASD). Employ various instructional strategies and locate appropriate educational materials for students with ASD.",
    "credits": "3"
  },
  {
    "course_name": "Education of Exceptional Individuals",
    "dept": "EDSP",
    "num": "710",
    "desc": "Prerequisite: EDCEP 315 and EDSP 323 or EDSP 324.\nA general study of special education, with emphasis on legislation, Individual Education Plans, cross-cultural assessment and intervention, and strategies for exceptional students at the preschool, elementary, and secondary levels.",
    "credits": "3"
  },
  {
    "course_name": "Characteristics of Exceptionalities",
    "dept": "EDSP",
    "num": "711",
    "desc": "\nProvide an overview of exceptionality as it pertains to students. The processes of IEP development, and characteristics of both high and low incidence populations will be examined. Each area of exceptionality will be reviewed in terms of etiology, diagnosis, prevalence, remediation, and educational strategies.",
    "credits": "3"
  },
  {
    "course_name": "Characteristics of Cognitive Disorders",
    "dept": "EDSP",
    "num": "723",
    "desc": "Prerequisite: EDSP 323 or 324, and EDCEP 315.\nEtiological, psychological, sociological, and educational aspects of cognitive disabilities.",
    "credits": "3"
  },
  {
    "course_name": "Characteristics of Emotional and Behavioral Disorders",
    "dept": "EDSP",
    "num": "728",
    "desc": "Prerequisite: EDCEP 315 and EDSP 323 or EDSP 324.\nStudy of conceptual models for understanding emotional and behavioral disorders of childhood and adolescents, and their implications for educators.",
    "credits": "3"
  },
  {
    "course_name": "Interventions: Emotional and Behavioral Disorders",
    "dept": "EDSP",
    "num": "742",
    "desc": "Prerequisite: EDSP 323 or 324, 710.\nEducational planning assessment, instructional methods, curricular modification, media and materials, teacher competencies, and model programs for students with emotional and behavioral disorders.",
    "credits": "3"
  },
  {
    "course_name": "Interventions: Academic Disabilities",
    "dept": "EDSP",
    "num": "743",
    "desc": "Prerequisite: EDCEP 323 or 324 and EDSP 710.\nEducational planning, instructional methods, and curricula modifications for students with academic learning disabilities.",
    "credits": "3"
  },
  {
    "course_name": "The Consulting Process in Special Education",
    "dept": "EDSP",
    "num": "745",
    "desc": "Prerequisite: EDSP 323 or 324 or 500, and EDSP 742 or 743.\nA course to prepare special education teachers with skills for consulting effectively with classroom teachers, related services personnel, administrators, and parents about curriculum and program alternatives for exceptional children. Emphasis is upon developing collaborative consultation processes through communication, cooperation, and coordination techniques.",
    "credits": "3"
  },
  {
    "course_name": "Characteristics and Needs of Individuals Who are Gifted",
    "dept": "EDSP",
    "num": "750",
    "desc": "Prerequisite: EDSP 323 or 324 or 500.\nAn overview of historical perspectives related to gifted child education, various facets of intellectual and creative functioning, national and state guidelines for planning and implementing gifted programs, modifying curriculum and classroom strategies to nurture gifted potential, current issues in gifted education.",
    "credits": "3"
  },
  {
    "course_name": "Guidance of the Exceptional Individual",
    "dept": "EDSP",
    "num": "755",
    "desc": "Prerequisite: EDSP 722 or 763.\nStrategies for teachers in working with the academic, vocational, personal, and social adjustment of the exceptional individual. The course will focus on the individual in preschool, elementary, secondary, postsecondary, and adult settings.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Special Education",
    "dept": "EDSP",
    "num": "775",
    "desc": "Prerequisite: FSHS 110.\nReadings in research and application in specialized areas in education.",
    "credits": "1-3"
  },
  {
    "course_name": "Behavior Management",
    "dept": "EDSP",
    "num": "777",
    "desc": "\nTheoretical and practical applications of behavior analysis in schools with emphasis on preventing and remediating behavior problems of students with disabilities.",
    "credits": "3"
  },
  {
    "course_name": "Technology for Special Education",
    "dept": "EDSP",
    "num": "778",
    "desc": "Prerequisite: EDCI 318 Educational Technology for Teaching and Learning or related professional experiences.\nDesigned to help special educators develop an awareness of assistive technology (AT) and related legislative guidelines, which can assist in the lives and learning of students receiving special education. This course will explore assistive technology devices and services and software appropriate for students with special needs. Internet resource and AT evaluation systems related to special education will also be covered.",
    "credits": "3"
  },
  {
    "course_name": "Practicum I",
    "dept": "EDSP",
    "num": "785",
    "desc": "Prerequisite: EDSP 323 or 324, 710, 742, and 743.\nObservation and participation in teaching individuals with exceptional educational needs under the supervision of selected teachers in special education.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Education",
    "dept": "EDSP",
    "num": "786",
    "desc": "Prerequisite: EDCEP 315.\nExamination of current topic in specialization of faculty.",
    "credits": "1-3"
  },
  {
    "course_name": "Field Experiences in Special Education",
    "dept": "EDSP",
    "num": "787",
    "desc": "\nObservation and supervised activities in schools, camps, clinics, or institutions related to student’s area of special interest or preparation.",
    "credits": "1-3"
  },
  {
    "course_name": "Problems in Special Education",
    "dept": "EDSP",
    "num": "795",
    "desc": "Prerequisite: Background of courses necessary for the problem undertaken and consent of instructor.\nSelected students are permitted to secure specialized training appropriate to the needs of the individual. The student’s project may involve intensive library investigation in a special field or the collection and analysis of data pertinent to a given problem. All work is done independently under the direction of a faculty member. As many conferences are held as necessary to assure successful completion of a project necessary for the problem undertaken and consent of instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Developmental English",
    "dept": "ENGL",
    "num": "080",
    "desc": "\nBasics of standard edited (written) English with emphasis on grammar, usage, and sentence structure. This course does not fulfill requirements for the associate degree.",
    "credits": "3"
  },
  {
    "course_name": "Expository Writing I",
    "dept": "ENGL",
    "num": "100",
    "desc": "\nIntroduction to expressive and informative writing. Frequent discussions, workshops, and conferences. Offers extensive practice in the process of writing: getting ideas, drafting, analyzing drafts, revising, and editing.",
    "credits": "3"
  },
  {
    "course_name": "Writing Laboratory",
    "dept": "ENGL",
    "num": "170",
    "desc": "\nLaboratory practice in writing for all students.",
    "credits": "1-4"
  },
  {
    "course_name": "Expository Writing II",
    "dept": "ENGL",
    "num": "200",
    "desc": "Prerequisite: ENGL 100 and sophomore standing.\nIntroduction to writing persuasively. As with ENGL 100, uses discussion, workshops, and conferences, and emphasizes the writing process.",
    "credits": "3"
  },
  {
    "course_name": "Honors English",
    "dept": "ENGL",
    "num": "210",
    "desc": "\nCritical reading and writing for students enrolled in the Honors Program.  Each individual section will concentrate on themes determined by the instructor.",
    "credits": "3"
  },
  {
    "course_name": "Fiction into Film",
    "dept": "ENGL",
    "num": "220",
    "desc": "\nCritical analysis of literary texts and their film adaptations.",
    "credits": "3"
  },
  {
    "course_name": "Television as Literature",
    "dept": "ENGL",
    "num": "224",
    "desc": "\nCritical analysis of television as a literary form.",
    "credits": "3"
  },
  {
    "course_name": "Classical Cultures",
    "dept": "ENGL",
    "num": "230",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Medieval and Renaissance",
    "dept": "ENGL",
    "num": "231",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Reformation to Enlightenment",
    "dept": "ENGL",
    "num": "233",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Modern",
    "dept": "ENGL",
    "num": "234",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Literature",
    "dept": "ENGL",
    "num": "251",
    "desc": "\nStudy of fiction, poetry, drama, and nonfiction.",
    "credits": "3"
  },
  {
    "course_name": "Short Story",
    "dept": "ENGL",
    "num": "253",
    "desc": "\nStudy of short stories from world literature with emphasis on American, British, and Continental.",
    "credits": "3"
  },
  {
    "course_name": "British Literature",
    "dept": "ENGL",
    "num": "260",
    "desc": "\nSelected writers from various periods of British literary history.",
    "credits": "3"
  },
  {
    "course_name": "American Literature",
    "dept": "ENGL",
    "num": "270",
    "desc": "\nSelected writers from various periods in American literary history.",
    "credits": "3"
  },
  {
    "course_name": "Studies in World Literature and Culture",
    "dept": "ENGL",
    "num": "280",
    "desc": "\nInvestigation of a particular theme or genre in World literature or culture.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to American Ethnic Literatures",
    "dept": "ENGL",
    "num": "285",
    "desc": "\nStudy of ethnic and multicultural literatures of the United States, such as African American, Asian American, Latina/o, Jewish, and Native American.  May offer cross-cultural comparisons of different ethnic traditions or may focus on a single ethnic tradition.",
    "credits": "3"
  },
  {
    "course_name": "Great Books",
    "dept": "ENGL",
    "num": "287",
    "desc": "\nIntroduction to world classics from past to present.",
    "credits": "3"
  },
  {
    "course_name": "Selected Studies in English",
    "dept": "ENGL",
    "num": "295",
    "desc": "\nSelected studies in literature, language, rhetoric, and cultural studies.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Introduction to the Humanities I",
    "dept": "ENGL",
    "num": "297",
    "desc": "Prerequisite: Consent of instructor.\nStudy of selected major works of history, literature, and philosophy of central importance in the Western cultural tradition. Emphasis on classroom discussion and writing interpretive essays.",
    "credits": "3"
  },
  {
    "course_name": "Honors Introduction to the Humanities II",
    "dept": "ENGL",
    "num": "298",
    "desc": "Prerequisite: ENGL 297 or consent of instructor.\nContinuation of ENGL 297.",
    "credits": "3"
  },
  {
    "course_name": "Honors Topics in English",
    "dept": "ENGL",
    "num": "299",
    "desc": "Prerequisite: Open only to arts and sciences honors program students and to others completing ENGL 100 or 200 and 110 or 125 with a 3.5 GPA.\nReadings and colloquia in selected topics in literature or language.",
    "credits": "3"
  },
  {
    "course_name": "Expository Writing III",
    "dept": "ENGL",
    "num": "300",
    "desc": "Prerequisite: ENGL 200 or 210.\nAdvanced practice in writing a variety of expository forms: personal essays and informative and persuasive reports. Additional work on style and the demands of various rhetorical situations.",
    "credits": "3"
  },
  {
    "course_name": "Technical Writing",
    "dept": "ENGL",
    "num": "302",
    "desc": "Prerequisite: ENGL 100 and sophomore standing.\nThis writing course will provide students from a number of business, technology and aviation disciplines with intensive practice writing the kinds of documents that are common in their future professional lives.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Classical Literature in Translation",
    "dept": "ENGL",
    "num": "309",
    "desc": "\nIntroduction to canonical works of Greek and Roman Literature in translation. Discussion of classical texts with attention to material culture, visual media, and classical culture.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Literary Studies",
    "dept": "ENGL",
    "num": "310",
    "desc": "\nElements of literary form and style: an introduction to criticism for English majors. Intended as a first course in the analysis of form and technique, an introduction to literary terms commonly used in later courses, and practice in critical writing. Readings from a broad range: poems, plays, essays, and novels.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Cultural Studies",
    "dept": "ENGL",
    "num": "315",
    "desc": "\nThis course introduces the theories and methods of cultural studies through practical application to particular topics in culture and/or literature. An introductory class that addresses such issues as gender and sexuality, power relations among social groups, the construction, communication, and preservation of knowledge. The course typically features theoretical cultural studies material and a variety of media, including traditional and nontraditional literature, film, comics, television, the Internet, and other popular culture platforms.",
    "credits": "3"
  },
  {
    "course_name": "Television",
    "dept": "ENGL",
    "num": "324",
    "desc": "\nStudy of television as a genre from historical beginnings to contemporary moment. Emphasis on form and critical analysis.",
    "credits": "3"
  },
  {
    "course_name": "Literature and Technology",
    "dept": "ENGL",
    "num": "325",
    "desc": "Prerequisite: ENGL 100.\nStudents will read in a variety of literary, civic, and professional genres about technology and its effect on society; through writing, understand technology in terms of humanistic themes.",
    "credits": "3"
  },
  {
    "course_name": "Fiction",
    "dept": "ENGL",
    "num": "330",
    "desc": "\nStudy of fiction as genre from historical and contemporary contexts and cultures. Emphasis on form and critical analysis.",
    "credits": "3"
  },
  {
    "course_name": "Film",
    "dept": "ENGL",
    "num": "335",
    "desc": "\nStudy of film as genre from historical beginnings through classic Hollywood to contemporary cinema. Emphasis on form and critical analysis.",
    "credits": "3"
  },
  {
    "course_name": "Poetry",
    "dept": "ENGL",
    "num": "340",
    "desc": "\nStudy of poetry as genre from historical and contemporary contexts and cultures. Emphasis on form and critical analysis.",
    "credits": "3"
  },
  {
    "course_name": "Drama",
    "dept": "ENGL",
    "num": "345",
    "desc": "\nStudy of drama as genre from historical and contemporary contexts and cultures. Emphasis on form and critical analysis.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Shakespeare",
    "dept": "ENGL",
    "num": "350",
    "desc": "\nStudy of representative comedies, histories, and tragedies.",
    "credits": "3"
  },
  {
    "course_name": "Literature for Children",
    "dept": "ENGL",
    "num": "355",
    "desc": "Prerequisite: Sophomore standing.\nSurvey emphasizing the reading and evaluating of books for children. Required for licensure in elementary education.",
    "credits": "3"
  },
  {
    "course_name": "British Survey I",
    "dept": "ENGL",
    "num": "361",
    "desc": "\nBritish literature from Anglo-Saxon times to 1700.",
    "credits": "3"
  },
  {
    "course_name": "British Survey II",
    "dept": "ENGL",
    "num": "362",
    "desc": "\nBritish literature from 1700 to the present.",
    "credits": "3"
  },
  {
    "course_name": "American Survey I",
    "dept": "ENGL",
    "num": "381",
    "desc": "\nAmerican literature from pre-colonial times to the Civil War.",
    "credits": "3"
  },
  {
    "course_name": "American Survey II",
    "dept": "ENGL",
    "num": "382",
    "desc": "\nAmerican literature from the Civil War to the present.",
    "credits": "3"
  },
  {
    "course_name": "Multicultural Children’s Literature",
    "dept": "ENGL",
    "num": "384",
    "desc": "\nTheories of differences and underrepresented experiences as related to, for example, ability, gender, ethnicity, and sexuality, through children’s literature.",
    "credits": "3"
  },
  {
    "course_name": "Selected American Ethnic Literatures",
    "dept": "ENGL",
    "num": "385",
    "desc": "\nComparative study of ethnic and multicultural literatures of the United States, such as African American, Asian American, Latina/o, Jewish, and Native American. May focus on a single ethnic tradition outside of the four federally recognized minority groups.",
    "credits": "3"
  },
  {
    "course_name": "African American Literatures",
    "dept": "ENGL",
    "num": "386",
    "desc": "\nStudy of African American literatures.",
    "credits": "3"
  },
  {
    "course_name": "American Indian Literatures",
    "dept": "ENGL",
    "num": "387",
    "desc": "\nStudy of American Indian literatures.",
    "credits": "3"
  },
  {
    "course_name": "Asian American Literatures",
    "dept": "ENGL",
    "num": "388",
    "desc": "\nStudy of Asian American literatures.",
    "credits": "3"
  },
  {
    "course_name": "Latina/o Literatures",
    "dept": "ENGL",
    "num": "389",
    "desc": "\nStudy of Latina/o literatures.",
    "credits": "3"
  },
  {
    "course_name": "Fable and Fantasy",
    "dept": "ENGL",
    "num": "390",
    "desc": "\nStudy of modern works in the fabulous or fantastic modes in relation to the traditions underlying them.",
    "credits": "3"
  },
  {
    "course_name": "Topics in English",
    "dept": "ENGL",
    "num": "395",
    "desc": "\nSelected studies in literature and language.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Seminar in English",
    "dept": "ENGL",
    "num": "399",
    "desc": "Prerequisite: Honors students only.\nReadings and colloquia in selected masterpieces.",
    "credits": "1-3"
  },
  {
    "course_name": "Advanced Expository Writing for Prospective Teachers",
    "dept": "ENGL",
    "num": "400",
    "desc": "Prerequisite: ENGL 200 or 210.\nExpository writing and a brief introduction to the history and theory of teaching writing, primarily for candidates for Secondary licensure in English.",
    "credits": "3"
  },
  {
    "course_name": "Written Communication for Engineers",
    "dept": "ENGL",
    "num": "415",
    "desc": "Prerequisite: Enrollment in the College of Engineering with junior or senior standing and ENGL 100 or equivalent with A or B credit or ENGL 200.\nStudy and intensive use of writing forms characteristic of professional practice.",
    "credits": "3"
  },
  {
    "course_name": "Written Communication for the Workplace",
    "dept": "ENGL",
    "num": "417",
    "desc": "Prerequisite: Junior standing and ENGL 200 or 210.\nTheory and intensive writing practice for students entering the workplace.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Film",
    "dept": "ENGL",
    "num": "420",
    "desc": "Prerequisite: ENGL 200 or 210.\nSelected studies in film analysis.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Television",
    "dept": "ENGL",
    "num": "424",
    "desc": "Prerequisite: ENGL 200 or ENGL 210.\nSelected studies in television analysis.",
    "credits": "3"
  },
  {
    "course_name": "The Structure of English",
    "dept": "ENGL",
    "num": "430",
    "desc": "\nSystematic study of the structure of the English language utilizing linguistic approaches to the analysis of sounds, lexicon, grammatical structure, and social variation.",
    "credits": "3"
  },
  {
    "course_name": "Linguistics for Teachers of English",
    "dept": "ENGL",
    "num": "435",
    "desc": "Prerequisite: ENGL 200 or 210.\nPedagogical aspects of the structure, history, and use of the English language.",
    "credits": "3"
  },
  {
    "course_name": "Themes in Literature",
    "dept": "ENGL",
    "num": "440",
    "desc": "Prerequisite: ENGL 200 or 210.\nExplores the literary treatment of important and recurring themes.",
    "credits": "3"
  },
  {
    "course_name": "Literary Kinds",
    "dept": "ENGL",
    "num": "445",
    "desc": "Prerequisite: ENGL 200 or 210.\nExamines the characteristics, the growth and development, or the uses of specified literary genres.",
    "credits": "3"
  },
  {
    "course_name": "Literature and Society",
    "dept": "ENGL",
    "num": "450",
    "desc": "Prerequisite: ENGL 200 or 210.\nLiterature in relation to social and cultural patterns and influences.",
    "credits": "3"
  },
  {
    "course_name": "Exploring Creativity",
    "dept": "ENGL",
    "num": "455",
    "desc": "Prerequisite: ENGL 200 or ENGL 210 or ENGL 415.\nA study of creative thinking.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Fiction Writing",
    "dept": "ENGL",
    "num": "461",
    "desc": "Prerequisite: ENGL 200 or 210.\nA practical introduction to short fiction writing.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Poetry Writing",
    "dept": "ENGL",
    "num": "463",
    "desc": "Prerequisite: ENGL 200 or 210.\nA practical introduction to poetry writing.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Creative Nonfiction",
    "dept": "ENGL",
    "num": "465",
    "desc": "Prerequisite: ENGL 200 or 210.\nA practical introduction to creative nonfiction or what can be called ”the literature of fact.” Writers of creative nonfiction use many of the stylistic and literary tools that fiction writers and poets use, but in the service of rendering factual, literally accurate prose.",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Creative Writing",
    "dept": "ENGL",
    "num": "469",
    "desc": "Prerequisite: ENGL 200 or 210.\nTopics vary.",
    "credits": "3"
  },
  {
    "course_name": "The Bible",
    "dept": "ENGL",
    "num": "470",
    "desc": "Prerequisite: ENGL 200 or 210.\nLiterature, history, and cultural backgrounds of the Hebrew Bible (Old Testament) and/or the New Testament and early Christianity.",
    "credits": "3"
  },
  {
    "course_name": "American English",
    "dept": "ENGL",
    "num": "476",
    "desc": "\nSystematic study of the English language as it has been and is spoken in the continental United States. Topics include regional, social, and ethnic variation, language ideologies, intersections of language and power, and analysis of language variation.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Rhetoric and Literacy",
    "dept": "ENGL",
    "num": "485",
    "desc": "Prerequisite: ENGL 200 or 210.\nContent may emphasize visual rhetoric and literacy, literacy theory, and persuasion, and how such topics are understood in particular contexts and cultures.",
    "credits": "3"
  },
  {
    "course_name": "Development of the English Language",
    "dept": "ENGL",
    "num": "490",
    "desc": "Prerequisite: ENGL 200 or 210.\nDepicts the English language in its place among other world languages, and introduces students to the major ways in which English has changed through time. Considers both internal and external influences as causes of language change.",
    "credits": "3"
  },
  {
    "course_name": "Humanities Seminar",
    "dept": "ENGL",
    "num": "492",
    "desc": "Prerequisite: Appropriate introductory humanities course (or an equivalent background, such as courses in Western civilization, art, or world literature) with consent of instructor.\nStudy in depth of selected major figures and movements in Western arts, ideas, and literature.",
    "credits": "3"
  },
  {
    "course_name": "English Internship",
    "dept": "ENGL",
    "num": "495",
    "desc": "\nChoice between research and service learning internships. A research internship works with English professor on semester-long research project. A service learning intern works with a community organization or other external office to develop written and other materials on behalf of that entity.",
    "credits": "1-3"
  },
  {
    "course_name": "Special Investigations in English",
    "dept": "ENGL",
    "num": "497",
    "desc": "Prerequisite: Background of preparation needed for investigation undertaken.\nIndividual investigation in authors, genres, periods of literature or language.",
    "credits": "1-18"
  },
  {
    "course_name": "Honors Tutorial in English",
    "dept": "ENGL",
    "num": "498",
    "desc": "Prerequisite: Consent of tutorial instructor.\nIndividually guided study in which the student will formulate and explore a narrowly defined topic in literature or language.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "ENGL",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Writing Center Theory and Practice",
    "dept": "ENGL",
    "num": "500",
    "desc": "Prerequisite: ENGL 200 or equivalent.\nReadings in the field of writing center studies, with attention to topics such as ESL, literacy, and multiculturalism. Literacy studied as it intersects with race, gender, class, ethnicity, and social and institutional structures. Application of theory through a research project and peer tutoring apprenticeship.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Classical Literature in Translation",
    "dept": "ENGL",
    "num": "501",
    "desc": "\nA detailed study of Greek and/or Roman literature in translation in a small discussion setting. Either an open survey of classical literature or the consideration of a specific question.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Professional Writing",
    "dept": "ENGL",
    "num": "510",
    "desc": "Prerequisite: ENGL 200 or 210.\nIntensive practice in applying rhetorical principles to a number of genres common in non-academic professions and workplaces; an introduction to allied topics such as document design and editing.",
    "credits": "3"
  },
  {
    "course_name": "Written Communication for the Sciences",
    "dept": "ENGL",
    "num": "516",
    "desc": "Prerequisite: Junior standing and ENGL 200 or 210. Will not substitute for ENGL 415.\nTheory and intensive writing practice for students in the basic and applied sciences.",
    "credits": "3"
  },
  {
    "course_name": "Women in Literature",
    "dept": "ENGL",
    "num": "525",
    "desc": "\nStudy of literary works by or about women. Emphasis on historical and cultural contexts.",
    "credits": "3"
  },
  {
    "course_name": "Literature for Adolescents",
    "dept": "ENGL",
    "num": "545",
    "desc": "Prerequisite: ENGL 200 or 210.\nSelecting, reading, and evaluating books for adolescents.",
    "credits": "3"
  },
  {
    "course_name": "Law, Politics, and Literature",
    "dept": "ENGL",
    "num": "570",
    "desc": "Prerequisite: ENGL 200 or junior standing or POLSC 301 or junior standing.\nClassic and contemporary works of literature, including novels, plays, short stories, and poems, are used to explore themes in law and politics.",
    "credits": "3"
  },
  {
    "course_name": "Holocaust Literature",
    "dept": "ENGL",
    "num": "575",
    "desc": "\nExamines texts that represent and react to the experience of Jews during the Holocaust. Emphasis on historical and cultural contexts.",
    "credits": "3"
  },
  {
    "course_name": "Selected World Literature",
    "dept": "ENGL",
    "num": "580",
    "desc": "\nAddresses writing by authors whose native origins lie outside Europe or the United States. Content may vary with instructor. May examine literature from several countries or regions, concentrate on literature from one country or region, or focus on a topic which transcends national or regional boundaries. Works are written in or translated into English.",
    "credits": "3"
  },
  {
    "course_name": "Literary Studies Abroad",
    "dept": "ENGL",
    "num": "595",
    "desc": "\nTravel abroad, with selected readings, lectures, and discussions which explore the relationships between literary texts and their physical and cultural environments.",
    "credits": "3"
  },
  {
    "course_name": "Special Research in English",
    "dept": "ENGL",
    "num": "599",
    "desc": "\nIndividual investigation in authors, genres, periods of literature, or language. Background of preparation needed for investigation undertaken.",
    "credits": "1-18"
  },
  {
    "course_name": "General Phonetics",
    "dept": "ENGL",
    "num": "601",
    "desc": "\nDescription and classification of speech sounds according to point and manner of articulation. Transcription in the International Phonetic Association Alphabet. Includes sounds of English, French, Spanish, German, and others.",
    "credits": "3"
  },
  {
    "course_name": "Historical Linguistics",
    "dept": "ENGL",
    "num": "602",
    "desc": "\nInternal and comparative reconstruction of earlier forms of languages. Genetic relationships in language families, and various typological considerations. Includes French, Spanish, and others.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Linguistics",
    "dept": "ENGL",
    "num": "603",
    "desc": "\nSeminar on a special-topic in linguistics: decipherment of ancient writing systems, linguistics applied to the teaching of English or other languages, discourse analysis (especially of spoken texts), etc. Topic to be announced for semester in which offered.",
    "credits": "1-3"
  },
  {
    "course_name": "Expository Writing Workshop",
    "dept": "ENGL",
    "num": "604",
    "desc": "Prerequisite: Junior standing.\nCourse emphasizes stylistic analysis of modern non-fiction prose in the sciences, social sciences, and humanities. Extensive writing required.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Medieval Literature",
    "dept": "ENGL",
    "num": "605",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Renaissance Literature",
    "dept": "ENGL",
    "num": "610",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Seventeenth-Century British Literature",
    "dept": "ENGL",
    "num": "620",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Eighteenth-Century British Literature",
    "dept": "ENGL",
    "num": "625",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Nineteenth-Century British Literature",
    "dept": "ENGL",
    "num": "630",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Twentieth- and Twenty-First-Century British Literature",
    "dept": "ENGL",
    "num": "635",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Early American Literature",
    "dept": "ENGL",
    "num": "640",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Nineteenth-Century American Literature",
    "dept": "ENGL",
    "num": "645",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Twentieth- and Twenty-First-Century American Literature",
    "dept": "ENGL",
    "num": "650",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Readings in American Ethnic Literature",
    "dept": "ENGL",
    "num": "655",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Major Authors",
    "dept": "ENGL",
    "num": "660",
    "desc": "\nThis course is one within a sequence of period studies covering the chronological range of English and American literature. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the periods.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Creative Writing: Prose Fiction",
    "dept": "ENGL",
    "num": "661",
    "desc": "Prerequisite: ENGL 461 or instructor permission.\nAdvanced writing of prose fiction.",
    "credits": "3"
  },
  {
    "course_name": "Playwriting",
    "dept": "ENGL",
    "num": "662",
    "desc": "\nTheoretical study and practical application of techniques of playwriting with regard to plot, characters, and production; emphasis on the one-act form.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Creative Writing: Poetry",
    "dept": "ENGL",
    "num": "663",
    "desc": "Prerequisite: ENGL 463 or instructor permission.\nAdvanced writing of poetry.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Creative Writing: Nonfiction",
    "dept": "ENGL",
    "num": "665",
    "desc": "Prerequisite: ENGL 465 or instructor permission.\nAdvanced writing of prose creative nonfiction.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Creative Writing: Special Topics",
    "dept": "ENGL",
    "num": "669",
    "desc": "Prerequisite: Instructor consent.\nAdvanced topics vary.",
    "credits": "3"
  },
  {
    "course_name": "Topics in British Literature",
    "dept": "ENGL",
    "num": "670",
    "desc": "\nThis course addresses topics not confined to a single period in a national literature. Specific course content will vary by semester and instructor. It may emphasize cross-national subjects, literary criticism, the development of a theme or genre over time, new perspectives from social, intellectual, or cultural studies, or non-traditional texts and topics.",
    "credits": "3"
  },
  {
    "course_name": "Topics in American Literature",
    "dept": "ENGL",
    "num": "680",
    "desc": "\nThis course addresses topics not confined to a single period in a national literature. Specific course content will vary by semester and instructor. It may emphasize cross-national subjects, literary criticism, the development of a theme or genre over time, new perspectives from social, intellectual, or cultural studies, or non-traditional texts and topics.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Literature for the Young",
    "dept": "ENGL",
    "num": "690",
    "desc": "\nThis course addresses topics not confined to a single period in a national literature. Specific course content will vary by semester and instructor. It may emphasize cross-national subjects, literary criticism, the development of a theme or genre over time, new perspectives from social, intellectual, or cultural studies, or non-traditional texts and topics.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Literature",
    "dept": "ENGL",
    "num": "695",
    "desc": "\nThis course addresses topics not confined to a single period in a national literature. Specific course content will vary by semester and instructor. It may emphasize cross-national subjects, literary criticism, the development of a theme or genre over time, new perspectives from social, intellectual, or cultural studies, or non-traditional texts and topics.",
    "credits": "3"
  },
  {
    "course_name": "Capstone Seminar",
    "dept": "ENGL",
    "num": "698",
    "desc": "Prerequisite: Twenty-one (21) credit hours in English beyond ENGL 310.\nA writing- and discussion-intensive course that provides a culminating experience to the English major.",
    "credits": "3"
  },
  {
    "course_name": "Old English",
    "dept": "ENGL",
    "num": "700",
    "desc": "Prerequisite: Instructor permission.\nThe elements of Old English grammar, with readings in prose and poetry.",
    "credits": "3"
  },
  {
    "course_name": "Critical Approaches to Children’s Literature",
    "dept": "ENGL",
    "num": "703",
    "desc": "\nIntroduction to advanced study of children’s and young adult literature.",
    "credits": "3"
  },
  {
    "course_name": "Theories of Cultural Studies",
    "dept": "ENGL",
    "num": "705",
    "desc": "Prerequisite: Junior standing.\nAn overview of theoretical approaches to the study of culture and their current application in English studies.",
    "credits": "3"
  },
  {
    "course_name": "Studies in a Literary Genre",
    "dept": "ENGL",
    "num": "710",
    "desc": "\nThe specific contents will vary by semester and instructor, but the studies courses will reflect concerns with literary and rhetorical forms and genres; with specific authors, periods, or literary movements; with perspectives from social, intellectual, and cultural studies; with literary themes; or with language or linguistics.",
    "credits": "3"
  },
  {
    "course_name": "Studies in a Major Author",
    "dept": "ENGL",
    "num": "720",
    "desc": "\nThe specific contents will vary by semester and instructor, but the studies courses will reflect concerns with literary and rhetorical forms and genres; with specific authors, periods, or literary movements; with perspectives from social, intellectual, and cultural studies; with literary themes; or with language or linguistics.",
    "credits": "3"
  },
  {
    "course_name": "Studies in Children’s/Young Adult Literature",
    "dept": "ENGL",
    "num": "725",
    "desc": "\nAddresses topics not confined to a single period in a national literature. May emphasize cross-national subjects, literary criticism, the development of a theme or genre over time, new perspectives from social, intellectual, or cultural studies, or non-traditional texts and topics.",
    "credits": "3"
  },
  {
    "course_name": "Studies in a Literary Period",
    "dept": "ENGL",
    "num": "730",
    "desc": "\nThe specific contents will vary by semester and instructor, but the studies courses will reflect concerns with literary and rhetorical forms and genres; with specific authors, periods, or literary movements; with perspectives from social, intellectual, and cultural studies; with literary themes; or with language or linguistics.",
    "credits": "3"
  },
  {
    "course_name": "Studies in Literary Theory",
    "dept": "ENGL",
    "num": "740",
    "desc": "\nThe specific contents will vary by semester and instructor, but the studies courses will reflect concerns with literary and rhetorical forms and genres; with specific authors, periods, or literary movements; with perspectives from social, intellectual, and cultural studies; with literary themes; or with language or linguistics.",
    "credits": "3"
  },
  {
    "course_name": "Cultural Studies",
    "dept": "ENGL",
    "num": "745",
    "desc": "\nA topic course in Cultural Studies that applies a theoretical approach or approaches.",
    "credits": "3"
  },
  {
    "course_name": "Theories of Composition and Rhetoric",
    "dept": "ENGL",
    "num": "753",
    "desc": "\nAn introduction to major theories of composition and/or rhetoric.",
    "credits": "3"
  },
  {
    "course_name": "Studies in Composition and Rhetoric",
    "dept": "ENGL",
    "num": "755",
    "desc": "\nThe specific contents will vary by semester and instructor, but the studies courses will reflect concerns with literary and rhetorical forms and genres; with specific authors, periods, or literary movements; with perspectives from social, intellectual, and cultural studies; with literary themes; or with language or linguistics.",
    "credits": "3"
  },
  {
    "course_name": "Business Communication",
    "dept": "ENGL",
    "num": "756",
    "desc": "Prerequisite: ENGL 200 or 210 or 415 or 417 or 516 or graduate standing.\nA writing-intensive course intended for advanced undergraduate students, graduate students, and working professionals in business.",
    "credits": "3"
  },
  {
    "course_name": "Studies in Language and Linguistics",
    "dept": "ENGL",
    "num": "757",
    "desc": "\nThe specific contents will vary by semester and instructor, but the studies courses will reflect concerns with literary and rhetorical forms and genres; with specific authors, periods, or literary movements; with perspectives from social, intellectual, and cultural studies; with literary themes; or with language or linguistics.",
    "credits": "3"
  },
  {
    "course_name": "Scientific Communication",
    "dept": "ENGL",
    "num": "758",
    "desc": "Prerequisite: ENGL 200 or 210 or 415 or 417 or 516 or graduate standing.\nA writing-intensive course intended for advanced undergraduate students, graduate students, and working professionals in science.",
    "credits": "3"
  },
  {
    "course_name": "Studies in Technical Communication",
    "dept": "ENGL",
    "num": "759",
    "desc": "\nThe specific contents will vary by semester and instructor, but the studies courses will reflect concerns with literary and rhetorical forms and genres; with specific authors, periods, or literary movements; with perspectives from social, intellectual, and cultural studies; with literary themes; or with language or linguistics.",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing Workshop: Short Fiction",
    "dept": "ENGL",
    "num": "761",
    "desc": "Prerequisite: ENGL 661 or instructor permission.\nAdvanced writing of short prose fiction.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Playwriting",
    "dept": "ENGL",
    "num": "762",
    "desc": "Prerequisite: ENGL 662.\nFurther study in the writing of drama; emphasis on problems of writing the full-length play.",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing Workshop: Poetry",
    "dept": "ENGL",
    "num": "763",
    "desc": "Prerequisite: ENGL 663 or instructor permission.\nAdvanced writing of poetry.",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing Workshop: Creative Nonfiction",
    "dept": "ENGL",
    "num": "765",
    "desc": "Prerequisite: ENGL 665 or instructor permission.\nAdvanced writing of creative nonfiction.",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing Workshop/Special Topic",
    "dept": "ENGL",
    "num": "769",
    "desc": "Prerequisite: Instructor permission.\nSpecial topics vary.",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing Workshop: Novel/Novella",
    "dept": "ENGL",
    "num": "771",
    "desc": "Prerequisite: ENGL 661 or instructor permission.",
    "credits": "3"
  },
  {
    "course_name": "History of the English Language",
    "dept": "ENGL",
    "num": "790",
    "desc": "Prerequisite: Graduate standing or instructor permission.\nThe development of British and American English from Indo-European origins to the present.",
    "credits": "3"
  },
  {
    "course_name": "Literary Theory",
    "dept": "ENGL",
    "num": "795",
    "desc": "Prerequisite: Junior standing.\nA historical survey of literary theory and criticism.",
    "credits": "3"
  },
  {
    "course_name": "Professional Writing Internship",
    "dept": "ENGL",
    "num": "797",
    "desc": "Prerequisite: ENGL 510 or ENGL 665 or ENGL 759 or ENGL 765.\nFaculty-supervised professional experience, emphasizing application of writing skills in professional contexts. Student projects must be approved by on-site supervisor and faculty supervisor. Report must be submitted at the end of the semester.",
    "credits": "1-18"
  },
  {
    "course_name": "Problems in English",
    "dept": "ENGL",
    "num": "799",
    "desc": "Prerequisite: Background of courses needed for problem undertaken.\nIndependent study in major authors, genres, and periods of English and American literature and language.",
    "credits": "1-18"
  },
  {
    "course_name": "Economic Entomology",
    "dept": "ENTOM",
    "num": "300",
    "desc": "\nClassification, biology, ecology, and principles of management of economically important insects.",
    "credits": "3"
  },
  {
    "course_name": "Insects and People",
    "dept": "ENTOM",
    "num": "301",
    "desc": "\nIntended for undergraduate non-majors as part of the university general education curriculum. The focus will be on the global impact of insects and their relatives on human concerns, from acting as disease vectors, agricultural pests, and pollinators to their roles in art, history, and religion.",
    "credits": "3"
  },
  {
    "course_name": "Art and Insects",
    "dept": "ENTOM",
    "num": "302",
    "desc": "\nScience and art are not different ends of an academic continuum, but rather simultaneously found in all disciplines within academia. The goal of this course is to provide a framework and appreciation that students can utilize to consider all aspects of novel experiences and problems, as global problems require global thinking. The model system for this course will be insects, where students will learn about evolution, genetics, behavior, and biodiversity, while also learning art history, interpretation, analysis of color and shape, perception, and the role of insect representations in the humanities. While there are specific lectures that cover Insects and Art separately, the majority of lectures combine both science and art.",
    "credits": "3"
  },
  {
    "course_name": "Animal Health Entomology",
    "dept": "ENTOM",
    "num": "305",
    "desc": "\nIntroduction to biology of arthropods that affect animal health. The main focus is on strategies to manage arthropods that negatively affect the health and productivity of animals, including beef and dairy cattle, swine, poultry, horses, sheep, goats, pets, and urban wildlife. This course is particularly recommended for students interested in animal science, pre-veterinary medicine, and other agricultural curricula.",
    "credits": "2"
  },
  {
    "course_name": "Animal Health Entomology Laboratory",
    "dept": "ENTOM",
    "num": "306",
    "desc": "\nThis laboratory course complements ENTOM 305 and offers hands-on experience in identification and management of arthropods of veterinary importance. Includes field trips to food animal operations.",
    "credits": "1"
  },
  {
    "course_name": "General Entomology",
    "dept": "ENTOM",
    "num": "312",
    "desc": "\nA basic study of insects and related arthropods, their structure, physiology, behavior, and relations to plants and animals, including man.",
    "credits": "3"
  },
  {
    "course_name": "Horticultural Entomology",
    "dept": "ENTOM",
    "num": "320",
    "desc": "\nBiological principles and management considerations for insects and related arthropods affecting horticulture. Practical application of classification and life history information for accurate recognition, monitoring, and pest management decisions. Control tactics and conservation of beneficial species.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "ENTOM",
    "num": "499",
    "desc": "Prerequisite: Consent of instructor.\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Turfgrass Insects and Their Management",
    "dept": "ENTOM",
    "num": "589",
    "desc": "Prerequisite: HORT 582 or concurrent enrollment and HORT 515 or concurrent enrollment.\nBiology, diagnosis and integrated management of turfgrass insect pests.",
    "credits": "1"
  },
  {
    "course_name": "Insect Pest Diagnosis",
    "dept": "ENTOM",
    "num": "612",
    "desc": "\nDiagnosis of plant damage by insects and mites, recognition of harmful insects and mites and beneficial insects. Emphasis on field crop pests but pests of other crops will be considered if there is sufficient interest.",
    "credits": "2"
  },
  {
    "course_name": "Insecticides: Properties and Laws",
    "dept": "ENTOM",
    "num": "620",
    "desc": "\nIntroduction to insecticides as arthropod control agents, including their classification, formulation, properties, mode of action, metabolism, resistance, benefits and environmental impact, and federal and state laws that regulate the development, sale, use and storage of insecticides.",
    "credits": "2"
  },
  {
    "course_name": "Integrative Behavioral Ecology",
    "dept": "ENTOM",
    "num": "625",
    "desc": "\nThis course is designed to provide an overview of the genetics, ecology, and evolution of insect behavior, emphasizing research done in insect systems. The topics covered in this course will include: (1) Conceptual and empirical framework for studying behavior, (2) the genetics of behavior, (3) “kinds” of behaviors, and (4) detailed examples of each “kind” of behavior.",
    "credits": "3"
  },
  {
    "course_name": "Insect Evolution",
    "dept": "ENTOM",
    "num": "635",
    "desc": "\nThis course covers the evolution and biodiversity of insects. Topics covered include  insects in the fossil record, insect phylogenies, the traits responsible for insect diversity, and the evolution of  traits like wings, color, mimicry, learning, behavior, farming, parasitic lifestyles and social living.",
    "credits": "3"
  },
  {
    "course_name": "Plant Resistance to Insects",
    "dept": "ENTOM",
    "num": "655",
    "desc": "Recommended Prerequisite: ENTOM/PLPTH 732.\nPlant resistance in crop plants including transgenic plants. Insect behavior, physiology, and ecology as affected by resistance. Discussion of methods of assessing and quantifying plant resistance.",
    "credits": "2"
  },
  {
    "course_name": "Insect Ecology",
    "dept": "ENTOM",
    "num": "692",
    "desc": "\nAbiotic and biotic factors underlying the distribution, abundance, and dynamics of insects. How to measure these factors, how they affect insect population processes, interactions, and community structure, especially in agricultural systems. Emphasis on basic concepts and their application, experimental methods and field techniques.",
    "credits": "3"
  },
  {
    "course_name": "Insect Taxonomy",
    "dept": "ENTOM",
    "num": "710",
    "desc": "\nLaboratory study of insect Order and family-group identification. Proper preparation and maintenance of adult insect collections. Lecture stresses the principles of systematics, legal principles of nomenclature, and the phylogeny of insects and their near relatives.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Plant Resistance to Pests",
    "dept": "ENTOM",
    "num": "732",
    "desc": "Prerequisite: ENTOM 300 or PLPTH 500 or ENTOM 312, and one course in plant or animal genetics.\nBasic concepts of the biology, ecology, genetics and breeding for pest resistance in plants.",
    "credits": "2"
  },
  {
    "course_name": "Entomology Seminar",
    "dept": "ENTOM",
    "num": "795",
    "desc": "Prerequisite: Consult seminar committee.",
    "credits": "1"
  },
  {
    "course_name": "Problems in Entomology",
    "dept": "ENTOM",
    "num": "799",
    "desc": "Prerequisite: Consent of instructor.\nFor nonthesis or nondissertation studies. Work in various fields of entomology.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to Entrepreneurship",
    "dept": "ENTRP",
    "num": "340",
    "desc": "\nThe foundation course in the program, this course examines the entrepreneurial process. We will focus on business start-up but will also address organizational entrepreneurship or “intrapreneurship.” We will address the process of creativity and innovation and its impact on the success of business start-up. Specific topics covered include new venture planning, marketing, financing, and management. This course will serve as a  strong foundation for those aspiring to own and operate their own businesses as well as a real-world heads-up course for students who acknowledge that their future in businesses could very well benefit from examining projects in an entrepreneurial way.",
    "credits": "3"
  },
  {
    "course_name": "Technology and Innovation Management",
    "dept": "ENTRP",
    "num": "350",
    "desc": "Prerequisite: ENTRP 340 or junior standing.\nThis course aims to equip students with an understanding of the main issues in the management of innovation and an appreciation of the relevant skills needed to manage innovation at both strategic and operational levels. The course focuses on four themes: (1) the source, discovery, and evaluation of innovation and opportunities; (2) the provisions of innovation (products and services) that satisfy the needs of customers; (3) the development of mechanisms to appropriate the returns fro the exploitation of the innovation; and (4) the organization of efforts to innovate.",
    "credits": "3"
  },
  {
    "course_name": "Entrepreneurship",
    "dept": "ENTRP",
    "num": "440",
    "desc": "Prerequisite: FINAN 450, MANGT 420, MKTG 400. Instructor may waive prerequisites based on appropriate business experience.\nThe role of the entrepreneur is examined in the conception, start-up, organization, and development of new independent businesses.  New venture problems to be studied include identification of possible new products and services, evaluation of practical commercial potential, and development of a business plan, with attention to financing, operating, and marketing.",
    "credits": "3"
  },
  {
    "course_name": "Digital Business",
    "dept": "ENTRP",
    "num": "466",
    "desc": "Prerequisite: MANGT 366 or Permission of Instructor.\nAn in-depth study of how social media, mobile technologies and digital business tools have enabled new businesses development and existing business transformation. Five major, interrelated components: social computing, social media, content sharing, filtering, and Web applications will be explored within the context of business application and development.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Entrepreneurship",
    "dept": "ENTRP",
    "num": "497",
    "desc": "\nDiscussion and analysis of current issues in entrepreneurship, including topics related to new theory and the practice of entrepreneurship.",
    "credits": "1-3"
  },
  {
    "course_name": "Social Entrepreneurship",
    "dept": "ENTRP",
    "num": "520",
    "desc": "Prerequisite: ENTRP 340 or Junior standing.\nSocial entrepreneurship is one of the fastest growing disciplines to emerge in management and is increasingly getting recognition as an important policy strategy at the national level. It is concerned with how to engage the talents and tools of professional entrepreneurship to address critical social needs both within and beyond the market. Social entrepreneurship is situated within a framework of social institutions, organizations, and entrepreneurial change in response to human and citizen rights and needs. The relevant social institutions include government, the market, education, philanthropy, and the family. Organizations may be for profit or non-profit, but all organizations, regardless of their legal structure, are seen to have a social purpose. Several non-market venues for sustainable social change will be examined in addition to the traditional delivery of goods and services through the market. The course provides a number of crucial tools and resources that may better orient and equip the prospective social entrepreneur to identify and act on opportunities.",
    "credits": "3"
  },
  {
    "course_name": "Entrepreneurial Consulting",
    "dept": "ENTRP",
    "num": "540",
    "desc": "Prerequisite: ENTRP 340 or Junior standing.\nThis course is designed to provide students and faculty in the Entrepreneurship program the opportunity to give business assistance to small firms in the University community.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to University Honors Program",
    "dept": "ENVD",
    "num": "189",
    "desc": "\nDirections and goals for the honors program.",
    "credits": "1"
  },
  {
    "course_name": "Student Success Seminar",
    "dept": "ENVD",
    "num": "200",
    "desc": "\nProvides students with strategies for creating success in college and life. Topics to be covered include accepting personal responsibility, motivation, academic self-management, self-awareness, and life balance.",
    "credits": "1"
  },
  {
    "course_name": "Environmental Design Studio I",
    "dept": "ENVD",
    "num": "201",
    "desc": "Prerequisite: Admission to the College of Architecture and Design or permission of the dean.\nFoundation studies introducing principles, processes, and vocabularies of environmental design. Instruction in two and three dimensional visualization of objects and spaces. Instruction in the use of instrument-aided drawing, freehand drawing, and model building to represent and communicate design ideas at different scales of observation.",
    "credits": "4"
  },
  {
    "course_name": "Environmental Design Studio II",
    "dept": "ENVD",
    "num": "202",
    "desc": "Prerequisite: Admission to the  College of Architecture and Design or permission of the dean.\nFoundation studies introducing principles, processes, and vocabularies of environmental design. Instruction in two and three dimensional visualization of objects and spaces. Instruction in the use of instrument-aided drawing, freehand drawing, and model building to represent and communicate design ideas at different scales of observation.",
    "credits": "4"
  },
  {
    "course_name": "Survey of the Design Professions",
    "dept": "ENVD",
    "num": "203",
    "desc": "\nOverview of the design professions. Comparative study of the working methods, and societal and occupational roles of the architect, interior architect, landscape architect, and planner.",
    "credits": "1"
  },
  {
    "course_name": "Studio Seminar",
    "dept": "ENVD",
    "num": "204",
    "desc": "Prerequisite: Enrollment in ENVD 201.\nSeminar for students enrolled in ENVD 201. Topics related to studio and student success will be covered.",
    "credits": "1"
  },
  {
    "course_name": "Indian Art, Architecture and Culture",
    "dept": "ENVD",
    "num": "210",
    "desc": "\nThis course is designed to assist students in understanding India and its cultural, artistic, and architectural heritage so that students can develop a deeper understanding and appreciation for Indian culture, people and their way of life.",
    "credits": "3"
  },
  {
    "course_name": "Design Drawing",
    "dept": "ENVD",
    "num": "240",
    "desc": "\nThis course offers an introduction to and sustained freehand drawing practice in fundamental drawing systems, methods and media for the environmental design professions.",
    "credits": "2"
  },
  {
    "course_name": "History of the Designed Environment I",
    "dept": "ENVD",
    "num": "250",
    "desc": "\nThe history of the designed environment from ancient times to the 12th century.",
    "credits": "3"
  },
  {
    "course_name": "History of the Designed Environment II",
    "dept": "ENVD",
    "num": "251",
    "desc": "Prerequisite: ENVD 250 or permission of instructor.\nThe history of the designed environment from the 12th century to the mid-18th century.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Basic Design",
    "dept": "ENVD",
    "num": "299",
    "desc": "Prerequisite: Approval of associate dean.\nA study of specified problems in elementary environmental design under the guidance of a member of the staff.",
    "credits": "1-18"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "ENVD",
    "num": "400",
    "desc": "\nMentored undergraduate research in architecture, interior architecture and product design, landscape architecture or planning.",
    "credits": "0-3"
  },
  {
    "course_name": "K-State APDesign: APDPro",
    "dept": "ENVD",
    "num": "430",
    "desc": "",
    "credits": "0"
  },
  {
    "course_name": "Italian Art, History and Culture",
    "dept": "ENVD",
    "num": "650",
    "desc": "\nThe course provides a synthesis of art, history, design and culture in the context of the Italian Peninsula and the Mediterranean region over time.  Integration of material covered in lectures with field trips in Italy is expected.",
    "credits": "3"
  },
  {
    "course_name": "Study Abroad Orientation",
    "dept": "ENVD",
    "num": "654",
    "desc": "\nPreparation for participation in study abroad with a focus on specific information pertaining to the design professions and the analysis of the built and natural environment.",
    "credits": "1"
  },
  {
    "course_name": "International Field Study",
    "dept": "ENVD",
    "num": "655",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Problems in Environmental Design",
    "dept": "ENVD",
    "num": "699",
    "desc": "Prerequisite: Junior standing; approval of Associate Dean.\nA study of specific environmental design problems under the direction of a member(s) of the departmental staff.",
    "credits": "0-18"
  },
  {
    "course_name": "Introduction to Environmental Engineering",
    "dept": "ENVE",
    "num": "101",
    "desc": "\nIntroduction to discipline, department, university, and profession. Exploration of career options. Gain skills through application-oriented problem solving.",
    "credits": "1"
  },
  {
    "course_name": "Professional Practice for Environmental Engineering Design",
    "dept": "ENVE",
    "num": "331",
    "desc": "\nA preparatory course for ENVE Senior Design class. Topics will include professionalism, project management, intellectual property, organizational behavior and ethics. Students will explore potential design project ideas, build design teams, and chose a project to complete for senior design in the following semester.",
    "credits": "1"
  },
  {
    "course_name": "Radiation Detection and Monitoring",
    "dept": "ET",
    "num": "584",
    "desc": "\nPrinciples of operation of detectors used in the measurement and monitoring of ionizing radiation.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Technology Seminar",
    "dept": "ETA",
    "num": "020",
    "desc": "\nAn introduction to university life and the skills necesary for personal and professional success after college. Activities include discussions, hands-on projects and opportunities to meet and learn from professionals. Topics explore the responsibilities of a college student and the benefits of a university education.",
    "credits": "0"
  },
  {
    "course_name": "Problems in Engineering Technology",
    "dept": "ETA",
    "num": "292",
    "desc": "Prerequisite: Consent of instructor.\nIndependent study in specific topics in engineering technology.",
    "credits": "1-18"
  },
  {
    "course_name": "Applied Data Analysis and Tools",
    "dept": "ETB",
    "num": "310",
    "desc": "Prerequisite: MATH 150\nAn introduction to numerical computing, data analysis, and visualization with emphasis on the use of software tools and programming to model, analyze, and solve a variety of science and engineering problems.",
    "credits": "3"
  },
  {
    "course_name": "UAS Senior Design I",
    "dept": "ETB",
    "num": "480",
    "desc": "\nApplication of UAS principles and design methodology to solving a significant design problem in a team context. Includes determining customer requirements, exploring and choosing design alternatives, scheduling, and project management. Significant milestones are the project’s conceptual, preliminary, and critical design reviews, which require written and oral presentations.",
    "credits": "1"
  },
  {
    "course_name": "UAS Senior Design II",
    "dept": "ETB",
    "num": "481",
    "desc": "Prerequisite: ETB 480.\nA continuation of ETB 480. Includes the implementation, testing, and delivery of the project initiated in ETB 480 UAS Senior Design I. Significant milestones are the project prototype, design report, and final presentation.",
    "credits": "2"
  },
  {
    "course_name": "Senior Design Project I",
    "dept": "ETB",
    "num": "482",
    "desc": "Prerequisite: ECET 350, MET 382, and senior standing.\nApplication of engineering principles and design methodology to solve a significant design problem in a team context. Includes determining customer requirements, exploring and choosing design alternatives, scheduling, and project management. Significant milestones are the project’s conceptual, preliminary, and critical design reviews, which require written and oral presentations.",
    "credits": "1"
  },
  {
    "course_name": "Senior Design Project II",
    "dept": "ETB",
    "num": "483",
    "desc": "Prerequisite: ETB 482.\nA continuation of ETB 482. Includes the implementation, testing, and delivery of the project initiated in ETB 482 Senior Design I. Significant milestones are the project prototype, design report, and final presentation.",
    "credits": "1-3"
  },
  {
    "course_name": "Advanced Problems in Engineering Technology",
    "dept": "ETB",
    "num": "492",
    "desc": "Prerequisite: Consent of instructor.\nAdvanced independent study in specific topics in engineering technology.",
    "credits": "1-18"
  },
  {
    "course_name": "Foundations in Food Science & Industry",
    "dept": "FDSCI",
    "num": "101",
    "desc": "Prerequisite: Freshman in FDSCI.\nIntroduction to the food science &amp; industry programs, activities, resources, faculty and career opportunities.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Food Science",
    "dept": "FDSCI",
    "num": "302",
    "desc": "\nThis course is the beginning course in food science designed to acquaint the student with the breadth and scope of the food industry and the role of science in the preservation, processing, and utilization of foods.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Food Processing",
    "dept": "FDSCI",
    "num": "305",
    "desc": "Prerequisite: A course in chemistry.\nThe study of some basic ingredients used in food processing, principles of preserving and processing of foods, and food packaging. Food science and industry majors should take before the senior year. Taught in cooperation with the Departments of Horticulture, and Grain Science and Industry.",
    "credits": "3"
  },
  {
    "course_name": "Applied Microbiology for Meat and Poultry Processors",
    "dept": "FDSCI",
    "num": "307",
    "desc": "\nAn introduction to basic food microbiology and food safety concepts with application and integration of principles to the meat and poultry processing industry, microbiological techniques for products and environmental samples, antimicrobial intervention strategies, employee hygiene, Good Manufacturing Practices (GMPs), food plant sanitation, and introduction to Hazard Analysis Critical Control Points (HACCP) programs.",
    "credits": "3"
  },
  {
    "course_name": "Food Science Professional Preparation",
    "dept": "FDSCI",
    "num": "310",
    "desc": "Prerequisite: Open to Food Science majors with Sophomore Standing.\nThis course prepares students to pursue and be successful in food science careers. Students will develop professional resumes, identify internship and career opportunities, hone interviewing skills, examine standards of professionalism with respect to personal integrity and business ethics, and practice professional communication in oral and written formats.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to the Graduate Experience",
    "dept": "FDSCI",
    "num": "330",
    "desc": "Prerequisite: Consent of instructor.\nExploration and exposure to graduate studies in food science by undergraduate students. Participation in data collection, laboratory analysis, scientific article evaluation and research group meetings.",
    "credits": "1"
  },
  {
    "course_name": "Food Products Evaluation",
    "dept": "FDSCI",
    "num": "430",
    "desc": "\nFundamentals of sensory evaluation of dairy, poultry products, meat, and other agricultural food products. Study of taste, smell, texture, visual appearance, and other senses related to organoleptic examination and its application to the food processing industry. Introduction to sensory testing methods, including sampling techniques and test forms.",
    "credits": "3"
  },
  {
    "course_name": "Food Science Seminar",
    "dept": "FDSCI",
    "num": "500",
    "desc": "\nReview of recent developments in the food science industry and in food science research. Food science literature and intradepartmental research will provide source material.",
    "credits": "1"
  },
  {
    "course_name": "Food Chemistry",
    "dept": "FDSCI",
    "num": "501",
    "desc": "\nAn in-depth coverage of the chemical structures of major food components and the chemical reactions occurring during storage and processing.",
    "credits": "3"
  },
  {
    "course_name": "Fruit and Vegetable Processing",
    "dept": "FDSCI",
    "num": "510",
    "desc": "Prerequisite: FDSCI 305 and MATH 205 or 220\nFundamental fruit and vegetable processes and related unit operations including blanching, cooling, freezing, canning, irradiation, fermentation, pickling, drying, packaging in relation to quality, safety, and nutritional aspects of related products. Importance of raw material characteristics and storage conditions will be discussed in terms of post-harvest physiology of fruits and vegetables and different product types. Functionality of ingredients common in fruit and vegetable processing will also be introduced.",
    "credits": "2"
  },
  {
    "course_name": "Fruit and Vegetable Processing Lab",
    "dept": "FDSCI",
    "num": "511",
    "desc": "Prerequisite OR Corequisite: FDSCI 510\nLab component of FDSCI 510 Fruit and Vegetable Processing. The labs will demonstrate both industrial and lab scale applications of technologies, unit operations, quality measurements, and related processing calculations commonly used in fruit and vegetable processing.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research in Food Science & Industry",
    "dept": "FDSCI",
    "num": "530",
    "desc": "Prerequisite: Consent of instructor.\nMentored undergraduate research experience in animal or food sciences.",
    "credits": "0-3"
  },
  {
    "course_name": "Food Microbiology",
    "dept": "FDSCI",
    "num": "600",
    "desc": "Prerequisite: BIOL 455.\nThis course deals with the isolation, identification, enumeration, and characterization of bacteria, yeasts, molds and other microbes associated with foods and food processing. Effects of physical and chemical agents on micro-organisms will be studied. Microbiological problems in food spoilage, food preservation, food fermentation, and food-borne diseases will be discussed.",
    "credits": "2"
  },
  {
    "course_name": "Food Microbiology Lab",
    "dept": "FDSCI",
    "num": "601",
    "desc": "Prerequisite: FDSCI 600 or concurrent enrollment.\nLaboratory procedures involving isolation, identification, enumeration, and characterization of bacteria, yeasts, molds and other microbes associated with foods and food processing.",
    "credits": "2"
  },
  {
    "course_name": "Food Science Internship",
    "dept": "FDSCI",
    "num": "603",
    "desc": "Prerequisite: Consent of supervising instructor.\nSupervised professional field experience in food science.",
    "credits": "1-6"
  },
  {
    "course_name": "Food Science Problems",
    "dept": "FDSCI",
    "num": "630",
    "desc": "\nResearch or related work with others, or a literature search. Written reports are required. Any field of food science for which the student has adequate background.",
    "credits": "1-18"
  },
  {
    "course_name": "International Study Experience in Food Science",
    "dept": "FDSCI",
    "num": "660",
    "desc": "Prerequisite: Instructor permission.\nSeminar and travel course designed to prepare students before the experience and for students to analyze, critique, and report their experiences of an international experience associated with study tours or short courses. Course will focus on appropriate oral and written documentation of the student learning objectives for course experience. The academic topics will vary with each international activity.",
    "credits": "0-6"
  },
  {
    "course_name": "Principles of HACCP and HARPC",
    "dept": "FDSCI",
    "num": "690",
    "desc": "Prerequisite: Junior Standing.\nA comprehensive study of the Hazard Analysis and Critical Control Point (HACCP) System and the Hazard Analysis Risk Based Preventive Controls (HARP) and their application in the meat and food industries. Students will meet the training requirements under USDA HACCP and the FDA Food Safety Modernization Act (FSMA) for food safety.",
    "credits": "3"
  },
  {
    "course_name": "Food Plant Management",
    "dept": "FDSCI",
    "num": "694",
    "desc": "\nThe integration of food science knowledge in managing a food processing operation to produce high quality food products.",
    "credits": "3"
  },
  {
    "course_name": "Quality Assurance of Food Products",
    "dept": "FDSCI",
    "num": "695",
    "desc": "Prerequisite: One course in microbiology.\nA comprehensive course covering all aspects of quality assurance practices in the food industry. Emphasis is placed on interrelations of food chemistry, microbiology, sanitation, processing, and laws and regulations.",
    "credits": "3"
  },
  {
    "course_name": "Kosher and Halal Food Regulations",
    "dept": "FDSCI",
    "num": "710",
    "desc": "Prerequisite: Junior Standing.\nThis course is an introduction to the origin and application of Jewish and Muslim dietary laws and their application in commercial food production and processing with some coverage of home practices. Hebrew, Yiddish, and Arabic words and phrases will be presented and explained as they relate to kosher and halal food production, processing, and consumption. Religious festivals and customs, and the associated food products, will also be presented. Current food-related topics and issues in both the Jewish and Islam communities will be discussed. Food scientists should be aware of what constitutes a kosher or halal product and the importance of regulations dealing with the production and processing of these products.",
    "credits": "2"
  },
  {
    "course_name": "Rapid Methods and Automation in Microbiology",
    "dept": "FDSCI",
    "num": "713",
    "desc": "\nRapid methods and automation is a dynamic area in applied microbiology dealing with the study of improved methods in the isolation, detection, characterization, and enumeration of microorganisms and their products in clinical, food, industrial, and environmental samples. The knowledge and techniques of this course are useful for students interested in medical, food, industrial, and environmental microbiology for early detection of beneficial as well as harmful microorganisms in their work.",
    "credits": "2"
  },
  {
    "course_name": "Reaction Kinetics in Foods",
    "dept": "FDSCI",
    "num": "720",
    "desc": "Prerequisite: MATH 205 or MATH 220.\nA comprehensive course covering the principles of reaction kinetics in food systems to make quantitative predictions about food quality and food safety, and optimize food processing conditions.",
    "credits": "2"
  },
  {
    "course_name": "Reaction Kinetics in Foods Recitation",
    "dept": "FDSCI",
    "num": "721",
    "desc": "Corequisite: FDSCI 720.\nRecitation course covering the theories, case-studies, and exercise problems for the lecture course FDSCI 720, which needs to be taken concurrently.",
    "credits": "1"
  },
  {
    "course_name": "Food Analysis",
    "dept": "FDSCI",
    "num": "725",
    "desc": "\nPrinciples, methods, and techniques necessary for quantitative, instrumental, physical, and chemical analyses of food and food products for off-campus students using an audio/video taped format. The analytical principles will be related to standards and regulations for food processing.",
    "credits": "3"
  },
  {
    "course_name": "Chemical Methods of Food Analysis",
    "dept": "FDSCI",
    "num": "727",
    "desc": "\nMethods for quantitative, physical, and chemical analyses of foods and food products. Analytical techniques covered will include spectroscopy, chromatography, mass spectrometry, immunochemistry and atomic absorption. The analyses will be related to standards and regulations for food processing.",
    "credits": "2"
  },
  {
    "course_name": "Physical Methods of Food Analysis",
    "dept": "FDSCI",
    "num": "728",
    "desc": "\nPrinciples of physical and chemical methods and instrumentation for measuring protein, fat, moisture, and ash content. Determination of fat and oil quality characteristics. Physical measurements of food properties: color, water activity, water holding capacity, textural characteristic. Determination of properties and stability of emulsions, foams, and gels.",
    "credits": "2"
  },
  {
    "course_name": "A Multidisciplinary Overview of Food Safety and Security",
    "dept": "FDSCI",
    "num": "730",
    "desc": "Prerequisite: A course in biology or chemistry.\nMultidisciplinary food safety and security perspectives provided by numerous subject matter experts. Topics include food safety policy, ag bioterrorism, border security, animal ID, food defense and site security, risk analysis, crisis communication, epidemiology, HACCP, and more.",
    "credits": "2"
  },
  {
    "course_name": "Food Protection and Defense–Essential Concepts",
    "dept": "FDSCI",
    "num": "731",
    "desc": "\nThis course presents foundational concepts relevant to protecting the food supply from intentional contamination, including the nature of the food and agriculture system as a critical infrastructure, threats to food and agricultural systems, as well as concepts and strategies related to response and mitigation of food protection incidents.",
    "credits": "2"
  },
  {
    "course_name": "Research and Development of Food Products",
    "dept": "FDSCI",
    "num": "740",
    "desc": "\nAll aspects of new food product development from concept to store shelves will be covered, including market screening; focus groups; idea generation; prototype development; ingredient functionality and interactions; statistical designs for product development; processing; packaging; scale-up of operations; regulatory issues; labeling; physical, chemical, microbiological and sensory evaluations; quality control procedures; and HACCP plans.",
    "credits": "4"
  },
  {
    "course_name": "Food Toxicants",
    "dept": "FDSCI",
    "num": "750",
    "desc": "Prerequisite: A course in biochemistry.\nQuantitation metabolism and mechanisms of action of major foodborne toxicants. Toxicant defense and control systems, risk analysis and assessment and application of food laws.",
    "credits": "2"
  },
  {
    "course_name": "Food Laws and the Regulatory Process",
    "dept": "FDSCI",
    "num": "751",
    "desc": "Prerequisite: Three credits in food science coursework at 200 level or above.\nHistory of the development of the current federal and state food regulations. Guidelines that govern the practice of regulating the wholesomeness of red meats, poultry, and eggs. Presentations by state and federal food regulators.",
    "credits": "2"
  },
  {
    "course_name": "Risk Assessment for Food, Ag, & Vet Med",
    "dept": "FDSCI",
    "num": "753",
    "desc": "Prerequisite: A course in statistics or instructor consent.\nRisk assessment principles as applied to biological systems. Exposure and effects characterization in human and animal health and ecological risk assessment. Risk analysis frameworks and regulatory decision-making. Introduction to quantitative methods for risk assessment using epidemiological and distributional analyses. Uncertainty analysis.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Application of HACCP Principles",
    "dept": "FDSCI",
    "num": "791",
    "desc": "Prerequisite: FDSCI 690. Recommended prerequisite: BIOL 455.\nEvaluation of control parameters and methodology at critical control points, validating and auditing the effectiveness of critical control points, critical limits, monitoring tools, corrective action procedures, recordkeeping and verification procedures in addressing biological, chemical, and physical hazards that may be present in food products.",
    "credits": "3"
  },
  {
    "course_name": "Personal Investing and Risk Management",
    "dept": "FINAN",
    "num": "250",
    "desc": "Prerequisite: Sophomore standing and MATH 100.\nProvides a framework for identifying, analyzing, and managing the lifetime financial risks faced by the average person. An overview of the types and mechanics of investment instruments, development of personal risk profiles and investment plans, asset allocation methods, diversifiable and non-diversifiable risk, and risk avoidance and hedging methods.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Finance",
    "dept": "FINAN",
    "num": "450",
    "desc": "Prerequisite: ACCTG 231.\nStudy of the basic principles of finance, including discounted cash flow analysis, risk-return tradeoff, asset pricing models, and financial and real asset valuation. Applications of these concepts to the firm’s investment and financing decisions and performance analysis will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Integrated Investment Management",
    "dept": "FINAN",
    "num": "451",
    "desc": "Prerequisite: ACCTG 231.\nThis course provides a survey of the investment management industry. The course examines various aspects of the investment management industry including discussions of investment markets, products, companies, and strategies. The course also examines the business of investment management by surveying each of the functional areas of investment management industry: accounting, finance, management, and marketing. The course introduces students to the basics of investment management and the course provides a survey of the legal and ethical environments in the investment management industry.",
    "credits": "3"
  },
  {
    "course_name": "Insurance",
    "dept": "FINAN",
    "num": "460",
    "desc": "Prerequisite: ECON 110.\nA study of life, property, casualty, and health insurance from the purchaser’s point of view with additional emphasis on the operation and contribution of the insurance industry.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "FINAN",
    "num": "490",
    "desc": "Prerequisite: Consent of instructor.\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Problems in Finance",
    "dept": "FINAN",
    "num": "498",
    "desc": "Prerequisite: Consent of department head based on background courses appropriate to the project selected.\nInternship program and selected projects appropriate to the student’s program of study.",
    "credits": "1-18"
  },
  {
    "course_name": "Investment Management Concepts",
    "dept": "FINAN",
    "num": "500",
    "desc": "Prerequisite: FINAN 450.\nAn introduction and study of the issues and skills involved in successful investment management. This course will survey the role of capital markets, the basics of fundamental and technical analysis, behavioral finance, the basic of financial statements, client development, and management skills necessary for investment management success.",
    "credits": "3"
  },
  {
    "course_name": "Financial Institutions and Markets",
    "dept": "FINAN",
    "num": "510",
    "desc": "Prerequisite: FINAN 450. May be taken concurrent with FINAN 520.\nAn analysis of financial institutions and markets from a risk management point of view. The role of  financial institutions in the marketplace, the determinants of interest rates, and the impact of inflation on asset returns will be examined. Risks in financial institutions will be analyzed and management of these risks will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Investments",
    "dept": "FINAN",
    "num": "520",
    "desc": "Prerequisite: FINAN 450. May be taken concurrent with FINAN 510.\nAn analysis of investment securities from the investor’s point of view. Topics covered include the mechanics of investing in securities and market basics, the risk-return tradeoff, asset pricing models, market efficiency, the valuation of securities, portfolio performance measurement, and an introduction to derivatives.",
    "credits": "3"
  },
  {
    "course_name": "Commercial Banking",
    "dept": "FINAN",
    "num": "531",
    "desc": "Prerequisite: FINAN 510 and FINAN 520.\nAn application of financial management concepts to the liquidity management, investment portfolio analysis, capital budgeting, and capital structure decision-making process required by a commercial bank to perform effectively its financial intermediation role within the financial system’s institutional, regulatory, and competitive environment.",
    "credits": "3"
  },
  {
    "course_name": "Real Estate",
    "dept": "FINAN",
    "num": "552",
    "desc": "Prerequisite: Junior standing.\nPrinciples and practices including legal, economic, and social implications from the viewpoint of the real estate practitioner, investor, and society.",
    "credits": "3"
  },
  {
    "course_name": "Finance for Entrepreneurs",
    "dept": "FINAN",
    "num": "561",
    "desc": "Prerequisite: FINAN 450.\nA comprehensive set of knowledge and tools to start, run, and exit an entrepreneurial or small business. These tools include financial forecasting and business planning, financing operations and capital investments, evaluation of asset acquisitions, tax planning, short-term capital management, mergers/acquisitions, and evaluation of exit strategies.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Finance",
    "dept": "FINAN",
    "num": "575",
    "desc": "Prerequisite: FINAN 510 and 520.\nAn in-depth study of a firm’s investment and financing decisions, firm performance measurement and financial planning for a business enterprise. Topics include financial statement analysis and forecasting, capital budgeting, risk considerations in capital budgeting, cost of capital, capital structure theory and practice, distribution policy, leasing and mergers and acquisitions.",
    "credits": "3"
  },
  {
    "course_name": "Financial Modeling",
    "dept": "FINAN",
    "num": "623",
    "desc": "Prerequisite: FINAN 510 and FINAN 520 or FINAN 830.\nThis course is designed to provide an in-depth knowledge of the use of Excel for use in the corporate finance and equity valuation environment.  Topics include: • Use of Excel •Developing Models in Excel • Developing functional understanding of how to use Excel.",
    "credits": "3"
  },
  {
    "course_name": "International Financial Management",
    "dept": "FINAN",
    "num": "643",
    "desc": "Prerequisite: Either FINAN 510 and FINAN 520 or FINAN 815.\nThe international (cross-currency) aspects of financial management. Topics include currency markets and exchange rate determination, parity conditions, foreign exchange exposure and management, and valuation of international projects.",
    "credits": "3"
  },
  {
    "course_name": "Security and Portfolio Analysis",
    "dept": "FINAN",
    "num": "653",
    "desc": "Prerequisite: FINAN 510 and FINAN 520 or FINAN 815.\nThe analysis and valuation of securities and the management of investment portfolios. Students analyze the composition of, make buy/sell recommendations for, and evaluate the performance of an actual portfolio.",
    "credits": "3"
  },
  {
    "course_name": "Derivative Securities and Markets",
    "dept": "FINAN",
    "num": "654",
    "desc": "Prerequisite: FINAN 510 and FINAN 520 or FINAN 815.\nStructure and operation of markets for futures, swaps, options, synthetic options, and futures on options. Valuation of futures contracts and options. Applications of derivatives to hedging and speculating strategies.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Portfolio Management",
    "dept": "FINAN",
    "num": "655",
    "desc": "Prerequisites: FINAN510, FINAN520, and acceptance to the Financial Analyst Track\nProvides students the background knowledge in portfolio management. This will include learning about: investment mix and policy, investment objectives, differing asset allocations for individuals and institutions, and balancing risk and performance.",
    "credits": "3"
  },
  {
    "course_name": "Professional Financial Planning",
    "dept": "FINAN",
    "num": "661",
    "desc": "Prerequisite: FINAN 510 and FINAN 520.\nA study of the principles and practices of professional financial planning using an integrated planning model. Topics include the planning environment, concepts, tax management, asset acquisition and management, credit management, risk management, investments, retirement planning, and estate planning. Contemporary applications, professional opportunities, and legal/ethical standards are emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Mergers and Acquisition",
    "dept": "FINAN",
    "num": "663",
    "desc": "Prerequisites: FINAN 575, FINAN623, and acceptance to Financial Analyst Track.\nPresents the theories and empirical evidence on mergers, acquisitions, and restructuring, and analyzes the effects of various policy options on stock values of acquirer and target companies.",
    "credits": "3"
  },
  {
    "course_name": "Cases in Finance",
    "dept": "FINAN",
    "num": "675",
    "desc": "Prerequisite: FINAN 575, and senior level students admitted in a College of Business Administration degree track or graduate standing.\nCapstone course in finance utilizing real world cases to integrate and apply financial concepts and theories, with emphasis on analytical and written and oral communication skills.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Public Health",
    "dept": "FNDH",
    "num": "110",
    "desc": "\nThis is an introductory survey course designed to provide a history of public health, an overview of the five core disciplines (epidemiology, biostatistics, environmental health, social and behavioral health, and health policy and management), and information about career options in public health. Using these introductory materials as a foundation, students will investigate and analyze contemporary issues in public health such as bioterrorism, threats to the nation’s food supply, the importance of health promoting behaviors in the prevention of disease, burden and distribution of infectious diseases on a global population, and the role of public health disaster preparedness and management.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Health and Nutrition Professions",
    "dept": "FNDH",
    "num": "115",
    "desc": "\nThis course will provide a history of public health and exposure to health professions that pertain to nutrition and sports medicine. It will offer learners a methodology for understanding populations and population health specific to nutrition, sport, and activity. Students will analyze contemporary public health issues such as threats to the nation’s food supply, health promoting behaviors in the prevention of disease, the burden and distribution of infectious diseases on a global population, public health’s role in disaster preparedness and management, and bioterrorism. Learners will then be exposed to healthcare professions utilizing some of the evidence derived from nutrition and health sciences that guides their decisions when counseling their patients.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Athletic Training",
    "dept": "FNDH",
    "num": "120",
    "desc": "Prerequisite: Athletic training majors only, and concurrent enrollment in FNDH 121.\nIntroduction to athletic training for first year athletic training majors. Emphasis will be on sports medicine team, legal concerns, pre-participation physicals, basic principles of injury prevention, policies and procedures.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Athletic Training Lab",
    "dept": "FNDH",
    "num": "121",
    "desc": "Prerequisite: Athletic training majors only, and concurrent enrollment in FNDH 120.\nIntroduction to athletic training for first year athletic training majors. Students will be required to complete a competencies skill list with a passing grade. Clinical hours in the athletic training room will give the student the opportunity to use the knowledge, skills, and techniques learned in this course.",
    "credits": "1"
  },
  {
    "course_name": "Careers in Nutrition and Dietetics",
    "dept": "FNDH",
    "num": "130",
    "desc": "\nAn introduction to career opportunities in the field of nutrition and dietetics with emphasis on academic preparation, acquisition of professional credentials, and career laddering. Guest speakers from various areas of professional practice will supplement lectures and student assignments.",
    "credits": "1"
  },
  {
    "course_name": "Basic Nutrition",
    "dept": "FNDH",
    "num": "132",
    "desc": "\nConcepts of human nutrition applied to personal food choices and health.",
    "credits": "3"
  },
  {
    "course_name": "Food Trends, Legislation, and Regulation",
    "dept": "FNDH",
    "num": "301",
    "desc": "\nCurrent trends in market forms, packaging, and utilization of various foods. Food laws, regulation, labeling, additives, and residues.",
    "credits": "3"
  },
  {
    "course_name": "Care and Prevention of Athletic Injuries",
    "dept": "FNDH",
    "num": "320",
    "desc": "Prerequisite: C or better in KIN 220 or EDCI 300, or 5 hours of anatomy and physiology transfer credit or concurrent enrollment in either BIOL 341, 342 or KIN 360 or Instructor consent.\nPrinciples and practices of treatment, taping, and care of minor athletic injuries.",
    "credits": "3"
  },
  {
    "course_name": "Medical Documentation",
    "dept": "FNDH",
    "num": "321",
    "desc": "\nThis course is to prepare students with the knowledge of medical nomenclature related to human systems, diseases, and scientific concepts for applications of electronic medical documentation (Electronic Medical Records; EMR) and scientific communication.",
    "credits": "2"
  },
  {
    "course_name": "Food and Health: Safety, Allergies and Intolerances",
    "dept": "FNDH",
    "num": "340",
    "desc": "\nAn overview of the food system as it relates to the field of dietetics, focusing on issues that impact the quality, safety, accessibility, and sustainability of food. The course includes the systems approach, food safety principles, food allergy/intolerances principles, food contamination, religious issues, and related government regulations. This course will cover the following topics: food safety, food allergies and intolerances, sustainability, religious and cultural issues that affect food safety and health. Specific applications of these topics will be made for the dietetics profession (institutions, health care settings, grocery stores, etc.)",
    "credits": "3"
  },
  {
    "course_name": "Food Production Management",
    "dept": "FNDH",
    "num": "342",
    "desc": "Prerequisite: HM 341 and FNDH 413 with a minimum grade of “C” in each; HM 220 or BIOL 455 with ServSafe Certification.\nApplication and principles of food production that includes procurement, quantity food production and controls, work simplification, food service systems, quality food; commercial equipment use, and Hazard Analysis Critical Control Point (HACCP) system.",
    "credits": "4"
  },
  {
    "course_name": "Personal Wellness",
    "dept": "FNDH",
    "num": "352",
    "desc": "Prerequisite: Sophomore standing.\nImpact of the effect of personal actions on lifelong wellness. Practical methods of assessing, maintaining, and improving behaviors to reduce the risk of illness and disability. Emphasis on developing skills to make informed, responsible health decisions.",
    "credits": "3"
  },
  {
    "course_name": "Rehabilitation and Exercise Modification Techniques I",
    "dept": "FNDH",
    "num": "355",
    "desc": "Prerequisite: Instructor approval required.\nThis course will cover the fundamental aspects of tactical strength and conditioning, and injury prevention techniques that occur during physical activity.",
    "credits": "3"
  },
  {
    "course_name": "Human Nutrition",
    "dept": "FNDH",
    "num": "400",
    "desc": "Prerequisite: CHM 110 and 111 or 210; BIOL 198.\nNutrients, their function, metabolism, and relation to health and disease: the digestion, absorption, transport, utilization, and storage of nutrients in humans.",
    "credits": "3"
  },
  {
    "course_name": "Science of Food",
    "dept": "FNDH",
    "num": "413",
    "desc": "Prerequisite: CHM 110 and 111 or 210.\nChemical, physical, sensory, and nutritional properties of food related to processes used in food preparation.",
    "credits": "4"
  },
  {
    "course_name": "Financial Management in Dietetics",
    "dept": "FNDH",
    "num": "426",
    "desc": "Prerequisite: ACCTG 231 with a grade of B or better, HMD 342 or concurrent enrollment.  Enrollment restricted to dietetics majors, non-majors completing CADE requirements, or consent of instructor.\nApplication of financial management principles used to control costs and generate revenue in dietetics practice and noncommercial foodservice operations.",
    "credits": "3"
  },
  {
    "course_name": "Nutritional Assessment",
    "dept": "FNDH",
    "num": "450",
    "desc": "Prerequisite: FNDH 132 and sophomore standing.\nMethods of nutritional assessment in humans to evaluate dietary intake and body composition; use of biologic markers of human nutritional status.",
    "credits": "2"
  },
  {
    "course_name": "Rehabilitation and Exercise Modification Techniques II",
    "dept": "FNDH",
    "num": "455",
    "desc": "Prerequisite: FNDH 355.\nThis course is designed to provide an academic platform to apply and enhance knowledge and skills in rehabilitation techniques for humans. Focus is on applying progressive resistive exercise programs for athletes who are engaged in reconditioning and rehabilitation programs.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Clinical Dietetics",
    "dept": "FNDH",
    "num": "490",
    "desc": "\nThrough a series of case studies and projects, this course introduces the student dietitian to the basics of the practice of clinical dietetics including review of the medical record, nutritional assessment and documentation of medical nutrition therapy in the medical record.  Students gain practical experience by completing shadowing experiences with a dietitian in clinical practice.",
    "credits": "2"
  },
  {
    "course_name": "Problems in Human Nutrition",
    "dept": "FNDH",
    "num": "499",
    "desc": "Prerequisite: Six hours in FNDH and consent of instructor.\nSupervised individual project to study current topics or participation in research.",
    "credits": "1-18"
  },
  {
    "course_name": "Life Span Nutrition",
    "dept": "FNDH",
    "num": "510",
    "desc": "Prerequisite: FNDH 400.\nPhysiological and environmental influences on nutritional requirements; nutritional problems and eating patterns of age groups throughout the life cycle.",
    "credits": "2"
  },
  {
    "course_name": "Counseling Strategies in Dietetic Practice",
    "dept": "FNDH",
    "num": "515",
    "desc": "Prerequisite: PSYCH 110 or SOCIO 211 with a grade of C or better; FNDH 450 with a grade of B or better.  Enrollment restricted to dietetics majors, non-majors completing CADE requirements, or consent of instructor.\nApplication of interviewing, counseling, and educational techniques in dietetics, including individual and group methods.",
    "credits": "3"
  },
  {
    "course_name": "Communication Competencies in Dietetics Practice",
    "dept": "FNDH",
    "num": "516",
    "desc": "Prerequisite: FNDH 515 or concurrent enrollment.\nAssessment of audiences and development of effective food/nutrition messages in community settings.",
    "credits": "1"
  },
  {
    "course_name": "Communication Competencies in Dietetics Practicum",
    "dept": "FNDH",
    "num": "517",
    "desc": "Prerequisite: Admission into the coordinated program in dietetics; concurrent enrollment in FNDH 516 and FNDH 521.\nApplication of principles learned in FNDH 516 Communication Competencies in Dietetics Practice to the development, implementation, and evaluation of a community project under the guidance of a community mentor.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Clinical Dietetics",
    "dept": "FNDH",
    "num": "519",
    "desc": "Prerequisite: Admission into the coordinated program in dietetics; concurrent enrollment in FNDH 521.\nPreparation for entrance into the clinical supervised practice experience. Review of medical record content; current practice protocols in clinical dietetics; practice case studies.",
    "credits": "1"
  },
  {
    "course_name": "Applied Clinical Dietetics",
    "dept": "FNDH",
    "num": "520",
    "desc": "Prerequisite: Admission to the coordinated program in dietetics.\nApplication of clinical nutrition principles through case studies, independent research, discussion, groups, and oral presentations. Case studies will focus on medical nutrition therapy and education of persons throughout the life cycle and nutrition intervention for individuals with multiple disease states in various healthcare settings.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Dietetic Practicum",
    "dept": "FNDH",
    "num": "521",
    "desc": "Prerequisite: Must be taken concurrent with FNDH 520.\nSupervised clinical/community experience in the nutritional care of patients/clients. Practicum experiences are arranged with participating healthcare facilities.",
    "credits": "8"
  },
  {
    "course_name": "Nutrition Education in Extension",
    "dept": "FNDH",
    "num": "530",
    "desc": "Prerequisite: Any college-level nutrition course and junior or senior standing.\nThe process of and strategies for providing nutrition education outreach to diverse community audiences, including those with limited resources.",
    "credits": "1"
  },
  {
    "course_name": "Energy Balance",
    "dept": "FNDH",
    "num": "535",
    "desc": "Prerequisite: FNDH 400 or KIN 335 or concurrent enrollment in either.\nThis course will cover metabolic principles as they relate to energy intake (diet) and expenditure (exercise). Specific topics will include: obesity, anorexia/bulimia, bioenergetics, substrate selection/regulation (especially exercise and diabetes), body composition; methodology to assess each; and metabolism related disease.",
    "credits": "2"
  },
  {
    "course_name": "Evaluation of Athletic Injuries of the Extremities",
    "dept": "FNDH",
    "num": "551",
    "desc": "Prerequisite: FNDH 320 with a B or better and a C or better in either KIN 360, BIOL 341, or 5 hours of anatomy and physiology credit.\nThis course is designed to familiarize the athletic training student with the principles of orthopedic assessment and to apply these principles to specific regions of the body. Knowledge gained in this course may be applicable to other individuals interested in health related professions which require systematic examination of the body.",
    "credits": "3"
  },
  {
    "course_name": "Emergency Procedures and Evaluation of Core Athletic Injuries",
    "dept": "FNDH",
    "num": "552",
    "desc": "Prerequisite: FNDH 320 with a B or better and a C or better in KIN 360, BIOL 340 and BIOL 342, or 8 hours of Anatomy and Physiology transfer credit.\nFamiliarize the athletic training student with the procedures of emergency management of athletic injuries and to apply these procedures both on the field and off the field. Familiarized with the principles of orthopedic and emergency medical assessment and to apply these principles to the core of the body. Knowledge gained may be applicable to other individuals interested in health related professions which require systematic examination of the body in emergency settings.",
    "credits": "3"
  },
  {
    "course_name": "Pharmacology in Athletic Training",
    "dept": "FNDH",
    "num": "553",
    "desc": "Prerequisite: C or better in KIN 360, BIOL 341 and BIOL 342 or 8 hours of Anatomy and Physiology transfer credit.\nStudy of medications commonly encountered in the practice of athletic training. Includes categories of drugs, generic and trade names of common drugs, the use, effects and precautions for common drugs and drug-interactions. Focuses on how various drugs affect the patient response to activity, exercise and other therapeutic interventions.",
    "credits": "2"
  },
  {
    "course_name": "General Medical Conditions in the Athlete",
    "dept": "FNDH",
    "num": "554",
    "desc": "Prerequisite: C or better in KIN 360, BIOL 341 and BIOL 342, or 8 hours of Anatomy and Physiology transfer credit; FNDH 551 and FNDH 552.\nRecognition, evaluation, management, and prevention of the most common medical conditions that affect athletic participation. Emphasis placed on the appropriate history, physical exam, indications for referral, and treatment for each condition.",
    "credits": "2"
  },
  {
    "course_name": "Therapeutic Modalities in Athletic Training",
    "dept": "FNDH",
    "num": "555",
    "desc": "Prerequisite: FNDH 551, FNDH 320 with a B or better.\nThe theory and application of the various energy systems used in the treatment of athletic injuries. Practical experiences will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Rehabilitation and Conditioning for Athletic Injuries",
    "dept": "FNDH",
    "num": "556",
    "desc": "Prerequisite: FNDH 551, FNDH 552 and KIN 330, FNDH 555 or concurrent enrollment.\nA study of applied rehabilitation and conditioning techniques used by athletic trainers.",
    "credits": "3"
  },
  {
    "course_name": "Administration of Athletic Training Programs",
    "dept": "FNDH",
    "num": "557",
    "desc": "Prerequisite: FNDH 556 and senior standing.\nA study of issues affecting athletic trainers in their roles as administrators in the areas of role delineation, budget designs, legal aspects of sport, facility design, and drug testing and drug education.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Athletic Training Techniques",
    "dept": "FNDH",
    "num": "558",
    "desc": "Prerequisite: FNDH 551.\nThis course will provide a deeper application of athletic training techniques in specific orthopedic related areas. Students will have a hands-on and lab component as it relates to casting, bracing, Kinesiotaping, and manual therapy techniques. Upon completion of this course, students will be eligible to complete the certification examinations to obtain credentialing as an ASOP Orthopedic Physician Extender.",
    "credits": "3"
  },
  {
    "course_name": "Management in Dietetics",
    "dept": "FNDH",
    "num": "560",
    "desc": "Prerequisite: FNDH 426. Admission to the didactic or coordinated program.\nManagement and leadership in dietetic practice. Discussion of current issues affecting practice including human resources, outcomes management, accreditation/quality assurance, financial resources, marketing, technology and recent trends in various fields of management practice.",
    "credits": "3"
  },
  {
    "course_name": "Management in Dietetics Practicum",
    "dept": "FNDH",
    "num": "561",
    "desc": "Prerequisite: Admission to Coordinated Program; FNDH 560 or concurrent enrollment.\nSupervised practice experience in the application of management principles in foodservice operations or other dietetics practice settings.",
    "credits": "8"
  },
  {
    "course_name": "Management in Dietetics Practicum Recitation",
    "dept": "FNDH",
    "num": "562",
    "desc": "Prerequisite: Admission to the coordinated program in dietetics; concurrent enrollment in FNDH 561.\nFocused discussion of significant occurrences during the supervised practice experience and the application of management principles in foodservice operations or other dietetic practice settings. Behavior-based assessment and progression is utilized to encourage self-development and entry-level competence in dietetics practice.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Research in Dietetics Practice",
    "dept": "FNDH",
    "num": "570",
    "desc": "Prerequisite: Junior standing or instructor permission.\nIntroduction to basic research design in dietetics with application of the research to evidenced-based practice using the Evidence Analysis Library of the Academy of Nutrition and Dietetics.",
    "credits": "1"
  },
  {
    "course_name": "Research Methods and Scientific Communication in Health Sciences",
    "dept": "FNDH",
    "num": "575",
    "desc": "Prerequisite: Junior Standing.\nStudents in this undergraduate course will examine the role and importance of the scientific method in health professions, with focus on nutrition and sports medicine. The course will outline the research methods used to acquire knowledge in health-related professions. The rationale and role of evidence-based practice and research will be explored, and students will be introduced to research language and core concepts.  Skills will be developed for asking clinical or professional questions, and how to translate these questions into search strategies for finding evidence.  The purpose of this course is to provide initial instruction on how to locate, understand, and evaluate the research literature in the student’s area of interest. As a broad survey course, the expectation is not mastery of research methodology, but rather improvement in competencies related to the critical consumption of research literature. Students will be introduced to quantitative and qualitative research methods, types of data, how data are described and how biostatistics are used to provide meaning to research data. A range of health research methods will be covered, and studies about treatment effectiveness (clinical trials and systematic reviews), as well as qualitative approaches will be explored. Students will be introduced to research tools and search engines that support conducting a literature review.",
    "credits": "3"
  },
  {
    "course_name": "Practicum I in Athletic Training",
    "dept": "FNDH",
    "num": "583",
    "desc": "Prerequisite: Instructor approval.\nA supervised, clinical experience at approved clinical settings. The athletic training student will apply principles taught in FNDH 320.",
    "credits": "1-4"
  },
  {
    "course_name": "Practicum II in Athletic Training",
    "dept": "FNDH",
    "num": "584",
    "desc": "Prerequisite: Instructor approval.\nA supervised, clinical experience at approved clinical settings. The athletic training student will apply principles taught in the classroom and practiced in the lab throughout the curriculum program.",
    "credits": "1-4"
  },
  {
    "course_name": "Practicum III in Athletic Training",
    "dept": "FNDH",
    "num": "585",
    "desc": "Prerequisite: Instructor approval.\nA supervised clinical experience at approved clinical settings. The athletic training student will apply principles taught in the classroom and practiced in the lab throughout the curriculum program.",
    "credits": "1-4"
  },
  {
    "course_name": "Practicum IV in Athletic Training",
    "dept": "FNDH",
    "num": "586",
    "desc": "Prerequisite: Instructor approval.\nA supervised, clinical experience at approved clinical settings. The athletic training student will apply principles taught in the classroom and practiced in the lab throughout the curriculum program.",
    "credits": "1-4"
  },
  {
    "course_name": "Practicum V in Athletic Training",
    "dept": "FNDH",
    "num": "587",
    "desc": "Prerequisite: Instructor approval.\nA supervised, clinical experience at approved clinical settings. The athletic training student will apply principles taught in the classroom and practiced in the lab throughout the curriculum program.",
    "credits": "1-4"
  },
  {
    "course_name": "Practicum VI in Athletic Training",
    "dept": "FNDH",
    "num": "588",
    "desc": "Prerequisite: Instructor approval.\nA supervised, clinical experience at approved clinical settings. The athletic training student will apply principles taught in the classroom and practiced in the lab throughout the curriculum program.",
    "credits": "1-4"
  },
  {
    "course_name": "Professional Preparation for Athletic Training",
    "dept": "FNDH",
    "num": "589",
    "desc": "Prerequisite: Senior Standing\nThis course will provide a comprehensive review of athletic training knowledge in specific domain areas. Students will have a seminar component to review and apply knowledge across the 5 domain areas of athletic training. The domain areas include: injury/illness prevention and wellness protection; clinical evaluation and diagnosis; immediate and emergency care; treatment and rehabilitation; organizational and professional health and well-being.",
    "credits": "0-1"
  },
  {
    "course_name": "Topics in Human Nutrition",
    "dept": "FNDH",
    "num": "599",
    "desc": "Prerequisite: Junior standing and consent of instructor.",
    "credits": "1-3"
  },
  {
    "course_name": "Public Health Nutrition",
    "dept": "FNDH",
    "num": "600",
    "desc": "Prerequisite: FNDH 450.\nPublic health nutrition issues for various segments of the population; nutritional components of community assessment; program planning and evaluation; and policy issues pertaining to the nutritional status of the population.",
    "credits": "3"
  },
  {
    "course_name": "Nutrient Metabolism",
    "dept": "FNDH",
    "num": "620",
    "desc": "Prerequisite: FNDH 400; BIOL 341 and BIOL 342 or KIN 360; and BIOCH 265 or BIOCH 521, or CHM 550 with concurrent enrollment in BIOCH 521.\nBasic concepts of the mechanisms of actions, interactions, and the processes of cellular assimilation and utilization of nutrients in humans. Emphasis on the coordinated control of nutrient utilization among the major organs.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Nutrition I",
    "dept": "FNDH",
    "num": "631",
    "desc": "Prerequisite: FNDH 450.\nFirst course of a two semester study of the application of nutrition principles in disease; includes physiological basis of nutritional care, effects of disease on nutrient metabolism, medical nutrition therapy, in-class team diagnoses presentations, and nutrition counseling.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Nutrition II",
    "dept": "FNDH",
    "num": "632",
    "desc": "Prerequisite: FNDH 620 and FNDH 631 taken within the previous five years.\nContinuation of the application of nutrition principles in disease; includes physiological and biochemical basis of nutritional care, effects of disease on nutrient metabolism, medical nutrition therapy for critical care needs, standardized language in advanced professional nutrition diagnoses and care of selected diseases.",
    "credits": "3"
  },
  {
    "course_name": "Nutrition and Exercise",
    "dept": "FNDH",
    "num": "635",
    "desc": "Prerequisite: FNDH 132 or FNDH 400 and a grade of C or higher in KIN 310 and 335.\nThe interrelationships among diet, nutrition, and exercise. Topics covered include physical fitness, weight control, nutrient metabolism during exercise, and athletic performance.",
    "credits": "3"
  },
  {
    "course_name": "Food Writing",
    "dept": "FNDH",
    "num": "643",
    "desc": "Prerequisite: ENGL 200.\nUnderstanding and appreciating how to communicate effectively in writing about food and food-related topics.  Hands-on experience in research and writing for various audiences and types of publications.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Food, Nutrition, Dietetics and Health",
    "dept": "FNDH",
    "num": "650",
    "desc": "Prerequisite: Consent of instructor.\nSupervised professional field experience.",
    "credits": "1-6"
  },
  {
    "course_name": "Pharmacology",
    "dept": "FNDH",
    "num": "653",
    "desc": "\nThis course is designed to bring together the body of knowledge regarding the study of medications commonly encountered in the profession of athletic training. Includes categories of drugs, generic and trade names of common drugs, the use, effects and precautions for common drugs and drug-interactions. Focuses on how various drugs affect the patient response to activity, exercise and other therapeutic interventions.",
    "credits": "3"
  },
  {
    "course_name": "Pathophysiology and Clinical Evaluation",
    "dept": "FNDH",
    "num": "654",
    "desc": "Prerequisite: Anatomy &amp; Physiology (5 credit hours completed) or equivalent; CHM 110/CHM 111 or CHM 210; Junior standing or Instructor Approval.\nDesigned to bring together the body of knowledge regarding the manifestation, diagnosis, and treatment of human illness, disease, and injury and the resulting physiological responses that occur during the lifespan. Content will build on anatomy, physiology and chemistry content from previous courses.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Applications and Neurological Function",
    "dept": "FNDH",
    "num": "655",
    "desc": "Prerequisite: KIN 360, or equivalent or permission of the instructor.\nScientific approach to advance knowledge related to the assessment of structured movement of the human body in relationship to neurological function and pathologies. Cognitive (knowledge), psychomotor (hands-on) learning, affective, and clinical/quantitative skills with a heavy emphasis on neuroanatomy to stress clinical application.",
    "credits": "3"
  },
  {
    "course_name": "Nutrition and Food Behavior",
    "dept": "FNDH",
    "num": "660",
    "desc": "Prerequisite: PSYCH 110 or SOCIO 211 or ANTH 200; and FNDH 400.\nFocus on the physiological, environmental, cultural, and economic factors that influence the use of food. Identification of appropriate methodology to study these factors as well as programs to modify food behavior.",
    "credits": "3"
  },
  {
    "course_name": "Global Health and Nutrition",
    "dept": "FNDH",
    "num": "700",
    "desc": "Prerequisite: Graduate level classification, or undergraduate student with instructor permission.\nThis course is designed to examine major global nutrition and health challenges, programs and policies. Students will become acquainted with the epidemiology of nutritional disease in developed and developing countries.  Programs and resources available to combat malnutrition will be evaluated. It will help students analyze current and emerging global health priorities, including emerging infectious diseases, newer nutritional problems, health inequity, health systems reforms, and major global initiatives for disease prevention and health promotion. Designed for advanced undergraduate and graduate students in health related field, including biological or social sciences.",
    "credits": "3"
  },
  {
    "course_name": "Sensory Analysis",
    "dept": "FNDH",
    "num": "701",
    "desc": "Prerequisite: STAT 325 or 340.\nSensory analysis of appearance, texture, aroma, flavor; physiology of sensory receptors; laboratory and consumer panels; and interpretation of data.",
    "credits": "3"
  },
  {
    "course_name": "Nutrition in Developing Countries",
    "dept": "FNDH",
    "num": "702",
    "desc": "Prerequisite: FNDH 510.\nNutritional problems in developing countries, including an analysis of factors which contribute to malnutrition, effects of undernutrition, methods for assessing nutritional status, and interventions to combat nutrition problems.",
    "credits": "3"
  },
  {
    "course_name": "Food Across Cultures and Countries",
    "dept": "FNDH",
    "num": "703",
    "desc": "\nExploration of food across cultures in the U.S. and the world with emphasis on the affects of geographic, social, economic, religious, and other issues.",
    "credits": "2"
  },
  {
    "course_name": "Nutritional Immunology",
    "dept": "FNDH",
    "num": "706",
    "desc": "\nPrinciples and issues related to nutrition and immunology. Impact of nutrients and nutritional status on immune responses. Impact of disease states on nutritional status.",
    "credits": "3"
  },
  {
    "course_name": "Pet Food Sensory Analysis",
    "dept": "FNDH",
    "num": "711",
    "desc": "Prerequisite: STAT 325 or STAT 702 or STAT 703 or equivalent.\nSensory analysis of food and other products for non-food animals (e.e. dogs and cats with mention of other species) with an emphasis on methods (descriptive, discrimination, consumer, sensory-related instrumental) used in the laboratory and in the field.",
    "credits": "2"
  },
  {
    "course_name": "Physical Health and Aging",
    "dept": "FNDH",
    "num": "718",
    "desc": "Prerequisite: BIOL 198 and senior standing.\nFocus is on the physiological theories of aging, the relationship between normal aging processes, and the major chronic and acute diseases of the elderly, and community health promotion/maintenance programs for older adults.",
    "credits": "3"
  },
  {
    "course_name": "Administration of Health Care Organizations",
    "dept": "FNDH",
    "num": "720",
    "desc": "\nComprehensive review of current health care institutions and their response to the economic, social/ethical, political/legal, technological, and ecological environments.",
    "credits": "3"
  },
  {
    "course_name": "Nutrition and Wellness",
    "dept": "FNDH",
    "num": "726",
    "desc": "Prerequisite: Course in basic nutrition and statistics at the undergraduate level.\nEpidemiology and pathophysiology of chronic disease related to nutrition (e.g., obesity, cardiovascular disease, osteoporosis, hypertension, diabetes, cancer). Nutritional risk and protective factors will be examined as they relate to public health and individual nutrition.",
    "credits": "3"
  },
  {
    "course_name": "Nutritional Oncology",
    "dept": "FNDH",
    "num": "729",
    "desc": "Prerequisite: Admission to the Masters in Dietetics program through the Great Plains Interactive Distance Education Alliance (GPIDEA).\nStudents will gain understanding of basic cancer biology and methodology used to study nutrition and cancer relationships. Using current research as a basis, the role of nutrition in specific cancers will be explored. Students will learn about sources of information for cancer prevention programs, and how to apply this information to clinical patient management.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Diabetes Management",
    "dept": "FNDH",
    "num": "731",
    "desc": "Prerequisite: FNDH 631 or RDN credential  or approval of instructor.\nThe course is designed for students to gain a comprehensive understanding of the classification, presentation, and diagnosis of diabetes and pre-diabetes. The course will explore etiology, pathophysiology, diagnostic tests, clinical management, chronic complications and co-morbidities, and emerging technologies.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Energy Balance",
    "dept": "FNDH",
    "num": "735",
    "desc": "Prerequisite: FNDH 620 or 635.\nLifestyle, metabolic, and endocrine factors affecting energy balance and the development of obesity. Research methods to assess and apply energy balance data will also be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Research in Health Sciences",
    "dept": "FNDH",
    "num": "775",
    "desc": "\nStudents in this graduate course will review the role and importance of the scientific method in health professions, especially those with clinical application. The rationale and role of evidence-based practice and research will be reviewed, and research language and core concepts will be discussed. Students will demonstrate their ability to ask research questions and translate questions into search strategies for finding evidence.  The purpose of this course is to provide students the opportunity to demonstrate their capacity to locate, understand, and evaluate the research literature in the student’s area of interest. The expectation is to demonstrate understanding of research methodology the ability to critically evaluate research literature. Students will demonstrate knowledge of quantitative and qualitative research methods, types of data, how data are described and how biostatistics are used to provide meaning to research data. A range of health research methods will be covered, and studies about treatment effectiveness (clinical trials and systematic reviews), as well as qualitative approaches will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Food, Nutrition, Dietetics and Health",
    "dept": "FNDH",
    "num": "780",
    "desc": "Prerequisite: Consent of instructor.\nSupervised individual project to study current issues.",
    "credits": "1-6"
  },
  {
    "course_name": "Topics in Food, Nutrition, Dietetics and Health",
    "dept": "FNDH",
    "num": "782",
    "desc": "Prerequisite: Consent of instructor.\nSupervised individual project to study current issues.",
    "credits": "1-6"
  },
  {
    "course_name": "Urban Forest Administration",
    "dept": "FOR",
    "num": "520",
    "desc": "Prerequisite: FOR 510.\nThis course is a study of urban and community forest administration. It considers the urban forest ecosystem involving an in-depth look at ownerships. composition, distribution, benefits, values, and administrative operation. The policies and politics of successful administration will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Forestry Problems",
    "dept": "FOR",
    "num": "741",
    "desc": "Prerequisite: Consent of instructor.\nWork is offered in various fields of forestry.",
    "credits": "1-3"
  },
  {
    "course_name": "Orientation for Summer School Program",
    "dept": "FREN",
    "num": "001",
    "desc": "",
    "credits": "0"
  },
  {
    "course_name": "French I",
    "dept": "FREN",
    "num": "101",
    "desc": "\nIntroduction to the structure of modern French, emphasizing the spoken language with practice in the language laboratory.",
    "credits": "5"
  },
  {
    "course_name": "French II",
    "dept": "FREN",
    "num": "102",
    "desc": "Prerequisite: FREN 101 or equivalent.\nContinuation of French I, completion of basic presentation of the structure of French. Emphasis on spoken language, use of language lab.",
    "credits": "5"
  },
  {
    "course_name": "Accelerated Beginning French",
    "dept": "FREN",
    "num": "103",
    "desc": "\nCourse covering material from French I and II in one semester. Listening, speaking, reading, and writing. Includes one hour lab per week in language laboratory or other language opportunities outside of class time.",
    "credits": "5"
  },
  {
    "course_name": "French III",
    "dept": "FREN",
    "num": "300",
    "desc": "Prerequisite: FREN 102 or equivalent.\nContinuation of French II, presentation of more advanced elements of the French language. Emphasis on spoken language, use of the language lab.",
    "credits": "5"
  },
  {
    "course_name": "French IV",
    "dept": "FREN",
    "num": "301",
    "desc": "Prerequisite: Recommended to have taken FREN 201 or equivalent.\nContinuation of French III, presentation of more advanced elements of the French language. Emphasis on spoken language, use of the language lab.",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Studies in French",
    "dept": "FREN",
    "num": "398",
    "desc": "\nOffered only to participants in study abroad programs.",
    "credits": "1-6"
  },
  {
    "course_name": "Readings in French",
    "dept": "FREN",
    "num": "501",
    "desc": "Prerequisite: FREN 213 or equivalent.\nPractice in reading a variety of literary, journalistic, and specialized texts.",
    "credits": "3"
  },
  {
    "course_name": "French Literature in Translation",
    "dept": "FREN",
    "num": "502",
    "desc": "\nSelected readings in English of works representing important literary trends.",
    "credits": "3"
  },
  {
    "course_name": "French Composition and Grammar",
    "dept": "FREN",
    "num": "503",
    "desc": "Prerequisite: FREN 213 or equivalent.\nReview in depth of the structure of the language. Intensive practice in written and conversational French.",
    "credits": "3"
  },
  {
    "course_name": "French Phonetics",
    "dept": "FREN",
    "num": "509",
    "desc": "Prerequisite: FREN 213 or equivalent.\nThe fundamentals of French phonetics. Intensive practice in diction.",
    "credits": "1"
  },
  {
    "course_name": "Modern French Culture",
    "dept": "FREN",
    "num": "510",
    "desc": "\nFrench culture since World War II with special emphasis on social, economic, historical, and artistic developments of that period. Taught in English.",
    "credits": "2"
  },
  {
    "course_name": "French/Francophone Cinema",
    "dept": "FREN",
    "num": "512",
    "desc": "Prerequisite: FREN 301 or equivalent.\nThe course consists of readings, written assignments, viewing, and discussion of French or Francophone films.",
    "credits": "3"
  },
  {
    "course_name": "Contemporary France",
    "dept": "FREN",
    "num": "514",
    "desc": "Prerequisite: FREN 213 or equivalent.\nIntroduction to French culture with special emphasis on social and historical developments since World War II.",
    "credits": "3"
  },
  {
    "course_name": "History of French Culture",
    "dept": "FREN",
    "num": "515",
    "desc": "Prerequisite: FREN 213 or equivalent.\nA survey of French culture from the Middle Ages to the present, including but not limited to, developments in art and architecture, music, and literature.",
    "credits": "3"
  },
  {
    "course_name": "Business French",
    "dept": "FREN",
    "num": "517",
    "desc": "Prerequisite: FREN 213 or equivalent.\nAdvanced grammar necessary for adequate oral and written expression in international business and diplomatic situations, including specialized terminology, conversation and discussion, and translation.",
    "credits": "3"
  },
  {
    "course_name": "French Conversation",
    "dept": "FREN",
    "num": "518",
    "desc": "Prerequisite: FREN 213 or equivalent.\nPractice in spoken French, with emphasis on idiomatic expression. Course not open to students whose primary language is French and whose competence has been demonstrated in the language at this level.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in French",
    "dept": "FREN",
    "num": "519",
    "desc": "Prerequisite: FREN 213 or equivalent and consent of department head and instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to French Literature (19th Century to the Present)",
    "dept": "FREN",
    "num": "520",
    "desc": "Prerequisite: FREN 516 or equivalent.\nThe reading and discussion of major works of French literature from the early nineteenth century to the present.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to French Literature (Medieval to 18th Century)",
    "dept": "FREN",
    "num": "521",
    "desc": "Prerequisite: FREN 516 or equivalent.\nThe reading and discussion of major works of French literature from the Middle Ages to the end of the eighteenth century.",
    "credits": "3"
  },
  {
    "course_name": "Topics in French/Francophone Literature and Culture",
    "dept": "FREN",
    "num": "530",
    "desc": "Prerequisite: At least one course taught in French at the 500 level.\nProvides the students the opportunity to investigate in detail a particular theme or genre in French literature or culture.",
    "credits": "3"
  },
  {
    "course_name": "Medieval French Literature",
    "dept": "FREN",
    "num": "709",
    "desc": "Prerequisite: FREN 520 or 521 and one other 500 level course, or consent of instructor.",
    "credits": "3"
  },
  {
    "course_name": "Sixteenth-Century French Literature",
    "dept": "FREN",
    "num": "710",
    "desc": "Prerequisite: FREN 520 or 521 and one other 500 level course, or consent of instructor.\nReading and discussion of selected prose and poetry of the French Renaissance.",
    "credits": "3"
  },
  {
    "course_name": "Seventeenth-Century French Literature",
    "dept": "FREN",
    "num": "711",
    "desc": "Prerequisite: Two 500 level courses, including FREN 520 or FREN 521 or with the consent of the instructor.\nVarious literary forms of the French Baroque and Classical period. Reading of representative texts by Corneille, Pascal, Moliere, Racine, La Fontaine, and others.",
    "credits": "3"
  },
  {
    "course_name": "Eighteenth-Century French Literature",
    "dept": "FREN",
    "num": "713",
    "desc": "Prerequisite: FREN 520 or 521 and one other 500 level course, or consent of instructor.\nCritical study of the literature of the Enlightenment.",
    "credits": "3"
  },
  {
    "course_name": "Romantic French Literature",
    "dept": "FREN",
    "num": "714",
    "desc": "Prerequisite: FREN 520 or 521 and one other 500 level course, or consent of instructor.\nA study of preromanticism and romanticism.",
    "credits": "3"
  },
  {
    "course_name": "Realist French Literature",
    "dept": "FREN",
    "num": "715",
    "desc": "Prerequisite: FREN 520 or 521 and one other 500 level course, or consent of instructor.\nA study of realism, naturalism, and symbolism.",
    "credits": "3"
  },
  {
    "course_name": "Contemporary French Literature",
    "dept": "FREN",
    "num": "716",
    "desc": "Prerequisite: Two 500-level courses, including FREN 520 or FREN 521 or with consent of the instructor.\nThe study of major themes and trends in the novel, drama, and poetry since 1900 as reflected by major authors as Proust, Camus, Sarraute, and others.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Spoken and Written French",
    "dept": "FREN",
    "num": "719",
    "desc": "Prerequisite: FREN 520 or 521 and one other 500 level course, or consent of instructor.\nAn advanced, intensive study of French prose style. Introduction to the techniques of translation from English to French. Intensive practice in oral style and diction.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in French Literature and Culture",
    "dept": "FREN",
    "num": "720",
    "desc": "Prerequisite: FREN 520 or FREN 521 or with the consent of the instructor.\nA seminar with various topics centered on literature and culture.",
    "credits": "3"
  },
  {
    "course_name": "Francophone Literature and Culture",
    "dept": "FREN",
    "num": "721",
    "desc": "Prerequisite: FREN 520 or 521 and one other course at a 500 level.\nThe development of French colonial and postcolonial literature and culture with an emphasis on the twentieth and twenty-first centuries. Regional focus may vary from Quebecois, Caribbean, Sub-Saharan or North African literature and culture.",
    "credits": "3"
  },
  {
    "course_name": "Literature for Second Language Acquisition",
    "dept": "FREN",
    "num": "742",
    "desc": "Prerequisite: FREN 520 or 521 and one other 500 level course, or instructor consent.\nAnalysis and interpretation of cultural and literary texts from French-speaking countries, with emphasis on the development of interpretive skills and materials, and their application to the French curriculum at all levels.",
    "credits": "3"
  },
  {
    "course_name": "Culture for Second Language Acquisition",
    "dept": "FREN",
    "num": "743",
    "desc": "Prerequisite: FREN 520 or FREN 521 and one other course at a 500 level, or instructor consent.\nAnalysis and interpretation of cultural resources from French-speaking countries, with emphasis on the development of interpretive skills and materials, and their application to the French curriculum at all levels.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Modern Languages",
    "dept": "FREN",
    "num": "799",
    "desc": "Prerequisite: FREN 520 or 521 and one other 500 level course, or consent of instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Problems in Family Studies and Human Services",
    "dept": "FSHS",
    "num": "300",
    "desc": "Prerequisite: Consent of instructor.\nIndependent or small group study.",
    "credits": "1-18"
  },
  {
    "course_name": "Manual Communication",
    "dept": "FSHS",
    "num": "415",
    "desc": "\nStudy of background information in current trends in the use of sign language. Restricted to sign language used in the United States. Includes instruction in the American Manual Alphabet and Vocabulary for about 700 signs. Primary focus will be application of beginning skills for communication with those who depend on this form of communication.",
    "credits": "3"
  },
  {
    "course_name": "International Experience in Family Studies and Human Services",
    "dept": "FSHS",
    "num": "500",
    "desc": "\nTravel seminar course designed to prepare students before their international, study abroad experience and analyze, critique, and report about their faculty-led study tours or short courses. The academic topics will vary with each international activity.",
    "credits": "0-6"
  },
  {
    "course_name": "Research Practicum",
    "dept": "FSHS",
    "num": "575",
    "desc": "Prerequisite: Consent of instructor.\nIndependent or small group study. Provides students with a high impact experiential research opportunity with faculty.",
    "credits": "0-3"
  },
  {
    "course_name": "Manual Communication II",
    "dept": "FSHS",
    "num": "615",
    "desc": "Prerequisite: FSHS 415 or basic sign language skills.\nInstruction in an additional 400-500 signs in the SEE system. Introduction to elementary ASL techniques. Discussion of other augmentative communication systems. Research will be conducted in the use of various manual communication systems with special populations, including aphasic, language disabled, mentally handicapped, and others.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Family Studies and Human Services",
    "dept": "FSHS",
    "num": "700",
    "desc": "Prerequisite: Consent of instructor.\nIndependent study on aspects of human development and family studies.",
    "credits": "1-18"
  },
  {
    "course_name": "Seminar in Family Studies and Human Services",
    "dept": "FSHS",
    "num": "704",
    "desc": "Prerequisite: Nine hours of FSHS or other social science.\nInterpretation and evaluation of information on varied topics relating to family members.",
    "credits": "1-18"
  },
  {
    "course_name": "Topics in Family Studies and Human Services",
    "dept": "FSHS",
    "num": "708",
    "desc": "Prerequisite: Consent of instructor.\nReview of recent research and theory related to exploration of methods and family and interpersonal processes.",
    "credits": "2-3"
  },
  {
    "course_name": "Foundations of Youth Development",
    "dept": "FSHS",
    "num": "711",
    "desc": "\nThis course examines the fundamentals of youth development and the youth development profession. Through this introduction to the field, students will explore the ethical, professional and historical elements of youth development as it has evolved toward professionalization.",
    "credits": "1"
  },
  {
    "course_name": "Community Youth Development",
    "dept": "FSHS",
    "num": "712",
    "desc": "\nCommunity Youth Development focuses upon the national emphasis of a strength-based or asset approach to community youth development. Emphasis is placed upon research, theory, and practice applied in communities throughout the United States. Students will explore existing models, theoretical and applied literature and current community efforts as a basis for understanding community youth development.",
    "credits": "3"
  },
  {
    "course_name": "Adolescents and Their Families: Implications for Youth Professionals",
    "dept": "FSHS",
    "num": "713",
    "desc": "\nThis course covers adolescent development as it is related to and intertwined with family development. The reciprocal influences between adolescents and their families will be examined. Working with youth vis-a-vis the family system will be highlighted.",
    "credits": "3"
  },
  {
    "course_name": "Program Design, Evaluation, and Implementation",
    "dept": "FSHS",
    "num": "714",
    "desc": "\nThis course is an overview of the program development process and out come evaluation of community, children, and family programs. Mode of outcome scholarship and their implications for community-based programs are discussed. Students will develop knowledge through participating in a community-based project involving the practical application of program design and evaluation methods.",
    "credits": "3"
  },
  {
    "course_name": "Youth Issues and Life Skills",
    "dept": "FSHS",
    "num": "715",
    "desc": "\nThis course will present three strands: issues faced by youth today and associated risk and resiliency factors; life skills for youth; and helping skills necessary for youth professionals who work with young poeple.",
    "credits": "2"
  },
  {
    "course_name": "Topics in Contemporary Youth Issues",
    "dept": "FSHS",
    "num": "716",
    "desc": "\nThis course will present issues faced by youth today and associated risk and resiliency factors.",
    "credits": "1-3"
  },
  {
    "course_name": "Youth Policy",
    "dept": "FSHS",
    "num": "717",
    "desc": "\nThis course examines various federal and state policies designed specifically for youth. This course will be divided into three sections: (a) what is policy and what youth policies exist? (b) policies specifically designed for to “protect the well-being” of youth (e.g., zero tolerance, restorative justice, juvenile justice and reform), and (c) targeted youth policies (e.g., foster care, policies for youth with disabilities, homeless youth).",
    "credits": "3"
  },
  {
    "course_name": "Youth Professionals as Consumers of Research",
    "dept": "FSHS",
    "num": "718",
    "desc": "\nThis course is designed to help youth development professionals understand and apply research results and theories to practice. Emphasis will be placed on research and theory reports related to the youth development with particular attention to research procedures and outcomes.",
    "credits": "3"
  },
  {
    "course_name": "Program Administration and Management",
    "dept": "FSHS",
    "num": "719",
    "desc": "\nThis course is designed to introduce students to the development, administration and management of youth, family, and community service organizations.",
    "credits": "3"
  },
  {
    "course_name": "Youth Development",
    "dept": "FSHS",
    "num": "720",
    "desc": "\nThis course is designed to introduce students to the developmental period of adolescence. The theory and research of positive youth development will be the lens through which this developmental period is examined. Through a critical examination of the theoretical and research literature, the course will help students recognize and become familiar with the major issues and transitions adolescents face as they successfully navigate this developmental stage.",
    "credits": "3"
  },
  {
    "course_name": "Youth and Cultural Contexts",
    "dept": "FSHS",
    "num": "722",
    "desc": "\nThis course will provide participants with an understanding of the cultural heritage of differing family structures, types, and social and educational processes experienced by youth in these families through in-depth reading, writing, discussion, critical listening, viewing of contemporary videos, and informal interviews with youth. Students will gain further knowledge of how ethnic groups fit historically into our society, and the results of how history has shaped our present day situation.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Youth Development",
    "dept": "FSHS",
    "num": "723",
    "desc": "Prerequisite: Consent of practicum supervisor as well as on-site supervisor required.\nSupervised experience in youth development practice and service provision in organizational setting.",
    "credits": "1-3"
  },
  {
    "course_name": "Working with Military Families",
    "dept": "FSHS",
    "num": "724",
    "desc": "\nThis course provides students with initial information necessary to prepare a service-provider for work with military families. Course participants will be introduced to the culture, context, and complexities of the contemporary military family. This course equips learners to work in capacities which support military families through times of challenge, helping them foster resilience as they cope with military life. This course is taught online with lectures, asynchronous discussions, and written assignments.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Approaches to Family Health and Illness",
    "dept": "FSHS",
    "num": "727",
    "desc": "\nClinical approaches to health behaviors and chronic illness management are generally focused on the individual. This course will address contextual and relational factors that impact health and illness within family contexts. The course will explore ways to develop an integrated clinical approach to assess individuals and families attempting to manage a variety of medical conditions across the life span.",
    "credits": "3"
  },
  {
    "course_name": "Foundations Family Services",
    "dept": "FSHS",
    "num": "784",
    "desc": "\nAn introduction to the field of family studies and related professions that involve working with individuals and families in communities.",
    "credits": "3"
  },
  {
    "course_name": "Family Dynamics",
    "dept": "FSHS",
    "num": "785",
    "desc": "\nAn examination of theories of family function and dysfunction, techniques of assessment, and models of family interventions.",
    "credits": "3"
  },
  {
    "course_name": "Lifespan Development",
    "dept": "FSHS",
    "num": "786",
    "desc": "\nHuman development from both lifespan and bio-ecological perspectives focusing on major theories of development and current research on micro-macro relationship.",
    "credits": "3"
  },
  {
    "course_name": "Resilience in Families",
    "dept": "FSHS",
    "num": "787",
    "desc": "\nExploration of resilience approaches to the study of families and human development across the life cycle.",
    "credits": "3"
  },
  {
    "course_name": "Parenting Education",
    "dept": "FSHS",
    "num": "791",
    "desc": "\nAn examination of theories, models, methods, research, and skills related to parenting and parent education.",
    "credits": "3"
  },
  {
    "course_name": "Agriculture Scholars Program",
    "dept": "GENAG",
    "num": "000",
    "desc": "Prerequisite: Acceptance into the College of Agriculture Scholars Program.\nFor all undergraduate students in the College of Agriculture Scholars Program. Students should enroll every semester while active in the program.",
    "credits": "0"
  },
  {
    "course_name": "University Honors Program",
    "dept": "GENAG",
    "num": "020",
    "desc": "Prerequisite: Acceptance into the University Honors Program.\nAll students participating in the University Honors Program and who are enrolled in the College of Agriculture must enroll each semester.",
    "credits": "0"
  },
  {
    "course_name": "Ag Orientation",
    "dept": "GENAG",
    "num": "101",
    "desc": "\nObjectives, organization, and procedures of the College of Agriculture and the university are studied. Historical developments and projected trends in agriculture and the application of basic sciences to agriculture are presented.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to the University Honors Program",
    "dept": "GENAG",
    "num": "189",
    "desc": "\nOverview of the University Honors Program including directions, goals, and student requirements for completion of the program.",
    "credits": "1"
  },
  {
    "course_name": "Topics in Agriculture",
    "dept": "GENAG",
    "num": "200",
    "desc": "\nSelected issues in agriculture.",
    "credits": "0-3"
  },
  {
    "course_name": "Human and Cultural Diversity in the Food and Agricultural Sciences",
    "dept": "GENAG",
    "num": "210",
    "desc": "\nThe purpose of this course is to introduce agriculture students to concepts of diversity by learning about cultural awareness, issues, and contributions made by different ethnic groups to the field of agriculture.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Global Food Systems Leadership",
    "dept": "GENAG",
    "num": "225",
    "desc": "\nAn interdisciplinary approach to the fundamental roles people, policies, and cultures play in the global food system enterprise as it relates to sustainable food production, processing, distribution, and availability. Students will explore complexities within self, others, and community related to leadership in the context of a rapidly increasing global population.",
    "credits": "3"
  },
  {
    "course_name": "Uncertainty in Global Food Systems Leadership",
    "dept": "GENAG",
    "num": "325",
    "desc": "Prerequisite: GENAG 225 or LEAD 225 or DAS 225.\nExplore technical and adaptive elements of grand challenges across disciplines. This course addresses the impact of cultural identity, life experience, and world views on leadership relationships as it relates to privilege and inclusion in the context of global food systems. Students will consider elements of community-engaged work.",
    "credits": "3"
  },
  {
    "course_name": "Research Topic and Proposal Development",
    "dept": "GENAG",
    "num": "396",
    "desc": "Prerequisite: Sophomore standing or instructor permission.\nUndergraduate honors and scholars students learn the research process and identify and work with a faculty mentor to prepare an individual undergraduate research project proposal. Class presentations focus on strategies to identify and narrow a research topic, seek a research mentor, and develop a research proposal. Additional content will address common research methods, safety and compliance issues, and tips for persuasively presenting research results.",
    "credits": "1"
  },
  {
    "course_name": "Global Food Systems Leadership in Action",
    "dept": "GENAG",
    "num": "425",
    "desc": "Prerequisite: GENAG 325 or LEAD 325 or DAS 325.\nIn this capstone course, students will conduct a community-engaged global food systems leadership research/service project. Emphasis will be placed on data collection, analysis and dissemination to appropriate audiences. Additional emphases will be on ethical dimensions of leadership and individual exploration of careers and roles within global food systems.",
    "credits": "3"
  },
  {
    "course_name": "Citizenship and Ethics in Agriculture",
    "dept": "GENAG",
    "num": "450",
    "desc": "Prerequisite: Junior or senior standing.\nThe study of agriculture’s relationship with society while encompassing ethics and personal development. Current controversial issues and multidimensional policy topics facing the agricultural industry will be explored with an emphasis on moral and philosophical debates. Issues regarding professional ethics and decision making will also be an emphasis.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar",
    "dept": "GENAG",
    "num": "495",
    "desc": "Prerequisite: Acceptance into the University Honors Program.\nSeminars treat topics relevant to students participating in the University Honors Program.",
    "credits": "1-3"
  },
  {
    "course_name": "Comparative Agriculture",
    "dept": "GENAG",
    "num": "505",
    "desc": "Prerequisite: Consent of instructor.\nA travel-study program which is intended to acquaint students with agriculture of other countries and other parts of the United States and how it differs from Midwest-Great Plains agriculture relative to climate, crops, soils, livestock practices, marketing, and cultural attitudes toward agriculture.",
    "credits": "1-4"
  },
  {
    "course_name": "Honors/Scholars Project",
    "dept": "GENAG",
    "num": "515",
    "desc": "Prerequisite: Approved project proposal.\nCompletion of an independent undergraduate research project or scholarly activity required for the University Honors Program or the College of Agriculture Scholars Program. Oral presentation and written report required. Taken during the semester when the project will be completed.",
    "credits": "0-1"
  },
  {
    "course_name": "Natural Resources/Environmental Science Project (NRES)",
    "dept": "GENAG",
    "num": "582",
    "desc": "Prerequisite: All writing and oral communications courses required for major. Prerequisite or corequisite: 15 hours of approved courses in NRES secondary major.\nA comprehensive project in NRES. Requires integration of information and understanding acquired in NRES secondary major courses. Students must prepare and present written and oral reports.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Agricultural Resources and Environmental Management",
    "dept": "GENAG",
    "num": "670",
    "desc": "\nInterdisciplinary, international study of agricultural and natural resource management sustainability.  Discussion of agro-ecologic, economic, and social science perspectives; sustainability criteria; issues of scale and culture; disciplinary methods; and systems-level approaches. Applications to important natural resources and environmental management issues in Kansas, U.S., and in other countries.",
    "credits": "2"
  },
  {
    "course_name": "Seminar in International Agriculture",
    "dept": "GENAG",
    "num": "690",
    "desc": "Prerequisite: Junior or senior standing.\nAn in-depth study of international agriculture topics.",
    "credits": "1"
  },
  {
    "course_name": "Occupational and Agricultural Health",
    "dept": "GENAG",
    "num": "711",
    "desc": "\nAddresses the identification, evaluation, and control of health hazards in occupational and agricultural settings. Topics include occupational toxicology, air contaminants, noise, radiation, thermal stress, ergonomics, biological hazards, emerging health risks, and health risks of special populations.",
    "credits": "3"
  },
  {
    "course_name": "Occupational and Agricultural Injury Prevention",
    "dept": "GENAG",
    "num": "712",
    "desc": "\nExplores traumatic injuries and their prevention in occupational and agricultural settings.  Topics include falls, workplace violence, animal handling, mobile equipment, fixed machines, work tools, electrical hazards, fires, and explosions.",
    "credits": "3"
  },
  {
    "course_name": "Occupational and Agricultural Safety and Health",
    "dept": "GENAG",
    "num": "721",
    "desc": "\nExamines the design and evaluation of behavioral interventions to prevent occupational and agricultural injuries and illnesses. Topics include theories of safety and health behavior; effective communication and persuasion strategies; planning, conducting and evaluating interventions; interventions for diverse populations; and intervention strategies in evolving occupational and societal contexts.",
    "credits": "3"
  },
  {
    "course_name": "Current Topics in Agriculture",
    "dept": "GENAG",
    "num": "780",
    "desc": "\nSelected topics studied to provide an in-depth understanding of current agricultural issues.",
    "credits": "1-3"
  },
  {
    "course_name": "University Honors Program",
    "dept": "GENBA",
    "num": "020",
    "desc": "\nAll students participating in the University Honors Program and who are enrolled in the College of Business Administration must enroll each semester.",
    "credits": "0"
  },
  {
    "course_name": "Business Orientation",
    "dept": "GENBA",
    "num": "105",
    "desc": "\nA general orientation to the College of Business Administration and university, academic planning, advising and enrollment processes.",
    "credits": "0"
  },
  {
    "course_name": "Business Foundations",
    "dept": "GENBA",
    "num": "110",
    "desc": "\nIn a highly interactive learning environment, topics in accounting, business creation, finance, information systems, management, marketing, and operations are covered, while integrating ethics and responsible business citizenship. The course demonstrates how core business areas are interrelated and the importance of creativity and innovation to business. In this applied class, students well engage in the process of making business decisions.",
    "credits": "3"
  },
  {
    "course_name": "Business Information Technology Skills Proficiency",
    "dept": "GENBA",
    "num": "166",
    "desc": "\nIn this course, students will demonstrate skills and knowledge of working effectively with spreadsheets, databases, word-processing and presentation software in a business setting. This proficiency is demonstrated by passing the Information Technology Sills Proficiency Exam administered through this course.",
    "credits": "0"
  },
  {
    "course_name": "Introduction to the University Honors Program",
    "dept": "GENBA",
    "num": "189",
    "desc": "\nOverview of the University Honors Program including directions, goals, and student requirements for completion of the program.",
    "credits": "1"
  },
  {
    "course_name": "Career Accelerator",
    "dept": "GENBA",
    "num": "205",
    "desc": "Prerequisite: Sophomore standing.\nEssential course on career preparation for all business students with topics focused on career exploration, personal brand, networking, resumes, interview skills, and workplace expectations.  Students completing this course will be well-equipped to engage with employers while leveraging extensive campus and College of Business resources to enhance internship and future employment opportunities.",
    "credits": "0"
  },
  {
    "course_name": "Honors Colloquium in Business",
    "dept": "GENBA",
    "num": "299",
    "desc": "\nDiscussions and lectures on topics of interest to business students.",
    "credits": "1"
  },
  {
    "course_name": "International Business Experience",
    "dept": "GENBA",
    "num": "375",
    "desc": "\nAn international business experience that requires travel to a foreign country. The length of the tour varies from one week to 16 weeks. This course enables students to complete an international experience that would include study, research, or work in a foreign country. The course provides enriched experience in the financial and business practices in a foreign country and enhances students” global and cultural awareness.",
    "credits": "0"
  },
  {
    "course_name": "Administrative Communications",
    "dept": "GENBA",
    "num": "391",
    "desc": "Prerequisite: ENGL 120 and COMM 106.\nPreparation of business communications, reports, and correspondence, and analysis of communication systems within an enterprise structure.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar",
    "dept": "GENBA",
    "num": "399",
    "desc": "Prerequisite: GENBA 299.\nThe Honors Seminar is designed as a follow-up course to the Honors colloquium and it prepares students for the honors capstone project that culminates into the honors project. It also provides a forum for all honors students who are working on their capstone honors project to share and discuss their project ideas.",
    "credits": "1"
  },
  {
    "course_name": "Problems in Business Administration",
    "dept": "GENBA",
    "num": "498",
    "desc": "Prerequisite: Senior standing and consent of instructor and the department head.\nIn-depth analysis of special problems in general business including study of current literature.",
    "credits": "1-18"
  },
  {
    "course_name": "Business Honors Project",
    "dept": "GENBA",
    "num": "499",
    "desc": "Prerequisite: GENBA 399.\nA business honors project is an independent study in an intellectual endeavor (research or creative activity) under the supervision of a faculty member.  The project must be approved by the College of Business Honors Director in consultation with the faculty supervisor and the University Honors Program Director.  Deliverables of an Honors project may include a paper presented at a student or professional conference, a paper presented at a faculty/student seminar, a paper appearing in a poster presentation or a paper submitted for a national competition.",
    "credits": "3"
  },
  {
    "course_name": "Theories of Gender",
    "dept": "GENBA",
    "num": "506",
    "desc": "Prerequisite: Six hours of Gender, Women, and Sexuality Studies.\nSurveys major contemporary United States theories of gender and their development, including impact of feminist movement on the development of theory, interactions of race and gender, women’s culture and men’s roles. Compares approaches of social sciences and humanities.",
    "credits": "3"
  },
  {
    "course_name": "International Business Experience",
    "dept": "GENBA",
    "num": "675",
    "desc": "\nAn international business experience that requires travel to a foreign country. The length of the tour varies from one week to 16 weeks. This course enables students to complete an international experience that would include study, research or work in a foreign country. The course provides enriched experience in the financial and business practices in a foreign country and enhances students’ global and cultural awareness.",
    "credits": "0"
  },
  {
    "course_name": "World Geography & Globalization",
    "dept": "GEOG",
    "num": "100",
    "desc": "\nIntroduction to geography structured on a framework of major world regions and countries. Within the regional approach is an explicit discussion of the essential concepts rooted in historical, cultural, social, political, economic, religious, gender, urban geography, and globalization.",
    "credits": "3"
  },
  {
    "course_name": "Introductory Physical Geography: Earth Systems Science",
    "dept": "GEOG",
    "num": "121",
    "desc": "\nA systemic introduction to the processes and spatial patterns of the atmosphere, biosphere, geosphere, and hydrosphere and their interactions at the Earth’s surface. Prepares science and engineering majors for more advanced coursework and promotes improved environmental literacy of non-science majors.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Physical Geography: Earth Systems Science Laboratory",
    "dept": "GEOG",
    "num": "122",
    "desc": "Corequisite: GEOG 121\nLaboratory investigation of the processes and spatial pasterns of the atmosphere, biosphere, geosphere, and hydrosphere and their interactions at the Earth’s surface.",
    "credits": "1"
  },
  {
    "course_name": "Human Geography",
    "dept": "GEOG",
    "num": "200",
    "desc": "\nA geographical assessment of the way human activities shape landscapes throughout the world. The course is especially appropriate for students interested in the social and behavioral sciences.",
    "credits": "3"
  },
  {
    "course_name": "Human Geography (Honors)",
    "dept": "GEOG",
    "num": "201",
    "desc": "Prerequisite: Membership in arts and sciences honors program.\nSpatial aspects of human organization and behavior are examined through selected concepts in modern geography. The course is especially appropriate for students interested in the social and behavioral sciences.",
    "credits": "3"
  },
  {
    "course_name": "Atmospheric Science",
    "dept": "GEOG",
    "num": "235",
    "desc": "Prerequisite: MATH 100 recommended.\nA comprehensive scientific study of the physics, chemistry, and dynamics of the earth’s atmosphere, from the earth’s surface to several hundred kilometers.  Fundamental topics covered include atmospheric composition and variability, subdivisions of the atmosphere, energy and mass transfers within the Earth-atmosphere system, atmospheric circulation, and accurate prediction of atmospheric phenomena.",
    "credits": "4"
  },
  {
    "course_name": "Geography of Tourism",
    "dept": "GEOG",
    "num": "300",
    "desc": "\nThe geography of tourism is concerned with the structure, form, use, and conservation of the landscape as well as with such spatial conditions as the location of tourist areas and the movements of people from place to place. This course addresses such concepts as the economic, environmental, social, and cultural impacts of tourism as well as examining the tourist geography of each of the world’s regions, focusing on the major tourist areas.",
    "credits": "3"
  },
  {
    "course_name": "Cartography and Thematic Mapping",
    "dept": "GEOG",
    "num": "302",
    "desc": "Prerequisite: STAT 325 or equivalent.\nIntroduction to cartographic history, theory and principles, thematic map design, symbolization, map perception, color theory, typography, and digital cartographic research. Laboratory work will familiarize students with the latest cartographic software that will be used to produce a series of thematic maps.",
    "credits": "3"
  },
  {
    "course_name": "Geography of Kansas",
    "dept": "GEOG",
    "num": "310",
    "desc": "\nA regional and historical analysis of Kansas including discussion of the physical environment, historical development, and current geographic patterns.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Japan",
    "dept": "GEOG",
    "num": "331",
    "desc": "\nGeographical survey of Japan from prehistoric times to the present day, which may include material on society, politics, and culture.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to China",
    "dept": "GEOG",
    "num": "332",
    "desc": "\nSurvey of the geography, history, politics, and culture of China from prehistoric times to the present day.",
    "credits": "3"
  },
  {
    "course_name": "European Landscapes",
    "dept": "GEOG",
    "num": "335",
    "desc": "\nExplores how humans have interacted with their environment and modified the natural and cultural landscape within Europe.",
    "credits": "3"
  },
  {
    "course_name": "Natural Resources",
    "dept": "GEOG",
    "num": "340",
    "desc": "\nThe significance, environmental consequences, and locational characteristics of natural resources and resource-based economic activities, including agriculture, fishing, forestry, and mining.  Sustainability and conservation considerations related to natural resource extraction, management, and use.",
    "credits": "3"
  },
  {
    "course_name": "Earth System Geography",
    "dept": "GEOG",
    "num": "350",
    "desc": "\nA basic physical geography course emphasizing the geosphere, hydrosphere, atmosphere and biosphere, including the processes, patterns, and physical science background required to understand related issues such as natural hazards and human modification of earth systems.",
    "credits": "4"
  },
  {
    "course_name": "Sustainability Concepts & Issues",
    "dept": "GEOG",
    "num": "360",
    "desc": "\nExploration of sustainability concepts, approaches, and decision-making.  Relation of sustainability to environmental, economic, and social considerations at global, regional, and local scales.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Geography",
    "dept": "GEOG",
    "num": "399",
    "desc": "\nSelected topics.",
    "credits": "2-3"
  },
  {
    "course_name": "Biogeography",
    "dept": "GEOG",
    "num": "445",
    "desc": "Prerequisite: One course in geography, life science, or physical science.\nCovers: 1) the spatial and temporal patterns of the distribution of living organisms on Earth (including plants, animals, and microbes), and 2) the biological and physical processes responsible for these patterns. Biogeography has crucial insights to offer regarding conservation of rare species, global changes such as climate change, and human domination of the Earth surface.",
    "credits": "3"
  },
  {
    "course_name": "Geography of Economic Behavior",
    "dept": "GEOG",
    "num": "450",
    "desc": "\nThe location of manufacturing industries and patterns of commercial activity. Case studies and simulations are used with emphasis on modern concepts of site selection and community development.",
    "credits": "3"
  },
  {
    "course_name": "Human Dimensions of Global Change",
    "dept": "GEOG",
    "num": "460",
    "desc": "Prerequisite: GEOG 121 and either GEOG 100 or 200.\nAn examination of the complexity of forces driving global change, with an emphasis on change related to population growth, technological development, and sociocultural and socioeconomic institutions.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Geography",
    "dept": "GEOG",
    "num": "490",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Capstone Seminar in Geography",
    "dept": "GEOG",
    "num": "495",
    "desc": "Prerequisite: Junior geography majors.\nAn integrative capstone seminar requiring geography majors to synthesize knowledge and skills acquired in prior geography courses. Students pursue independent projects in consultation with a faculty member and present their findings in written and oral reports. The course exposes students to and helps prepare them for a variety of professional and scholarly opportunities available after graduation.",
    "credits": "2"
  },
  {
    "course_name": "Undergraduate Research in Geography",
    "dept": "GEOG",
    "num": "497",
    "desc": "Prerequisite: Consent of instructor.\nIndependent research project conducted with the guidance of a faculty mentor.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Tutorial in Geography",
    "dept": "GEOG",
    "num": "498",
    "desc": "Prerequisite: Sophomore standing, membership in the honors Program of the College of Arts and Sciences, and permission of the instructor.\nIndividual directed research and study of a topic in geography, normally as a preliminary to writing a senior honors thesis.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "GEOG",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Geography of the United States",
    "dept": "GEOG",
    "num": "500",
    "desc": "\nA regional analysis of the United States with special attention to the historical, political, economic, and social factors which contribute to areal differentiation within the area.",
    "credits": "3"
  },
  {
    "course_name": "South Asian Civilizations",
    "dept": "GEOG",
    "num": "505",
    "desc": "Prerequisite: Three hours of social science or junior standing.\nInterdisciplinary survey on the development of civilization in India, Pakistan, Sri Lanka, Bangladesh, Nepal, Bhutan, and Afghanistan, including geography, philosophy, social, economic, political institutions, and historical movements.",
    "credits": "3"
  },
  {
    "course_name": "Geography of South Asia",
    "dept": "GEOG",
    "num": "506",
    "desc": "Prerequisite: Three hours of Social Science or junior standing.\nThis course will provide a survey of the physical and human geography of South Asia. More specifically, it will cover the major environmental, economic, demographic, and cultural geography patterns, processes, and issues of the region. Problems related to religious, ethnic, and linguistic diversity, along with environmental problems associated with global climate change and others will be examined in the context of modernization and economic development.",
    "credits": "3"
  },
  {
    "course_name": "Geographic Information Systems I",
    "dept": "GEOG",
    "num": "508",
    "desc": "Prerequisite: GEOG 302.\nExamination of the major theories, concepts, and operations in geographic information systems (GIS). Topics include: the structure of geographic data models, geographic data acquisition, spatial database management, data processing methods. Vector and raster GIS operations, and general approaches to GIS-based spatial modeling.",
    "credits": "4"
  },
  {
    "course_name": "Geography of the American West",
    "dept": "GEOG",
    "num": "510",
    "desc": "Prerequisite: A previous course in geography and sophomore standing.\nA broad survey of the geography of the American West with a focus on the distinctive human and environmental characteristics of the region. Historical, cultural, ethnic, resource, land use, and physical landscape patterns are examined through lectures, readings, videos, and discussions.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Climatology",
    "dept": "GEOG",
    "num": "535",
    "desc": "\nAn examination of climatology on global, regional, and local scales, with emphasis on the physical processes and environmental factors that influence and control climate. Climatic change and its impact on human activities are explored.",
    "credits": "4"
  },
  {
    "course_name": "Mountain Geography",
    "dept": "GEOG",
    "num": "600",
    "desc": "Prerequisite: A previous course in geography and junior standing.\nA broad survey of the human and physical geography of mountains. The course utilizes lectures, discussion, videos, and photographs to examine the human-environment interactions, cultural symbolism and sacredness, recreation and tourism, and sustainable development of mountain landscapes. The regional focus is primarily on the American West, but other mountains throughout the world will also be studied.",
    "credits": "3"
  },
  {
    "course_name": "Computer Mapping and Geographic Visualization",
    "dept": "GEOG",
    "num": "602",
    "desc": "Prerequisite: GEOG 508.\nBasic cartographic principles, advanced methods for representing spatial data, approaches for exploratory spatial data analysis, and practical applications of thematic maps, animated and Internet-based maps, and geographic visualization techniques. Students will prepare a series of maps and visualization products using modern geographic information system and illustration software.",
    "credits": "3"
  },
  {
    "course_name": "Remote Sensing of the Environment",
    "dept": "GEOG",
    "num": "605",
    "desc": "Prerequisite: One course in physical science and one in biological science.\nRemote sensing and its application to earth study, especially environmental problems and land use. Course employs both readings and the use of imagery.",
    "credits": "3"
  },
  {
    "course_name": "Geographic Information Systems II",
    "dept": "GEOG",
    "num": "608",
    "desc": "Prerequisite: GEOG 302 and 508 (or consent of instructor).\nAdvanced principles of and applications for geographic information systems (GIS). Examines the nature and accuracy of geo-referenced data and methods of data capture, storage, retrieval, modeling, and digital map display. Students will use modern GIS software packages and digital geographic data from physical and/or cultural sources to explore software procedures and techniques of spatial analysis, decision support, and geographic visualization.",
    "credits": "3"
  },
  {
    "course_name": "Geography Internship",
    "dept": "GEOG",
    "num": "610",
    "desc": "Prerequisite: Permission of the instructor and junior standing in geography is required.\nFaculty-supervised field experience, emphasizing the application of geographical topics and/or techniques. Student projects must be approved by both the on-site director and the faculty supervisor, and a report must be submitted at the end of the semester.",
    "credits": "1-18"
  },
  {
    "course_name": "Mexico, Central America, and Caribbean",
    "dept": "GEOG",
    "num": "620",
    "desc": "\nA broad survey of the physical and human geographic patterns of Middle America (Mexico, Central America, and the Caribbean), past and present, with emphasis on the changing landscape features in the successive patterns of human occupancy and globalization.",
    "credits": "3"
  },
  {
    "course_name": "Geography of South America",
    "dept": "GEOG",
    "num": "622",
    "desc": "\nA survey of the physical and human patterns of South America, past and present, with emphasis on the changing landscape features in the successive patterns of human occupancy and globalization.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Engineering Geology and Petrophysics",
    "dept": "GEOG",
    "num": "625",
    "desc": "Prerequisite: MATH 220\nStudents learn basic fundamentals to solve real-world problems in the area of geology and petrophysics. A field trip to an onshore oil rig in Kansas helps consolidating course materials with demands.",
    "credits": "3"
  },
  {
    "course_name": "Geography of East Asia/China",
    "dept": "GEOG",
    "num": "660",
    "desc": "\nAn introduction to the human and physical geography of East Asia, with emphasis on China. Examines this region’s physical, cultural, and socioeconomic patterns and changes, as well as interactions with other parts of the world.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Regional Geography",
    "dept": "GEOG",
    "num": "680",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1-3"
  },
  {
    "course_name": "Historical Geography of the United States",
    "dept": "GEOG",
    "num": "690",
    "desc": "Prerequisite: GEOG 100 and one course in American history.\nInterpretation and analysis of the American landscape and its regions from c. 1500 to c. 1950, with particular emphasis on landscape as both place and history. Also introduces and examines such current research topics as identity, contested places, landscape-as-text, and cultural politics.",
    "credits": "3"
  },
  {
    "course_name": "Quantitative Analysis in Geography",
    "dept": "GEOG",
    "num": "700",
    "desc": "Prerequisite: One course in statistics.\nQuantitative methods employed in modern geographical research. Applications of both statistical and mathematical approaches will be treated. Emphasis will be placed on interpretation and evaluation of techniques employed in spatial analysis.",
    "credits": "3"
  },
  {
    "course_name": "Thematic Remote Sensing",
    "dept": "GEOG",
    "num": "705",
    "desc": "Prerequisite: GEOG 605 or equivalent.\nIntroduction to digital image analysis in remote sensing, with an emphasis on extraction of thematic information from imagery. Emphasizes mastery of both practical classification techniques and the theory behind those techniques. Topics covered include preparing imagery for classification; per-pixel and object-based classification techniques; use of parametric, non-parametric, and machine learning\\A1-based decision rules; and techniques for validating classification accuracy. Classification techniques for hyperspectral imagery will also be covered.",
    "credits": "3"
  },
  {
    "course_name": "Biophysical Remote Sensing",
    "dept": "GEOG",
    "num": "706",
    "desc": "Prerequisite: GEOG 605.\nAn advanced seminar covering methods and models for retrieving quantitative information about the Earth’s surface from remotely sensed data. Topics covered will include inversion techniques for determining surface radiance and reflectance, correction of atmospheric effects, theory of vegetation indices and their use in empirical determination of canopy properties, canopy models and their inversion, and the use of hyperspectral data for retrieval of surface biophysical information.",
    "credits": "3"
  },
  {
    "course_name": "Remote Sensing of Water",
    "dept": "GEOG",
    "num": "707",
    "desc": "Prerequisite: GEOG and GEOG 605 or instructor permission.\nReviews and expands the fundamentals of remote sensing theory, basic surface hydrology and hydraulics, remote sensing methods and instruments, measurements of various hydrologic parameters, and integrated approaches in water resource studies.",
    "credits": "3"
  },
  {
    "course_name": "Geography Field Research Techniques",
    "dept": "GEOG",
    "num": "709",
    "desc": "Prerequisite: Junior standing and at least 6 hours in geography.\nExplores methods and techniques employed in modern field research. Stresses research design, field data acquisition techniques, and data analysis.",
    "credits": "2-3"
  },
  {
    "course_name": "Topics in Remote Sensing",
    "dept": "GEOG",
    "num": "711",
    "desc": "Prerequisite: GEOG 705.\nExamination of a selected remote sensing topic in an area of faculty specialization.",
    "credits": "3"
  },
  {
    "course_name": "Internet GIS and Distributed Geographic Information Services",
    "dept": "GEOG",
    "num": "712",
    "desc": "Prerequisite: GEOG 708.\nIntroduces the development and deployment of Internet maps and GIS-related web services. Students will use virtual globes and Internet map servers to learn the techniques of Internet mapping and development/delivery of geodata and geoprocessing services via the Web.  Studio-style classes will focus on building the necessary skills for creating, as well as the practical applications of, customized GIS map applications and “mashups”, web-based GIS services, and mobile GIS applications.",
    "credits": "3"
  },
  {
    "course_name": "World Population Patterns",
    "dept": "GEOG",
    "num": "715",
    "desc": "Prerequisite: Six hours of social science.\nGeographical processes that govern population distributions, growth rates, and migrations. Emphasis on international comparisons and implications for world society of continued differential growth rates.",
    "credits": "3"
  },
  {
    "course_name": "Geography of Public Lands",
    "dept": "GEOG",
    "num": "718",
    "desc": "Prerequisite: Six hours of social science.\nOverview of public lands systems, including distribution and uses of public lands, with an emphasis on United States federal lands. Historic and recent controversies regarding the public lands will be addressed. Seminar course with discussion and independent research components.",
    "credits": "3"
  },
  {
    "course_name": "Geography of Land Use",
    "dept": "GEOG",
    "num": "720",
    "desc": "Prerequisite: Six hours of social science.\nCritical factors affecting land use, scarcity, and management examined in a regional, national, and global context; land use classification system and variation of land use patterns.",
    "credits": "3"
  },
  {
    "course_name": "International Conservation",
    "dept": "GEOG",
    "num": "722",
    "desc": "Prerequisite: 6 hours of social sciences.\nExamines geographic perspectives of global biodiversity loss and conservation landscapes with an emphasis on the political, economic, and cultural dimensions of conservation around the world.",
    "credits": "3"
  },
  {
    "course_name": "Geography of Water Resources",
    "dept": "GEOG",
    "num": "725",
    "desc": "Prerequisite: Six hours of social science.\nInterpretation and analysis of the physical geography of water and water as a resource. Evaluation of water, emphasizing quality, hazards, institutions, and selected domestic and global issues.",
    "credits": "3"
  },
  {
    "course_name": "Programming for Geographic Analysis",
    "dept": "GEOG",
    "num": "728",
    "desc": "Prerequisite: GEOG 608 is recommended.\nIntroduces programming languages, scripting methods, and/or free and open-source software (FOSS) and their use with geospatial technologies and spatial data. Explanations of programming concepts, demonstrations of techniques, and practical exercises that will enable students to develop their own programs and workflows for geoprocessing, spatial analysis, and map production.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Climatology",
    "dept": "GEOG",
    "num": "735",
    "desc": "Prerequisite: GEOG 535.\nExamination of a selected climatology topic in an area of faculty specialization.",
    "credits": "3"
  },
  {
    "course_name": "Fluvial Geomorphology",
    "dept": "GEOG",
    "num": "740",
    "desc": "Prerequisite: GEOG 221 or permission of instructor.\nThis course is a basic introduction to the field of Fluvial Geomorphology, the study of the forms and processes found within streams and rivers. Topics will include: Review of watershed hydrology and hill slope processes, mechanics of open channel flow, sediment entrainment and transport, channel geometry, longitudinal profile and gradient, effective flows/formative events, channel patters, pool- and river management and restoration.",
    "credits": "3"
  },
  {
    "course_name": "Digital Geomorphology",
    "dept": "GEOG",
    "num": "742",
    "desc": "Prerequisite: Instructor permission. Introductory-level knowledge of Geomorphology, GIS and/or statistics is recommended.\nAn exploration of geomorphic concepts and ‘laws’ describing how landscapes and rivers can be used to understand historic and contemporary issues through raster-GIS and the ArcGIS toolbox.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Biogeography",
    "dept": "GEOG",
    "num": "745",
    "desc": "Prerequisite: GEOG 445 or instructor permission.\nExamination of selected biogeography topics.",
    "credits": "3"
  },
  {
    "course_name": "Soil Mapping",
    "dept": "GEOG",
    "num": "747",
    "desc": "Prerequisite: GEOG 121.\nPresents various approaches to soil mapping including the traditional soil-landscape paradigm, digital soil mapping, and a novel computer modeling. Local field sites will serve to reinforce techniques discussed.",
    "credits": "3"
  },
  {
    "course_name": "Urban Geography",
    "dept": "GEOG",
    "num": "750",
    "desc": "Prerequisite: Six hours of social science or planning.\nA study of geographic principles relating to the distribution, function, and structure of cities: a geographic analysis and classification of urban settlements.",
    "credits": "3"
  },
  {
    "course_name": "Human Impact on the Environment",
    "dept": "GEOG",
    "num": "761",
    "desc": "Prerequisite: Six hours of social science.\nAssessment of human impacts on the natural environment. Surveys changing human impacts on and attitudes towards the environment, and details alteration of water systems, the atmosphere, landforms, plants, and animals.",
    "credits": "3"
  },
  {
    "course_name": "Geography of Natural Hazards",
    "dept": "GEOG",
    "num": "765",
    "desc": "Prerequisite: Nine hours of social science.\nExamines important emergency management issues related to hazard mitigation, preparedness, disaster response, and recovery, including sociocultural and physical components of disaster process. Assesses human vulnerability and risk to environmental calamities, such as droughts, floods, tornadoes, hurricanes, and earthquakes.",
    "credits": "3"
  },
  {
    "course_name": "Perception of the Environment",
    "dept": "GEOG",
    "num": "770",
    "desc": "Prerequisite: Six hours of social science with one course above the introductory level, and 6 hours of natural science with one course above the introductory level.\nAn examination of the way people perceive their geographic environment and the role of perception in spatial behavior. Perceptions of neighborhoods, cities, states, nations, frontier regions, and environmental processes are explored.",
    "credits": "3"
  },
  {
    "course_name": "Cultural Geography",
    "dept": "GEOG",
    "num": "780",
    "desc": "Prerequisite: Six hours of social science.\nA study of the forms of human occupancy of landscapes, with consideration of innovations in the use of landscape, the origins and the dispersals of these innovations, and human attitudes toward the natural environment.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Geography",
    "dept": "GEOG",
    "num": "790",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1-3"
  },
  {
    "course_name": "Topics in Geographic Information Science",
    "dept": "GEOG",
    "num": "795",
    "desc": "Prerequisite: GEOG 302 or consent of instructor.\nSelected geographic information science topic in science topic in an area of faculty specialization.",
    "credits": "1-3"
  },
  {
    "course_name": "Earth in Action",
    "dept": "GEOL",
    "num": "100",
    "desc": "\nThe earth’s physical, structural, and dynamic features; the most common minerals and rocks; processes affecting the earth.",
    "credits": "3"
  },
  {
    "course_name": "Geology Colloquium",
    "dept": "GEOL",
    "num": "101",
    "desc": "\nTopics in earth science chosen to illustrate current research of scientists and methods chosen to study the physical universe. At each offering of this course a syllabus will be available giving the topics to be studied and the details of administration of the course.",
    "credits": "1-3"
  },
  {
    "course_name": "Earth Through Time",
    "dept": "GEOL",
    "num": "102",
    "desc": "Prerequisite: GEOL 100.\nAn introduction to the immensity of geologic time and a review of the history of the earth and the life upon it.",
    "credits": "3"
  },
  {
    "course_name": "Geology Laboratory",
    "dept": "GEOL",
    "num": "103",
    "desc": "Prerequisite or co-requisite:  GEOL 100, GEOL 102, or GEOL 125.\nLaboratory investigation of rocks and minerals; use of geologic and topographic maps; understanding of stream and groundwater processes and landforms.",
    "credits": "1"
  },
  {
    "course_name": "Dynamic Earth Laboratory",
    "dept": "GEOL",
    "num": "104",
    "desc": "\nCovers basic principles and tools of the geosciences and their applications.",
    "credits": "1"
  },
  {
    "course_name": "Oceanography",
    "dept": "GEOL",
    "num": "105",
    "desc": "\nThe oceans: their boundaries, contents, and processes.",
    "credits": "3"
  },
  {
    "course_name": "Introductory Geology Honors",
    "dept": "GEOL",
    "num": "110",
    "desc": "\nSurvey of earth materials, features, and processes. Higher level of sophistication and challenge than GEOL 100.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Geology",
    "dept": "GEOL",
    "num": "115",
    "desc": "\nMajor reservoirs of Earth and the hydrologic cycle; minerals and rocks on the surface and in subsurface environments; minerals and rock-water interactions; compositional variations of waters; surface and ground water pollutions; atmospheric pollutions; waste disposal problems.",
    "credits": "3"
  },
  {
    "course_name": "Age of Dinosaurs",
    "dept": "GEOL",
    "num": "120",
    "desc": "\nReconstructs the world of the dinosaurs, and places it in the context of Earth’s dynamic physical and biological history. The inferred biology and ecology of dinosaur species will be discussed, and the theories concerning their origin, evolution, and extinction will be presented.",
    "credits": "3"
  },
  {
    "course_name": "Natural Disasters",
    "dept": "GEOL",
    "num": "125",
    "desc": "\nDiscussion of geological phenomena such as earthquakes, volcanic eruptions, landslides, and floods, with particular emphasis on their causes, effects, and significance as hazards.",
    "credits": "3"
  },
  {
    "course_name": "Earth Resources",
    "dept": "GEOL",
    "num": "305",
    "desc": "Prerequisite: GEOL 100 or GEOG 121.\nOrigin and geologic settings of energy, water, and mineral resources. Additional emphasis will be placed upon exploration and development.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Geology",
    "dept": "GEOL",
    "num": "310",
    "desc": "Prerequisite: A course in natural science at the 100 level or higher.\nSeminar discussion of subjects of current interest in geology.",
    "credits": "1-3"
  },
  {
    "course_name": "Geology of the National Parks",
    "dept": "GEOL",
    "num": "315",
    "desc": "Prerequisite: GEOL 100 or 105.\nStratigraphy, structure, and geological history that produced the scenery of the national parks and national monuments.",
    "credits": "3"
  },
  {
    "course_name": "Quantitative Methods in Geoscience",
    "dept": "GEOL",
    "num": "360",
    "desc": "Prerequisite: MATH 220\nDesign geological data sampling, investigate whether or not two geological datasets are significantly different, develop regression-based equations among various quantities, analyze data in Excel and MATLAB, and handle large geological datasets.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Geology",
    "dept": "GEOL",
    "num": "399",
    "desc": "\nSelected topics.",
    "credits": "1-3"
  },
  {
    "course_name": "Senior Honors Thesis",
    "dept": "GEOL",
    "num": "499",
    "desc": "\nDirected research and preparation of an honors thesis.",
    "credits": "1-3"
  },
  {
    "course_name": "Independent Study in Geology",
    "dept": "GEOL",
    "num": "501",
    "desc": "Prerequisite: GEOL 300 and junior standing.\nIndependent reading; field or laboratory investigations, or both, of geologic problems.",
    "credits": "1-3"
  },
  {
    "course_name": "Mineralogy",
    "dept": "GEOL",
    "num": "502",
    "desc": "Prerequisite: GEOL 100 and GEOL 103; CHM 110 and CHM 111 or CHM 210.\nCrystallography; physical and chemical properties of minerals; emphasis on mineral identification through laboratory analysis.",
    "credits": "3"
  },
  {
    "course_name": "Petrology",
    "dept": "GEOL",
    "num": "503",
    "desc": "Prerequisite: GEOL 502 and CHM 230.\nInvestigation of physical and chemical processes forming igneous, metamorphic and sedimentary rocks. Mircroscopic examination of rock mineralogy and textures.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Studies",
    "dept": "GEOL",
    "num": "506",
    "desc": "Prerequisite: GEOL 100.\nPhysical and chemical qualities of natural environments and health from a geologic perspective-detection and prediction of environmental changes, identification of sources of pollutants and their movements in soils, rocks, and waters.",
    "credits": "3"
  },
  {
    "course_name": "Geology of Planets",
    "dept": "GEOL",
    "num": "510",
    "desc": "Prerequisite: GEOL 100.\nOrigin, evolution, and surficial geology of the extraterrestrial planets and satellites.",
    "credits": "3"
  },
  {
    "course_name": "Earth Science",
    "dept": "GEOL",
    "num": "512",
    "desc": "Prerequisite: GEOL 100 or GEOG 121 or junior standing.\nA critical study of the atmosphere, weather, climate, composition, and processes of the earth; also, the interaction of these in producing the pattern of landforms and human activity.",
    "credits": "3"
  },
  {
    "course_name": "Geomorphology",
    "dept": "GEOL",
    "num": "520",
    "desc": "Prerequisite: GEOL 100 or GEOG 121.\nClassroom, laboratory, and field studies of landforms and surficial deposits, with an emphasis on earth-surface processes. Classroom lectures and discussions; laboratory exercises; and field investigations.",
    "credits": "3"
  },
  {
    "course_name": "Structural Geology",
    "dept": "GEOL",
    "num": "530",
    "desc": "Prerequisite: GEOL 503.\nMechanics of the earth’s crust; origin and interrelation of structures of the earth.",
    "credits": "3"
  },
  {
    "course_name": "Geologic Record of Climate Change",
    "dept": "GEOL",
    "num": "540",
    "desc": "Prerequisite: GEOL 100 or GEOG 121.\nIntroduction to the major forcing and feedback mechanisms responsible for climate change. Reconstructing past climates using various geologic indicators including climate-sensitive sedimentary facies, paleosols, fossil species distributions, the microfossil record, and stable isotopes.",
    "credits": "3"
  },
  {
    "course_name": "Field Methods",
    "dept": "GEOL",
    "num": "560",
    "desc": "Prerequisite: GEOL 503.\nIntroduction to methods used to collect geologic data in the field. Emphasis is placed on map-reading, rock description, use of aerial photographs, and construction of geologic maps and cross sections.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Paleontology",
    "dept": "GEOL",
    "num": "581",
    "desc": "Prerequisite: GEOL 502 and junior standing.\nAn overview of paleontological principles relating to the application of the fossil record to questions of evolution, paleoecology, paleoenvironment, depositional dynamics, facies analysis, and stratigraphy.",
    "credits": "3"
  },
  {
    "course_name": "Senior Thesis",
    "dept": "GEOL",
    "num": "599",
    "desc": "\nDirected research and preparation of a senior thesis.",
    "credits": "1-3"
  },
  {
    "course_name": "Mineral Exploration",
    "dept": "GEOL",
    "num": "602",
    "desc": "Prerequisite: GEOL 503.\nGeological, geochemical, and geophysical prospecting techniques and their application in the exploration for metallic mineral deposits.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Geochemistry",
    "dept": "GEOL",
    "num": "605",
    "desc": "Prerequisite: CHM 210, CHM 230, GEOL 502.\nIntroduction to the use of inorganic geochemistry in the investigation of geologic processes in the crust, mantle, and surface environment.",
    "credits": "3"
  },
  {
    "course_name": "Hydrogeology",
    "dept": "GEOL",
    "num": "611",
    "desc": "Prerequisite: GEOL 100 or GEOL 115.\nPhysical and chemical principles of the water cycle (evaporation, condensation, precipitation, runoff, stream flow, percolation, and groundwater flow), as well as environmentally relevant applications based on case studies. Extensive coverage of groundwater hydrology, surface water hydrology, soil moisture, contemporary global issues related to water resources, including pollution control, and also hydrogeochemistry will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Volcanology",
    "dept": "GEOL",
    "num": "620",
    "desc": "Prerequisite: GEOL 502.\nExamines processes associated with active volcanoes as revealed by volcanic deposits. Emphasis on influence of volcanoes on human civilizations including economic deposits, climate change, or volcano monitoring.",
    "credits": "2"
  },
  {
    "course_name": "Sedimentology and Stratigraphy",
    "dept": "GEOL",
    "num": "630",
    "desc": "Prerequisite: GEOL 503.\nIdentification of sedimentary rocks and interpretation of sedimentary properties and depositional environments; analysis of spatial and temporal relationships to interpret depositional history and basin evolution.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Geophysics",
    "dept": "GEOL",
    "num": "640",
    "desc": "Prerequisite: MATH 220, PHYS 113, or PHYS 213, or instructor consent.\nIntroduction to geophysics, its uses in studies of the earth’s interior, its utility of illuminating subsurface geological features, and its applications in fields such as groundwater studies and the development of energy resources.",
    "credits": "3"
  },
  {
    "course_name": "Field Geophysics",
    "dept": "GEOL",
    "num": "642",
    "desc": "Prerequisite: GEOL 743.\nAcquisition and computer processing of geophysical data such as those from seismic reflection, seismic refraction, gravity, magnetic and electrical methods.",
    "credits": "3"
  },
  {
    "course_name": "Geomicrobiology",
    "dept": "GEOL",
    "num": "650",
    "desc": "Prerequisite: CHM 210, CHM 230.\nStudy of microorganisms in geological environments. Topics include: geochemical controls on microbial activity and impacts of microbial activity on geological environments.",
    "credits": "3"
  },
  {
    "course_name": "Field Geology",
    "dept": "GEOL",
    "num": "680",
    "desc": "Prerequisite: GEOL 503, 530, and 560.\nField projects in the Rocky Mountains designed to give students practical experience in apply geologic knowledge and skills.",
    "credits": "3"
  },
  {
    "course_name": "Economic Geology",
    "dept": "GEOL",
    "num": "702",
    "desc": "Prerequisite: GEOL 503.\nGeology and origin of metallic mineral deposits and of some nonmetallic deposits.",
    "credits": "3"
  },
  {
    "course_name": "Economic Geology Laboratory",
    "dept": "GEOL",
    "num": "703",
    "desc": "Prerequisite: GEOL 702 or concurrent enrollment.\nLaboratory activities related to metallic and nonmetallic mineral deposits, including detailed studies of selected deposits.",
    "credits": "1"
  },
  {
    "course_name": "Carbonate Paleoenvironments",
    "dept": "GEOL",
    "num": "704",
    "desc": "Prerequisite: GEOL 581 and 630.\nExamination of the biological, physical, and chemical factors in reefs and shallow carbonate platform environments through Earth history, including their modern analogs. Attention will be given to the geometry of carbonate facies, their geographic and temporal distribution, and their sedimentary fabric and porosity.",
    "credits": "3"
  },
  {
    "course_name": "Biomineralization",
    "dept": "GEOL",
    "num": "705",
    "desc": "Prerequisite: GEOL 581 and 605.\nDiscussion and critique of current and classic research in biomineralization.",
    "credits": "3"
  },
  {
    "course_name": "Sedimentary Geochemistry",
    "dept": "GEOL",
    "num": "708",
    "desc": "Prerequisite: GEOL 503 and MATH 220.\nGeochemical principles and processes in deposition and diagenesis of sediments; different chemical pathways in the exogenic cycle.",
    "credits": "3"
  },
  {
    "course_name": "Water Resources Geochemistry",
    "dept": "GEOL",
    "num": "711",
    "desc": "Prerequisite: GEOL 611, GEOL 605 or AGRON 605.\nGeochemistry of ground and surface waters; emphasis on mineralogical, biochemical, and hydrologic controls on inorganic and organic interactions in natural waters.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Geochemistry",
    "dept": "GEOL",
    "num": "712",
    "desc": "Prerequisite: GEOL 503 and CH 500 or 585.\nApplication of chemical principles to igneous, metamorphic systems; emphasis on equilibria, oxidation-reduction, crystal chemistry, and thermodynamics.",
    "credits": "3"
  },
  {
    "course_name": "Rock Microstructures and Geologic Processes",
    "dept": "GEOL",
    "num": "714",
    "desc": "Prerequisite: GEOL 503 and CHM 230.\nExamination of mineral shapes, orientations and assemblages (rock fabric) as a record of geologic processes.",
    "credits": "3"
  },
  {
    "course_name": "Dating Earth Materials",
    "dept": "GEOL",
    "num": "715",
    "desc": "Prerequisite: CHM 230, GEOL 503.\nDiscusses how ages are measured for rocks, minerals, waters, and sediments by analysis of isotopes produced by radioactive decay or cosmic rays.",
    "credits": "3"
  },
  {
    "course_name": "Quaternary Geology",
    "dept": "GEOL",
    "num": "720",
    "desc": "Prerequisite: GEOL 630.\nQuaternary stratigraphy as the framework for studying the geomorphic, climactic, archaeological, and biological changes of the last two million years, with emphasis on the North American record.",
    "credits": "3"
  },
  {
    "course_name": "Petroleum Geology",
    "dept": "GEOL",
    "num": "730",
    "desc": "Prerequisite: GEOL 530 and 630.\nOrigin, migration, and accumulation of petroleum; stratigraphy and structure of important fields.",
    "credits": "3"
  },
  {
    "course_name": "Fossil Fuel Sedimentology",
    "dept": "GEOL",
    "num": "735",
    "desc": "Prerequisite: CHM 230.\nIntroduces geology and geochemistry of fossil fuels.  Provides basic background information on carbon chemistry and its relationship to fossil fuels such as oil, natural gas and coal, as well as geochemical and petrologic (microscopic) characteristics of sedimentary organic matter and the distribution of fossil fuels through geologic time. Case studies of particular fossil fuel reserves are included.",
    "credits": "3"
  },
  {
    "course_name": "Formation Evaluation",
    "dept": "GEOL",
    "num": "738",
    "desc": "Prerequisite: GEOL 730.\nInvestigates projects on well log interpretation, petro-physical calculations, log corrections, and post-drilling decision workflows through lectures, discussions, laboratory exercises, or field trips.",
    "credits": "3"
  },
  {
    "course_name": "Regional Geology",
    "dept": "GEOL",
    "num": "740",
    "desc": "Prerequisite: GEOL 530 and 630.\nInterpretations of structural, stratigraphic, igneous, and tectonic history of selected sites in North America.",
    "credits": "3"
  },
  {
    "course_name": "Seismic Data Processing",
    "dept": "GEOL",
    "num": "741",
    "desc": "Prerequisite: GEOL 640.\nPrinciples of 3D seismic data processing techniques and the application of industrial software package(s) to process raw field seismic reflection data to render it in a form suitable for the seismic interpretation stage. This form of seismic data is utilized in subsurface reservoir characterization.",
    "credits": "3"
  },
  {
    "course_name": "Seismic Data Interpretation",
    "dept": "GEOL",
    "num": "742",
    "desc": "Prerequisite: GEOL 640.\nFundamental interpretation of 3D seismic reflection data as applied to hydrocarbon exploration and development problems. Students will conduct a project interpreting surface 3D seismic reflection data using industrial software package(s) for subsurface reservoir characterization.",
    "credits": "3"
  },
  {
    "course_name": "Exploration Geophysics",
    "dept": "GEOL",
    "num": "745",
    "desc": "Prerequisite: GEOL 743.\nPrinciples and applications of seismic, gravity, magnetic, and other geophysical methods used in energy, mining, and other industries to locate subsurface targets of interest.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Matlab",
    "dept": "GEOL",
    "num": "747",
    "desc": "\nPractical introduction to Matlab designed for students who may have limited experience with data processing. Includes handling data (import/export from other softwares/format), data structure, data processing, data visualization (2D, 3D graphs), designing functions, selection statements, loops, programming, descriptive statistics, plots for exploratory data analysis, fit probability distributions to data, regression analysis.",
    "credits": "3"
  },
  {
    "course_name": "Geologic Evolution of Planet Earth",
    "dept": "GEOL",
    "num": "750",
    "desc": "Prerequisite: Completion of, or concurrent enrollment in, all other courses required for the BS or BA degree in geology (except summer field courses).\nIntegration of the various geologic disciplines into a broad-based understanding of the history and dynamics of the earth. Specific regions, such as the western U.S., will be selected each year for detailed study. Guest lectures will make up a significant part of the course.",
    "credits": "3"
  },
  {
    "course_name": "Geochemical and Biogeochemical Modeling",
    "dept": "GEOL",
    "num": "760",
    "desc": "Prerequisite: CHM 210, CHM 230 (or CHM 220, CHM 250), GEOL 605.\nUse of geochemical modeling to examine geochemical and biogeochemical processes in aqueous environments.",
    "credits": "3"
  },
  {
    "course_name": "Subsurface Methods",
    "dept": "GEOL",
    "num": "770",
    "desc": "Prerequisite: GEOL 530 or concurrent enrollment.\nPrinciples and applications of subsurface geology.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Geology",
    "dept": "GEOL",
    "num": "790",
    "desc": "Prerequisite: Background of courses needed for problem undertaken.\nWork is offered in mineralogy, paleobiology, paleoecology, stratigraphy, structural geology, igneous, metamorphic, and sedimentary petrology, geomorphology, planetary geology, hydrogeology, geochemistry, and isotope geology.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to Gerontology",
    "dept": "GERON",
    "num": "315",
    "desc": "\nMultidisciplinary introduction to the field of aging. Examines social, psychological, developmental, organizational, and economic aspects of aging. Theoretical, methodological, and applied issues of aging related to contemporary American society.",
    "credits": "3"
  },
  {
    "course_name": "Biogerontology",
    "dept": "GERON",
    "num": "400",
    "desc": "\nThe course provides an introduction to the processes involved in physical aging. From theories of aging through the effects of age on systems of the body, including chronic and acute disease, and ending with a focus on health promotion this course will prepare students to better understand their aging clients/patients problems. It will also help students to better cope with their own parents’ and grandparents’ aging as well as their own.",
    "credits": "3"
  },
  {
    "course_name": "Culture Change in Long-Term Care",
    "dept": "GERON",
    "num": "501",
    "desc": "\nThis course will cover the basic characteristics of traditional and culture change nursing home models. Student will learn about the various processes of organizational change, the steps toward change, and potential regulatory, environmental and social barriers to major change. The course will include discussions about the necessity to change the way care is provided in such areas as dining, bathing, family/relationships, and environment.",
    "credits": "1"
  },
  {
    "course_name": "Measuring Change in Long-Term Care",
    "dept": "GERON",
    "num": "502",
    "desc": "\nTopics covered will include process and outcome measures in nursing home change as well as the importance of and the utility of measurement for the advancement of quality of life issues in long-term care. Students will gain an understanding of how regulatory support will be more likely to occur if culture change features can show a cost savings as well as improvements in the quality of life of residents.",
    "credits": "1"
  },
  {
    "course_name": "Creating Home in Long-Term Care",
    "dept": "GERON",
    "num": "503",
    "desc": "\nStudents will gain a better understanding of the interdependent networks within nursing homes, environmental factors in the development of community and culture in a nursing home, learn how fostering resident, family and staff interactions can improve quality of life for all those groups, understand the role of structural redesign and innovation, and consider how environmental change can improve relationships within the larger community.",
    "credits": "1"
  },
  {
    "course_name": "Strengthening Staff in Long-Term Care",
    "dept": "GERON",
    "num": "504",
    "desc": "\nTopics covered will include the development of deeper relational bonds within the nursing home environment, benefits of permanent staffing as a key component of building a relationship centered culture, how these types of changes can benefit and empower staff, and models for bridging cultural divides between long-term care administrators and staff to benefit the residents. A review of the impact of traditional models of managed care that focus on providing food, shelter, and medical attention and factors that hinder purposeful, proactive interactions between residents, families and staff.",
    "credits": "1"
  },
  {
    "course_name": "Dining in Long-Term Care",
    "dept": "GERON",
    "num": "505",
    "desc": "\nStudents will develop an appreciation of the impact dining has on the quality of social, physical and emotional health and quality of life of nursing home residents, become aware of the meanings/customs that residents may associate with the dining experience, recognize the importance of the dining experience in the overall culture of the home and develop an understanding of various institutional dining styles.",
    "credits": "1"
  },
  {
    "course_name": "Activities in Long-Term Care",
    "dept": "GERON",
    "num": "506",
    "desc": "\nA review of common activities in long-term care, their importance in resident care, the importance of meaningful activity and relationships, how the long-term care culture impacts resident individuality/choice, and individualized care plans.",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Gerontology",
    "dept": "GERON",
    "num": "600",
    "desc": "Prerequisite: Completion of 15 hours of course work in gerontology.\nAn interdisciplinary course organized topically, with students presenting papers on aging-related issues that draw upon the students’ previous and concurrent academic experience. Provides supervised independent study and subsequent discussion, allowing students to integrate and order their perceptions about gerontological issues.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Gerontology",
    "dept": "GERON",
    "num": "605",
    "desc": "Prerequisite: Consent of instructor.\nSupervised field experience in an aging-related setting as a practical application of gerontological knowledge and skills.",
    "credits": "1-3"
  },
  {
    "course_name": "Seminar in Long-Term Care Administration",
    "dept": "GERON",
    "num": "610",
    "desc": "\nAdministration principles involved in the planning, organizing, and directing of long-term care agencies. Includes in-depth exposure to federal and state standards and regulations governing long-term care.",
    "credits": "3"
  },
  {
    "course_name": "Long-Term Care Administration Internship",
    "dept": "GERON",
    "num": "615",
    "desc": "Prerequisite: Junior standing, GERON 315, MANGT 420, ACCTG 231, GERON 610, six hours of electives from approved list, GPA of 2.5 or above (3.0 or above in long-term care administration coursework).\nIncludes: (a) field experience in the general administration of long-term care programs and/or facilities; planning, budgeting, program management, and service delivery; (b) exposure to federal and state standards and regulations governing long-term care; and (c); professional leadership development.",
    "credits": "9"
  },
  {
    "course_name": "Problems in Gerontology",
    "dept": "GERON",
    "num": "620",
    "desc": "Prerequisite: Background of courses required for problem undertaken and consent of instructor.\nIndependent study of selected problems.",
    "credits": "1-3"
  },
  {
    "course_name": "Mental Health & Aging",
    "dept": "GERON",
    "num": "630",
    "desc": "Prerequisite: Junior/Senior.\nIntroduction to the issues involved in aging and mental health using a systems framework covering the major emotional and psychiatric problems encountered in old age. Includes discussion of personality disorders, dementia, cognitive problems, substance abuse, suicide and barriers to treatment.",
    "credits": "3"
  },
  {
    "course_name": "Gerontechnology",
    "dept": "GERON",
    "num": "700",
    "desc": "\nAn interdisciplinary approach to the understanding of the biological, environmental, and social spheres where technology and gerontology meet.  Topics include the interrelationship between population dynamics and technological change, technological research and devices that may improve elders’ lives, particular issues for rural communities, and the social and cultural meanings, challenges, and benefits of gerontechnologies.  Particular emphasis will be given to placing both population aging and technological change in a broader social perspective.",
    "credits": "3"
  },
  {
    "course_name": "Sexuality and Aging",
    "dept": "GERON",
    "num": "705",
    "desc": "\nSexuality is one important component of well-being throughout the life span and growing older doesn’t eliminate the need for sexual intimacy. This course will address the infrequently discussed topic of sexuality as it applies to older adulthood. Students will learn about the physiological changes that accompany aging and affect sexuality, as well as the psychological and social impact of barriers to sexual expression, including factors such as Alzheimer’s disease, accessibility, and medications. Sexual diversity, as well as the role of family, government, and technology will also be addressed.",
    "credits": "3"
  },
  {
    "course_name": "Creativity and Aging",
    "dept": "GERON",
    "num": "710",
    "desc": "\nWhat happens to creativity as a person ages?  This unique class will help students to understand developmental and pathological changes in the brain that can lead to changes in creative output over time.  Through hands-on experiences and direct association with older adults, students will grow an appreciation for creativity produced and inspired by older people.  This course is intended to provide experiences that will help the student to create art programs for older adults.",
    "credits": "3"
  },
  {
    "course_name": "Aging Veterans",
    "dept": "GERON",
    "num": "715",
    "desc": "\nIntroduction to the unique issues involved with aging military veterans. Topics include basic military structure, media portrayal of war, personnel issues resulting from American conflicts since WWII, veteran benefits, cultural issues, veteran health issues and navigating a career within the U.S. federal system.",
    "credits": "3"
  },
  {
    "course_name": "Design for Aging in the Modern World",
    "dept": "GERON",
    "num": "720",
    "desc": "\nThis course will explore the dynamic process of aging and the role of the built environment in the, multidimensional as well as multi-spheral spaces of life-course occurring in the family, work, education, leisure as well as other domains and its relationship to the environment from a life-course perspective. The emphasis on aging and the environment will focus on how individuals and groups manage interactions associated with the social and physical settings. The course will develop students’ foundational knowledge in the theories of aging, environment and behavior, and the ecology of the aging process. These theories will be used as the basis to discuss and debate contemporary issues that confront an aging society. Three levels of the environment will be explored: the microenvironment including those products that people of all ages interact with on a daily basis; the meso (or middle) environment that includes residential and work settings that shape our relationships with family, friends, and associates, and lastly at the macro environment of our communities where people are connected to the larger social settings, services and supports that make up our cities and rural settings, both from a national and international perspective. Each of the sections covered will acknowledge how behavior is influenced by the environment and spans the life-cycle.",
    "credits": "3"
  },
  {
    "course_name": "Topics of Gerontology",
    "dept": "GERON",
    "num": "725",
    "desc": "Prerequisite: Consent of instructor.\nReview of recent research and theory related to specialized issues in gerontology or long-term care.",
    "credits": "2-3"
  },
  {
    "course_name": "Adult Development and Aging",
    "dept": "GERON",
    "num": "772",
    "desc": "Prerequisite: Students properly enrolled in the Great Plains IDEA online Masters in Gerontology or online Graduate Certificate in Gerontology.\nThis course explores the biological, psychological, and social factors that are associated with aging. Although the focus is on the later years, information is presented from a life-span developmental framework. Empirical studies are reviewed and their strengths, limitations and implications for normative and optimal functioning are discussed.",
    "credits": "3"
  },
  {
    "course_name": "Physical Health and Nutrition in Aging",
    "dept": "GERON",
    "num": "773",
    "desc": "Prerequisite: Students properly enrolled in the Great Plains IDEA online Masters in Gerontology or online Graduate Certificate in Gerontology.\nThis course identifies the basic physiologic changes during aging and their impacts in health and disease. The focus will be on successful aging with special emphasis on physical activity and nutrition. Practical application to community settings is addressed.",
    "credits": "3"
  },
  {
    "course_name": "Environments and Aging",
    "dept": "GERON",
    "num": "774",
    "desc": "Prerequisite: Graduate level classification, or undergraduate student with instructor permission.\nUsing interdisciplinary perspectives the course will explore the preferences and needs of older adults and the attributes of various physical environments that hinder and facilitate successful adaptation by the aging individual. Students apply this knowledge to the design and management of housing, institutional facilities, neighborhoods, and communities.",
    "credits": "3"
  },
  {
    "course_name": "Perspectives in Gerontology",
    "dept": "GERON",
    "num": "775",
    "desc": "\nExploration of basic concepts in gerontology through current and classic research. Themes and issues include stereotypes and myths of aging, theories of aging, research approaches in aging, and related social issues facing the elderly.",
    "credits": "3"
  },
  {
    "course_name": "Program Evaluation and Research Methods in Gerontology",
    "dept": "GERON",
    "num": "776",
    "desc": "\nOverview of program evaluation, research methods, and grant writing in gerontology. Includes application of quantitative and qualitative methods in professional settings.",
    "credits": "3"
  },
  {
    "course_name": "Public Policy: Economic and Social Impacts on Older Adults",
    "dept": "GERON",
    "num": "777",
    "desc": "\nStudy of policy development and public policy programs associated with aging. Attention is given to the impact of policies on older adults and economic impacts of and for an aging population.",
    "credits": "3"
  },
  {
    "course_name": "Aging and the Family",
    "dept": "GERON",
    "num": "778",
    "desc": "\nInvestigates the issues that relate to family life in the later years from the perspective of older adults, the family and society.",
    "credits": "3"
  },
  {
    "course_name": "Professional Seminar in Gerontology",
    "dept": "GERON",
    "num": "779",
    "desc": "\nStudents apply and integrate knowledge gained in earlier courses and strengthen skills in ethical decisions-making through applications in gerontology-related areas such as advocacy, professionalism, family and workplace issues. Students from a variety of professions bring their unique perspective to bear on topics of common interest.",
    "credits": "3"
  },
  {
    "course_name": "Human Ecology Colloquium",
    "dept": "GNHE",
    "num": "208",
    "desc": "\nSpecial topics for human ecology majors.",
    "credits": "1-18"
  },
  {
    "course_name": "Foundations of Human Ecology",
    "dept": "GNHE",
    "num": "210",
    "desc": "\nHuman ecological theory, disciplines and professions represented in the College of Health and Human Sciences, the history of human ecology and family and consumer sciences, career paths, and contemporary issues in the field. Learning activities include case studies; critical thinking and evaluation; analysis of history, trends and issues; and career planning.",
    "credits": "1"
  },
  {
    "course_name": "Human Needs",
    "dept": "GNHE",
    "num": "310",
    "desc": "Prerequisite: Sophomore standing or consent of instructor.\nExamination of theories of human needs from a human ecological perspective, with emphasis on the impact of human, economic, and material resources. Analysis of developmental, ethical, cultural, and public policy factors that influence need satisfaction.",
    "credits": "3"
  },
  {
    "course_name": "Problems in General Human Ecology",
    "dept": "GNHE",
    "num": "385",
    "desc": "Prerequisite: Consent of instructor.\nIndependent study.",
    "credits": "0-18"
  },
  {
    "course_name": "Seminar in Human Ecology",
    "dept": "GNHE",
    "num": "410",
    "desc": "Prerequisite: GNHE 210 and senior standing.\nTransition from a baccalaureate degree program to career paths in human ecology professions. Topics include analysis based on human ecological theory; analysis of trends and issues in human ecology disciplines and professions; the demography of career paths in human ecology professions, and development of a professional portfolio and web site.",
    "credits": "2"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "GNHE",
    "num": "499",
    "desc": "Prerequisite: Consent of instructor.\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Problems in General Human Ecology",
    "dept": "GNHE",
    "num": "780",
    "desc": "Prerequisite: Consent of the instructor.\nIndividual investigation into work in general human ecology.",
    "credits": "1-18"
  },
  {
    "course_name": "Water and Society: Interdisciplinary Foundation",
    "dept": "GRAD",
    "num": "740",
    "desc": "Prerequisite: Senior or graduate standing.\nInterdisciplinary course focused on the natural and human elements of water resource systems; introduction to traditional disciplinary procedures, theory, and models; cross-disciplinary approaches to understand and quantify dynamic system relationships; case study for integrated problem solving, management and policy.",
    "credits": "3"
  },
  {
    "course_name": "Classical Greek I",
    "dept": "GREEK",
    "num": "101",
    "desc": "\nAn introduction to the grammar, vocabulary, and structure of Attic Greek.",
    "credits": "5"
  },
  {
    "course_name": "Classical Greek II",
    "dept": "GREEK",
    "num": "102",
    "desc": "\nDevelops reading and comprehension skills in the language of classical Athens, with a focus on further developing knowledge of grammar, vocabulary, and reading. Critical reading of texts in the original Greek.",
    "credits": "5"
  },
  {
    "course_name": "Intermediate Greek-Prose",
    "dept": "GREEK",
    "num": "301",
    "desc": "\nThe reading of classical Greek prose at an intermediate level.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Greek-Poetry",
    "dept": "GREEK",
    "num": "302",
    "desc": "\nIntermediate readings in classical Greek poetry. Renewed focus on Greek grammar, style, and vocabulary. Introduces a new dialect of Greek. Critical reading of texts.",
    "credits": "3"
  },
  {
    "course_name": "Orientation for Summer School Program",
    "dept": "GRMN",
    "num": "002",
    "desc": "",
    "credits": "0"
  },
  {
    "course_name": "German I",
    "dept": "GRMN",
    "num": "101",
    "desc": "\nIntroduction to the structure of modern German. Practice of the spoken language with additional experience in the language lab.",
    "credits": "5"
  },
  {
    "course_name": "German II",
    "dept": "GRMN",
    "num": "102",
    "desc": "Prerequisite: GRMN 101 or equivalent.\nContinuation to the introduction of modern German. Practice of the spoken language, additional experience in reading and with a variety of additional media.",
    "credits": "5"
  },
  {
    "course_name": "Elementary German Conversation IIIA",
    "dept": "GRMN",
    "num": "222",
    "desc": "Prerequisite: GRMN 122 or equivalent.\nPractice in beginning conversational German and review of grammar.",
    "credits": "2"
  },
  {
    "course_name": "German III",
    "dept": "GRMN",
    "num": "300",
    "desc": "Prerequisite: GRMN 102 or equivalent.\nConclusion of the introduction to modern German. Continued practice of the spoken language, reading, and additional experience with a range of audio and visual media.",
    "credits": "5"
  },
  {
    "course_name": "German IV",
    "dept": "GRMN",
    "num": "301",
    "desc": "Prerequisite: GRMN 221 or equivalent.\nReview of select points of German language structure accompanied by practice in conversation, speaking, reading, and writing, as well as additional experience with audio and visual media.",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Studies in German",
    "dept": "GRMN",
    "num": "398",
    "desc": "\nOffered only to participants in study abroad programs.",
    "credits": "1-18"
  },
  {
    "course_name": "German Literature in Translation",
    "dept": "GRMN",
    "num": "503",
    "desc": "\nSelected readings in English from such major German authors as Mann, Brecht, Hesse, Grass, and Kafka.",
    "credits": "3"
  },
  {
    "course_name": "German Film",
    "dept": "GRMN",
    "num": "510",
    "desc": "\nIn English. Addresses various topics within a German historical-cultural context. Students will consider what makes cinema a distinct form of artistic expression.",
    "credits": "3"
  },
  {
    "course_name": "Topics in German Cultural Studies",
    "dept": "GRMN",
    "num": "515",
    "desc": "\nIn English. Specific course content will vary by semester and instructor.",
    "credits": "3"
  },
  {
    "course_name": "Readings in German",
    "dept": "GRMN",
    "num": "520",
    "desc": "Prerequisite: GRMN 223 or equivalent.\nPractice in reading a variety of literary, journalistic, and specialized texts.",
    "credits": "3"
  },
  {
    "course_name": "Introductory Topics in German Literature and Culture of the 18th and 19th century",
    "dept": "GRMN",
    "num": "521",
    "desc": "\nTopics courses constitute a sequence of introductory period studies covering the chronological range of German literature from about 1750 to the present. Within these historical periods, the specific course contents will vary by semester and instructor.",
    "credits": "3"
  },
  {
    "course_name": "Introductory Topics in German Literature and Culture of the 20th and 21st century",
    "dept": "GRMN",
    "num": "522",
    "desc": "\nTopics courses constitute a sequence of introductory period studies covering the chronological range of German literature from about 1750 to the present. Within these historical periods, the specific course contents will vary by semester and instructor.",
    "credits": "3"
  },
  {
    "course_name": "German Composition",
    "dept": "GRMN",
    "num": "523",
    "desc": "Prerequisite: GRMN 223 or equivalent.\nCourse emphasizes writing and includes select grammar review.",
    "credits": "3"
  },
  {
    "course_name": "German for Reading Knowledge I",
    "dept": "GRMN",
    "num": "524",
    "desc": "\nThe grammar and syntax of German and the reading of basic material selected from modern German texts. (This course is designed for students who need to be able to read German.)",
    "credits": "3"
  },
  {
    "course_name": "German for Reading Knowledge II",
    "dept": "GRMN",
    "num": "525",
    "desc": "\nContinued reading of material from modern German texts. (This course is designed for students who need to be able to read German.).",
    "credits": "3"
  },
  {
    "course_name": "Business German",
    "dept": "GRMN",
    "num": "526",
    "desc": "Prerequisite: GRMN 223 or equivalent.\nAdvanced grammar necessary for adequate oral and written expression in international business and diplomatic situations, including specialized terminology, conversation and discussion and translation. Cultural aspects of business are also considered.",
    "credits": "3"
  },
  {
    "course_name": "Advanced German Conversation",
    "dept": "GRMN",
    "num": "527",
    "desc": "Prerequisite: GRMN 223 or equivalent.\nCourse emphasizes proficiency in oral expression and includes select grammar review. Course not open to students whose competency has been demonstrated in the language at this level.",
    "credits": "3"
  },
  {
    "course_name": "Introductory Topics in German Language and Linguistics",
    "dept": "GRMN",
    "num": "528",
    "desc": "Prerequisite: GRMN 301.\nIntroduction to topics in German Linguistics, with special emphasis on the connection between language structure and use or language structures and learning.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in German",
    "dept": "GRMN",
    "num": "529",
    "desc": "Prerequisite: Consent of department head and instructor involved.",
    "credits": "1-18"
  },
  {
    "course_name": "German Cultural Studies and History",
    "dept": "GRMN",
    "num": "530",
    "desc": "Prerequisite: One prior or concurrent 500-level German language class or equivalent.\nThis course addresses cultural and historical topics not confined to a single period. Specific course content will vary by semester and instructor. It may emphasize cross-national subjects, the development of a theme or discourse over time, new perspectives from social, intellectual, or cultural studies, or non-traditional texts and topics.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Medieval German Literature and Culture",
    "dept": "GRMN",
    "num": "700",
    "desc": "Prerequisite: One prior 500-level German literature course.\nTopics courses are designed for undergraduates and graduate students. These courses constitute a sequence of period studies covering the chronological ranges of German speaking literature and culture. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the period.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Eighteenth Century German Literature and Culture",
    "dept": "GRMN",
    "num": "701",
    "desc": "Prerequisite: One prior 500-level German literature course.\nTopics courses are designed for undergraduates and graduate students. These courses constitute a sequence of period studies covering the chronological ranges of German speaking literature and culture. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the period.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Nineteenth Century German Literature and Culture",
    "dept": "GRMN",
    "num": "702",
    "desc": "Prerequisite: One prior 500-level German literature course.\nTopics courses are designed for undergraduates and graduate students. These courses constitute a sequence of period studies covering the chronological ranges of German speaking literature and culture. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the period.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Early Twentieth Century German Literature and Culture",
    "dept": "GRMN",
    "num": "703",
    "desc": "Prerequisite: One prior 500-level German literature course.\nTopics courses are designed for undergraduates and graduate students. These courses constitute a sequence of period studies covering the chronological ranges of German speaking literature and culture. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the period.",
    "credits": "3"
  },
  {
    "course_name": "Topics in German Literature and Culture since 1945",
    "dept": "GRMN",
    "num": "704",
    "desc": "Prerequisite: One prior 500-level German literature course.\nTopics courses are designed for undergraduates and graduate students. These courses constitute a sequence of period studies covering the chronological ranges of German speaking literature and culture. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the period.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Twentieth and Twenty-First Century German Literature and Culture",
    "dept": "GRMN",
    "num": "705",
    "desc": "Prerequisite: One prior 500-level German literature course.\nTopics courses are designed for undergraduates and graduate students. These courses constitute a sequence of period studies covering the chronological ranges of German speaking literature and culture. Within these historical periods, the specific course contents will vary by semester and instructor. They may emphasize literary figures and movements, historical and cultural contexts, or different genres and forms within the period.",
    "credits": "3"
  },
  {
    "course_name": "Open Topics Seminar in German Language and Linguistics",
    "dept": "GRMN",
    "num": "720",
    "desc": "Prerequisite: At least one GRMN 500-level course preferably GRMN 528.\nAddresses topics in German Linguistics. It may emphasize a specific area of linguistics, a specific research approach, or the connection between language and society.",
    "credits": "3"
  },
  {
    "course_name": "History of the German Language",
    "dept": "GRMN",
    "num": "728",
    "desc": "\nA study of the development of the sounds, forms and syntax of standard German.",
    "credits": "3"
  },
  {
    "course_name": "Open Topics Seminar in German Literature and Culture",
    "dept": "GRMN",
    "num": "729",
    "desc": "Prerequisite: One prior 500-level German literature course.\nOpen Topics courses are designed for undergraduates and graduate students. Course addresses topics not confined to a single period in a national literature. Specific course content will vary by semester and instructor. It my emphasize cross-national subjects, literary or cultural criticism or theory, works of one or a pair of related authors, the development of a theme or genre over time, new perspectives from social, intellectual, or cultural studies, or non-traditional texts and topics.",
    "credits": "3"
  },
  {
    "course_name": "Advanced German: Speaking and Writing",
    "dept": "GRMN",
    "num": "731",
    "desc": "Prerequisite: GRMN 523 and GRMN 527 or equivalent.\nCourse combines practice in speaking, writing, and reading, and select advanced grammar review.",
    "credits": "3"
  },
  {
    "course_name": "German Culture and Literature in Second-Language Learning",
    "dept": "GRMN",
    "num": "740",
    "desc": "Prerequisite: One prior 500-level German course.\nAnalysis and interpretation of cultural and literary text from German-speaking countries, with emphasis on the development of interpretive skills and materials, and their application to the German curriculum at all levels.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Modern Languages",
    "dept": "GRMN",
    "num": "799",
    "desc": "",
    "credits": "1-18"
  },
  {
    "course_name": "Foundations in Grain Science and Industry",
    "dept": "GRSC",
    "num": "100",
    "desc": "Prerequisite: Required of all freshmen in Grain Science &amp; Industry.\nAn introduction to grain science &amp; industry; general freshman orientation; policies; student organizations; study skills and time management; departmental degree programs, and careers.",
    "credits": "2"
  },
  {
    "course_name": "Fundamentals of Grain Processing",
    "dept": "GRSC",
    "num": "101",
    "desc": "\nThis is an introductory course to grains and their processing/utilization in food and non-food products.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Milling",
    "dept": "GRSC",
    "num": "150",
    "desc": "\nIntroduction to grain and feed milling processes.",
    "credits": "2"
  },
  {
    "course_name": "Principles of Milling Laboratory",
    "dept": "GRSC",
    "num": "151",
    "desc": "Prerequisite: GRSC 150 or concurrent enrollment.  BSM, FSM and MSM majors have to take GRSC 150 and GRSC 151 concurrently.\nA laboratory course to accompany Principles of Milling (GRSC 150). Laboratory exercises in grain and feed milling processes.",
    "credits": "1"
  },
  {
    "course_name": "Fundamental Baking Calculations",
    "dept": "GRSC",
    "num": "201",
    "desc": "Prerequisite: This class has no prerequisites, and can be taken by an incoming freshman.\nThe course is designed to provide students with an understanding of the type of mathematical calculations used in the baking industry. It will cover ratio and proportion, true percent, baker’s percent, how to convert a straight dough to a sponge and dough, proper water temperature calculations, specific gravity as it applies to cake making, density, specific volume as it applies to bread making, flour blending calculations in order to achieve a specific flour protein content, flour calculations for proper baking performance and purchasing, major ingredient substitutions, pie filling calculations, parts per million calculations, and baking powder neutralization values.",
    "credits": "1"
  },
  {
    "course_name": "CAD Flow Sheets for Grain Processes",
    "dept": "GRSC",
    "num": "210",
    "desc": "Prerequisite: GRSC 150 or consent of instructor.\nThe course is designed to teach students the basic concepts of professional 2D drawing designs and drafting using AutoCAD. By the end of the semester, the students will be able to use AutoCAD for preparing process flow drawings and interpret a grain processing flow.",
    "credits": "3"
  },
  {
    "course_name": "Materials Handling",
    "dept": "GRSC",
    "num": "310",
    "desc": "Prerequisite: GRSC 150 and GRSC 210.\nThe course is designed to introduce students to how materials including grains, ingredients, mixes and finished products are physically moved and handled in the receiving, storage, formulation, production and shipping of grain related products.",
    "credits": "2"
  },
  {
    "course_name": "Grain Analysis Techniques",
    "dept": "GRSC",
    "num": "405",
    "desc": "\nPrinciples and instrumentation available for testing cereal and other grains and their food and feed products.",
    "credits": "2"
  },
  {
    "course_name": "Faculty-Led Study Abroad",
    "dept": "GRSC",
    "num": "491",
    "desc": "Prerequisite: Consent of instructor for undergraduates, consent of major professor for graduate students\nSeminar and travel course designed to prepare students before the experience and for students to analyze, critique, and report their experiences of an international experience associated with study tours or short courses.",
    "credits": "1-3"
  },
  {
    "course_name": "Undergraduate Research in Grain Science",
    "dept": "GRSC",
    "num": "499",
    "desc": "Prerequisites: Sophomore, junior or senior standing in BSM, FSM, or MSM; minimum GPA of 2.5/4.00.\nThis course is an opportunity to earn college credit while conducting an independent research project. The overall objective of the course is to introduce students to scientific research methods and procedures in grain science and related areas through hands-on experience and individual mentoring.  Students will learn how to design, conduct, analyze, and present scientific research.",
    "credits": "0-3"
  },
  {
    "course_name": "Milling Science I",
    "dept": "GRSC",
    "num": "500",
    "desc": "Prerequisite: GRSC 150 and GRSC 210, or consent of instructor.\nPrinciples and practices of wheat flour milling with full-scale equipment including grain storage, blending, cleaning, conditioning plant, and a modern pneumatic flour mill, with instrumentation and automation, etc.",
    "credits": "2"
  },
  {
    "course_name": "Milling Science I Laboratory",
    "dept": "GRSC",
    "num": "501",
    "desc": "Prerequisite: GRSC 500 or concurrent enrollment.\nA laboratory course to accompany Milling Science I (GRSC 500). Laboratory exercises in wheat flour milling with full-scale equipment including grain storage, blending, cleaning, conditioning plant, and a modern pneumatic flour mill, with instrumentation and automation.",
    "credits": "2"
  },
  {
    "course_name": "Milling Science II",
    "dept": "GRSC",
    "num": "502",
    "desc": "Prerequisite: GRSC 210 and 500 and 501, or consent of instructor.\nAdvanced study of the entire gradual reduction system of wheat flour milling and the many unit process systems that constitute the milling system. The theory and practice of mill control are studied in detail. Processing of other cereal grains and oil seeds are covered as well as general mill management.",
    "credits": "2"
  },
  {
    "course_name": "Milling Science II Laboratory",
    "dept": "GRSC",
    "num": "503",
    "desc": "Prerequisite: GRSC 502 or concurrent enrollment or consent of instructor.\nThe processes for milling other grains such as corn, oats, sorghum, different classes of wheat, and rye are studied in the laboratory and by practice on small scale milling units. Concepts of material handling properties of grain products and material handling equipment in dry milling operations will be presented. Concepts of statistical process control and spread sheet modeling in the decision making process will be introduced.",
    "credits": "2"
  },
  {
    "course_name": "Feed Technology I",
    "dept": "GRSC",
    "num": "510",
    "desc": "Prerequisite: ASI 318 and GRSC 210, or consent of instructor.\nIntroduction to formula feed manufacturing, including principles of conveying, grinding, mixing, pelleting, and other processing techniques, the formulation of concentrates, premixes, and rations.",
    "credits": "3"
  },
  {
    "course_name": "Management Applications in the Grain Processing Industries",
    "dept": "GRSC",
    "num": "530",
    "desc": "Prerequisites: Senior standing, GRSC 502 or GRSC 612 or GRSC 637.\nThis course deals with management principles, leadership concepts and their application to the grain, fed and food industries. This capstone experience uses business scenarios, team projects and knowledge management to expand student’s ability to solve problems, impact key business challenges and manage complex issues. Special emphasis is placed on organization dynamics, people management, key business metrics, common operational problems and ethics in business.",
    "credits": "3"
  },
  {
    "course_name": "Process Calculations in Food Systems",
    "dept": "GRSC",
    "num": "540",
    "desc": "Prerequisite: MATH 205 or 220. Recommended prerequisite: PHYS 113 or 115, CHM 210.\nApplication of grain/food industry analytical processing concepts including mass and energy balances, fluid flow, heat transfer, dehydration, evaporation.",
    "credits": "3"
  },
  {
    "course_name": "Process Calculations in Food Systems Laboratory",
    "dept": "GRSC",
    "num": "541",
    "desc": "Prerequisite: GRSC 540 or concurrent enrollment.\nVirtual laboratory experiments supplementing GRSC 540-Process Calculations in Food Systems. Simulations will be used to conduct wide range of virtual experiments representing major food processes.",
    "credits": "1"
  },
  {
    "course_name": "Grain Drying, Storage, Aeration and Pest Management",
    "dept": "GRSC",
    "num": "545",
    "desc": "\nIntroduction to the scientific principles and engineering practices required for the successful management of post-harvest quality grains.",
    "credits": "3"
  },
  {
    "course_name": "Cereal Food Plant Design",
    "dept": "GRSC",
    "num": "555",
    "desc": "Prerequisite: Junior standing and GRSC 500.\nThis course deals with principles of modern flour mill design, feasibility and equipment selection for plant improvements and new plant construction. It covers the steps of developing adequate process flow diagrams based on the specific production needs, constraints and preferences. Emphasis is placed on the effects of design on plant operating efficiency, finished product quality, and construction costs.",
    "credits": "3"
  },
  {
    "course_name": "Pneumatic Conveying of Dry Solids",
    "dept": "GRSC",
    "num": "556",
    "desc": "Prerequisite: Junior standing, GRSC 310, GRSC 500 and 501, PHYS 113 or 213, MATH 205, or consent of instructor.\nThe course is designed to introduce students to a comprehensive knowledge of the design, operation and capabilities of pneumatic conveying systems for transportation of dry, powdered and granular materials. The student will study the components of pneumatic conveying systems, the requirements for designing efficient and reliable pneumatic conveying systems, and troubleshooting existing systems.",
    "credits": "2"
  },
  {
    "course_name": "Electricity and Industrial Power Distribution",
    "dept": "GRSC",
    "num": "560",
    "desc": "Prerequisite: GRSC 500 or GRSC 510 or GRSC 635 or consent of instructor.\nMajor emphasis will be given to application of electricity to machinery for grain processing and electrical code.",
    "credits": "3"
  },
  {
    "course_name": "Qualities of Feed Ingredients and Laboratory",
    "dept": "GRSC",
    "num": "561",
    "desc": "Prerequisite: CHM 230, ASI 318, and concurrent enrollment in GRSC 510.\nThe course provides an integrated overview of the physical, biological, chemical characteristics of common feed ingredients. Quality control and evaluation of ingredients and complete feed is emphasized to ensure the productions of safe feed/safe food.",
    "credits": "4"
  },
  {
    "course_name": "Milling of Grains",
    "dept": "GRSC",
    "num": "580",
    "desc": "Prerequisite: GRSC 502, or consent of instructor.\nThis is a problem based learning course which aims to increase students’ knowledge of flour milling and specialty grain milling. During the semester students develop critical thinking and problem-solving skills needed to troubleshoot real-life issues related to processing, quality assurance, HSE (Health, Safety, and Environment), and finished product quality. Students are expected to analyze their problems and develop the skills needed to effectively communicate their findings during group presentations.",
    "credits": "2"
  },
  {
    "course_name": "Milling Processing Technology Management",
    "dept": "GRSC",
    "num": "584",
    "desc": "Prerequisite: GRSC 502 or consent of instructor.\nA capstone course for milling science and management students. The objective is to familiarize students with the latest technology utilized in cereal milling systems; the investment/business principles utilized in evaluating new milling technologies; mill management/leadership development and the food/employee safety requirements in the industry.",
    "credits": "3"
  },
  {
    "course_name": "Grain Science Problems",
    "dept": "GRSC",
    "num": "590",
    "desc": "Prerequisite: Instructor permission.\nStudy in an area pertinent to grain processing and utilization.",
    "credits": "1-3"
  },
  {
    "course_name": "Internship in Grain Science",
    "dept": "GRSC",
    "num": "591",
    "desc": "\nA practical application of feed and food manufacturing technology during an eight-week summer internship with an active commercial feed and food manufacturing company. The course will stress applied aspects of commercial feed and food manufacturing, which can include, but not be limited to, plant operations, maintenance, personnel and labor relations, business management, warehousing, ingredient procurement, quality assurance, and fleet management.",
    "credits": "1"
  },
  {
    "course_name": "Extended Internship in Grain Science",
    "dept": "GRSC",
    "num": "592",
    "desc": "\nIn-depth work-study experiences for up to 6 months on commercial feed and food manufacturing, which can include, but not limited to, plant operations, maintenance, personnel and labor relations, business management, warehousing, ingredient procurement, quality assurance, and fleet management.",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Bakery Technology I",
    "dept": "GRSC",
    "num": "600",
    "desc": "Prerequisite: Upper-class bakery science and management majors or permission of the instructor.\nLectures and hands-on laboratory experience with commercial production scale baking equipment for breads and rolls, cookies and crackers, and cakes and sweet doughs.",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Bakery Technology II",
    "dept": "GRSC",
    "num": "601",
    "desc": "Prerequisite: Upper-class bakery science and management majors or permission of the instructor. Recommended prerequisite: GRSC 635 and 636.\nLectures and hands-on laboratory experience with commercial production scale baking equipment for breads and rolls, cookies and crackers, and cakes and sweet doughs.",
    "credits": "1"
  },
  {
    "course_name": "Cereal Science",
    "dept": "GRSC",
    "num": "602",
    "desc": "Prerequisite: BIOCH 265 or CHM 350 and CHM 351.\nThe characteristics of cereals, legumes, their components and their processing to foods.",
    "credits": "3"
  },
  {
    "course_name": "Feed Technology II and Laboratory",
    "dept": "GRSC",
    "num": "612",
    "desc": "Prerequisite: GRSC 510 or GRSC 500, and STAT 325, or consent of instructor.\nAdvanced study of engineering principles applicable to flour and feed plant operations, equipment selection, and processing systems.",
    "credits": "4"
  },
  {
    "course_name": "Animal Food Safety",
    "dept": "GRSC",
    "num": "615",
    "desc": "\nAn introduction to the animal food safety regulations in the Food Safety Modernization Act.",
    "credits": "2"
  },
  {
    "course_name": "Extrusion Processing in the Food and Feed Industries",
    "dept": "GRSC",
    "num": "620",
    "desc": "\nThe course is designed to provide the student with an understanding of extrusion technology and the ability to apply it to product development and production through a “hands-on” approach. Major emphasis is on laboratory exercises in which students will operate pilot scale extrusion equipment to produce readily-recognizable commercial products such as cheese curls, breakfast cereals, pasta, pet food, etc.  Emphasis will also be placed on process and product development, analysis, and problem solving techniques.",
    "credits": "4"
  },
  {
    "course_name": "Flour and Dough Testing",
    "dept": "GRSC",
    "num": "625",
    "desc": "\nPhysical and chemical methods used in evaluating wheat flour and doughs.",
    "credits": "2"
  },
  {
    "course_name": "Baking Science I",
    "dept": "GRSC",
    "num": "635",
    "desc": "Prerequisite: BIOCH 265 or CHM 350 and 351.\nIntroduction to chemical and physical properties of flour and other principal ingredients used in production of yeast-leavened bakery foods. Study of major processing methods for making yeasted doughs such as breads, sweet goods, frozen dough, and partially baked goods. Examination of ingredient specifications role of quality control, keeping properties of bread products, and nutritional attributes of various types of breads.",
    "credits": "2"
  },
  {
    "course_name": "Baking Science I Laboratory",
    "dept": "GRSC",
    "num": "636",
    "desc": "\nA laboratory course to accompany Baking Science I (GRSC 635).  Laboratory exercises in theory and production of yeast-leavened baked products.",
    "credits": "2"
  },
  {
    "course_name": "Baking Science II",
    "dept": "GRSC",
    "num": "637",
    "desc": "\nCourse includes study of physical, chemical, and functional properties of ingredients and processes used in production of bakery products, including cakes, cookies, doughnuts, breads and related products. Shelf-life control and packaging of baked products is also discussed. Total quality programs, specification programs and management of distribution and purchasing systems will also be included in lectures.",
    "credits": "3"
  },
  {
    "course_name": "Baking Science II Laboratory",
    "dept": "GRSC",
    "num": "638",
    "desc": "\nA laboratory course to accompany Baking Science II (GRSC 637). Exercises and experiments in production of chemically-leavened and yeast-leavened bakery foods including various cakes, cookies, doughnuts, bagels, icings, and fillings.",
    "credits": "1"
  },
  {
    "course_name": "Pet Food Processing",
    "dept": "GRSC",
    "num": "645",
    "desc": "\nThe course is designed to provide students with an understanding of pet foods, including food products meant for dogs, cats, pet rodents, pet snakes, ornamental fish, exotic and captive wild animals, and the various processing technologies that are deployed for their production. Extrusion, baking, canning, and injection molding technologies will be covered. Other important aspects of pet food production, such as ingredient handling and compounding, quality control, HACCP and sanitation, and packaging will also be discussed. A concurrent laboratory section will allow students to produce pet foods, visit pet food production facilities, and personally explore selected topics in depth.",
    "credits": "4"
  },
  {
    "course_name": "Food and Feed Product Protection",
    "dept": "GRSC",
    "num": "651",
    "desc": "Prerequisite: Junior standing.\nSanitation in relation to processing, handling, and storage of human and animal foods. Emphasis on contaminants, control of causative agents, equipment and plant design, applicable laws and regulations.",
    "credits": "4"
  },
  {
    "course_name": "Feed Mill Plant Design",
    "dept": "GRSC",
    "num": "655",
    "desc": "Prerequisite: Junior standing and GRSC 510.\nThis course deals with principles of modern design, feasibility, and equipment selection for new feed mills. Emphasis is placed on the effects of logistics, ingredient availability, operating efficiency, and finished product quality.",
    "credits": "2"
  },
  {
    "course_name": "Bakery Layout",
    "dept": "GRSC",
    "num": "670",
    "desc": "Prerequisite: MATH 100, PHYS 113, GRSC 210, and GRSC 636.\nThe layouts of facilities to produce baked goods are studied. Students prepare their own bakery layout. Current problems in a bakery production setting in the baking industry are discussed.",
    "credits": "1"
  },
  {
    "course_name": "Vibrational Spectroscopic Analysis and Chemometrics",
    "dept": "GRSC",
    "num": "712",
    "desc": "\nInfrared and particularly modern near-infrared spectroscopic analysis of foods, natural products, and synthetic substances is accomplished with direct sampling and the use of multivariate statistics. This course is intended to enable the student to understand the principles and successfully apply this technology to practical analytical problems with emphasis upon food. Method development will be taught using specific analytes in selected products. Theoretical background, working of modern instrumentation and associated software is presented in support of achieving practical competence.",
    "credits": "1-2"
  },
  {
    "course_name": "Contemporary Chromatographic Analysis of Food",
    "dept": "GRSC",
    "num": "713",
    "desc": "\nHigh performance liquid chromatography (HPLC) is the primary focus of this course. This will be supported by including treatment of topics in contemporary gas chromatography and supercritical fluid chromatography and extraction. Optimizing chromatographic conditions through knowledge of the column chemistry will be covered in addition to detector options, instrumentation, and sample preparation.",
    "credits": "1"
  },
  {
    "course_name": "Biomaterials Processing",
    "dept": "GRSC",
    "num": "740",
    "desc": "Prerequisite: BAE 575 or GRSC 602.\nThis course is designed for students who are interested in plant biomaterials processing. This course will teach technologies of biobased materials processing including starch extraction (wet milling), plant oil extraction and refining, plant protein extraction and processing, cellulose processing, biofuel production, chemicals bioconversion, and drying technologies of biomaterials.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Bioprocessing",
    "dept": "GRSC",
    "num": "745",
    "desc": "\nThis course is designed for students who desire a clear understanding of bioprocessing principles as applied to the emerging bio-based industry. This course covers the fundamentals of mass and energy balances, fluid dynamics, heat and mass transfer, as applied to bioprocessing. The microbial growth, kinetics and fermenter operation will be covered in detail. Fundamentals of downstream operation as applicable to bioprocessing will be covered in this course. Industrial bioprocessing case studies that involve the integration of the course contents will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Pet Food Formulation for Commercial Production",
    "dept": "GRSC",
    "num": "750",
    "desc": "\nStudents completing this course will become proficient at formulating pet foods and have a working knowledge of ingredients, processes, and the software necessary to create new products, revise existing formulas, and perform business and production analyses.",
    "credits": "1"
  },
  {
    "course_name": "Particle Technology for Solids Handling and Processing",
    "dept": "GRSC",
    "num": "780",
    "desc": "Prerequisite: Graduate student status, MATH 220, STAT 325, PHYS 213 or consent of instructor.\nThis course is designed to provide students an overview of particle technology with an emphasis on practical applications in milling and grain based operations. Conveying, storage, size reduction and separation are the important unit operations of grain processing (food, feed, chemical, pharmaceutical) industries that involve particle sizes ranging from a fraction of a micron to a few millimeters. The particle characteristics as they relate to processing operations such as milling, sieving, mixing, pelleting, etc. will be covered in the course. Subjects include size and shape characterizations, size distribution and measurement, characteristic dimensions, density, and their theories governing the behavior of the particles under different conditions.",
    "credits": "3"
  },
  {
    "course_name": "Grain Science Problem",
    "dept": "GRSC",
    "num": "790",
    "desc": "Prerequisite: Consent of department head.\nGraduate study in an area pertinent to grain processing and utilization.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to Gender, Women, and Sexuality Studies",
    "dept": "GWSS",
    "num": "105",
    "desc": "\nAn interdisciplinary analysis of personal experiences and social and political institutions as they shape and are shaped by the intersections of gender, race, class, sex, sexuality, ethnicity, nation, citizenship, and ability on local, national, and global levels. Topics include the roles of biology and social construction in shaping gender and sexuality, sources of structural inequities; and feminist, queer, trans, anti-racist, and anti-colonial activisms.",
    "credits": "3"
  },
  {
    "course_name": "Gender and Sex in Science Fiction",
    "dept": "GWSS",
    "num": "275",
    "desc": "\nExamines various forms of U.S. science fiction, including short stories, films, and television and how these forms imagine gender (identities, roles, expectations) and sex (identity and acts). Using a feminist lens, students will gain an understanding of how power is understood, questioned, negotiated and/or reinforced in these sci-fi depictions.",
    "credits": "3"
  },
  {
    "course_name": "Selected Studies of Gender, Women, and Sexuality Studies",
    "dept": "GWSS",
    "num": "300",
    "desc": "\nSpecific course content will vary by semester and instructor.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Fundamentals of Gender, Women, and Sexuality Studies",
    "dept": "GWSS",
    "num": "305",
    "desc": "\nAn advanced examination of the origins of the Gender, Women, and Sexuality Studies field, provides core concepts and research methodologies.",
    "credits": "3"
  },
  {
    "course_name": "Queer Studies: Concepts, History, and Politics",
    "dept": "GWSS",
    "num": "325",
    "desc": "\nExamines the origins of Queer Studies and introduces core concepts, foundational histories, and critical frameworks that will prepare students for further study.",
    "credits": "3"
  },
  {
    "course_name": "Transgender Studies",
    "dept": "GWSS",
    "num": "335",
    "desc": "\nExplores the history of and current debates in the field of transgender studies. Examines the roles of race, class, nation, colonialism, and (dis)ability in understanding transgender identities and politics.",
    "credits": "3"
  },
  {
    "course_name": "Gender in American Film",
    "dept": "GWSS",
    "num": "350",
    "desc": "\nThis course examines depictions of gender, race/ethnicity, class, and sexuality in American film. It focuses on the way in which images in mainstream Hollywood films reinforce, normalize and/or question power, power relations, and stereotypes.",
    "credits": "3"
  },
  {
    "course_name": "Women and Global Social Change",
    "dept": "GWSS",
    "num": "380",
    "desc": "Prerequisite: ENGL 100 or 110.\nThis course explores contemporary approaches that help meet the needs of women and their families in different parts of the world, including the Plains region. Students will learn how approaches to social change in the Third World influence women in North America, and how First World women relate to women’s movements and organizations in the Third World.",
    "credits": "3"
  },
  {
    "course_name": "Resistance and Movements for Social Change",
    "dept": "GWSS",
    "num": "405",
    "desc": "Prerequisite: GWSS 105 or 305.\nExamines Women’s Resistance and movements against gender violence and discrimination in the context of colonialism, globalization, war, militarism, and occupation.",
    "credits": "3"
  },
  {
    "course_name": "Feminist Thought",
    "dept": "GWSS",
    "num": "410",
    "desc": "Prerequisite: GWSS 105 or 305.\nSurvey of a variety of feminist analyses of society, culture, and work, as well as visions for social change. The historical development of key feminist theories, contemporary debates, and multicultural and global feminism will be analyzed.",
    "credits": "3"
  },
  {
    "course_name": "Race/Sex/Science",
    "dept": "GWSS",
    "num": "435",
    "desc": "\nExamines the ways that race, gender, sex, sexuality, nation, ability, colonialism, and class shape and are shaped by science and technology.  Focus is on U.S,",
    "credits": "3"
  },
  {
    "course_name": "The Stories of a Young Girl",
    "dept": "GWSS",
    "num": "450",
    "desc": "Prerequisite: ENGL 100 or 110.\nAn interdisciplinary examination of female adolescence, focusing in particular on the way it is depicted in literature.",
    "credits": "3"
  },
  {
    "course_name": "Coming Out and Sexual Identity",
    "dept": "GWSS",
    "num": "460",
    "desc": "\nExamines how narratives of coming out and the organization of National Coming Out Day impact personal freedom, policies and attitudes toward sexual orientation.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Gender, Environment and Justice",
    "dept": "GWSS",
    "num": "480",
    "desc": "\nExamines the philosophical, historical, and material aspects of the human/nature relationships and the intersection of gender, race/ethnicity, class and global location with environment and environmental justice.",
    "credits": "3"
  },
  {
    "course_name": "Honors Project",
    "dept": "GWSS",
    "num": "499",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Topics in Gender, Women, and Sexuality Studies",
    "dept": "GWSS",
    "num": "500",
    "desc": "\nTopics vary.",
    "credits": "1-3"
  },
  {
    "course_name": "Independent Study in Gender, Women, and Sexuality Studies",
    "dept": "GWSS",
    "num": "505",
    "desc": "Prerequisite: GWSS 105 or 305.\nIndependent, supervised study of a topic related to Queer Studies or Gender, Women, and Sexuality Studies.",
    "credits": "1-3"
  },
  {
    "course_name": "Research Methods in Gender, Women, and Sexuality Studies",
    "dept": "GWSS",
    "num": "510",
    "desc": "Prerequisite: GWSS 305 and GWSS 410.\nAn advanced course in practices of research in Gender, Women, and Sexuality Studies, with attention to what distinguishes interdisciplinary, feminist research from traditional, disciplinary practices. Methods explored may include survey, interview, oral history, ethnography, hermeneutics, content analysis, case study, experimental, and action research.",
    "credits": "3"
  },
  {
    "course_name": "Women and Popular Culture",
    "dept": "GWSS",
    "num": "550",
    "desc": "Prerequisite: GWSS 105 or at least 3 hours of Gender, Women, and Sexuality Studies credit.\nImages of women in a variety of popular media forms: fiction, film, television, music (including MTV), magazines, advertising, and material culture. Women are explored as objects, consumers, and producers of popular culture. Material is drawn from a variety of disciplines, including psychology, sociology, history, literary criticism, and cultural studies.",
    "credits": "3"
  },
  {
    "course_name": "Intersections of Violence & Resistance",
    "dept": "GWSS",
    "num": "560",
    "desc": "Prerequisite: GWSS 105 or at least 3 hours of Gender, Women, and Sexuality Studies credit.\nAn examination of violence, and anti-violence justice organizing as the product of race, capitalism, gender, sexuality, nation, empire, and settler colonialism. Centers violence against women, gender violence, and the violence of the normative.",
    "credits": "3"
  },
  {
    "course_name": "Social Change: Field-Experience",
    "dept": "GWSS",
    "num": "605",
    "desc": "Prerequisite: Permission of the instructor, and junior standing.\nApplied, and interdisciplinary exploration of social change in community, national, and international groups and organizations. Includes field experience, professional-related training.",
    "credits": "3"
  },
  {
    "course_name": "Capstone Seminar in Gender, Women, and Sexuality Studies",
    "dept": "GWSS",
    "num": "610",
    "desc": "Prerequisite: GWSS 510.\nAn advanced seminar for in-depth investigation of a specific topic. Students will conduct independent research and produce a substantial project or paper.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Gender, Women, and Sexuality Studies",
    "dept": "GWSS",
    "num": "700",
    "desc": "Prerequisite: Junior standing or above and instructor permission.\nProvides an in-depth theoretical and empirical analysis of scholarly works relating to an interdisciplinary topic in gender, women, and sexuality studies.",
    "credits": "1-3"
  },
  {
    "course_name": "Internship in Gender, Women, and Sexuality Studies",
    "dept": "GWSS",
    "num": "784",
    "desc": "Prerequisite: Consent of instructor and two courses in gender, women, and sexuality studies.\nSupervised field work at the local, state, national, or international level in a community, volunteer, activist, or political organization.",
    "credits": "1-12"
  },
  {
    "course_name": "Independent Study for Graduate Students or Advanced Undergraduate Students",
    "dept": "GWSS",
    "num": "799",
    "desc": "\nIndependent study in problems, issues, topics in Gender, Women, and Sexuality Studies. Topics vary.",
    "credits": "1-3"
  },
  {
    "course_name": "Orientation to HDFS",
    "dept": "HDFS",
    "num": "102",
    "desc": "\nA general introduction for new majors in Family Studies and Human Services on the school’s academic programs, advising procedures, and career opportunities for HDFS majors.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Human Development",
    "dept": "HDFS",
    "num": "110",
    "desc": "\nA study of life span human development through an individual’s awareness and understanding of his or her own physical, social, and psychological growth and relationships with family, peers, and others.",
    "credits": "3"
  },
  {
    "course_name": "The Helping Relationship",
    "dept": "HDFS",
    "num": "301",
    "desc": "Prerequisite: HDFS 110 or PSYCH 110; FSHS, GNHE, and FCSED majors only.\nCharacteristics of the helping relationship; consideration of personal qualities necessary for recognizing needs of individuals and families; identification of effective procedures for referral to appropriate professions and agencies.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Human Sexuality",
    "dept": "HDFS",
    "num": "302",
    "desc": "\nStudy of the role and meaning of sexuality in human relationships across the life course.",
    "credits": "3"
  },
  {
    "course_name": "Developing Intimate Relationships",
    "dept": "HDFS",
    "num": "303",
    "desc": "\nThis course will explore topics related to intimate relationships, which include attraction, communication, casual encounters, cohabitation and conflict. Students will critically evaluate current theory and research concerning the elements of healthy relationships. This course will include a didactic and experiential opportunities for the development of a body of knowledge concerning committed relationships, the development of interpersonal skills, increasing personal awareness, and establishing appropriate expectations.",
    "credits": "3"
  },
  {
    "course_name": "Family Violence",
    "dept": "HDFS",
    "num": "305",
    "desc": "\nThe course will focus on the different types of violence within the family system: child abuse/neglect, dating violence, intimate partner violence, and elder abuse. Students will learn about the common forms of abuse, prevalence rates, risk factors, impact, and beginning interventions on family violence. Attitudes and myths regarding family violence will be explored through critical thinking.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Marriage and Family Therapy",
    "dept": "HDFS",
    "num": "307",
    "desc": "\nThis course is designed as an introduction to the theory and practice of MFT. It includes a study of the philosophical, conceptual, and theoretical background of family therapy. The course will review theoretical formulations, common family problems, and effective treatment strategies. Readings and class discussions will provide students with practical examples of the concepts and offer opportunities for students to examine their own family dynamics.",
    "credits": "3"
  },
  {
    "course_name": "Transition to Parenthood",
    "dept": "HDFS",
    "num": "322",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Family Relationships and Gender Roles",
    "dept": "HDFS",
    "num": "350",
    "desc": "Prerequisite: HDFS 110 or PSYCH 110 or SOCIO 211.\nFamily Relationships and Gender Roles is an introduction to the interdisciplinary, scholarly, and theoretical study of intimate interpersonal relationships, family forms and processes; and gender roles across the lifespan. Throughout our course of study, students gain an appreciation and understanding of contemporary research on couple and family dynamics, gender, and the complexity and diversity of families in today’s society.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Research Methods in Human Development and Family Science",
    "dept": "HDFS",
    "num": "375",
    "desc": "Prerequisite: HDFS Majors only.\nThis course provides an introduction to the methods of research most commonly employed by researchers and practitioners in the fields of human development and family studies. Specifically, the course will focus on the interaction between research and practice and the developing of the skills necessary to be a critical consumer of research.",
    "credits": "3"
  },
  {
    "course_name": "HDFS Practicum",
    "dept": "HDFS",
    "num": "411",
    "desc": "Prerequisite: Consent of Instructor.\nIndependent Study.",
    "credits": "0-3"
  },
  {
    "course_name": "Introduction to Child Life",
    "dept": "HDFS",
    "num": "475",
    "desc": "\nIntroduction to the field of child life practices in direct and non-direct services in pediatric healthcare. Focus on the impact of illness, injury and healthcare on children and their families through the context of development theory and psychosocial treatment issues that affect the healthcare experience.",
    "credits": "3"
  },
  {
    "course_name": "Special Problems in Human Development & Family Services",
    "dept": "HDFS",
    "num": "500",
    "desc": "\nIndependent or small group study on special topics in human development and family services.",
    "credits": "0-6"
  },
  {
    "course_name": "Middle Childhood and Adolescence",
    "dept": "HDFS",
    "num": "506",
    "desc": "Prerequisite: HDFS 110 or PSYCH 110.\nPrinciples of growth and development during middle childhood and adolescence, including familial, societal, and other ecological factors affecting development of youth.",
    "credits": "3"
  },
  {
    "course_name": "Human Development and Aging",
    "dept": "HDFS",
    "num": "510",
    "desc": "Prerequisite: HDFS 110 or PSYCH 280.\nSurvey of issues, research, and problems in aging and human development throughout adulthood, with particular emphasis upon the later years.",
    "credits": "3"
  },
  {
    "course_name": "Family Theory & Science",
    "dept": "HDFS",
    "num": "550",
    "desc": "Prerequisite: HDFS 350.\nThis course focuses on the family as a context for relationships across the life course. Students will study and apply family theories, research findings, and methodologies used to examine features of, and changes in, families across time and within context.",
    "credits": "3"
  },
  {
    "course_name": "Families and Diversity",
    "dept": "HDFS",
    "num": "552",
    "desc": "Prerequisite: HDFS 350.\nSelected topics for understanding families in multiple contexts. Implications for professionals working with individuals and families.",
    "credits": "3"
  },
  {
    "course_name": "Orientation to Human Development and Family Science Internship",
    "dept": "HDFS",
    "num": "579",
    "desc": "Prerequisite: Senior standing; and minimum GPA of 2.50; HDFS majors only.\nConsideration and application of professional knowledge and skills necessary for selection and placement in a social agency for a supervised experience in direct service to clients.",
    "credits": "2"
  },
  {
    "course_name": "Human Development Family Science Internship",
    "dept": "HDFS",
    "num": "580",
    "desc": "Prerequisite: HDFS 579 with grades of B or better; senior standing; and minimum GPA of 2.50; HDFS majors only.\nA block field placement in local agencies. Faculty-supervised experience in direct service to clients: individuals, groups, and communities. Weekly seminar during placement emphasizes theory underlying the practice.",
    "credits": "8-9"
  },
  {
    "course_name": "Professional Seminar in Human Development and Family Science",
    "dept": "HDFS",
    "num": "585",
    "desc": "Prerequisite: HDFS 579, Senior standing and HDFS majors only.\nSeminar course for students completing the HDFS Internship. Consideration of professional roles and responsibilities of family science professionals, ethical decision-making, and career development. Focus on skills required in the delivery of human services with diverse groups.",
    "credits": "3"
  },
  {
    "course_name": "Professional Capstone in Human Development and Family Science",
    "dept": "HDFS",
    "num": "590",
    "desc": "Prerequisite: Senior standing and HDFS majors only.\nThis course focuses on the development of career and professionals skills relevant to human development and family science professionals.",
    "credits": "2"
  },
  {
    "course_name": "Death and the Family",
    "dept": "HDFS",
    "num": "654",
    "desc": "Prerequisite: HDFS 550 or SOCIO 640.\nExploration of contemporary attitudes toward death and dying; related influences on individual development and family life.",
    "credits": "2-3"
  },
  {
    "course_name": "Marriage Preparation and Enrichment",
    "dept": "HDFS",
    "num": "660",
    "desc": "Prerequisite: HDFS 350. Recommended prerequisite: HDFS 550.\nHistory, processes, components, goals, and research support base for contemporary marriage preparation and enrichment programs.",
    "credits": "3"
  },
  {
    "course_name": "Working with Parents",
    "dept": "HDFS",
    "num": "670",
    "desc": "Prerequisite: HDFS 110 and HDFS 350.\nApproaches to parenting and parent education with emphasis on programmatic implications of life-span developmental principles within a family context.",
    "credits": "3"
  },
  {
    "course_name": "Hindi I",
    "dept": "HINDI",
    "num": "101",
    "desc": "\nIntroduction to the structure of modern Hindi. Listening, speaking, reading, and writing.",
    "credits": "4"
  },
  {
    "course_name": "Hindi II",
    "dept": "HINDI",
    "num": "102",
    "desc": "\nContinuation of Hindi I, completion of the basic structural and linguistic principles of Hindi.",
    "credits": "4"
  },
  {
    "course_name": "Hindi III",
    "dept": "HINDI",
    "num": "201",
    "desc": "\nContinuation of Hindi II. Listening, speaking, reading, and writing.",
    "credits": "4"
  },
  {
    "course_name": "Hindi IV",
    "dept": "HINDI",
    "num": "301",
    "desc": "\nContinuation of Hindi III. Listening, speaking, reading and writing.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to History",
    "dept": "HIST",
    "num": "100",
    "desc": "\nWhat history is, how it is produced, and what its functions are. Designed for freshmen who want an introductory course which explains the methodology, purposes, and career options of the discipline.",
    "credits": "3"
  },
  {
    "course_name": "Western Civilization: The Rise of Europe",
    "dept": "HIST",
    "num": "101",
    "desc": "\nMajor trends in Western history from the beginnings of European civilization to the end of the seventeenth century. The scope of this course includes classical antiquity, the Middle Ages, the Renaissance, the Reformation, and early modern Europe, but chronological and topical emphases vary with individual sections.",
    "credits": "3"
  },
  {
    "course_name": "Western Civilization: The Modern Era",
    "dept": "HIST",
    "num": "102",
    "desc": "\nPrincipal developments in Western civilization from the beginning of the eighteenth century to the present. Scope includes the Enlightenment, the French Revolution, the Industrial Revolution, nationalism, imperialism, communism, fascism, and the two world wars, but chronological and topical emphases vary with individual sections.",
    "credits": "3"
  },
  {
    "course_name": "Overseas European Studies",
    "dept": "HIST",
    "num": "103",
    "desc": "\nSelected aspects of European history and culture with readings, lectures, and discussions which will relate historical events to places visited.",
    "credits": "2-3"
  },
  {
    "course_name": "Western Civilization: The Rise of Europe (Honors)",
    "dept": "HIST",
    "num": "105",
    "desc": "\nMajor trends in Western history from the beginnings of European civilization to the end of the seventeenth century. Scope includes classical antiquity, the Middle Ages, the Renaissance, the Reformation, and early modern Europe, but chronological and topical emphases vary with individual sections.",
    "credits": "3"
  },
  {
    "course_name": "Western Civilization: The Modern Era (Honors)",
    "dept": "HIST",
    "num": "106",
    "desc": "\nPrincipal developments in Western civilization from the beginning of the eighteenth century to the present. Scope includes the Enlightenment, the French Revolution, the Industrial Revolution, nationalism, imperialism, communism, fascism, and the two world wars, but chronological and topical emphases vary with individual sections.",
    "credits": "3"
  },
  {
    "course_name": "World History to 1450",
    "dept": "HIST",
    "num": "111",
    "desc": "\nMajor developments in the history of the world from the earliest civilizations to the eve of European expansion in the fifteenth century. Comparison of key trends and conditions in different parts of the world. Topics include the agricultural revolution, the birth of the city, the formation of states and empires, and the emergence of world religions.",
    "credits": "3"
  },
  {
    "course_name": "World History From 1450",
    "dept": "HIST",
    "num": "112",
    "desc": "\nMajor trends in the history of the world from the 15th century to the present. Global patterns of contact, mutual influence, and interdependence.",
    "credits": "3"
  },
  {
    "course_name": "History of the United States to 1877",
    "dept": "HIST",
    "num": "151",
    "desc": "\nIncludes ethnic, social, military, political, economic, diplomatic, and ideological themes. The chronological emphasis varies with instructor. The aim of the course is to achieve a broad understanding of American civilization to 1877.",
    "credits": "3"
  },
  {
    "course_name": "History of the United States Since 1877",
    "dept": "HIST",
    "num": "152",
    "desc": "\nEthnic, social, political, economic, and diplomatic history. The goal of the course is to achieve a broad understanding of American civilization since 1877.",
    "credits": "3"
  },
  {
    "course_name": "U.S. Military History since 1775",
    "dept": "HIST",
    "num": "155",
    "desc": "\nStudies the history of the military and warfare in U.S. history from 1775-present.  Includes strategic, operation, political, and social elements as part of explaining how warfare has shaped U.S. history and how American institutions and history have shaped the U.S. military.  Topics include the history and development of the armed forces, the operational history of America’s wars, the place of the military in American society, the influence of technological change on warfare, and the role of women and people of color in the armed forces over time.",
    "credits": "3"
  },
  {
    "course_name": "Topics in History for Freshmen and Sophomores",
    "dept": "HIST",
    "num": "200",
    "desc": "\nExploration of the historical dimensions of a particular topic or theme.",
    "credits": "1-3"
  },
  {
    "course_name": "Western Warfare Since 1618",
    "dept": "HIST",
    "num": "222",
    "desc": "\nIntroductory survey that uses a ”battles and leaders” component as a starting point to engender a deeper understanding of the development of Western military practices and institutions as well as greater insight into the evolution of Western society and the nation-state in modern times.",
    "credits": "3"
  },
  {
    "course_name": "Russian Culture and Civilization",
    "dept": "HIST",
    "num": "250",
    "desc": "\nRussia’s past and present in the light of principle ideologies with emphasis upon fine arts, literature, music, religion, politics, and education. Equal time will be given to the Tsarist and the Soviet periods.",
    "credits": "3"
  },
  {
    "course_name": "Honors Introduction to the Humanities I",
    "dept": "HIST",
    "num": "297",
    "desc": "Prerequisite: Consent of instructor.\nStudy of selected major works of history, literature, and philosophy which have been of central importance in the Western cultural tradition. Considerable emphasis is placed on classroom discussion and writing interpretive essays.",
    "credits": "3"
  },
  {
    "course_name": "Honors Introduction to the Humanities II",
    "dept": "HIST",
    "num": "298",
    "desc": "Prerequisite: HIST 297 or consent of instructor.\nContinuation of HIST 297.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Historical Thinking",
    "dept": "HIST",
    "num": "300",
    "desc": "Prerequisite: Declared major in History.\nIntroduces the history major to the major principles of historical thinking as well as providing an introduction to the methodologies of historical research.",
    "credits": "3"
  },
  {
    "course_name": "Topics in History",
    "dept": "HIST",
    "num": "301",
    "desc": "\nDetailed investigation of a particular theme, event, or problem in history.",
    "credits": "3"
  },
  {
    "course_name": "Latin American History and Civilization",
    "dept": "HIST",
    "num": "303",
    "desc": "\nIntroduces the history of Latin America from the earliest times to the present. Argentina, Brazil, Cuba, Mexico, and Peru will receive special attention. Themes treated will include race and ethnicity, cultural survival, revolution and authoritarianism, women and family, and the role of economic development in Latin American history.",
    "credits": "3"
  },
  {
    "course_name": "Race & US Foreign Relations",
    "dept": "HIST",
    "num": "311",
    "desc": "\nIntroduction to the impact on racial issues on U.S. international relations, especially relations with Africa, Asia, the Pacific Islands, and Latin American from the early 1800s through the conclusion of the Cold War (1991).  Focuses on issues such as immigration, coloniziation, and decolonization, economic influences, and miliary deployment.",
    "credits": "3"
  },
  {
    "course_name": "History of Technology",
    "dept": "HIST",
    "num": "320",
    "desc": "Prerequisite: ENGL 100.\nThis course focuses on the development of technology from ancient times to modern day, with emphasis on technology and its impact on American society from colonial times to present. Students will prepare a portfolio project that will feature a research or service learning component.",
    "credits": "3"
  },
  {
    "course_name": "History of East Asian Civilizations",
    "dept": "HIST",
    "num": "330",
    "desc": "\nEast Asian history from earliest times to the present. Social structures, beliefs, and values during key periods of Chinese and Japanese history. Major developments in religion, philosophy, literature, and the arts.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Japan",
    "dept": "HIST",
    "num": "331",
    "desc": "\nHistorical survey of Japan from prehistoric times to the present day, which may include material on society, politics, and culture.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to China",
    "dept": "HIST",
    "num": "332",
    "desc": "\nSurvey of the history, geography, politics, and culture of China from prehistoric times to the present day.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in History",
    "dept": "HIST",
    "num": "399",
    "desc": "Prerequisite: Membership in honors program or consent of instructor.\nSelected topics in history.",
    "credits": "3"
  },
  {
    "course_name": "Senior Thesis",
    "dept": "HIST",
    "num": "498",
    "desc": "Prerequisite: Senior standing.",
    "credits": "3-6"
  },
  {
    "course_name": "Honors Project",
    "dept": "HIST",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Japan’s Samurai Age",
    "dept": "HIST",
    "num": "501",
    "desc": "\nThe history of Japan from earliest times to the fall of the Tokugawa shogunate in 1868, including major developments in political institutions, social structures, and religious beliefs. Examines the rise and development of the warrior class that dominated society and government for much of this period.",
    "credits": "3"
  },
  {
    "course_name": "Off-Campus American Studies",
    "dept": "HIST",
    "num": "502",
    "desc": "Prerequisite: Instructor permission.\nShort-term, intensive, and in-depth study of selected topics in American history that will supplement readings, lectures, discussions and other traditional classroom assignments with on-location activities.",
    "credits": "2-3"
  },
  {
    "course_name": "Historical Study in International Setting",
    "dept": "HIST",
    "num": "503",
    "desc": "Prerequisite: Instructor permission.\nCourse work that enhances the experience of international travel and study. Requires an historical engagement with the travel experience through readings, lectures, discussion, and written work.",
    "credits": "2-3"
  },
  {
    "course_name": "Intellectual History of Early China",
    "dept": "HIST",
    "num": "504",
    "desc": "Prerequisite: Sophomore standing.\nIntroduction to the development of Chinese thought during the period from about 1200 BC to 100 BC, with emphasis on the foundational ideas of Confucianism, Daoism, and Legalism and their incorporation within the emerging imperial order.",
    "credits": "3"
  },
  {
    "course_name": "South Asian Civilizations",
    "dept": "HIST",
    "num": "505",
    "desc": "Prerequisite: Three hours of social science or junior standing.\nInterdisciplinary survey of the development of civilization in India, Pakistan, Sri Lanka, Bangladesh, Nepal, Bhutan, and Afghanistan, including geography, philosophy, social, economic, political institutions, and historical movements.",
    "credits": "3"
  },
  {
    "course_name": "Modern India and South Asia",
    "dept": "HIST",
    "num": "506",
    "desc": "\nThe history of India, Pakistan, and Bangladesh since 1500, beginning with Mogul rule and continuing through European colonialism, the anti-imperial struggle, and the troubled transition to independence.",
    "credits": "3"
  },
  {
    "course_name": "China Since 1644",
    "dept": "HIST",
    "num": "507",
    "desc": "Prerequisite: Sophomore standing.\nChina from the founding of the Manchu Qing dynasty to the present. Includes the western imperialist challenge in the nineteenth century, the Revolution of 1949, and the post-Mao Reforms. Emphasis on social, political and intellectual changes in the context of increasing contact with western nations and Japan.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Modern East Asia",
    "dept": "HIST",
    "num": "508",
    "desc": "Prerequisite: Sophomore standing.\nThe history of China, Japan, and surrounding countries including the arrival of Europeans in the sixteenth century, reactions to Western imperialism, the rise of nationalism, and revolution. The impact of the two world wars, the era of post war developments, communism in China, democracy in Japan, and the end of Western colonialism are also examined.",
    "credits": "3"
  },
  {
    "course_name": "Japan Since 1550",
    "dept": "HIST",
    "num": "509",
    "desc": "Prerequisite: Sophomore standing.\nJapan from reunification in the sixteenth century through the Tokugawa and Imperial eras to the postwar recovery. Emphasis on understanding modern Japan as the product of traditional culture, the Meiji Restoration, and World War II.",
    "credits": "3"
  },
  {
    "course_name": "World War I",
    "dept": "HIST",
    "num": "510",
    "desc": "Prerequisite: Sophomore standing.\nExamines the origins, events and consequences of the “war to end all wars.” The impact and influence of the war on colonialism, imperialism, and popular culture will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Environmental History",
    "dept": "HIST",
    "num": "511",
    "desc": "Prerequisite: Sophomore standing.\nAn introduction to environmental history as an academic specialization through selected reading and topical lectures. The course emphasizes the study of people in nature through time; it stresses people’s response to environmental change through three broadly defined periods: pre-industrial, modern industrial, and contemporary.",
    "credits": "3"
  },
  {
    "course_name": "Women in European History",
    "dept": "HIST",
    "num": "512",
    "desc": "Prerequisite: Sophomore standing.\nA study of women in primitive European societies, in preindustrial times, and in the industrial era. Emphasis will be upon the position and role of women within the society.",
    "credits": "3"
  },
  {
    "course_name": "Battles and Leaders",
    "dept": "HIST",
    "num": "513",
    "desc": "Prerequisite: Sophomore standing.\nThe course will emphasize military organization, tactics and strategy, generalship and grand strategy, manpower and logistics, and the wartime ramifications of war on land, at sea, and in the air.",
    "credits": "3"
  },
  {
    "course_name": "World War II",
    "dept": "HIST",
    "num": "514",
    "desc": "Prerequisite: Sophomore standing.\nOrigins, conduct, and consequence of World War II. Films from the TV series “The World at War” form an integral part of the course.",
    "credits": "3"
  },
  {
    "course_name": "History of Sport",
    "dept": "HIST",
    "num": "515",
    "desc": "Prerequisite: Sophomore standing.\nThe historical development of sport (especially in Europe and North America) including the growth of competition, the rise of mass spectator sports, elitism, and the changing function of sport. History of sport as business and history of the relationship between sport and other institutions.",
    "credits": "3"
  },
  {
    "course_name": "The Modern Middle East",
    "dept": "HIST",
    "num": "516",
    "desc": "\nHistory of Islam and the broader Middle East including North Africa since 1500. Topics covered include the rise of early modern empires, closer contact with Western Europe and East Asia, the impact of Western imperialism, state-sponsored defensive reforms, the development of religious modernism, social movements and constitutionalism, the emergence of nationalism, oil-dependent economies and rentier states, the origins of religious activism, and the contemporary struggle for civil rights.",
    "credits": "3"
  },
  {
    "course_name": "Iranian People Since Antiquity",
    "dept": "HIST",
    "num": "517",
    "desc": "Prerequisite: Sophomore standing recommended.\nCritical introduction to the history, geography, society, politics, economy and culture of Iran (historical Persia) from prehistoric times to the present day.",
    "credits": "3"
  },
  {
    "course_name": "Science and Technology in the United States",
    "dept": "HIST",
    "num": "519",
    "desc": "Prerequisite: Sophomore standing.\nA survey of United States science and technology from the colonial era to the present, with special attention to how the wider social context, including the role of institutions and government, affected processes of scientific and technological development. Coverage also of the challenges of addressing the social problems that arose in connection with scientific and technological development throughout United States history.",
    "credits": "3"
  },
  {
    "course_name": "Death and Dying in History",
    "dept": "HIST",
    "num": "520",
    "desc": "Prerequisite: Sophomore standing.\nExamines European and American attitudes toward death and dying in various historical periods. Topics include: death and dying in the European Middle Ages and in nineteenth and twentieth century America, the impact of the Nazi Holocaust on modern opinions about death, suicide as a historical problem, the fear of cancer in modern times, and others.",
    "credits": "3"
  },
  {
    "course_name": "History of Christianity",
    "dept": "HIST",
    "num": "521",
    "desc": "Prerequisite: Sophomore standing.\nA history of the Christian religion from the era of Jesus Christ to the present with special emphasis on people and ideas.",
    "credits": "3"
  },
  {
    "course_name": "Religion in American History",
    "dept": "HIST",
    "num": "522",
    "desc": "Prerequisite: Sophomore standing.\nA study of the impact of religion on American culture and of American culture on religion, the Social Gospel and related issues, and the interrelationship of Christianity and politics.",
    "credits": "3"
  },
  {
    "course_name": "A History of the Occult and Witchcraft",
    "dept": "HIST",
    "num": "523",
    "desc": "Prerequisite: Sophomore standing.\nA study of the history of the occult and witchcraft in Western civilization with special attention to religious, intellectual, and social issues and influences.",
    "credits": "3"
  },
  {
    "course_name": "The History of Baseball in American Culture",
    "dept": "HIST",
    "num": "524",
    "desc": "Prerequisite: Sophomore standing.\nThe history of baseball from its origins in the early nineteenth century to the present, with emphasis on the major leagues and their collateral organizations but also with attention to semi-pro and amateur baseball and to the old Negro Leagues. The history of the game will be examined in the context of American history with special reference to social issues, politics, religion, literature, music, and the medial.",
    "credits": "3"
  },
  {
    "course_name": "Colonial America",
    "dept": "HIST",
    "num": "525",
    "desc": "Prerequisite: Sophomore standing.\nAbout 1450 to 1763. Includes the European background of North American colonization, the rivalry for new world empire, seventeenth century English colonial foundations, and development of the various colonial societies.",
    "credits": "3"
  },
  {
    "course_name": "The American Revolution",
    "dept": "HIST",
    "num": "526",
    "desc": "Prerequisite: Sophomore standing.\nEighteenth century colonial background of the Revolution and the revolutionary era itself, 1763-1789. Stresses ideological and other causes of the Revolution, the course of the war, its social results, the Confederation and its demise.",
    "credits": "3"
  },
  {
    "course_name": "The Early National Period",
    "dept": "HIST",
    "num": "527",
    "desc": "Prerequisite: Sophomore standing.\nFoundations of the new nation from the adoption of the Constitution to the conclusion of the War of 1812, approximately 1789-1815. Stresses the contest between Hamiltonians and Jeffersonians for philosophical dominance of institutions; other topics include diplomacy, westward expansion, military developments, the social and intellectual life of the era.",
    "credits": "3"
  },
  {
    "course_name": "America in the Age of Jackson",
    "dept": "HIST",
    "num": "528",
    "desc": "Prerequisite: Sophomore standing.\nA survey of the Age of Jackson, opening with Jackson’s election as America’s seventh president in 1828 and closing in 1850 as the tumultuous debates over the expansion of slavery tear the country apart.",
    "credits": "3"
  },
  {
    "course_name": "Civil War and Reconstruction",
    "dept": "HIST",
    "num": "529",
    "desc": "Prerequisite: Sophomore standing.\n1848-1877. Examination of the sectional controversy, the failure of the political system to resolve peacefully the conflict between North and South, the resort to arms, the nature of the post-war settlement. Emphasis is on the attempt of mid-nineteenth-century American leaders to deal with the complex problems of slavery and race.",
    "credits": "3"
  },
  {
    "course_name": "United States in the 19th Century",
    "dept": "HIST",
    "num": "530",
    "desc": "Prerequisite: Sophomore standing.\nExplores the history of the United States during the 19th century and traces the transition of the country from a fragile, uncertain republic to a robust imperial power standing in the first rank of the world’s nations.",
    "credits": "3"
  },
  {
    "course_name": "The United States in the Twentieth Century",
    "dept": "HIST",
    "num": "531",
    "desc": "Prerequisite: Sophomore standing.\nExamines the creation of modern America, 1890 to the present. Emphasis on the social and cultural roots, and political consequences, of Progressivism, World War I, the Great Depression, World War II, the Sixties, and Post-Vietnam America.",
    "credits": "3"
  },
  {
    "course_name": "Topics in the History of the Americas",
    "dept": "HIST",
    "num": "533",
    "desc": "Prerequisite: Sophomore standing.\nProvides instructor and students the opportunity to investigate in detail a particular theme, event, or problem in the history of North, Central, or South America. Topics vary.",
    "credits": "1-3"
  },
  {
    "course_name": "Social History of Medicine",
    "dept": "HIST",
    "num": "534",
    "desc": "Prerequisite: Sophomore standing.\nAn exploration of the development of American social thought and practices regarding health care from colonial times to the present. The course stresses changing cultural attitudes toward disease as well as alterations in social practices and institutions related to healing. Special emphasis is given to the institutional development and professionalization of modern medicine.",
    "credits": "3"
  },
  {
    "course_name": "The American West",
    "dept": "HIST",
    "num": "536",
    "desc": "Prerequisite: Sophomore standing.\nPrimary emphasis on the nineteenth century when Americans were rapidly spreading across the continent. Also examines the earlier developments of the frontier and considers the twentieth century role of the trans-Mississippi region.",
    "credits": "3"
  },
  {
    "course_name": "History of the Indians of North America",
    "dept": "HIST",
    "num": "537",
    "desc": "\nA discussion of Indian-white relations from 1492 to the present. Special emphasis given to federal government policy and the cultural decline of the native people of North America. Also includes an examination of Indian reservations and urban Indians.",
    "credits": "3"
  },
  {
    "course_name": "Women in Sport",
    "dept": "HIST",
    "num": "538",
    "desc": "Prerequisite: Sophomore standing.\nA survey of the history of the female athlete, with special emphasis on the significance of women in sport in the United States. Themes covered include the evolution of the social roles of sport, the relationship between sport and gender, and athletes’ construction of identity.",
    "credits": "3"
  },
  {
    "course_name": "African-American History",
    "dept": "HIST",
    "num": "539",
    "desc": "Prerequisite: Sophomore standing.\nAn overview of the African-American experience from the seventeenth century through the civil rights movement. Emphasizes social, legal, economic, political, and intellectual aspects of black history as well African-American contributions to American life and culture.",
    "credits": "3"
  },
  {
    "course_name": "Women in America, 1600 to the Civil War",
    "dept": "HIST",
    "num": "540",
    "desc": "Prerequisite: Sophomore standing.\nAn overview of the history of American women from the beginning of the European colonization to the Civil War. Women’s changing social role and its relation to the major transformations in American culture and society during this period is stressed. Special emphasis is given to ethnic, racial, and class variations among women.",
    "credits": "3"
  },
  {
    "course_name": "Women in America, Civil War to the Present",
    "dept": "HIST",
    "num": "542",
    "desc": "Prerequisite: Sophomore standing.\nAn overview of the history of American women from the end of the Civil War to the present. Examines women’s changing role in modern industrial society with special emphasis upon the women’s rights movement of both the nineteenth and twentieth centuries.",
    "credits": "3"
  },
  {
    "course_name": "U.S. World Affairs to 1920",
    "dept": "HIST",
    "num": "543",
    "desc": "Prerequisite: Sophomore standing.\nHistory of United States foreign relations from its origins in the colonial era through World War I.",
    "credits": "3"
  },
  {
    "course_name": "U.S. and World Affairs since 1920",
    "dept": "HIST",
    "num": "544",
    "desc": "Prerequisite: Sophomore standing.\nHistory of United States foreign relations from the end of World War I through the present day.  Explores how the United States engaged the world as a global power.",
    "credits": "3"
  },
  {
    "course_name": "War in the Twentieth Century",
    "dept": "HIST",
    "num": "545",
    "desc": "Prerequisite: Sophomore standing.\nConsiders the military theory and practice, the technology, and the political and ideological constraints of World Wars I and II, the Spanish Civil War, the Korean War, and the Indochinese wars. Students are to gain an understanding of the varieties of military experience in the twentieth century, including civil wars, “total war,”and guerrilla warfare.",
    "credits": "3"
  },
  {
    "course_name": "History of American Military Affairs",
    "dept": "HIST",
    "num": "546",
    "desc": "Prerequisite: Sophomore standing.\nDeals with the development of military institutions in colonial America and the United States, civil-military relations and conflicts between political constraints and strategic demands, popular attitudes toward the military, and the rise of the military-industrial complex.",
    "credits": "3"
  },
  {
    "course_name": "Economic History of the United States",
    "dept": "HIST",
    "num": "547",
    "desc": "Prerequisite: Sophomore standing.\nMajor topics in American economic history from the colonial period to the present.  Focus is on nineteenth- and twentieth-century issues, including the rise of big business; the expanding role of the government in the economy; the Great Depression; the postwar boom and its end; issues of class, race, and gender; America’s shifting roles in the global economy.",
    "credits": "3"
  },
  {
    "course_name": "Modern Africa from 1850",
    "dept": "HIST",
    "num": "549",
    "desc": "Prerequisite: Sophomore standing recommended.\nIntroduction to modern African history since 1850. Key topics include the establishment and impact of the colonial empires that dominated Africa between the 1880s and 1960s; the process of decolonization; African responses to colonial rule; and the development of post-Independence Africa with a special emphasis on the challenges faced by African countries.",
    "credits": "3"
  },
  {
    "course_name": "History of Family Violence",
    "dept": "HIST",
    "num": "551",
    "desc": "Prerequisite: Sophomore standing.\nExplores the history of family violence in America as a social, cultural, legal, and public policy issue from colonial times to the present. Stress is placed upon the cultural roots and evolution of domestic law. The development of state-controlled social welfare agencies as well as the emergence of the “battered women’s movement” is particularly emphasized.",
    "credits": "3"
  },
  {
    "course_name": "History of American Culture",
    "dept": "HIST",
    "num": "553",
    "desc": "Prerequisite: Sophomore standing.\nMain emphasis is on political, religious, and social thought and ideology, 1620 to present.",
    "credits": "3"
  },
  {
    "course_name": "History of the South",
    "dept": "HIST",
    "num": "554",
    "desc": "Prerequisite: Sophomore standing.\nTopical analysis of important issues in Southern history. Compares the plantation myth of popular films with interpretations by important historians. Emphasis on plantation agriculture, slavery, race relations, class, and gender in the Old South. Post-Civil War topics include federal Reconstruction efforts, segregation, economic reform, and the modern Civil Rights movement.",
    "credits": "3"
  },
  {
    "course_name": "American Constitutional History",
    "dept": "HIST",
    "num": "555",
    "desc": "Prerequisite: Sophomore standing.\nSurvey of constitutional and legal development from colonial times to the present. English constitutional ideas and the common law in the American colonies, formation of the Constitution, the role of the Supreme Court, development of the modern American legal system, growth of the legal profession, the problem of civil liberties. The course offers insight into the relationship of constitutional-legal institutions to American society.",
    "credits": "3"
  },
  {
    "course_name": "Bill of Rights in American History",
    "dept": "HIST",
    "num": "556",
    "desc": "Prerequisite: Sophomore standing.\nThis course provides a topical survey of the American Bill of Rights from the colonial era to the present. It begins with the origins of American rights in England and colonial America. An analysis of the need for a Bill of Rights at the founding and Supreme Court interpretations in 1835 and during the Reconstruction era follow. The bulk of the course is concerned with the nationalization and expansion of the Bill of Rights in the twentieth century and its meaning in the everyday lives of American citizens.",
    "credits": "3"
  },
  {
    "course_name": "History of American Agriculture",
    "dept": "HIST",
    "num": "557",
    "desc": "Prerequisite: Sophomore standing.\nConcentrates on the period since 1850 in an attempt to acquaint the student with the political and economic history of American agriculture. No attempt will be made to present the scientific or technological side of agriculture in detail, but agriculture will be shown in relation to the life of the entire United States. The life of the farmer and his family, the relationship between agricultural changes and other parts of the economy will be part of this course. Special attention will be paid to agriculture in Kansas and the Great Plains.",
    "credits": "3"
  },
  {
    "course_name": "History of Kansas",
    "dept": "HIST",
    "num": "558",
    "desc": "Prerequisite: Sophomore standing.\nLand, people, and cultural developments in Kansas, from the earliest written records to the present. Provides the student with an intimate understanding of the state of Kansas.",
    "credits": "3"
  },
  {
    "course_name": "History of Aztecs, Inca, and Maya",
    "dept": "HIST",
    "num": "559",
    "desc": "Prerequisite: Sophomore standing.\nIntroduction to the history of Ancient Mesoamerican and Andean civilizations through a multi-disciplinary approach combining materials from the fields of history, art history, anthropology, and archaeology.",
    "credits": "3"
  },
  {
    "course_name": "Latin American Nations",
    "dept": "HIST",
    "num": "560",
    "desc": "Prerequisite: Sophomore standing.\nSurvey of economic, social, and political developments of the Latin American nations from independence to the present decade with emphasis on Argentina, Brazil, Peru, Chile, and Mexico. Stresses reform and revolution of the last 50 years.",
    "credits": "3"
  },
  {
    "course_name": "Colonial Hispanic America",
    "dept": "HIST",
    "num": "561",
    "desc": "Prerequisite: Sophomore standing.\nIberian and indigenous American background, exploration, conquest, settlement, and development of Latin America. Stresses growth of mestizo culture, colonial styles of living, and wars of independence.",
    "credits": "3"
  },
  {
    "course_name": "Modern Mexico",
    "dept": "HIST",
    "num": "562",
    "desc": "Prerequisite: Sophomore standing.\nBrief survey of lines of national development, 1821-1910, and major emphasis on the twentieth-century revolution and its reforms (1910-1940) as well as its subsequent implications.",
    "credits": "3"
  },
  {
    "course_name": "History of Mass Communications in America",
    "dept": "HIST",
    "num": "564",
    "desc": "\nGrowth and development of media and media technology in the United States and their economic, political, and social significance.",
    "credits": "3"
  },
  {
    "course_name": "History and Culture of Greece",
    "dept": "HIST",
    "num": "565",
    "desc": "Prerequisite: Sophomore standing.\nThe rise of civilization in the ancient Near East, the migrations of the Greeks and the Heroic Age, the Greek city-states, commerce and colonization, the Persian invasion, Athens’ leadership of Greece, the war between Athens and Sparta, Alexander the Great, and the total Hellenic achievement.",
    "credits": "3"
  },
  {
    "course_name": "History and Culture of Rome",
    "dept": "HIST",
    "num": "566",
    "desc": "Prerequisite: Sophomore standing.\nExamines the various theories of Rome’s origin, the causes, problems, and influences upon the republican government, political and economic problems of Roman expansion, and the Roman world. Various reforms including those of the Gracchi, Caesar, and Augustus. Contact with Greece and the older areas of civilization. The Roman imperial system, the many causes of Rome’s fall, and Rome’s role as a synthesizer of the ancient classical culture.",
    "credits": "3"
  },
  {
    "course_name": "Europe in the Middle Ages",
    "dept": "HIST",
    "num": "567",
    "desc": "Prerequisite: Sophomore standing.\nEurope from the fall of the Roman Empire to the thirteenth century. Investigates the conflict and interaction of Roman, Christian, and Germanic ideals and attitudes in the early Middle Ages, and the increasing complexity and sophistication of society, culture, religion, and government of the high Middle Ages.",
    "credits": "3"
  },
  {
    "course_name": "The Renaissance",
    "dept": "HIST",
    "num": "568",
    "desc": "Prerequisite: Sophomore standing.\nThe Italian Renaissance as a major phase in the history of Western civilization and its spread to northern Europe.",
    "credits": "3"
  },
  {
    "course_name": "The Reformation",
    "dept": "HIST",
    "num": "569",
    "desc": "Prerequisite: Sophomore standing.\nA study of the Protestant, Catholic, and Radical Reformations with special attention to Luther, Calvin, the origins of the Church of England and the Presbyterian Church, the Anabaptists, the Puritans, and Roman Catholic Reform, and the impact of religious developments on the political, economic, social, and intellectual history of the Western world. Covers the period from approximately 1500 to 1660.",
    "credits": "3"
  },
  {
    "course_name": "Europe in the Seventeenth Century",
    "dept": "HIST",
    "num": "570",
    "desc": "Prerequisite: Sophomore standing.\nSurveys the economic, social, political and intellectual history of western Europe in the seventeenth century, a period marked by economic depression, international conflict, and domestic revolutions as well as by cultural achievement. Emphasizes the complex interaction among social groups; the rise of a European state system; the development of constitutional monarchy in England and absolute monarchy in France; and the change in values generated by the scientific revolution.",
    "credits": "3"
  },
  {
    "course_name": "Eighteenth-Century Europe",
    "dept": "HIST",
    "num": "571",
    "desc": "Prerequisite: Sophomore standing.\nEurope from the death of Louis XIV in 1715 to the fall of Napoleon in 1815. The origins and development of the French Revolution and the Napoleonic legacy, also examines reform and counter-revolutionary movements in England, Italy, Russia, Poland, and the Germanies.",
    "credits": "3"
  },
  {
    "course_name": "Nineteenth Century Europe",
    "dept": "HIST",
    "num": "572",
    "desc": "Prerequisite: Sophomore standing.\nThe history of Europe from the French Revolution to the end of the first World War. Major topics covered will include the rise of conservatism as an ideology and its application in practice, the nature of liberalism and socialism, the impact of science and technology, the origins and course of World War I.",
    "credits": "3"
  },
  {
    "course_name": "Twentieth Century Europe",
    "dept": "HIST",
    "num": "573",
    "desc": "Prerequisite: Sophomore standing.\nExamines the political, social, and intellectual developments of Europe in the period of the two world wars. Emphasis on the failure of democracy and the rise of competing antidemocratic and nondemocratic mass movements and ideologies. The course will also deal with the attempted system of collective security, its failure, and the origins and course of World War II.",
    "credits": "3"
  },
  {
    "course_name": "Europe since World War II",
    "dept": "HIST",
    "num": "574",
    "desc": "\nPostwar European society, politics, economy, and culture. The effects of total war on the population; restoration and reconstruction. The influence of the U.S. and U.S.S.R. on Europe. Capitalism, socialism, and communism in technological society. European unity movements and their conflicts with traditional values.",
    "credits": "3"
  },
  {
    "course_name": "European International Relations to 1815",
    "dept": "HIST",
    "num": "576",
    "desc": "Prerequisite: Sophomore standing.\nThe nature, evolution, and function of the diplomatic system for the Ancient World to 1815. Analyzes the Greek and Roman diplomatic tradition, international relations during the Medieval, Renaissance, and Early Modern periods, and the works of various theorists.",
    "credits": "3"
  },
  {
    "course_name": "European International Relations Since 1815",
    "dept": "HIST",
    "num": "577",
    "desc": "Prerequisite: Sophomore standing.\nThe nature, evolution, and functions of the European diplomatic system from 1815 to the present. Focuses on the Vienna settlement, the Eastern Question, the Crimean War, Italian and German unification, origins of World War I, international developments between the two world wars, the cold war, and the post-cold war era. Includes analysis of major theorists.",
    "credits": "3"
  },
  {
    "course_name": "Central Europe, 1500-1914",
    "dept": "HIST",
    "num": "578",
    "desc": "Prerequisite: Sophomore standing.\nThe diplomatic, military, political, cultural, and social aspects of the Hapsburg empire in Central Europe from its foundation to its dissolution in the twentieth century.",
    "credits": "3"
  },
  {
    "course_name": "The British Isles to 1603",
    "dept": "HIST",
    "num": "579",
    "desc": "Prerequisite: Sophomore standing.\nEnglish, Scottish, and Irish culture in the medieval and pre-modern periods. Early folk societies, feudalism, the church in society and politics, the origins of representative institutions and the religious reformations are studied topically.",
    "credits": "3"
  },
  {
    "course_name": "The British Isles Since 1603",
    "dept": "HIST",
    "num": "580",
    "desc": "Prerequisite: Sophomore standing.\nEnglish society and politics in modern times with reference also to Scotland and Ireland. Emphasis on topics such as the three orders of society (king, lords, and commons), the churches and religion, the appearance of parliamentary sovereignty, the industrial revolution, and the extension of democratic institutions.",
    "credits": "3"
  },
  {
    "course_name": "Eastern Europe Since 1914",
    "dept": "HIST",
    "num": "582",
    "desc": "Prerequisite: Sophomore standing.\nThe growth of nationalism, the formation of nation-states after World War I, the devastation of World War II, the establishment of Soviet rule, the dramatic revolutions of 1989, and Yugoslavia’s ethnic wars.",
    "credits": "3"
  },
  {
    "course_name": "History of France, 1400-1715",
    "dept": "HIST",
    "num": "583",
    "desc": "Prerequisite: Sophomore standing.\nFrance from the conclusion of the Hundred Years War to the death of Louis XIV. French economy, society, and royal administration, and the changes generated in these areas by significant events: the Reformation and the Wars of Religion; the rise of France to world power; peasant uprisings and constitutional crisis; and the reforms of Richelieu, Colbert, and Louis XIV. Trends in art, architecture, and philosophy.",
    "credits": "3"
  },
  {
    "course_name": "France and its Empire, 1815-Present",
    "dept": "HIST",
    "num": "584",
    "desc": "Prerequisite: Sophomore standing.\nEmphasis on the development of French democracy and France’s place in the world. Covers the world wars and French imperialism as well as social and gender change in French history.",
    "credits": "3"
  },
  {
    "course_name": "Medieval Christianity",
    "dept": "HIST",
    "num": "585",
    "desc": "Prerequisite: Sophomore standing.\nA survey of the development of Christianity in western Europe during the Middle Ages (c. 500-1500). Topics include the development of the papacy and the ecclesiastical hierarchy, the role of kings and other rulers, the Crusades, scholasticism, purgatory, penance, monasticism, specific religious orders like the Franciscans, baptism, marriage, asceticism, how medieval Christians read the Bible, saints, the roles of women, and heresy.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Seminar in History",
    "dept": "HIST",
    "num": "586",
    "desc": "Prerequisite: Six hours of History courses at or above the 500 level.\nAn undergraduate seminar that focuses on the intellectual principles of the historical discipline as well as the fundamental research techniques and writing skills used by historians. Each section of the seminar will center on a particular topic or historical problem. The students will prepare a research paper on a relevant subject of their choice.",
    "credits": "3"
  },
  {
    "course_name": "Nineteenth-Century Imperial Germany",
    "dept": "HIST",
    "num": "587",
    "desc": "Prerequisite: Sophomore standing.\nCentral Europe in the French Revolutionary era, the revolutions of 1848, German unification, imperial Germany, emphasizing social changes, especially the transition from agrarian to industrial society.",
    "credits": "3"
  },
  {
    "course_name": "Nazi Germany and the Holocaust",
    "dept": "HIST",
    "num": "588",
    "desc": "Prerequisite: Sophomore standing.\nExamines the political, social, economic, and intellectual developments in Germany from World War I to the end of World War II, including the Nazi ideology and the Holocaust.",
    "credits": "3"
  },
  {
    "course_name": "Lost Kansas Communities",
    "dept": "HIST",
    "num": "589",
    "desc": "Prerequisite: Sophomore standing.\nCombined lecture-field research course in the history of vanished Kansas towns. Overview of settlement, persistence, and decline. Students also research a lost community of their choosing.",
    "credits": "3"
  },
  {
    "course_name": "The Russian Empire",
    "dept": "HIST",
    "num": "591",
    "desc": "Prerequisite: Sophomore standing.\nImperial Russia from the earliest Slavic tribes through 1881, with emphasis on Russia’s heritage as a multi-ethnic state and the phenomenon of Russia’s revolutional intellectuals.",
    "credits": "3"
  },
  {
    "course_name": "Twentieth Century Russia",
    "dept": "HIST",
    "num": "592",
    "desc": "Prerequisite: Sophomore standing.\nThe turbulent history of modern Russia, including the upheaval of the Russian Revolution and Civil War, Stalin’s transformation of Soviet society, World War II, failed attempts to transform the Soviet system, and the fall of the Soviet Union.",
    "credits": "3"
  },
  {
    "course_name": "The Vietnam War",
    "dept": "HIST",
    "num": "593",
    "desc": "Prerequisite: Sophomore standing.\nThis course examines the origins, actions, and consequences of the Indochina wars fought by the French, Japanese, and Americans during the last century. Particular emphasis is placed on America’s experience in Southeast Asia. Videos from the PBS series, “Vietnam: A Television History,” are used in the course.",
    "credits": "3"
  },
  {
    "course_name": "French Revolution, 1789-1815",
    "dept": "HIST",
    "num": "595",
    "desc": "Prerequisite: Sophomore standing.\nThe political, economic, cultural, and social development of France from the origins of the Revolution to the Congress of Vienna.",
    "credits": "3"
  },
  {
    "course_name": "Topics in European History",
    "dept": "HIST",
    "num": "597",
    "desc": "Prerequisite: Sophomore standing.\nProvides instructor and students the opportunity to investigate in detail a particular theme, event, or problem in European history.",
    "credits": "1-3"
  },
  {
    "course_name": "Topics in Non-Western History",
    "dept": "HIST",
    "num": "598",
    "desc": "Prerequisite: Sophomore standing.\nProvides instructor and students the opportunity to investigate in detail a particular theme, event, or problem in non-Western history.",
    "credits": "1-3"
  },
  {
    "course_name": "Internship in History",
    "dept": "HIST",
    "num": "650",
    "desc": "Prerequisite: Junior standing.\nPractical professional experience involving at least three weeks in an archive, museum, historical library, or business. Student projects must be approved in advance and a report submitted at the end of the work period.",
    "credits": "3"
  },
  {
    "course_name": "Overseas European Studies",
    "dept": "HIST",
    "num": "703",
    "desc": "Prerequisite: Senior or graduate standing.\nShort-term, intensive, and in-depth study of various aspects of European history and culture with readings, lectures, discussions, and on-the-spot experiences which will relate historical events to the places visited.",
    "credits": "2-3"
  },
  {
    "course_name": "Readings in History",
    "dept": "HIST",
    "num": "798",
    "desc": "\nStudents will read on a central theme, attend weekly discussions, and write a final report.",
    "credits": "1-3"
  },
  {
    "course_name": "Problems in History",
    "dept": "HIST",
    "num": "799",
    "desc": "\nIntensive study of a particular phase of history. Students will attend weekly discussions and write a major research paper on their findings.",
    "credits": "1-18"
  },
  {
    "course_name": "Freshman Seminar in Hospitality Management",
    "dept": "HM",
    "num": "101",
    "desc": "Prerequisite: Hospitality Management majors only.\nA general orientation to the university, college, and department. Students will develop an understanding of Strengths Quest, academic career planning, the enrollment process, basic interviewing skills, resume development, and other issues as they apply to students in the hospitality management program.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to the Hospitality Industry",
    "dept": "HM",
    "num": "120",
    "desc": "\nOverview of the hospitality industry. Survey of the history, scope, trends, and career opportunities that comprise the segments of the industry.",
    "credits": "3"
  },
  {
    "course_name": "Food Safety and Protection in Hospitality Operations",
    "dept": "HM",
    "num": "205",
    "desc": "Prerequisite: Sophomore standing.\nOverview of environmental issues that impact the hospitality industry. Includes: food safety principles and applications, Hazard Analysis Critical Control Point (HACCP) systems, and governmental regulations in the hospitality industry. Successful completion of the ServSafe Food Protection Manager Exam is required of all students in the course.",
    "credits": "1"
  },
  {
    "course_name": "Environmental Issues in Hospitality",
    "dept": "HM",
    "num": "220",
    "desc": "Prerequisite: Sophomore standing.\nOverview of environmental issues that impact the hospitality industry. Includes: food safety principles and applications, Hazard Analysis Critical Control Point (HACCP) systems, conservation of natural resources, solid waste management, air quality, and governmental regulations in the hospitality industry.",
    "credits": "3"
  },
  {
    "course_name": "Issues in Tourism",
    "dept": "HM",
    "num": "230",
    "desc": "\nAn overview of the history and implications of travel and tourism focusing on the understanding of tourism from the perspectives of travelers and communities, while identifying tourism’s economic, socio-cultural, and environmental impacts.",
    "credits": "3"
  },
  {
    "course_name": "Hospitality Work Experience I",
    "dept": "HM",
    "num": "275",
    "desc": "Prerequisite: Consent of Advisor.\nPlanned experience in a hospitality operation; minimum of 200 hours exclusive of course work.",
    "credits": "1"
  },
  {
    "course_name": "Junior Seminar in Hospitality Management",
    "dept": "HM",
    "num": "301",
    "desc": "Prerequisite: STAT 350; HM 101; Junior Standing.\nThis seminar course will emphasize and reinforce important job searching skills including resume writing, interviewing techniques, job searches, communicating with employers before and after interviews, and social media management. This course will also introduce and emphasize critical thinking, research, and presentation skills that are needed for special projects in hospitality firms. After successfully completing the course, student will be able to search and secure an internship/professional position and to design, execute, and present a job related project in a hospitality firm.",
    "credits": "1"
  },
  {
    "course_name": "Professional Club Management",
    "dept": "HM",
    "num": "331",
    "desc": "Prerequisite: HM 120.\nExploration of topics involved in club management. Topics discussed are history and current trends of public and private clubs, food and beverage service, marketing, and event and financial management.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Food Production Management",
    "dept": "HM",
    "num": "341",
    "desc": "Prerequisite: Sophomore standing.\nBasic principles and theories of foodservice systems; menu planning; development, standardization, adjustment, and costing of quantity recipes; procurement and production of quality food; foodservice computer applications.",
    "credits": "3"
  },
  {
    "course_name": "Commercial Food Production Management",
    "dept": "HM",
    "num": "351",
    "desc": "\nApplications of principles of commercial food production and hospitality service management systems, including procurement, production, and service in a commercial foodservice system; quality and cost controls, employee performance evaluation, process improvement (i.e., work simplification, motion economy), and commercial foodservice equipment operation in the program’s commercial foodservice facility.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Hotel Operations",
    "dept": "HM",
    "num": "361",
    "desc": "Prerequisite: Sophomore standing.\nThe development of the lodging industry and current trends. Organization and administration of hotel operations including front desk, housekeeping, laundry, sales/marketing, management, and other positions common to hotel operations.",
    "credits": "3"
  },
  {
    "course_name": "Lodging Practicum",
    "dept": "HM",
    "num": "362",
    "desc": "Prerequisite: HM 361 or concurrent enrollment.\nSupervised experiences in the operational areas of a lodging property.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Business Events",
    "dept": "HM",
    "num": "363",
    "desc": "Prerequisite: Sophomore standing.\nThis course introduces students to the key players and potential careers in the meeting and event industry. Students will explore various perspectives and responsibilities of event planners. Additionally, basic core concepts essential for planning a meeting will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "The Business of Wedding Consulting",
    "dept": "HM",
    "num": "370",
    "desc": "\nThis course will introduce the student to the competencies required to become a professional wedding consultant. Students will analyze essential services that provide the necessary infrastructure for a wedding event and will examine the business, creative, and practical aspects of coordinating the wedding environment.",
    "credits": "3"
  },
  {
    "course_name": "Hospitality Work Experience II",
    "dept": "HM",
    "num": "375",
    "desc": "Prerequisite: HM 275; Consent of academic advisor.\nA 300-hour planned experience that combines observation, and employment within a hospitality operation. Must be completed in the student’s declared track.",
    "credits": "1"
  },
  {
    "course_name": "Hospitality Service Systems",
    "dept": "HM",
    "num": "421",
    "desc": "Prerequisite: Junior standing.\nExamination of the complexities of leading quality and service within all segments of the hospitality industry. A focus on developing leadership, problem solving and process management skills, work methods, team development, and evaluation of service systems.",
    "credits": "3"
  },
  {
    "course_name": "Cost Controls in Hospitality Operations",
    "dept": "HM",
    "num": "422",
    "desc": "Prerequisite: ACCTG 231; HM 341.\nApplication of accounting principles to analyze control measures used in lodging meeting/conventions/events, and commercial and noncommercial foodservice operations. Includes managerial, financial, and ethical considerations associated with procurement and human resources.",
    "credits": "3"
  },
  {
    "course_name": "Facility Management",
    "dept": "HM",
    "num": "423",
    "desc": "Prerequisite: HM 375\nEvaluation and selection of equipment, maintenance contracts, layout, design, sustainability of hospitality operations, facility renovation, and selection of consultants. Assessment of safety and security measures and development of risk management programs to increase guest/customer safety.",
    "credits": "3"
  },
  {
    "course_name": "Hospitality Sales and Promotion",
    "dept": "HM",
    "num": "424",
    "desc": "Prerequisite: MKTG 400.\nThis course guides the student to explore and understand successful sales and sales management behaviors in the hospitality industry. This course will focus on relational selling and include both asking for sales and being a hotel sales manager. Students will develop a comprehension in selling approaches, conversations and presentations, and sales management techniques. Course topics will include hotel sales structures, duties and responsibilities, sales forms, relationships, prospecting, sales call planning, communicating the message, closing the sale, as well as how to motivate, compensate and train sales people specific to the hospitality industry.",
    "credits": "3"
  },
  {
    "course_name": "Fundraising and Nonprofit Events",
    "dept": "HM",
    "num": "426",
    "desc": "Prerequisite: HM 363\nThis course introduces students to the basics of fundraising and nonprofit events.  Students will gain an understanding of the similarities and differences across nonprofit events and the key elements that make them successful. Students will build and develop a plan for all facets of fundraising or nonprofit events.",
    "credits": "3"
  },
  {
    "course_name": "Travel and Dining Auction Event Management",
    "dept": "HM",
    "num": "427",
    "desc": "Prerequisite: HM 426; instructor’s permission required.\nApplication of event planning principles by analyzing previous travel and dining auctions, managing and executing the current year’s travel and dining auction, and evaluating the results.",
    "credits": "3"
  },
  {
    "course_name": "Study Abroad Experience in Hospitality Management",
    "dept": "HM",
    "num": "430",
    "desc": "\nA Faculty-led Study Abroad Experience in Hospitality Management.",
    "credits": "1-3"
  },
  {
    "course_name": "Beverage Management",
    "dept": "HM",
    "num": "440",
    "desc": "Prerequisite: PSYCH 110 or SOCIO 211; 21 years of age or older\nThe study of historic, social, ethical, physiological, and legal issues relating to alcoholic beverage service and use in contemporary America with emphasis on responsible and knowledgeable service of beer, wine, and spirits in hospitality operations. Course will include beverage tasting and sensory analysis of products commonly served in the beverage industry. Must be 21 years of age to enroll in the course.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Wines",
    "dept": "HM",
    "num": "442",
    "desc": "Prerequisite: 21 years of age.\nOverview of wine varietals and major wine regions of the world, tasting and identifying wine varietals based on their specific characteristics, proper purchasing and service of wines, and using wines to complement foods.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Wines",
    "dept": "HM",
    "num": "462",
    "desc": "Prerequisite: HM 440 or HM 442, and 21 years of age or older.\nAn in-depth look at specific wine producing regions and sub-regions, a critical view of wines that define these regions, and preparation for service of wine in the hospitality industry.",
    "credits": "1"
  },
  {
    "course_name": "Business Event Coordination",
    "dept": "HM",
    "num": "463",
    "desc": "Prerequisite: HM 363\nIn this course, students will plan a theoretical event from start to completion and learn details pertinent to the organization and execution of a business meeting. Topics include objectives, timelines, finance and contracts, site selection, program development, marketing, and evaluation.",
    "credits": "3"
  },
  {
    "course_name": "Revenue Management",
    "dept": "HM",
    "num": "464",
    "desc": "Prerequisite: HM 361, Junior standing.\nAnalysis and interpretation of key lodging statistics including occupancy percentage, average daily rate (ADR), revenue per available room (REVPAR), customer profiles, etc. Overview of forecasting methods and pricing and distribution channel strategies. Emphasis on concepts and practices of revenue management in the hotel/lodging industry.",
    "credits": "3"
  },
  {
    "course_name": "Catering and Banquet Management",
    "dept": "HM",
    "num": "465",
    "desc": "\nApplication and principles of catering management, including off-site and on-site functions. Organizational, logistical, aesthetic, and marketing aspects of the catering industry will be utilized and applied.",
    "credits": "3"
  },
  {
    "course_name": "Internship in the Hospitality Management",
    "dept": "HM",
    "num": "475",
    "desc": "Prerequisite: For HM majors and minors only: junior standing, HM 275, HM 375, and HM 421; consent of instructor.\nPlanned and supervised experience in a foodservice or hospitality operation; minimum of 400 hours.",
    "credits": "3"
  },
  {
    "course_name": "Human Resource Management in the Hospitality Industry",
    "dept": "HM",
    "num": "482",
    "desc": "Prerequisite: HM 375.\nThis course will focus on the role of the hospitality manager as facilitator, trainer, and motivator of employees. High quality employees are vital for success in any organization, and the goal of this course is to provide you with the tools for successfully managing employees to enhance individual and organizational performance. Special attention is given to the unique problems associated with hotels, restaurants, and other hospitality businesses. Upon completion of this course, you should be able to design and implement the most effective methods for attracting, selecting, developing, motivating, and retaining quality employees to promote a competitive advantage for the hospitality organization.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Hospitality Management",
    "dept": "HM",
    "num": "499",
    "desc": "Prerequisite: Consent of instructor.\nIndependent study under the supervision of a faculty member.",
    "credits": "1-18"
  },
  {
    "course_name": "Hospitality Law",
    "dept": "HM",
    "num": "621",
    "desc": "Prerequisite: HM 475.\nLegal aspects of managing hospitality operations and responsibilities for the operations, patron civil rights, governmental regulations, franchising, and commercial transactions.",
    "credits": "3"
  },
  {
    "course_name": "Procurement in the Hospitality Industry",
    "dept": "HM",
    "num": "624",
    "desc": "Prerequisite: HM 342.\nPrinciples and theories of procurement of food and supplies for hospitality operations. Includes management, financial, safety, and ethical considerations in the procurement process.",
    "credits": "2"
  },
  {
    "course_name": "Entrepreneurship in Hospitality Management",
    "dept": "HM",
    "num": "640",
    "desc": "Prerequisite: ACCTG 231.\nDevelopment and management of small businesses or private practice within the hospitality industry. Business plan development, marketing, cost considerations. Overview of consulting to healthcare and hospitality operations and examination of skills required for success.",
    "credits": "3"
  },
  {
    "course_name": "Foodservice Systems Management",
    "dept": "HM",
    "num": "662",
    "desc": "Prerequisite: HM 351, HM 375.\nA capstone course in foodservice management that focuses on the management, analysis, and evaluation of food and beverage systems. Emphasis on planning, coordinating, and improving commercial and noncommercial operations. Development of analytical and decision-making skills for solving managerial and operational problems.",
    "credits": "3"
  },
  {
    "course_name": "Business Event Management",
    "dept": "HM",
    "num": "663",
    "desc": "Prerequisite: Senior Standing.\nA capstone course in meeting and event management. This course will provide students with an opportunity to integrate knowledge, concepts and capacities from different parts of their learning experiences into real-world event planning experiences. This course will enable students to plan an event from initial conception to final evaluation.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Hotel Operations",
    "dept": "HM",
    "num": "664",
    "desc": "Prerequisite: HM 464, Senior Standing.\nThis senior-level course provides students the opportunity to utilize a strategic management process as a decision-making tool that integrates marketing, human resources, operations, and financial performance measures. This is a computer simulation class, where teams will compete with each other in real-time to understand and evaluate the market dynamics of a competitive set of hotels.",
    "credits": "3"
  },
  {
    "course_name": "Casino Management",
    "dept": "HM",
    "num": "665",
    "desc": "Prerequisite: Junior standing, 60 credit hours or more.\nInvestigation of the histories and overall operations of casino properties and their impacts on the foodservice and hospitality industry from the social, economic, political and environmental perspectives.",
    "credits": "3"
  },
  {
    "course_name": "Information Technology Systems in Hospitality Operations",
    "dept": "HM",
    "num": "705",
    "desc": "Prerequisite: CIS 101; and HM 480 or 560 or MANGT 420.\nReview of computer development in foodservice and hospitality operations; development of criteria for implementation of a computer system; analysis of foodservice and hospitality hardware and software.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Hospitality Administration",
    "dept": "HM",
    "num": "710",
    "desc": "Prerequisite: HM 480 or 560 or MANGT 420.\nDirected study of current literature in hospitality management and related areas.",
    "credits": "1-3"
  },
  {
    "course_name": "Administration of Health Care Organizations",
    "dept": "HM",
    "num": "720",
    "desc": "\nComprehensive review of current health care institutions and their response to the economic, social/ethical, political/legal, technological, and ecological environments.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Hospitality Management",
    "dept": "HM",
    "num": "785",
    "desc": "Prerequisite or concurrent: HM 342; and HM 480 or 560 or MANGT 420.\nProfessional experiences in approved foodservice organization as a member of the management team under faculty supervision.",
    "credits": "1-6"
  },
  {
    "course_name": "Preparing for Your Horticulture Career",
    "dept": "HORT",
    "num": "190",
    "desc": "\nThis course is designed to assist students in their personal and professional development. Specifically, students will gain an appreciation for the significance of the horticultural industry while acquiring various skills necessary for a rewarding internship experience and their future professional career. Students will also develop an understanding, awareness and empathy of human diversity as it relates to each individual and the world around them.",
    "credits": "1"
  },
  {
    "course_name": "Principles of Horticultural Science",
    "dept": "HORT",
    "num": "201",
    "desc": "\nThe basic principles of plant science and the environment that apply to horticulture; survey of the industry; plant taxonomy, anatomy, morphology, and physiology; environment and plant growth; plant propagation, pest management, plant breeding.",
    "credits": "4"
  },
  {
    "course_name": "Concepts of Floral Design",
    "dept": "HORT",
    "num": "210",
    "desc": "\nAn introduction to the use of flowers and related products with emphasis on fundamentals of design.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the Horticultural Therapy Profession",
    "dept": "HORT",
    "num": "235",
    "desc": "\nThis course will consist of a practical exploration of the field of horticultural therapy services in various settings. Students will learn about major job duties such as facilitation techniques, programs, clients, staff, budgets, facilities, and equipment and the variety of populations with which professional horticultural therapists work.",
    "credits": "3"
  },
  {
    "course_name": "Human Dimensions of Horticulture",
    "dept": "HORT",
    "num": "256",
    "desc": "\nIntroduction to horticulture applied in schools, psychiatric and medical hospitals, corrections, vocational rehabilitation centers, elderly programs, and consumer horticulture settings. Networking the art and science of horticulture with architecture, business, social sciences, health care, horticulture, and education.",
    "credits": "3"
  },
  {
    "course_name": "Horticultural Design I",
    "dept": "HORT",
    "num": "275",
    "desc": "\nIntroduction to the landscape design process including historical perspectives and contemporary issues; development of planning, graphical presentation, and communication skills; and application of design principles to horticultural garden design.",
    "credits": "3"
  },
  {
    "course_name": "Horticulture Practicum",
    "dept": "HORT",
    "num": "301",
    "desc": "Prerequisite: HORT 201, junior standing, and successful completion of practicum assistance course with at least a C.\nExperiential approach to learning horticulture through teaching. Students will assist faculty with specific horticulture courses.",
    "credits": "1-3"
  },
  {
    "course_name": "Introduction to Organic Farming",
    "dept": "HORT",
    "num": "325",
    "desc": "\nThis class will cover the history of organic farming principles, practices, and policies. USDA standards will be compared to similar standards in other countries, and to “green labels” that compete with organic products in the marketplace. Industry trends as well as the basics of how to certify farms and food processors will be included.",
    "credits": "2"
  },
  {
    "course_name": "Plant Propagation",
    "dept": "HORT",
    "num": "350",
    "desc": "Prerequisite: BIOL 198. Recommended prerequisite: HORT 201.\nDesigned to develop proficiency in various skills and techniques necessary for propagation of horticultural plants. Basic fundamentals of seed structure and vegetative makeup of plants are emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Public Horticulture",
    "dept": "HORT",
    "num": "360",
    "desc": "\nIn-depth presentation and discussion of techniques and requirements for the management and administration of a public horticultural facility.  Topics include oral and written presentation skills, proposal development, public relations, budgeting, fundraising, dealing with governing boards, interpersonal relationships and managing horticultural operations.",
    "credits": "3"
  },
  {
    "course_name": "Landscape Plants I",
    "dept": "HORT",
    "num": "374",
    "desc": "\nAn introduction to landscape plant identification of trees, shrubs, and cultivated herbaceous cultivated plants, including perennials, annuals, biennials, and bulbs. Topics covered in the course include classification and nomenclature, plant growth characteristics and their landscape use. Weekly labs consist of lengthy walking campus tours to observe and identify plant specimens. A field trip may be required.",
    "credits": "3"
  },
  {
    "course_name": "Landscape Plants II",
    "dept": "HORT",
    "num": "375",
    "desc": "\nContinued identification of cultivated landscape tree, shrubs, and herbaceous plants, including perennials, annuals, biennials, and bulbs. Topics covered in the course include classification and botanical nomenclature, plant growth characteristics and their landscape use.",
    "credits": "3"
  },
  {
    "course_name": "Interior Plantscaping",
    "dept": "HORT",
    "num": "377",
    "desc": "\nA study of the interior plantscaping industry to include identification of plants used in interior environments; designing, installing and maintaining interiorscapes and green walls; and managing interior plantscaping businesses.",
    "credits": "3"
  },
  {
    "course_name": "Horticulture Topics",
    "dept": "HORT",
    "num": "390",
    "desc": "Prerequisite: Consent of instructor.\nLectures and discussion of topics of importance to undergraduate majors.",
    "credits": "1-18"
  },
  {
    "course_name": "Water Issues in the Lawn and Landscape",
    "dept": "HORT",
    "num": "405",
    "desc": "\nThis course will examine critical water issues related to irrigation in urbanizing watersheds, with an emphasis on water quality and quantity. Factors impacting water scarcity and quality will be discussed. Successful completion of this course will help students understand the interrelatedness of incorrect irrigation practices and water quality/quantity, and will equip them to help protect water resources through application of science based irrigation practices.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research in Horticulture",
    "dept": "HORT",
    "num": "495",
    "desc": "Prerequisite: Instructor permission.\nUndergraduate students work with faculty mentors on projects involving various elements of research in horticultural science including identifying a problem, designing and conducting experiments, interpreting and communicating the research results. The completed project must be presented at a professional forum, and students are required to write a final project report on completion of their project.",
    "credits": "0-3"
  },
  {
    "course_name": "Sustainable Landscape Maintenance Practices",
    "dept": "HORT",
    "num": "508",
    "desc": "\nUnderstanding and implementing maintenance requirements for the care of young trees, shrubs and herbaceous plants that focus on practices that address environmental issues related to the management of residential and commercial landscapes. Students will learn how to analyze and apply landscape maintenance practices while creating an attractive landscape in balance with the local climate that requires minimal resource inputs, such as human energy, fertilizers, pesticides and water.",
    "credits": "2"
  },
  {
    "course_name": "Horticultural Design II",
    "dept": "HORT",
    "num": "510",
    "desc": "Prerequisite: HORT 275 and two plant materials courses.\nReinforcement of the horticultural design process as applied to the use of native and introduced plant materials. Emphasis on functional and aesthetic arrangement of plants in small-scale design to meet site design objectives and adaptation to microclimates.  Students expected to develop site adapted plant palettes and graphic ability to present their design.",
    "credits": "3"
  },
  {
    "course_name": "Basic Turfgrass Culture",
    "dept": "HORT",
    "num": "515",
    "desc": "\nTurfgrass identification and adaptation; establishment and maintenance of turf for golf courses, sports fields, home lawns, parks, and commercial/institutional grounds.",
    "credits": "3"
  },
  {
    "course_name": "Golf Course and Sports Turf Operations",
    "dept": "HORT",
    "num": "517",
    "desc": "\nStrategies involved in golf course and sports turf operation, including development of cultural practices, effective communication, personnel management, and budgeting.",
    "credits": "3"
  },
  {
    "course_name": "Fruit Production",
    "dept": "HORT",
    "num": "520",
    "desc": "Prerequisite: HORT 201 or equivalent.\nPrinciples and practices of cultivating fruit and nut crops commercially.  Laboratory offers experiences in pomological practices.",
    "credits": "3"
  },
  {
    "course_name": "Horticulture for Special Populations",
    "dept": "HORT",
    "num": "525",
    "desc": "\nAn intensive study of the concepts and methods of using plants and gardening as therapeutic activities with developmentally disabled, geriatric, economically and socially disadvantaged, emotionally disturbed, or educationally deprived clients.",
    "credits": "3"
  },
  {
    "course_name": "Horticultural Therapy Case Management",
    "dept": "HORT",
    "num": "530",
    "desc": "\nGuest lecturer and student presentations of topics relating to professionalism, current issues, or goals of horticultural therapy. The course is intended to help students focus expectations and assumptions about a professional career in horticultural therapy and to give them practice in articulating their understanding of the field. Client case management is used as part of career practice.",
    "credits": "1"
  },
  {
    "course_name": "Horticultural Therapy Field Techniques",
    "dept": "HORT",
    "num": "535",
    "desc": "Prerequisite: HORT 525.\nStudents under supervision will plan, conduct, and evaluate horticultural therapy activities at Manhattan institutional sites selected according to student’s interest. A weekly discussion session addresses evaluation and issues of professionalism.",
    "credits": "3"
  },
  {
    "course_name": "Horticultural Therapy Field Experiences",
    "dept": "HORT",
    "num": "540",
    "desc": "\nSupervised training at institutions with horticultural therapy programs to gain experience in the application and use of horticultural activities for special populations. Six months (1,000) hours continuous internships required in psychiatric and correctional programs.",
    "credits": "3 or 6"
  },
  {
    "course_name": "Computer Applications in Horticultural Design",
    "dept": "HORT",
    "num": "545",
    "desc": "Prerequisite: HORT 510, or instructor permission.\nIntroduction to a variety of computer software packages that students may encounter in the nursery/garden center environment. These include planning, routing, and estimating packages.",
    "credits": "3"
  },
  {
    "course_name": "Horticultural Irrigation Systems",
    "dept": "HORT",
    "num": "550",
    "desc": "\nApplication of the principles and practices of horticultural irrigation which involve the various aspects of irrigation system installation, maintenance and scheduling, electrical troubleshooting, basic hydraulics, and drip irrigation as these topics pertain to residential and commercial landscapes, recreational turf areas, and greenhouse and field production systems.",
    "credits": "3"
  },
  {
    "course_name": "The Business of Landscape Contracting",
    "dept": "HORT",
    "num": "551",
    "desc": "\nThe study of contracts and specifications, and the bidding and estimating processes as applied to landscape contracting.",
    "credits": "1"
  },
  {
    "course_name": "Horticultural Landscape Construction",
    "dept": "HORT",
    "num": "552",
    "desc": "\nThe interpretation and implementation of small-scale landscape construction (hardscape) projects.",
    "credits": "1"
  },
  {
    "course_name": "Vegetable Crop Production",
    "dept": "HORT",
    "num": "560",
    "desc": "Prerequisite: HORT 201.\nStudy of production principles and cultural practices involved in the growing of vegetable crops.",
    "credits": "3"
  },
  {
    "course_name": "Greenhouse Operations Management",
    "dept": "HORT",
    "num": "570",
    "desc": "Prerequisite: HORT 201.\nGreenhouse systems operations and management including greenhouse layout; structures; glazing materials; heating, ventilation, irrigation, lighting, benching, growing medium handling, and fertilization systems; traffic flow; crop handling, processing and shipping.",
    "credits": "3"
  },
  {
    "course_name": "Nursery Management",
    "dept": "HORT",
    "num": "575",
    "desc": "\nA study of the various practices and methods of operating a commercial nursery for the production of woody ornamental plants for the landscaping industry. Nursery layout, planting systems, nutrition management, plant maintenance, and harvesting technologies will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Horticultural Design",
    "dept": "HORT",
    "num": "580",
    "desc": "Prerequisite: HORT 510.\nEmphasis is on horticultural design projects with clients, working with the design process, design articulation and communication with the clients.",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Horticultural Pest Management",
    "dept": "HORT",
    "num": "582",
    "desc": "\nPesticide use and handling, horticultural pesticides and their characteristics, integrated pest management approaches, and pesticide applicator certification.",
    "credits": "1"
  },
  {
    "course_name": "Arboriculture",
    "dept": "HORT",
    "num": "585",
    "desc": "\nPrinciples and practices of maintaining shade and ornamental trees under urban environments.",
    "credits": "3"
  },
  {
    "course_name": "Turfgrass Diseases and Their Management",
    "dept": "HORT",
    "num": "587",
    "desc": "Prerequisite: HORT 582 or concurrent enrollment and HORT 515 or concurrent enrollment.\nBiology, diagnosis and integrated management of turfgrass diseases.  Emphasis is on diseases of intensively maintained turfgrass.",
    "credits": "1"
  },
  {
    "course_name": "Turfgrass Weeds and Their Management",
    "dept": "HORT",
    "num": "588",
    "desc": "Prerequisite: HORT 582 or concurrent enrollment and HORT 515 or concurrent enrollment.\nBiology, diagnosis and integrated management of turfgrass weeds.",
    "credits": "1"
  },
  {
    "course_name": "Turfgrass Insects and Their Management",
    "dept": "HORT",
    "num": "589",
    "desc": "Prerequisite: HORT 582 or concurrent enrollment and HORT 515 or concurrent enrollment.\nBiology, diagnosis and integrated management of turfgrass insect pests.",
    "credits": "1"
  },
  {
    "course_name": "Horticulture Internship",
    "dept": "HORT",
    "num": "590",
    "desc": "\nPrinciples of commercial or public horticulture activity including exposure to multiple phases of the working horticulture operation.",
    "credits": "2-6"
  },
  {
    "course_name": "Horticulture Study Abroad",
    "dept": "HORT",
    "num": "595",
    "desc": "Prerequisite: Instructor permission.\nSeminar and travel course designed to prepare students before an international study abroad experience focused on horticulture. Upon completion of travel, students will analyze, critique, and report their experiences. In addition, students will be introduced and immersed in historical components, both disciplinary and culturally.",
    "credits": "3"
  },
  {
    "course_name": "The Horticultural Professional",
    "dept": "HORT",
    "num": "599",
    "desc": "\nCompletion of horticulture program assessment tools. Completion of modules associated with professional development during careers in horticultural disciplines, including diversity and ethics in the workplace, job search skills, and providing leadership in the profession.",
    "credits": "0"
  },
  {
    "course_name": "Herbaceous Landscape Plant Production",
    "dept": "HORT",
    "num": "600",
    "desc": "\nThe principles and commercial practices for producing annual and herbaceous perennial plants from seed and cuttings, including vegetable and herb crops in controlled environments. Analysis of crop production costs and plant growth regulation will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Floral Crops Production and Handling",
    "dept": "HORT",
    "num": "625",
    "desc": "Prerequisite: HORT 201. Recommended prerequisite: HORT 350, BIOL 500, and HORT 570.\nThe principles and commercial practices for producing floral potted crops and fresh flowers crops, emphasizing the physical responses of plants to their environment. Aspects of postharvest physiology of fresh flowers will be covered.",
    "credits": "2"
  },
  {
    "course_name": "General Viticulture",
    "dept": "HORT",
    "num": "630",
    "desc": "\nFocus is on aspects of grapes, from vine anatomy to final products produced from them.  Includes cultivars, propagation, canopy management, diseases, weed control, physiology, anatomy, irrigation, wine production, climates and soils.",
    "credits": "3"
  },
  {
    "course_name": "Horticultural Problems",
    "dept": "HORT",
    "num": "640",
    "desc": "\nProblems and reports in floriculture, olericulture, ornamental horticulture, pomology, turfgrass and horticultural therapy.",
    "credits": "0-3"
  },
  {
    "course_name": "Introduction to Permaculture",
    "dept": "HORT",
    "num": "695",
    "desc": "\nExploration of a thinking/design methodology that seeks to provide for the physical needs of humans, including food, water, shelter, energy, etc. while doing so in an environmentally-friendly, sustainable manner.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Culture of Golf and Sports Turf",
    "dept": "HORT",
    "num": "706",
    "desc": "Prerequisite: HORT 515.\nAdvanced topics in golf and sports turf maintenance focusing on construction methods and management of abiotic and biotic stresses.",
    "credits": "3"
  },
  {
    "course_name": "Plant Cell, Tissue and Organ Culture",
    "dept": "HORT",
    "num": "710",
    "desc": "\nCourse will cover the principles and laboratory exercises that demonstrate major concepts and practical techniques in plant cell, tissue and organ culture. The history and use of plant cell-, tissue-, and organ-culture for crop improvement will be explained. The variety of tissue-culture techniques will be highlighted. Selected readings and practical tissue culture projects will be required.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Interiorscaping",
    "dept": "HORT",
    "num": "715",
    "desc": "\nFocus is the physiological principles and industry practices in the production, moving, care, and maintenance of interior plants.  This course will provide students the career tools to design, install and maintain interior plantscapes through knowledge of interior plant physiology, care and maintenance.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Nursery Production",
    "dept": "HORT",
    "num": "720",
    "desc": "\nCultural practices used with nursery production will be presented with focus on the adoption of best management practices, conservation of resources, scientific research-based investigations related to nursery cultural practices, potential risks to nursery personnel, and off-site movement of air-borne materials and effluents to surrounding areas and public watersheds.",
    "credits": "3"
  },
  {
    "course_name": "Postharvest Technology and Physiology of Horticultural Crops",
    "dept": "HORT",
    "num": "725",
    "desc": "Prerequisite: One horticulture commodity course and BIOL 500.\nA study of the principles and practices involved in the harvesting, handling and storage of horticultural products. The relationship of plant structure and physiology will be emphasized in discussing effects of postharvest handling and storage to maximize quality and shelf life of products.",
    "credits": "3"
  },
  {
    "course_name": "Human Issues in Horticultural Therapy",
    "dept": "HORT",
    "num": "751",
    "desc": "\nThis course will explore human issues in horticulture generally, and human issues in horticultural therapy specifically. Consideration of selected topics and issues such as people-plant relationship theories, horticultural therapy as a specialized allied health field, health-care gardens and their use, societal impacts on horticultural therapy, and research issues. Provides students with a knowledge and understanding of the literature in horticultural therapy and develops an appreciation of the interrelationships involved in this multidisciplinary area.",
    "credits": "3"
  },
  {
    "course_name": "Horticulture in Horticultural Therapy",
    "dept": "HORT",
    "num": "752",
    "desc": "\nApplication of horticulture principles and practices in therapeutic settings; considerations for greenhouse systems operations and management in therapeutic settings; landscape maintenance, fruit and vegetable gardening, and production horticulture as part of a therapeutic program; and plant propagation for production and therapy.",
    "credits": "3"
  },
  {
    "course_name": "Clinical Skills in Horticultural Therapy",
    "dept": "HORT",
    "num": "753",
    "desc": "\nDevelopment of horticultural therapy skills and methodology is facilitated through real-life case studies. Includes instruction, practice, and evaluation of clinical skills with population groups typically served through horticultural therapy.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Horticultural Therapy",
    "dept": "HORT",
    "num": "755",
    "desc": "\nThe practicum is a means of demonstrating the interconnections between ‘theory’ and ‘practice’. By conducting a practicum project, students demonstrate the ability to apply concepts and ideas from their study of horticultural therapy to a specific population or setting.",
    "credits": "3"
  },
  {
    "course_name": "Business Management for Horticultural Enterprises",
    "dept": "HORT",
    "num": "760",
    "desc": "\nFocus is on developing a detailed business plan for the service, design and production businesses in horticulture that incorporates considerations of start-up capitalization, insurance, investments, legal accounting and employee compensation.  Strategic decision-making and aspects of a horticulture firms that are unique to its industries, such as product seasonality and perishability, will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Plant Breeding Methods in Horticulture",
    "dept": "HORT",
    "num": "775",
    "desc": "\nFocus is on introductory plant breeding principles with emphasis on traditional methods of developing improved cultivars of crosspollinated, self-pollinated, and asexually-propagated horticultural crops, and the genetic principles on which breeding methods are based.  The course provides a general background in all areas of plant breeding as a foundation for mastering more complex breeding principles.",
    "credits": "3"
  },
  {
    "course_name": "Health-Promoting Phytochemicals: Fruits and Vegetables",
    "dept": "HORT",
    "num": "780",
    "desc": "Prerequisite: Senior standing and CHM 110 or CHM 210.\nThe course deals with various aspects of phytochemicals in plant-based foods including fruits and vegetables and their impact on human health and well-being. It includes potential effects of phytochemicals in promoting human health, preventing various diseases and fostering wellness. It also includes biosynthesis and metabolism of phytochemicals in plants. Emphasis is placed on developing strategies to improve the phytochemical content of food crops through approaches involving crop management, environmental and biotechnology tools.",
    "credits": "2"
  },
  {
    "course_name": "Sustainable Agriculture",
    "dept": "HORT",
    "num": "790",
    "desc": "\nHistorical perspectives of the sustainable agriculture movement in the United States and world-wide will be examined and critiqued.  Components of sustainable agriculture such as agroecosystem theory, permaculture, energy use efficiency, and organic standards will be compared and evaluated.  Students will demonstrate their understanding and application of the material by conducting research on a topic within sustainable agriculture and presenting the topic to the rest of the class.",
    "credits": "2"
  },
  {
    "course_name": "Urban Agriculture",
    "dept": "HORT",
    "num": "791",
    "desc": "\nStudents will become familiar with a wide variety of urban agriculture types and production systems utilized in urban settings. The course will include background readings, case studies, guest speakers, student-facilitated class discussions, and lectures.",
    "credits": "2"
  },
  {
    "course_name": "Urban Food Production Practicum",
    "dept": "HORT",
    "num": "792",
    "desc": "\nStudents will complete a 400 hour practicum in an approved urban agriculture setting to gain exposure to a broad range of tasks facing the urban farmer. This includes planning, production and marketing of crops in high tunnels and open field.",
    "credits": "1"
  },
  {
    "course_name": "Farm to Fork Produce Safety",
    "dept": "HORT",
    "num": "793",
    "desc": "\nThis course will cover all aspects of food safety for fresh produce grown in urban and rural environments, including pathogen ecology and production aspects as well as pre-harvest and postharvest factors that influence the risk of microbial contamination. More specifically, we will discuss ways to minimize the risk of human pathogens on fresh produce using strategies such as the implementation of Good Agricultural Practices (GAPs) and Good Handling Practices (GHPs). The course will cover postharvest interventions that are currently used (chemical sanitizers) as well as innovative technology applications like physical treatments, irradiation, and biological control techniques. Additionally, students will explore the impact of food borne outbreaks on public health and the fresh produce industry in terms of economics, consumer acceptance, and legal aspects.",
    "credits": "2"
  },
  {
    "course_name": "Urban Food Systems",
    "dept": "HORT",
    "num": "794",
    "desc": "\nThis course will cover all components of urban food systems through the lens of food security, food justice, access, policy, and community planning. Students will gain skills in grant-writing, non-profit planning and management, and working with urban policy and planning boards.",
    "credits": "2"
  },
  {
    "course_name": "Urban Agriculture Study Tour",
    "dept": "HORT",
    "num": "795",
    "desc": "Prerequisite: Instructor’s permission.\nFaculty-led trip for students to explore leading examples of urban agriculture. Each year, a trip will occur within North America, lasting approximately 7 days. The study tours will focus on urban food system development in major cities and will highlight examples of how food is being grown in urban areas and the impacts that it has on the community.",
    "credits": "1"
  },
  {
    "course_name": "Professional Development in Urban Food Systems",
    "dept": "HORT",
    "num": "796",
    "desc": "\nA team instructed seminar course that provides urban food systems students with a suite of skills complimentary to their research experience but still necessary for professional career success.",
    "credits": "0-1"
  },
  {
    "course_name": "Introduction to Digital Applications",
    "dept": "IAPD",
    "num": "210",
    "desc": "Prerequisite: Admission to the professional program in interior architecture and product design.\nThis course introduces basic design software skills in development of both 3D digital models and 2D graphics renderings and diagramming. Additionally, this course introduces best practices with regard to basic computer skills (ie, assembly, file management, etc.).",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Architectural Technology",
    "dept": "IAPD",
    "num": "248",
    "desc": "Prerequisite: PHYS 115 or 113 and admission to a professional program in the college.\nInstruction in the fundamentals of architectural technology with emphasis on the concepts and principles necessary for developing an integrated approach to building design.",
    "credits": "3"
  },
  {
    "course_name": "Design and Material Culture",
    "dept": "IAPD",
    "num": "300",
    "desc": "\nPeople’s personal characteristics or social position can be expressed by the products they purchase, the possessions they own, and the physical environments they create. Design has become a major factor influencing one’s final decision for purchasing these products. This course examines material culture which is created from the influences of human behavior, design, history, marketing, economics, politics, geography, the arts, and sociology.",
    "credits": "3"
  },
  {
    "course_name": "IAPD Design Studio I",
    "dept": "IAPD",
    "num": "307",
    "desc": "Prerequisite: Admission to the professional program in interior architecture and product design.\nGeneration of design concept, design process, and design alternatives for small-scale projects including living environments. Introduction to basic design theory, beginning design research, human scale, behavior and anthropometrics as they affect design decisions. Introduction of structure and environmental analysis as informants and determinants of design. Focus on multiple graphic representations and compositions, including diagramming, sketching, freehand drawing, and enhancing through digital means.",
    "credits": "5"
  },
  {
    "course_name": "Digital Applications",
    "dept": "IAPD",
    "num": "310",
    "desc": "Prerequisite: Admission to the professional program in interior architecture and product design.\nThis course addresses current digital media as it is used by the profession to draft and visualize design projects. Survey a wide variety of contemporary design and visualization software. The intention is not mastery of any single software but instead to form an understanding of the interface and use of the tools and when they are appropriate. Enable the thoughtful discussion and understanding of design representation and process in both drafting and visualization. Enable and empower the student to comfortably engage design software as they continue to evolve.",
    "credits": "2"
  },
  {
    "course_name": "IAPD Design Studio II",
    "dept": "IAPD",
    "num": "320",
    "desc": "Prerequisite: IAPD 307; no grade lower than a C in any interior architecture and product design studio course.\nIntroductory Product Design studio that explores the design and development of human scale consumer products with focus on human-centered need and desire satisfaction; physical, cognitive and emotional/behavioral ergonomics; architectural context; usability; human interface and experience; technology exploration; and final modeling. Introduction to empathetic and ethnographic research methods.",
    "credits": "5"
  },
  {
    "course_name": "Topics in Contemporary Design Seminar",
    "dept": "IAPD",
    "num": "391",
    "desc": "Prerequisite: Open to non-majors accepted in the College of Architecture, Planning and Design; third-year standing.\nSeminar on current interior architecture, product design, and furniture design that illustrate principles and practical concerns that motivate design with readings, class discussion, student presentations, research papers or projects.",
    "credits": "3"
  },
  {
    "course_name": "Problems in IAPD",
    "dept": "IAPD",
    "num": "406",
    "desc": "Prerequisite: ENVD 201.\nStudy of specific interior architectural problems under direct supervision of a member of the department.",
    "credits": "1-18"
  },
  {
    "course_name": "Design Workshop I",
    "dept": "IAPD",
    "num": "407",
    "desc": "Prerequisite: IAPD 409, IAPD 435. Corequisite: IAPD 412.\nAn introduction to shop procedures, equipment, design materials, joinery, and elementary design experiences in turning and shaping various materials. The course also includes identification and application of specific interior finishes and provides the student the opportunity through a series of small projects to be exposed to the total creative design process by researching, designing, constructing, and evaluating finished products.",
    "credits": "3"
  },
  {
    "course_name": "Materials and Finishes",
    "dept": "IAPD",
    "num": "409",
    "desc": "Prerequisite: Admission to the professional program in interior architecture and product design.\nIntroduction to materials, textiles, and finishes specific to interior applications. Criteria for evaluation, selection, and application of interior materials and finishes with the building fabric and their impact on building design. Preparation of written and graphic communications to illustrate and direct the construction process.",
    "credits": "3"
  },
  {
    "course_name": "Interior Architecture Digital Applications",
    "dept": "IAPD",
    "num": "410",
    "desc": "Prerequisite: IAPD 307 and admission to the professional program in interior architecture and product design.\nIntroduction to software and digital means to investigate, visualize, model, and represent design.",
    "credits": "3"
  },
  {
    "course_name": "Drawing in Black and White",
    "dept": "IAPD",
    "num": "411",
    "desc": "Prerequisite: Third-year standing.\nFreehand representational drawing of architectonic space using graphite pencil and ink pen. Emphasis is on the development of the visual perception of space and the communication of the perceived space through drawings that are clear and expressive.",
    "credits": "3"
  },
  {
    "course_name": "Design Workshop I Studio",
    "dept": "IAPD",
    "num": "412",
    "desc": "Corequisite: IAPD 407.\nExploration of design alternatives; process, presentation and construction graphics communicating design.",
    "credits": "1"
  },
  {
    "course_name": "History of Furniture",
    "dept": "IAPD",
    "num": "416",
    "desc": "Prerequisite: IAPD 320.\nExploration of furniture history from prehistory to the present. Focus on socio-cultural, architectural, technological, material culture, manufacturing, spiritual, aesthetic, sustainable factors over the human timeline.",
    "credits": "3"
  },
  {
    "course_name": "Theory of Furniture Design",
    "dept": "IAPD",
    "num": "420",
    "desc": "Prerequisite: Admission to the professional program in architecture, interior architecture, or landscape architecture.\nAnalysis, materials, and construction techniques from the early American period through the contemporary movement, with a focus on contemporary furniture design from the 1960’s to the present.",
    "credits": "2"
  },
  {
    "course_name": "Visual Communication",
    "dept": "IAPD",
    "num": "430",
    "desc": "Prerequisite: ENVD 202.\nStudents will be challenged to visualize and communicate in both two- and three-dimensional languages using diagramming and freehand perspective. Students use simple form models and cameras as tools to attain rapid graphic images. Various media is studied enabling quick exploration of multiple design options in a spatial environment. Emphasis is placed on two-dimensional graphics in storytelling using diagrams to describe and analyze the design and build process. Quick ideation sketching to record and refine design solutions. Color theory is introduced with Munsell and Pantone systems and applied throughout the semester.",
    "credits": "2"
  },
  {
    "course_name": "Visual Communications II",
    "dept": "IAPD",
    "num": "431",
    "desc": "Prerequisite: IAPD 430\nProvides an advanced understanding of design visualization and presentation. Introduces a variety of 3D modeling and rendering software commonly used in the Industrial and Product Design field. Explores digital form development, materials representation, perceptual education and visual communication.",
    "credits": "2"
  },
  {
    "course_name": "IAPD Design Studio III",
    "dept": "IAPD",
    "num": "435",
    "desc": "Prerequisite: IAPD 320, no grade lower than a C in any interior architecture and product design studio course.\nIntermediate product design studio focusing on projects involving products and their associated contextual spatial environments. Projects incorporate object scale product solutions, and include a ‘near environment’, within-reach sphere of human influence. Students follow the industrial design process from identification of opportunity; research around user, market, environment and technology; the iterative creative, ideation and prototyping process; and finally, commercial implementation.",
    "credits": "5"
  },
  {
    "course_name": "IAPD Design Studio IV",
    "dept": "IAPD",
    "num": "440",
    "desc": "Prerequisite: IAPD 435, no grade lower than a C in any interior architecture and product design studio course.\nThis course will build upon and extend the knowledge and skill base gained by students in previous studios, and will include the introduction of programming methodology and its relationship to the design and organization of interior space. Emphasis will be placed on an understanding of how human behavior affects the designed environment, including the elements and objects that shape it such as the appropriate selection of furniture, finishes, fixtures, and equipment within the context of their relationships to form, function, task and users’ needs.",
    "credits": "5"
  },
  {
    "course_name": "Product Design Illustration",
    "dept": "IAPD",
    "num": "455",
    "desc": "Prerequisite: IAPD 420.\nExercises in various rendering techniques and involvement in different media presentations associated with product design.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Product/Industrial Design",
    "dept": "IAPD",
    "num": "456",
    "desc": "Prerequisite: IAPD 307.\nIntroduction to the Profession of Product/Industrial Design including history; major movements; key practitioners; socio-cultural, architectural and technological drivers; unique design/make processes and methodologies; materials and manufacturing techniques; and, contemporary issues.",
    "credits": "2"
  },
  {
    "course_name": "Design Graphics Workshop",
    "dept": "IAPD",
    "num": "520",
    "desc": "Prerequisite: Junior standing.\nA course in the use of colored pencils, to render and present form and space using different techniques. Emphasis on the visual perception and composition of elements in design drawings and presentation.",
    "credits": "3"
  },
  {
    "course_name": "Problems in IAPD",
    "dept": "IAPD",
    "num": "605",
    "desc": "\nStudy of specific problems related to interior architecture, product design, and furniture design.",
    "credits": "1-18"
  },
  {
    "course_name": "IAPD Design Studio VI",
    "dept": "IAPD",
    "num": "606",
    "desc": "Prerequisite: ARCH 433 and IAPD 801, and no grade lower than a C in any interior architecture and product design studio course.\nThis semester of study provides an option for an interdisciplinary collaborative studio course oriented towards replicating the learning experience and interactive activities that takes place in the modern multidisciplinary professional office or a validated equivalent studio completed in an approved study program.",
    "credits": "5"
  },
  {
    "course_name": "Advanced Digital Applications and Fabrications",
    "dept": "IAPD",
    "num": "610",
    "desc": "\nExploration of advanced representation and fabrication techniques for the design professions.",
    "credits": "3"
  },
  {
    "course_name": "Lighting",
    "dept": "IAPD",
    "num": "625",
    "desc": "Prerequisite: IAPD 435 or INDD 435.\nAn examination of design and technical issues related to luminous environments in building interiors. Topics include color and light, vision, light sources, luminaire selection and design, and the evaluation of lighting solutions.",
    "credits": "3"
  },
  {
    "course_name": "Building Construction Systems IA",
    "dept": "IAPD",
    "num": "628",
    "desc": "Prerequisite: IAPD 435.\nA technical capstone course that explores the development of construction documentation for interior architecture projects includes demolition, partition, and reflected ceiling plans, power and communications plans, finish and furnishings plans, interior elevations, sections, details, and schedules. Understanding of the mechanical, electrical, plumbing and structural systems, as well as building and life-safety codes, and the Americans with Disabilities Act will be demonstrated through completion of the set of drawings.",
    "credits": "3"
  },
  {
    "course_name": "Internship",
    "dept": "IAPD",
    "num": "644",
    "desc": "Prerequisite: IAPD 440 or INDD 440.\nFifteen week internship in a professional environment with a focus on Interior Architecture, Product/Industrial Design and/or Furniture Design: office and field experience.",
    "credits": "9"
  },
  {
    "course_name": "Internship Report",
    "dept": "IAPD",
    "num": "645",
    "desc": "Corequisite: IAPD 644.\nDevelopment of the student’s analysis; observation, and communication skills in relationship to the professional office and field environment. Detailed documentation, online and on-campus, of the experiences encountered during internship, allowing classmates to learn from their peer’s varied experiences as well as provide a detailed documentation of the student’s work during internship.",
    "credits": "5"
  },
  {
    "course_name": "Summer Internship",
    "dept": "IAPD",
    "num": "664",
    "desc": "Prerequisite: IAPD 440, IAPD 440 or INDD 440 and IAPD 628 and no grade lower than a C in any IAPD or INDD studio course.\nTen week internship in a professional environment with a focus on Interior Architecture, Industrial/Product Design and/or Furniture Design: office and field experience.",
    "credits": "6"
  },
  {
    "course_name": "Summer Internship Report",
    "dept": "IAPD",
    "num": "665",
    "desc": "Corequisite: IAPD 664.\nDevelopment of the student’s analysis, observation, and communication skills in relationship to the professional office and field environment. Detailed documentation, online and on-campus, of the experiences encountered during internship, allowing classmates to learn from their peer’s varied experiences as well as provide a detailed documentation of the student’s work during internship.",
    "credits": "1"
  },
  {
    "course_name": "Study Abroad Experience",
    "dept": "IAPD",
    "num": "668",
    "desc": "\nCourses taken from a university in an approved foreign studies program.",
    "credits": "1-18"
  },
  {
    "course_name": "Production Furniture for the Contract Market Research",
    "dept": "IAPD",
    "num": "680",
    "desc": "\nIntroduction and implementation of market research; client end-user research; manufacturing implications; BIFMA and other testing requirements; and, competitive market analysis and implications to develop a complete “design brief” for a line of contract furniture within a major manufacturer’s existing line.",
    "credits": "1"
  },
  {
    "course_name": "Production Furniture for the Contract Market Design",
    "dept": "IAPD",
    "num": "681",
    "desc": "Prerequisite: IAPD 680.\nThis course builds upon the knowledge gained and the design brief developed in IAPD 680, Production Furniture for the Contract Market Research and develops the designers’ understanding of intersecting forces affecting the design of a line of furniture, from conception to final production. Students work in teams with a manufacturer in the design and development of a line/family of products-expectations of design, prototyping, royalties and licensing-as well as the manufacturing processes and knowledge of effectively specifying furnishings.",
    "credits": "2"
  },
  {
    "course_name": "Advanced 3-D Computer Modeling",
    "dept": "IAPD",
    "num": "710",
    "desc": "Prerequisite: IAPD 410.\nLighting, materials, animation, advanced modeling techniques, sound, and storyboarding are methodologies required to successfully build a digital presentation for projection in a two dimensional, or 3-dimensional environment using the vision domes. Projects that utilize these topics will include an introduction to 3D modeling, animation, sound, titling, lighting, and a material editor.",
    "credits": "3"
  },
  {
    "course_name": "Product Design Studio",
    "dept": "IAPD",
    "num": "740",
    "desc": "Prerequisite: Admission to the professional program in interior architecture and product design.\nAdvanced design projects involving products related to the interior environment. Synthesis of the design, materials, construction and finishing of prototype products relevant to human use.",
    "credits": "1-5"
  },
  {
    "course_name": "Professional Practice: Professional Responsibility",
    "dept": "IAPD",
    "num": "753",
    "desc": "\nInterdisciplinary course addresses the connections between allied design professions and the larger community. It helps students to understand and appreciate their professional legal and ethical responsibilities.",
    "credits": "1"
  },
  {
    "course_name": "Professional Practice: Office Practices",
    "dept": "IAPD",
    "num": "754",
    "desc": "\nInterdisciplinary course addresses practice-based issues concerning professional relationships in the design and delivery process, management of projects, communication practices, and fiscal concerns.",
    "credits": "1"
  },
  {
    "course_name": "Professional Practice: Discipline-Specific Topics",
    "dept": "IAPD",
    "num": "755",
    "desc": "\nCovers discipline-specific concerns, focusing on issues specific to architecture, interior architecture and product design, landscape architecture or regional and community planning.",
    "credits": "1"
  },
  {
    "course_name": "Theory of Product Design",
    "dept": "IAPD",
    "num": "756",
    "desc": "Prerequisite: Graduate standing.\nIntroduction to the Profession of Product/Industrial Design including history; major movements; key practitioners; socio-cultural, architectural and technological drivers; unique design/make processes and methodologies; materials and manufacturing techniques; and, contemporary issues.",
    "credits": "2"
  },
  {
    "course_name": "IAPD Seminar",
    "dept": "IAPD",
    "num": "760",
    "desc": "Prerequisite: Graduate standing.\nReadings and discussion of contemporary thought and movements within the field of interior architecture and product design with special emphasis on the societal factors that produce and effect change.",
    "credits": "0-18"
  },
  {
    "course_name": "IAPD Design Studio V",
    "dept": "IAPD",
    "num": "801",
    "desc": "Prerequisite: IAPD 440 and no grade lower than a C in any IAPD studio course.\nThis semester of study provides an option for an interdisciplinary collaborative studio course oriented towards replicating the learning experience and interactive activities that takes place in the modern multi-disciplinary professional office.",
    "credits": "5"
  },
  {
    "course_name": "Design Workshop II",
    "dept": "IAPD",
    "num": "802",
    "desc": "Prerequisite: IAPD 407, IAPD 412, and no grade lower than a C in any IAPD or INDD studio course.\nDesign Workshop II is intended to further develop the student’s understanding of the three dimensional design process through research, design, prototype construction, evaluation, and redesign. Enhance and increase the student’s understanding of the structural characteristics of materials.",
    "credits": "3"
  },
  {
    "course_name": "Design Workshop II Studio",
    "dept": "IAPD",
    "num": "803",
    "desc": "Prerequisite: IAPD 412, IAPD 407 and no grade lower than a C in any IAPD or INDD studio course.\nStudio component of Design Workshop II. Exploration of design alternatives; process, presentation and construction graphics, students increase their proficiency at communicating ideas through working and presentation drawings for projects to be created in IAPD 802: Design Workshop II.",
    "credits": "1"
  },
  {
    "course_name": "IAPD Capstone Studio",
    "dept": "IAPD",
    "num": "810",
    "desc": "Prerequisite: IAPD 801, IAPD 811.\nStudents are to pursue design projects that encompass their previous educational experience validating their knowledge of the IAPD program studies. The project will be based on extensive research and review. The project presentation will suggest unique and applicable solutions with clearly identified methodology of implementation.",
    "credits": "5"
  },
  {
    "course_name": "Design Research",
    "dept": "IAPD",
    "num": "811",
    "desc": "Prerequisite: IAPD 440.\nIdentify evaluation criteria appropriate for design research and problem solving; analysis of literature; construction of problem statements, development and documentation of design problem proposals and reports.",
    "credits": "2"
  },
  {
    "course_name": "Furniture Design Workshop Studio",
    "dept": "IAPD",
    "num": "813",
    "desc": "Prerequisite: IAPD 603.\nStudio component of IAPD 814 Furniture Design Workshop. Exploration of contemporary design alternatives, students explore innovation and demonstrate knowledge through design processes and including process, presentation and construction graphics for projects to be created in IAPD 814: Furniture Design Workshop.",
    "credits": "1"
  },
  {
    "course_name": "Furniture Design Workshop",
    "dept": "IAPD",
    "num": "814",
    "desc": "Prerequisite: IAPD 602.\nDesign, construction, and finishing of contemporary furniture and accessories.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Studio Programming",
    "dept": "IAPD",
    "num": "815",
    "desc": "Prerequisite: IAPD 801.\nResearch of programming methodologies culminating in a programmatic document used as the basis for the design project in IAPD 822, 823, or 824.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Seminar in IA",
    "dept": "IAPD",
    "num": "820",
    "desc": "\nAdvanced readings and discussions of environmental issues related to the practice of interior architecture. Readings, discussions, reports.",
    "credits": "0-18"
  },
  {
    "course_name": "Advanced IAPD Design Studio",
    "dept": "IAPD",
    "num": "821",
    "desc": "\nAdvanced study of interior space planning, product design, and interior design.",
    "credits": "0-18"
  },
  {
    "course_name": "Advanced Product Design Studio",
    "dept": "IAPD",
    "num": "822",
    "desc": "Prerequisite: IAPD 810, IAPD 815.\nStudents explore projects programmed under the previous semester IAPD 815: Advanced Studio Programming. Projects must be relevant in a contemporary socio-cultural, architectural and technological context; employ rigorous design research processes and methodologies; identify user and usability needs/desires; accommodate market opportunities and constraints; explore multiple conceptual solutions in a variety of hand and digital media; build and document models and prototypes; and estimate material and manufacturing costs.",
    "credits": "6"
  },
  {
    "course_name": "Advanced Interior Architecture Design Studio",
    "dept": "IAPD",
    "num": "823",
    "desc": "Prerequisite: IAPD 810, IAPD 815.\nStudents explore projects programmed under the previous semester IAPD 815 Advanced Studio Programming. Projects focus on Interior Architecture represent a suitable design relevancy and proper academic rigor on the level of graduate design study. Design solutions must be relevant in a contemporary socio-cultural and architectural context; employ rigorous design research processes and methodologies; respond to user needs and desires; explore multiple innovative conceptual solutions in a variety of hand and digital media; and illustrate advanced knowledge and application of materiality, understanding of structural and building environmental systems’ implication on interior architecture, and the selection or design of furnishings that enhance the goals for the spaces.",
    "credits": "6"
  },
  {
    "course_name": "Advanced Furniture Design Studio & Workshop",
    "dept": "IAPD",
    "num": "824",
    "desc": "Prerequisite: IAPD 810 or INDD 810, IAPD 815 or INDD 815.\nAdvanced design, construction, and finishing of contemporary furniture. Students explore projects programmed under the previous semester’s Advanced Studio Programming. Projects must be relevant in a contemporary socio-cultural, architectural and technological context; employ rigorous design research processes and methodologies; identify user and usability needs/desires; accommodate market opportunities and constraints; explore multiple conceptual solutions in a variety of hand and digital media; and demonstrate experimentation in the design of spatial components utilizing advanced construction techniques and materials through the development and documentation of models and prototypes.",
    "credits": "6"
  },
  {
    "course_name": "Problems in IAPD",
    "dept": "IAPD",
    "num": "830",
    "desc": "Prerequisite: Graduate standing.\nStudy of specific interior architectural problems under direct supervision of the departmental staff.",
    "credits": "1-18"
  },
  {
    "course_name": "Facilities Management",
    "dept": "IAPD",
    "num": "831",
    "desc": "\nA survey of the methods of managing the physical assets of large facilities-corporate, institutional, and governmental-through a review of current literature, presentations by professionals active in the field, and case studies.",
    "credits": "2"
  },
  {
    "course_name": "Professional Practice",
    "dept": "IAPD",
    "num": "853",
    "desc": "Prerequisite: Fifth-year standing.\nStudies of conventional and newly developing modes of professional design practice. presented are the relationships of interior architects, architects, and landscape architects and other design professionals to users, clients, building industry, society, government, and one another.",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Design Seminar",
    "dept": "IAPD",
    "num": "891",
    "desc": "Prerequisite: Graduate standing.\nSeminar on current interior architecture, product design, and furniture design that illustrate principles and practical concerns that motivate design with readings, class discussion, student presentations, research papers or projects.",
    "credits": "3"
  },
  {
    "course_name": "First Year ID Student Seminar",
    "dept": "ID",
    "num": "115",
    "desc": "Prerequisite: Admission to the Interior Design Program.\nFirst Year Seminar is structured to engage and support students during their first semester of study. The course is focused on learning strategies and resources that build toward successful outcomes for the remainder of their college studies.",
    "credits": "1"
  },
  {
    "course_name": "Design and Behavior in the Interior Environment",
    "dept": "ID",
    "num": "210",
    "desc": "\nDeveloping awareness of aesthetic and behavioral relationships fundamental to interior design.",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio 1",
    "dept": "ID",
    "num": "225",
    "desc": "Prerequisite: Admission to the College of Health and Human Sciences interior design program.\nIntroduction to two-dimensional and three-dimensional design fundamentals including design elements and principles. Introduction to the design process.  Introduction to interior design theory and its application. Introduction to fundamental design communication methods including drawing and model building.",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio 2",
    "dept": "ID",
    "num": "245",
    "desc": "Prerequisite: ID 225 with a C or better.\nExploration of two-dimensional and three-dimensional design fundamentals. Introduction to color theory in spatial design. Introduction to light, shade, and shadow. Introduction to rendering, constructed perspective, and paraline drawing.",
    "credits": "4"
  },
  {
    "course_name": "Global Experiences in Interior Design",
    "dept": "ID",
    "num": "300",
    "desc": "Prerequisite: Instructor’s permission.\nAn experiential learning course that prepares students for and immerses them in an international study tour designed to enhance their global and cultural awareness. Lectures and tours target important interior/architectural design, furniture, and objects of material culture.",
    "credits": "1-3"
  },
  {
    "course_name": "Construction Methods and Materials for Interior Design",
    "dept": "ID",
    "num": "310",
    "desc": "Prerequisite: ID 245 and ID 350 with C or better.\nIntroduction to theories, concepts, selection, and application of construction processes, materials, and finishes.  Introduction to codes, regulations, representation of construction methods, and sustainability.",
    "credits": "4"
  },
  {
    "course_name": "History of Interior Design I",
    "dept": "ID",
    "num": "320",
    "desc": "Prerequisite: HIST 101 and ART 196.\nA historic survey of all aspects of the built environment, including architecture, furniture, textiles, and the minor arts from antiquity to 1850.",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio 3",
    "dept": "ID",
    "num": "325",
    "desc": "Prerequisite: ID 245 with a C or better.\nAdvanced spatial design fundamentals.  Application of human factors and theories of human behavior in the built environment.  Selection of materials and colors.  Emphasis on design conceptualization and creativity.  Advanced visual communication methods including perspective drawing and rendering and other rapid visualization skills.",
    "credits": "4"
  },
  {
    "course_name": "Textiles for Interior Design",
    "dept": "ID",
    "num": "330",
    "desc": "\nIntroduction to textiles for interior environments, with a focus on the fabrication and application of materials designed specifically for use as upholstery, window coverings, soft floor coverings, wall coverings, panel systems, and other miscellaneous interior applications.  Also includes the regulatory, environmental, and human health impacts of textile production, application, and maintenance.",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio 4",
    "dept": "ID",
    "num": "345",
    "desc": "Prerequisite: ID 310 and 325 with a C or better.\nApplication of interior design theory and evidence-based design in small scale projects. Introduction of project programming for interior design. Application of codes and regulations. Continued emphasis on design communication skills.",
    "credits": "3"
  },
  {
    "course_name": "Our Sustainable World: Current Challenges and Future Opportunities",
    "dept": "ID",
    "num": "350",
    "desc": "\nSustainability has become one of the most pressing scientific and social challenges of the modern era. This course introduces students to the theory, principles, and practices of sustainability - by focusing on environmental, social, and economic sustainability perspectives, behaviors, policies, and customs on a global level. It includes discussions on creating ecological health, economic welfare, and social justice.",
    "credits": "3"
  },
  {
    "course_name": "History of Interior Design II",
    "dept": "ID",
    "num": "360",
    "desc": "Prerequisite: ID 320.\nA survey of design evolution of architecture, interiors, furniture, textiles, and the minor arts from 1850 to the present.",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Practicum",
    "dept": "ID",
    "num": "399",
    "desc": "Prerequisite: ID 345 and 415 with a C or better.\nSupervised off-campus professional experience in an appropriate design-related setting.",
    "credits": "1-2"
  },
  {
    "course_name": "Housing and Its Environment",
    "dept": "ID",
    "num": "410",
    "desc": "Prerequisite: Junior standing.\nSocioeconomic, political-legal, and consumer overview of housing. Includes individual, family, and public decisions related to residential alternatives, their acquisition, and housing and environmental standards.",
    "credits": "3"
  },
  {
    "course_name": "Computer-Aided Visual Communication in Interior Design",
    "dept": "ID",
    "num": "415",
    "desc": "Prerequisite: ID 310 and 325 with a C or better.\nIntroduction to and application of digital technologies used by interior design professionals.",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio 5",
    "dept": "ID",
    "num": "425",
    "desc": "Prerequisite: ID 345 and 415 with a C or better.\nApplication of theory and research in medium scale projects. Focus on construction systems, materials, and methods. Continued emphasis on communication skills, programming, spatial design, and application of codes and regulations.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Systems for Interior Design",
    "dept": "ID",
    "num": "435",
    "desc": "Prerequisite: PHYS 101 and 103 or PHYS 115; ID 345, ID 350, and ID 415 with a C or better.\nIntroduction to the principles of lighting, daylighting, acoustics, thermal comfort, and indoor air quality to enhance the health, safety, welfare, and performance of building occupants.",
    "credits": "3"
  },
  {
    "course_name": "Lighting for Interiors",
    "dept": "ID",
    "num": "440",
    "desc": "\nIntegration and application of technical, functional, and aesthetic considerations in lighting design with an emphasis on selection and specification.",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio 6",
    "dept": "ID",
    "num": "445",
    "desc": "Prerequisite: ID 425 and 435 with a C or better.\nDevelopment of working drawings and specifications for projects integrating building systems and interior construction.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Interior Design",
    "dept": "ID",
    "num": "499",
    "desc": "Prerequisite: Consent of instructor.\nIndependent study.",
    "credits": "1-18"
  },
  {
    "course_name": "Intermediate Interior Design Studio",
    "dept": "ID",
    "num": "500",
    "desc": "Prerequisite: ID 315, ID 345, ID 435, and admitted to the interior design major.\nProblem-solving in interior design.  May substitute for Interior Design studio ID 445, ID 545, or ID 645.  Students should plan to substitute this course for the next level studio in sequence.",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Practices and Procedures",
    "dept": "ID",
    "num": "530",
    "desc": "Prerequisite: ID 425 with a C or better and admission to the interior design program.\nEthics, business procedures, and professional development; contract services and administration; and preparation for job market entry as applied to the practice of interior design.",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio 7",
    "dept": "ID",
    "num": "545",
    "desc": "Prerequisite: ID 445 and 530 with a C or better.\nApplication of design theory to create solutions for complex, large-scale interior spaces. Projects require implementation of all phases of the design process. Students will gain greater understanding of the interior designer’s responsibilities within the context of the design professions.",
    "credits": "4"
  },
  {
    "course_name": "Interior Design Internship",
    "dept": "ID",
    "num": "599",
    "desc": "Prerequisite: ID 445 and ID 530 with a C or better and admission to the interior design program and a 2.2 cumulative GPA and 2.5 GPA in professional areas.\nSupervised off-campus professional experience in appropriate design-related firms, government agencies, or the housing industry.",
    "credits": "3-4"
  },
  {
    "course_name": "Interior Design Study Tour",
    "dept": "ID",
    "num": "600",
    "desc": "Prerequisite: Instructor’s permission.\nSupervised off-campus tour to acquaint the student with rich artistic and cultural locations around the world and expand student’s global perspectives of the design profession. Lectures and tours target important interior/architectural design and furniture collections.",
    "credits": "1-3"
  },
  {
    "course_name": "Topics in Advanced Interior Design Theory",
    "dept": "ID",
    "num": "630",
    "desc": "Prerequisite: ID 345 with a C or better.\nAn examination of contemporary social and cultural influences on design theory and applications within the interior design profession.",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio 8",
    "dept": "ID",
    "num": "645",
    "desc": "Prerequisite: ID 445 and 530 with a C or better.\nApplication of design theory to create solutions for complex, large-scale interior spaces. Projects will conform to professional standards regarding design process, protection of health, safety, and welfare, and construction methods.",
    "credits": "4"
  },
  {
    "course_name": "Advanced Design and Behavior in the Interior Environment",
    "dept": "ID",
    "num": "650",
    "desc": "Prerequisite: ID 345 or consent of instructor.\nThe design of interior environments explored in an ecological, behavioral, and cultural context.",
    "credits": "3"
  },
  {
    "course_name": "Design for Supportive Environments",
    "dept": "ID",
    "num": "651",
    "desc": "Prerequisite: ID 345 with a C or better.\nAnalysis of the age and ability related needs and challenges faced by children, older adults, and persons with disabilities. Team approaches to providing living and work environments that accommodate both universal and special human needs.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Kitchen and Bath Design",
    "dept": "ID",
    "num": "660",
    "desc": "Prerequisite: ID 345 and ID 435 with a C or better and admission to the interior design program.\nFunctional and research basis for planning and arranging based on activity analysis, equipment, materials, lighting, and ventilation.",
    "credits": "3"
  },
  {
    "course_name": "Historic Fabric Design",
    "dept": "ID",
    "num": "680",
    "desc": "Prerequisite: HIST 101; and AT 260; or AT 265 and AT 266.\nInterrelationships of fabric design and social, cultural, political, economic, and geographical environments from prehistoric times to present.",
    "credits": "3"
  },
  {
    "course_name": "Housing and Facilities Management Processes/Applications",
    "dept": "ID",
    "num": "710",
    "desc": "Prerequisite: ID 410, MANGT 420 or 720, and consent of instructor.\nApplication of theories, principles, and practices used in managing physical facilities and the residents or workers they house. Issues and problems encountered by professional managers in providing quality living or working environments within cost-effective operations.",
    "credits": "3"
  },
  {
    "course_name": "Community Housing Assessment",
    "dept": "ID",
    "num": "725",
    "desc": "Prerequisite: ID 410 or instructor consent.\nDeveloping local and regional housing needs assessments and strategies to meet the challenges faced by lower-income people and racial and ethnic minorities. Analysis of current housing and community development programs and public-private partnerships for affordable housing.",
    "credits": "3"
  },
  {
    "course_name": "Historic Preservation and Restoration of Interiors",
    "dept": "ID",
    "num": "760",
    "desc": "Prerequisite: ID 320 and 360; or ENVD 250 and 251.\nPrinciples, guidelines, and qualities of preservation and restoration of interiors. Research and application.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Assembly",
    "dept": "IMSE",
    "num": "015",
    "desc": "\nAssemblies are held once a month for practicing industrial engineers to make presentations to the students. Students are given an opportunity to interact with the visitors. The purpose is to provide an opportunity to learn about various companies and their products and operations.",
    "credits": "0"
  },
  {
    "course_name": "Industrial Plant Studies",
    "dept": "IMSE",
    "num": "050",
    "desc": "Prerequisite: Junior standing in industrial engineering.\nTrip to industrial centers for study of facilities of special interest to industrial engineering students.",
    "credits": "0"
  },
  {
    "course_name": "Introduction of Industrial Engineering",
    "dept": "IMSE",
    "num": "201",
    "desc": "Corequisite: MATH 220.\nIntroduction to the core areas of industrial engineering including ergonomics, operations, research, quality control, management, engineering economics, resource management, production systems and inventory control. Both engineering ethics and careers in industrial engineering will be discussed.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Manufacturing Processes and Systems",
    "dept": "IMSE",
    "num": "250",
    "desc": "Prerequisite or concurrent: MATH 205 or MATH 220.\nThis course provides an introduction to manufacturing processes and systems. The history and impact of manufacturing on society will be explored. A review of manufacturing processes and the products to which they are best suited will be emphasized. The impact of product design on manufacturability will be introduced. The role of engineers in designing good manufacturing processes and systems will be discussed.",
    "credits": "2"
  },
  {
    "course_name": "Manufacturing Processes Laboratory",
    "dept": "IMSE",
    "num": "251",
    "desc": "Prerequisite or concurrent: IMSE 250.\nGeneral introduction to foundry, welding, and machining. Includes safe manufacturing practices, metrology, and hands-on experience in foundry, welding, and machining operations.",
    "credits": "1"
  },
  {
    "course_name": "Welding Laboratory",
    "dept": "IMSE",
    "num": "252",
    "desc": "\nIntroduction to welding. Includes safe welding practices and lab experiments in gas, spot, and arc welding.",
    "credits": "1"
  },
  {
    "course_name": "Net Shape Manufacturing Laboratory",
    "dept": "IMSE",
    "num": "253",
    "desc": "Prerequisite or concurrent: IMSE 250, ME 212.\nIncludes safe manufacturing practices and experiments in casting and injection molding.",
    "credits": "1"
  },
  {
    "course_name": "Machining Laboratory",
    "dept": "IMSE",
    "num": "254",
    "desc": "Prerequisite or concurrent: IMSE 250, ME 212.\nProduction of machined parts. Includes metrology, safe machining practices, reading shop drawings, and good machining practices.",
    "credits": "1"
  },
  {
    "course_name": "Computer Numerical Control Laboratory",
    "dept": "IMSE",
    "num": "255",
    "desc": "Prerequisite: IMSE 253 or 254.\nIntroduction to computer numerical control. Part programming for CNC lathes and mills will be accomplished.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "IMSE",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Honors Research in Industrial Engineering",
    "dept": "IMSE",
    "num": "499",
    "desc": "\nIndividual research problem selected with approval of faculty advisor. Open to students in the College of Engineering honors program. A report is presented orally and in writing during the last semester.",
    "credits": "1-18"
  },
  {
    "course_name": "Industrial Management",
    "dept": "IMSE",
    "num": "501",
    "desc": "\nBasic functions in an industrial organization and their interrelationships; management considerations involving product, process, plant, and personnel.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Economic Analysis",
    "dept": "IMSE",
    "num": "530",
    "desc": "Prerequisite: MATH 220.\nThe analysis of the economic aspects of engineering/industrial projects. Focus on decision making among competing alternatives, including replacement decisions. It includes: cost estimating, time-value of money and effects of depreciation and taxation. Methods of comparing alternatives are developed, including: equivalent worth, rate of return, break even analysis, and benefit-cost ratio.",
    "credits": "2"
  },
  {
    "course_name": "Industrial Project Evaluation",
    "dept": "IMSE",
    "num": "532",
    "desc": "\nThe analysis and selection of engineering/industrial projects. This course is a continuation of IMSE 530. Topics in addition to IMSE 530 includes: risk/uncertainty, impact of inflation, capital rationing, multiple criteria decision making, and determining the MARR.",
    "credits": "1"
  },
  {
    "course_name": "Statistical Quality Control",
    "dept": "IMSE",
    "num": "541",
    "desc": "Prerequisite: STAT 511.\nNormal, binomial, and frequency distributions. Seven process improvement tools. Control charts on means and variances for variables and attributes. Design of experiments for process and product design. Acceptance sampling plans.",
    "credits": "3"
  },
  {
    "course_name": "Industrial Facilities Layout and Design",
    "dept": "IMSE",
    "num": "555",
    "desc": "Prerequisite: IMSE 251 and corequisite or prerequisite: IMSE 530.\nDesign of industrial facilities with emphasis on manufacturing engineering and material handling.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Operations Research I",
    "dept": "IMSE",
    "num": "560",
    "desc": "Prerequisite: MATH 222 and MATH 551.\nA study of the methods of operations research including model formulation and optimization. Topics include: linear programming, sensitivity analysis, network flows, and graph optimization.",
    "credits": "3"
  },
  {
    "course_name": "Materials and the Impact of Manufacturing Processes",
    "dept": "IMSE",
    "num": "562",
    "desc": "Prerequisite: PHYS 214, CHE 354.\nThe categorization and analysis of materials used in manufacturing is introduced.  Emphasis is placed on the electronic and mechanical properties of materials along with the impact that manufacturing processes have on these properties.  Through laboratory work, the students will learn how to design and conduct manufacturing experiments to measure material properties and explore the interplay between processes and properties. 3 credit hours, 2 hours lecture, 1 hour lab  per week [2 lab sections]. Offered spring semesters every year.",
    "credits": "3"
  },
  {
    "course_name": "Manufacturing Processes Engineering",
    "dept": "IMSE",
    "num": "563",
    "desc": "Prerequisite: IMSE 251, CHE 356, and CE 530.\nThe effects of operating variables on manufacturing processes such as machining, metal forming, casting, welding, plastics, etc. Emphases are on manufacturing process theory, process variables measurement, and the technical inferences of collected data. Strength of materials, manufacturing process theory, instrumentation, computer data acquisition, and data analysis concepts are included. Laboratory testing of manufacturing processes and the engineering design of experiments for process variable measurements are used to develop efficient manufacturing processes.",
    "credits": "3"
  },
  {
    "course_name": "Product and Process Engineering",
    "dept": "IMSE",
    "num": "564",
    "desc": "Prerequisite: IMSE 250 and IMSE 251 and IMSE 530.\nA study of the interrelationships between product design and production process selection. Emphasis is on the development of economic production systems for discrete products in a competitive manufacturing environment. Concepts of design for manufacture and assembly, tool engineering, and manufacturing systems design are included.",
    "credits": "3"
  },
  {
    "course_name": "Manufacturing Systems Design and Analysis",
    "dept": "IMSE",
    "num": "580",
    "desc": "Prerequisite or concurrent: 24 credit hours of IMSE 500 level and above courses.\nComprehensive design and analysis of a manufacturing system: integration of the undergraduate industrial engineering and manufacturing engineering courses.",
    "credits": "4"
  },
  {
    "course_name": "Senior Design Project I",
    "dept": "IMSE",
    "num": "591",
    "desc": "Prerequisite or concurrent: 24 credit hours of IMSE 500 level and above courses.\nStudents organize themselves in teams, not exceeding five students in each team. Each team is responsible to establish a client. The teams select a general subject agreeable to the client, formulate a specific design project, and gather data and resources needed to support the project.",
    "credits": "2"
  },
  {
    "course_name": "Senior Design Project II",
    "dept": "IMSE",
    "num": "592",
    "desc": "Prerequisite: IMSE 591.\nContinuation of IMSE 591 in which student teams complete engineering design projects formulated and approved in IMSE 591.",
    "credits": "2"
  },
  {
    "course_name": "Topics in Industrial Engineering",
    "dept": "IMSE",
    "num": "602",
    "desc": "\nLectures on recent topics in industrial engineering.",
    "credits": "1-18"
  },
  {
    "course_name": "Independent Study of Industrial Engineering",
    "dept": "IMSE",
    "num": "604",
    "desc": "\nThis course involves independent study at the introductory graduate level.",
    "credits": "1-18"
  },
  {
    "course_name": "Advanced Industrial Management",
    "dept": "IMSE",
    "num": "605",
    "desc": "Prerequisite: IMSE 501 or MANGT 420.\nContemporary management philosophies and their impact on engineers and engineering managers. Topics include: planning, organizing, leading, and controlling.",
    "credits": "3"
  },
  {
    "course_name": "Occupational Safety Engineering",
    "dept": "IMSE",
    "num": "610",
    "desc": "Prerequisite: IMSE 251.\nAn overview of factors affecting safety in organizations, emphasizing analysis techniques and design strategies. Topics include occupational safety, accidents, fire protection, industrial hygiene, hazardous waste, toxicology, radiation safety, product liability and federal standards. A project involving a hazard analysis and the design of a solution for a field location is required.",
    "credits": "3"
  },
  {
    "course_name": "Industrial Ergonomics",
    "dept": "IMSE",
    "num": "623",
    "desc": "Prerequisite: STAT 510.\nProcess analysis and charting; principles of motion economy and ergonomics; work stations and environments; micromotion analysis and an introduction to standard data systems.",
    "credits": "3"
  },
  {
    "course_name": "Work Environments",
    "dept": "IMSE",
    "num": "625",
    "desc": "Prerequisite: IMSE 251.\nBasic structure and performance of the human, viewed as a component in information processing and control systems. Effect of visual, auditory, toxic, and thermal environments.",
    "credits": "3"
  },
  {
    "course_name": "Production Planning and Inventory Control",
    "dept": "IMSE",
    "num": "633",
    "desc": "Prerequisite: IMSE 250.  Prerequisite or concurrent: IMSE 560.\nPrinciples, techniques, and applications of production planning and inventory control. The course covers strategic planning tools such as forecasting and aggregate planning as well as tactical tools such as inventory management and scheduling.",
    "credits": "3"
  },
  {
    "course_name": "Quality Engineering",
    "dept": "IMSE",
    "num": "641",
    "desc": "Prerequisite: STAT 511.\nAn introduction to the modern practice of quality engineering concepts, systems, strategies, and tools to both manufacturing and service industries. Topics include advanced techniques related to statistical process control, international quality standards, quality data management, and automatic inspection.",
    "credits": "3"
  },
  {
    "course_name": "Industrial Simulation",
    "dept": "IMSE",
    "num": "643",
    "desc": "Prerequisite: IMSE computer programming elective from approved Departmental list.\nBasic concepts of computer simulation modeling of manufacturing, production, service and other stochastic systems. Use of a commercial simulation software environment to build, analyze, verify and validate models. Use of models as a system design tool through statistical and optimization techniques.",
    "credits": "3"
  },
  {
    "course_name": "Operations Research II",
    "dept": "IMSE",
    "num": "660",
    "desc": "Prerequisite: IMSE 560 and STAT 510.\nContinuation of IMSE 560. Topics include: integer programming, nonlinear programming, Markov chains, and queuing theory.",
    "credits": "3"
  },
  {
    "course_name": "Computer Aided Manufacturing",
    "dept": "IMSE",
    "num": "662",
    "desc": "Prerequisite: IMSE 251 and CIS 209, or 200, or ME 400.\nConcepts in CAM, integrated control of machine tools and transport devices with production control. Concepts of CAM and automated assembly in small lot production environment.",
    "credits": "3"
  },
  {
    "course_name": "Additive Manufacturing",
    "dept": "IMSE",
    "num": "664",
    "desc": "Prerequisite: ME 212.\nA study of current 3D printing or additive manufacturing technologies that convert a digital file into a physical object. Emphasis is on rapid prototyping involving materials, processes, techniques, and 3D printing machines. Capabilities and limitations of 3D printing technologies are included.",
    "credits": "3"
  },
  {
    "course_name": "Operations Research III",
    "dept": "IMSE",
    "num": "666",
    "desc": "Prerequisite: IMSE 660.  Prerequisite or concurrent: IMSE 530.\nA continuation of IMSE 660.  Covers more advanced aspects of LP and NLP.  Introduces three new topics: normative theory of decision and games, dynamic programming and Markov decision systems.",
    "credits": "3"
  },
  {
    "course_name": "Quantitative Problem Solving Techniques",
    "dept": "IMSE",
    "num": "680",
    "desc": "Prerequisite: MATH 205.\nSurvey of decision making techniques. Topics covered include: linear, integer and nonlinear programming; network flows and stochastic processes. A focus of the course will include modeling and the use of software to solve these problems.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Manufacturing Information Systems",
    "dept": "IMSE",
    "num": "685",
    "desc": "Prerequisite: IMSE computer programming elective from approved Departmental list.\nIntroduction to the theory and concepts of information for manufacturing. Design of manufacturing systems such as MRP, SFRS, CAD/CAM, etc. Concerns of integration and man-machine interface in manufacturing systems.",
    "credits": "3"
  },
  {
    "course_name": "Normative Theory of Decisions and Games",
    "dept": "IMSE",
    "num": "751",
    "desc": "Prerequisite: STAT 511.\nBayes theorem, Bayesian estimators, utility, loss function and risk, minimax strategies, elementary game theory.",
    "credits": "3"
  },
  {
    "course_name": "Stochastic Calculus Financial Engineering",
    "dept": "IMSE",
    "num": "760",
    "desc": "Prerequisite: IMSE 530, 660, and CIS 209 or 200, or ME 400.\nThis course will serve as an introduction to the basic concepts and computing techniques of financial engineering and its real-life applications. These basics can be applied in many other aspects of industrial engineering used throughout stochastic processes, probability theory, system simulation, portfolio/risk management, and supply chain optimization.",
    "credits": "3"
  },
  {
    "course_name": "Methods of Operations Research",
    "dept": "IMSE",
    "num": "780",
    "desc": "Prerequisite: MATH 560 and STAT 510.\nThis course is intended to give an overview of OR at the graduate level. After this course, the student will have the general basic knowledge in OR and a better idea about the usefulness and interrelationships of the various subjects in OR. Topics to be covered include the various optimization techniques, stochastic processes and optimization, and the various approaches in the treatment of uncertainty.",
    "credits": "3"
  },
  {
    "course_name": "Big Data Analytics",
    "dept": "IMSE",
    "num": "785",
    "desc": "Prerequisite: CIS 209; STAT 510 or STAT 350.\nTopics include big data management, data architecture of hosting big data, big data retrieval languages, parallel computing methods, big data analytical methods, and data visualization.",
    "credits": "3"
  },
  {
    "course_name": "INDD Design Studio II",
    "dept": "INDD",
    "num": "320",
    "desc": "Prerequisite: IAPD 307.\nBasic principles of Product Design process through research, ideation, sketching, modeling, prototyping and presentation. Explores and analyzes complex social, cultural, and economical aspects of society for product design development.",
    "credits": "3"
  },
  {
    "course_name": "Product Semantics",
    "dept": "INDD",
    "num": "350",
    "desc": "Prerequisite: IAPD 307.\nExplores visual and symbolic qualities of the man-made forms in the context of their use and application of this knowledge in order to understand the aspects of communication in Industrial Design. Course also focuses on the cognitive and social context of the products.",
    "credits": "3"
  },
  {
    "course_name": "INDD Design Studio IV",
    "dept": "INDD",
    "num": "440",
    "desc": "Prerequisite: INDD 435.\nExposes students to a deeper understanding about user experience, user interface and form development in the Industrial Design process. Provides an advance research and analysis of design problems and opportunities, using Human Centered Design, Universal Design and Design Thinking.",
    "credits": "5"
  },
  {
    "course_name": "Materials and Manufacturing Processes",
    "dept": "INDD",
    "num": "500",
    "desc": "Prerequisite: IMSE 250.\nSeeks to provide an advanced understanding of materials and processes commonly used by Industrial Designers and manufacturers. The objective is to develop a more precise, professional and accurate approach to design while broadening the student’s technical base.",
    "credits": "3"
  },
  {
    "course_name": "INDD Design Studio V",
    "dept": "INDD",
    "num": "606",
    "desc": "Prerequisite: INDD 440.\nThis semester of study provides an option for an interdisciplinary collaborative studio course oriented towards replicating the learning experience and interactive activities that takes place in the modern multidisciplinary professional office or a validated equivalent studio completed in an approved study program.",
    "credits": "5"
  },
  {
    "course_name": "Italian I",
    "dept": "ITAL",
    "num": "101",
    "desc": "\nIntroduction to the structure of modern Italian.",
    "credits": "4"
  },
  {
    "course_name": "Italian II",
    "dept": "ITAL",
    "num": "102",
    "desc": "Prerequisite: ITAL 101 or equivalent.\nContinuation and completion of the study of modern Italian grammar, using the facilities of the language laboratory for audiolingual practice.",
    "credits": "4"
  },
  {
    "course_name": "Italian for Travelers",
    "dept": "ITAL",
    "num": "105",
    "desc": "\nPrepares students for everyday situations on a visit to Italy.",
    "credits": "1-8"
  },
  {
    "course_name": "Italian III",
    "dept": "ITAL",
    "num": "300",
    "desc": "Prerequisite: ITAL 102 or equivalent.\nGrammar review and reading selections from Italian literature.",
    "credits": "4"
  },
  {
    "course_name": "Italian IV",
    "dept": "ITAL",
    "num": "301",
    "desc": "Prerequisite: ITAL 300.\nSelective review of grammar and reading of examples of modern Italian literature.",
    "credits": "4"
  },
  {
    "course_name": "Special Studies in Italian",
    "dept": "ITAL",
    "num": "520",
    "desc": "Prerequisite: Consent of department head and instructor involved.",
    "credits": "1-18"
  },
  {
    "course_name": "Japanese I",
    "dept": "JAPAN",
    "num": "101",
    "desc": "\nIntroduction to the fundamental linguistics and cultural characteristics of the Japanese language and its writing systems (Hiragana, Katakana, and Kanji).",
    "credits": "4"
  },
  {
    "course_name": "Japanese II",
    "dept": "JAPAN",
    "num": "102",
    "desc": "Prerequisite: JAPAN 101 or equivalent.\nContinuation of Japanese I. Development of functional skills for familiar situations.",
    "credits": "4"
  },
  {
    "course_name": "Special Studies in Japanese",
    "dept": "JAPAN",
    "num": "299",
    "desc": "Prerequisite: Permission of the instructor.",
    "credits": "1-8"
  },
  {
    "course_name": "Japanese III",
    "dept": "JAPAN",
    "num": "300",
    "desc": "Prerequisite: JAPAN 102 or equivalent.\nContinuation of Japanese II with emphasis on building and applying basic language knowledge in communicative tasks; exercises in oral interactions and interactions involving text; weekly language lab; approx. 1– new kanji in text.",
    "credits": "5"
  },
  {
    "course_name": "Japanese IV",
    "dept": "JAPAN",
    "num": "301",
    "desc": "Prerequisite: JAPAN 201 or equivalent.\nContinuation of Japanese III. Enhancement of speaking and writing skills, and reading and listening comprehension.",
    "credits": "5"
  },
  {
    "course_name": "Culture of Japanese Communication",
    "dept": "JAPAN",
    "num": "391",
    "desc": "Prerequisite: JAPAN 191.\nIntroduction to verbal and nonverbal cultural aspects of Japanese discourse. Includes comparative study, followed by discussion on application of knowledge in cross-cultural context.",
    "credits": "3"
  },
  {
    "course_name": "Japanese V",
    "dept": "JAPAN",
    "num": "591",
    "desc": "Prerequisite: JAPAN 292 or equivalent.\nDevelopment of communication skills through application activities such as problem-solving tasks and role plays. Enhancement of vocabulary, structures, and their usage. Emphasis on extended discourse.",
    "credits": "4"
  },
  {
    "course_name": "Japanese VI",
    "dept": "JAPAN",
    "num": "592",
    "desc": "Prerequisite: JAPAN 591 or equivalent.\nContinuation of Japanese V.  Development of functional skills for general situations.",
    "credits": "4"
  },
  {
    "course_name": "Special Studies in Japanese",
    "dept": "JAPAN",
    "num": "599",
    "desc": "Prerequisite: Consent of department head and instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Adaptive Physical Activities",
    "dept": "KIN",
    "num": "100",
    "desc": "\nExercise programs adapted to the needs of the special student.",
    "credits": "1"
  },
  {
    "course_name": "Topics in Strength and Conditioning",
    "dept": "KIN",
    "num": "101",
    "desc": "\nDiscussion of topics and participation in activities of importance in strength and conditioning.",
    "credits": "1"
  },
  {
    "course_name": "Topics in Aerobic Exercise",
    "dept": "KIN",
    "num": "102",
    "desc": "\nDiscussion of topics and participation in activities of importance in aerobic exercise.",
    "credits": "1"
  },
  {
    "course_name": "Swimming I",
    "dept": "KIN",
    "num": "104",
    "desc": "\nBeginning instruction for students who have no previous experience with swimming.",
    "credits": "1"
  },
  {
    "course_name": "Swimming II",
    "dept": "KIN",
    "num": "105",
    "desc": "\nFor the beginning swimmer who has had some previous swimming experience.",
    "credits": "1"
  },
  {
    "course_name": "Swimming III",
    "dept": "KIN",
    "num": "106",
    "desc": "Prerequisite: KIN 105 or consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Fitness Swimming",
    "dept": "KIN",
    "num": "107",
    "desc": "Prerequisite: KIN 106 or consent of instructor.",
    "credits": "1"
  },
  {
    "course_name": "Strength and Conditioning Specialist",
    "dept": "KIN",
    "num": "108",
    "desc": "\nCourse prepares students for completion of exam required for Certified Strength and Conditioning Specialist (CSCS) credential from the National Strength and Conditioning Association.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Public Health",
    "dept": "KIN",
    "num": "110",
    "desc": "\nAn introductory survey course designed to provide a history of public health, an overview of the five core disciplines (epidemiology, biostatistics, environmental health, social and behavioral health, and health policy and management), and information about career options in public health. Investigation and analysis of contemporary issues in public health such as bioterrorism, threats to the nation’s food supply, the importance of health promoting behaviors in the prevention of disease, distribution of infectious diseases on a global population, and the role of public health in disaster preparedness and management.",
    "credits": "3"
  },
  {
    "course_name": "Aerobic Dancing and Exercise",
    "dept": "KIN",
    "num": "160",
    "desc": "",
    "credits": "1"
  },
  {
    "course_name": "Fitness and Conditioning",
    "dept": "KIN",
    "num": "161",
    "desc": "\nFor students in the College of Health and Human Sciences, no more than 4 credit hours in lifetime sports and exercise activity classes may be applied toward a degree.",
    "credits": "1"
  },
  {
    "course_name": "Jogging",
    "dept": "KIN",
    "num": "162",
    "desc": "",
    "credits": "1"
  },
  {
    "course_name": "Weight Training",
    "dept": "KIN",
    "num": "163",
    "desc": "\nFor students in the College of Health and Human Sciences, no more than 4 credit hours in lifetime sports and exercise activity classes may be applied toward a degree.",
    "credits": "1"
  },
  {
    "course_name": "Water Exercise and Water Fitness Instructor Training",
    "dept": "KIN",
    "num": "206",
    "desc": "Prerequisite: KIN 104.\nSkills and knowledge to develop competency in participating, designing, and leading different types of water exercise, as well as administering all aspects of water fitness classes.",
    "credits": "1"
  },
  {
    "course_name": "Biobehavioral Bases of Physical Activity",
    "dept": "KIN",
    "num": "220",
    "desc": "\nCurrent perspectives from the biological and behavioral domains of kinesiology will be used to explore the significance of physical activity for optimal health.  Topics include physiology of physical activity, social and behavioral epidemiology of physical activity and health, control and biomechanics of human movement.",
    "credits": "4"
  },
  {
    "course_name": "Measurement and Research Techniques in Kinesiology",
    "dept": "KIN",
    "num": "310",
    "desc": "Prerequisite: KIN 220 with a C or better.\nTheory and techniques of measurement and research in the biological and behavioral aspects of kinesiology.",
    "credits": "4"
  },
  {
    "course_name": "Motor Learning and Development",
    "dept": "KIN",
    "num": "320",
    "desc": "Prerequisite: PSYCH 110.\nIssues of motor learning and development as they relate to the application of instructional techniques.",
    "credits": "3"
  },
  {
    "course_name": "Biomechanics",
    "dept": "KIN",
    "num": "330",
    "desc": "Prerequisite: C or better in KIN 220 and a C or better in either KIN 360, BIOL 340 or 8 hours of Anatomy and Physiology transfer credit.\nMechanical and anatomical aspects of human movement.  Kinematic and kinetic principles applied to the analysis of human movement.",
    "credits": "3"
  },
  {
    "course_name": "Physiology of Exercise",
    "dept": "KIN",
    "num": "335",
    "desc": "Prerequisite: C or better in either KIN 360, BIOL 340 or 8 hours of Anatomy and Physiology transfer credit.\nThe responses of the human body to exercise. Emphasis will be placed on understanding the structure-function relationships of the respiratory, cardiovascular, and muscular systems and how their function is integrated to support the dynamics of muscular contraction. Limitations to exercise performance will be examined in health and disease and the adaptability of the human body to physiological (i.e., exercise training) and environmental (e.g., hypoxia) stressors will be examined.",
    "credits": "4"
  },
  {
    "course_name": "Physiology of Exercise Lab",
    "dept": "KIN",
    "num": "336",
    "desc": "Prerequisite: KIN 335 or concurrent enrollment.\nA laboratory course to supplement the material of KIN 335.",
    "credits": "1"
  },
  {
    "course_name": "Exercise Behavioral Science",
    "dept": "KIN",
    "num": "345",
    "desc": "Prerequisite: KIN 220, PSYCH 110; SOCIO 211 with a grade of C or better.\nExamination of the social and behavioral determinants of physical activity using a social ecological framework. Social ecological levels include individual, interpersonal, community, institutional and societal/policy factors.",
    "credits": "5"
  },
  {
    "course_name": "Laboratory Experience for Social and Behavioral Epidemiology of Public Health Physical Activity",
    "dept": "KIN",
    "num": "346",
    "desc": "Prerequisite: Concurrent enrollment in KIN 345.\nA laboratory experience for KIN 345.",
    "credits": "1"
  },
  {
    "course_name": "Anatomy and Physiology",
    "dept": "KIN",
    "num": "360",
    "desc": "Prerequisite: C or better in either BIOL 198 or transferred introductory Biology credit.\nAnatomy and Physiology of the organ systems of the human body. Laboratory includes physiology experiments, study of anatomy from computer simulation, dissection demonstrations, X-rays, and slide work.",
    "credits": "8"
  },
  {
    "course_name": "Principles of Exercise Training",
    "dept": "KIN",
    "num": "380",
    "desc": "\nThis course is designed to cover the application of current scientific research on program design for healthy athletes competing in any sport or physically active individuals. Contributing science include anatomy, biochemistry, biomechanics, endocrinology, nutrition, exercise physiology and psychology. Emphasis will be placed on adaptations to resistance training, plyometric training, speed/agility/speed endurance training and aerobic endurance training. Exercise Techniques, Testing and Evaluation and Program Design will also be major components of the course. Students should be prepared for strenuous physical activity.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Kinesiology",
    "dept": "KIN",
    "num": "398",
    "desc": "\nStudy of a selected topic in an area not covered in the curriculum or involving application of theory presented in a related subject core course.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Seminar",
    "dept": "KIN",
    "num": "399",
    "desc": "\nSelected topics in kinesiology.",
    "credits": "1-3"
  },
  {
    "course_name": "Practicum in Lifetime Sports",
    "dept": "KIN",
    "num": "430",
    "desc": "Prerequisite: Junior standing and consent of Undergraduate Coordinator.\nSupervised students assist in lifetime sports classes.",
    "credits": "2"
  },
  {
    "course_name": "Laboratory Practicum in Kinesiology",
    "dept": "KIN",
    "num": "463",
    "desc": "Prerequisite: Junior standing and successful completion of lab experience, consent of undergraduate coordinator.\nSupervised students assist in laboratory.",
    "credits": "1-2"
  },
  {
    "course_name": "Honors Tutorial in Kinesiology",
    "dept": "KIN",
    "num": "498",
    "desc": "Prerequisite: Sophomore standing, membership in the honors Program of the College of Health and Human Sciences, and permission of instructor.\nIndividually directed research in kinesiology, normally as a preliminary to writing a senior honors thesis.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "KIN",
    "num": "499",
    "desc": "Prerequisite: Membership in Human Ecology Honors Program.\nOpen only to Health and Human Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Fitness Settings",
    "dept": "KIN",
    "num": "520",
    "desc": "Prerequisite: Instructor Consent.\nPractical experiences in the fitness setting such as observation and participation in exercise testing and prescription, exercise leadership, and record keeping and program management.",
    "credits": "1-3"
  },
  {
    "course_name": "Prac/Public Health Physical Activity",
    "dept": "KIN",
    "num": "521",
    "desc": "Prerequisite: C or better in both KIN 310 and 345 and instructor consent.\nPractical experiences in the public health setting, such as observation and participation in public health physical activity program planning and evaluation.",
    "credits": "1-3"
  },
  {
    "course_name": "Internship in Kinesiology",
    "dept": "KIN",
    "num": "580",
    "desc": "Prerequisite: Instructor permission.\nSupervised field experience in approved fitness, strength and conditioning, clinical, public health, or healthcare setting 3-8 credit hours, 50 hours required at the internship site per credit.",
    "credits": "3-8"
  },
  {
    "course_name": "Psychology of Exercise and Sport Injury",
    "dept": "KIN",
    "num": "591",
    "desc": "Prerequisite: C or better in KIN 310 and KIN 345.\nUnderlying effects, treatment of psychological consequences, and physical trauma of exercise and sport injury. Topics include the impact of injury on exercise behavior, the athlete at risk, behavioral risk factors, injury assessment, treatment of injury, and psychological factors addressed by the sports medicine team.",
    "credits": "3"
  },
  {
    "course_name": "Sport and Exercise Personality",
    "dept": "KIN",
    "num": "592",
    "desc": "Prerequisite: A grade of C or higher in KIN 310 and 345.\nThe role of personality in sport, sport performance and exercise behavior. Theories relevant to sport and exercise personality will be examined to provide a theoretical framework for understanding and applying research. Assessment instruments and relevant research will be examined and critiqued.",
    "credits": "3"
  },
  {
    "course_name": "Sport and Exercise Psychology",
    "dept": "KIN",
    "num": "594",
    "desc": "\nThis course is designed to introduce the student to the basic psychological principles related to sport and exercise behavior and performance. Factors that influence sport performance will be examined as will the principles related to exercise and exercise behavior.",
    "credits": "3"
  },
  {
    "course_name": "Teaching Experience in Kinesiology",
    "dept": "KIN",
    "num": "596",
    "desc": "\nThis course will be a learning experience for students supporting a faculty course. Objectives include identifying and discussing learning and teaching, leading discussions, and providing assistance and direction to students in the course.",
    "credits": "3"
  },
  {
    "course_name": "Research Experience in Kinesiology",
    "dept": "KIN",
    "num": "597",
    "desc": "Prerequisite: Consent of Undergraduate Coordinator.\nExposure to and assisting with current research projects in a laboratory setting in Kinesiology.",
    "credits": "0-3"
  },
  {
    "course_name": "Topics in Kinesiology",
    "dept": "KIN",
    "num": "598",
    "desc": "Prerequisite: Related core course.\nStudy of a selected topic in kinesiology involving either an in-depth study or application of theory presented in a related core course.",
    "credits": "1-3"
  },
  {
    "course_name": "Independent Studies in Kinesiology",
    "dept": "KIN",
    "num": "599",
    "desc": "Prerequisite: Consent of undergraduate coordinator.\nSelected topics in kinesiology. Maximum of 3 hours applicable towards a degree.",
    "credits": "1-3"
  },
  {
    "course_name": "Interpersonal Aspects of Physical Activity",
    "dept": "KIN",
    "num": "600",
    "desc": "Prerequisite: Grade of C or better in KIN 310 or KIN 312; and a grade of C or better in KIN 345.\nExamination of theory and research related to interpersonal aspects of physical activity. Topics include: social networks, social support, social influence, cohesion, and intervention strategies that target interpersonal factors to increase and maintain physical activity participation.",
    "credits": "3"
  },
  {
    "course_name": "Cardiorespiratory Exercise Physiology",
    "dept": "KIN",
    "num": "601",
    "desc": "Prerequisite: A grade of C or higher in KIN 310 and KIN 335.\nAn examination of the structure and function of the respiratory system and the manner in which oxygen passes from the atmosphere to its site of utilization in the mitochondria. Exercise and environmental stresses will form the basis for examining the capacity, plasticity, and limitations to respiratory function.",
    "credits": "3"
  },
  {
    "course_name": "Social Structural Determinants of Physical Activity",
    "dept": "KIN",
    "num": "602",
    "desc": "Prerequisite: Grade of C or better in KIN 310 or KIN 312; and a grade of C or better in KIN 345.\nAn examination of how social structural determinants impact participation in physical activity. Topics include: social class, race and ethnicity, gender, sexual orientation, family, education, and work. Promising physical activity intervention strategies are also discussed.",
    "credits": "3"
  },
  {
    "course_name": "Cardiovascular Exercise Physiology",
    "dept": "KIN",
    "num": "603",
    "desc": "Prerequisite: A grade of C or higher in KIN 310 and 335.\nStudy of the structure and function of the cardiovascular system as it pertains to acute and chronic exercise. Topics include the control of blood pressure, vascular volume, and blood flow during orthostasis and exercise.",
    "credits": "3"
  },
  {
    "course_name": "Topics in the Biological Basis of Kinesiology",
    "dept": "KIN",
    "num": "605",
    "desc": "Prerequisite: A grade of C or higher in KIN 310 and 335.\nStudy of a selected topic in the biological basis of kinesiology involving either an in-depth study or application of theory presented in a related course area.",
    "credits": "1-3"
  },
  {
    "course_name": "Topics in the Behavioral Basis of Kinesiology",
    "dept": "KIN",
    "num": "606",
    "desc": "Prerequisite: A grade of C or higher in KIN 310 and 345.\nStudy of a selected topic in the behavioral basis of kinesiology involving either an in-depth study or application of theory presented in a related course area.",
    "credits": "1-3"
  },
  {
    "course_name": "Muscle Physiology",
    "dept": "KIN",
    "num": "607",
    "desc": "Prerequisite: A grade of C or higher in both KIN 310 and KIN 335.\nSubcellular, cellular, and tissue structure of skeletal muscle and the relationship of these structural characteristics to the functioning of the muscle. Examines energy pathways available to the muscle to support the various functions, and mechanisms underlying changes in exercise tolerance that accompany exercise training and detraining, aging, and diseases that affect skeletal muscle.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Physiology",
    "dept": "KIN",
    "num": "609",
    "desc": "Prerequisite: C or better in both KIN 310 and KIN 335.\nStudy of the physiological adaptations to acute and chronic challenges imposed by the environment. Topics will focus on how different physiological systems respond to different environmental stressors (heat, cold, deep sea diving, high altitude).",
    "credits": "3"
  },
  {
    "course_name": "Program Planning and Evaluation",
    "dept": "KIN",
    "num": "610",
    "desc": "Prerequisite: Grade of C or better in KIN 310 or KIN 312; and a grade of C or better in KIN 345.\nTheories and models and the stages and activities of planning, implementing, and evaluating health promotion programs.",
    "credits": "3"
  },
  {
    "course_name": "Autonomic Neurophysiology",
    "dept": "KIN",
    "num": "611",
    "desc": "Prerequisite: C or better in both KIN 310 and KIN 335\nStudy of the structure and function of the autonomic nervous system primarily as it pertains to physical stress. Particular emphasis is placed on the mechanisms evoking changes in the autonomic nervous system during physical stress including feed-forward and feedback autonomic control signals. The effects of disease and exercise training on those neural control signals are discussed.",
    "credits": "3"
  },
  {
    "course_name": "Policy, Built Environment and Physical Activity",
    "dept": "KIN",
    "num": "612",
    "desc": "Prerequisite: Grade of C or better in KIN 310 or KIN 312; and a grade of C or better in KIN 345.\nExamination of the characteristics of active living policies and neighborhood/community design that contribute to improved health.",
    "credits": "3"
  },
  {
    "course_name": "Physical Activity Behavior Settings: Youth Sport to Senior Centers",
    "dept": "KIN",
    "num": "614",
    "desc": "Prerequisite: KIN 310 and KIN 345 with grades of C or higher.\nThe course is a study of key physical activity behavior settings across life-span development. Topics include observation of social and physical environmental variables, surveillance of physical activity in behavior settings, motivational theory and responses, setting interventions and developmental outcomes, and intervention evaluation methods.",
    "credits": "3"
  },
  {
    "course_name": "Cardiorespiratory/Comparative Physiology",
    "dept": "KIN",
    "num": "615",
    "desc": "Prerequisite: C or better in both KIN 310 and KIN 335\nThis course seeks to fulfill the following objectives: (1) To provide the student with an awareness and mechanistic understanding of the effects of physical activity on humans and animals and the concept of homeostasis. (2) Foster an understanding of the integrative nature of kinesiology/physiology by considering the relationships among different systems and their response to stress in humans and animal species in health and disease. Focus is brought to bear in particular on the pulmonary, cardiovascular and muscle systems. Chronic and acute adaptations to special environments and physical stress are considered and the students are asked to consider the the different systems are controlled in health and disease. This course is recommended for pre-med students, biology and physiology majors, aspiring scientists in physiology and/or medicine and those interested in a career in health and human services.",
    "credits": "3"
  },
  {
    "course_name": "Obesity and Physical Activity: Behavioral, Environment, and Policy Influences",
    "dept": "KIN",
    "num": "616",
    "desc": "Prerequisite: Grade of C or better in KIN 310 or KIN 312; and a grade of C or better in KIN 345.\nExamines the contributing factors to obesity, especially through the lens of physical activity/inactivity. Attention is paid to the environment and policy influences on behaviors that contribute to weight gain.",
    "credits": "3"
  },
  {
    "course_name": "Signaling Pathways in Physiology",
    "dept": "KIN",
    "num": "617",
    "desc": "Prerequisite: C or better in both KIN 310 and KIN 335; or Instructor Permission",
    "credits": "3"
  },
  {
    "course_name": "Exercise Testing and Prescription",
    "dept": "KIN",
    "num": "625",
    "desc": "Prerequisite: C or better in both KIN 310 and KIN 335, CPR, and First Aid.\nBenefits and risks of exercise testing and prescription with healthy populations, individuals at risk, and patients with cardiovascular and metabolic diseases. Includes experiences with exercise test technology and methods of exercise prescription.",
    "credits": "3"
  },
  {
    "course_name": "Nutrition and Exercise",
    "dept": "KIN",
    "num": "635",
    "desc": "Prerequisite: HN 132 or HN 400 and a grade of C or higher in KIN 310 and 335.\nThe interrelationships between diet, nutrition, and exercise. Topics covered include physical fitness, weight control, nutrient metabolism during exercise, and athletic performance.",
    "credits": "3"
  },
  {
    "course_name": "Development of Motor Control",
    "dept": "KIN",
    "num": "650",
    "desc": "Prerequisite: C or better in both KIN 310 and either BIOL 340, KIN 360 or 8 hours of transfer Anatomy and Physiology.\nA multi-level analysis of the neurophysiological activation of muscle, reflexes, sensory integration during movement, and theories of voluntary movement.",
    "credits": "3"
  },
  {
    "course_name": "Individual Physical Activity Promotion",
    "dept": "KIN",
    "num": "655",
    "desc": "Prerequisite: Grade of C or better in KIN 310 or KIN 312; and a grade of C or better in KIN 345.\nAn in-depth study of individual-level influences on physical activity and strategies to promote physical activity among individuals.",
    "credits": "3"
  },
  {
    "course_name": "Integrative Human Pathophysiology",
    "dept": "KIN",
    "num": "657",
    "desc": "Prerequisite: A grade of C or higher in both KIN 310 and KIN 335.",
    "credits": "3"
  },
  {
    "course_name": "Internship/Public Health Physical Activity",
    "dept": "KIN",
    "num": "793",
    "desc": "Prerequisite: KIN 345, 346, 521, 655.\nSupervised field experience in settings such as public health departments, foundations, government offices, or research programs.",
    "credits": "1-8"
  },
  {
    "course_name": "Topics in Exercise Physiology",
    "dept": "KIN",
    "num": "796",
    "desc": "Prerequisite: C or better in both KIN 310 and KIN 335 and consent of instructor.\nSelected topics in exercise physiology involving either greater in-depth study, or application of theory presented in a related course.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Public Health Physical Activity Behavior",
    "dept": "KIN",
    "num": "797",
    "desc": "Prerequisite: C or better in both KIN 310 and KIN 345 and consent of instructor.\nSelected topics in public health physical activity behavior involving either greater in-depth study, or application of theory presented in a related course.",
    "credits": "3"
  },
  {
    "course_name": "Travel: Regional 1",
    "dept": "LAR",
    "num": "010",
    "desc": "Prerequisite: LAR 220.\nMulti-day regional field trip experience. Students will study existing natural and/or built environments to develop landscape architecture knowledge base and apply findings to other courses.",
    "credits": "0"
  },
  {
    "course_name": "Travel: Regional 2",
    "dept": "LAR",
    "num": "020",
    "desc": "Prerequisite: LAR 010.\nMulti-day field trip experience in an urban environment. Students will study notable works of landscape architecture, and visit professional offices to develop landscape architecture knowledge base and apply findings to other courses.",
    "credits": "0"
  },
  {
    "course_name": "Travel: Narratives and Placemaking",
    "dept": "LAR",
    "num": "030",
    "desc": "Prerequisite: LAR 020.\nImmersive field trip experience that supports the Narrative and Placemaking Studio.",
    "credits": "0"
  },
  {
    "course_name": "Travel: Major City 1",
    "dept": "LAR",
    "num": "040",
    "desc": "Prerequisite: LAR 030.\nMulti-day field trip experience in a major city. Students will study notable works of landscape architecture, and visit professional offices to develop landscape architecture knowledge base and apply findings to other courses.",
    "credits": "0"
  },
  {
    "course_name": "Travel: Major City 2",
    "dept": "LAR",
    "num": "050",
    "desc": "Prerequisite: LAR 040.\nMulti-day field trip experience in a major city. Students will study notable works of landscape architecture, and visit professional offices to develop landscape architecture knowledge base and apply findings to other courses.",
    "credits": "0"
  },
  {
    "course_name": "Introduction to Landscape Architecture",
    "dept": "LAR",
    "num": "101",
    "desc": "\nExploratory lecture course open to students in all majors providing an overview of landscape architecture which focuses on innovations in natural and built environments. Students will learn about a wide variety of global issues and perspectives, types of planning and design projects, and professional aspects of the discipline.",
    "credits": "3"
  },
  {
    "course_name": "Drawing Landscapes Studio",
    "dept": "LAR",
    "num": "220",
    "desc": "Prerequisite: Admission to the LA professional program.\nFoundational aspects of 2D analog and digital medium. Students will learn how to view, analyze, represent and design through the lens of landscape architecture.",
    "credits": "5"
  },
  {
    "course_name": "Modeling Landscapes Studio",
    "dept": "LAR",
    "num": "230",
    "desc": "Prerequisite: LAR 220.\nFoundational aspects of 3D modeling using both analog and digital medium. Students will learn how to view, analyze, represent and design through creation and fabrication of 3D models.",
    "credits": "5"
  },
  {
    "course_name": "Landscape Architecture Materials and Methods",
    "dept": "LAR",
    "num": "248",
    "desc": "Prerequisite: PHYS 113, 115 or 213.  Prerequisite or co-requisite: LAR 520.\nTo provide the student a basic understanding of materials and methods commonly utilized in the practice of landscape architecture as a basis to pursue subsequent land design and land construction course work.",
    "credits": "3"
  },
  {
    "course_name": "Design Graphics and Visual Thinking",
    "dept": "LAR",
    "num": "310",
    "desc": "Prerequisite: Admission to the LA professional program.\nA study of graphic communication techniques for the exploration and presentation of landscape architecture design ideas.",
    "credits": "2"
  },
  {
    "course_name": "Unlocking Creativity",
    "dept": "LAR",
    "num": "311",
    "desc": "\nDo you want to become creative? Good news, you already are! For students in all majors, this course is designed to help you access your creative potential and become more imaginative, innovative, and courageous. Learning outcomes include overcoming blocks, refining your creative process, practicing activities to enhance creativity, and effectively communicating ideas.",
    "credits": "3"
  },
  {
    "course_name": "Site Design Studio II",
    "dept": "LAR",
    "num": "320",
    "desc": "Prerequisite: LAR 220.  Prerequisite or corequisite: LAR 520.\nSmall- to medium-scale site design studies with emphasis placed on design process, response to cultural and natural conditions, detailed articulation of space including definition and use of materials, and design communication.",
    "credits": "5"
  },
  {
    "course_name": "Ethics and Environmental Dilemmas",
    "dept": "LAR",
    "num": "322",
    "desc": "\nIntroduction to environmental ethics and significant local and global dilemmas. Students will learn about how humans have impacted the environment through time and the implications of those actions, and environmental/social movements and justice.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Plants",
    "dept": "LAR",
    "num": "350",
    "desc": "Corequisite: LAR 220.\nIntroduction to plant morphology, forms of classification, and a basic understanding of plant habitat. Students will learn to identify a palette of plants in the field and understand their application for design.",
    "credits": "1"
  },
  {
    "course_name": "Plant Patterns and Use",
    "dept": "LAR",
    "num": "351",
    "desc": "Prerequisite: LAR 350.\nIntroduction to the patterns and use of plants in cultural and natural contexts. Students will identify plant palettes and communities in historical and contemporary landscapes.",
    "credits": "1"
  },
  {
    "course_name": "Landscape Performance Lab",
    "dept": "LAR",
    "num": "352",
    "desc": "Prerequisite: LAR 351, LAR 322, LAR 420.\nIntroduction to the scientific process as well as methods for assessing landscape performance. Students will learn how to acquire, organize and analyze information using qualitative and quantitative methods.",
    "credits": "3"
  },
  {
    "course_name": "Plant Selection",
    "dept": "LAR",
    "num": "353",
    "desc": "Prerequisite: LAR 352.\nSelection of plants for specific site requirements. Students learn how to anticipate plant performance and identify plants to achieve design goals in associated courses.",
    "credits": "1"
  },
  {
    "course_name": "Landscape Restoration",
    "dept": "LAR",
    "num": "354",
    "desc": "Prerequisite: LAR 353.\nDevelopment of landscape restoration plans. Students will learn the principles, methods, and plants of ecological restoration at local and regional scales.",
    "credits": "1"
  },
  {
    "course_name": "Planting Design Studio",
    "dept": "LAR",
    "num": "410",
    "desc": "Prerequisite: LAR 320.  Prerequisite or corequisite: LAR 520, HORT 374.\nDesign studies emphasizing functional, aesthetic, and ecological uses of plants. projects emphasize design process and the relationship between plants and the built environment; elements and principles of planting design; plant selection; preparation of planting plans; specification writing; and design implementation.",
    "credits": "5"
  },
  {
    "course_name": "Socio-Ecological Systems Studio",
    "dept": "LAR",
    "num": "420",
    "desc": "Prerequisite: LAR 230.\nIntroduction to key principles of ecology as related to ecological planning and design. Students will learn how to connect theoretical knowledge of socio-ecological systems and processes to address multi-scale problems in urban and rural contexts.",
    "credits": "5"
  },
  {
    "course_name": "Narratives and Placemaking Seminar",
    "dept": "LAR",
    "num": "425",
    "desc": "Prerequisite: LAR 420.\nImmersive exploration into fundamentals of landscape narratives, place theory and placemaking. Students will examine and engage in a variety of locations, create expressions of narrative using a variety of representational techniques, and apply knowledge gained in site design.",
    "credits": "2"
  },
  {
    "course_name": "Narratives and Placemaking Studio",
    "dept": "LAR",
    "num": "430",
    "desc": "Prerequisite: LAR 420.\nImmersive exploration into fundamentals of landscape narratives, place theory and placemaking. Students will examine and engage in a variety of locations, create expressions of narrative using a variety of representational techniques, and apply knowledge gained in site design.",
    "credits": "4"
  },
  {
    "course_name": "Landscape History and Design Studio",
    "dept": "LAR",
    "num": "433",
    "desc": "Prerequisite: LAR 230.\nIntroduction to the history and theory of landscape architecture materials and design from the Middle Ages to the present with a focus on Europe and North America. Students will gain competency in landscape architecture vocabulary, the ability to recognize notable works and practitioners, and apply historical precedents to site design projects.",
    "credits": "5"
  },
  {
    "course_name": "Site Design Implementation",
    "dept": "LAR",
    "num": "438",
    "desc": "Prerequisite: LAR 425, LAR 430.\nIntroduction to construction materials, methods, and documentation appropriate for design implementation at the site scale. Focus on producing a set of construction documents including grading, stormwater management, plants and materials.",
    "credits": "5"
  },
  {
    "course_name": "Master Plan Design and Implementation",
    "dept": "LAR",
    "num": "439",
    "desc": "Prerequisite: LAR 438.\nDesign implementation at the master plan and regional scales. Focus on suitability analyses and systems supporting community services such as pedestrian and vehicular transportation, land use, hydrology and other natural systems.",
    "credits": "5"
  },
  {
    "course_name": "Site Research and Design Studio",
    "dept": "LAR",
    "num": "442",
    "desc": "Prerequisite: LAR 352, LAR 425, LAR 430.\nIterative development of site plans and designs. Students will research and share precedent studies to expand knowledge base, and will apply findings to multiple design projects.",
    "credits": "5"
  },
  {
    "course_name": "Career and Academic Planning",
    "dept": "LAR",
    "num": "444",
    "desc": "Prerequisite: LAR 430.\nExploration and identification of career paths and development of academic plans for reaching personal and professional goals including specific coursework, internships, study abroad and extracurricular activities.",
    "credits": "2"
  },
  {
    "course_name": "Career Development Communications",
    "dept": "LAR",
    "num": "445",
    "desc": "Prerequisite: LAR 444.\nDevelopment of visual, written and oral communication skills for career development. Students will prepare materials for internship application, job search, or career advancement.",
    "credits": "1"
  },
  {
    "course_name": "Site Planning and Design",
    "dept": "LAR",
    "num": "500",
    "desc": "Prerequisite: ARCH 403 or concurrent enrollment with ARCH 403, or admission to RCP professional program.\nTheory, principles, and elements of site planning and design. Lectures, readings, short problems, and site visits dealing with site analysis, ecological consideration, grading drainage, circulation and parking, lighting, planting design, materials and details, management and maintenance, and cost factors.",
    "credits": "3"
  },
  {
    "course_name": "Landscape Architecture Seminar I",
    "dept": "LAR",
    "num": "501",
    "desc": "\nDiscussion of current trends in landscape architecture and related fields by students, faculty, and invited speakers.",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture Tech Module I",
    "dept": "LAR",
    "num": "510",
    "desc": "Prerequisite: Admission to LA professional program.\nIntroductory theory, methods, and application of technological skills and support of concurrent landscape architecture studios and courses. Emphasis is on data collection and management and mapping and analysis.",
    "credits": "1"
  },
  {
    "course_name": "Landscape Architecture Tech Module II",
    "dept": "LAR",
    "num": "520",
    "desc": "Prerequisite: LAR 510.\nIntroductory theory, methods, and application of technological skills and support of concurrent landscape architecture studios and courses. Emphasis is on CAD and 3-D modeling.",
    "credits": "1"
  },
  {
    "course_name": "Landscape Architecture Tech Module III",
    "dept": "LAR",
    "num": "530",
    "desc": "Prerequisite: LAR 520.\nIntermediate theory, methods, and application of technological skills and support of concurrent landscape architecture studios and courses. Emphasis is on CAD and 3-D modeling and surveying.",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture Tech Module IV",
    "dept": "LAR",
    "num": "540",
    "desc": "Prerequisite: LAR 530.\nIntermediate theory, methods, and application of technological skills and support of concurrent landscape architecture studios and courses. Emphasis is on CAD and 3-D modeling and presentation graphics.",
    "credits": "1"
  },
  {
    "course_name": "Landscape Architecture Tech Module V",
    "dept": "LAR",
    "num": "550",
    "desc": "Prerequisite: LAR 540.\nAdvanced application of technological skills and support of concurrent landscape architecture studios and courses. Emphasis is on CAD and 3-D modeling, thematic mapping, and geoprocessing.",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture Tech Module VI",
    "dept": "LAR",
    "num": "560",
    "desc": "Corequisite: LAR 705.\nAdvanced project specific applications in data collection and management, CAD modeling, thematic mapping and GIS, and presentation graphics.",
    "credits": "1"
  },
  {
    "course_name": "Planning and Design Intro to GIS",
    "dept": "LAR",
    "num": "580",
    "desc": "\nThis course will provide students with the essential background in geospatial analysis and information systems for the design and planning fields. Students will learn basics about data models and management, vector and raster analysis and cartography. Students will learn how to use these skills to develop suitability analyses to evaluate the performance of plans and designs or to identify which location would be best for a particular purpose.",
    "credits": "2"
  },
  {
    "course_name": "Golf Course Planning and Design",
    "dept": "LAR",
    "num": "635",
    "desc": "\nFundamentals of golf course planning and design, including: history, management, design, facilities, aesthetics, and technical development.",
    "credits": "1-4"
  },
  {
    "course_name": "Professional Internship Report",
    "dept": "LAR",
    "num": "645",
    "desc": "Prerequisite:  LAR 655.\nConfirmed employment with a landscape architecture, architecture, planning, or engineering sponsor.",
    "credits": "1"
  },
  {
    "course_name": "Community Engagement Studio",
    "dept": "LAR",
    "num": "646",
    "desc": "Prerequisite: LAR 442.  Corequisite: LAR 050.\nEngagement with communities and stakeholders through service learning projects. Focus on engagement methods and visualization, representation and communication to general audiences. Utilizes planning and design techniques and knowledge gained in previous semesters.",
    "credits": "5"
  },
  {
    "course_name": "Design Implementation III",
    "dept": "LAR",
    "num": "647",
    "desc": "Prerequisite: LAR 439.\nContinuation of LAR 439 to include large scale site design, road alignment, large area grading, soils and excavation methods, storm drainage, and utilities routing.",
    "credits": "5"
  },
  {
    "course_name": "Advanced Studio",
    "dept": "LAR",
    "num": "648",
    "desc": "Prerequisite: LAR 354, LAR 439, LAR 444, LAR 646.\nIn-depth exploration of a specific landscapte architecture topic.",
    "credits": "5"
  },
  {
    "course_name": "Landscape Architecture Seminar II",
    "dept": "LAR",
    "num": "650",
    "desc": "\nLiterature review and discussion of current issues and trends in community planning and design. Readings and discussion in preparation for field trip.",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture Professional Internship",
    "dept": "LAR",
    "num": "655",
    "desc": "Prerequisite: LAR 444.\nTwenty-eight week internship with an approved landscape architecture, architecture, planning or engineering sponsor subject to the approval of the departmental faculty.",
    "credits": "7-9"
  },
  {
    "course_name": "Project Programming",
    "dept": "LAR",
    "num": "700",
    "desc": "Prerequisite: LAR 725, LAR 648, LAR 750 or corequisite: LAR 750.\nResearch and the development of a program directed toward the advancement of a capstone project for LAR 705 Master’s Project and Report.",
    "credits": "3"
  },
  {
    "course_name": "Landscape Architecture Off-Campus Studio",
    "dept": "LAR",
    "num": "703",
    "desc": "Prerequisite: LAR 647, 648 and 444.\nOff campus design studies fulfilled in an approved professional design office or in an approved international studies program.",
    "credits": "5"
  },
  {
    "course_name": "Environmental Landscape Planning and Design",
    "dept": "LAR",
    "num": "704",
    "desc": "Prerequisite: LAR 580, or GEOG 508 or equivalent, or instructor permission.\nIntroduction to and understanding of environmental planning, design and management of natural and social landscape systems beyond site scale. The course focuses on theories, techniques and processes for designing sustainable landscapes and urban environments. Students will develop a final project starting with the conceptualization, through inventory, analysis and simulation, in order to develop a final design proposal.",
    "credits": "3"
  },
  {
    "course_name": "Master’s Project Studio 1",
    "dept": "LAR",
    "num": "705",
    "desc": "Prerequisite: LAR 648, LAR 725, LAR 750.\nIn-depth exploration of a specific landscape architecture topic through research and design supervised by a major professor in accordance with Graduate School guidelines.",
    "credits": "5"
  },
  {
    "course_name": "Master’s Project Studio 2",
    "dept": "LAR",
    "num": "710",
    "desc": "Prerequisite: LAR 705.\nIn-depth exploration of a specific landscape architecture topic through research and design supervised by a major professor in accordance with Graduate School guidelines.",
    "credits": "3"
  },
  {
    "course_name": "Public Lands and Natural Resources Law",
    "dept": "LAR",
    "num": "720",
    "desc": "Prerequisite: Advanced standing.\nLegal aspects of land use and natural resource management on the federal public lands. A brief history of the acquisition and disposition of the public domain and a review of legal authority on the public lands are followed by an examination of key legal issues concerning the resources of water, minerals, timber, range, wildlife, recreation and wilderness.",
    "credits": "3"
  },
  {
    "course_name": "Research Methods",
    "dept": "LAR",
    "num": "725",
    "desc": "\nDevelopment of the research design process. Students will learn to employ appropriate methods and strategies to answer research questions, and to effectively and clearly communicate research-based information to peers and the public.",
    "credits": "3"
  },
  {
    "course_name": "Rivers: Process & Forms",
    "dept": "LAR",
    "num": "734",
    "desc": "\nThis course addresses key aspects of hydrology such as precipitation and movement of water from uplands to channels. This movement, generally referred to as “runoff processes,” is responsible for shaping the watershed. It then focuses upon fluvial geomorphology, the science of riverscapes, to examine processes and resultant landforms. This course teaches field observation skills and field survey procedures that allow the classification of natural rivers and streams. Finally, it previews methods of prediction and monitoring of river channel stability parameters.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Golf Course Planning and Design",
    "dept": "LAR",
    "num": "735",
    "desc": "Prerequisite: LAR 635.\nAdvanced methods and strategies of golf course and resort planning and design.",
    "credits": "1-4"
  },
  {
    "course_name": "Problems in Landscape Architecture",
    "dept": "LAR",
    "num": "741",
    "desc": "\nSpecific problems and/or reports in the area of landscape architecture.",
    "credits": "1-18"
  },
  {
    "course_name": "Topics in Italian Landscape Architecture",
    "dept": "LAR",
    "num": "742",
    "desc": "\nInvestigation of Italian culture, landscape and communities through analytical readings and/or drawings.",
    "credits": "3"
  },
  {
    "course_name": "Professional Practice",
    "dept": "LAR",
    "num": "745",
    "desc": "\nStudies of conventional and newly developing methods of professional design practice. Instruction in the relationships of architects, landscape architects, interior architects, and other professionals to users, clients, construction industry, society, government, and one another.",
    "credits": "3"
  },
  {
    "course_name": "Urban Design Studio I",
    "dept": "LAR",
    "num": "746",
    "desc": "Prerequisite: PLAN 315 or equivalent and concurrent enrollment in PLAN 745.\nAn interdisciplinary design studio involving large-scale design; projects with extensive time implementation sequence; responses to socioeconomic, cultural, environmental, and technical needs; and implementation strategies. Design methods are applied to selected urban areas of the Midwest.",
    "credits": "4"
  },
  {
    "course_name": "Advanced Seminar",
    "dept": "LAR",
    "num": "750",
    "desc": "\nStudies and discussion of topics related to advanced studio.",
    "credits": "2"
  },
  {
    "course_name": "Professional Practice: Professional Responsibility",
    "dept": "LAR",
    "num": "753",
    "desc": "Prerequisite: LAR 442.\nInterdisciplinary course addresses the connections between allied design professions and the larger community. It helps students to understand and appreciate their professional legal and ethical responsibilities.",
    "credits": "1"
  },
  {
    "course_name": "Professional Practice: Office Practices",
    "dept": "LAR",
    "num": "754",
    "desc": "Prerequisite: LAR 442.\nInterdisciplinary course addresses practice-based issues concerning professional relationships in the design and delivery process, management of projects, communication practices, and fiscal concerns.",
    "credits": "1"
  },
  {
    "course_name": "Professional Practice: Discipline-Specific Topics",
    "dept": "LAR",
    "num": "755",
    "desc": "Prerequisite: LAR 442.\nCovers discipline-specific concerns, focusing on issues specific to architecture, interior architecture and product design, landscape architecture or regional and community planning.",
    "credits": "1"
  },
  {
    "course_name": "Design of Parks and Recreation Areas",
    "dept": "LAR",
    "num": "756",
    "desc": "\nSite planning of national, state, municipal, and private parks, and specialized recreation areas.",
    "credits": "3"
  },
  {
    "course_name": "Design for Special Populations",
    "dept": "LAR",
    "num": "757",
    "desc": "Prerequisite: Advanced undergraduate or graduate standing.\nDesign of exterior environment to accommodate the handicapped and disadvantaged individual.",
    "credits": "3"
  },
  {
    "course_name": "Landscape Resource Evaluation",
    "dept": "LAR",
    "num": "759",
    "desc": "Prerequisite: Senior or graduate standing.\nThe determination of the impact of physical project design upon the natural and man-made environment. Studies of existing site conditions and projections of the effect of such projects upon the site and vicinity.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Planting Design",
    "dept": "LAR",
    "num": "860",
    "desc": "Prerequisite: LAR 749.\nSpecial studies in advanced planting design.",
    "credits": "1-4"
  },
  {
    "course_name": "Advanced Landscape Architecture",
    "dept": "LAR",
    "num": "870",
    "desc": "Prerequisite: LAR 702.\nSpecial studies and design in advanced landscape architecture.",
    "credits": "1-4"
  },
  {
    "course_name": "Advanced Landscape Architecture Construction",
    "dept": "LAR",
    "num": "880",
    "desc": "Prerequisite: LAR 439.\nSpecialized study of large-scale landscape planning involving landscape construction and grading.",
    "credits": "1-4"
  },
  {
    "course_name": "Proposal Writing",
    "dept": "LAR",
    "num": "897",
    "desc": "Prerequisite: LAR 648, LAR 725, LAR 750.\nDevelopment of a master’s project and report proposal.",
    "credits": "2"
  },
  {
    "course_name": "Master’s Report",
    "dept": "LAR",
    "num": "898",
    "desc": "Prerequisite: LAR 700. Corequisite: LAR 705.\nComprehensive application of research and design study through individual studies approved by the department faculty.",
    "credits": "2"
  },
  {
    "course_name": "Research in Landscape Architecture",
    "dept": "LAR",
    "num": "899",
    "desc": "Prerequisite: Graduate standing in landscape architecture.\nInvestigations in landscape architecture and related areas, of such caliber as to form the basis for a graduate thesis.",
    "credits": "1-18"
  },
  {
    "course_name": "Latin I",
    "dept": "LATIN",
    "num": "101",
    "desc": "\nAn introductory study of the structure of Latin.",
    "credits": "5"
  },
  {
    "course_name": "Latin II",
    "dept": "LATIN",
    "num": "102",
    "desc": "Prerequisite: LATIN 101.\nContinuation and completion of the study of the structure of Latin.",
    "credits": "5"
  },
  {
    "course_name": "Intermediate Latin - Prose",
    "dept": "LATIN",
    "num": "301",
    "desc": "Prerequisite: LATIN 102.\nContinuation of the study of Latin syntax and grammar, based upon reading of Roman prose. Topics may include Caesar, Cicero, or Sallust.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Latin - Poetry",
    "dept": "LATIN",
    "num": "302",
    "desc": "Prerequisite: LATIN 301.\nThe reading of Latin poetry in the original at an intermediate level. Topics may include Virgil, Ovid, and Lucretius.",
    "credits": "3"
  },
  {
    "course_name": "CAT Community Connections",
    "dept": "LEAD",
    "num": "195",
    "desc": "\nInterdisciplinary course that explores the connections among two different fields, courses, or disciplines. For first-year students enrolled in a specific CAT (Connections Across Topics) Community linked to the Staley School of Leadership Studies.",
    "credits": "1-3"
  },
  {
    "course_name": "Foundations of Leadership of Society",
    "dept": "LEAD",
    "num": "200",
    "desc": "\nExpose students to a variety of concepts, theories and skills relevant to contemporary leadership thought. Consider their personal conceptions and philosophy of leadership. Examine leadership within particular contexts such as creating change, ethical leadership, leadership and management, and historical leadership thought and leaders.",
    "credits": "1-3"
  },
  {
    "course_name": "Introduction to Leadership Concepts",
    "dept": "LEAD",
    "num": "212",
    "desc": "\nThis course is organized to provide students with a broad overview of leadership theories, an introduction to ethical decision making, identification of personal leadership styles, and current societal issues for leaders.",
    "credits": "2-3"
  },
  {
    "course_name": "Fundamentals of Global Food Systems Leadership",
    "dept": "LEAD",
    "num": "225",
    "desc": "\nAn interdisciplinary approach to the fundamental roles people, policies, and cultures play in the global food system enterprise as it relates to sustainable food production, processing, distribution, and availability. Students will explore complexities within self, others, and community related to leadership in the context of a rapidly increasing global population.",
    "credits": "3"
  },
  {
    "course_name": "Honors Leadership I",
    "dept": "LEAD",
    "num": "251",
    "desc": "Prerequisite: Freshman standing with honors.\nThis is the first of two courses in a year-long curriculum that is designed to explore four tenets of leadership: citizenship, stewardship, humanitarianism, and purposeful passion. Students will begin to clarify and express their core values as they explore questions around effective leadership and followership concepts and strategies.",
    "credits": "3"
  },
  {
    "course_name": "Honors Leadership II",
    "dept": "LEAD",
    "num": "252",
    "desc": "Prerequisite: LEAD 251 Honors Leadership I. Freshman standing with honors.\nThis is the second of two courses in a year-long curriculum that is designed to explore four tenets of leadership: citizenship, stewardship, humanitarianism, and purposeful passion. Students will continue to explore their values and develop leadership and teamwork skills through service, reflection, and designing a purposeful passion project.",
    "credits": "3"
  },
  {
    "course_name": "Peer Leader Practicum",
    "dept": "LEAD",
    "num": "312",
    "desc": "Prerequisite: LEAD 212 - Introduction to Leadership Concepts.\nThis course uses experiential learning to prepare students with the personal, relational, planning, and facilitation skills needed to effectively lead a team or organization. Weekly LEAD 212 facilitation, class preparation seminars, and peer feedback will allow for experience, reflection, meaning-making, and experimentation.",
    "credits": "0-3"
  },
  {
    "course_name": "Theories of Leadership",
    "dept": "LEAD",
    "num": "320",
    "desc": "\nThis course provides an overview of the major theories of leadership and the empirical and theoretical evidence supporting those theories. Students will demonstrate an understanding of the theories and the empirical evidence supporting them as well as develop their ability to critically assess the theoretical and empirical work surrounding leadership theories and models.",
    "credits": "3"
  },
  {
    "course_name": "Uncertainty in Global Food Systems Leadership",
    "dept": "LEAD",
    "num": "325",
    "desc": "Prerequisite: GENAG 225 or LEAD 225 or DAS 225.\nExplore technical and adaptive elements of grand challenges across disciplines. This course addresses the impact of cultural identity, life experience, and world views on leadership relationships as it relates to privilege and inclusion in the context of global food systems. Students will consider elements of community-engaged work.",
    "credits": "3"
  },
  {
    "course_name": "Culture and Context in Leadership",
    "dept": "LEAD",
    "num": "350",
    "desc": "\nOpportunity to integrate the course and leadership experiences in light of contemporary issues in the study of leadership behavior across cultures and contexts. Based on the current research and writing that introduce and discuss the impact of culture and context on the concept of leadership and development of individuals as interculturally competent leaders.",
    "credits": "3"
  },
  {
    "course_name": "Internships for Career Development",
    "dept": "LEAD",
    "num": "399",
    "desc": "\nThis course helps you apply your academic knowledge, skills and understanding to experiences as a developing leader within the workplace. The course is structured to incorporate your internship experience with self-directed analysis to develop your personal, academic and professional competencies. You will practice and reflect on your leadership strengths.",
    "credits": "1"
  },
  {
    "course_name": "Leadership in Practice",
    "dept": "LEAD",
    "num": "405",
    "desc": "Prerequisite: LEAD 212, LEAD 350, and junior standing.\nThis course provides an opportunity to practice leadership and followership in an experiential setting followed by an in-depth classroom discussion.",
    "credits": "2"
  },
  {
    "course_name": "Theories of Nonprofit Leadership",
    "dept": "LEAD",
    "num": "420",
    "desc": "Prerequisite: LEAD 212, LEAD 350 and LEAD 405.  Corequisite: Junior standing.\nThis course provides an overview of nonprofit organization leadership by integrating concepts and theories with applied practice.  Students will demonstrate an understanding and application of competencies (knowledge and skills) necessary for professional success as a nonprofit organization leader.",
    "credits": "3"
  },
  {
    "course_name": "Global Food Systems Leadership in Action",
    "dept": "LEAD",
    "num": "425",
    "desc": "Prerequisite: GENAG 325 or LEAD 325 or DAS 325.\nIn this capstone course, students will conduct a community-engaged global food systems leadership research/service project. Emphasis will be placed on data collection, analysis and dissemination to appropriate audiences. Additional emphases will be on ethical dimensions of leadership and individual exploration of careers and roles within global food systems.",
    "credits": "3"
  },
  {
    "course_name": "Women and Leadership",
    "dept": "LEAD",
    "num": "430",
    "desc": "Prerequisite: LEAD 212 or WOMST 105.\nThis course addresses issues related to leadership as it intersects with women’s studies scholarship, such as: women’s styles of leadership, women and competition, sexism in the workplace, gender differences in communication, and feminist models of leadership. This course will explore issues related to women’s leadership development in the theoretical contexts of leadership studies and women’s studies.",
    "credits": "3"
  },
  {
    "course_name": "Senior Seminar in Leadership Studies",
    "dept": "LEAD",
    "num": "450",
    "desc": "Prerequisite: LEAD 212, 350, 405, and senior standing.\nIn this capstone course students will integrate and apply learning from the minor. Emphasis will be on the clarification of the students’ personal values, their evaluation of codes of ethics for organizations in their proposed professions, and their analysis of current events through the lens of ethical dimensions of leadership.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in International Service-Learning",
    "dept": "LEAD",
    "num": "489",
    "desc": "Prerequisite: Students must complete a program application, interview, and be accepted into the International Service Team program prior to enrollment in the course.\nThis course is the first phase of the International Service Teams service-learning program. Learning in the course facilitates preparation for the summer service experience. This course is designed around the PARE service-learning model; both the curriculum and class expectations will be reflective of the service-learning process.",
    "credits": "3"
  },
  {
    "course_name": "Nonprofit Organization Internship",
    "dept": "LEAD",
    "num": "499",
    "desc": "Prerequisite: LEAD 212, LEAD 405, LEAD 420, LEAD 502-Ethical Dimensions of Leadership.\nThis course provides a capstone opportunity for students in the nonprofit leadership focus of the leadership studies minor to document and present their achievement of the foundation and professional development competencies required by American Humanics national certification in nonprofit leadership through coursework, co-curricular and work experiences, and their 300-hour internship experience.  Current texts focusing on the leadership of high impact nonprofit organizations will be incorporated into this process.",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Leadership Studies",
    "dept": "LEAD",
    "num": "502",
    "desc": "Prerequisite: Consent of department chair.\nSelected topics in leadership studies.",
    "credits": "0-3"
  },
  {
    "course_name": "Foundations of Community-Engaged Leadership",
    "dept": "LEAD",
    "num": "510",
    "desc": "\nThis course integrates leadership theory and practice exploring principles, purposes, and processes of community engagement and democratic practice. Utilizing service-learning methods, students will partner with community to consider and examine foundational forms of civic and public life. Community paradigms will be explored and deconstructed in relation to course themes.",
    "credits": "3"
  },
  {
    "course_name": "Approaches to Community-Engaged Leadership",
    "dept": "LEAD",
    "num": "520",
    "desc": "Prerequisite: LEAD 510.\nThrough theory and practice, students consider the ethical dimensions of leadership in relation to community systems, organizations, and institutions. Students will deconstruct concepts of community-engaged leadership including race, class, gender, justice, and power. Through service-learning, students will work with partners to understand community systems, organizations, and institutions.",
    "credits": "3"
  },
  {
    "course_name": "Experiences in Community-Engaged Leadership",
    "dept": "LEAD",
    "num": "560",
    "desc": "Prerequisites: LEAD 510 and LEAD 520.\nIn this capstone experience students design, plan, execute, and evaluate a community-engaged research project. The project will be consistent with the principles of community engagement and the purposes and process of democratic practice. Students will exercise leadership with community partners to build capacity for systemic change.",
    "credits": "6"
  },
  {
    "course_name": "General Phonetics",
    "dept": "LG",
    "num": "601",
    "desc": "\nDescription and classification of speech sounds according to point and manner of articulation. Transcription in the International Phonetic Association alphabet. Includes sounds of English, French, Spanish, German, and others.",
    "credits": "3"
  },
  {
    "course_name": "Historical Linguistics",
    "dept": "LG",
    "num": "602",
    "desc": "\nInternal and comparative reconstruction of earlier forms of languages. Genetic relationships in language families, and various typological considerations. Includes French, Spanish, and others.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Linguistics",
    "dept": "LG",
    "num": "603",
    "desc": "\nSeminar on a special topic in linguistics: decipherment of ancient writing systems, linguistics applied to the teaching of English or other languages, discourse analysis (especially of spoken texts), etc. Topic to be announced for semester in which offered.",
    "credits": "1-3"
  },
  {
    "course_name": "Problems in Life Span Human Development",
    "dept": "LSHD",
    "num": "700",
    "desc": "\nRelevant topics in life span human development will be explored in a small group setting.",
    "credits": "1-6"
  },
  {
    "course_name": "Introduction to Total Quality Management",
    "dept": "MANGT",
    "num": "300",
    "desc": "Prerequisite: MATH 100, 205, or 220, sophomore standing.\nOverview of major topics related to Total Quality Management (TQM), including managerial and engineering aspects.",
    "credits": "1"
  },
  {
    "course_name": "Information Technology for Business",
    "dept": "MANGT",
    "num": "366",
    "desc": "Prerequisite: GENBA 166 or CIS 101, 102, 103.\nA comprehensive view of the role of information technology in satisfying organizations’ information requirements. Problems and techniques concerning the management of responsive information systems with special attention to managers’ use of systems outputs. Cases and hands-on exercises emphasizing the use of information systems in decision making, information gathering and organizing, use of modeling techniques, and presentation of information.",
    "credits": "3"
  },
  {
    "course_name": "Business Law II",
    "dept": "MANGT",
    "num": "392",
    "desc": "Prerequisite: MANGT 390.\nA study of civil law as it affects commercial transactions, including corporations, partnerships, property, commercial paper, and secured transactions.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Management",
    "dept": "MANGT",
    "num": "420",
    "desc": "\nProvides an introduction to the four basic managerial functions of planning, organizing, leading and controlling and their application to today’s complex work environment. An emphasis is placed on the roles and responsibilities of managers that help them to successfully meet organizational objectives by effectively leading employees and optimizing processes.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Operations and Supply Chain Management",
    "dept": "MANGT",
    "num": "421",
    "desc": "\nTo gain knowledge of Operations and Supply Chain Management (OSCM) principles and techniques, such as process management, project management, quality management, continuous improvement, forecasting, supply chain management, inventory management, planning and scheduling, and lean systems. The primary goals are to develop students’ analytical skills in solving OSCM-related problems in a variety of business settings and to help students understand how OSCM contributes to a firm’s competitive position in a global marketplace.",
    "credits": "3"
  },
  {
    "course_name": "Business Law I",
    "dept": "MANGT",
    "num": "430",
    "desc": "Prerequisite: MANGT 420 or Junior standing.\nA study of law as it relates to business, including court procedures and systems, contracts, torts, agency and employment law, and business crimes.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "MANGT",
    "num": "490",
    "desc": "Prerequisite: Consent of instructor.\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Management Internship",
    "dept": "MANGT",
    "num": "495",
    "desc": "Prerequisite: MANGT 420 and consent of instructor.\nEight weeks of applied management business designed to coordinate the interests of students and firms.",
    "credits": "0-3"
  },
  {
    "course_name": "Topics in Management",
    "dept": "MANGT",
    "num": "497",
    "desc": "\nDiscussion and analysis of current issues in management, including topics related to new theory, the practice of management, and management development.",
    "credits": "1-3"
  },
  {
    "course_name": "Independent Studies in Management",
    "dept": "MANGT",
    "num": "498",
    "desc": "Prerequisite: Senior standing, consent of instructor, and 12 hours of management.\nIn-depth analysis of special problems in management including study of current literature.",
    "credits": "1-18"
  },
  {
    "course_name": "Organizational Behavior",
    "dept": "MANGT",
    "num": "520",
    "desc": "Prerequisite: MANGT 420.\nExamination of psychological and sociological variables important in understanding individual motivation, group functioning, change, creativity, and leadership in organizations.",
    "credits": "3"
  },
  {
    "course_name": "Managerial Decision Analytics",
    "dept": "MANGT",
    "num": "521",
    "desc": "Prerequisite: GENBA 166 or CIS 101, 102, 103 or 200 and lab, MANGT 420, MATH 205, and STAT 350.\nGiven the flood of data available to businesses regarding their supply chain these days, companies are turning to analytics solutions to extract meaning from big data to help improve decision making. Managerial decision analytics is designed to render managerial decisions supported by analytic capabilities that improve the decision-making process and reduce decision time, complexity, and uncertainty.",
    "credits": "3"
  },
  {
    "course_name": "Operations Planning and Control",
    "dept": "MANGT",
    "num": "522",
    "desc": "Prerequisite: MANGT 421.\nDevelopment of concepts and understanding of planning and control systems for allocating resources and scheduling activities in business firms. To guide and coordinate the flow of materials, labor inputs, and goods and services through physical productive systems. Topics include: aggregate planning, master production scheduling, production activity planning and control, operations information systems, inventory control, material requirements planning, and total quality control.",
    "credits": "3"
  },
  {
    "course_name": "Labor Relations and Negotiations",
    "dept": "MANGT",
    "num": "530",
    "desc": "Prerequisite: MANGT 420 or Junior standing.\nThis is a problem based learning course which aims to increase students’ knowledge of flour milling and specialty grain milling. During the semester students develop critical thinking and problem-solving skills needed to troubleshoot real-life issues related to processing, quality assurance, HSE (Health, Safety, and Environment), and finished product quality. Students are expected to analyze their problems and develop the skills needed to effectively communicate their findings during group presentations.",
    "credits": "3"
  },
  {
    "course_name": "Human Resources Management",
    "dept": "MANGT",
    "num": "531",
    "desc": "Prerequisite: MANGT 420.\nThis course provides an overview of the human resource systems and processes needed to achieve organizational effectiveness and strategic success. All key functional areas including human resource planning, staffing, performance management, employee development, and compensation are addressed.",
    "credits": "3"
  },
  {
    "course_name": "Employment Law",
    "dept": "MANGT",
    "num": "535",
    "desc": "Prerequisite: MANGT 531.\nA survey course designed to acquaint students with the broad and controlling aspects of prominent laws which affect human resource management. Topics include ADA, ADEA, OSHA, Title VII, etc.",
    "credits": "3"
  },
  {
    "course_name": "Management of Quality",
    "dept": "MANGT",
    "num": "541",
    "desc": "Prerequisite: MANGT 421.\nAddresses quality management topics and applications vital to business and organizational improvement.  Coverage of quality as a management philosophy through the study of ideas from contemporary quality philosophies of Deming, Juran, and Taguchi, as well as topics of Lean Six Sigma, Kaizen continuous improvement, employee empowerment, statistical process control charting, and other applicable organizational topics.",
    "credits": "3"
  },
  {
    "course_name": "Organizational Training and Development",
    "dept": "MANGT",
    "num": "550",
    "desc": "Prerequisite: MANGT 520 and MANGT 531.\nThe process of training and developing the human resources in organizations, which includes organizational diagnosis, needs assessment, program design, appropriate methodologies, program implementation, transfer of training, and the evaluation of program effectiveness. Current trends in the content and process of training and development activities are also examined.",
    "credits": "3"
  },
  {
    "course_name": "Business Project Management",
    "dept": "MANGT",
    "num": "553",
    "desc": "Prerequisite: MANGT 420, MANGT 421.\nProvides an in-depth coverage of project management concepts and methodologies required for service and manufacturing operations. Topics to be covered include, but are not limited to: project selection and evaluation, project organization, management or project team members organization, project scheduling, project budgeting, project monitoring and control and project closure.",
    "credits": "3"
  },
  {
    "course_name": "Managing for Diversity and Inclusion in the Workplace",
    "dept": "MANGT",
    "num": "560",
    "desc": "Prerequisite: MANGT 420 or Junior standing.\nProvides a framework for understanding how diversity and a culture of inclusion interfaces with all aspects of an organization. Topics include the business case for diversity and inclusion (D&amp;I), related demographic, technological, and social changes, current events and their associated impact in the workplace, diversity recruitment and retention, and theories and strategies for creating inclusion. On an individual level, students will develop their ability to communicate across differences. On an organizational level, students will gain skills to develop and present a strategic plan for diversity and inclusion.",
    "credits": "3"
  },
  {
    "course_name": "Computer Systems for Finance and Investment Management",
    "dept": "MANGT",
    "num": "566",
    "desc": "Prerequisite: MANGT 366 and FINAN 450.\nAn integrated course examining the interrelationship between finance/investment management and information technology taught using a mixture of theory/concepts and hands-on activities. Topics include spreadsheet design and use in finance and investments, decision support systems and artificial intelligence used in risk analysis, financial database design, and information technologies used to transmit financial and investment information.",
    "credits": "3"
  },
  {
    "course_name": "International Management",
    "dept": "MANGT",
    "num": "590",
    "desc": "Prerequisite: MANGT 420.\nAnalysis of the political, legal, economic, and sociocultural environments and how they influence international management decisions such as timing and place of foreign market entry, mode of entry, and formulations and implementation of international strategies. Development of knowledge and skills necessary for managing international operations including cross-cultural communication.",
    "credits": "3"
  },
  {
    "course_name": "Business Strategy",
    "dept": "MANGT",
    "num": "595",
    "desc": "Prerequisite: FINAN 450 and MANGT 420 and MKTG 400 and 75 credit hours and admitted in a College of Business Administration major (ACCTG, ENTRP, FINAN, GENBA, MANGT, MIS, MKTG, PSS).\nAnalysis of the strategic management process firms use to attain competitiveness in a global business environment.  Students develop the knowledge and skills required to diagnose strategic issues, make strategic decisions, and evaluate their consequences.  Capstone course that requires integration of knowledge gained in prior functional coursework along with application of strategic management concepts to formulate and implement value-creating solutions to business challenges.",
    "credits": "3"
  },
  {
    "course_name": "Business Ethics and Corporate Citizenship",
    "dept": "MANGT",
    "num": "596",
    "desc": "Prerequisite: FINAN 450 (may be taken concurrently), MANGT 420, MKTG 400, and senior level students admitted in a College of Business Administration degree track (major).\nDelivers a managerial perspective on how corporations can fulfill their economic, legal, ethical, and philanthropic responsibilities to a broad array of business stakeholders.",
    "credits": "3"
  },
  {
    "course_name": "Compensation and Performance Management",
    "dept": "MANGT",
    "num": "623",
    "desc": "Prerequisite or concurrent enrollment: MANGT 531.\nAn in-depth critique of compensation system design and performance management strategies needed to attract, retain, develop and motivate the human capital required for organizational effectiveness and strategic success.",
    "credits": "3"
  },
  {
    "course_name": "Sports Management",
    "dept": "MANGT",
    "num": "630",
    "desc": "Prerequisite: MANGT 420 or MKTG 400 or Junior standing.\nAn exploration into management issues associated with professional and amateur sports. Major topics include strategic planning, operational planning, human resource management, team management, leadership, communication, and diversity all in the context of sports.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Human Resource Management",
    "dept": "MANGT",
    "num": "633",
    "desc": "Prerequisite: MANGT 531.\nAn in-depth analysis of selected topics in human resource management including study of current research and literature.",
    "credits": "3"
  },
  {
    "course_name": "Staffing Organizations",
    "dept": "MANGT",
    "num": "643",
    "desc": "Prerequisite: May be taken concurrently with MANGT 531.\nFocuses on recruitment, selection, and retention issues, including an in-depth consideration of legal and practical issues involved in the acquisition and retention of human resources. Detailed coverage of job analysis, criterion development, recruitment strategies, and techniques and procedures for ensuring valid and effective selection of employees.",
    "credits": "3"
  },
  {
    "course_name": "Constraint Management and Continuous Improvement",
    "dept": "MANGT",
    "num": "652",
    "desc": "Prerequisite: MANGT 420, MANGT 421, MANGT 521.\nThe intent of this course is to provide an overview of the application of Theory of Constraints (TOC). TOC suggests that every process or system has at least one constraint that prevents the operation from being more efficient. TOC offers methodologies that are specifically developed to identify and manage constraints to enable the operation to achieve its goals. Students will be taught the skills required for the identification and management of constraints within an operation system.",
    "credits": "3"
  },
  {
    "course_name": "Supply Chain Planning and Control",
    "dept": "MANGT",
    "num": "660",
    "desc": "Prerequisite: MANGT 421.\nProvides a framework of how the demand side of the supply chain should interface with supply side in the context of global manufacturing and service. Topics include: layout/process design and control, capacity planning, master scheduling, materials requirement, coordination, and revenue management.",
    "credits": "3"
  },
  {
    "course_name": "Logistics and Warehouse Management",
    "dept": "MANGT",
    "num": "661",
    "desc": "Prerequisite: MANGT 421.\nExamines current issues and strategies in logistics and warehouse management. Topics include carrier management problems and opportunities, carrier selection, transportation costing, the economic characteristics of various transportation modes, location problems, and material handling.",
    "credits": "3"
  },
  {
    "course_name": "Procurement, Logistics and Supply Chain Design",
    "dept": "MANGT",
    "num": "662",
    "desc": "Prerequisite: MANGT 421, or with permission of instructor.\nAddresses the interrelationship between operations and other functions required to deliver value to the end customer of a supply chain. Topics include: strategic procurement and purchasing operations and process, sourcing decisions, location strategies, distribution network design, global supply chain network design, and supply chain risk management.",
    "credits": "3"
  },
  {
    "course_name": "Supply Chain Analytics",
    "dept": "MANGT",
    "num": "663",
    "desc": "Prerequisite: MANGT 421.\nThe objective of this course is to introduce models and tools to effectively manage a supply chain that purchase, produce, and distribute products. Topics include: forecasting, production and logistics, and inventory management. We illustrate the effectiveness of these models and tools using real-life cases and examples drawn from diverse industries.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Algebra",
    "dept": "MATH",
    "num": "010",
    "desc": "Prerequisite: Two units of mathematics in grades 9-12 and a Mathematics ACT score of 16 or higher; or a Mathematics Algebra Placement Exam score of 15 or higher.\nPreparatory course for MATH 100. Includes arithmetic (signed numbers, polynomials, algebraic fractions, exponents, and roots), solutions to equations (linear, quadratic, polynomial, root, and fractional), graphs (linear and quadratic), and geometry (area, perimeter, and the Pythagorean Theorem).",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Algebra Review",
    "dept": "MATH",
    "num": "011",
    "desc": "\nSupplemental algebra lab that is required to be taken in conjunction with MATH 010.",
    "credits": "2"
  },
  {
    "course_name": "College Algebra Review",
    "dept": "MATH",
    "num": "020",
    "desc": "\nSupplemental algebra lab to be taken in conjunction with MATH 100 for students who need additional instruction in algebra.",
    "credits": "2"
  },
  {
    "course_name": "College Algebra",
    "dept": "MATH",
    "num": "100",
    "desc": "Prerequisite: B or better in Math 010; or two years of high school algebra and a Mathematics ACT score of 23 or higher; or two years of high school algebra and a Mathematics Algebra Placement Exam score of 21 or higher.\nFundamental concepts of algebra; algebraic equations and inequalities; functions and graphs; zeros of polynomial functions; exponential and logarithmic functions; systems of equations and inequalities.",
    "credits": "3"
  },
  {
    "course_name": "Plane Trigonometry",
    "dept": "MATH",
    "num": "150",
    "desc": "Prerequisite: C or better in MATH 100; or two years of high school algebra and a Mathematics ACT score of 25 or higher; or two years of high school algebra and a Mathematics Algebra Placement Exam score of 40 or higher; or two years of high school algebra and a Mathematics Calculus Placement Exam score of 9 or higher.\nTrigonometric and inverse trigonometric functions; trigonometric identities and equations; applications involving right triangles and applications illustrating the laws of sines and cosines.",
    "credits": "3"
  },
  {
    "course_name": "Applied Plane Trigonometry",
    "dept": "MATH",
    "num": "151",
    "desc": "Prerequisite: Students are placed in this course on the basis of their score on the College of Technology and Aviation math placement exam or ACT score.\nTrigonometry and inverse trigonometric functions, trigonometric identities and equations; applications involving right triangles and applications illustrating the laws of sines and cosines. Emphasis is placed on applications to engineering technology, tool and machine design.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Contemporary Mathematics",
    "dept": "MATH",
    "num": "160",
    "desc": "\nMathematics as used in the contemporary world. Combinatorics and probability; descriptions of data; graph theory; and various additional topics selected by the individual instructors.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Mathematics Seminar",
    "dept": "MATH",
    "num": "199",
    "desc": "\nTopics of special interest to undergraduates in mathematics, including orientation to the mathematics curriculum, possible careers in mathematics, and cultural and professional aspects of mathematics.",
    "credits": "1-5"
  },
  {
    "course_name": "General Calculus and Linear Algebra",
    "dept": "MATH",
    "num": "205",
    "desc": "Prerequisite: C or better in MATH 100; or two years of high school algebra and a Mathematics ACT score of 26 or higher; or two years of high school algebra and a Mathematics Algebra Placement Exam score of 40 or higher.\nIntroduction to calculus and linear algebra concepts that are particularly useful to the study of economics and business administration with special emphasis on working problems.",
    "credits": "3"
  },
  {
    "course_name": "Technical Calculus I",
    "dept": "MATH",
    "num": "210",
    "desc": "Prerequisite: B or better in MATH 100 and C or better in MATH 150; or three years of college preparatory mathematics including trigonometry and a Mathematics ACT score of 27 or higher; or a Mathematics Calculus Placement Exam score of 21 or higher.\nA condensed course in analytic geometry and differential calculus with an emphasis on applications.",
    "credits": "3"
  },
  {
    "course_name": "Technical Calculus II",
    "dept": "MATH",
    "num": "211",
    "desc": "Prerequisite: C or better in MATH 210; or a Mathematics Calculus Placement Exam score of 40 or higher.\nA continuation of MATH 210 to include integral calculus with an emphasis on application.",
    "credits": "3"
  },
  {
    "course_name": "Calculus I",
    "dept": "MATH",
    "num": "215",
    "desc": "Prerequisite: MATH 100; and MATH 150 or MATH 151.\nCourse content includes a brief review of pre-calculus materials of algebra and trigonometry, functions, limits, differentiation, applications of differentiation, integration, and applications of the definite integral. Theory is presented in a style tailored for first-semester students of mathematics.",
    "credits": "5"
  },
  {
    "course_name": "Calculus II",
    "dept": "MATH",
    "num": "216",
    "desc": "Prerequisite: MATH 220 or MATH 215.\nAn extension of MATH 215, Calculus I, to include integration, differentiation, and applications of transcendent functions.",
    "credits": "5"
  },
  {
    "course_name": "Analytic Geometry and Calculus I",
    "dept": "MATH",
    "num": "220",
    "desc": "Prerequisite: B or better in MATH 100 and C or better in MATH 150; or three years of college preparatory mathematics including trigonometry and an Mathematics ACT score of 28 or higher; or a Mathematics Calculus Placement Exam score of 21 or higher.\nAnalytic geometry, differential and integral calculus of algebraic and trigonometric functions.",
    "credits": "4"
  },
  {
    "course_name": "Analytic Geometry and Calculus II",
    "dept": "MATH",
    "num": "221",
    "desc": "Prerequisite: C or better in MATH 220; or a Mathematics Calculus Placement Exam score of 40 or higher.\nContinuation of MATH 220 to include transcendental functions, techniques of integration, and infinite series.",
    "credits": "4"
  },
  {
    "course_name": "Analytic Geometry and Calculus III",
    "dept": "MATH",
    "num": "222",
    "desc": "Prerequisite: C or better in MATH 221.\nContinuation of MATH 221 to include functions of more than one variable.",
    "credits": "4"
  },
  {
    "course_name": "Finite Applications of Mathematics",
    "dept": "MATH",
    "num": "312",
    "desc": "Prerequisite: MATH 100.\nSystems of equations, vector operations, linear algebra, and linear programming. Practice in setting up, solving, and interpreting mathematical models which arise in social sciences and business.",
    "credits": "3"
  },
  {
    "course_name": "Computational Number Theory",
    "dept": "MATH",
    "num": "313",
    "desc": "Prerequisite: Sophomore standing, MATH 100.\nTopics in number theory selected from: divisibility, primes, modular arithmetic and special types of numbers. Emphasis is on computations. Primarily for prospective elementary school teachers of mathematics.",
    "credits": "3"
  },
  {
    "course_name": "Mathematics for Elementary School Teachers I",
    "dept": "MATH",
    "num": "320",
    "desc": "Prerequisite: MATH 100.\nMathematical problem solving and reasoning, development of whole number concepts and the whole number system, computation and estimation with whole numbers, number patterns and number theory, integers, fractions and rational numbers, decimals and real numbers, geometry and measurement.",
    "credits": "3"
  },
  {
    "course_name": "Intuitive Geometry",
    "dept": "MATH",
    "num": "330",
    "desc": "Prerequisite: MATH 320.\nGeometric figures and patterns, properties of geometric figures, transformation and coordinate geometry, measurement.",
    "credits": "3"
  },
  {
    "course_name": "Elementary Differential Equations",
    "dept": "MATH",
    "num": "340",
    "desc": "Prerequisite: C or better in MATH 221.\nElementary techniques for solving ordinary differential equations and applications to solutions of problems in science and engineering.",
    "credits": "4"
  },
  {
    "course_name": "Academic Excellence Workshop",
    "dept": "MATH",
    "num": "395",
    "desc": "Prerequisite: Concurrent enrollment in qualifying lower-division mathematics course and written permission of instructor.\nThis course provides enriched supplementary instruction to selected students enrolled in selected lower-division courses.",
    "credits": "1-2"
  },
  {
    "course_name": "Honors Seminar in Mathematics",
    "dept": "MATH",
    "num": "399",
    "desc": "Prerequisite: Membership in honors program.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "MATH",
    "num": "498",
    "desc": "\nOpen only to Arts and Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Topics in Mathematics",
    "dept": "MATH",
    "num": "499",
    "desc": "Prerequisite: Background of courses needed for topic undertaken and consent of instructor.\nReading courses in advanced undergraduate mathematics.",
    "credits": "1-18"
  },
  {
    "course_name": "Mathematical Theory of Interest",
    "dept": "MATH",
    "num": "500",
    "desc": "Prerequisite: MATH 221.\nExtensive introduction to the mathematical theory of interest with applications to the field of actuarial science. Prepares students to take the second professional examination administered by the Society of Actuaries and the Casualty Actuarial Society.",
    "credits": "3"
  },
  {
    "course_name": "Mathematical Foundations of Actuarial Science",
    "dept": "MATH",
    "num": "501",
    "desc": "Prerequisite: MATH 222 and STAT 510 or concurrent enrollment in STAT 510.\nIntroduction to calculus-based applications and models with an emphasis on applications to insurance. Prepares students to take the first professional examination administered by the Society of Actuaries and Casualty Actuarial Society.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Number Theory",
    "dept": "MATH",
    "num": "506",
    "desc": "Prerequisite: MATH 221.\nDivisibility properties of integers, prime numbers, congruences, multiplicative functions.",
    "credits": "3"
  },
  {
    "course_name": "Discrete Mathematics",
    "dept": "MATH",
    "num": "510",
    "desc": "Prerequisite: Sophomore standing and MATH 221.\nCombinatorics and graph theory. Topics selected from counting principles, permutations and combinations, the inclusion-exclusion principle, recurrence relations, trees, graph coloring, Eulerian and Hamiltonian circuits, block designs, and Ramsey Theory.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Algebraic Systems",
    "dept": "MATH",
    "num": "511",
    "desc": "Prerequisite: MATH 222.\nProperties of groups, rings, domains and fields. Examples selected from subsystems of the complex numbers, elementary number theory, and solving equations.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Modern Algebra",
    "dept": "MATH",
    "num": "512",
    "desc": "Prerequisite: MATH 222.\nIntroduction to the basic algebraic systems, viz., groups, rings, integral domains, and fields, often drawing from elementary number theory. Special emphasis will be given to methods of theorem proving.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Linear Algebra",
    "dept": "MATH",
    "num": "515",
    "desc": "Prerequisite: MATH 222.\nFinite-dimensional vector spaces, linear transformations and their matrix representations, dual spaces, invariant subspaces, Euclidean and unitary spaces, solution spaces for systems of linear equations.",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Analysis",
    "dept": "MATH",
    "num": "520",
    "desc": "Prerequisite: MATH 222.\nA study of sets and sequences, neighborhoods, limit points, convergence, open and closed sets in the real line and in the plane, the concept of a continuous function.",
    "credits": "3"
  },
  {
    "course_name": "The Real Number System",
    "dept": "MATH",
    "num": "521",
    "desc": "Prerequisite: MATH 221.\nAn extensive development of number systems, with emphasis upon structure. Includes systems of natural numbers, integers, rational numbers, and real numbers.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Ordinary Differential Equations",
    "dept": "MATH",
    "num": "540",
    "desc": "Prerequisite: MATH 340.\nFirst-order scalar equations: geometry of integral curves, symmetries and exactly soluble equations; existence, uniqueness and dependence on parameters with examples. Systems of first-order equations, Hamilton’s equations and classical mechanics, completely integrable systems. Higher-order equations. Initial value problems for second order linear equations, series solutions and special functions. Boundary value problems with applications. Introduction to perturbation theory and stability.",
    "credits": "3"
  },
  {
    "course_name": "Applied Matrix Theory",
    "dept": "MATH",
    "num": "551",
    "desc": "Prerequisite: MATH 205 or 220.\nMatrix algebra, solutions to systems of linear equations, determinants, vector spaces, linear transformations, eigenvalues, linear programming, approximation techniques.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Topology",
    "dept": "MATH",
    "num": "560",
    "desc": "Prerequisite: MATH 222.\nAn introduction to the basic topological concepts. Topological spaces, metric spaces, closure, interior, and frontier operators, subspaces, separation and countability properties, bases, sub bases, convergence, continuity, homeomorphisms, compactness, connectedness, quotients and products. The course will include a brief introduction to proof techniques and set theory. Other topics in topology also may be included.",
    "credits": "3"
  },
  {
    "course_name": "History of Mathematics",
    "dept": "MATH",
    "num": "570",
    "desc": "Prerequisite: MATH 220.\nA survey of the development of mathematics from ancient to modern times.",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Geometry",
    "dept": "MATH",
    "num": "572",
    "desc": "Prerequisite: MATH 221.\nEuclidean, non-Euclidean, and finite geometries; role of axioms; practice proving theorems in a formal system; synthetic, metric, and transformation approaches to Euclidean geometry.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Mathematics for Teachers",
    "dept": "MATH",
    "num": "591",
    "desc": "Prerequisite: Consent of instructor.\nTopics of importance for teachers of mathematics.",
    "credits": "1-3"
  },
  {
    "course_name": "Topics in Mathematics",
    "dept": "MATH",
    "num": "599",
    "desc": "\nCourses on special topics.",
    "credits": "1-3"
  },
  {
    "course_name": "Introduction to Digital Image Processing",
    "dept": "MATH",
    "num": "615",
    "desc": "Prerequisite: MATH 220.\nThe basic ideas and techniques in digital image processing stem from mathematics, engineering, and computer science. This course focuses on ideas and techniques such as spatial filtering, frequency filtering (Fast Fourier Transform), scale filtering (Fast Wavelet Transform), and their applications to image compression standards and image recognition. The course will place equal emphasis on the mathematical ideas and their applications.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Complex Analysis",
    "dept": "MATH",
    "num": "630",
    "desc": "Prerequisite: MATH 340.\nComplex analytic functions and power series, complex integrals. Taylor and Laurent expansions, residues, Laplace transformations, and the inversion integral.",
    "credits": "3"
  },
  {
    "course_name": "Elementary Partial Differential Equations",
    "dept": "MATH",
    "num": "632",
    "desc": "Prerequisite: MATH 340.\nOrthogonal functions, Fourier series, boundary value problems in partial differential equations.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Calculus I",
    "dept": "MATH",
    "num": "633",
    "desc": "Prerequisite: MATH 222.\nFunctions of one variable; limits, continuity, differentiability, Riemann-Stieltjes integral, sequences, series, power series, improper integrals.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Calculus II",
    "dept": "MATH",
    "num": "634",
    "desc": "Prerequisite: MATH 633.\nFunctions of several variables; partial differentiation and implicit function theorems, curvilinear coordinates, differential geometry of curves and surfaces, vectors and vector fields, line and surface integrals, double and triple integrals, Green’s Theorem, Stokes’ Theorem, and Divergence Theorem.",
    "credits": "3"
  },
  {
    "course_name": "Dynamics, Chaos, and Fractals",
    "dept": "MATH",
    "num": "635",
    "desc": "Prerequisite: MATH 221.\nAn introduction to one dimensional real and complex dynamics: attracting and repelling cycles, iterations of quadratic polynomials, bifurcation theory, chaos, Hausdorff measures and Hausdorff dimension, fractals, Julia and Fatou sets, and Mandelbrot sets.",
    "credits": "3"
  },
  {
    "course_name": "Elementary Numerical Analysis I",
    "dept": "MATH",
    "num": "655",
    "desc": "Prerequisite: MATH 221, a computer language, and either MATH 515 or 551.\nError analysis, root finding, interpolation, approximation of functions, numerical integration and differentiation, systems of linear equations.",
    "credits": "3"
  },
  {
    "course_name": "Elementary Numerical Analysis II",
    "dept": "MATH",
    "num": "656",
    "desc": "Prerequisite: MATH 340 and MATH 655.\nA continuation of MATH 655. Linear programming, numerical solutions of differential equations, and the use of standard packages for the solutions of applied problems.",
    "credits": "3"
  },
  {
    "course_name": "Mathematical Modeling",
    "dept": "MATH",
    "num": "670",
    "desc": "Prerequisite: Four mathematics courses numbered 500 or above.\nIntroduction of modeling procedures. Case studies in mathematical modeling projects from physical, biological, and social sciences.",
    "credits": "3"
  },
  {
    "course_name": "Set Theory and Logic",
    "dept": "MATH",
    "num": "700",
    "desc": "Prerequisite: MATH 511 or 512.\nAn introduction to logic, mathematical proof, and elementary set theory. Topics include elementary logic, relations, partitions, functions, cartesian products, disjoint unions, orders, construction of the natural numbers, ordinal and cardinal numbers, the Axiom of Choice, and transfinite induction. Special emphasis will be given to proving theorems.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the Theory of Groups",
    "dept": "MATH",
    "num": "704",
    "desc": "Prerequisite: MATH 512.\nIntroduction to abstract group theory, permutation groups, homomorphisms, direct products, Abelian groups. Jordan-Holder and Sylow theorems.",
    "credits": "3"
  },
  {
    "course_name": "Computational Math",
    "dept": "MATH",
    "num": "705",
    "desc": "Prerequisite: MATH 222.\nTopics from complex analysis, vector calculus, higher-dimensional calculus, ordinary differential equations, liner algebra, and geometry of curves.",
    "credits": "3"
  },
  {
    "course_name": "Theory of Numbers",
    "dept": "MATH",
    "num": "706",
    "desc": "Prerequisite: MATH 221 and either 511 or 512.\nDivisibility, congruences, multiplicative functions, number theory from an algebraic viewpoint, quadratic reciprocity, Diophantine equations, prime numbers.",
    "credits": "3"
  },
  {
    "course_name": "Theory of Numbers II",
    "dept": "MATH",
    "num": "707",
    "desc": "\nContinuation of MATH 706, including p-adic numbers, basic analytic number theory, geometry of numbers, and diophantine approximation.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Category Theory",
    "dept": "MATH",
    "num": "710",
    "desc": "Prerequisite: MATH 730 and MATH 770.\nCategories, duality, special morphisms, functors, natural transformations, limits and colimits, adjoint situations, and applications.",
    "credits": "3"
  },
  {
    "course_name": "Category Theory",
    "dept": "MATH",
    "num": "711",
    "desc": "Prerequisite: MATH 710.\nSet-valued functors and concrete categories, factorization structures, algebraic and topological functors, categorical completions, Abelian categories.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Applied Matrix Theory",
    "dept": "MATH",
    "num": "713",
    "desc": "Prerequisite: MATH 551 or 630.\nA development of the concepts of eigenvalues by considering applications in differential equations, quadratic forms and estimation problems. Supporting topics include the Jordan canonical form, functions of matrices, vector and matrix norms, convex sets, with selected topics from the theory and application of the simplex algorithm, Markov chains, Leslie population models, Leontieff input-output model.",
    "credits": "3"
  },
  {
    "course_name": "Applied Mathematics I",
    "dept": "MATH",
    "num": "715",
    "desc": "Prerequisite: MATH 515 or MATH 551 or equivalent.\nAnalysis of numerical methods for linear algebra.  Perturbation theory and error analysis, matrix factorizations, solutions to linear systems, least-squares, problems, techniques for special matrix structures, symmetric and nonsymmetric eigenvalue problems, iterative and direct methods.",
    "credits": "3"
  },
  {
    "course_name": "Applied Mathematics II",
    "dept": "MATH",
    "num": "716",
    "desc": "Prerequisite: MATH 340 and MATH 515 or MATH 551; or equivalent.\nLinear operator theory applied to matrix, integral and differential equations. Spectral theory, the Fredholm Alternative, least-squares and pseudo-inverses. Banach and Hilbert space techniques, Fourier series and wavelets, theory of distributions, Green’s functions.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Real Analysis",
    "dept": "MATH",
    "num": "721",
    "desc": "Prerequisite: MATH 634 or graduate standing.\nLimits, continuity, uniform convergence, completeness, differentiation, Riemann integration.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Functions of Several Variables",
    "dept": "MATH",
    "num": "722",
    "desc": "Prerequisite: MATH 634 or graduate standing.\nAnalysis of functions of several variables, including differentiability, partial differentiability, maxima and minima, inverse function theorem, implicit function theorem, integration, Fubini’s theorem.",
    "credits": "3"
  },
  {
    "course_name": "Complex Functions",
    "dept": "MATH",
    "num": "723",
    "desc": "Prerequisite: MATH 721 is recommended\nIntroduction to the theory of analytic functions, designed to prepare students for the qualifying exams. Holomorphic functions, contour integrals, residue theory, conformal mapping and other topics.",
    "credits": "3"
  },
  {
    "course_name": "The Mathematics of Data and Networks I",
    "dept": "MATH",
    "num": "725",
    "desc": "\nDevelops the mathematical tools necessary for studying and handling large data-sets and networks. Includes matrix, graph, and probability theory, dimensionality reduction, clustering, maximum likelihood, Bayesian networks, sparsification, modularity, information theory, hidden Markov chains, branching processes, electrical networks, internet mathematics, random walks, random graphs, random matrices, and search algorithms.",
    "credits": "3"
  },
  {
    "course_name": "The Mathematics of Data and Networks II",
    "dept": "MATH",
    "num": "726",
    "desc": "\nContinuation of MATH 725. Develops the mathematical tools necessary for studying and handling large data-sets and networks. Includes matrix, graph, and probability theory, dimensionality reduction, clustering, maximum likelihood, Bayesian networks, sparsification, modularity, information theory, hidden Markov chains, branching processes, electrical networks, internet mathematics, random walks, random graphs, random matrices, and search algorithms.",
    "credits": "3"
  },
  {
    "course_name": "Abstract Algebra I",
    "dept": "MATH",
    "num": "730",
    "desc": "Prerequisite: MATH 512 or consent of instructor.\nGroups, rings, fields, vector spaces and their homomorphisms. Elementary Galois theory and decomposition theorems for linear transformations on a finite dimensional vector space.",
    "credits": "3"
  },
  {
    "course_name": "Abstract Algebra II",
    "dept": "MATH",
    "num": "731",
    "desc": "Prerequisite: MATH 730 or consent of instructor.\nContinuation of MATH 730.",
    "credits": "3"
  },
  {
    "course_name": "Calculus of Variation",
    "dept": "MATH",
    "num": "740",
    "desc": "Prerequisite: MATH 722 or equivalent.\nNecessary conditions and the Euler-Lagrange equations. Hamilton-Jacobi theory, Noether’s theorems, direct methods, applications to geometry and physics.",
    "credits": "3"
  },
  {
    "course_name": "Ordinary Differential Equations",
    "dept": "MATH",
    "num": "745",
    "desc": "Prerequisite: MATH 340.\nFirst-order equations and applications, second-order equations and oscillation theorems, series solutions and special functions, Sturm Liouville problems, linear systems, autonomous systems and phase plane analysis, stability, Liapunov’s method, periodic solutions, perturbation and asymptotic methods, existence and uniqueness theorems.",
    "credits": "3"
  },
  {
    "course_name": "Dynamic Modeling Processes",
    "dept": "MATH",
    "num": "755",
    "desc": "Prerequisite: MATH 340 and MATH 551.\nTopics to include equilibrium and stability, limit circles, reaction-diffusion, and shock phenomena, Hopf bifurcation and cusp catastrophes, chaos and strange attractors, bang-bang principle. Applications from physical and biological sciences and engineering.",
    "credits": "3"
  },
  {
    "course_name": "Mathematical Control Theory",
    "dept": "MATH",
    "num": "757",
    "desc": "Prerequisite: MATH 560, 715.\nMathematical analysis of dynamical systems governed by differential equations and their optimal processes, feedback, and filtering. Topics include: dynamical systems with controls, axioms of control systems, input-output behaviors, stability and instability, reachability and controllability, dynamic feedback and stabilization, optimal control processes, piecewise constant control and bang-bang principle, Pontryagin maximum principle, tracking, filtering.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Probability Theory",
    "dept": "MATH",
    "num": "760",
    "desc": "Prerequisite: MATH 633 and STAT 510.\nAn introduction to the mathematical theory of probability. Material covered includes combinatorial probability, random variables, independence, expectations, limit theorems, Markov chains, random walks, and martingales.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Topology/Geometry I",
    "dept": "MATH",
    "num": "770",
    "desc": "Prerequisite: MATH 633.\nThis is the first course of a two course sequence including definitions and examples of topological spaces, simplicial complexes, topological and smooth manifolds, quotient spaces, CW complexes, projective spaces and knots. Topological properties including elementary separation, compactness, connectedness. Homotopy, the fundamental group, Covering spaces, Euler characteristics, classification of closed surfaces, differential forms, integration, Stokes’ theorem, de Rham cohomology.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Topology/Geometry II",
    "dept": "MATH",
    "num": "771",
    "desc": "Prerequisite: MATH 770.\nThe second course in a two class introduction to topology at a graduate level. Second term topics include: covering spaces, Euler characteristic, classification of closed surfaces, differential forms, integration, Stokes’ theorem, and de Rham cohomology.",
    "credits": "3"
  },
  {
    "course_name": "Elementary Differential Geometry",
    "dept": "MATH",
    "num": "772",
    "desc": "Prerequisite: MATH 340.\nCurves and surfaces in Euclidean spaces, differential forms and exterior differentiation, differential invariants and frame fields, uniqueness theorems for curves and surfaces, geodesics, introduction to Riemannian geometry, some global theorems, minimal surfaces.",
    "credits": "3"
  },
  {
    "course_name": "Combinatorial Analysis",
    "dept": "MATH",
    "num": "789",
    "desc": "Prerequisite: MATH 512.\nPermutations, combinations, inversion formulas, generating functions, partitions, finite geometries, difference sets, and other topics.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Mathematics for Secondary School Teachers",
    "dept": "MATH",
    "num": "791",
    "desc": "\nTopics of importance in the preparation of secondary school teachers to teach modern mathematics.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Mathematics",
    "dept": "MATH",
    "num": "799",
    "desc": "\nCourses on special topics to be taught on sufficient demand.",
    "credits": ".5-3"
  },
  {
    "course_name": "JMC Orientation",
    "dept": "MC",
    "num": "100",
    "desc": "\nAn overview of the curriculum electives, extracurricular activities in mass communications, the advising process, and career options.",
    "credits": "0"
  },
  {
    "course_name": "Mass Communication in Society",
    "dept": "MC",
    "num": "110",
    "desc": "\nA historical, social, legal, economic, and technological study of mass communication and its role and impact in society.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Advertising",
    "dept": "MC",
    "num": "120",
    "desc": "\nAn examination of the advertising field and its relationship to marketing and journalism.",
    "credits": "3"
  },
  {
    "course_name": "Writing Conventions and Mechanics",
    "dept": "MC",
    "num": "130",
    "desc": "\nReorientation to basic rules of grammar, spelling and punctuation, and assessment of student writing skills prior to admission to the A.Q. Miller School. Students must receive a “C” or better to advance in JMC curriculum.",
    "credits": "1"
  },
  {
    "course_name": "Elements of Media Writing",
    "dept": "MC",
    "num": "131",
    "desc": "Prerequisite: MC 130 with a grade of “C” or better.\nThe basics of Associated Press writing style and writing across media platforms. Students must receive a “C” or better to advance in JMC curriculum.",
    "credits": "1"
  },
  {
    "course_name": "Writing Styles and Audiences",
    "dept": "MC",
    "num": "132",
    "desc": "Prerequisite: MC 131 with a grade of “C” or better.\nBasic exposure to writing across platforms for target audiences in journalism and strategic communications. Students must receive a “C” or better to advance in JMC curriculum.",
    "credits": "1"
  },
  {
    "course_name": "Principles of Journalism",
    "dept": "MC",
    "num": "160",
    "desc": "\nAn overview of the current news industry, including legacy media and newer platforms. Introduction to news gathering and reporting, including hands-on work on the multi-platform JMC NewsDesk.",
    "credits": "3"
  },
  {
    "course_name": "KSDB-FM Participation",
    "dept": "MC",
    "num": "165",
    "desc": "\nStudents participate in various music, news, sports, program production and other operational roles on student radio station KSDB-FM.",
    "credits": "0"
  },
  {
    "course_name": "KKSU-TV Participation",
    "dept": "MC",
    "num": "166",
    "desc": "\nExposure to basic video production roles and participation in producing a television program for KKSU-TV.",
    "credits": "0"
  },
  {
    "course_name": "Principles of Public Relations",
    "dept": "MC",
    "num": "180",
    "desc": "\nContemporary persuasive social science principles, processes, and issues involved in the management of communications between an organization and its publics.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Journalism and Mass Communications",
    "dept": "MC",
    "num": "190",
    "desc": "\nSelected topics in the study of mass communication practices and principles.",
    "credits": "1-3"
  },
  {
    "course_name": "Audio Production Foundations",
    "dept": "MC",
    "num": "191",
    "desc": "\nBasic audio production concepts and techniques.",
    "credits": "1"
  },
  {
    "course_name": "Pixel Foundations",
    "dept": "MC",
    "num": "192",
    "desc": "\nTheory and practical application of two dimensional computer photo editing and production using professional editing software.",
    "credits": "1"
  },
  {
    "course_name": "Video Production Foundations",
    "dept": "MC",
    "num": "193",
    "desc": "\nBasic video production practices with a focus on editing concepts.",
    "credits": "1"
  },
  {
    "course_name": "Social Media Foundations",
    "dept": "MC",
    "num": "194",
    "desc": "\nAn introduction to basic concepts and uses of social media.",
    "credits": "1"
  },
  {
    "course_name": "Vector Foundations",
    "dept": "MC",
    "num": "195",
    "desc": "\nCreating vector graphics and documents using professional standard design software for journalism and strategic communication products.",
    "credits": "1"
  },
  {
    "course_name": "Web-CMS Foundations",
    "dept": "MC",
    "num": "196",
    "desc": "\nProducing and publishing content across web formats and content management systems.",
    "credits": "1"
  },
  {
    "course_name": "News Reporting and Writing Across Platforms",
    "dept": "MC",
    "num": "200",
    "desc": "Prerequisite: MC 110, MC 130, MC 131, and MC 132, and MC 160  with a grade of C or better; OR MC 130, AGCOM 110 and MC 160  with a grade of C or better.\nInstruction in news reporting and writing for publication across various media platforms.",
    "credits": "3"
  },
  {
    "course_name": "Visual Communication in Mass Media",
    "dept": "MC",
    "num": "210",
    "desc": "Prerequisite: MC 110.\nAn overview of concepts and theories of communicating through visual means, including the physiology and psychology of seeing and perceiving; the basics of design and aesthetic principles; and examination of the uses of these concepts and principles within the mass media.",
    "credits": "3"
  },
  {
    "course_name": "Writing for the Electronic Media",
    "dept": "MC",
    "num": "211",
    "desc": "Prerequisite: MC 110 with minimum grade of C or better, passing score on JMC composition skills test and 2.5 GPA upon completion of 12 or more credit hours, majors only.\nStudy of writing formats and the preparation of written material for news, commercial and promotional announcements, and entertainment programs for the electronic media.",
    "credits": "3"
  },
  {
    "course_name": "Advertising Strategy & Writing",
    "dept": "MC",
    "num": "221",
    "desc": "Prerequisite: Completion of MC 110; MC 130, MC 131, and MC 132; and MC 120 with grade of “C” or better, OR completion of MC 110, MC 130, AGCOM 110 and MC 120 with C or better.\nWriting for the various media to reach or achieve advertising objectives. Setting communication goals within the context of writing to persuade and inform mass audiences.",
    "credits": "3"
  },
  {
    "course_name": "Digital News",
    "dept": "MC",
    "num": "251",
    "desc": "Prerequisite: MC 200 with grade of C or better; majors have priority, others by department consent.\nBasic audio, video, and web reporting, writing, and production.",
    "credits": "3"
  },
  {
    "course_name": "Public Relations Writing",
    "dept": "MC",
    "num": "280",
    "desc": "Prerequisite: Completion of MC 110; MC 130, MC 131, and MC 132; and MC 180 with grade of C or better; OR completion of MC 110, MC 130, AGCOM 110 and MC 180 with a C or better.\nExamines various forms of contemporary public relations writing, with special emphasis on preparation of messages for different media and audiences.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Mass Communications",
    "dept": "MC",
    "num": "290",
    "desc": "\nSelected topics in the study of mass communication principles and practices.",
    "credits": "1-3"
  },
  {
    "course_name": "Introduction to Media Production",
    "dept": "MC",
    "num": "301",
    "desc": "Prerequisites: MC 200, MC 221, MC 280.\nBasic concepts and principles of audio, video, and Web-CMS production.",
    "credits": "3"
  },
  {
    "course_name": "Data Journalism",
    "dept": "MC",
    "num": "316",
    "desc": "Prerequisite: MC 200 with a grade of C or better.\nIssues and practices associated with using relational data bases and other online services as tools of news gathering and data analysis, as well as other advanced reporting applications.",
    "credits": "3"
  },
  {
    "course_name": "Digital Photography for Mass Media",
    "dept": "MC",
    "num": "331",
    "desc": "Prerequisite: MC 110 with a grade of C or better, or permission of the instructor.\nBasics of composition, exposure, cropping and editorial judgment using converted analog and digital images and image-building software. Introduction to uses of digital photography in mass media such as newspapers, magazines, brochures and web sites.",
    "credits": "3"
  },
  {
    "course_name": "Editing for Print and Online Media",
    "dept": "MC",
    "num": "340",
    "desc": "Prerequisite: MC 200, or MC 221, or MC 280 with a grade of C or better.\nFundamentals of micro and macro journalistic editing for print and digital media including industry standards, practices, and ethics.",
    "credits": "3"
  },
  {
    "course_name": "Media Design and Data Visualization",
    "dept": "MC",
    "num": "341",
    "desc": "Prerequisite: MC 200, MC 221 or MC 280 with grade of C or better.\nTheories and concepts of visual communication and the craft of conveying data in graphic form.",
    "credits": "3"
  },
  {
    "course_name": "Application of Layout and Printing techniques in Agriculture and Natural Resources",
    "dept": "MC",
    "num": "345",
    "desc": "Prerequisite: AGCOM 201 or MC 341\nAdvances students’ understanding of how industry-adopted software and hardware are used to develop print media, from individual use to integrating a variety of software and hardware in production.",
    "credits": "3"
  },
  {
    "course_name": "Theories in Strategic Communication",
    "dept": "MC",
    "num": "360",
    "desc": "Prerequisites:  MC 120 or MC 180 with a C or better, or instructor permission.\nAn examination of persuasion and behavior change theories as applied to advertising and public relations messages.",
    "credits": "3"
  },
  {
    "course_name": "Social Media in Strategic Communications",
    "dept": "MC",
    "num": "370",
    "desc": "Recommended Prerequisites:  MC 120 or MC 180 with a C or better or instructor permission.\nStrategic methods and approaches for messaging via social media platforms.",
    "credits": "3"
  },
  {
    "course_name": "Strategic Communication Strategy and Planning",
    "dept": "MC",
    "num": "380",
    "desc": "Prerequisite: MC 221 or MC 280 with a grade of C or better.\nBasic principles and processes of developing and implementing communication strategy and planning.",
    "credits": "3"
  },
  {
    "course_name": "Media Practicum",
    "dept": "MC",
    "num": "385",
    "desc": "Prerequisite: Instructor permission.\nPractical work in student media operations of the school under supervision of an instructor, preparing students for work in the various media industries. Topics include newspaper, radio, yearbook, and video.",
    "credits": "1"
  },
  {
    "course_name": "Topics in Journalism and Mass Communications",
    "dept": "MC",
    "num": "390",
    "desc": "\nSelected topics in the study of mass communications practices and principles.",
    "credits": "1-3"
  },
  {
    "course_name": "Strategic Communication Research",
    "dept": "MC",
    "num": "396",
    "desc": "Prerequisite: MC 221 or MC 280.\nMethods and procedures involved in the formulation of a research problems particular to strategic communication.  Examines the process of inquiry, elements of the scientific method, the design of research in quantitative and qualitative studies, as well as ethics of conducting research.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Mass Communications",
    "dept": "MC",
    "num": "399",
    "desc": "Prerequisite: Honors students only.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Reporting and Writing Across Platforms",
    "dept": "MC",
    "num": "403",
    "desc": "Prerequisite: MC 200 with grade of C or better; majors have priority, others by department consent.\nIntensive course emphasizing advanced reportorial principles and practices for multiple media platforms.",
    "credits": "3"
  },
  {
    "course_name": "Public Affairs Reporting",
    "dept": "MC",
    "num": "404",
    "desc": "Prerequisite: MC 403 with grade of C or better.\nInvestigative reporting of local, state and national affairs.",
    "credits": "3"
  },
  {
    "course_name": "KKSU-TV News Reporting",
    "dept": "MC",
    "num": "406",
    "desc": "Prerequisite: MC 301 with grade of C or better; majors have priority, others by department consent.\nAdvanced techniques of reporting, writing, and producing news for audio, video, and Web-related media.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Strategic Communications Writing",
    "dept": "MC",
    "num": "409",
    "desc": "Recommended Prerequisite: MC 280 with a C or better.\nStrategic aspects of public relations writing and messaging through advanced types of client communications projects.",
    "credits": "3"
  },
  {
    "course_name": "Sports Reporting",
    "dept": "MC",
    "num": "410",
    "desc": "Prerequisite: MC 301 with a grade of C or better.\nThe study of today’s sports media environment with an emphasis on reporting, writing, and producing sports stories for audio, video, print, Internet, and other platforms.",
    "credits": "3"
  },
  {
    "course_name": "Photojournalism",
    "dept": "MC",
    "num": "416",
    "desc": "Prerequisite: MC 331 with grades of C or better; majors have priority, others by department consent.\nThe materials, principles, and processes of photography directed toward visual reporting in newspapers, magazines and other media.",
    "credits": "3"
  },
  {
    "course_name": "Magazine Writing, Editing and Design",
    "dept": "MC",
    "num": "426",
    "desc": "Prerequisite: MC 341 with a grade of C or better; majors have priority, others by department consent.",
    "credits": "3"
  },
  {
    "course_name": "Magazine Production",
    "dept": "MC",
    "num": "436",
    "desc": "Prerequisite: MC 403.\nThe practical application of theory to writing, editing, graphic reproduction, layout and management of magazines.",
    "credits": "3"
  },
  {
    "course_name": "Advertising Media Planning",
    "dept": "MC",
    "num": "446",
    "desc": "Prerequisite: MC 221 with grade of C or better.\nThe selecting, scheduling, selling and buying of the various advertising media.",
    "credits": "3"
  },
  {
    "course_name": "Health Communication",
    "dept": "MC",
    "num": "451",
    "desc": "Recommended Prerequisite:  Sophomore standing or consent of instructor.\nDeveloping strategy and messages in health communication campaigns.",
    "credits": "3"
  },
  {
    "course_name": "Web Techniques",
    "dept": "MC",
    "num": "461",
    "desc": "Prerequisite: MC 200, MC 211 or MC 221 with grade of C or better.\nDevelop expertise in the construction of web sites with a solid emphasis on the appropriateness, integrity and quality of the content provided.",
    "credits": "3"
  },
  {
    "course_name": "Law of Mass Communications",
    "dept": "MC",
    "num": "466",
    "desc": "Prerequisite: MC 110 with a grade of C or better.\nA study of the legal issues relating to media and strategic communications. Emphasis on defamation, privacy, copyright, administrative controls and other legal areas.",
    "credits": "3"
  },
  {
    "course_name": "Drone Photography and Video",
    "dept": "MC",
    "num": "469",
    "desc": "Prerequisite or Corequisite: UAS 115, Junior standing.\nTechniques and procedures to use a Small Unmanned Ariel System (Drone) to acquire and produce video and photographic data that can be used for storytelling, advertising, short film, public relation and other media related analyses.",
    "credits": "3"
  },
  {
    "course_name": "Advertising Account Management",
    "dept": "MC",
    "num": "470",
    "desc": "Prerequisite: MC 221 or MC 280 with a C or better is recommended.\nExamines the roll of account managers in modern advertising agencies.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Production",
    "dept": "MC",
    "num": "471",
    "desc": "Prerequisite: MC 331 or MC 406 with grade of C or better; majors have priority, others by department consent.\nEmphasis on aesthetics of audio and video writing, producing, directing, sound recording, lighting, camera work, editing, mixing, and distribution.",
    "credits": "3"
  },
  {
    "course_name": "KKSU-TV News Production",
    "dept": "MC",
    "num": "472",
    "desc": "Prerequisite: MC 301 with grade of C or better; majors have priority, others by department consent.\nAn advanced production course that emphasizes producing and directing techniques for news and other information-oriented programming.",
    "credits": "3"
  },
  {
    "course_name": "Military Strategic Communications",
    "dept": "MC",
    "num": "475",
    "desc": "Prerequisite: MC 380 with a C or better or instructor consent.\nAn examination of the U.S. military in terms of operational and communication issues and its overall relationship with the media.",
    "credits": "3"
  },
  {
    "course_name": "Travel and Tourism Strategic Communications",
    "dept": "MC",
    "num": "477",
    "desc": "Prerequisites: MC 120 or MC 180, or instructor consent.\nThe role and function of advertising and public relations in travel and tourism, focusing on the development of communication strategies and tactics.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Journalism and Mass Communications",
    "dept": "MC",
    "num": "490",
    "desc": "\nSelected topics in the study of mass communications practices and principles.",
    "credits": "1-3"
  },
  {
    "course_name": "Mass Communication Internship",
    "dept": "MC",
    "num": "491",
    "desc": "Prerequisite: Consent of instructor and specified MC courses. Journalism: MC 301; Strategic Communications: MC 221 or MC 280; majors have priority, others by department consent.\nSupervised professional experience; reports from student and supervisor required.",
    "credits": "1-3"
  },
  {
    "course_name": "Media Portfolio",
    "dept": "MC",
    "num": "498",
    "desc": "Prerequisite: MC 341 or instructor consent.\nEmphasis on enhancement of creative concepts, personal branding and portfolio development.",
    "credits": "3"
  },
  {
    "course_name": "Honors Project",
    "dept": "MC",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members on the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Strategic Communications Case Studies",
    "dept": "MC",
    "num": "502",
    "desc": "Prerequisite: MC 180 with grade of C or better or instructor consent.\nStudy of historic and contemporary strategic communications strategies and tactics using a case-method approach.",
    "credits": "3"
  },
  {
    "course_name": "History of Mass Communication",
    "dept": "MC",
    "num": "564",
    "desc": "Prerequisite: Junior standing.\nGrowth and development of media and media technology in the United States and their economic, political and social significance.",
    "credits": "3"
  },
  {
    "course_name": "Global Mass Communication",
    "dept": "MC",
    "num": "572",
    "desc": "Prerequisite: Junior standing.\nComparative study of world media systems and the role of mass communication in national development.",
    "credits": "3"
  },
  {
    "course_name": "Ethics in Mass Communication",
    "dept": "MC",
    "num": "573",
    "desc": "Prerequisite: Junior standing.\nMaking ethical decisions in mass media fields and the principles on which those decisions are based.",
    "credits": "3"
  },
  {
    "course_name": "Mass Communications and Political Campaigns",
    "dept": "MC",
    "num": "576",
    "desc": "Prerequisite: MC 110 and either MC 200, MC 211, MC 221, or MC 280.\nThe roles of journalism, advertising and public relations in political campaigns.  Examines campaign communication strategies, staffing, and the role of political consultants.  Analyzes how voter decision making is affected by mass communications and how voters develop attitudes about candidates and issues.",
    "credits": "3"
  },
  {
    "course_name": "Storytelling Across Platforms",
    "dept": "MC",
    "num": "580",
    "desc": "Prerequisite: MC 301 and senior standing.\nReporting, writing, and production across multiple platforms. Critical analysis of media and engagement strategies for reporting in a digital world.",
    "credits": "3"
  },
  {
    "course_name": "Strategic Communication Campaigns",
    "dept": "MC",
    "num": "581",
    "desc": "Prerequisite: MC 380 and MC 396 with a grade of C or better, senior standing.\nThis capstone course focuses on students demonstrating all of the knowledge and skills learned in developing a client campaign.",
    "credits": "3"
  },
  {
    "course_name": "Media Management",
    "dept": "MC",
    "num": "585",
    "desc": "Prerequisite: Junior standing.\nIssues, ethics and practices in managing media companies, with special emphasis on problems and practices, in converged media operations.",
    "credits": "3"
  },
  {
    "course_name": "Issues in Mass Communication",
    "dept": "MC",
    "num": "589",
    "desc": "\nAdvanced topics in mass communication practices and principles.",
    "credits": "1-3"
  },
  {
    "course_name": "Economics of Mass Communication",
    "dept": "MC",
    "num": "600",
    "desc": "Prerequisite: Junior standing.\nStudy of the various economic models applicable to the media industries and application of basic economic concepts and analytical tools to explain media industry behaviors, evaluate business strategies of media firms and assess the merits of public policies toward the media industries.",
    "credits": "3"
  },
  {
    "course_name": "Supervision of School Publications",
    "dept": "MC",
    "num": "605",
    "desc": "\nA methods course for those planning to teach secondary or community college journalism courses and advise high school or community college publications.",
    "credits": "3"
  },
  {
    "course_name": "Gender, Class, Race, and the Media",
    "dept": "MC",
    "num": "612",
    "desc": "Prerequisite: Junior standing and one course in MC or Women’s Studies.\nHistoric and current roles media play in creating awareness of gender, racial, and class issues in society, including bias and stereotyping.",
    "credits": "3"
  },
  {
    "course_name": "Global Advertising",
    "dept": "MC",
    "num": "623",
    "desc": "Prerequisite: MC 120 with a grade of C or better.\nIssues associated with advertising in a global environment, including cultural impact, international media, regulation, ethics and digital media technologies.",
    "credits": "3"
  },
  {
    "course_name": "Media Relations",
    "dept": "MC",
    "num": "625",
    "desc": "Prerequisite: MC 280 with a grade of C or better.\nExamines management skills necessary for establishing, maintaining and evaluating a media relations program. Discussion includes working with journalists, conducting media events, preparing spokespersons and developing crisis communications.",
    "credits": "3"
  },
  {
    "course_name": "International and Intercultural Public Relations",
    "dept": "MC",
    "num": "662",
    "desc": "Prerequisite: MC 280 with grade of C or better.\nGlobal diversity in business, governmental, and charitable organizations and the demographic changes within countries and across communities that affect the role and practice of public relations worldwide.",
    "credits": "3"
  },
  {
    "course_name": "Managing Integrated Strategic Communications",
    "dept": "MC",
    "num": "665",
    "desc": "Prerequisite: MC 120 or MC 180 with grade of C or better.\nInvestigation of managerial decision making in advertising and public relation programs. Emphasizes strategic and logical thinking in the decision-making process. Theories and practices from media management, social/cognitive psychology and integrated communication.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Mass Communications",
    "dept": "MC",
    "num": "680",
    "desc": "Prerequisite: Senior or graduate standing and consent of supervisory instructor.\nInvestigation of the literature of mass communications.  Three significant books per credit hour with written analysis and oral presentation.",
    "credits": "1-3"
  },
  {
    "course_name": "Seminar in Public Relations",
    "dept": "MC",
    "num": "682",
    "desc": "Prerequisite: MC 280, MC 380, MC 502 with grades of C or better.\nContemporary topics in public relations practice, theory, and research.",
    "credits": "3"
  },
  {
    "course_name": "Reputation Management",
    "dept": "MC",
    "num": "683",
    "desc": "Recommended Prerequisites: MC 380.\nManaging the public perception of organizations from the standpoint of preparing for issues and unforeseen emergencies that can potentially disrupt the relationship between organizations and the publics they serve.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Mass Communications",
    "dept": "MC",
    "num": "690",
    "desc": "Prerequisite: Background of courses needed for problem undertaken.",
    "credits": "1-4"
  },
  {
    "course_name": "Proseminar in Mass Communication",
    "dept": "MC",
    "num": "701",
    "desc": "\nIntroduction to advanced study in mass communication with special emphasis on requirements for obtaining the master of science degree.",
    "credits": "1"
  },
  {
    "course_name": "History of Mass Communications",
    "dept": "MC",
    "num": "710",
    "desc": "Prerequisite: Graduate standing, or instructor permission with a 2.5 GPA and completion of a United States history course.\nGrowth and development of the news media and mass communication media and systems in the United States and their economic, political, and social significance.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Communications",
    "dept": "MC",
    "num": "712",
    "desc": "Prerequisite: Senior standing.\nCombines theoretical discussions with practical experience regarding communications about environmental issues and provides introduction to natural and applied science topics related to the communications plan.",
    "credits": "3"
  },
  {
    "course_name": "Ethics in Mass Communications",
    "dept": "MC",
    "num": "720",
    "desc": "Prerequisite: Graduate standing, or instructor permission with a 2.5 GPA and completion of a philosophy course.\nMoral analysis, argument, and decision-making by the mass communicator.",
    "credits": "3"
  },
  {
    "course_name": "International Communications",
    "dept": "MC",
    "num": "725",
    "desc": "Prerequisite: Graduate standing, or instructor permission with a 2.5 GPA.\nComparative study of world media systems and the role of mass communications in national development.",
    "credits": "3"
  },
  {
    "course_name": "Seminar on Issues of the Media",
    "dept": "MC",
    "num": "730",
    "desc": "Prerequisite: Graduate standing or instructor permission with a 2.5 GPA.\nA study of philosophical and technological advances in mass communications with emphasis on projected patterns of future growth and development.",
    "credits": "3"
  },
  {
    "course_name": "Colloquium in Mass Communications",
    "dept": "MC",
    "num": "740",
    "desc": "Prerequisite: Graduate standing or instructor permission.\nDiscussion of selected topics in mass communications research and practice.",
    "credits": "1-3"
  },
  {
    "course_name": "Seminar in Mass Communication Law",
    "dept": "MC",
    "num": "745",
    "desc": "Prerequisite: Graduate standing.\nAnalysis of mass communication freedoms and limitations in such areas as defamation, privacy, copyright, censorship, obscenity, and advertising and electronic media regulation.",
    "credits": "3"
  },
  {
    "course_name": "Strategic Health Communication",
    "dept": "MC",
    "num": "750",
    "desc": "Prerequisite: Graduate standing, or instructor permission with a 2.5 GPA.\nThe role of effective communication through mass media and other communication strategies in health promotion and behavior change.  Includes the theories and strategies used to promote public health messages, services, or products for multicultural audiences, with a focus on human, environment and animal health.  Legal, ethical issues and gender issues in health communication will be given special attention.",
    "credits": "3"
  },
  {
    "course_name": "Issues, Risk, and Reputation",
    "dept": "MC",
    "num": "760",
    "desc": "Prerequisite: Graduate standing, or instructor permission.\nPromotes understanding of strategic communication and media as tools to prepare for, respond to, and recover from threats to organizational and brand reputation.",
    "credits": "3"
  },
  {
    "course_name": "Communication Theory",
    "dept": "MC",
    "num": "765",
    "desc": "Prerequisite: Graduate standing, or instructor permission with 2.5 GPA.\nAn examination of major communication theories as they relate to mass communications.",
    "credits": "3"
  },
  {
    "course_name": "Mass Communication Practicum",
    "dept": "MC",
    "num": "770",
    "desc": "Prerequisite: Instructor consent required.\nSupervised practical work in professional  mass communications settings, including laboratory investigation, field work, internships, and applied workplace research.",
    "credits": "1-4"
  },
  {
    "course_name": "Research Methods in Mass Communications",
    "dept": "MC",
    "num": "780",
    "desc": "Prerequisite: For graduate students.\nSurvey of research methods used in the study of the mass media.",
    "credits": "3"
  },
  {
    "course_name": "Issues in Media Management",
    "dept": "MC",
    "num": "785",
    "desc": "Prerequisite: Graduate standing or instructor permission.\nSeminar in the analysis of issues in media management and media economics research and practices.  Issues include leadership in converged media organizations, market research in media organizations, motivational behaviors in media organizations and developments in new technology as they relate to managing media organizations.",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Mass Communication",
    "dept": "MC",
    "num": "799",
    "desc": "Prerequisite: Graduate standing, instructor consent.\nSupervised independent study in mass communication. Requires contractual agreement between student and professor, specifying content, meeting times, and credits to be awarded.",
    "credits": "1-3"
  },
  {
    "course_name": "Introduction to Mechanical Engineering",
    "dept": "ME",
    "num": "101",
    "desc": "Prerequisite or concurrent enrollment: MATH 220.\nIntroduction to the mechanical engineering curriculum and profession. Orientation for successful transition of new students to college life. Engineering approach to problem solving and computer use in all areas of mechanical engineering. Exchange of information regarding academic, technical, social, ethical, and professional matters between students, faculty, and practicing professionals.",
    "credits": "2"
  },
  {
    "course_name": "Engineering Graphics",
    "dept": "ME",
    "num": "212",
    "desc": "Prerequisite: Plane geometry.\nTechnical sketching, study of basic principles of projective geometry, multiview drawings, pictorials, reading and interpreting drawings, CAD, sectioning, dimensioning.",
    "credits": "2"
  },
  {
    "course_name": "Topics in Mechanical Engineering",
    "dept": "ME",
    "num": "390",
    "desc": "Prerequisite: Consent of instructor.\nTopics selected in consultation with instructor. Intended for interdisciplinary studies or innovative studies in mechanical engineering.",
    "credits": "1-18"
  },
  {
    "course_name": "Computer Applications in Mechanical Engineering",
    "dept": "ME",
    "num": "400",
    "desc": "Prerequisite or concurrent: MATH 340.\nThe development and application of computer techniques to the problems of design and analysis in mechanical engineering, including computer programming (abstraction and problem solving; algorithms; control structures; input/output; functions; arrays and array processing).",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "ME",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Honors Research in Mechanical Engineering",
    "dept": "ME",
    "num": "499",
    "desc": "\nIndividual research problem selected with approval of faculty advisor. Open to students in the College of Engineering honors program.  A report is presented orally and in writing during the last semester.",
    "credits": "1-18"
  },
  {
    "course_name": "Dynamics",
    "dept": "ME",
    "num": "512",
    "desc": "Prerequisite: CE 333.  Prerequisite or concurrent: MATH 340.\nVector treatment of kinematics, Newton’s Laws, work and energy, impulse and momentum, with applications to problems of particle and rigid body motion.",
    "credits": "3"
  },
  {
    "course_name": "Thermodynamics I",
    "dept": "ME",
    "num": "513",
    "desc": "Prerequisite: PHYS 213; MATH 222.\nProperties of the pure substance. The first and second laws of thermodynamics. Gas mixtures and psychrometry.",
    "credits": "3"
  },
  {
    "course_name": "Thermodynamics II",
    "dept": "ME",
    "num": "523",
    "desc": "Prerequisite: ME 513.\nContinuation of Thermodynamics I. Energy analysis, thermodynamic cycles, generalized thermodynamic relations, and reactive systems.",
    "credits": "3"
  },
  {
    "course_name": "Machine Design I",
    "dept": "ME",
    "num": "533",
    "desc": "Prerequisite: CE 533, ME 212 and ME 512.\nIntroduction to the design and analysis of machine elements. Emphasis on materials, loads, stress, strain, deflection, failure theories, and finite element analysis. Applications include design and analysis of shafts, gears, and fasteners, weldments, springs, bearings.",
    "credits": "3"
  },
  {
    "course_name": "Measurement and Instrumentation Laboratory",
    "dept": "ME",
    "num": "535",
    "desc": "Prerequisite: ME 513 and ECE 519.\nTheory and application of mechanical engineering measurements, instrumentation, and computer-based data acquisition.",
    "credits": "3"
  },
  {
    "course_name": "Machine Design II",
    "dept": "ME",
    "num": "563",
    "desc": "Prerequisite: ME 533.\nDesign and analysis of machine elements. Applications include design and analysis of bearings, gears, shafts, clutches, brakes, belt and chain drives, and hydraulic fluid power.",
    "credits": "3"
  },
  {
    "course_name": "Control of Mechanical Systems I",
    "dept": "ME",
    "num": "570",
    "desc": "Prerequisite: MATH 340, ME 400, and ME 512.  Prerequisite or concurrent: ME 535 or NE 612.\nIntroduction to modeling and control of dynamic systems encountered by mechanical engineers. Topics include basic linear systems modeling and analysis; feedback control; time response and stability of dynamic systems; introduction to root locus and frequency response design.",
    "credits": "4"
  },
  {
    "course_name": "Fluid Mechanics",
    "dept": "ME",
    "num": "571",
    "desc": "Prerequisite: ME 512 or CE 530.  Prerequisite or concurrent: ME 513.\nPhysical properties; fluid statics; dynamics of ideal and real fluids (for incompressible and compressible flow); impulse and momentum; laws of similitude; dimensional analysis; flow in pipes; flow in open channels; flow about immersed objects.",
    "credits": "3"
  },
  {
    "course_name": "Heat Transfer",
    "dept": "ME",
    "num": "573",
    "desc": "Prerequisite: ME 400, ME 571, MATH 340.\nFundamentals of conduction, convection, and radiation; principles of heat exchanger design and dimensional analysis.",
    "credits": "3"
  },
  {
    "course_name": "Interdisciplinary Industrial Design Projects I",
    "dept": "ME",
    "num": "574",
    "desc": "Prerequisite: ME 535 or NE 612, ME 533, ME 571.\nIntroduction to design theory, project management, team dynamics and socio-economic context of design, etc.; application of design principles, engineering analysis and experimental methods to an industrial interdisciplinary design project involving design, analysis, fabrication and testing. Discussion of career planning, graduate school, ethics, technical/professional societies, and engineering licensing.",
    "credits": "3"
  },
  {
    "course_name": "Interdisciplinary Industrial Design Projects II",
    "dept": "ME",
    "num": "575",
    "desc": "Prerequisite/Corequisite: ME 574 or instructor permission.",
    "credits": "3"
  },
  {
    "course_name": "Finite Element Applications in Mechanical Engineering",
    "dept": "ME",
    "num": "610",
    "desc": "Prerequisite: CE 533.\nThe application of the finite element method to the solution of engineering problems. Topics include introductions to the methods, linear elastic stress analysis, thermal analysis, and modeling limitations and errors. Commercial computer codes are used in the applications.",
    "credits": "3"
  },
  {
    "course_name": "Applications in Mechatronics",
    "dept": "ME",
    "num": "615",
    "desc": "Prerequisite: ME 400 or ECE 431. Corequisite: ME 535 (not required if ECE 431 is taken).\nApplication of Mechanical and Electronic engineering to design. Microcontrollers; sensors; analog-to-digital signal conversion; DC motor operation and pulse with modulation; drive train configuration; embedded C programming; competition at Engineering Open House.",
    "credits": "3"
  },
  {
    "course_name": "Internal Combustion Engines",
    "dept": "ME",
    "num": "620",
    "desc": "Prerequisite: ME 523.\nApplication of principles of thermodynamics, fluid mechanics, and chemistry, kinematics, and heat transfer to internal combustion engine processes. Performance and design characteristics of internal combustion engines.",
    "credits": "3"
  },
  {
    "course_name": "Indoor Environmental Engineering",
    "dept": "ME",
    "num": "622",
    "desc": "Prerequisite: ME 571.\nVentilation, heating and cooling system design for buildings. Application of thermodynamic, heat transfer, and fluid mechanics principles for determination of building heating and cooling loads. Determination of ventilation requirements. Sizing, design and integration of environmental control systems.",
    "credits": "3"
  },
  {
    "course_name": "Aerodynamics",
    "dept": "ME",
    "num": "628",
    "desc": "Prerequisite: ME 571, MATH 340.\nA general introduction to aerodynamics including the analysis of lift, drag, thrust, and performance for subsonic aircraft, and the application of aerodynamic principles to design.",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Propulsion",
    "dept": "ME",
    "num": "631",
    "desc": "Prerequisite: ME 523, 571, MATH 340.\nMechanics and thermodynamics of aircraft propulsion systems; gas turbine aircraft engines; applied compressible flow; performance and design of propulsion systems.",
    "credits": "3"
  },
  {
    "course_name": "Thermodynamics of Modern Power Production",
    "dept": "ME",
    "num": "633",
    "desc": "Prerequisite: ME 523.\nThe first and second law analysis of modern stationary power systems using fossil, nuclear, and renewable energy sources. Component and system design, such as cycle design, load factor, and auxiliaries are considered in conjuction with their costs.",
    "credits": "3"
  },
  {
    "course_name": "Control of Mechanical Systems II",
    "dept": "ME",
    "num": "640",
    "desc": "Prerequisite: ME 570 and MATH 551.\nDesign and analysis of control systems. Topics include linear and nonlinear systems modeling; parameter estimation/system identification; steady state errors; advanced root locus and frequency response design; controller implementation.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Composites",
    "dept": "ME",
    "num": "651",
    "desc": "Prerequisite: CE 533 and senior standing in engineering.\nDesign, fabrication and testing of various composite materials. Analysis of mechanical properties of laminated composites.",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Vibrations",
    "dept": "ME",
    "num": "656",
    "desc": "Prerequisite: ME 512 and MATH 340.\nA general consideration for the formation and analysis of free and forced vibration of mechanical systems of single and mulitple degrees of freedom.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Mechanical Engineering",
    "dept": "ME",
    "num": "699",
    "desc": "Prerequisite: Approval of department head.",
    "credits": "1-18"
  },
  {
    "course_name": "Development of Computer Applications In Mechanical Engineering",
    "dept": "ME",
    "num": "701",
    "desc": "Prerequisite: ME 400.\nNature of design, graphical user interface development to support computer-aided design, algorithms and computer graphics in computer applications, feature-based design, applications to design problems.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Dynamics",
    "dept": "ME",
    "num": "716",
    "desc": "Prerequisite: ME 512, MATH 340.\nGeneral vector principles of the dynamics of particles and rigid bodies; applications to orbital calculations, gyrodynamics, and rocket performance; introduction to the energy methods of advanced dynamics.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Fluid Mechanics",
    "dept": "ME",
    "num": "720",
    "desc": "Prerequisite: ME 571, MATH 340.\nA continuation of ME 571 in the study of general topics in fluid mechanics. Conservation of mass and momentum principles with particular emphasis on analysis of inviscid (potential) flows, compressible flows, and more advanced viscous flows including boundary layers. Numerous applications utilizing numerical methods.",
    "credits": "3"
  },
  {
    "course_name": "Thermal Systems Design",
    "dept": "ME",
    "num": "721",
    "desc": "Prerequisite: ME 573.\nThermal systems design including economics, simulation, and optimization. Includes heating, ventilating and air conditioning design and control.",
    "credits": "3"
  },
  {
    "course_name": "Human Thermal Engineering",
    "dept": "ME",
    "num": "722",
    "desc": "Prerequisite: ME 573.\nApplication of thermodynamic, heat transfer, and fluid mechanics principles of the thermal analysis of the human body. Mathematical analysis and computer modeling of human response to the thermal environment. Evaluation of heat stress and cold stress. Protection from heat and cold. Requirements for thermal comfort and impact on human performance.",
    "credits": "3"
  },
  {
    "course_name": "Computer Control of ElectroMechanical Systems",
    "dept": "ME",
    "num": "728",
    "desc": "Prerequisite: ME 570.\nDiscrete modeling and analysis of dynamic physical systems in mechanical engineering. Sampling and data conversion and reconstruction. Real time implementation of control on a computer. Digital controller design and implementation. Laboratory exercises in control applications and design.",
    "credits": "3"
  },
  {
    "course_name": "Control Systems Analysis and Design",
    "dept": "ME",
    "num": "730",
    "desc": "Prerequisite: ECE 530 or ME 640.\nUse of classical analysis techniques for control system compensation. State space-control theory fundamentals are presented in addition to an introductory treatment of several major systems areas.",
    "credits": "3"
  },
  {
    "course_name": "Experimental Stress Analysis",
    "dept": "ME",
    "num": "738",
    "desc": "Prerequisite or concurrent: CE 533.\nExperimental methods of investigating stress distributions. Photoelastic models, photoelastic coatings, brittle coatings, and resistance strain gauges applied to static and dynamic problems.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Analysis I",
    "dept": "ME",
    "num": "760",
    "desc": "Prerequisite: MATH 340 and senior standing.\nMethods of analysis employed in the solution of problems selected from various branches of engineering. Emphasis is on discrete systems.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Heat Transfer",
    "dept": "ME",
    "num": "773",
    "desc": "Prerequisite: ME 573.\nConduction, convection and radiation, mass transfer, phase change, heat exchangers, introductory numerical methods.",
    "credits": "3"
  },
  {
    "course_name": "Monte Carlo Methods",
    "dept": "ME",
    "num": "777",
    "desc": "Prerequisite: MATH 340 or equivalent and knowledge of a programming language.\nThe objective of this course is to explore various methods of Monte Carlo for solving direct and inverse problems in engineering. The course covers probability distributions; laws of large numbers and Central Limit Theorem; pseudo random number generation; sampling, scoring, and precision; variance reduction procedures; Markov chain Monte Carlo; inverse Monte Carlo; solution of linear operator equations; particle transport simulation.",
    "credits": "3"
  },
  {
    "course_name": "Technical Graphics",
    "dept": "MET",
    "num": "111",
    "desc": "\nIntroduction to applications in sketching and 2D computer-aided design applied to geometric development and engineering communication. Techniques are applied to produce finished drawings and schematics to National and international standards. Theory and applications of orthographic and auxiliary projection and pictorial drawing. Standards for symbols, section views, and dimensioning included.",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Modeling and Detailing",
    "dept": "MET",
    "num": "117",
    "desc": "\nProfessional practices in the development and application of 3D part and assembly modeling for design and manufacturing. Preparation of 3D model for manufacturing data or production drawing. Development of tolerances versus cost, fit tolerances, and introductory geometric dimensioning and tolerancing (GD&amp;T) specifications. Application of handbook data and spreadsheet computation to design detail development.",
    "credits": "3"
  },
  {
    "course_name": "Manufacturing Methods",
    "dept": "MET",
    "num": "121",
    "desc": "\nIntroduction to contemporary manufacturing processes and practices, including precision measurement and inspection, machining, forming, casting, and welding processes. Recitation and laboratory experience in manufacturing practices, including metrology and basic setup and operation of manufacturing equipment. Observation of applications in local industry.",
    "credits": "3"
  },
  {
    "course_name": "Computer-Numerical-Controlled Machine Processes",
    "dept": "MET",
    "num": "125",
    "desc": "\nStudy and practice of basic CNC programming and machining operations.",
    "credits": "2"
  },
  {
    "course_name": "Statics",
    "dept": "MET",
    "num": "211",
    "desc": "Corequisite: PHYS 113.\nA study of forces and their effects on the bodies upon which they act.",
    "credits": "3"
  },
  {
    "course_name": "Automated Manufacturing Systems I",
    "dept": "MET",
    "num": "230",
    "desc": "Prerequisite: ECET 100.\nA general survey of the various components and systems in automated manufacturing, including material handling, electropneumatic control, programmable logic control, robotics, tooling, inspection and quality control, CNC, and other production processes.",
    "credits": "3"
  },
  {
    "course_name": "Physical Materials and Metallurgy",
    "dept": "MET",
    "num": "231",
    "desc": "\nA broad view of materials used in industry, including structures of materials, how they react to stress and temperature, how the polyphase structures form, and how they are controlled to produce optimum properties. Students will examine through study and laboratory experimentation ferrous and nonferrous metals, polymers, composites, and ceramics.",
    "credits": "3"
  },
  {
    "course_name": "Material Strength and Testing",
    "dept": "MET",
    "num": "245",
    "desc": "Prerequisite: MET 211.\nCalculations of material strength and deformation are complemented with principles and practice of mechanical testing including instrumentation and measurement in the areas of loads, stresses, deformations, thermal stresses, and other quantities.",
    "credits": "3"
  },
  {
    "course_name": "Dynamics of Machines",
    "dept": "MET",
    "num": "246",
    "desc": "Prerequisite: MATH 220 and PHYS 113.\nVelocities, accelerations, and forces in existing mechanisms to produce motions. Work, energy, impulse and momentum concepts in kinetics. Vibrations in machine parts.",
    "credits": "3"
  },
  {
    "course_name": "Fluid Power Technology",
    "dept": "MET",
    "num": "252",
    "desc": "Prerequisite: MATH 150.\nStudy, design, analysis, operation, maintenance, and applications of hydraulic and pneumatic power systems and components.",
    "credits": "3"
  },
  {
    "course_name": "Machine Design Technology I",
    "dept": "MET",
    "num": "264",
    "desc": "Corequisite: MET 245.\nIntroduction to application and selection of machine elements to design mechanical systems.  Covers primary machine elements such as shafts and shaft components, screws and fasteners, welded joints, springs, bearings, gears, clutches and brakes.",
    "credits": "4"
  },
  {
    "course_name": "Topics in Mechanical Engineering Technology",
    "dept": "MET",
    "num": "299",
    "desc": "Prerequisite: Consent of instructor.\nProvides an opportunity for faculty to present mechanical engineering technology topics.",
    "credits": "1-18"
  },
  {
    "course_name": "Finite Element Analysis and Design Modeling",
    "dept": "MET",
    "num": "314",
    "desc": "Prerequisite: MET 117 and MET 245.\nIntroduction to finite element analysis applied to mechanical design.  Study and application of advanced computer-aided modeling techniques.",
    "credits": "3"
  },
  {
    "course_name": "Additive Manufacturing",
    "dept": "MET",
    "num": "325",
    "desc": "\nThe course develops an understanding of additive manufacturing (AM) principles and applications combined with a problem-based learning project which develops design, manufacturing and maintenance skill sets for AM practitioners.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Material Science",
    "dept": "MET",
    "num": "333",
    "desc": "Prerequisite: CHM 110 and CHM 111 and MET 231.\nA continuation of MET 231 Physical Materials and Metallurgy. Emphasizes the understanding of material properties used to give various materials their function. Theory and laboratory work focus on controlling and testing material properties. Ferrous and non-ferrous metals, polymers and adhesives, composites, smart materials, effects of corrosion, failure analysis, and selection techniques for design.",
    "credits": "3"
  },
  {
    "course_name": "Elements of Mechanisms",
    "dept": "MET",
    "num": "346",
    "desc": "Prerequisite: MET 117 and MET 246.\nFundamental motion concepts of displacement, velocity, and acceleration are studied, as well as analytical and graphical analysis and synthesis of linkages, gear trains, cams, pulleys, and combinations of these elements.",
    "credits": "3"
  },
  {
    "course_name": "Fluid Mechanics",
    "dept": "MET",
    "num": "353",
    "desc": "Prerequisite: MATH 220, MET 252, and PHYS 113.\nFundamental concepts of fluid mechanics. Study of buoyancy, energy equation, viscosity, and flow measurement. Selected applications of fluid mechanics in civil and mechanical technologies. Computer-aided solution of problems in fluid mechanics.",
    "credits": "3"
  },
  {
    "course_name": "Machine Design Technology II",
    "dept": "MET",
    "num": "365",
    "desc": "Prerequisite: MET 264.\nContinued study of design of mechanical elements and systems including engineering mechanics and materials, investigation of failure theories under static and variable loading, stress analysis, stress concentration, and deflections.",
    "credits": "3"
  },
  {
    "course_name": "Quality Control",
    "dept": "MET",
    "num": "381",
    "desc": "Prerequisite: Junior standing or consent of instructor.\nAn introductory course in quality concepts and techniques used in industry. Topics include fundamentals of statistics and probability, statistical process control charts, and quality improvement tools.",
    "credits": "3"
  },
  {
    "course_name": "Industrial Instrumentation and Controls",
    "dept": "MET",
    "num": "382",
    "desc": "Prerequisite: ECET 304 or ECET 201.\nAn introduction to process control systems for industrial applications. Course topics include concepts and terminology, first- and second-order systems, measurement of motion, gauges and transducers, signal processing, and measurement of properties.",
    "credits": "3"
  },
  {
    "course_name": "Managerial and Project Economics",
    "dept": "MET",
    "num": "410",
    "desc": "Prerequisite: MATH 100.\nEconomic analysis of problems as applied to managerial decision making. Students consider the economic viability of solutions in engineering and a variety of other kinds of projects common in technology-oriented businesses.",
    "credits": "3"
  },
  {
    "course_name": "Tool Design for Manufacturing",
    "dept": "MET",
    "num": "460",
    "desc": "Prerequisite: MET 117 and  MET 125, and MET 346.\nPrinciples and practices involved in tool drawing and design concepts necessary for the manufacture of products. Emphasis on design of jigs and fixtures, gauging devices, dies, ease of operation, and methods of assembly. Production cost related to selection of parts and methods of production is stressed. Applied laboratory exercises illustrated through specific case studies.",
    "credits": "3"
  },
  {
    "course_name": "Senior Design Project I",
    "dept": "MET",
    "num": "462",
    "desc": "Prerequisite: MET 365 and senior standing.\nSelection, definition, and analysis of a project supervised by faculty. Includes consideration of project parameters, trade-off studies, alternative solutions, and justification of selected solution. Completion and presentation of a written project proposal included.",
    "credits": "1"
  },
  {
    "course_name": "Senior Design Project II",
    "dept": "MET",
    "num": "464",
    "desc": "Prerequisite: MET 462 and senior standing.\nDevelopment and implementation of project proposal submitted in MET 462. Construction, packaging, and testing of project culminating in a senior design project report which may include full documentation and performance specifications, functional description, theoretical analysis, schematics, cost analysis, parts list, drawings, etc. Project results will be presented orally to a select committee at the end of the course.",
    "credits": "2"
  },
  {
    "course_name": "Thermodynamics and Heat Transfer",
    "dept": "MET",
    "num": "471",
    "desc": "Prerequisite: MET 353.\nThis course emphasizes thermodynamic laws and equations and the use of tables and charts for properties of important fluids. Applications to systems used for producing, transforming, and applying heat and mechanical energy are also studied. Conduction, convection, and radiation heat transfer processes are investigated.",
    "credits": "3"
  },
  {
    "course_name": "Automated Manufacturing Systems II",
    "dept": "MET",
    "num": "481",
    "desc": "Prerequisite: MET 125, MET 230, and MET 382.\nCovers systems for manufacturing operations including facilities, supplies, materials, procedures, and control. Topics include design, programming, feedback for manufacturing, production set-up, automated work cells, and decision issues.",
    "credits": "3"
  },
  {
    "course_name": "Industrial Work Internship",
    "dept": "MET",
    "num": "490",
    "desc": "Prerequisite: Sophomore standing and consent of MET program coordinator.\nThe student will work as an intern with business and industry in mechanical engineering technology field. A report detailing duties performed and tasks accomplished is required at the end of the internship period.",
    "credits": "1-18"
  },
  {
    "course_name": "Advanced Topics in Mechanical Engineering Technology",
    "dept": "MET",
    "num": "499",
    "desc": "Prerequisite: Consent of instructor.\nProvides an opportunity for faculty to present advanced mechanical engineering technology topics.",
    "credits": "1-18"
  },
  {
    "course_name": "Info Tech for Business",
    "dept": "MIS",
    "num": "366",
    "desc": "Prerequisite: GENBA 166 or CIS 101, 102, 103.\nA comprehensive view of the role of information technology in satisfying organizations’ information requirement. Problems and techniques concerning the management of responsive information systems with special attention to managers’ use of systems outputs. Cases and hands-on exercises emphasizing the use of information systems in decision making, information gathering and organizing, use of modeling techniques, and presentation of information. Course made specific to prospective Management Information Systems (MIS) majors.",
    "credits": "3"
  },
  {
    "course_name": "Studio 1: Business Programming Applications I",
    "dept": "MIS",
    "num": "411",
    "desc": "Prerequisite or concurrent: MANGT 366 or MIS 366.\nBusiness-related object-oriented programming fundamentals used to enhance skills for problem solving and logical thinking. The course focuses on class diagrams, and the utilization of visual programming languages for understanding and applying software development concepts.",
    "credits": "3"
  },
  {
    "course_name": "Studio 2: Business Database Systems",
    "dept": "MIS",
    "num": "422",
    "desc": "Prerequisite: MANGT 366 or MIS 366.\nExamination of database theory, design, implementation and the value of data to an organization. Study of data query languages including the definition and creation of database objects, manipulation of data stores including entry, modification, removal and extraction, and database programming fundamentals.",
    "credits": "3"
  },
  {
    "course_name": "Studio 3: ERP Project Planning and Implementation",
    "dept": "MIS",
    "num": "433",
    "desc": "Prerequisite: MIS 411 and MIS 422.\nStudy of project management techniques used by information systems specialists and applications of enterprise systems. Emphasis on ERP systems configuration, business process integration and hands-on project management.",
    "credits": "3"
  },
  {
    "course_name": "Studio 4: Digital Business Networks",
    "dept": "MIS",
    "num": "444",
    "desc": "Prerequisite: MIS 411 or MIS 422.\nStudy of digital networks considering impact and value to business organizations. Coverage includes communications protocols and standards, hardware, software, network implementation and configuration; and network security. Emphasis on hands-on network setup, configuration and testing.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "MIS",
    "num": "490",
    "desc": "Prerequisite: Consent of instructor.\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "MIS Internship",
    "dept": "MIS",
    "num": "495",
    "desc": "Prerequisite: Consent of instructor.\nEight weeks of applied Management Information Systems (MIS) experience designed to coordinate the interests of students and firms.",
    "credits": "0-3"
  },
  {
    "course_name": "Studio 5: Business Programming Applications II",
    "dept": "MIS",
    "num": "555",
    "desc": "Prerequisite: MIS 411 and either MIS 422 or MIS 667.\nAdvanced application of business-related object-oriented programming fundamentals. This course focuses on the utilization of web programming languages and mobile software development for creating solutions to business problems.",
    "credits": "3"
  },
  {
    "course_name": "Studio 6: Systems Analysis and Design",
    "dept": "MIS",
    "num": "566",
    "desc": "Prerequisite: MIS 433 and either MIS 444 or MIS 667.\nAn in-depth study of systems analysis and design techniques viewing information systems as an integral component of organizational strategic planning. Emphasis on systems planning, use of CASE tools, process and data modeling, quality and systems reengineering.",
    "credits": "3"
  },
  {
    "course_name": "K-State MIS: Health Info Sys Portfolio I",
    "dept": "MIS",
    "num": "580",
    "desc": "Prerequisite: Associate’s Degree in Health Information Systems from JCCC.\nThis course serves a mechanism to indicate students have completed a series of Health Information Systems courses at Johnson County Community College in the process of completing their Associate’s Degree. It is used solely for transfer credit tracking and fulfills the thematic sequence requirement in the College of Business. Students cannot enroll in this class nor can this course be transferred into programs other than Management Information Systems in the College of Business Administration.",
    "credits": "9"
  },
  {
    "course_name": "K-State MIS: Health Info Sys Portfolio II",
    "dept": "MIS",
    "num": "581",
    "desc": "Prerequisite: Associate’s Degree in Health Information Systems from JCCC.\nThis course serves a mechanism to indicate students have completed a series of Health Information Systems courses at Johnson County Community College in the process of completing their Associate’s Degree. It is used solely for transfer credit tracking and fulfills the unrestricted electives requirement in the College of Business. Students cannot enroll in this class nor can this course be transferred into programs other than Management Information Systems in the College of Business Administration.",
    "credits": "15"
  },
  {
    "course_name": "Systems Analysis & Design",
    "dept": "MIS",
    "num": "656",
    "desc": "Prerequisite: MIS 411 or permission of instructor.\nAn in-depth study of systems analysis &amp; design techniques viewing information systems as an integral component of organizational strategic planning. Emphasis on systems planning, use of CASE tools, process and data modeling, and creating design specifications for business applications.",
    "credits": "3"
  },
  {
    "course_name": "Business Analytics and Data Mining",
    "dept": "MIS",
    "num": "665",
    "desc": "Prerequisite: MANGT 366 or MIS 366 or an equivalent introductory computing course.\nIn-depth study of a broad range of topics and techniques in business intelligence (BI), data mining, and database marketing (DM). Emphasis on fundamentals of relational database management, data warehousing as a business practice, customer relationship management (CRM), customer segmentation, various data mining techniques, data visualization, business performance management, use of scorecard/dashboard, and advanced BI and data mining software tools.",
    "credits": "3"
  },
  {
    "course_name": "Applications of Data Models in Business",
    "dept": "MIS",
    "num": "667",
    "desc": "Prerequisite: MIS 444 or permission of instructor.\nExamination of database theory, design, implementation and the value of data to an organization. Study of data query languages including the definition and creation of database objects, manipulation of data stores including entry, modification, removal and extraction, and database programming fundamentals.",
    "credits": "3"
  },
  {
    "course_name": "Social Media Analytics and Web Mining",
    "dept": "MIS",
    "num": "670",
    "desc": "Prerequisite: MANGT 366 or MIS 366 or an equivalent introductory computing course.\nThis course is an in-depth study of a broad range of topics and techniques in the areas of social media analytics, web mining and social network analysis. Emphasis is on fundamentals of data acquisition from the web and social media platforms, transformation of these unstructured data into structured format, advanced data processing techniques for analysis, business intelligence through web crawling, analysis of web and social media data using classification, clustering, and association techniques, sentiment analysis (or opinion mining) for business decisions, visualization of unstructured data, and social network analysis.",
    "credits": "3"
  },
  {
    "course_name": "Studio 7: Senior MIS Project",
    "dept": "MIS",
    "num": "677",
    "desc": "Prerequisite: MIS 555 and MIS 566.\nSenior project. Students must demonstrate proficiency in the analysis, design and implementation of a business application by creating a working prototype of a business application. The prototype must include a graphical user interface with operable connections to a remote database.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Marketing",
    "dept": "MKTG",
    "num": "400",
    "desc": "Prerequisite: ECON 110 or 120.\nA general study of marketing principles which lead to the development of marketing strategy. A review of environmental influences and key analytical tools used in formulating marketing plans. Product or service design, distribution, pricing, and promotional programs.",
    "credits": "3"
  },
  {
    "course_name": "Consumer Behavior",
    "dept": "MKTG",
    "num": "450",
    "desc": "Prerequisite: MKTG 400 and junior standing.\nConsumer behavior is the study of the cognitive, affective, and behavioral factors that interact with social, cultural, and situational influences to guide decision making in the marketplace.  The goals are to provide a conceptual understanding of consumer behavior, experience in applying consumer behavior concepts to marketing strategy, and knowledge of consumer research applications.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "MKTG",
    "num": "490",
    "desc": "Prerequisite: Consent of instructor.\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Marketing Internship",
    "dept": "MKTG",
    "num": "495",
    "desc": "Prerequisite: FINAN 450, MANGT 420, MKTG 400, and consent of instructor.\nEight weeks of applied marketing business experience between junior and senior years designed to coordinate the interests of students and firms.",
    "credits": "0-3"
  },
  {
    "course_name": "Special Topics in Marketing",
    "dept": "MKTG",
    "num": "496",
    "desc": "\nDiscussion and analysis of current and emerging issues in marketing, including topics related to new theory, new applications, and the practice of marketing.",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Marketing",
    "dept": "MKTG",
    "num": "498",
    "desc": "Prerequisite: Consent of department head.\nSelected topics in marketing.",
    "credits": "1-18"
  },
  {
    "course_name": "Sales Practicum",
    "dept": "MKTG",
    "num": "499",
    "desc": "Prerequisite: MKTG 542. Consent of National Strategic Selling Institute (NSSI) Director.\nThe student will work as a sales intern in a business environment as a means to gain applied sales experience. A report detailing duties performed and tasks accomplished is required at the end of the internship period, along with an evaluation by the supervisor and a self-assessment. Additionally, the student will complete required reading and answer weekly discussion questions and post weekly diary entries.",
    "credits": "3"
  },
  {
    "course_name": "Retailing",
    "dept": "MKTG",
    "num": "541",
    "desc": "Prerequisite: MKTG 400.\nDesigned introduce the student to the role retailing performs in the distribution of consumer goods and services. The course will survey the retailing environment and incorporate strategic planning from the management point of view; study retail policies and organizations; merchandise control; personnel management; retail accounting and expense control.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Professional Selling",
    "dept": "MKTG",
    "num": "542",
    "desc": "Prerequisite or concurrent enrollment: MKTG 400.\nFocuses on interpersonal communications between buyers and sellers, both oral and written. The mechanics and intricacies of personal sales presentations, which will be developed through practice.",
    "credits": "3"
  },
  {
    "course_name": "Integrated Marketing Communications",
    "dept": "MKTG",
    "num": "543",
    "desc": "Prerequisite: MKTG 400.\nFocuses on the management of promotional programs which include elements of advertising, personal selling, sales promotion, and public relations. Includes a review of concepts from economics, behavioral sciences, and mathematics which play a role in creating, executing, and evaluating promotional programs.",
    "credits": "3"
  },
  {
    "course_name": "International Marketing",
    "dept": "MKTG",
    "num": "544",
    "desc": "Prerequisite: MKTG 400.\nThis course deals with the problems and perspectives of marketing across national boundaries. It also focuses on the tools and practices for structuring and controlling marketing programs related to overseas business. Emphasis is on the management of marketing functions in a global context. Topics include international trade organizations, international economic factors, foreign business customs, and the international marketing mix.",
    "credits": "3"
  },
  {
    "course_name": "Marketing Channels",
    "dept": "MKTG",
    "num": "545",
    "desc": "Prerequisite: MKTG 400.\nStudy of the quantitative and qualitative factors involved in selecting, developing, managing, and controlling marketing channels of distribution. Includes decision models from industrial marketers through purchasing units.",
    "credits": "3"
  },
  {
    "course_name": "Services Marketing",
    "dept": "MKTG",
    "num": "546",
    "desc": "Prerequisite: MKTG 400.\nAn analysis of the unique marketing challenges faced by service organizations. Major topics include the unique characteristics of services, creating and positioning a service in the marketplace, distributing, promoting and pricing services. An evaluation of marketing strategies from the perspective of a service firm.",
    "credits": "3"
  },
  {
    "course_name": "International Business",
    "dept": "MKTG",
    "num": "547",
    "desc": "Prerequisite: MKTG 400, MANGT 420.\nThis course provides students with an appreciation of the opportunities and unique challenges in international business, an understanding of the strategic and operational options available to an international firm, and managerial decision making abilities required to be successful abroad. The course examines strategic and operational issues involved in international business activity and how to best manage these issues.",
    "credits": "3"
  },
  {
    "course_name": "Marketing Field Study",
    "dept": "MKTG",
    "num": "548",
    "desc": "Prerequisite: MKTG 400 or MKTG 542.\nThis course is designed to provide students with an opportunity to observe international business and marketing perspectives by participating in a field trip outside the United States.  This experiential course may involve a combination of business visits, cultural experiences, internship activities, or other learning activities while abroad.",
    "credits": "3"
  },
  {
    "course_name": "Business Marketing",
    "dept": "MKTG",
    "num": "550",
    "desc": "Prerequisite: MKTG 400.\nA study of the nature of the industrial marketplace, concentrating on those aspects that differentiate it from the consumer markets. The major topics are analysis of market needs, market segments, organizational buying behavior, purchasing agent functions and activities, marketing strategy and mix for institutional customers, not-for-profit and services marketing, and buyer/seller relationships.",
    "credits": "3"
  },
  {
    "course_name": "Sales Force Leadership",
    "dept": "MKTG",
    "num": "560",
    "desc": "Prerequisite: MKTG 542.\nManagement of the sales force in non-retail settings including hiring, training, organizing, motivating, supervising, and evaluating sales representatives and techniques of sales forecasting.",
    "credits": "3"
  },
  {
    "course_name": "Sales Negotiation",
    "dept": "MKTG",
    "num": "561",
    "desc": "Prerequisite: Permission from Director of National Strategic Selling Institute required.\nCovers the fundamentals of negotiation, and how those fundamentals can be used during the sales process, with the goal of improving student understanding of negotiation theory and practical application. Learning components include reading assignments, in-class lectures and discussions, and role plays. Emphasis is placed on building students’ skill sets.",
    "credits": "3"
  },
  {
    "course_name": "Key Account Management",
    "dept": "MKTG",
    "num": "562",
    "desc": "\nIntroduces students to the complex strategies and tactics used in identifying and managing key customer accounts, including those with large multi-national footprints. Course components include reading assignments, quizzes/tests, and role plays.",
    "credits": "3"
  },
  {
    "course_name": "Cooperation Selling",
    "dept": "MKTG",
    "num": "563",
    "desc": "Prerequisite: MKTG 542.\nTeaches participants how to successfully synchronize their selling process with the decision maker’s buying process so they can create completely satisfied customers and thus generate more sales. Course components include reading assignments, workbook assignments, quizzes, and role plays.",
    "credits": "3"
  },
  {
    "course_name": "Customer Relationship Management",
    "dept": "MKTG",
    "num": "565",
    "desc": "Prerequisite: MKTG 400\nThis course introduces students to the strategies, methodology and technology used to manage customer relationships; and support and enhance the sales and marketing functions. 100% of time devoted to lecture.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Selling",
    "dept": "MKTG",
    "num": "570",
    "desc": "Prerequisite: MKTG 555.\nProvides students the opportunity to enhance their professional selling skills through advanced instruction and skill development. Extensive use will be made of role playing and actual sales experience. Content will include prospecting, developing a sales story, adaptive selling, cold-calling, and managing a sales pipeline.",
    "credits": "3"
  },
  {
    "course_name": "Marketing Analytics Fundamentals",
    "dept": "MKTG",
    "num": "580",
    "desc": "Prerequisite: STAT 350 Business and Economic Statistics I or equivalent.\nBusiness intelligence is a systematic approach to harnessing customer data and competitive information to drive strategic business decision making. This course deals with how to collect and analyze business data to enhance quality of decision making in modern enterprises. Unlike courses based on data mining (inductive approach), this course will be largely based on regression techniques (deductive approach). The course will be based on lectures, case analysis, and hands-on exercises to make students comfortable with powerful computing tools used for data analysis. The cases and exercises will be bundled with data which will be used to apply concepts learned in class to real business situations.",
    "credits": "3"
  },
  {
    "course_name": "Applications of Marketing Analytics",
    "dept": "MKTG",
    "num": "581",
    "desc": "Prerequisite: STAT 350 or equivalent.",
    "credits": "3"
  },
  {
    "course_name": "Entertainment Marketing",
    "dept": "MKTG",
    "num": "625",
    "desc": "Prerequisite: MKTG 400.\nExamines the entertainment industry using strategic marketing approaches to assess market opportunities, develop marketing strategies, and design implementation tactics.",
    "credits": "3"
  },
  {
    "course_name": "Sports Marketing",
    "dept": "MKTG",
    "num": "630",
    "desc": "Prerequisite: MKTG 400.\nThis course provides students with the opportunity to study the nature and scope of marketing a sports franchise as well as marketing traditional products or services with the assistance of sports figures. Topics include sports franchise promotion, sports identification, consumer loyalty to a team and consumer loyalty to participation sports.",
    "credits": "3"
  },
  {
    "course_name": "Digital Marketing",
    "dept": "MKTG",
    "num": "635",
    "desc": "Prerequisite: MKTG 400.\nThis course is designed to provide students with the awareness and understanding of how Internet and Web-based technologies can be utilized to create effective marketing programs. Major topics will include new product development, brand building, promotion, pricing, and distribution in an electronic commerce context.",
    "credits": "3"
  },
  {
    "course_name": "Marketing Research",
    "dept": "MKTG",
    "num": "642",
    "desc": "Prerequisite: MKTG 580 or MKTG 581.\nMarketing research is designed to acquaint the students with concepts, methods, and applications of research regarding the market environment. Topics include business problem identification, qualitative &amp; quantitative research design formulation, primary &amp; secondary data collection methods, advanced data analysis approaches, and communicating the value of findings from analysis. This capstone course on the marketing analytics track helps the students integrate marketing knowledge and analytical skills by conducting business case analyses and comprehensive data analysis projects so that they can make insightful decisions based on empirical evidence.",
    "credits": "3"
  },
  {
    "course_name": "Marketing Strategy",
    "dept": "MKTG",
    "num": "690",
    "desc": "Prerequisite: MKTG 450, MKTG 542, and senior standing.\nAnalysis of marketing situations which lead to appropriate management of the marketing program’s objectives. Capstone course integrates knowledge of marketing and other business management principles into marketing strategy, development, implementation, and control.",
    "credits": "3"
  },
  {
    "course_name": "Study Abroad",
    "dept": "MLANG",
    "num": "001",
    "desc": "",
    "credits": "0"
  },
  {
    "course_name": "Beginner Studies in Foreign Language",
    "dept": "MLANG",
    "num": "100",
    "desc": "\nCourse used to transfer credit for first and second semester language courses not offered at K-State. Consultation for approval is expected.",
    "credits": "1-5"
  },
  {
    "course_name": "Hebrew for Beginners",
    "dept": "MLANG",
    "num": "110",
    "desc": "\nAn introduction to the Hebrew language and the culture of the people who speak the language. This general introduction includes skill development in reading, writing, and speaking basic Hebrew.",
    "credits": "2"
  },
  {
    "course_name": "Intermediate Studies in Foreign Language I",
    "dept": "MLANG",
    "num": "200",
    "desc": "\nCourse used to transfer credit for third semester language courses not offered at K-State.",
    "credits": "1-5"
  },
  {
    "course_name": "Studies in World Literature and Culture",
    "dept": "MLANG",
    "num": "280",
    "desc": "\nProvides the students the opportunity to investigate in detail a particular theme or genre in World literature or culture. Taught in English.",
    "credits": "1-5"
  },
  {
    "course_name": "Honors Introduction to the Humanities I",
    "dept": "MLANG",
    "num": "297",
    "desc": "Prerequisite: Consent of instructor.\nStudy of selected major works of history, literature, and philosophy which have been of central importance in the Western cultural tradition. Considerable emphasis is placed on classroom discussion and writing interpretive essays.",
    "credits": "3"
  },
  {
    "course_name": "Honors Introduction to the Humanities II",
    "dept": "MLANG",
    "num": "298",
    "desc": "Prerequisite: MLANG 297 or consent of instructor.\nContinuation of MLANG 297.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Studies in Foreign Language II",
    "dept": "MLANG",
    "num": "300",
    "desc": "\nCourse used to transfer credit for fourth semester language course not offered at K-State.",
    "credits": "1-4"
  },
  {
    "course_name": "Languages and Your Future",
    "dept": "MLANG",
    "num": "301",
    "desc": "\nInvestigation and application of resources for developing language and culture skills, as well as a knowledge base about related fields and careers. Taught in English.",
    "credits": "1"
  },
  {
    "course_name": "Intermediate Studies in Foreign Language",
    "dept": "MLANG",
    "num": "398",
    "desc": "\nOffered only to participants in study abroad programs. Prior consultation for approval is expected.",
    "credits": "1-6"
  },
  {
    "course_name": "Honors Seminar in Modern Languages",
    "dept": "MLANG",
    "num": "399",
    "desc": "\nReading and discussion of selected masterpieces of European literature in English translation.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "MLANG",
    "num": "499",
    "desc": "\nOpen only to Arts and Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "European Literature in Translation",
    "dept": "MLANG",
    "num": "507",
    "desc": "\nSelected readings in English from the major authors of Europe and the Spanish-speaking world.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Linguistics: Language Structure and Language Use",
    "dept": "MLANG",
    "num": "600",
    "desc": "Prerequisite: For ML majors &amp; minors: GRMN 523 or 527, or FREN 513 or 518 or one 700-level class, or SPAN 410 or 420 or 510; For other majors: ENGL 200.\nIntroduction to the fundamentals of linguistic analysis, including the sound system (phonetics and phonology), word formation (morphology), sentence formation (syntax), meaning (semantics and pragmatics). Formal and functional (usage-based) perspectives. Application of linguistics to language acquisition theory and to pedagogy.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Foreign Language Pedagogy",
    "dept": "MLANG",
    "num": "710",
    "desc": "Prerequisite: Instructor approval required.\nSecond and foreign language pedagogical theory is combined with the examination of practical concerns in the teaching of languages, in order to provide future and current instructors with the necessary background for making informed decisions concerning classroom practices. Taught in English.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Literary Theory and Research Methodology",
    "dept": "MLANG",
    "num": "720",
    "desc": "\nAn overview of theoretical approaches and classical texts that inform current trends in literary research in the modern languages.",
    "credits": "3"
  },
  {
    "course_name": "Theories of 2nd Language Acquisition",
    "dept": "MLANG",
    "num": "770",
    "desc": "Prerequisite: Instructor approval required.\nIntroduction to the major theoretical frameworks of second language acquisition (SLA). Reading, discussion, and analysis of SLA research on a variety of linguistic and learning issues. Of interest to students of both language acquisition and literature. Taught in English.",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Modern Languages",
    "dept": "MLANG",
    "num": "779",
    "desc": "\nVariable topics.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Military Science and ROTC",
    "dept": "MSCI",
    "num": "100",
    "desc": "\nBasic drill, physical fitness, rappelling, army values, military presentations and basic marksmanship.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to Military Leadership",
    "dept": "MSCI",
    "num": "101",
    "desc": "\nPrinciples of effective leading. Communication skills to improve individual performance and group interaction. Relation of military organizational ethical values to the effectiveness of a leader, incorporating perspectives of the evolution of the U.S. Military from colonial times through the modern era.",
    "credits": "1-18"
  },
  {
    "course_name": "Self/Team Development",
    "dept": "MSCI",
    "num": "200",
    "desc": "\nEthics-based military leadership skills that develop individual abilities and contribute to building effective teams. Oral presentations, leadership, land navigation, and basic military tactics.",
    "credits": "1-18"
  },
  {
    "course_name": "Individual/Team Military Tactics",
    "dept": "MSCI",
    "num": "202",
    "desc": "\nIntroduction to individual and team aspects of military tactics in small unit operations. Safety assessments, movement techniques, military orders process, rifle marksmanship, rappelling.",
    "credits": "1-18"
  },
  {
    "course_name": "Leaders Training Course",
    "dept": "MSCI",
    "num": "206",
    "desc": "\nA five-week summer camp conducted at Fort Knox, Kentucky. The United States Army provides pay, travel, lodging and meal costs. No military obligation incurred.",
    "credits": "0-4"
  },
  {
    "course_name": "Leading Small Military Organizations I",
    "dept": "MSCI",
    "num": "301",
    "desc": "Prerequisite: Completion of the basic course. Instructor permission required for enrollment.\nSeries of practical opportunities to lead small groups in situations of increasing complexity. Uses small unit defensive tactics and opportunities to plan and conduct training.",
    "credits": "1-18"
  },
  {
    "course_name": "Leading Small Military Organizations II",
    "dept": "MSCI",
    "num": "302",
    "desc": "Prerequisite: Completion of MSCI 301 and instructor permission.\nContinues methodology of MSCI 301. Military missions and task analysis. Ethical decision making and lessons from leadership case studies.",
    "credits": "1-18"
  },
  {
    "course_name": "Leaders Development and Assessment Course",
    "dept": "MSCI",
    "num": "306",
    "desc": "Prerequisite: MSCI 301 and 302.\nA five-week camp conducted at Fort Lewis, Washington, by members of Kansas State University and other university Army ROTC faculty. The U.S. Army provides pay, travel, lodging and most meal costs. Highly structured and demanding, stressing leadership at small unit levels under varying, challenging conditions.",
    "credits": "0-4"
  },
  {
    "course_name": "Military Leadership Studies and Practical Applications",
    "dept": "MSCI",
    "num": "351",
    "desc": "Prerequisite: MSCI 301 or 302. Instructor permission.\nIndependent research, analysis and monthly discussion on related military topics. Small unit tactics and practical application of leadership skills and individual research projects.",
    "credits": "1-18"
  },
  {
    "course_name": "Leadership Challenges and Objective-Setting",
    "dept": "MSCI",
    "num": "401",
    "desc": "Prerequisite: MSCI 301 and 302 or department head permission.\nPlan, conduct, and evaluate activities of the ROTC cadet organization. Articulate goals, put plans into action to attain them. Assess organizational cohesion and develop strategies to improve it. Develop confidence in skills to lead people and manage resources. Learn and apply various Army policies and programs.",
    "credits": "1-18"
  },
  {
    "course_name": "Transition to Lieutenant",
    "dept": "MSCI",
    "num": "402",
    "desc": "\nContinues the methodology from MSCI 401. Identify and resolve dilemmas. Refine counseling and motivating techniques. Examine aspects of tradition and law as relate to leading as an officer in the United States Army. Prepare for a future as a successful United States Army lieutenant.",
    "credits": "1-18"
  },
  {
    "course_name": "Honors Project",
    "dept": "MSCI",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program and Advanced Military Science Curriculum (must have completed the Basic Military Science Curriculum or received United States Army Cadet Command credit through prior military service or completion of the Leaders Training Course).",
    "credits": "3"
  },
  {
    "course_name": "Advanced Transition to Lieutenant I",
    "dept": "MSCI",
    "num": "501",
    "desc": "Prerequisite: MSCI 401 and 402 or department head permission.\nIndependent research, analysis and monthly discussion on related military topics. Personal, academic, and professional goals and objectives, development and maintenance of an officer evaluation report support form.",
    "credits": "1-18"
  },
  {
    "course_name": "Advanced Transition to Lieutenant II",
    "dept": "MSCI",
    "num": "502",
    "desc": "Prerequisite: MSCI 501.\nIndependent research, analysis, and monthly discussion on related military topics. Personal, academic, and professional goals and objectives, development, and maintenance of an officer evaluation report support form.",
    "credits": "1-18"
  },
  {
    "course_name": "Recital Attendance",
    "dept": "MUSIC",
    "num": "050",
    "desc": "",
    "credits": "0"
  },
  {
    "course_name": "Piano Proficiency",
    "dept": "MUSIC",
    "num": "060",
    "desc": "\nRequired for graduation of all music majors.",
    "credits": "0"
  },
  {
    "course_name": "Introduction to Music Theory",
    "dept": "MUSIC",
    "num": "100",
    "desc": "\nIntroduction to the theory of music for non-music majors, including the skills needed to read and write Western music notation and to understand the rhythmic, melodic, harmonic, and structural elements of music.",
    "credits": "3"
  },
  {
    "course_name": "Voice Class I",
    "dept": "MUSIC",
    "num": "103",
    "desc": "\nA beginning course in the basics of singing for non-music majors.",
    "credits": "1"
  },
  {
    "course_name": "Voice Class II",
    "dept": "MUSIC",
    "num": "104",
    "desc": "Prerequisite: MUSIC 103.\nSinging technique skills beyond the basics to include performance skills for non-music majors.",
    "credits": "1"
  },
  {
    "course_name": "Concert Choir",
    "dept": "MUSIC",
    "num": "111",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "University Choir",
    "dept": "MUSIC",
    "num": "112",
    "desc": "\nOpen to all K-State students without audition.",
    "credits": "0-1"
  },
  {
    "course_name": "University Band",
    "dept": "MUSIC",
    "num": "113",
    "desc": "\nOpen to all interested wind and percussion performers without audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Pep Band",
    "dept": "MUSIC",
    "num": "114",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Marching Band",
    "dept": "MUSIC",
    "num": "115",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Concert Band",
    "dept": "MUSIC",
    "num": "116",
    "desc": "\nOpen to all interested wind and percussion performers without audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Wind Ensemble I",
    "dept": "MUSIC",
    "num": "117",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Jazz Ensemble Lab A",
    "dept": "MUSIC",
    "num": "118",
    "desc": "\nAn intermediate level college jazz ensemble.  Examine and perform various jazz ensemble pieces selected from extant literature which may include cool, swing, hard bop, bossa, Latin, samba, funk/rock, and other styles.",
    "credits": "0-1"
  },
  {
    "course_name": "Collegiate Chorale",
    "dept": "MUSIC",
    "num": "121",
    "desc": "\nOpen to all interested singers. Audition determines membership in this and other choral organizations.",
    "credits": "0-1"
  },
  {
    "course_name": "K-State Singers",
    "dept": "MUSIC",
    "num": "125",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Symphony Orchestra",
    "dept": "MUSIC",
    "num": "130",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Theatre Orchestra",
    "dept": "MUSIC",
    "num": "131",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Men’s Choir",
    "dept": "MUSIC",
    "num": "135",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "University Treble Chorus",
    "dept": "MUSIC",
    "num": "140",
    "desc": "\nAdmission by audition.",
    "credits": "1"
  },
  {
    "course_name": "Music Listening Laboratory",
    "dept": "MUSIC",
    "num": "160",
    "desc": "Prerequisite: Limited to non-music majors.\nA basic introduction to music. Overview of Medieval, Renaissance, Baroque, Classic, Romantic, and Twentieth Century stylistic periods; elements of music (melody, rhythm, harmony, form, timbre); and instrument recognition. The focus of the class is on developing listening skills and learning to write brief papers using the new language that has been acquired.",
    "credits": "2"
  },
  {
    "course_name": "History of Rock and Roll",
    "dept": "MUSIC",
    "num": "170",
    "desc": "\nA study of Rock and Roll from its origins through today, focusing on the development of rock styles from its roots in blues, folk, country, and pop.  Expansion of listening experience through study of song forms, musical instruments of rock, and the socio-political significance of song lyrics.  Examinations, research paper required.",
    "credits": "3"
  },
  {
    "course_name": "Inventing the Future: Underground Rock: 1968-1993",
    "dept": "MUSIC",
    "num": "171",
    "desc": "\nAn introduction to the underground rock music, musicians, and scenes from the 1960’s to the 1990’s that have proven most influential on modern popular music and culture.",
    "credits": "3"
  },
  {
    "course_name": "Vocal Techniques I",
    "dept": "MUSIC",
    "num": "203",
    "desc": "\nA beginning course in the basics of singing and teaching skills.",
    "credits": "1"
  },
  {
    "course_name": "Vocal Techniques II",
    "dept": "MUSIC",
    "num": "204",
    "desc": "Prerequisite: MUSIC 203.\nSinging and teaching skills beyond the basics and presentation of materials suitable for private and public school instruction at the secondary level.",
    "credits": "1"
  },
  {
    "course_name": "Guitar Class I",
    "dept": "MUSIC",
    "num": "208",
    "desc": "\nBeginning-level group instruction in guitar performance.",
    "credits": "1"
  },
  {
    "course_name": "Guitar Class II",
    "dept": "MUSIC",
    "num": "209",
    "desc": "\nIntermediate-level instruction in guitar performance.",
    "credits": "1"
  },
  {
    "course_name": "Music Theory I",
    "dept": "MUSIC",
    "num": "210",
    "desc": "Prerequisite: Tested knowledge of basic music reading and aural skills.\nAn introduction to the basic language of music; scales, triads and seventh chords, and all simple intervals. Written and aural skills reinforce concepts of melody, rhythm, and harmony.",
    "credits": "3"
  },
  {
    "course_name": "Piano Class I",
    "dept": "MUSIC",
    "num": "211",
    "desc": "\nFor students with no piano background.  Topics covered will include notation, intervals, accompaniment patterns, major scales, triads, basic progressions, and musicianship.",
    "credits": "1"
  },
  {
    "course_name": "Piano Class II",
    "dept": "MUSIC",
    "num": "212",
    "desc": "Prerequisite: MUSIC 211.\nCovers minor scales and arpeggios, minor chords, black-key major and minor scales, seventh chords, and harmonization.",
    "credits": "1"
  },
  {
    "course_name": "Piano Class III",
    "dept": "MUSIC",
    "num": "213",
    "desc": "Prerequisite: MUSIC 212.\nReinforces and expands the skills introduced in the previous levels: harmonization, transposition, sight-reading, improvisation, and technical exercises continue to be at the core of the curriculum, while introducing new concepts such as transposing instruments, secondary chords, and both instrumental and vocal accompanying.",
    "credits": "1"
  },
  {
    "course_name": "Piano Class IV",
    "dept": "MUSIC",
    "num": "214",
    "desc": "Prerequisite: MUSIC 213.\nReinforces and expands the skills introduced in previous levels: harmonization, transposition, sight-reading, improvisation, and technical exercises continue to be at the core of the curriculum, while introducing new concepts such as modulations, alto clef reading, augmented and Neapolitan sixth chords, and vocal warm-ups. Passing the final exam for this course fulfills the piano Proficiency requirements (MUSIC 060).",
    "credits": "1"
  },
  {
    "course_name": "Topics in Music",
    "dept": "MUSIC",
    "num": "220",
    "desc": "\nExploration of the musical dimensions of a particular topic or theme. Topics vary.",
    "credits": "1-3"
  },
  {
    "course_name": "Freshman Survey",
    "dept": "MUSIC",
    "num": "225",
    "desc": "\nAn introduction to the elements of music; the major historical periods of western classical music; music of non-western cultures; popular styles.",
    "credits": "2"
  },
  {
    "course_name": "Music Theory II",
    "dept": "MUSIC",
    "num": "230",
    "desc": "Prerequisite: Grade of C or higher in MUSIC 210 or tested knowledge of basic music theory and concurrent enrollment in MUSIC 231.\nContinued experience with the language of music. Part-writing, analysis, composition.",
    "credits": "3"
  },
  {
    "course_name": "Aural Skills I",
    "dept": "MUSIC",
    "num": "231",
    "desc": "Prerequisite: Grade of C or higher in MUSIC 210 or tested knowledge of music.\nDevelopment of aural skills through sight singing, rhythmic training, and ear-training; melodic, rhythmic, and harmonic dictation to reinforce concepts in Music Theory II.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Teaching Music",
    "dept": "MUSIC",
    "num": "232",
    "desc": "Prerequisite: Sophomore standing in music.\nTechniques, materials, and experiences for a variety of music classes will be examined through discovery.  Furthermore, lesson plan development, writing, and implementation will be examined in detail.",
    "credits": "2"
  },
  {
    "course_name": "String Techniques and Materials",
    "dept": "MUSIC",
    "num": "234",
    "desc": "\nA beginning course in the fundamentals of playing and methods for teaching stringed instruments.",
    "credits": "1"
  },
  {
    "course_name": "Percussion Techniques and Materials",
    "dept": "MUSIC",
    "num": "235",
    "desc": "\nThe fundamentals of playing and methods of teaching percussion instruments.",
    "credits": "2"
  },
  {
    "course_name": "Clarinet & Saxophone Woodwind Techniques and Materials",
    "dept": "MUSIC",
    "num": "236",
    "desc": "\nA course in the fundamentals of playing and methods for teaching single reed woodwind instruments.",
    "credits": "1"
  },
  {
    "course_name": "Double Reed and Flute Woodwind Techniques and Materials",
    "dept": "MUSIC",
    "num": "237",
    "desc": "\nA course in the fundamentals of playing and methods for teaching double reed and flute woodwind instruments.",
    "credits": "1"
  },
  {
    "course_name": "High Brass Techniques and Materials",
    "dept": "MUSIC",
    "num": "238",
    "desc": "\nA course in the fundamentals of playing and methods for teaching high brass instruments.",
    "credits": "1"
  },
  {
    "course_name": "Low Brass Techniques and Materials",
    "dept": "MUSIC",
    "num": "239",
    "desc": "\nA course in the fundmentals of playing and methods for teaching low brass instruments.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to American Music",
    "dept": "MUSIC",
    "num": "245",
    "desc": "\nAn introduction to the functions of music in American society and the elements of music, including a survey of the development of various types and styles of music in America.",
    "credits": "3"
  },
  {
    "course_name": "Songwriting",
    "dept": "MUSIC",
    "num": "248",
    "desc": "\nBasic music theory pertainng to the creation of a melody and the harmonization of that melody; how to craft creative lyrics, identify song form, and write a song using the most common and relevant forms in popular music.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Music of the World",
    "dept": "MUSIC",
    "num": "249",
    "desc": "\nThis course will develop listening skills and an understanding of the meaning of music from around the world. Students will discover how music can be used as a form of human expression, and also reflect the culture in which it was created. Due to the non-Western focus, cultural background and perspective will be provided for each population discussed including the influence of music within and upon societies and its members highlighting issues of human diversity outside the U.S.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Music",
    "dept": "MUSIC",
    "num": "250",
    "desc": "\nElements of music as represented in selected masterpieces of the standard concert repertory, designed to heighten the perception and the enjoyment of the listener who has limited musical knowledge.",
    "credits": "3"
  },
  {
    "course_name": "Applied Study for Non-Music Majors",
    "dept": "MUSIC",
    "num": "251",
    "desc": "Prerequisite: Admission by audition.\nApplied study for non-music majors.",
    "credits": "1-2"
  },
  {
    "course_name": "Secondary Performance",
    "dept": "MUSIC",
    "num": "254",
    "desc": "\nFor students who wish to study an instrument or voice other than the major performance area. Instruction is offered every semester in voice and each of the following instruments: baritone, bassoon, clarinet, double bass, early winds, flute, French horn, guitar, harp, harpsichord, oboe, organ, percussion, piano, saxophone, trombone, trumpet, tuba, viola, viola da gamba, violin, and violoncello.",
    "credits": "1-2"
  },
  {
    "course_name": "Lower-Division Performance",
    "dept": "MUSIC",
    "num": "255",
    "desc": "Prerequisite: Admission by audition\nInstruction and experience in solo performance is offered every semester in voice and each of the following instruments: baritone, bassoon, clarinet, double bass, early winds, flute, French horn, guitar, harp, harpsichord, oboe, organ, percussion, piano, saxophone, trombone, trumpet, tuba, viola, viola da gamba, violin, and violoncello.",
    "credits": "1-4"
  },
  {
    "course_name": "Marching Band Techniques for School Music Educators",
    "dept": "MUSIC",
    "num": "266",
    "desc": "\nPractical techniques of marching band in school music programs and the skills necessary to design, organize, instruct, and evaluate a marching band show.",
    "credits": "2"
  },
  {
    "course_name": "Lower-Division Ensemble Performance",
    "dept": "MUSIC",
    "num": "280",
    "desc": "\nInstruction is offered each semester in the following areas: brass, chamber music, concert jazz, jazz combo, strings, winds, percussion, and vocal ensemble.",
    "credits": "1"
  },
  {
    "course_name": "West African Drumming and Percussion",
    "dept": "MUSIC",
    "num": "281",
    "desc": "\nExplores several styles of drumming and African Xylophone playing from the Ga, Dagara, and Ewe traditions from Ghana and other parts of West Africa. Instruction, includes but it is not limited to playing techniques and musical structure for drumming and Xylophone playing as associated with common recreational dances. No prior experience is necessary.",
    "credits": "2"
  },
  {
    "course_name": "Italian Diction",
    "dept": "MUSIC",
    "num": "285",
    "desc": "\nRules for pronouncing and translating Italian vocal texts.",
    "credits": "1"
  },
  {
    "course_name": "German Diction",
    "dept": "MUSIC",
    "num": "287",
    "desc": "\nRules for pronouncing and translating German vocal texts.",
    "credits": "1"
  },
  {
    "course_name": "History of Musical Instruments",
    "dept": "MUSIC",
    "num": "310",
    "desc": "Prerequisite: MUSIC 160 or 250.\nThe development of musical instruments in each period of Western music.",
    "credits": "2"
  },
  {
    "course_name": "Women in Music",
    "dept": "MUSIC",
    "num": "311",
    "desc": "\nExplores music composed by women. Features western art music from the traditional stylistic periods, women’s contributions to jazz, popular, and some world music. Examines women’s roles as performers and patrons, and attitudes toward female musicians.",
    "credits": "3"
  },
  {
    "course_name": "Music Theory III",
    "dept": "MUSIC",
    "num": "320",
    "desc": "Prerequisite: Admission by audition.\nTheoretical concepts of eighteenth-century music. Modulations, secondary function chords, counterpoint, and some chromatic harmony. Identify and work with elements of musical structure through exercises, analysis and composition.",
    "credits": "3"
  },
  {
    "course_name": "Aural Skills II",
    "dept": "MUSIC",
    "num": "321",
    "desc": "Prerequisite: Grade of C or higher in MUSIC 231.\nSight singing, rhythmic training, and ear-training through drills and dictation to reinforce concepts in Music Theory III.",
    "credits": "1"
  },
  {
    "course_name": "Aural Skills Proficiency",
    "dept": "MUSIC",
    "num": "322",
    "desc": "Prerequisite: MUSIC 320 or concurrent enrollment.\nRequired for graduation of all music majors.",
    "credits": "0"
  },
  {
    "course_name": "Lower-Division Composition",
    "dept": "MUSIC",
    "num": "323",
    "desc": "Prerequisite: Instructor permission.\nComposition instruction through individual lessons and group seminar instruction.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to Film Music",
    "dept": "MUSIC",
    "num": "340",
    "desc": "\nExplores the evolution of the cinematic soundtrack. Introduces students to notable film composers, film-scoring techniques, and significant works in this genre. Designed for non-music majors and does not require previous musical training, also open to music majors.",
    "credits": "3"
  },
  {
    "course_name": "Collaborative Piano-Studio",
    "dept": "MUSIC",
    "num": "350",
    "desc": "Prerequisite: Consent of instructor.\nPiano student assigned to studio instructor.",
    "credits": "1"
  },
  {
    "course_name": "Collaborative Piano-Recital",
    "dept": "MUSIC",
    "num": "351",
    "desc": "Prerequisite: Consent of instructor.\nPiano student assigned to a music major preparing for graduation recital.",
    "credits": "1"
  },
  {
    "course_name": "Music Theory IV",
    "dept": "MUSIC",
    "num": "360",
    "desc": "Prerequisite: Admission by audition.\nTheoretical concepts of late nineteenth-century music and twentieth-century music: chromatic harmony and twentieth-century compositional techniques, analysis, and composition.  Identify and work with elements of musical structure.",
    "credits": "3"
  },
  {
    "course_name": "Aural Skills III",
    "dept": "MUSIC",
    "num": "361",
    "desc": "Prerequisite: Grade of C or higher in MUSIC 321.\nSight singing, rhythmic training, and ear-training through drills and dictation to reinforce concepts in Music Theory IV.",
    "credits": "1"
  },
  {
    "course_name": "Jazz Guitar Seminar",
    "dept": "MUSIC",
    "num": "373",
    "desc": "Prerequisite: Audition. Corequisite: MUSIC 696, MUSIC 698.\nListening to jazz guitar literature, performing, and offering meaningful critique.",
    "credits": "1"
  },
  {
    "course_name": "Special Studies in Music",
    "dept": "MUSIC",
    "num": "390",
    "desc": "Prerequisite: Declared major or minor in any music degree.",
    "credits": "1-3"
  },
  {
    "course_name": "Keyboard Pedagogy",
    "dept": "MUSIC",
    "num": "391",
    "desc": "Prerequisite: Keyboard majors with concurrent enrollment in MUSIC 455.\nA systematic study of pedagogy which examines effective teaching methods and aids in the development of a philosophy of professional teaching.",
    "credits": "2"
  },
  {
    "course_name": "Honors Seminar",
    "dept": "MUSIC",
    "num": "399",
    "desc": "\nFor selected sophomores.",
    "credits": "3"
  },
  {
    "course_name": "Concert Choir",
    "dept": "MUSIC",
    "num": "400",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Concert Band",
    "dept": "MUSIC",
    "num": "401",
    "desc": "\nOpen to all interested wind and percussion performers without audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Wind Ensemble II",
    "dept": "MUSIC",
    "num": "402",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Collegiate Chorale",
    "dept": "MUSIC",
    "num": "403",
    "desc": "\nOpen to all interested singers. Audition determines membership in other choral organizations.",
    "credits": "0-1"
  },
  {
    "course_name": "Symphony Orchestra",
    "dept": "MUSIC",
    "num": "404",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Music for Elementary Teachers",
    "dept": "MUSIC",
    "num": "405",
    "desc": "Prerequisite: Junior standing or consent of instructor.\nThe contribution of music to child development in elementary schools. A study of music literature suited to children through the development of purposive listening and the expressive phases of music including rhythmic response, singing, playing, reading, and writing.",
    "credits": "3"
  },
  {
    "course_name": "Collegiate Jazz Ensemble",
    "dept": "MUSIC",
    "num": "406",
    "desc": "\nAn advanced level college jazz ensemble.  Examines and preforms various jazz ensemble pieces selected from extant literature which may include cool, swing, hard bop, bossa, Latin, samba. funk/rock, and other styles.",
    "credits": "0-1"
  },
  {
    "course_name": "Men’s Choir",
    "dept": "MUSIC",
    "num": "408",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "University Treble Chorus",
    "dept": "MUSIC",
    "num": "409",
    "desc": "\nAdmission by audition.",
    "credits": "1"
  },
  {
    "course_name": "Marching Band",
    "dept": "MUSIC",
    "num": "411",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "University Band",
    "dept": "MUSIC",
    "num": "412",
    "desc": "\nOpen to all interested wind and percussion performers by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Theatre Orchestra",
    "dept": "MUSIC",
    "num": "414",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Pep Band",
    "dept": "MUSIC",
    "num": "416",
    "desc": "\nAdmission by audition.",
    "credits": "0-1"
  },
  {
    "course_name": "Conducting",
    "dept": "MUSIC",
    "num": "417",
    "desc": "Prerequisite: Grade of C or higher in MUSIC 320 and 321.\nTechniques of the baton gestures, signs, and cues as generally used in conducting choral and instrumental organizations.",
    "credits": "2"
  },
  {
    "course_name": "History of Jazz",
    "dept": "MUSIC",
    "num": "420",
    "desc": "Prerequisite: MUSIC 160, 250, or equivalent.\nSurvey of jazz styles and personalities.",
    "credits": "3"
  },
  {
    "course_name": "Salsa: Afro-Cuban Music of the Past and Present",
    "dept": "MUSIC",
    "num": "421",
    "desc": "Prerequisite: MUSIC 225, 245, or 250.\nAppreciation, historical knowledge, mechanics, aesthetics, and cultural contexts of salsa.",
    "credits": "3"
  },
  {
    "course_name": "Jazz in Kansas City and the Southwest",
    "dept": "MUSIC",
    "num": "424",
    "desc": "Prerequisite: MUSIC 160.\nThe history and development of jazz styles in Kansas City and the southwestern United States, emphasizing the influence on styles of other geographic areas.",
    "credits": "2-3"
  },
  {
    "course_name": "Topics in Jazz",
    "dept": "MUSIC",
    "num": "425",
    "desc": "Prerequisite: MUSIC 160.\nBig bands; jazz pianists and styles; survey of combo jazz styles, etc.",
    "credits": "1-18"
  },
  {
    "course_name": "Advanced String Techniques and Materials",
    "dept": "MUSIC",
    "num": "427",
    "desc": "Prerequisite: MUSIC 234.\nPlaying and teaching skills beyond fundamentals and presentation of materials suitable for private and public school instruction at the secondary level.",
    "credits": "1-2"
  },
  {
    "course_name": "Upper-Division Performance",
    "dept": "MUSIC",
    "num": "455",
    "desc": "Prerequisite: Admission by audition.\nInstruction and experience in solog performance is offered every semester in voice and each of the following instruments: baritone, bassoon, clarinet, double bass, early winds, flute, French horn, guitar, harp, harpsichord, oboe, organ, percussion, piano, saxophone, trombone, trumpet, tuba, viola, viola da gamba, violin, and violoncello.",
    "credits": "0-4"
  },
  {
    "course_name": "French Diction I",
    "dept": "MUSIC",
    "num": "465",
    "desc": "\nRules for pronouncing and translating French vocal texts.",
    "credits": "1"
  },
  {
    "course_name": "Songwriting",
    "dept": "MUSIC",
    "num": "470",
    "desc": "Prerequisite: MUSIC 100.\nComposition of original small song forms including preparation of lead sheet and vocal score using guitar chord symbols.",
    "credits": "3"
  },
  {
    "course_name": "Opera Workshop",
    "dept": "MUSIC",
    "num": "475",
    "desc": "\nPrinciples and techniques of operatic and musical theatre production, with emphasis on class rehearsal and performance of selected scenes from opera and musical drama; brief survey of the history of opera.",
    "credits": "1-18"
  },
  {
    "course_name": "Upper-Division Ensemble Performance",
    "dept": "MUSIC",
    "num": "480",
    "desc": "\nInstruction is offered each semester in the following areas: brass, chamber music, concert jazz, jazz combo, strings, winds, percussion, and vocal ensemble.",
    "credits": "1"
  },
  {
    "course_name": "Instrumental Jazz Instruction",
    "dept": "MUSIC",
    "num": "481",
    "desc": "\nGuides future instrumental teachers on techniques to teach jazz including beginning improvisation, combo, big band techniques, and school jazz literature.",
    "credits": "1"
  },
  {
    "course_name": "Vocal Jazz Instruction",
    "dept": "MUSIC",
    "num": "482",
    "desc": "\nGuides future choral teachers on techniques to teach jazz including beginning improvisation, jazz choir, and school jazz literature.",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Music",
    "dept": "MUSIC",
    "num": "489",
    "desc": "Prerequisite: Consent of instructor.\nSpecialized interest areas for undergraduate students only.",
    "credits": "1-2"
  },
  {
    "course_name": "Collegium Musicum",
    "dept": "MUSIC",
    "num": "490",
    "desc": "Prerequisite: Consent of instructor.\nA vocal and instrumental ensemble devoted to the historically-informed performance of music written primarily during the Medieval, Renaissance, and Baroque periods (c. 1100-1750. Instruments of the historical period used when possible.",
    "credits": "1"
  },
  {
    "course_name": "Vocal Pedagogy",
    "dept": "MUSIC",
    "num": "491",
    "desc": "\nStudy of vocal production, exploring the scientific principles of breathing, resonance, timbre, and other vocal features.  Discussion of vocal health and teaching styles will be included.",
    "credits": "2"
  },
  {
    "course_name": "Methods and Materials for the Studio",
    "dept": "MUSIC",
    "num": "492",
    "desc": "Prerequisite: MUSIC 391, or consent.\nMethods of teaching fundamental techniques; selection of teaching materials outlining courses of study. For undergraduate students in performance curricula. Taught in divisions according to the major. Practical application through supervised studio teaching.",
    "credits": "2"
  },
  {
    "course_name": "Honors Tutorial in Music",
    "dept": "MUSIC",
    "num": "498",
    "desc": "Prerequisite: Sophomore standing, membership in the honors program of the College of Arts and Sciences, and permission of the instructor.\nIndividual directed research and study of a topic in music, normally as a preliminary to writing a senior honors thesis.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "MUSIC",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Applied Recital",
    "dept": "MUSIC",
    "num": "500",
    "desc": "Prerequisite: MUSIC 255\nPublic performance; vocal or instrumental with suggested performing time of 25 minutes. Intended for performances in addition to required recital performances (MUSIC 502 and/or 501).",
    "credits": "0"
  },
  {
    "course_name": "Half Recital",
    "dept": "MUSIC",
    "num": "501",
    "desc": "\nPublic performance; vocal or instrumental with suggested performing time of 25 minutes.",
    "credits": "0"
  },
  {
    "course_name": "Full Recital",
    "dept": "MUSIC",
    "num": "502",
    "desc": "\nPublic performance; vocal or instrumental with suggested performing time of 50 minutes.",
    "credits": "0"
  },
  {
    "course_name": "A Survey of Music Therapy",
    "dept": "MUSIC",
    "num": "510",
    "desc": "Prerequisite: Junior standing or consent of instructor.\nThis course will provide students with an overview of music therapy: its history, theoretical bases, training requirements, common settings for its use, and general techniques employed. Upon completion of this course, students will have a basic understanding of the music therapy profession, and  have knowledge of music therapy as a viable career option.",
    "credits": "3"
  },
  {
    "course_name": "Music in the Schools K-6",
    "dept": "MUSIC",
    "num": "511",
    "desc": "Prerequisite: Prerequisite of co-enrolled in EDCEP 315, EDSEC 376, EDSP 323.\nThe study of the musical characteristics of children and development of appropriate curriculum, instructional materials and techniques, and related technology for teaching musical understanding, literacy, multi-cultural connections, and creative improvisation in grades K-6 instrumental, vocal, and general music.",
    "credits": "3"
  },
  {
    "course_name": "Music Program in Junior/Senior High Schools",
    "dept": "MUSIC",
    "num": "512",
    "desc": "Prerequisite or concurrent enrollment in EDCEP 315, EDSEC 376, EDSP 323.\nOrganization and administration of the comprehensive music program in junior and senior high schools; including the study of vocal and instrumental ensemble development, as well as techniques, materials and appropriate instructional technologies.",
    "credits": "3"
  },
  {
    "course_name": "Teaching Beginning Band and Jazz Techniques",
    "dept": "MUSIC",
    "num": "513",
    "desc": "\nStudents will learn and employ techniques and strategies for teaching beginning band and beginning through intermediate jazz ensemble.",
    "credits": "1"
  },
  {
    "course_name": "Choral Conducting",
    "dept": "MUSIC",
    "num": "517",
    "desc": "Prerequisite: MUSIC 322, 360, 361, 417.\nContinued mastery of the skills in Conducting I while emphasizing essential techniques and interpretation for choral ensembles.",
    "credits": "2"
  },
  {
    "course_name": "Instrumental Conducting",
    "dept": "MUSIC",
    "num": "518",
    "desc": "Prerequisite: MUSIC 322, 360, 361, 417.\nContinued mastery of the skills in Conducting I while emphasizing essential techniques and interpretation for instrumental ensembles.",
    "credits": "2"
  },
  {
    "course_name": "Upper-Division Composition",
    "dept": "MUSIC",
    "num": "523",
    "desc": "Prerequisite: Submission of a portfolio of pieces for faculty review and approval.\nComposition instruction through individual lessons and group seminar instruction. Emphasis on meeting professional standards of composition and score/part preparation and creation of a varied portfolio of works.",
    "credits": "1-18"
  },
  {
    "course_name": "Instrumentation and Arranging",
    "dept": "MUSIC",
    "num": "525",
    "desc": "Prerequisite: MUSIC 322, 360, 361.\nStudy of writing and arranging for the strings, woodwinds, brass and percussion as well as choral ensembles. Functional ranges and practical applications through score study and projects.",
    "credits": "2"
  },
  {
    "course_name": "Music History I: Ancient Greece through 1700",
    "dept": "MUSIC",
    "num": "530",
    "desc": "Prerequisite: Grade of C or higher in MUSIC 320.\nAn overview of stylistic trends, major composers, repertoire of ancient Greece, the Middle Ages, Renaissance and early Baroque periods.",
    "credits": "3"
  },
  {
    "course_name": "Music History II: 1700 to 1850",
    "dept": "MUSIC",
    "num": "531",
    "desc": "Prerequisite: Grade of C or higher in MUSIC 320.\nAn overview of stylistic trends, major composers, repertoire of the late Baroque, Classical and early Romantic periods.",
    "credits": "3"
  },
  {
    "course_name": "Music History III: 1850 to the Present",
    "dept": "MUSIC",
    "num": "532",
    "desc": "Prerequisite: Grade of C or higher in MUSIC 320.\nAn overview of the development of stylistic and culture trends, major composers, and repertoire of the late Romantic period through the present.",
    "credits": "3"
  },
  {
    "course_name": "Musical Comedy",
    "dept": "MUSIC",
    "num": "570",
    "desc": "\nThe history of operetta and music comedy from Offenbach to the present.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in Music",
    "dept": "MUSIC",
    "num": "599",
    "desc": "Prerequisite: Background of courses needed for studies undertaken.",
    "credits": "1-3"
  },
  {
    "course_name": "Percussion Pedagogy",
    "dept": "MUSIC",
    "num": "603",
    "desc": "\nAdvanced study of percussion instruments and related performance techniques, teaching methods and responsibilities, organization, and literature.",
    "credits": "2-3"
  },
  {
    "course_name": "Upper String Pedagogy",
    "dept": "MUSIC",
    "num": "604",
    "desc": "\nStudy of violin technique and related teaching methods, also applicable to other bowed string instruments.",
    "credits": "2-3"
  },
  {
    "course_name": "Lower String Pedagogy",
    "dept": "MUSIC",
    "num": "605",
    "desc": "\nStudy of low string technique and related teaching methods. Intended for teachers of string, concert/jazz bands and vocal music if they use a bass with accompaniment combos for pit orchestras or swing choirs.",
    "credits": "2"
  },
  {
    "course_name": "Graduate Theory Review",
    "dept": "MUSIC",
    "num": "614",
    "desc": "\nFor graduate students in music for whom additional work in the harmonic and formal aspects of tonal and chromatic music is needed.",
    "credits": "2"
  },
  {
    "course_name": "18th Century Counterpoint",
    "dept": "MUSIC",
    "num": "615",
    "desc": "Prerequisite: MUSIC 322, 360, 361, or consent of instructor.\nContrapuntal compositional techniques from the late baroque to Classical periods, including compositional procedures for the canon and fugue.",
    "credits": "2"
  },
  {
    "course_name": "Theories of Contemporary Music",
    "dept": "MUSIC",
    "num": "616",
    "desc": "Prerequisite: MUSIC 322, 360, 361, or consent of instructor.\nIntroduction to analytical and compositional techniques applicable to the predominately non-tonal music of the 20th and 21st centuries.",
    "credits": "2"
  },
  {
    "course_name": "Graduate History Review",
    "dept": "MUSIC",
    "num": "618",
    "desc": "\nFor graduate students in music for whom additional work in music history is needed based on their performance on the Graduate Music History Entrance Exam.",
    "credits": "2"
  },
  {
    "course_name": "Technology of the Electronic Music Studio",
    "dept": "MUSIC",
    "num": "631",
    "desc": "Prerequisite: MUSIC 521, consent of instructor.\nInstrumentation and systematic procedures as applied to the construction of electronic music. Principles of voltage-controlled systems, synchronous tape machines, and audio mixing. Individual and team projects.",
    "credits": "2"
  },
  {
    "course_name": "Digital Sound Synthesis",
    "dept": "MUSIC",
    "num": "632",
    "desc": "Prerequisite: MUSIC 631.\nExploration of real-time interactive systems. Theory and application pertaining to the creation of instruments and scores using additive and FM techniques. Team projects.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Woodwind Techniques",
    "dept": "MUSIC",
    "num": "636",
    "desc": "\nAdvanced techniques in the teaching of all woodwind instruments for music teachers.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Brass Techniques",
    "dept": "MUSIC",
    "num": "637",
    "desc": "\nAdvanced techniques in the teaching of all brass instruments for music teachers.",
    "credits": "2"
  },
  {
    "course_name": "Concert and Ethnic Percussion Techniques",
    "dept": "MUSIC",
    "num": "638",
    "desc": "\nAdvanced study of percussion performance techniques commonly associated with concert band and percussion ensemble, as well as percussion techniques associated with music of other cultures.",
    "credits": "2-3"
  },
  {
    "course_name": "Jazz and Marching Percussion Techniques",
    "dept": "MUSIC",
    "num": "639",
    "desc": "\nAdvanced study of percussion performance techniques commonly associated with marching percussion and jazz idioms.",
    "credits": "2-3"
  },
  {
    "course_name": "Secondary Performance Area",
    "dept": "MUSIC",
    "num": "641",
    "desc": "\nFor graduate students who wish to study an instrument (or voice) other than the major performance area. Pedagogical methods and fundamentals are stressed.",
    "credits": "1-3"
  },
  {
    "course_name": "History of the Opera",
    "dept": "MUSIC",
    "num": "650",
    "desc": "Prerequisite: MUSIC 201 or MUSIC 250.\nA study of selected masterpieces of musical drama, with emphasis on the relationship of music and drama, and on the unique qualities of opera as a collective artwork.",
    "credits": "3"
  },
  {
    "course_name": "Marching Band Techniques",
    "dept": "MUSIC",
    "num": "660",
    "desc": "Prerequisite: MUSIC 512.\nPhilosophical and practical purposes of the marching band, and the skills necessary to design, organize, instruct, and evaluate a marching band show.",
    "credits": "2"
  },
  {
    "course_name": "Choral Ensemble Techniques",
    "dept": "MUSIC",
    "num": "661",
    "desc": "\nPhilosophical and practical study of the choral ensemble, and the skills necessary to design, organize, instruct and evaluate the choral program.",
    "credits": "2"
  },
  {
    "course_name": "Jazz Techniques",
    "dept": "MUSIC",
    "num": "665",
    "desc": "\nBasic practices found in jazz education, including literature, teaching techniques, and resource materials.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Studies in Music Education",
    "dept": "MUSIC",
    "num": "670",
    "desc": "Prerequisite: EDCEP 315, EDSEC 376, EDSP 323, and prerequisite or concurrent enrollment in MUSIC 511 MUSIC 512.\nAdvanced instructional methods and technologies related to the teaching of music in grades pre-K-12 implemented through investigation of current trends in the field, advanced unit design, and field experiences.",
    "credits": "2"
  },
  {
    "course_name": "Arranging for Bands",
    "dept": "MUSIC",
    "num": "675",
    "desc": "Prerequisite: MUSIC 525.\nAssessing, evaluating, and applying the basic issues, techniques, and possibilities inherent in scoring and arranging for various wind band media. Primary attention will be given to concert and marching bands, but students will also spend time learning about various jazz ensembles and other possible combinations of wind and percussion instruments.",
    "credits": "2"
  },
  {
    "course_name": "Arranging Choral Music",
    "dept": "MUSIC",
    "num": "676",
    "desc": "\nExamination of basic compositional issues. Application of compositional techniques. Scoring and arranging for various choral ensembles.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Instrumental Rehearsal Techniques",
    "dept": "MUSIC",
    "num": "680",
    "desc": "\nExplore, evaluate, and develop the musical understanding and skills necessary in leading instrumental ensembles toward significant musical expression through effective rehearsal techniques.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Choral Rehearsal Techniques",
    "dept": "MUSIC",
    "num": "681",
    "desc": "\nExplore, evaluate, and develop the musical understanding and skills necessary in leading choral ensembles toward significant musical expression through effective rehearsal techniques.",
    "credits": "2"
  },
  {
    "course_name": "Organization and Administration of School Music Programs",
    "dept": "MUSIC",
    "num": "685",
    "desc": "\nProvides models and ideas on organizing program/teaching to enable the teacher and students to succeed and enjoy the music making process. Present strategies and philosophies on dealing with administrators, parents, peers, and students will be discussed, as well as motivation of self and student.",
    "credits": "2"
  },
  {
    "course_name": "Survey of Vocal Solos for Adolescents",
    "dept": "MUSIC",
    "num": "690",
    "desc": "\nAn in-depth study of appropriate solo literature for adolescent singers.",
    "credits": "3"
  },
  {
    "course_name": "Jazz Theory I",
    "dept": "MUSIC",
    "num": "696",
    "desc": "Prerequisite: MUSIC 230 with grade of C or better.\nBasic fundamentals of jazz theory to develop critical thinking and performing skills.",
    "credits": "1"
  },
  {
    "course_name": "Jazz Theory II",
    "dept": "MUSIC",
    "num": "697",
    "desc": "Prerequisite: MUSIC 696, MUSIC 298.\nIntermediate level fundamentals of jazz theory to develop critical thinking and performing skills.",
    "credits": "1"
  },
  {
    "course_name": "Jazz Improvisation I",
    "dept": "MUSIC",
    "num": "698",
    "desc": "Prerequisite: MUSIC 696.\nDevelop skills in the area of jazz improvisation in a performance lab setting.",
    "credits": "1"
  },
  {
    "course_name": "Jazz Improvisation II",
    "dept": "MUSIC",
    "num": "699",
    "desc": "Prerequisite: MUSIC 697 or consent of instructor.\nContinued development of jazz improvisational skills in a performance lab setting.",
    "credits": "1"
  },
  {
    "course_name": "Literature Analysis",
    "dept": "MUSIC",
    "num": "700",
    "desc": "\nExplore, evaluate, and analyze the masterworks of the wind, choral, and orchestral genres.",
    "credits": "3"
  },
  {
    "course_name": "Style Analysis",
    "dept": "MUSIC",
    "num": "702",
    "desc": "\nTraining in a comprehensive, systematic analytical approach to all style periods, and in verbalizing analytical perceptions.",
    "credits": "3"
  },
  {
    "course_name": "Symphonic Literature",
    "dept": "MUSIC",
    "num": "704",
    "desc": "\nThe development of orchestral music from the late Baroque to the present, with emphasis on selected symphonies of the late eighteenth and nineteenth centuries.",
    "credits": "3"
  },
  {
    "course_name": "Chamber Music Literature",
    "dept": "MUSIC",
    "num": "705",
    "desc": "\nA selected survey of masterpieces of small ensemble music from 1750 to the present. Special emphasis on the string quartet.",
    "credits": "3"
  },
  {
    "course_name": "Song Literature",
    "dept": "MUSIC",
    "num": "706",
    "desc": "\nSurvey, by historical period and national styles, of major solo vocal works.",
    "credits": "3"
  },
  {
    "course_name": "History of Wind Bands",
    "dept": "MUSIC",
    "num": "707",
    "desc": "\nDevelopment of the wind band medium from the Renaissance to the present, with focus on the composers and literature.",
    "credits": "3"
  },
  {
    "course_name": "Choral Literature",
    "dept": "MUSIC",
    "num": "708",
    "desc": "\nA study of standard choral masterpieces in both large and small forms from 1450 to the present.",
    "credits": "3"
  },
  {
    "course_name": "History of School Choral Music",
    "dept": "MUSIC",
    "num": "709",
    "desc": "\nDevelopment of choral music in schools with focus on composers and literature.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Orchestration",
    "dept": "MUSIC",
    "num": "714",
    "desc": "Prerequisite: MUSIC 525.\nThe study of orchestra and band scores. Exercises in orchestrating this type of music for different choirs of instruments, as well as scoring for full orchestra and symphonic band.",
    "credits": "2"
  },
  {
    "course_name": "Organ Literature",
    "dept": "MUSIC",
    "num": "737",
    "desc": "\nA survey of significant compositions from the Renaissance to the present with emphasis on performance practice.",
    "credits": "3"
  },
  {
    "course_name": "Piano Literature",
    "dept": "MUSIC",
    "num": "738",
    "desc": "\nSelective survey of music for piano from 1750 to the present.",
    "credits": "3"
  },
  {
    "course_name": "Studies in Music Literature",
    "dept": "MUSIC",
    "num": "740",
    "desc": "\nStudy of the repertory of a selected musical genre or medium of performance.",
    "credits": "3"
  },
  {
    "course_name": "Techniques of Music Technology",
    "dept": "MUSIC",
    "num": "759",
    "desc": "\nStudents develop skills of notation, scanning, manipulating, sequencing, and recording necessary to integrate digital technologies into the practice of music making and teaching.",
    "credits": "2"
  },
  {
    "course_name": "Seminar in the Life and Works of an Individual Composer",
    "dept": "MUSIC",
    "num": "766",
    "desc": "\nStudy of the career and achievements of a selected composer of major stature.",
    "credits": "3"
  },
  {
    "course_name": "Topics in American Music",
    "dept": "MUSIC",
    "num": "767",
    "desc": "\nStudies of the various genres of American music.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Vocal Pedagogy",
    "dept": "MUSIC",
    "num": "791",
    "desc": "\nAdvanced study of vocal production, exploring the scientific principles of breathing, resonance, timbre, and other vocal features. Discussion of vocal health and teaching styles.",
    "credits": "2"
  },
  {
    "course_name": "Problems in Music",
    "dept": "MUSIC",
    "num": "799",
    "desc": "Prerequisite: 6 hours graduate credit in music.\nIndividual guided work in a selected area.",
    "credits": "1-18"
  },
  {
    "course_name": "Reactor Operations Laboratory",
    "dept": "NE",
    "num": "350",
    "desc": "Prerequisite: PHYS 214.\nA basic course in reactor operator licensing, nuclear safety, and reactor operations with structured laboratory exercises.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Engineering Analysis",
    "dept": "NE",
    "num": "415",
    "desc": "Prerequisite: MATH 211 or 221.\nIntroduction to analytical, statistical, and numerical analysis, including computer programming, as applied to engineering.",
    "credits": "3"
  },
  {
    "course_name": "Elements of Nuclear Engineering",
    "dept": "NE",
    "num": "495",
    "desc": "Prerequisite: MATH 221, PHYS 213.\nSurvey of nuclear engineering concepts and applications. Nuclear reactions, radioactivity, radiation interaction with matter, reactor physics, risk and dose assessment, applications in medicine, industry, agriculture, and research.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "NE",
    "num": "497",
    "desc": "\nOpen to students pursuing undergraduate research projects.",
    "credits": "0-3"
  },
  {
    "course_name": "Principles of Radiation Detection",
    "dept": "NE",
    "num": "612",
    "desc": "Prerequisite: NE 495.\nOperating principles and general properties of devices used in the detection and characterization of ionizing radiation. Fundamental methods of data interpretation and presentation.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Nuclear Engineering",
    "dept": "NE",
    "num": "620",
    "desc": "Prerequisite: Consult program director.\nSpecific studies in current and advanced problems in various phases of nuclear engineering.",
    "credits": "1-18"
  },
  {
    "course_name": "Nuclear Reactor Theory",
    "dept": "NE",
    "num": "630",
    "desc": "Prerequisite: MATH 340, NE 495.\nTheory of neutron diffusion and thermalization with application to steady-state nuclear reactors.",
    "credits": "3"
  },
  {
    "course_name": "Generation IV Reactor Design",
    "dept": "NE",
    "num": "635",
    "desc": "Prerequisite: NE 630.\nIntroduction to the complex field of nuclear reactor design, with emphasis on Gen IV reactor technology. Discussion topics include nuclear power cycles, the nuclear fuel cycle, the reactor design process, and reactor safety. The conceptual design of an advanced nuclear reactor based on a candidate Generation IV technology.",
    "credits": "3"
  },
  {
    "course_name": "Nuclear Reactor Thermalhydraulics",
    "dept": "NE",
    "num": "640",
    "desc": "Prerequisite: NE 495\nEngineering principles underlying the design and operation of nuclear power plant components and systems. Fundamentals of nuclear energy generation, heat transport, and single- and two-phase flows.",
    "credits": "3"
  },
  {
    "course_name": "Nuclear Reactor Laboratory",
    "dept": "NE",
    "num": "648",
    "desc": "Prerequisite: NE 612 and NE 630.\nTheory and measurement of nuclear and reactor parameters of fundamental importance to nuclear reactors and their operation.",
    "credits": "3"
  },
  {
    "course_name": "Radiation Protection and Shielding",
    "dept": "NE",
    "num": "690",
    "desc": "Prerequisite: NE 495, PHYS 214, MATH 340.\nBasic concepts of radiation protection, doses, associated risks, and exposure limits. Properties of natural and other radiation sources, and evaluation of internal and external doses. Techniques for shield design including ray, point kernel, and transport theories for both neutrons and gamma rays.",
    "credits": "3"
  },
  {
    "course_name": "Applied Reactor Physics",
    "dept": "NE",
    "num": "730",
    "desc": "Prerequisite: NE 630 and ME 400.\nPrinciples of reactor physics as used in practice.  Topics include the fundamentals of nuclear data processing, pin- and lattice-level analysis for generation of multigroup constants, and full-core models of nuclear reactors based on multigroup diffusion theory. Throughout, students will use commercial-grade software, including CASMO 4 and SIMULATE 3, to complete computational laboratory assignments.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Radiation Measurement Applications",
    "dept": "NE",
    "num": "737",
    "desc": "Prerequisite: NE 612, NE 690.\nThe course will cover physical principles and mathematical modeling of radiation-based measurement systems used in medical and non-medical applications. Topics include measurement principles and inverse methods, radio-gauging, radio-tracing, quantitative analysis methods, imaging with ionizing radiation, and radiation scanning.",
    "credits": "3"
  },
  {
    "course_name": "Nuclear Systems and Design",
    "dept": "NE",
    "num": "740",
    "desc": "Prerequisite: ME 573.\nPrinciples underlying the design and operation of nuclear systems with emphasis on nuclear power reactors. Energy generation and removal in heat transfer fluids, reactor and component control systems and nuclear fuel reloading patterns. Design philosophy of existing, advanced and passively safe nuclear reactors will be covered.",
    "credits": "3"
  },
  {
    "course_name": "Radiation Measurement Systems",
    "dept": "NE",
    "num": "761",
    "desc": "Prerequisite: NE 612.\nPrinciples of systems used to measure radiation. Applications to radiation monitoring, dosimetry, and spectroscopy.",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Nuclear Engineering",
    "dept": "NE",
    "num": "799",
    "desc": "Prerequisite: Consent of program director.\nTopical material of importance in nuclear engineering, such as controlled thermonuclear reactions, numerical analysis, Monte Carlo methods in radiation transport, effects of nuclear explosions, etc.",
    "credits": "1-18"
  },
  {
    "course_name": "Family Financial Planning as a Career",
    "dept": "PFP",
    "num": "100",
    "desc": "\nThis course is an introduction to career opportunities in the field of financial planning for families with an emphasis on academic preparation, acquisition of professional credentials, and career opportunities. A survey of the history, scope, and trends of the financial planning industry will be explored.",
    "credits": "1"
  },
  {
    "course_name": "Money 101",
    "dept": "PFP",
    "num": "101",
    "desc": "\nThis course provides an introduction to resources and tools available to assist students in developing beginning personal finance skills that will assist them throughout their lifetime. Application exercises will allow students to apply personal finance knowledge in solving real-life problems.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Personal Financial Planning",
    "dept": "PFP",
    "num": "105",
    "desc": "\nFundamental principles for making financial decisions. Analysis and evaluation of personal and family money management strategies.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Personal Financial Planning",
    "dept": "PFP",
    "num": "300",
    "desc": "\nRelevant topics in personal financial planning will be explored in a small group setting.",
    "credits": "0-3"
  },
  {
    "course_name": "Advanced Personal Financial Planning",
    "dept": "PFP",
    "num": "305",
    "desc": "Prerequisite: PFP 105 with grade of “B” or better and KSU cumulative GPA of 2.5 or higher.\nIn-depth applications of personal and family money management principles with emphasis on credit, savings, insurance, and budgeting.",
    "credits": "3"
  },
  {
    "course_name": "Family and Consumer Economics",
    "dept": "PFP",
    "num": "310",
    "desc": "Prerequisite: ECON 110 or concurrent enrollment.\nIssues and problems confronting consumers. Emphasis on current economic issues and their potential for impacting families and society.",
    "credits": "3"
  },
  {
    "course_name": "Financial Counseling and Communication",
    "dept": "PFP",
    "num": "456",
    "desc": "Prerequisite: KSU cumulative GPA of 2.5 or higher.\nThis course provides an introduction to the interactive process between the client and the practitioner, including communication techniques, motivation and esteem building, the counseling environment, ethics, and methods of data intake, verification, and analysis. Other topics include legal issues, compensation, uses of technology to identify resources, information management, and current or emerging issues.",
    "credits": "3"
  },
  {
    "course_name": "Retirement Planning Concepts",
    "dept": "PFP",
    "num": "460",
    "desc": "Prerequisite: PFP 305 or FINAN 450 with a grade of “C” or better and KSU cumulative GPA of 2.5 or higher.\nThis course surveys various types of retirement plans, ethical considerations in providing retirement planning services, assessing and forecasting financial needs in retirement, and integration of retirement plans with government benefits.",
    "credits": "3"
  },
  {
    "course_name": "Personal Investment Concepts I",
    "dept": "PFP",
    "num": "462",
    "desc": "Prerequisite: KSU cumulative GPA of 2.5 or higher and FINAN 450 OR corequisite: PFP 305.\nAn in-depth study of investment options for clients, this course will include common stocks, fixed income securities, convertible securities, and related choices. Relationships between investment options and employee/employer benefit plan choice will be studies. Current and emerging issues, and ethics will be an integral part of the course.",
    "credits": "3"
  },
  {
    "course_name": "Estate Planning Concepts",
    "dept": "PFP",
    "num": "464",
    "desc": "Prerequisite: PFP 305 or FINAN 450 with a grade of “C” or better and KSU cumulative GPA of 2.5 or higher.\nThis course provides an introduction to fundamentals of the estate planning process. Includes property transfer, tax consequences, probate avoidance, powers of appointment, and various tools/techniques used in implementing an effective estate plan.",
    "credits": "3"
  },
  {
    "course_name": "Personal Risk Management and Insurance Planning",
    "dept": "PFP",
    "num": "466",
    "desc": "Prerequisite: PFP 305 or FINAN 450 with a grade of “C” or better and KSU cumulative GPA of 2.5 or higher.\nThis course provides an analysis of risk management concepts, tools, and strategies for individuals and families, including: life insurance; property and casualty insurance; liability insurance; accident, disability, health, and long-term care insurance; and government-subsidized programs. Current and emerging issues, as well as ethical considerations, relative to risk management will be discussed. Case studies will provide experience in selecting insurance products suitable for individuals and families.",
    "credits": "3"
  },
  {
    "course_name": "Professional Practice Management in Personal Financial Planning",
    "dept": "PFP",
    "num": "468",
    "desc": "Prerequisite: PFP 305, KSU cumulative GPA of 2.5 or higher.\nIssues and solutions for challenges of managing family financial planning practices.",
    "credits": "1"
  },
  {
    "course_name": "Personal Income Tax Concepts",
    "dept": "PFP",
    "num": "472",
    "desc": "Prerequisite: KSU cumulative GPA of 2.5 or higher.\nThis course provides an introduction to personal income tax practices and procedures including tax regulations, tax return preparation, the tax audit process, the appeals process, preparation for an administrative or judicial forum, and ethical considerations of taxation. New and emerging issues related to taxation will be covered. Family/individual case studies provide practice in applying and analyzing tax information and recommending appropriate tax strategies.",
    "credits": "3"
  },
  {
    "course_name": "Personal Investment Concepts II",
    "dept": "PFP",
    "num": "482",
    "desc": "Prerequisite: PFP 462 and KSU cumulative GPA of 2.5 or higher.\nThis course is designed to build off of PFP 462 (Personal Investment Concepts I) and to help students develop a better understanding of the available tools and procedures of investment planning for family and individual goal attainment. Lectures, reading, case studies, and problem sets are designed to help students in preparing for the Investment Planning section of the Certified Financial Planner™examination.",
    "credits": "3"
  },
  {
    "course_name": "Pre-Internship Orientation in Personal Financial Planning",
    "dept": "PFP",
    "num": "579",
    "desc": "\nConsideration and application of professional knowledge and skills necessary for selection and placement in a financial planning firm for a supervised experience.",
    "credits": "1"
  },
  {
    "course_name": "Internship in Personal Financial Planning",
    "dept": "PFP",
    "num": "580",
    "desc": "Prerequisite: PFP 579.\nInternship experience in personal financial planning or an allied field.",
    "credits": "3"
  },
  {
    "course_name": "Professional Seminar in Personal Financial Planning",
    "dept": "PFP",
    "num": "595",
    "desc": "Prerequisite: PFP 305, PFP 460, PFP 462, PFP 466, KSU cumulative GPA of 2.5 or higher.\nExamination of professional issues in personal financial planning, including ethical considerations, regulation and certification requirements, communication skills, and professional responsibility. Development of skills needed for personal financial planners working with families in meeting their financial needs.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Family Financial Planning",
    "dept": "PFP",
    "num": "624",
    "desc": "\nThis course provides an overview of family financial planning by integrating concepts and issues with planning and counseling applications. Students will be introduced to the key concepts of family financial planning, including: insurance, tax, investments, retirement, and estate planning. The family financial planning process is introduced with an emphasis on the integration and application of concepts in meeting individual and family financial goals and objectives. Other topics presented include an ethics overview, compensation trends within the industry, and regulatory frameworks.",
    "credits": "3"
  },
  {
    "course_name": "Field Study in Family Economics",
    "dept": "PFP",
    "num": "675",
    "desc": "Prerequisite: Consent of instructor.\nSupervised experiences in financial planning, financial counseling, community action, or consumer services.",
    "credits": "1-3"
  },
  {
    "course_name": "Theories and Research in Family Financial Planning I",
    "dept": "PFP",
    "num": "702",
    "desc": "\nIntroduction to the social science of family finances, including theories of family economic functions, microeconomic theory of family resource allocation decisions, the family as an economic unit in the macro-economy, and the interaction of the economy and families.",
    "credits": "3"
  },
  {
    "course_name": "Public Policy and Family Economic Well-Being",
    "dept": "PFP",
    "num": "709",
    "desc": "Prerequisite: Nine hours in FSHS or other social science.\nAnalysis of conceptual models for policy choices. Impact of socioeconmic and public policy factors as family economic well-being including the special issues faced by financially disadvantaged and nontraditional households.",
    "credits": "3"
  },
  {
    "course_name": "Financial Counseling",
    "dept": "PFP",
    "num": "756",
    "desc": "Prerequisite: FSHS 301 and KSU cumulative GPA of 2.5 or higher.\nTheory and research regarding the interactive process between the client and the practitioner, including communication techniques, motivation and esteem building, the counseling environment, ethics, and methods of data intake, verification, and analysis. Other topics include legal issues, compensation, uses of technology to identify resources, information management, and current or emerging issues.",
    "credits": "3"
  },
  {
    "course_name": "Financial Behavior Assessment Consulting",
    "dept": "PFP",
    "num": "757",
    "desc": "\nStudents will learn characteristics, cultural factors, support issues, confidentiality and facilitation of discussions concerning the personal involvement, the family involvement, and the financial professional involvement in financial planning and counseling. The intent is to provide financial planners and counselors a framework for guiding individuals and families in restructuring dysfunctional developmental financial behavior.",
    "credits": "3"
  },
  {
    "course_name": "Housing/Real Estate",
    "dept": "PFP",
    "num": "758",
    "desc": "\nAn overview of the role of housing and real estate in the family financial planning process from a theoretical perspective. Taxation, legal aspects, mortgages, and financial calculations related to home ownership and real estate investments are included. New and emerging issues in the context of housing and real estate will be emphasized. The role of ethics in family financial planning with housing and real estate will also be included.",
    "credits": "3"
  },
  {
    "course_name": "Retirement Planning for Families",
    "dept": "PFP",
    "num": "760",
    "desc": "Prerequisite: FSHS 305 or FINAN 450 with a grade of “B” or better and KSU cumulative GPA of 2.5 or higher.\nStudy of micro and macro considerations for retirement planning. Survey of various types of retirement plans, ethical considerations in providing retirement planning services, assessing and forecasting financial needs in retirement, and integration of retirement plans with government benefits.",
    "credits": "3"
  },
  {
    "course_name": "Investing for the Family’s Future I",
    "dept": "PFP",
    "num": "762",
    "desc": "Prerequisite: FSHS 305 or FINAN 450 with a grade of “B” or better and KSU cumulative GPA of 2.5 or higher.\nAn in-depth study of investment options for clients, this course will include common stocks, fixed income securities, convertible securities, and related choices. Relationships between investment options and employee/employer benefit plan choice will be studied. Current and emerging issues, and ethics will be an integral part of the course.",
    "credits": "3"
  },
  {
    "course_name": "Estate Planning for Families",
    "dept": "PFP",
    "num": "764",
    "desc": "Prerequisite: FSHS 305 or FINAN 450 with a grade of “B” or better and KSU cumulative GPA of 2.5 or higher.\nIntroduction to fundamentals of the estate planning process. Includes property transfer, tax consequences, probate avoidance, powers of appointment, and various tools/techniques used in implementing an effective estate plan.",
    "credits": "3"
  },
  {
    "course_name": "Military Personal Finance",
    "dept": "PFP",
    "num": "765",
    "desc": "\nThis course gives an overview of the topics relevant to the financial planning process. The course adapts the topics to address the unique needs, terminology, benefits, and resources that impact military service members and their families. Topics covered are: status of service member; financial readiness; financial management; recordkeeping; cash flow management; risk management; credit and debt management; savings, education planning, and investment management; tax management; retirement management; estate management; and special topics.",
    "credits": "3"
  },
  {
    "course_name": "Insurance Planning for Families",
    "dept": "PFP",
    "num": "766",
    "desc": "Prerequisite: FSHS 305 or FINAN 450 with a grade of “B” or better and KSU cumulative GPA of 2.5 or higher.\nAn in-depth study of risk management concepts, tools, and strategies for individuals and families, including: life insurance; property and casualty insurance; liability insurance; accident, disability, health, and long-term care insurance; and government-subsidized programs. Current and emerging issues, as well as ethical considerations, relative to risk management will be discussed. Case studies will provide experience in selecting insurance products suitable for individuals and families.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Financial Therapy",
    "dept": "PFP",
    "num": "768",
    "desc": "\nAn applied financial psychology course that examines the intersection of financial planning, coaching, and therapy; the psychology of investing; money disorders frequently seen by financial professionals; advanced techniques to establish rapport; helping clients change problematic/destructive money-related behaviors; dealing with client resistance to change; working with couples and families; and integrating financial psychology tools into personal financial planning.",
    "credits": "3"
  },
  {
    "course_name": "Money and Relationships",
    "dept": "PFP",
    "num": "769",
    "desc": "\nThis course will explore the connection between money and couple and family relationships. The objective of the course is to understand the factors that impact how individuals, couples, and families perceive and manage money. Students will gain in-depth knowledge of current literature, research, and theory in this area. Students will gain personal insight into their own relationship with money and how it impacts their relationships in order to enhance their ability to help and work with others to improve financial well-being.",
    "credits": "3"
  },
  {
    "course_name": "Applied Behavioral Finance",
    "dept": "PFP",
    "num": "770",
    "desc": "\nThis course is applied behavioral finance course that examines the intersection of behavioral finance and financial planning. It reviews the research on behavioral finance, neuroeconomics, and investor psychology; exploring the effects of human emotions and cognitive errors on financial decisions and the financial planning process. This course focuses on the application of behavioral finance theory and research to the practice of personal financial planning to help financial planners improve the financial health of their clients.",
    "credits": "3"
  },
  {
    "course_name": "Financial Therapy Theory & Research",
    "dept": "PFP",
    "num": "771",
    "desc": "\nSurvey of financial therapy and planning literature, conceptual models, and empirical research. Students will be expected to read empirical research related to financial therapy and write a short report on their findings on a weekly basis.",
    "credits": "1-3"
  },
  {
    "course_name": "Personal Income Taxation",
    "dept": "PFP",
    "num": "772",
    "desc": "Prerequisite: KSU cumulative GPA of 2.5 or higher.\nThis course provides in-depth information of income tax practices and procedures including tax regulations, tax return preparation, the tax audit process, the appeals process, preparation for an administrative or judicial forum, and ethical considerations of taxation. New and emerging issues related to taxation will be covered. Family/individual case studies provide practice in applying and analyzing tax information and recommending appropriate tax strategies.",
    "credits": "3"
  },
  {
    "course_name": "Investing for the Family’s Future II",
    "dept": "PFP",
    "num": "782",
    "desc": "Prerequisite: PFP 762.\nThe focus of this course is to develop a better understanding of the available tools and procedures of investment planning for family and individual goal attainment. Lectures, readings, case studies, and problem sets are designed to help students in preparing for the Investment Planning section of the Certified Financial Planner™examination.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Philosophical Problems",
    "dept": "PHILO",
    "num": "100",
    "desc": "\nAn introduction to some of the main problems of philosophy, such as the nature of morality, knowledge, mind and body, political authority, and the existence of God.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Critical Thinking",
    "dept": "PHILO",
    "num": "105",
    "desc": "\nA basic introduction to both deductive and inductive reasoning. Emphasis is placed on constructing, analyzing, and evaluating arguments.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Formal Logic",
    "dept": "PHILO",
    "num": "110",
    "desc": "\nSystematic study of deductive reasoning (and possibly inductive reasoning) using the techniques of modern logic. Examines different types of valid inference, the logical structure of English sentences, and the validity of arguments generally. Involves the development and use of a symbolic system which models logical relations among sentences.",
    "credits": "3"
  },
  {
    "course_name": "Causal and Statistical Reasoning",
    "dept": "PHILO",
    "num": "112",
    "desc": "\nThis course introduces students to some ideas about causation, and also to some elementary tools for thinking both critically and constructively about causal claims. The treatment is broadly formal, and introduces ideas from statistics, computer science, and philosophy, but requires no mathematical background beyond high school algebra. Some sections are taught using web-based course-ware.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Philosophy of Religion",
    "dept": "PHILO",
    "num": "115",
    "desc": "\nArguments pertaining to the existence of God, the nature of religious experience, the problem of evil, the proper relation between reason and faith, and religious diversity.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Philosophy of Art",
    "dept": "PHILO",
    "num": "120",
    "desc": "\nPhilosophical problems concerning the concepts of art and aesthetic value, patterns of reasoning in art appreciation and criticism, and writing histories of art and artistic movements.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Philosophy of Science",
    "dept": "PHILO",
    "num": "125",
    "desc": "\nExamines the nature of science and how it differs from pseudo-sciences such as astrology, and raises questions about the nature of reality and social value of science.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Moral Philosophy",
    "dept": "PHILO",
    "num": "130",
    "desc": "\nPhilosophical issues arising in and about morality, such as the nature of moral judgments, moral knowledge, moral justification, and the relation of morality to religion. Topics might be approached by a study of contemporary moral Problems, by reading of classical texts, or by both methods.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Social and Political Philosophy",
    "dept": "PHILO",
    "num": "135",
    "desc": "\nExamines rival theories of justice and applies them to current debates about economic inequality, gender, race, and sexual orientation. Combines some influential historical texts with contemporary philosophical literature on current political issues.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Philosophy of Mind",
    "dept": "PHILO",
    "num": "140",
    "desc": "\nPhilosophical problems concerning the nature of human beings, including the relation between mind and body, the existence of the soul, the nature of consciousness, the possibility of artificial intelligence, human freedom and personal identity.",
    "credits": "3"
  },
  {
    "course_name": "Historical Introduction to Philosophy",
    "dept": "PHILO",
    "num": "145",
    "desc": "\nIntroduction to philosophy through the study of major thinkers in the history of philosophy, such as Plato, Descartes, Hume. Topics may include the immortality of the soul, the existence of God, skepticism, reasons for being moral.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Philosophy of Feminism",
    "dept": "PHILO",
    "num": "150",
    "desc": "\nPhilosophical examination of issues such as femininity and masculinity, the social conditions of gender equality, multiculturalism and gender, affirmative action, sexual harassment, and welfare policy.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Philosophy of Law",
    "dept": "PHILO",
    "num": "160",
    "desc": "\nExamines fundamental issues concerning the nature and justification of legal institutions. Topics selected from: the nature of law and its relations to morality, criminal justice and punishment, responsibility and liberty, and legal interpretation.",
    "credits": "3"
  },
  {
    "course_name": "Philosophical Composition",
    "dept": "PHILO",
    "num": "175",
    "desc": "Prerequisite: ENGL 100 and open only to freshmen and sophomores.\nThe purpose of this course is to provide students an introduction to philosophy while assisting them to further develop writing skills in preparation for Expository Writing II. Topics covered vary, but typically are related to understanding ourselves and our moral practices.",
    "credits": "4"
  },
  {
    "course_name": "Honors Introduction to Philosophy",
    "dept": "PHILO",
    "num": "215",
    "desc": "\nCentral problems of philosophy, such as skepticism and knowledge, the nature of human minds, freedom, the nature of morality, justice and the existence of God.",
    "credits": "3"
  },
  {
    "course_name": "Honors Introduction to Moral Philosophy",
    "dept": "PHILO",
    "num": "230",
    "desc": "\nPhilosophical issues arising in and about morality. Topics selected from: the nature of moral judgments, moral knowledge, moral justification, and the relation of morality to religion.",
    "credits": "3"
  },
  {
    "course_name": "Honors Introduction to the Humanities I",
    "dept": "PHILO",
    "num": "297",
    "desc": "Prerequisite: Consent of instructor.\nStudy of selected major works of history, literature, and philosophy which have been of central importance in the Western cultural tradition. Considerable emphasis is placed on classroom discussion and writing interpretive essays.",
    "credits": "3"
  },
  {
    "course_name": "Honors Introduction to the Humanities II",
    "dept": "PHILO",
    "num": "298",
    "desc": "Prerequisite: PHILO 297 or consent of instructor.\nContinuation of PHILO 297.",
    "credits": "3"
  },
  {
    "course_name": "History of Ancient Philosophy",
    "dept": "PHILO",
    "num": "300",
    "desc": "Prerequisite: One course in philosophy, major standing, or consent of instructor.\nAncient Greek Philosophy, particularly in the writings of Plato and Aristotle. Pre-Socratic and/or Hellenistic philosophers may be represented as well.",
    "credits": "3"
  },
  {
    "course_name": "History of Philosophy",
    "dept": "PHILO",
    "num": "301",
    "desc": "Prerequisite: One course in philosophy, or major standing, or consent of instructor.\nThis course introduces students to the development of philosophical ideas from ancient Greece to the modern era, and develops skills in the critical interpretation of original texts.",
    "credits": "3"
  },
  {
    "course_name": "Writing Philosophy",
    "dept": "PHILO",
    "num": "303",
    "desc": "\nIntroduction to philosophical composition to develop skills necessary to succinctly explicate single arguments, dialectics relating several arguments, and critical analyses of arguments. Philosophical topics covered vary, but typically are related to understanding ourselves and our moral practices.",
    "credits": "3"
  },
  {
    "course_name": "Reasons, Decisions and Society",
    "dept": "PHILO",
    "num": "305",
    "desc": "Prerequisite: One course in philosophy, major standing, or consent of instructor.\nIntroduction to decision and social choice theory emphasizing theories of utility, equilibria, and aggregation.",
    "credits": "3"
  },
  {
    "course_name": "Symbolic Logic I",
    "dept": "PHILO",
    "num": "320",
    "desc": "\nFirst order logic, covering truth tables and truth functions, and derivations in both propositional and predicate logic.",
    "credits": "3"
  },
  {
    "course_name": "Moral Philosophy",
    "dept": "PHILO",
    "num": "330",
    "desc": "Prerequisite: One course in philosophy, major standing, or consent of instructor.\nAn introduction to ethics, surveying central issues in normative ethical theory with an emphasis on consequentialism, virtue theory, and deontology.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Gender",
    "dept": "PHILO",
    "num": "331",
    "desc": "Prerequisite: One philosophy course or consent of instructor.\nThe concept of gender and its effects in the world, including the metaphysical nature of gender, the potentially gendered nature of many areas of “traditional” philosophy, the nature of structural injustice, and the way in which gender influences life choices in areas such as career, family life, and sexuality.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Sex and Love",
    "dept": "PHILO",
    "num": "332",
    "desc": "Prerequisite: One philosophy course or consent of instructor.\nEngages philosophical issues pertaining to intimate human relationships, including the concept of love, the ethics of sexuality, and the role of biology and culture in shaping our intimate lives.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Social and Political Philosophy",
    "dept": "PHILO",
    "num": "335",
    "desc": "Prerequisite: One course in philosophy, major standing, or consent of instructor.\nIntroduction to modern social and political philosophy, examining questions about central political values, such as equal citizenship, property rights, distributive justice, fairness, and democratic social and political institutions.",
    "credits": "3"
  },
  {
    "course_name": "Global Justice",
    "dept": "PHILO",
    "num": "336",
    "desc": "Prerequisite: One philosophy course or consent of instructor.\nAddresses philosophical and ethical issues of global and international justice, including responsibility to help the poor, human rights, cosmopolitanism and global equality, the moral dimensions of immigration, just war, global health, and responsibility for combatting climate change.",
    "credits": "3"
  },
  {
    "course_name": "Religious Freedom and Democracy",
    "dept": "PHILO",
    "num": "337",
    "desc": "Prerequisite: One philosophy course or consent of instructor.\nReligious freedom and religious toleration. Consider this topic in a variety of contexts, including Western democracies and Muslim majority states.",
    "credits": "3"
  },
  {
    "course_name": "Justification and Reliable Knowledge",
    "dept": "PHILO",
    "num": "340",
    "desc": "Prerequisite: One philosophy course, major standing, or consent of instructor.\nThis course offers an introduction to epistemology, surveying the historical development of important theories of knowledge, alternative conceptions of justification, and differing ideas about evidence and reliable inference.",
    "credits": "3"
  },
  {
    "course_name": "Worlds, Things and Properties",
    "dept": "PHILO",
    "num": "345",
    "desc": "Prerequisite: One course in philosophy, major standing, or consent of instructor.\nIntroduction to metaphysics, surveying the historical development of different metaphysical theories, including alternative conceptions of causation and of identity through time, and alternative theories about the relationship between physical and non-physical (e.g. mental) properties.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Continental Philosophy",
    "dept": "PHILO",
    "num": "360",
    "desc": "\nA study of selected figures (such as Kierkegaard, Fichte, Marx, Nietzsche, Beauvoir, Hegel, Schopenhauer, Sartre, Heideggar, Husserl, Wittgenstein, Gadamer, Ricoeur, Foucault, Lacan), or movements (such as Transcendental Idealism, Existentialism, Marxism, Phenomenology, Post-Modernism), or issues in continental philosophy (such as humanity’s relation to God, free will, the state, irrationalism, gender, philosophical methodology).",
    "credits": "3"
  },
  {
    "course_name": "Medical Ethics",
    "dept": "PHILO",
    "num": "365",
    "desc": "\nSelected moral issues which confront the medical professional, including experimentation on human subjects, informed consent, abortion, euthanasia, conflict of interest, and confidentiality.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy and Race",
    "dept": "PHILO",
    "num": "380",
    "desc": "\nThe concept of race and racial identity, and contemporary controversies about the nature of racism and social justice, examined through fiction, movies, and readings in biology, anthropology, history, and philosophy.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Ethics",
    "dept": "PHILO",
    "num": "385",
    "desc": "\nAn examination of the principles of ethics as applied to cases arising in the practice of the various branches of engineering.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Computer Science and Software Engineering",
    "dept": "PHILO",
    "num": "386",
    "desc": "\nExplores conceptual, ethical, and practical questions about computers and software including the nature of computer science, digital rights, special and general AI, and the ethical responsibilities of software engineers.",
    "credits": "3"
  },
  {
    "course_name": "Business Ethics",
    "dept": "PHILO",
    "num": "390",
    "desc": "\nAn examination of the principles of ethics as applied to situations and practices in modern American business.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Philosophy",
    "dept": "PHILO",
    "num": "399",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Computers and Society",
    "dept": "PHILO",
    "num": "492",
    "desc": "Prerequisite: Junior standing plus concurrent enrollment in CIS 415; CIS 520.\nA study of ethical issues raised by the impact of computers and associated technologies on society, including such topics as ethics of computer use, computer fraud, protection of privacy; legal, moral, and public policy-making responsibilities of computer professionals.",
    "credits": "1-2"
  },
  {
    "course_name": "Honors Project",
    "dept": "PHILO",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Perspectives on Science",
    "dept": "PHILO",
    "num": "501",
    "desc": "\nProvides historical, philosophical, and sociological perspectives on science, its methods and products, the social processes by which its methods are deployed and its products used, and the ways in which its results become imbued with cultural meaning.",
    "credits": "3"
  },
  {
    "course_name": "Symbolic Logic II",
    "dept": "PHILO",
    "num": "510",
    "desc": "Prerequisite: PHILO 220 or PHILO 110.\nAn advanced study of logical systems and problems in logical theory.",
    "credits": "3"
  },
  {
    "course_name": "Social-Political Philosophy",
    "dept": "PHILO",
    "num": "525",
    "desc": "Prerequisite: PHILO 305, or PHILO 330, or PHILO 335 or consent of instructor.\nExamines key developments in contemporary political philosophy in such areas as liberalism, libertarianism, communitarianism, Marxism, and feminism, and on topics of special interest where these theories are applied.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Law",
    "dept": "PHILO",
    "num": "535",
    "desc": "Prerequisite: One course in philosophy (PHILO 135, PHILO 160, or PHILO 330 recommended), or consent of instructor.\nPhilosophical issues arising in the legal context, such as the nature of legal reasoning, the nature and scope of constitutional protections, the justification of punishment, affirmative action, and civil disobedience.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Social Sciences",
    "dept": "PHILO",
    "num": "550",
    "desc": "Prerequisite: Two courses in philosophy, one of which must be PHILO 100 or 320.\nEpistemic methods and metaphysical presuppositions in the social sciences. Topics selected from: models, measurement, reduction, explanation, theories of function, theories of ideal types, and rational choice theory.",
    "credits": "3"
  },
  {
    "course_name": "Aesthetics",
    "dept": "PHILO",
    "num": "570",
    "desc": "Prerequisite: One course in philosophy or consent of instructor.\nA study of selected topics in aesthetics and the philosophy of art.",
    "credits": "3"
  },
  {
    "course_name": "Ethics",
    "dept": "PHILO",
    "num": "585",
    "desc": "Prerequisite: PHILO 330.\nExamines key developments in moral philosophy. May focus on issues in metaethics, ethical theory, or history of ethics.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Philosophy",
    "dept": "PHILO",
    "num": "590",
    "desc": "Prerequisite: One course in philosophy.\nA study of selected topics in applied ethics, applied philosophy, or the continental tradition.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Ethics",
    "dept": "PHILO",
    "num": "595",
    "desc": "Prerequisite: One course in philosophy (PHILO 330 recommended), or consent of instructor.\nEthical issues that arise from the use and exploitation of the environment, such as the value of biodiversity, obligations to future generations, obligations to non-humans, and the ethics of environmental risk management.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Issues in the History of Philosophy",
    "dept": "PHILO",
    "num": "601",
    "desc": "Prerequisite: Two courses in philosophy and consent of instructor. Depending on topic, PHILO 300 or 301 required.\nParticular sets of issues in the history of philosophy or in-depth examination of the thought of a particular philosopher. Emphasis on issues in metaphysics and epistemology.",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Logic",
    "dept": "PHILO",
    "num": "610",
    "desc": "Prerequisite: PHILO 110 or PHILO 320, or consent of instructor.\nExamination of one or more advanced topics in mathematical or philosophical logic, such as: modal, temporal, and epistemic logics; counterfactuals; intuitionistic and other sub-classical logics; higher-order and other super-classical logics; formal semantics of natural language; or theories of truth.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Religion",
    "dept": "PHILO",
    "num": "615",
    "desc": "Prerequisite: Two courses in philosophy. PHILO 305, 320, or 340 recommended.\nConcepts of religion, including truth and faith, God and atheism, reason and revelation, morality and religion, evil, humanity, sin, salvation, eschatology.",
    "credits": "3"
  },
  {
    "course_name": "The Development of Analytical Philosophy",
    "dept": "PHILO",
    "num": "620",
    "desc": "Prerequisite: Two courses in philosophy, one of which must be PHILO 110 or 320.\nThe history of analytic philosophy from 1870 to 1960, examining the works of most of the following philosophers: Frege, Russell, Wittgenstein, Moore, the logical positivists, and Quine.",
    "credits": "3"
  },
  {
    "course_name": "The Philosophy of Language",
    "dept": "PHILO",
    "num": "625",
    "desc": "Prerequisite: Two courses in philosophy, one of which must be PHILO 110 or 320.\nPhilosophical problems concerning the nature of language and such concepts as meaning and truth.",
    "credits": "3"
  },
  {
    "course_name": "Metaphysics",
    "dept": "PHILO",
    "num": "635",
    "desc": "Prerequisite: Two courses in philosophy. PHILO 305, 320, or 340 recommended.\nA critical examination of theories about objects and their qualities, causality, space, and time. Both traditional and contemporary sources may be used, but emphasis will be placed on the latter.",
    "credits": "3"
  },
  {
    "course_name": "Epistemology",
    "dept": "PHILO",
    "num": "640",
    "desc": "Prerequisite: Two courses in philosophy. PHILO 305, 320, or 340 recommended.\nPhilosophical issues relating to human knowledge. Issues selected from: the difference between knowledge and belief, whether knowledge is really attainable, whether we have epistemic duties and what they might be, what counts as justification for belief. Special topics may include self-knowledge, a prior knowledge, inductive knowledge, and naturalism.",
    "credits": "3"
  },
  {
    "course_name": "The Philosophy of Science",
    "dept": "PHILO",
    "num": "645",
    "desc": "Prerequisite: Two courses in philosophy, one of which must be PHILO 110 or 320.\nPhilosophical problems concerning science, its methods. Topics selected from: qualitative and quantitative confirmation theories and the nature of scientific theories, laws, and explanation in the physical and biological sciences.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Physics",
    "dept": "PHILO",
    "num": "646",
    "desc": "Prerequisite: Two courses in philosophy.\nThis course offers an exploration of the conceptual foundations of modern physics, including topics from relativistic space-time theories, quantum mechanics and gauge theories, and related topics in the philosophy of science, including the nature of physical laws, reduction, the measurement problem and non-locality.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Biology",
    "dept": "PHILO",
    "num": "647",
    "desc": "Prerequisite: Two courses in philosophy.\nThis course will introduce a range of topics in the philosophy of biology, including: the conceptual foundations of evolutionary theory, interpretations of fitness and selection, group selection, definitions of species, epistemological problems in phylogenetic inference, design arguments, explanation in biological sciences and reliable modeling in ecology and evolutionary biology.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy and the Origins of Ancient Science",
    "dept": "PHILO",
    "num": "648",
    "desc": "Prerequisite: Two courses in philosophy.\nExamination of the development of ancient science, with special attention paid to the interrelationship in antiquity of philosophical and scientific accounts of the world. Topics will include developments in mathematics, optics, astronomy, mechanics, and medicine, among others.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy and the Origins of Modern Science",
    "dept": "PHILO",
    "num": "649",
    "desc": "Prerequisite: Two courses in philosophy or four natural science courses, with at least two of them in physics.\nExamination of the development of modern science from roughly the 16th century, with special attention paid to the interrelationship in early modern philosophical and scientific accounts of the world. Topics will include developments in physics, astronomy, biology, mathematics, and medicine, as well as related areas of metaphysics, epistemology, and philosophy of religion.",
    "credits": "3"
  },
  {
    "course_name": "Rationality and Action",
    "dept": "PHILO",
    "num": "650",
    "desc": "Prerequisite: Two courses in philosophy.\nPhilosophical issues connected with human action and reasons for action, such as the existence of objective reasons to act one way rather than another, the existence of reasons to act that do not stem from desires, the difference between reasoning about how to act and reasoning about what is true, the nature of intention and desire and their specific roles in action.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Mind",
    "dept": "PHILO",
    "num": "655",
    "desc": "Prerequisite: Two courses in philosophy. PHILO 305, 320 or 340 recommended.\nA philosophical examination of major theories about the nature of the mind, mental causation, consciousness, intentionality, cognition and psychological explanation.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Ethics",
    "dept": "PHILO",
    "num": "660",
    "desc": "Prerequisite: PHILO 330 and one other philosophy course.\nSelected topics in contemporary ethical theory.",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Economics",
    "dept": "PHILO",
    "num": "665",
    "desc": "Prerequisite: Two courses in philosophy.\nMoral and conceptual foundations of modern economic systems. Topics selected from: the relations between “economics rationality” and the quality of life, the just distribution of wealth, the nature of property rights, and the value of technology in society.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Social-Political Philosophy",
    "dept": "PHILO",
    "num": "670",
    "desc": "Prerequisite: PHILO 525 and one other philosophy course.\nA study of a single topic in contemporary philosophical literature, with application to current political issues. Topic selected from: multiculturalism, minority rights, nationalism, justification of democracy.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Philosophy of Law",
    "dept": "PHILO",
    "num": "675",
    "desc": "Prerequisite: PHILO 535 and one other philosophy course.\nA current issue in analytical jurisprudence (such as the nature of law, the relation between law and morality, the proper standards for constitutional interpretation) or normative jurisprudence (such as basis for tort liability, whether and when strict criminal liability is justified, the rights of criminals).",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Philosophy",
    "dept": "PHILO",
    "num": "680",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Current Topics in Metaphysics and Epistemology",
    "dept": "PHILO",
    "num": "685",
    "desc": "Prerequisite: PHILO 340 and two additional philosophy courses.\nSelected philosophical issues of current interest in analytic metaphysics and epistemology.",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Philosophy",
    "dept": "PHILO",
    "num": "690",
    "desc": "Prerequisite: PHILO 320 and additional background courses required for topic.\nSelected topics in metaphysics, epistemology, philosophy of science, philosophy of language, or philosophy of mind.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Metalogic",
    "dept": "PHILO",
    "num": "701",
    "desc": "Prerequisite: PHILO 510 or MATH 511.\nSelected topics in the analysis of first-order theories and the foundations of mathematics.",
    "credits": "3"
  },
  {
    "course_name": "Colloquium in Physics",
    "dept": "PHYS",
    "num": "017",
    "desc": "\nWeekly lectures on topics of current interest in physics by faculty and visiting scientists.",
    "credits": "0"
  },
  {
    "course_name": "The Physical World",
    "dept": "PHYS",
    "num": "101",
    "desc": "\nPresents an overview of physics for students who have little or no physics background. The Physical World is principally classical physics with some discussion of modern physics. The observations and phenomena are simple and basic.",
    "credits": "3"
  },
  {
    "course_name": "Current Topics in the Physical World",
    "dept": "PHYS",
    "num": "102",
    "desc": "Prerequisite: PHYS 101, PHYS 113, PHYS 115, PHYS 213, PHYS 223, or consent of the instructor.\nMay include nuclear physics, atomic theory, quantum mechanics, chemistry, geology, molecular biology, astronomy, and other topics of current interest.",
    "credits": "3"
  },
  {
    "course_name": "The Physical World Laboratory",
    "dept": "PHYS",
    "num": "103",
    "desc": "Prerequisite: PHYS 101 or concurrent enrollment in PHYS 101.\nThis laboratory is designed to introduce students to the scientific method with an emphasis on basic physics experiments in mechanics, thermal physics, electricity and magnetism.",
    "credits": "1"
  },
  {
    "course_name": "Concepts of Physics",
    "dept": "PHYS",
    "num": "106",
    "desc": "\nAn introductory course in physics which emphasizes the topics of physics normally presented to elementary school children. A qualitative approach with integrated laboratory, this course is recommended for students preparing for careers as elementary school teachers.",
    "credits": "4"
  },
  {
    "course_name": "General Physics I",
    "dept": "PHYS",
    "num": "113",
    "desc": "Prerequisite: MATH 150 or one and one-half units of high school algebra and one unit high school trigonometry.\nA basic development of the principles of mechanics, heat, fluids, oscillations, waves and sound.  Emphasis is on conceptual development and numerical problem solving.",
    "credits": "4"
  },
  {
    "course_name": "General Physics II",
    "dept": "PHYS",
    "num": "114",
    "desc": "Prerequisite: PHYS 113.\nThe continued treatment of the fundamentals of electricity and magnetism, light and optics, atomic and nuclear physics.  These concepts are used to understand D.C. and A.C. circuits, motors, and generators.  Emphasis is placed on conceptual development and problem solving.",
    "credits": "4"
  },
  {
    "course_name": "Descriptive Physics",
    "dept": "PHYS",
    "num": "115",
    "desc": "Prerequisite: High school algebra.\nCovers mechanics, electricity, heat, light, sound, and atomic theory. Surveys of the major fields of physics concentrating on how physicists work to understand and describe physical phenomena.",
    "credits": "5"
  },
  {
    "course_name": "Physics Today I",
    "dept": "PHYS",
    "num": "122",
    "desc": "Prerequisite: Physics major or permission of instructor.\nThe first of a two-semester study of problem solving in physics. Introductory physics problems as well as problems encountered in research will be discussed. Introductory problems will focus on mechanics and thermodynamics. Research discussions will center on topics of current interest at K-State and elsewhere.",
    "credits": "1"
  },
  {
    "course_name": "Physics Today II",
    "dept": "PHYS",
    "num": "123",
    "desc": "Prerequisite: PHYS 122 and physics major or permission of instructor.\nSecond of a two-semester study of problem solving in physics. Introductory physics problems as well as problems encountered in research will be discussed. Introductory problems will focus on electricity, magnetism, and optics. Research discussions will center on topics of current interest at K-State and elsewhere.",
    "credits": "1"
  },
  {
    "course_name": "Descriptive Astronomy",
    "dept": "PHYS",
    "num": "191",
    "desc": "\nA qualitative study of the earth, sun, planets, stars, galaxies and the universe; a survey of what is known about the universe and how we know it.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Physics I",
    "dept": "PHYS",
    "num": "213",
    "desc": "Prerequisite or concurrent: MATH 221.\nMechanics and heat; for students of science and engineering.",
    "credits": "5"
  },
  {
    "course_name": "Engineering Physics II",
    "dept": "PHYS",
    "num": "214",
    "desc": "Prerequisite: PHYS 213, MATH 221.\nSound, electricity, magnetism, light, and modern physics; for students of science and engineering.",
    "credits": "5"
  },
  {
    "course_name": "Physics I, Mechanics, and Thermodynamics",
    "dept": "PHYS",
    "num": "223",
    "desc": "Prerequisite: Concurrent enrollment in PHYS 122 or permission of lecturer required, MATH 220 or concurrent enrollment.\nFor physics majors. Lecture and quiz in common with PHYS 213. Special studio.",
    "credits": "5"
  },
  {
    "course_name": "Physics II, Electromagnetism, and Sound",
    "dept": "PHYS",
    "num": "224",
    "desc": "Prerequisite: Concurrent enrollment in PHYS 123 or permission of lecturer required, PHYS 223, MATH 221 or concurrent enrollment.\nFor physics majors. Lecture and quiz in common with PHYS 214. Special studio.",
    "credits": "5"
  },
  {
    "course_name": "Physics in Relation to Other Disciplines",
    "dept": "PHYS",
    "num": "300",
    "desc": "Prerequisite: Consent of instructor.\nVariable content, offered only by prearrangement with the physics department and with the instructor. A brief syllabus will be available for each offering of PHYS 300 outlining the objectives and organization of the course for the semester in which offered.",
    "credits": "1-3"
  },
  {
    "course_name": "Physics III, Relativity, and Quantum Physics",
    "dept": "PHYS",
    "num": "325",
    "desc": "Prerequisite: PHYS 224 or 214; MATH 222 or concurrent; and a working knowledge of spreadsheets and use of computers as data analysis tools.\nAn introduction to modern physics as exemplified by atomic, nuclear, condensed matter, and particle phenomena.",
    "credits": "4"
  },
  {
    "course_name": "Physics Honors Seminar",
    "dept": "PHYS",
    "num": "399",
    "desc": "\nDiscussions of topics of current interest in physics.",
    "credits": "1-3"
  },
  {
    "course_name": "Independent Study in Physics",
    "dept": "PHYS",
    "num": "400",
    "desc": "Prerequisite: Junior standing and consent of instructor.\nIndependent theoretical or experimental investigation of a topic for physics majors or for a senior honors thesis.",
    "credits": "1-3"
  },
  {
    "course_name": "Principles of Contemporary Physics",
    "dept": "PHYS",
    "num": "451",
    "desc": "Prerequisite: PHYS 101 or equivalent.\nA non mathematical introduction to twentieth century physics: relativity, quantum mechanics, the physics of solids, and fundamental particles.",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Physics: Problems and Principles",
    "dept": "PHYS",
    "num": "452",
    "desc": "Prerequisite: One year of college physics (PHYS 113 and 114 or equivalent), college algebra, and trigonometry.\nAn introduction to twentieth century physics; relativity, quantum mechanics, the physics of solids, and fundamental particles. The lectures are in common with PHYS 451.",
    "credits": "4"
  },
  {
    "course_name": "Undergraduate Topics in Physics",
    "dept": "PHYS",
    "num": "460",
    "desc": "Prerequisite: PHYS 114 or equivalent.\nSpecial topics in physics not completely treated in other courses.",
    "credits": "1-6"
  },
  {
    "course_name": "Astronomy",
    "dept": "PHYS",
    "num": "495",
    "desc": "Prerequisite: PHYS 191.\nTopics in modern astronomy. Use of a telescope for observational astronomy will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Senior Research in Physics",
    "dept": "PHYS",
    "num": "497",
    "desc": "Prerequisite: Senior in physics and permission of instructor.\nIndividually directed research in atomic physics, condensed matter, particle physics or physics education.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Tutorial in Physics",
    "dept": "PHYS",
    "num": "498",
    "desc": "\nIndividually directed research in physics, normally taken as a preparation for writing an honors thesis.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "PHYS",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Physics Laboratory",
    "dept": "PHYS",
    "num": "506",
    "desc": "Prerequisite: PHYS 325.\nThe completion of experiments of current and/or historical interest in contemporary physics. Students develop skills in and knowledge of measurement techniques using digital and analog instruments. Various data analysis techniques are used.",
    "credits": "4"
  },
  {
    "course_name": "Physics for Science Teachers",
    "dept": "PHYS",
    "num": "515",
    "desc": "Prerequisite: One year of college physics.\nStudy of current topics in physics, with laboratory experience and demonstration of the processes or phenomena under consideration. Topics and activities will be directed toward providing teachers with material for demonstrations and student experiments or projects. Examples of topics are: solar power, laser applications, holography, and subnuclear particles, relativity, or the historical development of some physical concept.",
    "credits": "1-4"
  },
  {
    "course_name": "Mechanics",
    "dept": "PHYS",
    "num": "522",
    "desc": "Prerequisite: PHYS 224.\nPrinciples of statistics and dynamics of systems of particles and rigid bodies. Topics include Newton’s laws for one particle, non-inertial reference frames, central forces, system of particles, rigid body statics and motion in a plane and in three dimensions, Lagrangian mechanics and Hamilton’s equations, oscillating systems and normal coordinates.",
    "credits": "4"
  },
  {
    "course_name": "Electromagnetic Fields I",
    "dept": "PHYS",
    "num": "532",
    "desc": "Prerequisite: PHYS 224 and MATH 240.\nAn introduction to electricity and magnetism. The first of a two semester study of Maxwell’s equations in both integral and differential forms. Topics include electrostatics with vector calculus; electrostatic potential solutions in rectangular, cylindrical, and spherical coordinates; dielectrics; electrostatic energy and capacitance; magnetostatics with vector calculus; Biot-Savart law; vector and scalar potentials for magnetism; magnetic permeability; Faraday’s law in integral and differential form; magnetic energy and inductance; displacement current; lumped oscillations and LCR systems; impedance.",
    "credits": "4"
  },
  {
    "course_name": "Teaching University Physics",
    "dept": "PHYS",
    "num": "620",
    "desc": "Prerequisite: PHYS 325.\nA discussion of techniques which will aid in the development of understanding the concepts in physics. Emphasis is placed on models of learning and teaching techniques which can be applied to the teaching of contemporary physics to university students. These models and techniques are used to analyze a teaching approach of topics, such as quantum mechanics, which is important to today’s physicist.",
    "credits": "3"
  },
  {
    "course_name": "Electromagnetic Fields II",
    "dept": "PHYS",
    "num": "633",
    "desc": "Prerequisite: PHYS 532.\nSecond of a two semester study of Maxwell’s equations in both integral and differential forms. Special relativity; Lorentz transformations; relativistic invariants; transformation properties of electric and magnetic fields and potentials; Lorentz force and electrodynamics; electromagnetic fields of a point charge; electromagnetic waves; solutions to the wave equation in rectangular, cylindrical, and spherical geometries; wave propagation in matter; reflection, refraction, and transmission; wave guides and fiber optics; Fresnel equations; polarization; dipole radiation.",
    "credits": "3"
  },
  {
    "course_name": "Physical Measurements Instrumentation",
    "dept": "PHYS",
    "num": "636",
    "desc": "Prerequisite: PHYS 214 or 224.\nA laboratory-oriented course to acquaint students with electronic circuits, their interfacing with measuring instruments, and their use in making physical measurements.",
    "credits": "4"
  },
  {
    "course_name": "Computations in Physics",
    "dept": "PHYS",
    "num": "639",
    "desc": "Prerequisite: PHYS 532.\nAn introduction to applying computational and numerical techniques to solve problems of interest to physicists. Topics include the application of computational analysis and solution to physical problems in both classical, and quantum physics including particle structure and motion, interaction of particles with fields, and model building for simulation of physical phenomena. A practicum is an integral part of the course. Students will use both personal computers and advanced workstations.",
    "credits": "3"
  },
  {
    "course_name": "Nuclear Physics",
    "dept": "PHYS",
    "num": "642",
    "desc": "Prerequisite: PHYS 662.\nAn introduction to the structure of the nucleus, radioactivity, and nuclear energy; the application of quantum mechanics to describe nuclear physics.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Optics",
    "dept": "PHYS",
    "num": "651",
    "desc": "Prerequisite: PHYS 214.\nIntroduction to modern concepts in optics: electromagnetic waves, propagation of light through media, geometrical optics of lenses, mirrors and simple optical instruments, polarization, interference, coherence, and diffractions.",
    "credits": "4"
  },
  {
    "course_name": "Applied Optics and Optical Measurement",
    "dept": "PHYS",
    "num": "652",
    "desc": "Prerequisite: PHYS 651.\nTopical approach oriented toward measurements including coherence, Fourier Optics, holography, light scattering, interferometry, laser technology.",
    "credits": "3"
  },
  {
    "course_name": "Physics of Solids",
    "dept": "PHYS",
    "num": "655",
    "desc": "Prerequisite: PHYS 662.\nAn introduction to the physics of solids with an emphasis on energy band structures, electrical and optical properties of solids and solid state devices.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Quantum Mechanics",
    "dept": "PHYS",
    "num": "662",
    "desc": "Prerequisite: PHYS 325, 522.\nConcepts and mathematical models of quantum physics. Solutions to the time independent Schrödinger equation, descriptions of one-electron and multi-electron atoms, electron spin and magnetic moments.",
    "credits": "4"
  },
  {
    "course_name": "Thermodynamics and Statistical Physics",
    "dept": "PHYS",
    "num": "664",
    "desc": "Prerequisite: PHYS 522; MATH 240.\nAn introduction to thermodynamics developed from the concepts of statistical physics. Applications include the gas laws, concepts of heat and work, phase transitions, and kinetic theory with applications to statistical physics.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Astrophysics",
    "dept": "PHYS",
    "num": "691",
    "desc": "Prerequisite: PHYS 325, 522, 532.\nAn introduction to the application of physical principles to understanding astronomical objects. Topics include properties of stars, stellar evolution, galaxies, and cosmology.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Cosmology",
    "dept": "PHYS",
    "num": "692",
    "desc": "Prerequisite: PHYS 522.\nAn introduction to the physics and astrophysics of the hot big bang model to the Universe.",
    "credits": "3"
  },
  {
    "course_name": "Particle Physics",
    "dept": "PHYS",
    "num": "694",
    "desc": "Prerequisite: PHYS 325.\nAn experimental and phenomenological introduction to high energy physics. The course will emphasize understanding the experimental basis of what is known about the subnuclear domain. Students will be asked to design simple conceptual experiments in addition to solving problems.",
    "credits": "3"
  },
  {
    "course_name": "Cosmology",
    "dept": "PHYS",
    "num": "701",
    "desc": "Prerequisite: PHYS 692.\nA general-relativity-based discussion of the physics of the hot big bang model of the Universe.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Physics",
    "dept": "PHYS",
    "num": "707",
    "desc": "Prerequisite: Graduate standing or senior standing and consent of instructor.\nSpecial topics courses. Topics and credits announced for the semester in which offered. May be given in conjunction with lecture series by visiting scientists.",
    "credits": "1-18"
  },
  {
    "course_name": "Applied Quantum Mechanics",
    "dept": "PHYS",
    "num": "709",
    "desc": "Prerequisite: PHYS 662.\nA study of Schrödinger’s theory of quantum mechanics and its application to one electron atoms, multielectron atoms, quantum statistics, spectra of molecules and selected topics in quantum excitations of solids, nuclear physics, and elementary particles.",
    "credits": "3"
  },
  {
    "course_name": "The Physics of Lasers",
    "dept": "PHYS",
    "num": "741",
    "desc": "Prerequisite: PHYS 651 and PHYS 652.\nThe theory of lasers including Light-matter interactions, atomic rate equations, threshold and oscillation; resonators and cavity modes; and laser dynamics including Q-switching and mode-locking.",
    "credits": "3"
  },
  {
    "course_name": "Biological Physics",
    "dept": "PHYS",
    "num": "775",
    "desc": "Prerequisite: PHYS 664.\nThis lecture course introduces basic cellular biology for students lacking a biological background and established connections between molecular and cellular phenomena (such as photosynthesis, cellular foraging, and nerve stimulation) and experimentally verifiable models built from physical (classical, statistical, and quantum mechanical, as well as electromagnetic) considerations.",
    "credits": "3"
  },
  {
    "course_name": "Planning Field Trip",
    "dept": "PLAN",
    "num": "010",
    "desc": "\nField trip requirement: each spring students will be required to participate in a 4- to 5-day field trip.",
    "credits": "0"
  },
  {
    "course_name": "World Cities",
    "dept": "PLAN",
    "num": "215",
    "desc": "\nThis course introduces undergraduates from a variety of disciplines to some of the major urban areas in the world, how and why they developed, what makes them unique, what it might be like to live there, and what issues they may face in achieving a sustainable future. This course gives students a way of thinking about cities in a global context that highlights both their differences and their similarities. Through lectures, text and other multi-media formats, students explore some of the main opportunities and challenges facing the inhabitants of large cities in today’s world.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to City Planning",
    "dept": "PLAN",
    "num": "315",
    "desc": "\nThe origins and evolution of planning in response to economic, social, political, physical, and environmental issues. The planning process and its relationship to the design professions and the social and behavioral sciences.",
    "credits": "3"
  },
  {
    "course_name": "Planning Principles Seminar",
    "dept": "PLAN",
    "num": "316",
    "desc": "Corequisite: PLAN 315, admission to the Regional and Community Planning program.\nDiscussion of the principles and process of regional and community planning as practiced by the profession. The tools, skills and knowledge of the planning professions are presented in a focused introduction to the profession.",
    "credits": "2"
  },
  {
    "course_name": "Career Planning Seminar",
    "dept": "PLAN",
    "num": "444",
    "desc": "Prerequisite: PLAN 315, PLAN 316.\nExploration and preparation for a planning internship.",
    "credits": "1"
  },
  {
    "course_name": "Tech Module",
    "dept": "PLAN",
    "num": "510",
    "desc": "Corequisite: LAR 420.\nIntroductory theory, methods, and application of technological skills and support of concurrent required courses. Emphasis is on data collection, management, mapping and analysis.",
    "credits": "1"
  },
  {
    "course_name": "Urban Design and Development",
    "dept": "PLAN",
    "num": "640",
    "desc": "Prerequisite: PLAN 315.\nReview of recent and historical developments of urban form and space, presented through lecture and discussion. Criteria and methodology for urban design and planning as well as the role of historic preservation.",
    "credits": "3"
  },
  {
    "course_name": "Housing and Development Programs",
    "dept": "PLAN",
    "num": "650",
    "desc": "Prerequisite: PLAN 315; ENGL 200.\nReview and evaluation of historical and current housing issues, production, and financial systems, including consideration of racial, ethnic, income, and gender issues as they relate to the role of housing developments and programs in community development.",
    "credits": "3"
  },
  {
    "course_name": "Land Development Planning",
    "dept": "PLAN",
    "num": "655",
    "desc": "Prerequisite: PLAN 315.\nExamination of the process of land development in the United States, and its impacts from the perspective of developers, financial institutions, community planners, and city administrators. Focus is on the understanding of the land development process in meeting community goals and shaping land development to meet community expectations for the improvement of the community. Conflict resolution and negotiation skills represent a communication emphasis.",
    "credits": "3"
  },
  {
    "course_name": "Community Development Planning",
    "dept": "PLAN",
    "num": "660",
    "desc": "Prerequisite: PLAN 315.\nExamination of past and present approaches to community development planning in the United States. Review and assessment of community development planning policies, programs and practices.",
    "credits": "3"
  },
  {
    "course_name": "Community Development Workshop",
    "dept": "PLAN",
    "num": "661",
    "desc": "\nThe organization, planning, design, development, and evaluation of community development projects with real clients and actual locations.",
    "credits": "3"
  },
  {
    "course_name": "Planning Professional Internship",
    "dept": "PLAN",
    "num": "665",
    "desc": "Prerequisite: PLAN 444.\nInternship with an approved planning sponsor subject to the approval of the departmental faculty.",
    "credits": "7-9"
  },
  {
    "course_name": "Transportation Planning",
    "dept": "PLAN",
    "num": "667",
    "desc": "\nThe background, framing theories, professional activities and policy debates of transportation planning regarding transit, roads, non-motorized travel, energy use and climate change, land use, congestion, finance, economic development, health, safety, politics, asset management, politics, emerging technologies and the sharing economy.",
    "credits": "3"
  },
  {
    "course_name": "Travel Demand Modeling",
    "dept": "PLAN",
    "num": "668",
    "desc": "\nThe history, evolving theory, application, and debates surrounding travel demand modeling. Instruction in one of the main travel demand modeling software packages. Practical use of that software.",
    "credits": "3"
  },
  {
    "course_name": "Planning in POP Culture",
    "dept": "PLAN",
    "num": "670",
    "desc": "\nPlanning in POP Culture is an exploratory educational adventure of regional and community planning issues through the cultural media of song, literature, visual art, and film.",
    "credits": "3"
  },
  {
    "course_name": "Collective Decisions",
    "dept": "PLAN",
    "num": "672",
    "desc": "Prerequisite: PLAN 315 or instructor permission.\nProvides an introduction to planning as a collective decision-making tool; examines how planners work within a decision-making environment to move from regional and community planning concepts to implementing plans.",
    "credits": "3"
  },
  {
    "course_name": "Regional Economic Development Policy",
    "dept": "PLAN",
    "num": "674",
    "desc": "\nIntroduce students to the theory and practice of economic development at the sub-national level. Evaluate the design and implementation of economic development activities.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in Planning",
    "dept": "PLAN",
    "num": "699",
    "desc": "Prerequisite: PLAN 315.\nSpecial Studies in the area of regional and community planning.",
    "credits": "1-18"
  },
  {
    "course_name": "Off-Campus Studies",
    "dept": "PLAN",
    "num": "703",
    "desc": "Prerequisite: PLAN 720, PLAN 801, PLAN 803.\nOff campus studies fulfilled in an approved professional office or in an approved international studies program.",
    "credits": "5"
  },
  {
    "course_name": "Master’s Project",
    "dept": "PLAN",
    "num": "705",
    "desc": "Prerequisite: PLAN 897\nComprehensive application of research and planning through individual studies approved by the department faculty.",
    "credits": "3"
  },
  {
    "course_name": "Infrastructure and Plan Implementation",
    "dept": "PLAN",
    "num": "720",
    "desc": "Prerequisite: PLAN 315.\nExamination of infrastructure systems, the transportation process, land-use, and development standards; consideration of policy options and strategies; review of financing options and regulatory requirements associated with the various infrastructure elements. The course also reviews social and other issues that affect and are affected by infrastructure related decisions.",
    "credits": "3"
  },
  {
    "course_name": "Planning Administration",
    "dept": "PLAN",
    "num": "730",
    "desc": "Prerequisite: PLAN 315.\nFunctions of a planning administrator, including city organizational structures and the role of the planner in city administration and management; budgeting and capital improvements programming, including a study of the roles that bonds, taxation and intergovernmental grants play in the financing of various community based activities.",
    "credits": "3"
  },
  {
    "course_name": "Small Community and Rural Area Planning",
    "dept": "PLAN",
    "num": "740",
    "desc": "Prerequisite: PLAN 315.\nSynthesis of small community and rural area change, including socio-economic-political determinants as bases for community design and planning.",
    "credits": "3"
  },
  {
    "course_name": "Metropolitan Planning and Design",
    "dept": "PLAN",
    "num": "749",
    "desc": "Prerequisite: PLAN 315.\nExamination of urban form and the making of livable and sustainable metropolitan regions from an urban design perspective.  Introduction to public and private roles in the creation of urban form at regional, city, neighborhood, and site scales; consideration of regional and global consequences of local decisions; examination of design tools and methods used to shape decision making in urban development.",
    "credits": "3"
  },
  {
    "course_name": "Planning Law",
    "dept": "PLAN",
    "num": "753",
    "desc": "\nExamination of the evolution and current state of land use regulation within constitutional limits. Introduction to zoning, subdivision, and other police power controls within the comprehensive planning process.",
    "credits": "3"
  },
  {
    "course_name": "Professional Practice: Discipline-Specific Topics",
    "dept": "PLAN",
    "num": "755",
    "desc": "Prerequisite: PLAN 316.\nCovers discipline-specific concerns, focusing on issues specific to architecture, interior architecture and product design, landscape architecture or regional and community planning.",
    "credits": "1"
  },
  {
    "course_name": "Growth Management",
    "dept": "PLAN",
    "num": "765",
    "desc": "Prerequisite: PLAN 315, PLAN 720.\nStudy of the process of city growth and change in relation to planning techniques and socio-economic-political determinants. Criteria and methodology for the growth management are reviewed and applied to the contemporary city.",
    "credits": "3"
  },
  {
    "course_name": "Planning Methods I",
    "dept": "PLAN",
    "num": "801",
    "desc": "Prerequisite: PLAN 315 or with concurrent enrollment in PLAN 315.\nIntroduction to quantitative methods in planning used to measure change in the demographic characteristics of communities, and changes in the economic structure of the community. Emphasis is on the location and interpretation of Census data, population projection methodologies, and processes of community economic analysis, including the application of computer concepts to problem solving and data analysis in the planning profession.",
    "credits": "3"
  },
  {
    "course_name": "Planning Methods II",
    "dept": "PLAN",
    "num": "802",
    "desc": "Prerequisite: PLAN 801.\nThe application of computer concepts to problem solving and data analysis in the planning profession, for community economic analysis, market analysis, including the development of user skills in the application of various software packages for producing multimedia presentations. Included are elements of producing video and multimedia presentations of planning projects for use in public meetings, as well as professional report preparation and graphic displays of the material for public viewing. Material developed in PLAN 801 and 802 form the subject matter of the presentations.",
    "credits": "3"
  },
  {
    "course_name": "Community Research Methods",
    "dept": "PLAN",
    "num": "803",
    "desc": "Prerequisite: STAT 325, STAT 350, STAT 702, or STAT 703.\nFocus is on the analytical tools for the selection, collection, analysis, and interpretation of regional and community policy planning activities. Included is the development of survey instruments and interpretation, work flow and work measurement skills, performance standards and program evaluation techniques for policy planning and analysis at the local governmental level.",
    "credits": "3"
  },
  {
    "course_name": "Internship in Planning",
    "dept": "PLAN",
    "num": "805",
    "desc": "Prerequisite: Completion of two semesters of graduate study in planning.\nAssignment to a planning staff for a period of at least 10 weeks; supervision by a professional planner with periodic reports of activities to planning faculty.",
    "credits": "1-4"
  },
  {
    "course_name": "Planning Theory, Ethics and Practice",
    "dept": "PLAN",
    "num": "815",
    "desc": "Prerequisite: PLAN 315.\nReview of the basic theories of regional and community growth and change, analysis of the process of urbanization in relation to societal determinants and environmental constraints, and the study of a process of planning for professional practice. Exploration of societal and human values in relation to issues of equity, social justice, economic welfare, and efficient use of resources, as well as ethical approaches to these issues.",
    "credits": "3"
  },
  {
    "course_name": "Community Plan Preparation",
    "dept": "PLAN",
    "num": "836",
    "desc": "Prerequisite: PLAN 801.\nReview of the principles and elements of city growth and change, with application to the preparation of a comprehensive community plan for a community in Kansas. Criteria, standards, and methodology for city analysis and planning are applied to the practice of planning. Emphasis is on collaborative group participation in a practical planning process using skills developed in the RCP program.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Planning",
    "dept": "PLAN",
    "num": "880",
    "desc": "Prerequisite: PLAN 803.\nIndependent study of selected concepts and trends in regional and community planning and development.",
    "credits": "1-18"
  },
  {
    "course_name": "Proposal Writing",
    "dept": "PLAN",
    "num": "897",
    "desc": "Prerequisite: PLAN 803.\nExploration of procedures of planning, design, scheduling, organization, and management of a regional and community planning research project.",
    "credits": "2-3"
  },
  {
    "course_name": "Master’s Project and Report",
    "dept": "PLAN",
    "num": "898",
    "desc": "\nComprehensive application of research and planning through individual studies approved by the department faculty.",
    "credits": "2"
  },
  {
    "course_name": "Research in Planning",
    "dept": "PLAN",
    "num": "899",
    "desc": "Prerequisite: PLAN 803 or LAR 725 or ARCH 725 and completion of two semesters of graduate study in planning.\nOriginal research and advanced study in regional and community planning, urban design, and related fields for the master’s report/thesis.",
    "credits": "1-18"
  },
  {
    "course_name": "Undergraduate Research in Plant Pathology",
    "dept": "PLPTH",
    "num": "495",
    "desc": "Prerequisite: Consent of instructor.\nResearch experience is offered in classical and molecular plant pathology and biotechnology.",
    "credits": "0-3"
  },
  {
    "course_name": "Principles of Plant Pathology",
    "dept": "PLPTH",
    "num": "500",
    "desc": "Prerequisite: BIOL 198.\nAn introductory class in the nature of plant pathogens and the cause, effect, and control of plant diseases. Diseases of field and horticultural crops will be addressed.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Plant Pathology",
    "dept": "PLPTH",
    "num": "575",
    "desc": "Prerequisite: Consent of instructor.\nDiscussions and lectures on important areas and contributions in the field of plant pathology.",
    "credits": "1-3"
  },
  {
    "course_name": "Special Topics in Plant Pathology",
    "dept": "PLPTH",
    "num": "576",
    "desc": "Prerequisite: Consent of instructor.\nDiscussions and lectures on important areas and contributions in the field of plant pathology.",
    "credits": "1-3"
  },
  {
    "course_name": "Crop Diseases",
    "dept": "PLPTH",
    "num": "585",
    "desc": "Prerequisite: PLPTH 500.\nAn overview of plant diseases associated with Kansas crops, with an emphasis on identification and management strategies.",
    "credits": "2"
  },
  {
    "course_name": "Turfgrass Diseases and Their Management",
    "dept": "PLPTH",
    "num": "587",
    "desc": "Prerequisite: HORT 582 or concurrent enrollment and HORT 515 or concurrent enrollment.\nBiology, diagnosis and integrated management of turfgrass diseases. Emphasis is on diseases of intensively maintained turfgrass.",
    "credits": "1"
  },
  {
    "course_name": "Landscape Diseases",
    "dept": "PLPTH",
    "num": "590",
    "desc": "Prerequisite: PLPTH 500 or concurrent enrollment.\nAn overview of plant diseases associated with Kansas greenhouse and nursery production systems as well as landscape settings, with an emphasis on identification and management strategies.",
    "credits": "2"
  },
  {
    "course_name": "Biotechnology",
    "dept": "PLPTH",
    "num": "610",
    "desc": "Prerequisite: ASI 500 or BIOL 450.\nThe use of biotechnology and molecular genetic approaches in plant and animal sciences. Emphasis is on the use of molecular techniques for plant and animal improvement.",
    "credits": "3"
  },
  {
    "course_name": "Fusarium Laboratory Workshop",
    "dept": "PLPTH",
    "num": "676",
    "desc": "Prerequisite: BIOL 455 or BIOL 604; and consent of instructor.\nA one-week laboratory/lecture course on the identification, systematics, physiology, mycotoxicology, genetics, and molecular biology of fungi in the genus Fusarium. Students should not be enrolled in any other class while attending this workshop.",
    "credits": "1"
  },
  {
    "course_name": "Plant Nematology",
    "dept": "PLPTH",
    "num": "730",
    "desc": "Prerequisite: PLPTH 500.\nAn introduction to the morphology, taxonomy, and ecology of phytoparasitic and free-living nematodes found in plants, soil, and fresh water. Emphasis is on the identification and control of plant parasitic nematodes and on lab techniques used in their study.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Plant Resistance to Pests",
    "dept": "PLPTH",
    "num": "732",
    "desc": "Prerequisite: ENTOM 300 or PLPTH 500 or ENTOM 312 and 313, and one course in plant or animal genetics.\nBasic concepts of the biology, ecology, genetics and breeding for pest resistance in plants.",
    "credits": "2"
  },
  {
    "course_name": "Problems in Plant Pathology",
    "dept": "PLPTH",
    "num": "750",
    "desc": "Prerequisite: Consent of instructor.\nWork is offered in general plant pathology, plant virology, plant nematology, disease physiology, epidemiology, and disease diagnosis.",
    "credits": "1-3"
  },
  {
    "course_name": "Plant Resistance to Diseases",
    "dept": "PLPTH",
    "num": "755",
    "desc": "Prerequisite: ENTOM 732 or PLPTH 732.\nSurvey of recent literature on conventional and novel strategies for obtaining durable resistance to plant diseases. Several well-characterized host/pathogen systems will be selected for in-depth analysis.",
    "credits": "2"
  },
  {
    "course_name": "Integrated Plant Disease Management",
    "dept": "PLPTH",
    "num": "765",
    "desc": "Prerequisite: PLPTH 590 or concurrent enrollment with PLPTH 585.\nAdvanced topics in integrated plant disease management will be examined, including: epidemiological concepts, disease loss assessment, fungicides, resistance traits, on farm research trials and utilization of precision agriculture technologies to measure disease impacts.",
    "credits": "2"
  },
  {
    "course_name": "Environmental Education and Leadership",
    "dept": "PMC",
    "num": "110",
    "desc": "Prerequisite: Park Management and Conservation majors only.\nThis course will help students develop and understand the value of outcome based outdoor recreation/environmental education experiences for youth. Students will gain experience in group dynamics and a variety of leadership approaches involving nationally recognized environmental education programs.",
    "credits": "1"
  },
  {
    "course_name": "Boat Safety and Navigation",
    "dept": "PMC",
    "num": "112",
    "desc": "\nThe course covers a range of topics–from safety instructions to boat handling to reading the weather–and prepares students for a variety of situations one could find themselves in while on the water. The course is also designed to serve as an important first step for PMC majors wishing to pursue boat safety instructor status. Students will receive at least 8 hours on-the-water experience divided among 5 vessels: power boat-steering, power boat-tiller, sailboat, PWC, and canoe.  Students will earn a KS boat safety card.",
    "credits": "1"
  },
  {
    "course_name": "Shooting Sports Certification",
    "dept": "PMC",
    "num": "113",
    "desc": "\nStudents will gain youth leadership and shooting sports proficiency and instruction skills in riflery, hunting skills, pistol, archery, shotgun and muzzleloaders. Participants in the firearms disciplines may (with additional coursework and passing of a written test) be eligible to receive 4H or Scouting shooting sports instructor certification.",
    "credits": "1"
  },
  {
    "course_name": "Kansas Park and Wildlife Regulations",
    "dept": "PMC",
    "num": "114",
    "desc": "\nStudents will gain proficiency in their understanding and appropriate enforcement of state statutes and enforceable regulations dealing specifically with parks and wildlife. The underlying purpose of the course is to provide PMC students interested in pursuing careers as park rangers or conservation officers with Kansas specific regulation coverage.",
    "credits": "1"
  },
  {
    "course_name": "Adventure Challenge Certification",
    "dept": "PMC",
    "num": "115",
    "desc": "\nThis training focuses on adventure challenge and team building on low ropes courses, high ropes facilitation and 16 additional hours of ropes course managers training. Students will be provided skills to work with various clientele from corporate teams to persons with disabilities.",
    "credits": "1"
  },
  {
    "course_name": "Certified Interpretive Guide (CIG) Certification",
    "dept": "PMC",
    "num": "116",
    "desc": "\nStudents will participate in the professional certification course offered by the National Association for Interpretation (NAI). Successful completion of this course will certify them as NAI Certified Interpretive Guides. This certification combines both the theoretical foundations of the profession with practical skills in delivering quality interpretive programming to visitors.",
    "credits": "1"
  },
  {
    "course_name": "Outdoor Recreation Certification",
    "dept": "PMC",
    "num": "120",
    "desc": "Prerequisite: Consent of Instructor\nThis course is designed to provide the PMC major 1 hour of credit for outdoor recreation certifications not directly taught by Kansas State University. Examples are numerous, and include First Responder, Archery in Schools Instructor, Aquatic Facility Operator, Playground Inspector certification. Certifications being accepted must involve a minimum of 16 hours of contact, exercise and assessment hours; or additional requirements can be added by PMC faculty to meet 16 hours of content.",
    "credits": "1"
  },
  {
    "course_name": "Intro to Outdoor Recreation",
    "dept": "PMC",
    "num": "210",
    "desc": "\nOverview of the outdoor recreation industry and profession with emphasis on history of outdoor recreation in the U.S., current trends, public/private delivery systems, and associated individual and societal benefits. Highlights the breadth and diversity of the outdoor recreation industry and emphasizes the contributions and outcomes associated with outdoor recreation participation.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Natural Resource Management",
    "dept": "PMC",
    "num": "275",
    "desc": "\nA survey of historic and present-day uses, problems, and basic management approaches associated with our renewable and nonrenewable natural resources. The impact of society, economics, law, politics, and philosophy on the management and use of our natural resources will also be examined.",
    "credits": "3"
  },
  {
    "course_name": "Dendrology",
    "dept": "PMC",
    "num": "330",
    "desc": "\nIdentification, classification, silvical characteristics, distribution, and economic significance of North American angiosperm and gymnosperm trees.",
    "credits": "3"
  },
  {
    "course_name": "Parks and Outdoor Recreation Practicum",
    "dept": "PMC",
    "num": "350",
    "desc": "Prerequisite: Completion of at least 12 PMC (prefixed) core hours.\nRequired professional work experience (paid or volunteer), 120 hours minimum for 1 hour of credit; 240 hours minimum for 2 credit hours of credit. Designed to provide the future park and recreation professional an opportunity to apply acquired professional knowledge, skills and abilities in a supervised setting. A special problem allows the student to explore a topic/issue of professional interest.",
    "credits": "1-2"
  },
  {
    "course_name": "Topics in Park Management and Conservation",
    "dept": "PMC",
    "num": "441",
    "desc": "\nDiscussion of topics and activities of importance in park management and conservation.",
    "credits": "0-18"
  },
  {
    "course_name": "Natural History for Park Professionals",
    "dept": "PMC",
    "num": "475",
    "desc": "Prerequisite: available only to Park Management and Conservation majors.\nThis course will introduce students to the vertebrate fauna of Kansas. Specifically, students will learn to identify the amphibians, reptiles, birds and mammals found regularly in Kansas parks and wildlife areas. The course will prepare students to take the Kansas Conservation Officer wildlife identification test as well as prepare park interpreters and managers to identify species found in their parks and educate the public about them.",
    "credits": "3"
  },
  {
    "course_name": "Outdoor Recreation Program and Event Development",
    "dept": "PMC",
    "num": "489",
    "desc": "Prerequisite: PMC majors only.\nA focused study of the design, supply, and marketing of specific outdoor recreation programs and events.  The course will focus on tools and techniques of both the direct supply and facilitation of planned outdoor activities and events.",
    "credits": "3"
  },
  {
    "course_name": "Internship in Parks and Recreation",
    "dept": "PMC",
    "num": "492",
    "desc": "\nAn intensive, paid practical experience with an approved agency, extending over a 10-week, 400-hour span.",
    "credits": "6"
  },
  {
    "course_name": "Undergraduate Research in Park Management and Conservation",
    "dept": "PMC",
    "num": "495",
    "desc": "Prerequisite: Instructor permission.\nUndergraduate students work with faculty mentors on projects involving various elements of research in PMC including identifying a problem, designing and conducting experiments, interpreting and communicating the research results. The completed project must be presented at a professional forum, and students are required to write a final project report on completion of their project.",
    "credits": "0-3"
  },
  {
    "course_name": "Forestry for Park Professionals",
    "dept": "PMC",
    "num": "510",
    "desc": "\nPrinciples and practices of managing forest resources in the park setting. Special emphasis will be given to tree management in high use areas such as parks where human visitors present special problems for tree survival and development.",
    "credits": "3"
  },
  {
    "course_name": "Water Management for Natural Water Resource Managers",
    "dept": "PMC",
    "num": "575",
    "desc": "\nA study of the management of water resources for public and commercial uses. The course investigates the use of rivers, lakes, reservoirs, and marine resources. Management considerations, including agency policy formation, legal rights, use conflicts, and use valuation are covered.",
    "credits": "3"
  },
  {
    "course_name": "Park Operations and Maintenance Management",
    "dept": "PMC",
    "num": "580",
    "desc": "\nA focus on the principles and practices of operating and maintaining park and recreation areas and facilities. The focus of the course will be on the daily operation and related issues of various public parks (e.g. federal, state, county and municipal) and specific park features, including: campgrounds, trails and OHV areas, marinas, zoos, shooting ranges, aquatic facilities, and multipurpose sports complexes and limited facilities.",
    "credits": "4"
  },
  {
    "course_name": "Park Planning and Design",
    "dept": "PMC",
    "num": "620",
    "desc": "\nParks and protected areas play a vital role in the landscape, both for the people who use them and the natural resources they protect. The desire to maximize public access as well as protection can create conflicting demands on small to moderate sized parks. This course will explore current best practices for the social and ecological design and management of parks and protected areas. Course content will also discuss theoretical foundations of human beings’ relationship to nature and landscapes.",
    "credits": "3"
  },
  {
    "course_name": "Methods of Environmental Interpretation",
    "dept": "PMC",
    "num": "635",
    "desc": "\nThis course focuses on principles and techniques necessary to communicate environmental and cultural values to visitors in park areas. The philosophy, theory, design, and application of interpretive media to communicate information about the environment is studied.",
    "credits": "3"
  },
  {
    "course_name": "Parks and Recreation Administration",
    "dept": "PMC",
    "num": "690",
    "desc": "Prerequisite: Junior standing or instructor permission.\nThis course will introduce students to the use of specific practices to effectively manage a contemporary leisure service enterprise. Special emphasis is placed on financial management, human resource management, policy development, risk management and general administrative operations.",
    "credits": "4"
  },
  {
    "course_name": "Natural Resource Based Tourism",
    "dept": "PMC",
    "num": "710",
    "desc": "\nThis course will explore the obstacles and opportunities of using ecotourism and agritourism to contribute to rural economic development. Examples of successful ecotourism projects both domestically and internationally will be presented with an emphasis on the role of National Parks as tourism destinations. Agritourism efforts in Kansas will be highlighted and compared to similar efforts in other states and countries. Principles of attracting and managing tourists and park visitors in a sustainable manner also will be covered.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Environmental Interpretation",
    "dept": "PMC",
    "num": "740",
    "desc": "Prerequisite: PMC 635.\nThis course builds on the principles and interpretive techniques which are introduced in PMC 635. Specifically, labs emphasize development of personal interpretive skills and students are introduced to interpretive media not covered in PMC 635 (e.g., video equipment, computers, etc.). The lecture and readings focus on the philosophy of interpretation and the theoretical framework for designing and evaluating interpretive strategies.",
    "credits": "3"
  },
  {
    "course_name": "Political Science Colloquium",
    "dept": "POLSC",
    "num": "107",
    "desc": "\nTopics in political science chosen to illustrate current research of political scientists and approaches to the study of politics. Each time the course is offered, a syllabus will outline the topics to be studied and the way the course will be administered.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Political Science",
    "dept": "POLSC",
    "num": "110",
    "desc": "\nIntroduction to politics, public policy, and governmental processes from a political science perspective, studying political power, political thought, public opinion, groups, parties, institutions, public law, careers in politics, and related topics.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Political Science, Honors",
    "dept": "POLSC",
    "num": "111",
    "desc": "Prerequisite: Membership in arts and sciences honors program.\nIntroduction to politics, public policy, and governmental processes. Distribution and use of political power, political thought, public opinion, groups, parties, institutions, public law, careers in politics, and related topics.",
    "credits": "4"
  },
  {
    "course_name": "U.S. Politics",
    "dept": "POLSC",
    "num": "115",
    "desc": "\nThe national government with emphasis on constitutional principles, basic structure, functions, and the political process.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Comparative Politics",
    "dept": "POLSC",
    "num": "135",
    "desc": "\nComparative analysis of politics in both ”developed” and ”developing” countries. Though some attention will be given to abstract and theoretical concepts, the emphasis will be on the actual political process in the countries selected for study.",
    "credits": "3"
  },
  {
    "course_name": "World Politics",
    "dept": "POLSC",
    "num": "145",
    "desc": "\nIntroduction to the study of politics among nations-states and other world actors, including a survey of major contemporary problems of world politics and focusing on the pursuit of power, order, wealth, and safe environment.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Political Thought",
    "dept": "POLSC",
    "num": "155",
    "desc": "\nAn introduction to the major themes and leading writers in political philosophy and a discussion of their application to modern politics. This course emphasizes learning how to read and appreciate classic texts.",
    "credits": "3"
  },
  {
    "course_name": "Environmental Political Thought: The Future of Food, Air, Water, and Soil",
    "dept": "POLSC",
    "num": "250",
    "desc": "\nEnvironmental theories, with a concentration on the world’s food production. Discusses important viewpoints past and present, including anarchist and socialist, New Right, liberal, conservative and democratic agrarian ideas concerning agriculture, food production and consumption, and how we should treat the environment in which we live.",
    "credits": "3"
  },
  {
    "course_name": "Kansas Politics and Government",
    "dept": "POLSC",
    "num": "321",
    "desc": "\nAn introduction to the political institutions of, the political behavior in and surrounding, and the public policies flowing from governmental units in the state of Kansas.",
    "credits": "3"
  },
  {
    "course_name": "United States Politics, Honors",
    "dept": "POLSC",
    "num": "326",
    "desc": "Prerequisite: Membership in an honors program.\nThe national government with emphasis on constitutional principles, basic structure, functions, and the political process.",
    "credits": "4"
  },
  {
    "course_name": "Politics of the World Economy",
    "dept": "POLSC",
    "num": "341",
    "desc": "\nAddresses the reciprocal relationship between politics and economics in the management and functioning of the world economy. Explores the political influences on worldwide trade, financial, and investment flows as well as development policies and financial institutions.",
    "credits": "3"
  },
  {
    "course_name": "American Foreign Policy",
    "dept": "POLSC",
    "num": "343",
    "desc": "\nExamination of American external relations since 1945 and evaluation of processes involved in the formulation and conduct of contemporary foreign policy of the United States.",
    "credits": "3"
  },
  {
    "course_name": "Current Political Issues",
    "dept": "POLSC",
    "num": "350",
    "desc": "\nEach week a different political science faculty member or guest authority explains and analyzes current developments in state, national, and world affairs, using the news media as text material.",
    "credits": "2"
  },
  {
    "course_name": "Contemporary Issues",
    "dept": "POLSC",
    "num": "355",
    "desc": "\nStudy and analysis of selected political topics of immediate relevancy and concern.",
    "credits": "3"
  },
  {
    "course_name": "Practical Politics",
    "dept": "POLSC",
    "num": "366",
    "desc": "\nStrategies and techniques of running for office, organizing a campaign, mobilizing community resources, direct action lobbying, and related practical aspects of local level citizen politics.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Public Policy",
    "dept": "POLSC",
    "num": "377",
    "desc": "Prerequisite: POLSC 110 or POLSC 115 or another social science course.\nThe process of public policy formation and analysis with emphasis on the relationship between decisions taken, values maximized, and the social impact of these decisions in over 10 policy areas.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Political Science",
    "dept": "POLSC",
    "num": "399",
    "desc": "",
    "credits": "1-3"
  },
  {
    "course_name": "Political Inquiry and Analysis",
    "dept": "POLSC",
    "num": "400",
    "desc": "Prerequisite: Introductory social science course or consent of instructor.\nUnderlying principles and techniques used in the conduct of political science research.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Politics",
    "dept": "POLSC",
    "num": "401",
    "desc": "\nDifferent subjects in politics are selected for intensive study.",
    "credits": "0-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "POLSC",
    "num": "499",
    "desc": "\nOpen only to Arts and Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Political Sociology",
    "dept": "POLSC",
    "num": "504",
    "desc": "Prerequisite: SOCIO 211; POLSC 110.\nAn introduction to the principles of political sociology. Processes of political socialization, participation within and outside established organizational channels, recruitment of elites, communication and influence, power, decision making, and policy outputs. Data are presented from a cross-national perspective.",
    "credits": "3"
  },
  {
    "course_name": "South Asian Civilizations",
    "dept": "POLSC",
    "num": "505",
    "desc": "Prerequisite: 3 hours of social science or junior standing.\nInterdisciplinary survey of recent and contemporary civilization in India, Pakistan, Sri Lanka, Bangladesh, Nepal, Bhutan, and Afghanistan, including geography, philosophy, social, economic, political institutions, and historical movements.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Public Administration",
    "dept": "POLSC",
    "num": "507",
    "desc": "Prerequisite: POLSC 110 or POLSC 115 or ECON 110.\nThe basic concepts of public administration, with emphasis on orientation for citizen understanding; the place of administration and the role of the administrator in the American political process; the organization and activities of government in carrying out public policy; administrative functions, organization, accountability, finance, and personnel.",
    "credits": "3"
  },
  {
    "course_name": "Internship in Government, Public Administration, and Politics",
    "dept": "POLSC",
    "num": "510",
    "desc": "Prerequisite: Consent of instructor and a minimum of one course in political science that is relevant to the internship area.\nSupervised field work at the international, national, state, and local levels of government or with political parties or other politically oriented voluntary organizations.",
    "credits": "1-6"
  },
  {
    "course_name": "Contemporary Chinese Politics",
    "dept": "POLSC",
    "num": "511",
    "desc": "Prerequisite: POLSC 135 or junior standing.\nPrincipal components of Communist Chinese ideology, conditions determining organizational structure, composition of present leadership, role of social forces, impact of external relations on other Asian nations and on the major world powers.",
    "credits": "3"
  },
  {
    "course_name": "Political Islam",
    "dept": "POLSC",
    "num": "524",
    "desc": "Prerequisite: POLSC 135 or POLSC 155 or instructor permission.\nIntroduction to the main tenets of Muslim politics and a survey of thematic issues across the political systems in the Muslim world. Issues may include Muslim democracy, Islamist movements and political parties, Shia-Sunni conflict, Islamic law (shari’a), Islamophobia, violent organizations, Muslim public opinion, and the Arab Spring.",
    "credits": "3"
  },
  {
    "course_name": "U.S. National Government and Politics",
    "dept": "POLSC",
    "num": "525",
    "desc": "Prerequisite: POLSC 115.\nAdvanced overview of United States national government. Especially tailored to meet content area needs of prospective K-12 teachers. Topics to be addressed include: the constitution and the American founding; political and electoral processes; institutional structure and function; and, public policy.",
    "credits": "3"
  },
  {
    "course_name": "Comparative Political Institutions",
    "dept": "POLSC",
    "num": "526",
    "desc": "Prerequisite: POLSC 135\nAnalysis of political institutions in comparative perspective, including institutional creation and change, the functions and effects of institutional arrangements, as well as how they structure political behavior.",
    "credits": "3"
  },
  {
    "course_name": "Comparative Political Corruption",
    "dept": "POLSC",
    "num": "527",
    "desc": "Prerequisite: POLSC 135\nExplores the meaning and origins of political corruption. Emphasizes constraints on power and the political economy of corruption-reform efforts from a comparative perspective.",
    "credits": "3"
  },
  {
    "course_name": "Global Security Threats",
    "dept": "POLSC",
    "num": "540",
    "desc": "\nAnalysis of global threats to the security of societies and individuals emphasizing issues outside the traditional scope of international relations theory.",
    "credits": "3"
  },
  {
    "course_name": "The Politics of Developing Nations",
    "dept": "POLSC",
    "num": "545",
    "desc": "Prerequisite: POLSC 110 or 135 or sophomore standing.\nComparative analysis of politics in emergent states with emphasis on process of modernization and nation building.",
    "credits": "3"
  },
  {
    "course_name": "International Defense Strategies",
    "dept": "POLSC",
    "num": "549",
    "desc": "Prerequisite: POLSC 145, 541, or junior standing.\nContemporary international strategies and defense policies with emphasis on nuclear, conventional, and guerrilla war, arms control and disarmament, diplomatic and political roles of the military.",
    "credits": "3"
  },
  {
    "course_name": "Senior Honors Seminar",
    "dept": "POLSC",
    "num": "555",
    "desc": "\nOpen to senior majors who have attained a 3.0 grade point average in political science.",
    "credits": "3"
  },
  {
    "course_name": "Mass Communications and Political Campaigns",
    "dept": "POLSC",
    "num": "576",
    "desc": "Prerequisite: POLSC 115.\nThe roles of journalism, advertising and public relations in political campaigns. Examines campaign communication strategies, staffing, and the roles of political consultants.  Analyzes how voter decision making is affected by mass communications and how voters develop attitudes about candidates and issues.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Political Science",
    "dept": "POLSC",
    "num": "601",
    "desc": "Prerequisite: POLSC 400.\nExtensive exploration of a specific problem in political thought. American government, comparative politics, international relations, or public administration.",
    "credits": "3"
  },
  {
    "course_name": "Political Parties and Elections",
    "dept": "POLSC",
    "num": "603",
    "desc": "Prerequisite: POLSC 110, 115 or junior standing.\nOrigins, structure and function of political parties. Dynamics of the two-party system. Roles of third parties. Analysis of election results and voting behavior.",
    "credits": "3"
  },
  {
    "course_name": "Interest Groups and Public Opinion",
    "dept": "POLSC",
    "num": "604",
    "desc": "Prerequisite: POLSC 110 or POLSC 115.\nGroup theory and politics. Structure, internal politics, and techniques of interest groups and their impact on public policy. Formation and measurement of public opinion.",
    "credits": "3"
  },
  {
    "course_name": "The American Presidency",
    "dept": "POLSC",
    "num": "605",
    "desc": "Prerequisite: POLSC 110, 115 or junior standing.\nThe presidency as an institution, its evolution, congressional relationships, executive organization.",
    "credits": "3"
  },
  {
    "course_name": "Gender and Politics",
    "dept": "POLSC",
    "num": "606",
    "desc": "Prerequisite: SOCIO 545 or POLSC 115.\nAnalysis of the role of gender in political behavior, including gender differences in voting and political participation, legal and cultural restrictions on women’s rights and political activity, and women’s liberation and other gender-based political movements.",
    "credits": "3"
  },
  {
    "course_name": "Administrative Law",
    "dept": "POLSC",
    "num": "607",
    "desc": "Prerequisite: One course in political science, United States history, or legal or political philosophy.\nLegal analysis of the rule-making, adjudicatory, and enforcement functions of administrative agencies, with emphasis on constitutional framework, judicial review, requirements of procedural fairness, and rights of public employees.",
    "credits": "3"
  },
  {
    "course_name": "Political Participation in the United States",
    "dept": "POLSC",
    "num": "608",
    "desc": "Prerequisite: POLSC 110 or POLSC 115 or junior standing.\nA broad overview of the various tools of democracy; public opinion, political parties, interest groups, and elections.",
    "credits": "3"
  },
  {
    "course_name": "Local Government Law",
    "dept": "POLSC",
    "num": "610",
    "desc": "Prerequisite: POLSC 110 or POLSC 115 or junior standing.\nExplores the dynamic relationship between states and cities. Major issues may include budget shortfalls, social issues, and sprawl. Focus on the legal framework of state and city powers, including the forms of government, state preemption, and home rule theory and practice.",
    "credits": "3"
  },
  {
    "course_name": "The Legislative Process",
    "dept": "POLSC",
    "num": "611",
    "desc": "Prerequisite: POLSC 110, 115, or junior standing.\nLegislative decision-making in modern democracy with emphasis on the United States, the concept of representation, and political behavior of participants in the legislative process.",
    "credits": "3"
  },
  {
    "course_name": "The Judicial Process",
    "dept": "POLSC",
    "num": "612",
    "desc": "Prerequisite: POLSC 115 or junior standing.\nThe structure, process, and politics of the American judicial system. Analysis of important issues concerning law and courts.",
    "credits": "3"
  },
  {
    "course_name": "Constitutional Law",
    "dept": "POLSC",
    "num": "614",
    "desc": "Prerequisite: One course in political science, United States history, or legal or political philosophy.\nPrinciples of the American political system as prescribed by the Constitution and interpreted by Supreme Court decisions, with emphasis on the institutions and powers of the national government, federalism, and property rights.",
    "credits": "3"
  },
  {
    "course_name": "The Constitution, Civil Rights and Civil Liberties",
    "dept": "POLSC",
    "num": "615",
    "desc": "Prerequisite: One course in political science, United States history, or legal or political philosophy.\nThe Constitution as a limitation on governmental power, with emphasis on Supreme Court decisions defining fundamental civil rights and liberties.",
    "credits": "3"
  },
  {
    "course_name": "Urban Politics",
    "dept": "POLSC",
    "num": "618",
    "desc": "Prerequisite: POLSC 110 or 115.\nFundamental problems of political power and decision making in urban suburban governmental settings.",
    "credits": "3"
  },
  {
    "course_name": "Comparative Agriculture Politics and Policy",
    "dept": "POLSC",
    "num": "619",
    "desc": "Prerequisite: POLSC 110, 135, or junior standing.\nComparative examination of agricultural politics and policy with emphasis on decision making processes and the socio-political impacts of agricultural policy.",
    "credits": "3"
  },
  {
    "course_name": "State and Local Government",
    "dept": "POLSC",
    "num": "620",
    "desc": "Prerequisite: POLSC 110 or POLSC 115.\nThe United States system of federalism with emphasis on a comparative analysis of the government and politics of the fifty states and their subdivisions.",
    "credits": "3"
  },
  {
    "course_name": "West European Politics",
    "dept": "POLSC",
    "num": "621",
    "desc": "Prerequisite: POLSC 135.\nComparative analysis of British, French, German, and Italian democracies, political systems.",
    "credits": "3"
  },
  {
    "course_name": "Latin American Politics",
    "dept": "POLSC",
    "num": "622",
    "desc": "Prerequisite: POLSC 110 or 135 or junior standing.\nComparative analysis of selected political systems of Latin America emphasizing political inputs, political organization, and political outputs. special consideration is given to problems of political change.",
    "credits": "3"
  },
  {
    "course_name": "South Asian Politics",
    "dept": "POLSC",
    "num": "623",
    "desc": "Prerequisite: POLSC 135, 505, or junior standing.\nAnalysis of selected political systems of South Asia.",
    "credits": "3"
  },
  {
    "course_name": "Middle East Politics",
    "dept": "POLSC",
    "num": "624",
    "desc": "Prerequisite: POLSC 110, POL 135, or junior standing.\nComparative analysis of selected political systems in the Middle East including nationalism and the conflict of differing ideologies. Validity and usefulness of various theories of political development are tested.",
    "credits": "3"
  },
  {
    "course_name": "East Asian Politics",
    "dept": "POLSC",
    "num": "625",
    "desc": "Prerequisite: POLSC 110, POLSC 135, or junior standing.\nComparative analysis of selected political systems in East Asia, including consideration of the democratization process in the region.",
    "credits": "3"
  },
  {
    "course_name": "African Politics",
    "dept": "POLSC",
    "num": "626",
    "desc": "Prerequisite: POLSC 110, POLSC 135, or junior standing.\nComparative analysis of selected political systems of sub-Sahara Africa, including consideration of problems of nationalism and development.",
    "credits": "3"
  },
  {
    "course_name": "Eastern and Central European Politics",
    "dept": "POLSC",
    "num": "627",
    "desc": "Prerequisite: POLSC 135.\nExamination of comparative politics and policy in the countries of Easter and Central Europe.",
    "credits": "3"
  },
  {
    "course_name": "Civic Engagement",
    "dept": "POLSC",
    "num": "628",
    "desc": "Prerequisite: POLSC 115 and junior standing.\nSeminar on the role of voluntary organizations and civic groups in American political life and the factors that lead citizens to participate in both electoral and non-electoral activities.",
    "credits": "3"
  },
  {
    "course_name": "Development Policy and Administration",
    "dept": "POLSC",
    "num": "629",
    "desc": "Prerequisite: POLSC 110, POLSC 135, POLSC 377, or POLSC 507.\nComparative examination of development policy, politics, and administration.",
    "credits": "3"
  },
  {
    "course_name": "Politics of Russia and the Former Soviet Union",
    "dept": "POLSC",
    "num": "630",
    "desc": "Prerequisite: POLSC 135.\nAn overview of the major factors influencing the evolution of politics in Russia and the Soviet Union. Special emphasis is placed on the problems associated with the transition from a communist to a non-communist more democratic policy.",
    "credits": "3"
  },
  {
    "course_name": "Ethnic Conflict",
    "dept": "POLSC",
    "num": "638",
    "desc": "Prerequisite: Sophomore standing.\nEthnic Conflict in Comparative Prospective.  Comparative examination of ethnic conflicts across regions with the emphasis on Africa.",
    "credits": "3"
  },
  {
    "course_name": "International Conflict",
    "dept": "POLSC",
    "num": "642",
    "desc": "Prerequisite: POLSC 145.\nExamines the nature of international political conflicts and the types of such conflicts.",
    "credits": "3"
  },
  {
    "course_name": "Global Human Rights",
    "dept": "POLSC",
    "num": "643",
    "desc": "Prerequisite: POLSC 145, POLSC 400.\nIntroduction to human rights in the global system with a focus on the philosophical foundations, historical evolution, institutional development, and important actors in global human rights.",
    "credits": "3"
  },
  {
    "course_name": "International Politics of Europe",
    "dept": "POLSC",
    "num": "645",
    "desc": "Prerequisite: POLSC 145.\nRelationships among the countries of Europe since World War II. With emphasis on efforts to create a more unified European Community. Among the organizations that will be studied are the former Warsaw Pact, NATO, the European Parliament, and the European Union.",
    "credits": "3"
  },
  {
    "course_name": "International Law",
    "dept": "POLSC",
    "num": "647",
    "desc": "Prerequisite: POLSC 145, POLSC 341, or junior standing.\nTheories of international law, and general problems, such as: recognition, responsibility, war crimes, sources, evidence, codification, and settlement of disputes.",
    "credits": "3"
  },
  {
    "course_name": "International Organization",
    "dept": "POLSC",
    "num": "651",
    "desc": "Prerequisite: POLSC 145, POLSC 341, or junior standing.\nStructure, functions, values, and effectiveness of international organizations with emphasis on the United Nations, European Union, and other regional arrangements.",
    "credits": "3"
  },
  {
    "course_name": "International Politics of South Asia",
    "dept": "POLSC",
    "num": "652",
    "desc": "Prerequisite: POLSC 344 or POLSC 623.\nStudy of regional problems of South Asia and of international roles and foreign policies of South Asian states.",
    "credits": "3"
  },
  {
    "course_name": "International Politics of the Middle East",
    "dept": "POLSC",
    "num": "653",
    "desc": "Prerequisite: POLSC 145, POLSC 344, or three hours of other social sciences.\nConsideration of the Arab-Israeli conflict, inter-Arab relations, foreign policies of Middle Eastern states, and the impact of the major foreign powers on the area.",
    "credits": "3"
  },
  {
    "course_name": "International Politics of Africa",
    "dept": "POLSC",
    "num": "654",
    "desc": "Prerequisite: POLSC 334, POLSC 344, or junior standing.\nThe course analyzes contemporary relations among African countries including economic and political security, border claims, formal and informal economic relations, and regional groupings. The course also examines the relations between African countries, the United States and the former Soviet Union, and between African countries and the former colonial rulers.",
    "credits": "3"
  },
  {
    "course_name": "International Politics of Latin America",
    "dept": "POLSC",
    "num": "655",
    "desc": "Prerequisite: POLSC 145 or POLSC 341.\nAnalysis of international relations of Latin America. Examining theoretical approaches to the study of Latin America’s relations, United States Latin American relations, and comparative foreign policies of Latin American states. This course also explores special topics such as regional integration and geopolitics.",
    "credits": "3"
  },
  {
    "course_name": "Ancient and Medieval Political Thought",
    "dept": "POLSC",
    "num": "661",
    "desc": "Prerequisite: POLSC 110, POLSC 155, or junior standing.\nSystematic study of ideas about law, politics, and government of great philosophers of Western civilization from Greek antiquity to the sixteenth century.",
    "credits": "3"
  },
  {
    "course_name": "Early Modern Political Thought",
    "dept": "POLSC",
    "num": "663",
    "desc": "Prerequisite: POLSC 110, POLSC 155, or POLSC 325 or junior standing.\nStudy of the development of Western political thought from the sixteenth century to the twentieth century.",
    "credits": "3"
  },
  {
    "course_name": "American Political Thought",
    "dept": "POLSC",
    "num": "667",
    "desc": "Prerequisite: POLSC 110, POLSC 155, POLSC 325 or three hours in other social sciences.\nPolitical ideas underlying the American union, including the doctrine of rights, the nature of union, liberty, property, and democracy.",
    "credits": "3"
  },
  {
    "course_name": "Law, Politics, and Literature",
    "dept": "POLSC",
    "num": "670",
    "desc": "Prerequisite: POLSC 155 or junior standing.\nClassic and contemporary works of literature, including novels, plays, short stories, and poems, are used to explore themes in law and politics.",
    "credits": "3"
  },
  {
    "course_name": "Late Modern Political Thought",
    "dept": "POLSC",
    "num": "671",
    "desc": "Prerequisite: POLSC 110, POLSC 155, POLSC 325, or junior standing.\nStudy of contemporary political ideas and social thought.",
    "credits": "3"
  },
  {
    "course_name": "Ideologies: Their Origins and Impact",
    "dept": "POLSC",
    "num": "672",
    "desc": "Prerequisite: POLSC 110, POLSC 155, POLSC 325, or junior standing.\nExplores ideologies, including liberalism, conservatism, socialism, communism, and fascism. Their philosophical origins, transformation into systems of thought with mass appeal, and practical consequences are discussed. The conflict between ideology and philosophy is examined.",
    "credits": "3"
  },
  {
    "course_name": "Religion and Politics",
    "dept": "POLSC",
    "num": "675",
    "desc": "Prerequisite: POLSC 110, POLSC 115, POLSC 155 or 3 hours in other social sciences.\nFocuses on religious life in America and its changing relationship to politics and government. Examination of the American founding as it relates to church/ state issues, the controversy over meaning of the First Amendment’s establishment and free exercise clauses, and contemporary political agendas of mainline and evangelical churches.",
    "credits": "3"
  },
  {
    "course_name": "Research Methods in Political Science",
    "dept": "POLSC",
    "num": "700",
    "desc": "Prerequisite: POLSC 325, 333, or 344.\nPrinciples of research design, of measurement of political phenomena, and of methods for collecting and analyzing political data.",
    "credits": "3"
  },
  {
    "course_name": "Computer and Quantitative Analysis in Political Science",
    "dept": "POLSC",
    "num": "701",
    "desc": "Prerequisite: POLSC 400 or 700.\nAdvanced data management, data analysis, and computing skills involved in conducting political science and public policy research.",
    "credits": "3"
  },
  {
    "course_name": "Public Administration and Society",
    "dept": "POLSC",
    "num": "702",
    "desc": "Prerequisite: POLSC 507.\nIntroduction to the discipline and profession of public administration, which may include the cultural, constitutional, institutional, organizational, and ethical context of public administration. Introduction to central issues facing public administrators, using the related perspectives of management, politics, and law.",
    "credits": "3"
  },
  {
    "course_name": "Comparative Administrative Systems",
    "dept": "POLSC",
    "num": "707",
    "desc": "Prerequisite: POLSC 344 or 507.\nComparative analysis of public administration concepts and the morphology of administrative systems. Included are U.S., British,and French models and attempts by Third World countries to adapt these to their local cultures.",
    "credits": "3"
  },
  {
    "course_name": "Public Personnel Administration",
    "dept": "POLSC",
    "num": "708",
    "desc": "Prerequisite: POLSC 507 or 607.\nPersonnel aspects of administration at all levels of government, including recruitment, selection, discrimination law, pay, and motivation. Emphasis on to those features unique to the public sector, e.g. civil service systems, public unions, and public sector ethics law.",
    "credits": "3"
  },
  {
    "course_name": "Policy Analysis and Evaluation",
    "dept": "POLSC",
    "num": "710",
    "desc": "Prerequisite: POLSC 115 or 507.\nMethods of policy analysis and evaluation. Includes a discussion of the relationship between public policy and the distribution of values in society. Students analyze policies in an area of their choice; e.g., agriculture, business, health, income, trade.",
    "credits": "3"
  },
  {
    "course_name": "Administrative Ethics",
    "dept": "POLSC",
    "num": "711",
    "desc": "Prerequisite: POLSC 115 or 507 or graduate standing, or consent of the instructor.\nEthical issues, approaches, and strategies in public service.",
    "credits": "3"
  },
  {
    "course_name": "Game Theory for Political Scientists",
    "dept": "POLSC",
    "num": "712",
    "desc": "Prerequisite: POLSC 115, 135, 301, 333.\nIntroduction to game theoretic models as applied to problems in American politics, international relations and comparative politics.",
    "credits": "3"
  },
  {
    "course_name": "Comparative Civil-Military Relations",
    "dept": "POLSC",
    "num": "731",
    "desc": "Prerequisite: POLSC 110, 135, or junior standing.\nA look at civil-military relations in the United States, Russia, Germany, and Spain. Primary focus will be on understanding the political role of the military in totalitarian, authoritarian, and democratic states.",
    "credits": "3"
  },
  {
    "course_name": "Public Organization Theory",
    "dept": "POLSC",
    "num": "735",
    "desc": "Prerequisite: POLSC 115 or 507.\nTheories of the structure and mission of public organizations. Explores the use of analytical questioning of various theories, to solve organizational problems.",
    "credits": "3"
  },
  {
    "course_name": "Strategic Management of Public Organizations",
    "dept": "POLSC",
    "num": "736",
    "desc": "Prerequisite: POLSC 507 or POLSC 735.\nStrategic management in the public sector of democratic societies. Provides a set of tools and research skills to focus thinking, judgment and decision making in order to act strategically.",
    "credits": "3"
  },
  {
    "course_name": "Public Budgeting",
    "dept": "POLSC",
    "num": "737",
    "desc": "Prerequisite: POLSC 507 or MANGT 420.\nBudgeting as apart of our political system and as a fiscal process assists in allocating scarce resources. Overview of the budgetary decision-making process and the various budgetary approaches.",
    "credits": "3"
  },
  {
    "course_name": "Public Finance",
    "dept": "POLSC",
    "num": "738",
    "desc": "Prerequisite: POLSC 737.\nEconomics of the public sector, addressing the fundamental issue of the appropriate role of government activity in a market economy. Behavioral consequences of government policy. Model construction to explain real world government policy making.",
    "credits": "3"
  },
  {
    "course_name": "Intergovernmental Relations",
    "dept": "POLSC",
    "num": "739",
    "desc": "\nEvolution of the intergovernmental system in the United States and internationally.  Emphasis on federal, state, and local interrelationships.",
    "credits": "3"
  },
  {
    "course_name": "Nonprofit Financial Management",
    "dept": "POLSC",
    "num": "740",
    "desc": "Prerequisite: Graduate Student standing.\nIntroduction to the major issues in nonprofit management. Highlights the unique nature of the nonprofit sector with government (public) and business (for-profit) sectors. Issues may include governance roles and responsibilities, ethics and risk management, financial management and resource generation, managing staff and volunteers, performance measurements, and the emerging trends that threaten nonprofits’ tax-exempt status.",
    "credits": "3"
  },
  {
    "course_name": "The Professional Diplomat and Foreign Policy Formulation",
    "dept": "POLSC",
    "num": "754",
    "desc": "Prerequisite: POLSC 145.\nPresent day foreign policy formulation in the United States government, including the role of professional diplomats and foreign affairs specialists in the State Department and embassies abroad, as well as within other United States government agencies.",
    "credits": "3"
  },
  {
    "course_name": "International Political Economy",
    "dept": "POLSC",
    "num": "756",
    "desc": "Prerequisite: ECON 110 and 120, POLSC 145, 344, and 541, or junior standing.\nThe course introduces students to the political and historical dimensions of the international economy, dimensions that include trade, monetary systems, foreign investment, aid, dependency, and global interdependence. This course also examines various theories and practices of the international system, the state, bureaucracies, interest groups, international organizations, bargaining processes, and distributive norms.",
    "credits": "3"
  },
  {
    "course_name": "Readings in Political Science",
    "dept": "POLSC",
    "num": "785",
    "desc": "\nDirected reading and discussion of a selected topic in political science.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Political Science",
    "dept": "POLSC",
    "num": "790",
    "desc": "\nStudents will complete a research project and prepare an original paper under the supervision of a faculty member.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Political Science",
    "dept": "POLSC",
    "num": "791",
    "desc": "\nExtensive exploration of a specific problem in political thought. American government, comparative politics, international relations, and public administration.",
    "credits": "3"
  },
  {
    "course_name": "Pro-Seminar in Political Science",
    "dept": "POLSC",
    "num": "799",
    "desc": "\nStudy and analysis in various areas of the discipline with emphasis on critical evaluation of political conflicts and issues.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in Portuguese",
    "dept": "PORT",
    "num": "572",
    "desc": "Prerequisite: 15 hours of Portuguese and consent of instructor.",
    "credits": "1-3"
  },
  {
    "course_name": "Private Pilot Glider",
    "dept": "PPIL",
    "num": "109",
    "desc": "\nThe subject areas necessary for completion and passing of the FAA Private Pilot Written Knowledge Test for Gliders are presented.",
    "credits": "3"
  },
  {
    "course_name": "Private Pilot",
    "dept": "PPIL",
    "num": "111",
    "desc": "\nThe subject areas necessary for completion and passing of the FAA Private Pilot Knowledge Test are presented.",
    "credits": "4"
  },
  {
    "course_name": "Professional Instrument Pilot",
    "dept": "PPIL",
    "num": "112",
    "desc": "Prerequisite: PPIL 111\nA study of the procedures, regulations, and techniques required to safely fly in instrument meteorological conditions within our national airspace system. The course will prepare the student to pass the FAA Instrument Airplane Knowledge Test.",
    "credits": "3"
  },
  {
    "course_name": "Private Pilot Flight Lab",
    "dept": "PPIL",
    "num": "113",
    "desc": "Corequisite: PPIL 111.\nAn introduction of the fundamentals of flight. Solo flights to include all flight operations and maneuvers necessary for meeting the aeronautical experience for the FAA Private Pilot Certificate.",
    "credits": "1"
  },
  {
    "course_name": "Professional Instrument Pilot Flight Lab",
    "dept": "PPIL",
    "num": "114",
    "desc": "Prerequisite: PPIL 111, 113.  Corequisite: PPIL 112.\nInstructional flight training necessary to maneuver the aircraft safely in actual or simulated instrument meteorological conditions within the national airspace system.",
    "credits": "1"
  },
  {
    "course_name": "Private Pilot Helicopter Flight Lab",
    "dept": "PPIL",
    "num": "115",
    "desc": "\nAn introduction to the flight operations and maneuvers necessary to  meet the aeronautical experience for the private pilot rotocraft helicopter class rating.",
    "credits": "1"
  },
  {
    "course_name": "Instrument Helicopter Pilot Flight Lab",
    "dept": "PPIL",
    "num": "116",
    "desc": "Prerequisite: PPIL 115. Corequisite: PPIL 112.\nFlight training necessary to maneuver a helicopter safely in actual or simulated instrument meteorological conditions within the national airspace system.",
    "credits": "1"
  },
  {
    "course_name": "VFR Pilot Proficiency Lab",
    "dept": "PPIL",
    "num": "196",
    "desc": "\nInstruction and flight training necessary to safely operate an aircraft to meet the Federal Aviation Regulations. This course provides the student the opportunity to review and demonstrate proficiency to satisfactorily meet the FAA regulations for the current ratings held.",
    "credits": "1"
  },
  {
    "course_name": "IFR Pilot Proficiency Lab",
    "dept": "PPIL",
    "num": "197",
    "desc": "\nInstruction, simulator, and flight training necessary to safely operate an aircraft, to meet and maintain the Federal Aviation Regulations currency requirement of Instrument Competency, and maintain instrument currency and proficiency.",
    "credits": "1"
  },
  {
    "course_name": "Aviation Safety",
    "dept": "PPIL",
    "num": "210",
    "desc": "\nThis course provides an introduction to the field of aviation safety with an emphasis on promoting a safety culture.  Various safety programs and their relevance in the field of aviation are discussed.  Students will examine numerous accident reports and discuss safety issues facing the aviation industry today.",
    "credits": "3"
  },
  {
    "course_name": "Professional Commercial Pilot",
    "dept": "PPIL",
    "num": "211",
    "desc": "Prerequisite: PPIL 112, 114.\nThe subject areas necessary for passing the FAA Commercial Pilot Knowledge Test.",
    "credits": "3"
  },
  {
    "course_name": "Professional Commercial Pilot Flight Lab I",
    "dept": "PPIL",
    "num": "212",
    "desc": "Prerequisite: PPIL 112, 114. Corequisite: PPIL 211.\nInstructional cross country flight training necessary to maneuver the aircraft safely in actual or simulated instrument meteorological conditions within the national airspace system.",
    "credits": "2"
  },
  {
    "course_name": "Professional Commercial Pilot Flight Lab II",
    "dept": "PPIL",
    "num": "213",
    "desc": "Prerequisite: PPIL 212.\nAn introduction to complex airplane operations and a review of those operations required of a commercial pilot. The completion of this course readies the student to take the commercial FAA Practical test.",
    "credits": "2"
  },
  {
    "course_name": "Extended Cross Country",
    "dept": "PPIL",
    "num": "214",
    "desc": "Prerequisite: PPIL 113.\nA characteristic of aviation is that aircraft can cover a large geographic area. Aircraft operations in other geographic areas may differ greatly from a student’s training base. The experience of long-range navigation can be a great learning experience as well as a confidence booster. Selection of a destination that allows the student to increase their knowledge of aviation also aids in producing a more well-rounded, responsible professional.",
    "credits": "1"
  },
  {
    "course_name": "Mountain Flying",
    "dept": "PPIL",
    "num": "215",
    "desc": "Prerequisite: PPIL 113.\nA characteristic of aviation is that aircraft can cover a large geographic area. Aircraft operations in mountainous areas may differ greatly from a student’s training. The experience of reduced aircraft performance caused by high-density altitudes can be a great training into operations with aircraft exhibiting marginal performance. Learning of weather patterns, hypoxia, and survival allows the student to increase their knowledge of aviation and also aids in producing a more well-rounded, responsible professional.",
    "credits": "1"
  },
  {
    "course_name": "Altitude Chamber",
    "dept": "PPIL",
    "num": "216",
    "desc": "\nThis course offers a 1-day aviation physiology course for civil aviation pilots through the CAMI’s Aeromedical Education Division in Oklahoma City, OK. In addition to the basic academic contents, this course offers practical demonstrations of rapid decompression and hypoxia in a hypobaric chamber, as well as a practical demonstration of spatial disorientation. Upon completion of the course students will receive a certificate noting that they have completed the FAA’s Physiological Training course. The FFA requires a current Aviation Medical Certificate.",
    "credits": "1"
  },
  {
    "course_name": "Glider Towing",
    "dept": "PPIL",
    "num": "217",
    "desc": "Prerequisite: PPIL 113.\nInstruction and flight training necessary to obtain a logbook endorsement in the techniques and procedures for the safe towing of gliders.",
    "credits": "1"
  },
  {
    "course_name": "Commercial Pilot Helicopter Ground School",
    "dept": "PPIL",
    "num": "218",
    "desc": "Prerequisite: PPIL 115.\nGround instruction covering helicopter aircraft to develop the aeronautical knowledge to meet the ground school requirements for a commercial pilot rotocraft helicopter class rating.",
    "credits": "3"
  },
  {
    "course_name": "Single Engine Seaplane Transition",
    "dept": "PPIL",
    "num": "219",
    "desc": "Prerequisite: PPIL 213.\nInstruction and flight training necessary to add the seaplane rating to the commercial pilot certificate.  Course requires a one-week trip to a specified contract training location.",
    "credits": "1"
  },
  {
    "course_name": "Preventive Maintenance",
    "dept": "PPIL",
    "num": "221",
    "desc": "\nThis course will give the student hands-on experience with the maintenance tasks allowed under FAR 43 entitled preventive maintenance.",
    "credits": "2"
  },
  {
    "course_name": "Commercial Pilot Helicopter Flight Lab I",
    "dept": "PPIL",
    "num": "222",
    "desc": "Prerequisite: PPIL 115. Corequisite: PPIL 218.\nFlight instruction and experience to build time for the Commercial Pilot rating.",
    "credits": "2"
  },
  {
    "course_name": "Commercial Pilot Helicopter Flight Lab II",
    "dept": "PPIL",
    "num": "223",
    "desc": "Prerequisite: PPIL 222. Corequisite: PPIL 218.\nFlight instruction and experience in a helicopter to develop the aeronautical skills to meet the requirements for a commercial pilot rotocraft helicopter class rating.",
    "credits": "1-2"
  },
  {
    "course_name": "Private Pilot Glider Transition",
    "dept": "PPIL",
    "num": "230",
    "desc": "Prerequisite: PPIL 113.\nInstruction and flight training in the design, performance, operating characteristics, and flight proficiency for the safe operation of glider aircraft that will lead to an Private Pilot Glider certificate. This course provides students the opportunity to enhance and develop their skills in this segment of aviation.",
    "credits": "1"
  },
  {
    "course_name": "Commercial Pilot Glider Transition",
    "dept": "PPIL",
    "num": "231",
    "desc": "Prerequisite: PPIL 213 and PPIL 230.\nInstruction and flight training in the design, performance, operating characteristics, and flight proficiency for the safe operation of glider aircraft that will lead to a commercial pilot glider certificate. This course provides students the opportunity to enhance and develop their skills in this segment of aviation.",
    "credits": "1"
  },
  {
    "course_name": "Private Pilot Helicopter Ground School",
    "dept": "PPIL",
    "num": "251",
    "desc": "Prerequisite: PPIL 111.\nGround instruction covering helicopter aircraft to develop the aeronautical knowledge to meet the ground school requirements for a private pilot rotocraft class rating.",
    "credits": "1"
  },
  {
    "course_name": "Multi-Engine Ground School",
    "dept": "PPIL",
    "num": "262",
    "desc": "Prerequisite: PPIL 211.\nGround instruction covering multi-engine aircraft to develop the aeronautical knowledge to meet the ground school requirements for a multi-engine land class rating.",
    "credits": "1"
  },
  {
    "course_name": "Multi-Engine Flight Lab",
    "dept": "PPIL",
    "num": "263",
    "desc": "Corequisite: PPIL 262.\nFlight instruction and experience in a multi-engine aircraft to develop the aeronautical skills to meet the requirements to add a multi-engine land class rating to the student’s existing pilot certificate.",
    "credits": "1"
  },
  {
    "course_name": "Instrument Helicopter Pilot Ground School",
    "dept": "PPIL",
    "num": "281",
    "desc": "Prerequisite: PPIL 251.\nGround instruction covering helicopter aircraft to develop the aeronautical knowledge to meet the ground school requirements for an instrument helicopter rating.",
    "credits": "1"
  },
  {
    "course_name": "Multi-Engine Crew Coordination",
    "dept": "PPIL",
    "num": "290",
    "desc": "Prerequisite: PPIL 211, 263.\nInstruction, simulator and flight training necessary to operate a multi-engine aircraft as a member of a crew. Enhances multi-engine, instrument and cross country skills.",
    "credits": "1"
  },
  {
    "course_name": "Tailwheel Transition",
    "dept": "PPIL",
    "num": "295",
    "desc": "Prerequisite: PPIL 113.\nInstruction and flight training in the design, performance, operating characteristics, and flight proficiency for the safe operation of conventional-geared (tailwheel) aircraft that will lead to an endorsement allowing the student to act as pilot-in-command. This course provides students the opportunity to enhance and develop their skills in this segment of aviation.",
    "credits": "1"
  },
  {
    "course_name": "Certified Flight Instructor Ground School",
    "dept": "PPIL",
    "num": "312",
    "desc": "\nInstruction techniques, practices, and procedures necessary to provide skill in organizing and presenting lessons. This course will prepare the student for the FAA Certified Instructor Knowledge Test.",
    "credits": "6"
  },
  {
    "course_name": "Certified Flight Instructor Flight Lab",
    "dept": "PPIL",
    "num": "314",
    "desc": "Prerequisite: PPIL 213.  Concurrent enrollment: PPIL 312.\nThe needed flight skills and proper display of teaching ability will be emphasized. The demonstration of flight maneuvers with recognition of common errors in students performing the demonstrated maneuvers is stressed.",
    "credits": "2"
  },
  {
    "course_name": "Certified Flight Instructor Glider",
    "dept": "PPIL",
    "num": "315",
    "desc": "Prerequisite: PPIL 314.\nInstruction techniques, practices, and procedures necessary to provide skill in organizing and presenting lessons.  Prepares the student for the FAA Certified Instructor Knowledge Test Glider.",
    "credits": "1"
  },
  {
    "course_name": "Certified Flight Instructor Glider Flight Lab",
    "dept": "PPIL",
    "num": "316",
    "desc": "Prerequisite: PPIL 231.\nProvides the opportunity to apply and demonstrate concepts learned in the flight instructor glider ground instruction course (PPIL 315).  Requires demonstration of flight maneuvers and the ability to recognize common errors in student performance.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Aircraft Systems",
    "dept": "PPIL",
    "num": "325",
    "desc": "Prerequisite: PPIL 211.\nElectrical, environmental, hydraulic, fuel, ignition, and lubrication systems, including theory of operation and calculations. Principles, systems, analysis, operation, and limitations of advanced electronic navigation, flight director, and automatic flight control systems, including Inertial Navigation Systems and GPS.",
    "credits": "3"
  },
  {
    "course_name": "Flight Instructor Helicopter",
    "dept": "PPIL",
    "num": "351",
    "desc": "Prerequisite: PPIL 312 and PPIL 291.\nGround instruction covering helicopter aircraft to develop the aeronautical knowledge to meet the ground school requirements for a certified flight instructor rotocraft helicopter class rating.",
    "credits": "1"
  },
  {
    "course_name": "Flight Instructor Helicopter Flight Lab",
    "dept": "PPIL",
    "num": "352",
    "desc": "Prerequisite: PPIL 223. Corequisite: PPIL 312.\nFlight instruction and experience in a helicopter to develop the aeronautical skills to meet the requirements for a helicopter instructor rating.",
    "credits": "1"
  },
  {
    "course_name": "Helicopter Turbine Transition Lab",
    "dept": "PPIL",
    "num": "353",
    "desc": "Prerequisite: PPIL 223 or 292.\nInstruction and flight training in the design, performance, operating characteristics, and flight proficiency, for the safe operation of a turbine-powered helicopter. This course provides students the opportunity to enhance their knowledge and skills related to an entry-level turbine helicopter.",
    "credits": "1"
  },
  {
    "course_name": "Night Vision Goggle Lab",
    "dept": "PPIL",
    "num": "354",
    "desc": "Prerequisite: PPIL 223 or 292.\nInstruction and flight training in order to increase safety, situational awareness and mission operational capabilities during night flight while wearing night vision goggles. Upon completing FAA requirements, students may obtain a logbook or training record endorsement certifying they have completed the flight and ground training required to act as pilot in command of an aircraft using night vision goggles.",
    "credits": "1"
  },
  {
    "course_name": "Environmental Helicopter Operations",
    "dept": "PPIL",
    "num": "365",
    "desc": "Prerequisite: Junior standing or instructor consent.\nFoundational instruction for helicopter operations in varying terrain and environmental conditions. Topics include helicopter flight in diverse terrain and climate, principles of flight close to the earth, and avoidance of both natural and man-made hazards. Emphasis on aeronautical decision making and cockpit resource management.",
    "credits": "3"
  },
  {
    "course_name": "Turbine Transition",
    "dept": "PPIL",
    "num": "379",
    "desc": "Prerequisite: PPIL 213.\nTo provide required knowledge to meet FAA requirements to operate as second-in-command in KSU transportation aircraft. Covers systems performance and emergency procedures for turbine aircraft. In conjunction with simulator training, students will be qualified to operate as co-pilots on university transportation trips.",
    "credits": "3"
  },
  {
    "course_name": "Airline Transport Pilot Rating",
    "dept": "PPIL",
    "num": "385",
    "desc": "\nProvides the student with the aeronautical knowledge necessary to prepare for the FAA Airline Transport Pilot Knowledge Test. The demonstration of flight maneuvers, with recognition of proper control of emergencies in compliance of the Airline Transport Pilot Practical Test Standards will be stressed.",
    "credits": "2"
  },
  {
    "course_name": "Crew Resource Management I",
    "dept": "PPIL",
    "num": "387",
    "desc": "Prerequisite: PPIL 262, PPIL 325.\nThis course involves using all available resources for a safe and efficient flight.  Aircraft crew performance is reviewed to include the background and philosophy of Crew Resource Management (CRM) communication, decision behavior, team building, workload management, and situational awareness. Students accomplish two flight scenarios using a Canadair Regional Jet advanced aircraft training device.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Aviation",
    "dept": "PPIL",
    "num": "389",
    "desc": "\nTo provide the student an opportunity to apply aviation education to the improvement of skills previously learned as designated by the instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to Upset Training and Recovery",
    "dept": "PPIL",
    "num": "396",
    "desc": "Prerequisite: PPIL 114.\nInstruction and flight training necessary to develop an understanding and flight proficiency in basic upset flight attitudes. This course provides the student the opportunity to develop a better understanding of aircraft and safety of flight in other than normal flight attitudes.",
    "credits": "1"
  },
  {
    "course_name": "Crew Resource Management II",
    "dept": "PPIL",
    "num": "416",
    "desc": "Prerequisite: PPIL 387 and AVT 340.\nUtilizing a modern advanced jet aircraft training device, special emphasis is placed on systems knowledge, Flight Management Systems (FMS) programming, flight profiles and cockpit flows.  Students fly Line Orientated Flight Training (LOFT) missions and self-critique their performance.",
    "credits": "3"
  },
  {
    "course_name": "Certified Instrument Flight Instructor Ground School",
    "dept": "PPIL",
    "num": "482",
    "desc": "Prerequisite: PPIL 312.\nInstrument instruction techniques, practices, and procedures necessary to provide skills in organizing and presenting lessons in instrument flying procedures. This course will prepare the student for the FAA Certified Instrument Flight Instructor knowledge test.",
    "credits": "1"
  },
  {
    "course_name": "Certified Instrument Flight Instructor Lab",
    "dept": "PPIL",
    "num": "483",
    "desc": "Prerequisite: PPIL 314.  Prerequisite or corequisite: PPIL 482.\nInstrument instruction techniques, practices, and procedures necessary to provide skills in organizing and presenting lessons in instrument flying procedures. This course will prepare the student for the FAA Certified Instrument Flight Instructor practical test.",
    "credits": "1"
  },
  {
    "course_name": "Certified Instrument Flight Instructor Helicopter Flight Lab",
    "dept": "PPIL",
    "num": "484",
    "desc": "Prerequisite: PPIL 352. Corequisite: PPIL 482.\nInstrument instruction techniques, practices, and procedures necessary to provide skills in organizing and presenting lessons in instrument flying procedures. Prepares the student for the FAA Certified Instrument Flight Instructor practical test.",
    "credits": "1"
  },
  {
    "course_name": "Certified Multi-Engine Flight Instructor Ground School",
    "dept": "PPIL",
    "num": "492",
    "desc": "Prerequisite: PPIL 312, 314.\nProvides the student with the aeronautical knowledge necessary to meet the requirements for the addition of an airplane, multi-engine rating to the flight instructor certificate.",
    "credits": "1"
  },
  {
    "course_name": "Certified Multi-Engine Flight Instructor Lab",
    "dept": "PPIL",
    "num": "493",
    "desc": "Prerequisite: PPIL 314. Prerequisite or corequisite: PPIL 492.\nProvides the student with the aeronautical skills and experience necessary to meet the requirements for the addition of an airplane, multi-engine rating to the flight instructor certificate.",
    "credits": "1"
  },
  {
    "course_name": "Helicopter Operations",
    "dept": "PPIL",
    "num": "494",
    "desc": "Prerequisite: Junior standing or instructor consent.\nThe in-depth study of helicopter operations in civil operations. Topics will include helicopter operations in law enforcement, EMS, petroleum industry, etc. Advanced helicopter systems, multi-crew and multi-engine helicopter operations will also be addressed.",
    "credits": "3"
  },
  {
    "course_name": "Freshman Seminar",
    "dept": "PSYCH",
    "num": "100",
    "desc": "\nAn orientation and introduction to the field of psychology for freshman psychology majors only. Additional emphasis on the means by which psychological principles can be used to adapt to college life.",
    "credits": "1"
  },
  {
    "course_name": "General Psychology",
    "dept": "PSYCH",
    "num": "110",
    "desc": "\nAn introductory survey of the general content areas of psychology, including methods, data and principles.",
    "credits": "3"
  },
  {
    "course_name": "General Psychology (Honors)",
    "dept": "PSYCH",
    "num": "115",
    "desc": "\nAn introductory survey of the general content areas of psychology, including methods, data and principles.",
    "credits": "4"
  },
  {
    "course_name": "Drugs and Behavior",
    "dept": "PSYCH",
    "num": "202",
    "desc": "Prerequisite: PSYCH 110.\nEffects of drugs on human performance, cognition, and physiological processes will be discussed and the empirical evidence surveyed and critically evaluated in relation to both use and abuse of drugs in society.",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Childhood and Adolescence",
    "dept": "PSYCH",
    "num": "280",
    "desc": "Prerequisite: PSYCH 110.\nSurvey of behavioral development from birth through adolescence.",
    "credits": "3"
  },
  {
    "course_name": "Innovative Studies in Psychology",
    "dept": "PSYCH",
    "num": "290",
    "desc": "Prerequisite: Consent of instructor.\nTopics selected in consultation with the instructor. To be used for interdisciplinary and innovative approaches to psychological topics.",
    "credits": "1-6"
  },
  {
    "course_name": "Experimental Methods in Psychology",
    "dept": "PSYCH",
    "num": "350",
    "desc": "Prerequisite: PSYCH 110 (Psychology majors only).\nIntroduction to basic principles of research design and scientific methodology as applied to psychological sciences.",
    "credits": "3"
  },
  {
    "course_name": "Experimental Methods Laboratory",
    "dept": "PSYCH",
    "num": "351",
    "desc": "Prerequisite: PSYCH 350.\nApplication of experimental design and data analysis emphasized in the psychological literature, procedures, and reporting of research findings.",
    "credits": "2"
  },
  {
    "course_name": "Brain and Behavior",
    "dept": "PSYCH",
    "num": "370",
    "desc": "Prerequisite: PSYCH 110.\nA general overview of human brain function using case studies as a primary means for understanding the relationship between behavior and brain mechanisms.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Psychology",
    "dept": "PSYCH",
    "num": "399",
    "desc": "\nSelected topics.",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Teaching Psychology",
    "dept": "PSYCH",
    "num": "400",
    "desc": "Prerequisite: Consent of instructor; nine hours of psychology including PSYCH 110; junior standing.\nSupervised experience in presentation of psychological concepts in various classes. May be taken only with approval of the instructor of a psychology class under whose supervision the student will obtain this experience.",
    "credits": "1-4"
  },
  {
    "course_name": "Judgment and Decision Making",
    "dept": "PSYCH",
    "num": "425",
    "desc": "Prerequisite: PSYCH 110.\nCovers the academic field of judgment and decision making, its major methods, results, and controversies. Examines the generality of experimental results across various domains including gambling, clinical prediction, perception of randomness, and legal and medical decision making. Focus on practical analytical skills for decision making that are useful in everyday life and work.",
    "credits": "3"
  },
  {
    "course_name": "Forensic Psychology",
    "dept": "PSYCH",
    "num": "430",
    "desc": "Prerequisite: PSYCH 110.\nSurvey of psychological principles and facts in areas such as perception, cognition, neuropsychology, social psychology, personality, and decision making, as they apply to forensic psychology. Topics include: polygraph (lie detection), eyewitness testimony, jury decision making, and profiling.",
    "credits": "3"
  },
  {
    "course_name": "Applications of Memory",
    "dept": "PSYCH",
    "num": "450",
    "desc": "Prerequisite: PSYCH 110.\nExamination of the applications of memory in such diverse areas as courtroom testimony, expert performance, mnemonic procedures, and advertising. Relevant theories and research in each area are examined.",
    "credits": "3"
  },
  {
    "course_name": "Cognitive Psychology",
    "dept": "PSYCH",
    "num": "460",
    "desc": "Prerequisite: PSYCH 350 (Psychology majors only).\nA survey of the manner in which people extract and use relevant information from their environment as a basis for behavior. Topics may include memory storage and retrieval, attention, imagery, mnemonic devices, decision making, and other cognitive processes.",
    "credits": "3"
  },
  {
    "course_name": "Psychobiology",
    "dept": "PSYCH",
    "num": "470",
    "desc": "Prerequisite: BIOL 198, PSYCH 110.\nBehavior from a biological point of view. Topics include: behavioral neuroscience techniques, sensory coding, food and water intake, sexual behavior, sleep and waking, memory, and learning.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Learning",
    "dept": "PSYCH",
    "num": "475",
    "desc": "Prerequisite: PSYCH 350 (Psychology majors only).\nIntroduction to the principles of learning and their relevance to the understanding of the behavior of animals and humans.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Perception and Sensation",
    "dept": "PSYCH",
    "num": "480",
    "desc": "Prerequisite: PSYCH 350 (Psychology majors only).\nEmpirical and theoretical approaches to phenomena of sensation and perception.",
    "credits": "3"
  },
  {
    "course_name": "Honors Tutorial in Psychology",
    "dept": "PSYCH",
    "num": "490",
    "desc": "Prerequisite: Sophomore standing, membership in the honors program of the College of Arts and Sciences, and permission of instructor.\nIndividual directed research and study of a topic in psychology, normally as a preliminary to writing a senior honors thesis.",
    "credits": "1-3"
  },
  {
    "course_name": "Honors Project",
    "dept": "PSYCH",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Junior Seminar in Psychology",
    "dept": "PSYCH",
    "num": "500",
    "desc": "Prerequisite: Psych/Pre-Psych Major; Junior standing.\nDiscussion of professional, research, and educational methods and objectives in psychology. Acquaints psychology majors with psychology as a profession, and with the various options available to them at various levels of training.",
    "credits": "1"
  },
  {
    "course_name": "Abnormal Psychology",
    "dept": "PSYCH",
    "num": "505",
    "desc": "Prerequisite: Junior standing; PSYCH 110.\nAn introductory study of behavior pathologies, with emphasis on their etiology and treatment.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Behavior Modification",
    "dept": "PSYCH",
    "num": "510",
    "desc": "Prerequisite: PSYCH 505.\nStudy of the principles of behavior modification and applications to human behavior. Emphasis on the learning principles and research in behavior modification.",
    "credits": "3"
  },
  {
    "course_name": "Psychology Applied to Work",
    "dept": "PSYCH",
    "num": "515",
    "desc": "Prerequisite: PSYCH 110.\nIntroduction to the basic theories and practices used by industrial and organizational psychologists to enhance individual and organizational effectiveness and well-being. Topics include personnel selection, training, performance management, job attitudes, work motivation, leadership, occupational health, and group processes at work.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Health Psychology",
    "dept": "PSYCH",
    "num": "518",
    "desc": "Prerequisite: PSYCH 110.\nPsychosocial factors relevant to general health maintenance, recovery from disease or injury, and the achievement of health. Topics include stress-management techniques, personality characteristics associated with disease, cognitive-emotional effects of diet and exercise, and theories of pain and pain management. Concepts of prevention and behavioral medicine are also included.",
    "credits": "3"
  },
  {
    "course_name": "Life Span Personality Development",
    "dept": "PSYCH",
    "num": "520",
    "desc": "Prerequisite: PSYCH 110; sophomore standing.\nTheories and research in the development of personality from infancy through old age. Origins of personality in heredity and early experience, socialization practices, life crises and choices at various stages throughout life, and problems of aging.",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Mass Communications",
    "dept": "PSYCH",
    "num": "530",
    "desc": "Prerequisite: PSYCH 110.\nThe psychological effects of mass communication on behavior and thought, including advertising, stereotyping of women and minorities, effects on children, violence and sex in the media, effects of news on behavior, and the promotion of prosocial behavior through the media.",
    "credits": "3"
  },
  {
    "course_name": "Social Psychology",
    "dept": "PSYCH",
    "num": "535",
    "desc": "Prerequisite: PSYCH 110.\nPsychology of the individual in society. Survey of empirical studies and theoretical models of social perception, attitudes, and social behavior (e.g., attribution, ethnic and gender prejudice, conformity). Relationship of these topics to personal and media influence, social mores, and social systems is also included.",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Women",
    "dept": "PSYCH",
    "num": "540",
    "desc": "Prerequisite: PSYCH 110.\nInvestigation of psychological processes of women. A developmental sequence with emphasis on major life events for women. Female physiology, early socialization into sex roles, friendship, achievement motivation, sexuality, marriage, childbearing, work, and mental health.",
    "credits": "3"
  },
  {
    "course_name": "Consumer Psychology",
    "dept": "PSYCH",
    "num": "545",
    "desc": "Prerequisite: PSYCH 110.\nSurvey of psychological principles and facts in perception, learning, attitude formation, personality, etc., as they apply to behavior of consumers.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Psychological Research Methods",
    "dept": "PSYCH",
    "num": "550",
    "desc": "Prerequisite: PSYCH 350, STAT 325 or equivalent.  Corequisite: Majors only, Grade of B or better in PSYCH 350.\nStudents will read primary literature, design research studies, employ the instruments and technology currently used in psychological research.",
    "credits": "4"
  },
  {
    "course_name": "Multicultural Psychology",
    "dept": "PSYCH",
    "num": "556",
    "desc": "Prerequisite: PSYCH 110.\nIntroduce and familiarize students with the concept of multicultural psychology.",
    "credits": "3"
  },
  {
    "course_name": "The Psychology of Ethnic Humor",
    "dept": "PSYCH",
    "num": "557",
    "desc": "Prerequisite: PSYCH 110 or SOCIO 211.\nReviews the structure, dynamics, and social functions of ethnic humor.",
    "credits": "3"
  },
  {
    "course_name": "Psychological Testing",
    "dept": "PSYCH",
    "num": "559",
    "desc": "Prerequisite: PSYCH 110.\nPrinciples of psychological testing in industrial, clinical/counseling, and research environments. Topics include technical issues such as reliability, validity, norming, selection, placement, discrimination, etc. Also covers procedures for selecting, administering, and interpreting psychological tests.",
    "credits": "3"
  },
  {
    "course_name": "Industrial Psychology",
    "dept": "PSYCH",
    "num": "560",
    "desc": "Prerequisite: PSYCH 110.\nSurvey of human behavior and psychological principles in an industrial/personnel context. Topics include: recruiting, selecting, and training personnel; evaluating their job performance; conducting job analyses; and implementing compensation strategies.",
    "credits": "3"
  },
  {
    "course_name": "Gender Issues in the Workplace",
    "dept": "PSYCH",
    "num": "563",
    "desc": "Prerequisite: PSYCH 110.\nPsychological experiences of women and men in the world of work, with emphasis on traditional and nontraditional sex-role behavior, sexual discrimination and harassment, and relevant socialization experiences.",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Organizations",
    "dept": "PSYCH",
    "num": "564",
    "desc": "Prerequisite: PSYCH 110.\nRelationships between individuals, groups, and organizations. How organizational factors contribute to individual behavior, and how individuals affect groups and organizational functioning. Emphasis is on such traditional topics as work motivation, job satisfaction and other attitudes, leadership, communication, socialization, and organization and job design.",
    "credits": "3"
  },
  {
    "course_name": "Occupational Health Psychology",
    "dept": "PSYCH",
    "num": "565",
    "desc": "Prerequisite: PSYCH 110.\nSurvey of occupational health issues for juniors and seniors. Provides students with a background in psychologically related health issues occurring at work. The basic processes for identification, prevention, treatment, and well being of workers will be identified and explored.",
    "credits": "3"
  },
  {
    "course_name": "Psychopharmacology",
    "dept": "PSYCH",
    "num": "570",
    "desc": "Prerequisite: PSYCH 202, PSYCH 470.\nSurvey of basic principles of neural communication and pharmacology, the etiology and bio-behavioral bases of substance abuse, and chemical treatments of psychiatric disorders.",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Sexual Behavior",
    "dept": "PSYCH",
    "num": "580",
    "desc": "Prerequisite: PSYCH 110, sophomore standing.\nStudy of psychological determinants and consequences of human sexual behavior; roles of personality, attitudinal and emotional factors will be emphasized.",
    "credits": "3"
  },
  {
    "course_name": "Basic Concepts in Clinical Psychology",
    "dept": "PSYCH",
    "num": "585",
    "desc": "Prerequisite: PSYCH 110, PSYCH 505, and 3 additional hours of psychology.\nCritical analysis of the profession. Review of theoretical and empirical bases of such areas as intelligence and its measurement, personality and diagnosis, psychotherapy, and other modes of behavioral change.",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Clinical Concepts",
    "dept": "PSYCH",
    "num": "586",
    "desc": "Prerequisite: Concurrent enrollment in PSYCH 585.\nMay be taken only in conjunction with PSYCH 585. Supervised practice in, demonstration of, and orientation to selected psychological techniques and practices.",
    "credits": "2"
  },
  {
    "course_name": "Field Placement",
    "dept": "PSYCH",
    "num": "587",
    "desc": "Prerequisite: PSYCH 585 and 586, or 560; 561, and 562 and consent of psychological technician training committee.\nSupervised field experience in an agency or institutional setting in the application of psychological techniques to individuals, groups, or organizations. Regular supervision emphasizes relationship between theory and application and the evaluation of outcomes.",
    "credits": "1-6"
  },
  {
    "course_name": "Interdisciplinary Topics in Psychology",
    "dept": "PSYCH",
    "num": "590",
    "desc": "Prerequisite: Consent of instructor.\nTopics selected in consultation with the instructor, covering interdisciplinary and innovative approaches to psychological topics.",
    "credits": "1-3"
  },
  {
    "course_name": "Research in Psychology",
    "dept": "PSYCH",
    "num": "599",
    "desc": "Prerequisite: Consent of instructor.\nInvestigation of selected problems.",
    "credits": "0-18"
  },
  {
    "course_name": "Advanced Social Psychology",
    "dept": "PSYCH",
    "num": "605",
    "desc": "Prerequisite: PSYCH 350 (Psychology majors only).\nAn advanced look at some of the core topics in social psychology (e.g. the self, social influence, personal relationships, prejudice and discrimination, group processes) with a strong emphasis on applying the theory in these areas to current social problems and students’ daily lives.",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Personality",
    "dept": "PSYCH",
    "num": "620",
    "desc": "Prerequisite: PSYCH 350.\nDiscussion of different approaches to the study of personality.",
    "credits": "3"
  },
  {
    "course_name": "Human Factors Psychology",
    "dept": "PSYCH",
    "num": "625",
    "desc": "Prerequisite: PSYCH 110; STAT 325 or equivalent.\nThe application of psychological principles to the design and operation of machines, products, and systems, including human-computer interactions, automation, and training.",
    "credits": "3"
  },
  {
    "course_name": "Human Neuropsychology",
    "dept": "PSYCH",
    "num": "630",
    "desc": "Prerequisite: BIOL 198 and PSYCH 110, or consent of instructor.\nStudy of brain-behavior relationships in humans. Brief review of human neuroanatomy followed by a major emphasis on brain function in learning, memory, language, and other cognitive behaviors. Also includes an examination of behavioral alterations following brain damage.",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Language",
    "dept": "PSYCH",
    "num": "650",
    "desc": "Prerequisite: PSYCH 110 and junior standing.\nExperimental study of language, including sentence comprehension and memory, language acquisition and development, speech perception, and effects of context, perception, reasoning, and linguistic structure on processing of language.",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Aging",
    "dept": "PSYCH",
    "num": "715",
    "desc": "Prerequisite: PSYCH 110 and junior standing.\nThe psychological aspects of human aging. An analysis of the contributions of experimental, developmental, and personality-social psychology to the study of aging. The psychopathology of aging and psychological intervention strategies are also covered.",
    "credits": "3"
  },
  {
    "course_name": "History of Current Trends",
    "dept": "PSYCH",
    "num": "775",
    "desc": "Prerequisite: PSYCH 110 and 9 additional hours of psychology; senior standing.\nA review of the contributions of individuals and intellectual movements to the development of modern psychology. A survey of theoretical systems currently of influence.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Psychology",
    "dept": "PSYCH",
    "num": "790",
    "desc": "Prerequisite: PSYCH 110 and consent of instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Problems in Psychology",
    "dept": "PSYCH",
    "num": "799",
    "desc": "Prerequisite: PSYCH 110 and consent of instructor.",
    "credits": "1-18"
  },
  {
    "course_name": "Topics in Recreation Resources",
    "dept": "RRES",
    "num": "200",
    "desc": "\nDiscussion of topics and activities of importance in recreation resources.",
    "credits": "1-3"
  },
  {
    "course_name": "Russian I",
    "dept": "RUSSN",
    "num": "101",
    "desc": "\nIntroduction to the structure of modern Russian. Emphasis on the sounds of Russian, the use of the Cyrillic alphabet, and oral drills with added practice in the language laboratory.",
    "credits": "5"
  },
  {
    "course_name": "Russian II",
    "dept": "RUSSN",
    "num": "102",
    "desc": "Prerequisite: RUSSN 101 or equivalent.\nContinuation of the study of Russian grammar and oral communication.",
    "credits": "5"
  },
  {
    "course_name": "Russian Culture and Civilization",
    "dept": "RUSSN",
    "num": "250",
    "desc": "\nRussia’s past and present in the light of principal ideologies with emphasis upon fine art, literature, music, religion, politics, and education. Equal time will be devoted to the Tsarist and Soviet periods.",
    "credits": "3"
  },
  {
    "course_name": "Russian III",
    "dept": "RUSSN",
    "num": "300",
    "desc": "Prerequisite: RUSSN 102 or equivalent.\nCompletion of the study of Russian grammar. Reading of selected prose on the intermediate level.",
    "credits": "4"
  },
  {
    "course_name": "Russian IV",
    "dept": "RUSSN",
    "num": "301",
    "desc": "Prerequisite: RUSSN 301 or equivalent.\nIntensive review of Russian grammar. Exercises in reading selected modern Russian texts in the original.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Studies in Russian",
    "dept": "RUSSN",
    "num": "398",
    "desc": "\nOffered only to participants in study abroad programs. Prior consultation for approval is expected.",
    "credits": "1-18"
  },
  {
    "course_name": "Russian Literature in Translation: The Nineteenth Century",
    "dept": "RUSSN",
    "num": "504",
    "desc": "\nSurvey of principal writers of Tsarist Russia with emphasis upon Turgenev, Dostoevsky, Tolstoy, and Chekhov.",
    "credits": "3"
  },
  {
    "course_name": "Russian Literature in Translation: The Soviet Period",
    "dept": "RUSSN",
    "num": "508",
    "desc": "\nThe development of Russian literature since the Revolution, with emphasis upon Mayakovsky, Sholokov, Pasternak, and Solzhenitsyn.",
    "credits": "3"
  },
  {
    "course_name": "Russian V",
    "dept": "RUSSN",
    "num": "551",
    "desc": "\nReading of Russian short stories of the nineteenth and twentieth centuries, including works by Pushkin, Lermontov, Dostoevsky, and Chekhov.",
    "credits": "3"
  },
  {
    "course_name": "Survey of Russian Literature",
    "dept": "RUSSN",
    "num": "552",
    "desc": "\nA history of Russian literature from its beginnings until the present, with emphasis on the works of the nineteenth century, including those of Pushkin, Lermontov, Gogol, Turgenev, Dostoevsky, and Tolstoy.",
    "credits": "3"
  },
  {
    "course_name": "Russian Conversation and Composition",
    "dept": "RUSSN",
    "num": "553",
    "desc": "\nDiscussion in Russian. Extensive practice in writing Russian compositions.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in Russian",
    "dept": "RUSSN",
    "num": "559",
    "desc": "Prerequisite: Consent of department head and instructor involved.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to Sociology",
    "dept": "SOCIO",
    "num": "211",
    "desc": "\nDevelopment, structure, and functioning of human groups; social and cultural patterns; and the principal social processes.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Sociology, Honors",
    "dept": "SOCIO",
    "num": "214",
    "desc": "\nDevelopment, structure, and functioning of human groups; societal and cultural patterns; the nature of sociological inquiry. Lecture, discussion, and independent study.",
    "credits": "4"
  },
  {
    "course_name": "Topics in Sociology",
    "dept": "SOCIO",
    "num": "301",
    "desc": "Prerequisite: SOCIO 211 and consent of instructor.\nSupervised independent and/or interdisciplinary study projects.",
    "credits": "1-18"
  },
  {
    "course_name": "Social Problems",
    "dept": "SOCIO",
    "num": "360",
    "desc": "Prerequisite: SOCIO 211.\nAnalysis of social problems such as drug use, crime, juvenile delinquency, mental illness, unemployment, and family instability.",
    "credits": "3"
  },
  {
    "course_name": "Criminal Justice Systems",
    "dept": "SOCIO",
    "num": "361",
    "desc": "Prerequisite: SOCIO 211.\nAn examination of the major components in the American criminal justice system and how these reflect and are affected by norms and changes in our society. Special emphasis is placed on issues of gender, race/ethnicity, and class within criminal justice.",
    "credits": "3"
  },
  {
    "course_name": "Police and Society",
    "dept": "SOCIO",
    "num": "362",
    "desc": "Prerequisite: SOCIO 211.\nExamines in detail the policing function in society and the role police play in the criminal justice process.",
    "credits": "3"
  },
  {
    "course_name": "Global Problems",
    "dept": "SOCIO",
    "num": "363",
    "desc": "\nAnalysis of globalization and contemporary social problems around the world. Emphasis on non-Western, low-income countries. Examines food and hunger, global warming, debt crisis, democratization, ethnic conflict, and structures of economic and political inequality.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Sociology",
    "dept": "SOCIO",
    "num": "399",
    "desc": "\nReadings and discussion of selected topics.",
    "credits": "1-3"
  },
  {
    "course_name": "Methods of Social Research I",
    "dept": "SOCIO",
    "num": "423",
    "desc": "Prerequisite: SOCIO 211, STAT 325.\nTreatment of the logic and procedures involved in the formulation of a research problem and the difficulties encountered in conducting research. Examines problems of explanation and prediction, the process of inquiry, elements of the scientific method, the design of research, and analysis in the social sciences.",
    "credits": "4"
  },
  {
    "course_name": "Comparative Social Theories",
    "dept": "SOCIO",
    "num": "431",
    "desc": "Prerequisite: SOCIO 211.\nA systematic survey of major theoretical approaches in sociology. The works of Marx, Weber, Durkheim, and other classical theorists are examined, along with selections from major contemporary perspectives such as functionalism, symbolic interactionism, structuralism, critical theory, and feminist theory. Current debates over structure versus agency, postmodernism, and other controversies are considered.",
    "credits": "3"
  },
  {
    "course_name": "Sport and Contemporary Society",
    "dept": "SOCIO",
    "num": "435",
    "desc": "Prerequisite: SOCIO 211.\nAn analysis of sport and its role in contemporary society. Course creates a greater awareness of the social significance of sport in society and fosters the capacity to use critical thinking in the analysis of significant sport issues.",
    "credits": "3"
  },
  {
    "course_name": "Social Organization",
    "dept": "SOCIO",
    "num": "440",
    "desc": "Prerequisite: SOCIO 211.\nPrinciples and processes of the organization and structure of human societies. Examines how people create social institutions and how these organizations and structures shape human relations and experience. Analysis of capitalism and other forms of social organization.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Social Interaction",
    "dept": "SOCIO",
    "num": "450",
    "desc": "Prerequisite: SOCIO 211.\nA survey of theories of social interaction and social psychology with special attention to research on principles of interpersonal relations in social situations, group formation, maintenance, and change.",
    "credits": "3"
  },
  {
    "course_name": "Youth and Crime",
    "dept": "SOCIO",
    "num": "460",
    "desc": "Prerequisite: SOCIO 211.\nNature, extent, and causes of delinquency; characteristics of delinquents; means of prevention and treatment.",
    "credits": "3"
  },
  {
    "course_name": "Gangs in American Society",
    "dept": "SOCIO",
    "num": "463",
    "desc": "Prerequisite: SOCIO 361.\nCovers the historical development and current status of gangs in America. Focus on gang types/forms, criminal activities and sociological impact on communities. Also examines gang control mechanisms as well as classic and modern research conducted about gangs.",
    "credits": "3"
  },
  {
    "course_name": "The Criminal Justice System and Family Violence",
    "dept": "SOCIO",
    "num": "470",
    "desc": "\nThis course critically examines the incidence and prevalence of family violence in society, emphasizing how the criminal justice system responds to this social problem.",
    "credits": "3"
  },
  {
    "course_name": "Prisons and Punishment",
    "dept": "SOCIO",
    "num": "480",
    "desc": "\nThe historical development and current status of the correctional system. Major institutional components include jails, prisons, probation, parolee, and other forms of community corrections. Modern issues such as offender and victim rights and electronic monitoring are also covered.",
    "credits": "3"
  },
  {
    "course_name": "Honors Project",
    "dept": "SOCIO",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Sociological Perspectives on Contemporary Issues",
    "dept": "SOCIO",
    "num": "500",
    "desc": "Prerequisite: SOCIO 211.\nAnalysis of a selected topic of contemporary interest. Topics vary from semester to semester and might include: impact of public policy on rural life; white collar crime; student-athlete education; social change in the Third World.",
    "credits": "1-18"
  },
  {
    "course_name": "Proficiency Development",
    "dept": "SOCIO",
    "num": "501",
    "desc": "Prerequisite: Consent of instructor and superior performance in relevant course.\nIntegrative review of sociological concepts and skills under faculty supervision.",
    "credits": "1-3"
  },
  {
    "course_name": "Political Sociology",
    "dept": "SOCIO",
    "num": "504",
    "desc": "Prerequisite: SOCIO 211, POLSC 110.\nAn introduction to the principles of political sociology. Processes of political socialization, participation within and outside established organizational channels, recruitment of elites, communication and influence, power, decision making, and policy outputs. Data are presented from a cross-national perspective.",
    "credits": "3"
  },
  {
    "course_name": "South Asian Civilizations",
    "dept": "SOCIO",
    "num": "505",
    "desc": "Prerequisite: 3 hours of social science or junior standing.\nInterdisciplinary survey of the development of civilizations in India, Pakistan, Sri Lanka, Bangladesh, Nepal, Bhutan, and Afghanistan, including geography, philosophy, social, economic, political institutions, and historical movements.",
    "credits": "3"
  },
  {
    "course_name": "International Development and Social Change",
    "dept": "SOCIO",
    "num": "507",
    "desc": "Prerequisite: SOCIO 211 or consent of instructor.\nA survey of the socioeconomic and political dimensions of international development, with attention focused on developing world contexts. Special attention is given to understanding post-war development trends, including the debt crisis, globalization and neoliberalism, and movements for social change, such as the anti-globalization and the fair trade movements.",
    "credits": "3"
  },
  {
    "course_name": "Social Welfare as a Social Institution",
    "dept": "SOCIO",
    "num": "510",
    "desc": "Prerequisite: SOCIO 211.\nThe development and present status of social welfare in meeting changing human needs and the requirements in other parts of our social system; the analysis of present-day philosophy and functions of social welfare.",
    "credits": "3"
  },
  {
    "course_name": "Community Engaged Research and Evaluation",
    "dept": "SOCIO",
    "num": "522",
    "desc": "Prerequisite: SOCIO 423.\nIntroduction to partnering with community organizations and applying observation,  surveys, interviews, governmental resources, secondary data identification and analysis, and basic program and policy evaluation.  Students practice notetaking, report writing, and ethical standards that protect the well-being of study participants.",
    "credits": "3-6"
  },
  {
    "course_name": "Urban Sociology",
    "dept": "SOCIO",
    "num": "531",
    "desc": "Prerequisite: SOCIO 211.\nGrowth, development, and structure of the city as determined by geographical, ecological, and social factors; relation of rural and urban communities; problems of the city and various approaches to their solution.",
    "credits": "3"
  },
  {
    "course_name": "Our Communities, Our Futures",
    "dept": "SOCIO",
    "num": "532",
    "desc": "Prerequisite: SOCIO 211.\nCombines real-world experience and sociological knowledge about community organization. Explores organizational ties, social interaction, social capital, and leadership in communities.",
    "credits": "3"
  },
  {
    "course_name": "Society, Food, and Agriculture",
    "dept": "SOCIO",
    "num": "533",
    "desc": "Prerequisite: SOCIO 211 or consent of instructor.\nExamines the relationships between agriculture, food, and society. Topics to be examined include the changing structure of agriculture, food system resilience, the globalization of food and agriculture, issues of distribution, access, and food security, and related social movements.  Examines implications for both rural and urban societies in the US and around the world.",
    "credits": "3"
  },
  {
    "course_name": "Population Dynamics",
    "dept": "SOCIO",
    "num": "535",
    "desc": "Prerequisite: SOCIO 211.\nWorld population trends and their implications for economic development, public policy, and social and cultural change. The interaction of fertility, mortality, and migration with the size, distribution, and structure of populations in nations and world regions.",
    "credits": "3"
  },
  {
    "course_name": "Society and Natural Resources",
    "dept": "SOCIO",
    "num": "536",
    "desc": "Prerequisite: SOCIO 211 or instructor consent.\nThe interrelations among human societies, social institutions, and the biophysical environment. Emphasis on the reciprocal links among technological change, economic structure, and the ecological basis of human societies.",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Emotions",
    "dept": "SOCIO",
    "num": "537",
    "desc": "\nExamines different sociological perspectives on the role of emotions in social life, from the level of self and identity, through social interaction, to the macro level of social structure, social order, and social change. Emotions as both social products, and as factors constitutive of social life.",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Culture",
    "dept": "SOCIO",
    "num": "538",
    "desc": "\nIntroduction to the concept of “culture” and the role of culture and collective meaning in social life and social change. How we make sense of the world, and how this affects our responses and actions in the world. Relationship between cultural change and social change.",
    "credits": "3"
  },
  {
    "course_name": "Sexuality and Society",
    "dept": "SOCIO",
    "num": "540",
    "desc": "Prerequisite: SOCIO 211.\nOverview of key concepts related to sexuality studies and examination of social and cultural constructions of sexuality. Discussion of issues of power, inequalities, and social control.",
    "credits": "3"
  },
  {
    "course_name": "Wealth, Power, and Privilege",
    "dept": "SOCIO",
    "num": "541",
    "desc": "Prerequisite: SOCIO 211.\nAnalysis of social inequality, particularly within the contemporary United States. Competing explanations for unequal wealth, status, power, etc. Emphasis on explanations related to class, occupational structure, gender, and ethnicity.",
    "credits": "3"
  },
  {
    "course_name": "Social Gerontology: An Introduction to the Sociology of Aging",
    "dept": "SOCIO",
    "num": "544",
    "desc": "Prerequisite: SOCIO 211.\nAnalysis of the phenomenon of human aging in its individual, social, and cultural aspects with special attention to the problems of aging populations in Western societies.",
    "credits": "3"
  },
  {
    "course_name": "The Sociology of Women",
    "dept": "SOCIO",
    "num": "545",
    "desc": "Prerequisite: SOCIO 211.\nExamines patterns of gender in contemporary society and corresponding experiences of women. The course emphasizes both interactional and structural approaches and provides an overview of theoretical work in the field. Particular attention is paid to how gender interacts with ethnicity, class, and sexuality.",
    "credits": "3"
  },
  {
    "course_name": "Bureaucracy in Modern Societies",
    "dept": "SOCIO",
    "num": "546",
    "desc": "Prerequisite: SOCIO 211.\nThe nature and types of bureaucratic organizations in modern societies. Selected aspects of their internal structure, such as peer group and hierarchical relations in organizations, processes of communication, management, and impersonal mechanisms of control.",
    "credits": "3"
  },
  {
    "course_name": "Technocrime, Security, and Society",
    "dept": "SOCIO",
    "num": "550",
    "desc": "\nCritically examines the social and cultural issues surrounding technology, crime, deviance, and crime control, including hackers, digital activists, online fraudsters, techno security agents, and other actors and subcultures from sociological and criminological perspectives.",
    "credits": "3"
  },
  {
    "course_name": "Criminology",
    "dept": "SOCIO",
    "num": "561",
    "desc": "Prerequisite: SOCIO 361 or SOCIO 431.\nAddresses basic concepts, theories, and research methods used in the study of crime, with an emphasis on critical perspectives on crime as a social phenomenon. The course provides an overview of the nature and extent of major categories of crime as well as the integration of current issues dealing with crime.",
    "credits": "3"
  },
  {
    "course_name": "Study of Serial Murder",
    "dept": "SOCIO",
    "num": "562",
    "desc": "\nThe course critically examines the social construction of serial murder as a phenomenon that has long existed but only recently has been polarized as a concern of the criminal justice system and the public in general. The objective of the course is to synthesize historical and social scientific analysis of serial murder, assess public and media debates centered on both offenders and victims, and evaluate the portrayal of serial murder in contemporary literature and film.",
    "credits": "3"
  },
  {
    "course_name": "Program and Policy Formulation and Analysis",
    "dept": "SOCIO",
    "num": "565",
    "desc": "Prerequisite: SOCIO 510.\nExamination of policies and programs developed to cope with various social problems. Emphasis will be on analysis of existing programs and policies and the formulation of alternative policies. Attention will be given to policy change through legislative action.",
    "credits": "3"
  },
  {
    "course_name": "Pre-Internship Orientation",
    "dept": "SOCIO",
    "num": "567",
    "desc": "Prerequisite: SOCIO 520.\nThis course prepares students for internship placements. Resumes are written, interview procedures discussed, agency interviews conducted, internships selected, and agency orientation completed.",
    "credits": "1"
  },
  {
    "course_name": "Criminology and Sociology Internship",
    "dept": "SOCIO",
    "num": "568",
    "desc": "Prerequisite: SOCIO 567.\nSupervised field experience in various agencies within the criminal justice systems or other public or private organizations in areas involving applied sociological analysis or practice. Criminology majors wishing to pursue careers in the field of criminal justice are strongly encouraged to complete an internship. General sociology students may take this course under the direction of a faculty member who agrees to serve as their internship advisor. Does not fulfill sociology or criminology elective requirements.",
    "credits": "6-9"
  },
  {
    "course_name": "Criminology and Sociology Professional Seminar",
    "dept": "SOCIO",
    "num": "569",
    "desc": "Prerequisite: SOCIO 567.\nIntegrates field experience and everyday practices with relevant bodies of sociological and criminological theory and research.  Must be taken concurrent with SOCIO 568.",
    "credits": "3"
  },
  {
    "course_name": "Race and Ethnic Relations in the USA",
    "dept": "SOCIO",
    "num": "570",
    "desc": "Prerequisite: SOCIO 211.\nThis survey of racial and ethnic relations focuses on discrimination and conflict now as well as on background factors of the past to enlarge understanding of dominant and minority groups.",
    "credits": "3"
  },
  {
    "course_name": "Sociology of the Death Penalty",
    "dept": "SOCIO",
    "num": "572",
    "desc": "\nStudies data, public opinion, execution patterns and methods, and debates regarding capital punishment as public policy in the U.S. from early history to 21st century.  Examines selected cases and issues such as general deterrence, methods of execution, and constitutional challenges.",
    "credits": "3"
  },
  {
    "course_name": "The Construction of the Criminal Mind",
    "dept": "SOCIO",
    "num": "582",
    "desc": "\nExamines interaction between social forces and physical experiences, such as cognitive impairment and/or abuse.  Critically reviews history of criminology and biological theories of crime; explores how remnants of these feature in current explanations of crime.",
    "credits": "3"
  },
  {
    "course_name": "Anatomy of Mass Murder",
    "dept": "SOCIO",
    "num": "592",
    "desc": "\nExamines a specific kind of murder, killing of four or more people in a single incident. Examines the killers’ pathways, the weapons, and especially the social context of mass murder.",
    "credits": "3"
  },
  {
    "course_name": "Senior Thesis in Sociology",
    "dept": "SOCIO",
    "num": "599",
    "desc": "Prerequisite: SOCIO 423; SOCIO 431, and instructor consent.\nIndependent research in sociology. Students conduct original research and produce a senior thesis in sociology.",
    "credits": "3-6"
  },
  {
    "course_name": "Religion in Culture",
    "dept": "SOCIO",
    "num": "618",
    "desc": "Prerequisite: ANTH 200 or SOCIO 211.\nThe nature of religion and its manifestations in different cultural systems.",
    "credits": "3"
  },
  {
    "course_name": "Gender, Power, and International Development",
    "dept": "SOCIO",
    "num": "633",
    "desc": "Prerequisite: SOCIO 211 or ANTH 200 and 3 additional hours in sociology or cultural anthropology.\nExamination of various models of development and their impact on roles of women and men in various cultures. Emphasis upon Africa, Asia, and Latin America. Comparisons of public, service, and economic sectors, including agriculture, marketing, and industry. Examination of policy issues.",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Human Trafficking",
    "dept": "SOCIO",
    "num": "635",
    "desc": "\nThe course explores a range of topics related to human trafficking, anti-trafficking institutions, and legislation in the context of globalization. Analysis of contemporary forms of slavery-like practices (forced labor, child trafficking, domestic servitude, and others), with primary focus on sex trafficking of women.",
    "credits": "3"
  },
  {
    "course_name": "Sociology of the Family",
    "dept": "SOCIO",
    "num": "640",
    "desc": "Prerequisite: SOCIO 211.\nOrigin and development of marriage customs and systems of family organization; the preparation for family life under present conditions.",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Religion",
    "dept": "SOCIO",
    "num": "643",
    "desc": "Prerequisite: SOCIO 211.\nThe role of religion as an institution in American society. An assessment of the functions of religion and an exploration of contemporary trends and movements, including information on traditional denominations and emerging sects and cults.",
    "credits": "3"
  },
  {
    "course_name": "Post-Communist Societies",
    "dept": "SOCIO",
    "num": "645",
    "desc": "Prerequisite: SOCIO 211.\nAnalysis of divergent scenarios of post-communist social transformation, primarily in the countries of Eastern Europe and Eurasia. Discussion of the history of communist societies, changing social institutions, and social stratification in the post-communist contexts.  Examines post-communist space and mobility, class and gender inequalities, political democratization, youth culture and prospects, crime, global connections of the transformation, human rights and  civil society, security and conflict, religion and ethnicity, and the changing family.",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Work",
    "dept": "SOCIO",
    "num": "647",
    "desc": "Prerequisite: SOCIO 211 and junior standing.\nAnalysis of the world of work, both paid and unpaid. Examines changes that affect the organization of work and the distribution of income, and examines how change alters class, gender, and ethnic relations.",
    "credits": "3"
  },
  {
    "course_name": "Women and Crime",
    "dept": "SOCIO",
    "num": "665",
    "desc": "Prerequisite: SOCIO 561 or SOCIO 545 or other gender, women, and sexuality studies course at the 500-level or above.\nNature and extent of criminal offending among women and women offenders’ interactions with legal and criminal justice systems; women’s victimization, including rape and intimate violence; women workers in the criminal justice system, specifically in law, policing, and prison work.",
    "credits": "3"
  },
  {
    "course_name": "Diversity and Social Interaction in the Workplace",
    "dept": "SOCIO",
    "num": "670",
    "desc": "Prerequisite: 6 hours of social science.\nExamines changes in the world of work; examines various contexts of work, such as business, the professions, education, and home; analyzes the social organization of work, both in terms of formal arrangements, such as authority and hierarchy, and in terms of informal structure, such as gender, race, class, and other categories of social difference; provides hands-on experience in dealing with interpersonal relations, management styles, communication, diversity issues, and conflict and stress management.",
    "credits": "3"
  },
  {
    "course_name": "Problems in Sociology",
    "dept": "SOCIO",
    "num": "701",
    "desc": "Prerequisite: SOCIO 211 and junior standing.",
    "credits": "1-18"
  },
  {
    "course_name": "International Migration",
    "dept": "SOCIO",
    "num": "738",
    "desc": "\nA comprehensive examination of international migration dynamics with a focus on immigration to the United States. Introduces current theoretical debate on migration and examines global migration trends, integration and community formation of immigrants, construction of immigration policies, and impacts on United States society.",
    "credits": "3"
  },
  {
    "course_name": "Society and Change in South Asia",
    "dept": "SOCIO",
    "num": "742",
    "desc": "Prerequisite: SOCIO 211 or ANTH 200 and either a 500-level course in South Asian studies or one in social change and development.\nExamines recent studies of family and community, population, mobility, urbanization, and modernization in the India-Pakistan region, with focus on social change.",
    "credits": "3"
  },
  {
    "course_name": "Social Work: The Helping Profession",
    "dept": "SOCWK",
    "num": "100",
    "desc": "\nAn introduction to the profession of social work and the various fields of social service by observing, experiencing, and analyzing social work and its place in society. An opportunity for the student to test social work as a possible career choice.",
    "credits": "3"
  },
  {
    "course_name": "Basic Skills for Working with People",
    "dept": "SOCWK",
    "num": "200",
    "desc": "\nCourse develops basic skill components for the helping professions. Students learn fundamentals of interpersonal communication.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Social Work",
    "dept": "SOCWK",
    "num": "310",
    "desc": "Prerequisite: Consent of the instructor.\nSupervised independent study projects.",
    "credits": "1-3"
  },
  {
    "course_name": "Fundamentals of Communication for the Agriculture and Food Science Community",
    "dept": "SOCWK",
    "num": "312",
    "desc": "\nThis course develops communication skills among the scientific community to improve discourse with lay persons. Fundamentals of active listening as well as techniques to diffuse tense situations are addressed.",
    "credits": "3"
  },
  {
    "course_name": "Human Behavior in the Social Environment I",
    "dept": "SOCWK",
    "num": "315",
    "desc": "Prerequisite: Two courses in the social sciences and sophomore standing.\nAn introduction to the relationship among biological, social, psychological, and cultural systems as they affect or are affected by human behavior as it relates to social world models of practice. Emphasis on social systems understanding of human development.",
    "credits": "3"
  },
  {
    "course_name": "Dynamics of Working with Older Adults",
    "dept": "SOCWK",
    "num": "320",
    "desc": "Prerequisite: ENGL 100 and PSYCH 110.\nThis course will provide students in all fields a unique foundation upon which successful interaction with older adults is built. Specific communication techniques will be taught along with the knowledge, skills and values necessary to understand working with, or on the behalf of, older consumers, clients, patients and family members.",
    "credits": "3"
  },
  {
    "course_name": "Social Work Research Methods and Analysis I",
    "dept": "SOCWK",
    "num": "330",
    "desc": "Prerequisite: SOCWK 100 and MATH 100.\nFirst of two research courses. Emphasis on social work research methodology and statistical analysis of small sample data sets. Content examines the ethics and processes of research.",
    "credits": "3"
  },
  {
    "course_name": "Substance Abuse Case Management and Holistic Recovery",
    "dept": "SOCWK",
    "num": "360",
    "desc": "\nIntroduction to the concept of case management and the role case managers play in helping persons with substance use disorders obtain and maintain recovery.",
    "credits": "3"
  },
  {
    "course_name": "Honors Project",
    "dept": "SOCWK",
    "num": "499",
    "desc": "\nOpen only to Arts &amp; Sciences students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Proficiency Development",
    "dept": "SOCWK",
    "num": "501",
    "desc": "Prerequisite: Consent of instructor and superior performance in relevant course.\nIntegrative review of social work concepts and skills under faculty supervision.",
    "credits": "1-3"
  },
  {
    "course_name": "Social Welfare as a Social Institution",
    "dept": "SOCWK",
    "num": "510",
    "desc": "Prerequisite: One course in each of the following areas: sociology, economics, and political science.\nThe development and present status of social welfare in meeting changing human needs and the requirements in other parts of our social system; the analysis of present-day philosophy and the functions of social welfare.",
    "credits": "3"
  },
  {
    "course_name": "Social Work Research Methods and Analysis II",
    "dept": "SOCWK",
    "num": "530",
    "desc": "Prerequisite: SOCWK 330.\nSecond of two research methods courses. Emphasis on designing and conducting social work research projects appropriate for baccalaureate social work practice. Attention given to research strategies for the evaluation of social work practice.",
    "credits": "3"
  },
  {
    "course_name": "Field Practicum Preparation",
    "dept": "SOCWK",
    "num": "550",
    "desc": "Prerequisite: Senior standing and instructor permission.\nSocial work majors take this course in the semester before enrollment in SOCWK 562 Field Experience, in preparation for the field practice experience. Students explore various fields of practice and social work settings and work with the instructor to plan their practicum for the following semester.",
    "credits": "3"
  },
  {
    "course_name": "Social Work Practice I",
    "dept": "SOCWK",
    "num": "560",
    "desc": "Prerequisite: SOCWK 100, 200, 315, and 510; junior standing and permission of the instructor.\nContinued development of social work practice skills. The social systems perspective is used to guide the development of a problem-solving methodology with attention to information gathering, assessment, and problem identification. Values clarification and self awareness are emphasized and the skills needed for intervention, termination, and evaluation are introduced.",
    "credits": "3"
  },
  {
    "course_name": "Social Work Practice II",
    "dept": "SOCWK",
    "num": "561",
    "desc": "Prerequisite: SOCWK 560 and senior standing and permission of the instructor.\nContinuation of SOCWK 560 with emphasis on skill development in intervention techniques, and practice evaluation from a social systems perspective. A variety of intervention strategies and techniques is presented with emphasis on the development of a social work frame of reference.",
    "credits": "3"
  },
  {
    "course_name": "Field Experience",
    "dept": "SOCWK",
    "num": "562",
    "desc": "Prerequisite: SOCWK 550 and 561; senior standing; permission of the instructor.\nSupervised field experience in community agencies and programs as a practical application of social work knowledge and skills gained from major course work. Emphasis on direct work with clients, whether individuals, groups, or communities. Seminars make use of student’s experiences to analyze social work theory and practice.",
    "credits": "10"
  },
  {
    "course_name": "The Practice of Social Work in Rural Areas",
    "dept": "SOCWK",
    "num": "563",
    "desc": "Prerequisite: SOCWK 560.\nA review of characteristics and social problems of rural areas. The development of practice competency in social work roles and skills necessary for rural practice.",
    "credits": "3"
  },
  {
    "course_name": "Social Work Professional Seminar",
    "dept": "SOCWK",
    "num": "564",
    "desc": "Prerequisite: To be taken concurrent with SOCWK 562.\nA review of various theories in the behavioral sciences which influence the practice of social work. Primary focus of the course is on the use of these theories in implementing change in various client systems.",
    "credits": "2"
  },
  {
    "course_name": "Social Policy",
    "dept": "SOCWK",
    "num": "565",
    "desc": "Prerequisite: SOCWK 510; one course in each of the following areas: sociology, economics, and political science; and one course in social science research methods.\nExamination of policies and programs developed to cope with various social problems. Emphasis will be placed on analysis of existing programs and policies and the formulation of alternative policies. Attention will be given to policy change through organizational and legislative action.",
    "credits": "3"
  },
  {
    "course_name": "Macro Practice and Theory",
    "dept": "SOCWK",
    "num": "568",
    "desc": "Corequisite: SOCWK 560 (taken concurrently with).\nContinuation of social work practice sequence with focus on skills development for macro-level social work practice and an understanding of macro-systems using the ecological perspective as a framework. Community and organization intervention strategies with emphasis on the development of a social work frame of reference. Focus on institutional racism, institutional discrimination, and the importance of recognizing these functions within society.",
    "credits": "3"
  },
  {
    "course_name": "Social Work with Groups",
    "dept": "SOCWK",
    "num": "570",
    "desc": "Prerequisite: SOCWK 560.\nTaken concurrently with SOCWK 561. Course provides the theoretical framework for effective generalist social work practice with groups, facilitates the development of group leaders who possess an understanding of group dynamics and effective leadership skills through group discussion, experiential exercises and leadership experiences.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Social Work",
    "dept": "SOCWK",
    "num": "610",
    "desc": "Prerequisite: SOCWK 100 plus 6 hours of behavioral science foundation courses and consent of instructor.\nSupervised independent study projects.",
    "credits": "1-3"
  },
  {
    "course_name": "Fundamentals of Communication for the Agriculture and Food Science Community",
    "dept": "SOCWK",
    "num": "612",
    "desc": "\nThis course develops communication skills among the scientific community to improve discourse with lay persons. Fundamentals of active listening as well as techniques to diffuse tense situations are addressed. Students will apply the skills learned to their career field through a final research project.",
    "credits": "3"
  },
  {
    "course_name": "Assessment and Treatment of Substance Use Disorders",
    "dept": "SOCWK",
    "num": "650",
    "desc": "\nComprehensive examination of substance use treatment and rehabilitation includes a thorough examination of the treatment models of addiction, recovery, and relapse.",
    "credits": "3"
  },
  {
    "course_name": "Orientation for Summer School Abroad Program in Zacatecas/Cuernavaca, Mexico",
    "dept": "SPAN",
    "num": "003",
    "desc": "",
    "credits": "0"
  },
  {
    "course_name": "Spanish I",
    "dept": "SPAN",
    "num": "101",
    "desc": "Prerequisite: Less than 1-year previous Spanish study, or permission from Spanish Coordination Office.\nDesigned for students with no prior Spanish experience.  Develops basic language skills and cultural awareness to function in everyday situations in Spanish-speaking communities.  Conducted in Spanish with practice in speaking, listening, reading, and writing.",
    "credits": "5"
  },
  {
    "course_name": "Spanish II",
    "dept": "SPAN",
    "num": "102",
    "desc": "Prerequisite: SPAN 101, 1-2 years high school, or equivalent.\nContinuation of Spanish 1.  Develops basic language skills and cultural awareness to function in everyday situations in Spanish-speaking communities.  Conducted in Spanish with practice in speaking, listening, reading, and writing.",
    "credits": "5"
  },
  {
    "course_name": "Conversational Spanish for the Workplace",
    "dept": "SPAN",
    "num": "110",
    "desc": "\nIntroduction to the basic Spanish conversational skills focusing on everyday language used in the workplace with an emphasis on technical terms and concepts, supplemented with grammar and writing.",
    "credits": "3"
  },
  {
    "course_name": "Spanish III",
    "dept": "SPAN",
    "num": "300",
    "desc": "Prerequisite: SPAN 102, 3-4 years high school or equivalent.\nEnhances skills in reading and analysis to develop intermediate proficiency in Spanish.  Grammatical structures presented in context through literary and informational texts, media, to promote cultural awareness.  Conducted in Spanish.",
    "credits": "5"
  },
  {
    "course_name": "Spanish IV",
    "dept": "SPAN",
    "num": "301",
    "desc": "Prerequisite: SPAN 300, 4-5 years high school, or equivalent.\nBridges to more advanced language, culture, and literature courses.  Grammatical structures studied in context through literary and informational materials.  Conducted in Spanish.  Practice in researching and presenting the history and cultures of Spanish-speaking countries.",
    "credits": "4"
  },
  {
    "course_name": "Spanish IV for Heritage Speakers",
    "dept": "SPAN",
    "num": "302",
    "desc": "\nDesigned for individuals who have been exposed to Spanish from an early age at home. Promotes awareness of linguistic variation in Spanish; exposes students to an academic register; develops basic literary skills, such as spelling and lexicon, so that learners can effectively engage in scholarly contexts and endeavors.",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Studies in Spanish",
    "dept": "SPAN",
    "num": "398",
    "desc": "\nOffered only to participants in study abroad programs. Prior consultation for approval is expected.",
    "credits": "1-18"
  },
  {
    "course_name": "Spanish Composition and Grammar",
    "dept": "SPAN",
    "num": "410",
    "desc": "Prerequisite: SPAN 301 or SPAN 302 or equivalent.\nWriting-intensive course with targeted grammar review to develop written communication abilities in Spanish.  Composing and revising various types of essays, honing usage of grammar and vocabulary, developing research techniques, using Modern Language Association style.",
    "credits": "3"
  },
  {
    "course_name": "Spanish for heritage speakers: Composition and grammar",
    "dept": "SPAN",
    "num": "411",
    "desc": "Prerequisite:  Recommended SPAN 302.\nCourse for heritage speakers of Spanish to improve reading and writing skills, including grammar, and develop a professional and academic knowledge of the language.",
    "credits": "3"
  },
  {
    "course_name": "Spanish Conversation",
    "dept": "SPAN",
    "num": "420",
    "desc": "Prerequisite: SPAN 301 or equivalent.\nIntensive practice in conversation to develop listening and speaking skills, expand vocabulary, and review grammatical structures.",
    "credits": "3"
  },
  {
    "course_name": "Listening Skills",
    "dept": "SPAN",
    "num": "421",
    "desc": "Prerequisites: SPAN 410 or equivalent.\nDevelops aural comprehension skills for communicative situations with focus on Spanish phonetics and interpretation of oral texts within the corresponding cultural context.",
    "credits": "3"
  },
  {
    "course_name": "Professional Spanish: Business",
    "dept": "SPAN",
    "num": "530",
    "desc": "Prerequisite: SPAN 410 or SPAN 411.\nDevelops culturally relevant communication skills in business and professional contexts. Specialized content and vocabulary including professional writing, such as employment materials.",
    "credits": "3"
  },
  {
    "course_name": "Professional Spanish: Health and Human Services",
    "dept": "SPAN",
    "num": "531",
    "desc": "Prerequisite: SPAN 410 or SPAN 411.\nDevelops culturally relevant communication skills in health and human services contexts (including social work, kinesiology, dietetics, education).  Specialized content and vocabulary, community-based learning, and experience in professional writing.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Hispanic Readings and Media",
    "dept": "SPAN",
    "num": "550",
    "desc": "Prerequisite: SPAN 410 or SPAN 411.\nCommunication, critical thinking, and analytical skills applied to Spanish-language literary texts, film, and art. Skill development through conversation, presentations, papers, and creative projects.",
    "credits": "3"
  },
  {
    "course_name": "Cultures of the Spanish-speaking World: U.S. Latinx",
    "dept": "SPAN",
    "num": "560",
    "desc": "Prerequisite: SPAN 410 or SPAN 411.\nExplores the development of literature and other media representing Latinx experiences in the United States since the Mexican-American War.",
    "credits": "3"
  },
  {
    "course_name": "Cultures of the Spanish-speaking World: Spain",
    "dept": "SPAN",
    "num": "565",
    "desc": "Prerequisite: SPAN 550.\nDevelops critical understanding of the historical, political, and social forces that have shaped Spanish literature and culture through interdisciplinary focus on a topic (e.g. cities, music, sport).",
    "credits": "3"
  },
  {
    "course_name": "Cultures of the Spanish-speaking World: Spanish America",
    "dept": "SPAN",
    "num": "566",
    "desc": "Prerequisite: SPAN 550.\nDevelops critical understanding of the historical, political, and social forces that have shaped Spanish-America through interdisciplinary focus on a region or topic (e.g. food identity, journeys, revolutions).",
    "credits": "3"
  },
  {
    "course_name": "Cultures of the Spanish-speaking World: Transatlantic",
    "dept": "SPAN",
    "num": "567",
    "desc": "Prerequisite: SPAN 550 and SPAN 565.\nDevelops critical understanding of the historical, political, social forces that have connected Spanish and Spanish American literatures and cultures over time through interdisciplinary focus on a topic (e.g., conflict, exploration, social class).",
    "credits": "3"
  },
  {
    "course_name": "Literature of Spanish America",
    "dept": "SPAN",
    "num": "568",
    "desc": "Prerequisite: SPAN 550 and SPAN 566.\nAnalysis of representative works of Spanish American literature from the pre-Columbian period to the present.  Develops an understanding of historical and cultural context within the framework of Spanish American literary criticism.",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in Spanish",
    "dept": "SPAN",
    "num": "569",
    "desc": "Prerequisite: Consent of department head and instructor involved.",
    "credits": "1-18"
  },
  {
    "course_name": "Introduction to Spanish Translation",
    "dept": "SPAN",
    "num": "575",
    "desc": "Prerequisite: Minimum of 3 credit hours at the 500 level or instructor permission.\nIntroduction to concepts of translation, including aspects of history, theory, and professional ethics.  Practice in bi-directional translation [Spanish-English-Spanish] of a variety of texts in different genres including literature.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Spanish Linguistics",
    "dept": "SPAN",
    "num": "580",
    "desc": "Prerequisite: Minimum of 3 hours at the 500 level or instructor permission.\nIntroduction to the fundamentals of linguistic analysis, including the sound system, word and sentence formation, and semantic and pragmatic meaning.  Formal and usage-based perspectives.  Application of linguistics to language acquisition theory and to pedagogy.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Spanish Grammar",
    "dept": "SPAN",
    "num": "670",
    "desc": "Prerequisite: SPAN 410 or equivalent.\nIntensive study of the structures of the Spanish Language for communicative and pedagogical purposes.  Comparison/contrast to English structures.",
    "credits": "3"
  },
  {
    "course_name": "Medieval Spanish Literature",
    "dept": "SPAN",
    "num": "730",
    "desc": "Prerequisite: SPAN 567 or 568.  SPAN 565 recommended.",
    "credits": "3"
  },
  {
    "course_name": "Early Modern Literature of Spain",
    "dept": "SPAN",
    "num": "731",
    "desc": "Prerequisite: SPAN 550 and 6 additional hours at the 500-level or instructor permission.\nContextualized discussion and analysis of literature and cultural life in 15th-17th-century Spain. Course may be focused on a theme, genre, or writer (such as Miguel de Cervantes).",
    "credits": "3"
  },
  {
    "course_name": "Cervantes",
    "dept": "SPAN",
    "num": "732",
    "desc": "Prerequisite: SPAN 567 or 568.  SPAN 565 recommended.\nReading and discussion of the works of Cervantes and of his literary and cultural background.",
    "credits": "3"
  },
  {
    "course_name": "19th-Century Spain",
    "dept": "SPAN",
    "num": "734",
    "desc": "Prerequisite: SPAN 550 and 6 additional hours at the 500-level or instructor permission.\nContextualized discussion and analysis of literature and cultural life in 18th-19th-century Spain. Course may be focused on a theme, genre, or movement (Enlightenment, Romanticism, Realism, Naturalism). Topics may include anticlericalism and Catholicism; revolution and empire; scientific reasoning.",
    "credits": "3"
  },
  {
    "course_name": "20th- and 21st-Century Spain",
    "dept": "SPAN",
    "num": "735",
    "desc": "Prerequisite: SPAN 550 and 6 additional hours at the 500-level or instructor permission.\nContextualized discussion and analysis of contemporary Spanish literature and cultural life. Course may be focused on a theme or genre (e.g., the Generation of ‘27, the Spanish Civil War, the Franco dictatorship and transition to democracy, feminism, or immigration).",
    "credits": "3"
  },
  {
    "course_name": "Spanish Poetry",
    "dept": "SPAN",
    "num": "736",
    "desc": "Prerequisite: SPAN 567 or 568. SPAN 565 recommended.",
    "credits": "3"
  },
  {
    "course_name": "Spanish American Narrative",
    "dept": "SPAN",
    "num": "750",
    "desc": "Prerequisite: SPAN 550 and 6 additional hours at the 500-level or instructor permission.\nContextualized discussion and analysis of literary and cultural narratives over time, focused on a theme or region. Topics may include cultural encounters, illness and disability, ecology, modernity.",
    "credits": "3"
  },
  {
    "course_name": "Spanish-American Narrative: Early Twentieth Century",
    "dept": "SPAN",
    "num": "751",
    "desc": "Prerequisite: SPAN 567 or 568. SPAN 565 recommended.",
    "credits": "3"
  },
  {
    "course_name": "Spanish American Topics",
    "dept": "SPAN",
    "num": "752",
    "desc": "Prerequisite: SPAN 550 and 6 additional hours at the 500-level or instructor permission.\nInterdisciplinary exploration of a Spanish American political, social, or cultural issue over time. Examples: memory and testimonio, utopia and dystopia, gender and sexuality. Includes literary readings and media.",
    "credits": "3"
  },
  {
    "course_name": "Spanish American Performance Studies",
    "dept": "SPAN",
    "num": "755",
    "desc": "Prerequisite: SPAN 550 and 6 additional hours at the 500-level or instructor permission.\nContextualized interdisciplinary approach to performance studies in Spanish America. Discussion and analysis of plays and other performative events (political protests, rituals, installations). May focus on a time period, region, or theme.",
    "credits": "3"
  },
  {
    "course_name": "Spanish-American Poetry",
    "dept": "SPAN",
    "num": "757",
    "desc": "Prerequisite: SPAN 550 and additional 6 hours at the 500-level or instructor permission.\nContextualized discussion of Spanish American poetry over time, focused on a theme or region. Examples: musicality and song lyrics, places and journeys, voice and identity, innovation.",
    "credits": "3"
  },
  {
    "course_name": "U.S. Latinx/a Literature and Culture in Spanish",
    "dept": "SPAN",
    "num": "760",
    "desc": "Prerequisite: SPAN 550 and 6 additional hours at the 500-level or instructor permission.\nExamines the border as a metaphorical concept in Latinx literature and culture. Analysis of literary texts and media that explore intersecting identities, languages, and counter-traditions that shape the Latinx cultural legacy in the U.S.",
    "credits": "3"
  },
  {
    "course_name": "Hispanic Cinema",
    "dept": "SPAN",
    "num": "768",
    "desc": "Prerequisite: SPAN 550 and 6 additional hours at 500-level or instructor permission.\nCritical analysis of films representing a selected region, period, or theme, within their theoretical, cultural, socio-political and historic contexts.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Spanish Translation",
    "dept": "SPAN",
    "num": "771",
    "desc": "Prerequisite: SPAN 575 or senior level.\nAnalysis and practice in bi-directional translation [Spanish-English-Spanish] of a variety of texts from a number of genres, including literary texts.  Discussion of professional opportunities for translators and interpreters.  Development of personal portfolio.",
    "credits": "3"
  },
  {
    "course_name": "Spain Today",
    "dept": "SPAN",
    "num": "772",
    "desc": "Prerequisite: Minimum of 3 hours at the 700-level or instructor permission.\nExplores key issues of contemporary Spain including the legacy of the Spanish Civil War. Interdisciplinary focus on a topic, such as regional tensions, economics, politics. Representative literary texts and media serve as a basis for developing a critical view of the region.",
    "credits": "3"
  },
  {
    "course_name": "Spanish America Today",
    "dept": "SPAN",
    "num": "773",
    "desc": "Prerequisite: Minimum of 3 hours at the 700-level or instructor permission.\nFocus on the most significant cultural, social, political, ecological and economic issues affecting Spanish America in recent years.  Representative literary texts and media serve as a basis for developing a critical view of the region.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Spanish-English Translation/Interpreting",
    "dept": "SPAN",
    "num": "774",
    "desc": "Prerequisite: SPAN 575 or SPAN 771.\nTheory, strategies, terminology, and practice in a designated field in Spanish&lt;&gt;English translation and/or interpreting (fields: healthcare, literary translation, legal, technical and scientific community interpreting).",
    "credits": "3"
  },
  {
    "course_name": "History of the Spanish Language",
    "dept": "SPAN",
    "num": "776",
    "desc": "Prerequisite: SPAN 565 or 566 or 567 or 568.\nThe development of Spanish from Latin to its present-day variation in the Spanish-speaking world.  Influence of and interaction with world cultures and languages across time.",
    "credits": "3"
  },
  {
    "course_name": "Hispanic Cultures and Literatures: Teaching Strategies",
    "dept": "SPAN",
    "num": "777",
    "desc": "Prerequisite: SPAN 565 or 566 or 567 or 568.\nAn integrated teaching program that develops linguistic, cultural and literary skills through the analysis and interpretation of texts from Spain and Spanish-America.  Emphasis on student-centered cooperative and collaborative learning. Reading- and writing-intensive class.",
    "credits": "3"
  },
  {
    "course_name": "Selected Topics in Spanish",
    "dept": "SPAN",
    "num": "779",
    "desc": "Prerequisite: SPAN 565 or 566 or 567 or 568.\nIn depth exploration of a special cultural, linguistic and/or literary subject. Reading- and writing-intensive class.",
    "credits": "3"
  },
  {
    "course_name": "Research Topics in Spanish",
    "dept": "SPAN",
    "num": "799",
    "desc": "\nA seminar with variable topics.",
    "credits": "1-18"
  },
  {
    "course_name": "Statistical Literacy in the Age of Information",
    "dept": "STAT",
    "num": "100",
    "desc": "Prerequisite: MATH 100.\nThis course is intended for majors in non-quantitative fields. Focus will be on the development of an awareness of statistics at the conceptual and interpretative level, in the context of everyday life. Data awareness and quality, sampling, scientific investigation, decision making, and the study of relationships are included. Emphasis will be on the development of critical thinking through in-class experiments and activities, discussions, analysis of real data sets, written reports, and collaborative learning. Computing activities will be included where appropriate; no previous computing experience required.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Statistics",
    "dept": "STAT",
    "num": "325",
    "desc": "Prerequisite: MATH 100.\nA project-oriented first course in probability and statistics with emphasis on computer analysis of data.  Examples selected primarily from social sciences, natural sciences, education and popular culture.  Descriptive statistics, probability, sampling, tests of hypothesis and confidence intervals for means and proportions, design and analysis of simple comparative studies, chi-square test for association, correlation and linear regression.",
    "credits": "3"
  },
  {
    "course_name": "Biometrics I",
    "dept": "STAT",
    "num": "340",
    "desc": "Prerequisite: MATH 100.\nA basic first course in probability and statistics with textbook, examples, and problems aimed toward the biological sciences. Frequency distributions, averages, measures of variation, probability, confidence intervals; tests of significance appropriate to binomial, multinomial, Poisson, and normal sampling; simple regression and correlation.",
    "credits": "3"
  },
  {
    "course_name": "Biometrics II",
    "dept": "STAT",
    "num": "341",
    "desc": "Prerequisite: STAT 325 or STAT 340 or STAT 350.\nAnalysis and interpretation of biological data using analysis of variance, analysis of covariance, and multiple regression. Negative binomial distribution and its applications.",
    "credits": "3"
  },
  {
    "course_name": "Business and Economic Statistics I",
    "dept": "STAT",
    "num": "350",
    "desc": "Prerequisite: MATH 100.\nA basic first course in probability and statistics with textbook, examples, and problems pointed toward business administration and economics. Frequency distributions, averages, index numbers, time series, measures of variation, probability, confidence intervals, tests of significance appropriate to binomial, multinomial, Poisson, and normal sampling; simple regression and correlation.",
    "credits": "3"
  },
  {
    "course_name": "Business and Economic Statistics II",
    "dept": "STAT",
    "num": "351",
    "desc": "Prerequisite: STAT 325, 340 or 350.\nContinuation of STAT 350 including study of index numbers, time series, business cycles, seasonal variation, multiple regression and correlation, forecasting; some nonparametric methods applicable in business and economic studies.",
    "credits": "3"
  },
  {
    "course_name": "Honors Seminar in Statistics",
    "dept": "STAT",
    "num": "399",
    "desc": "\nSelected topics.",
    "credits": "3"
  },
  {
    "course_name": "Probabilistic Systems Modeling",
    "dept": "STAT",
    "num": "410",
    "desc": "Prerequisite: MATH 221 and CIS 300.\nDescriptive statistics and graphical methods; basic probability; probability distributions; several random variable; Poisson processes; computer simulation of random phenomena; confidence interval estimation; hypothesis testing.",
    "credits": "3"
  },
  {
    "course_name": "Statistics for Engineers",
    "dept": "STAT",
    "num": "490",
    "desc": "\nFirst course in statistics with examples and problems toward engineering. Distributions, means, measures of variation, confidence intervals, graphical display of data, simple regression and correlation, philosophy of experimentation.",
    "credits": "1"
  },
  {
    "course_name": "Statistics for Engineers II",
    "dept": "STAT",
    "num": "491",
    "desc": "Prerequisite: STAT 490.\nA continuation of STAT 490. Offered second half of the semester following STAT 490. Statistical tests, multiple regression, model fitting, simple comparative and factorial experiments. Emphasis on computer analysis of data.",
    "credits": "1"
  },
  {
    "course_name": "Honors Project",
    "dept": "STAT",
    "num": "499",
    "desc": "\nOpen only to Arts and Science students who are active members of the University Honors Program.",
    "credits": "3"
  },
  {
    "course_name": "Introductory Probability and Statistics I",
    "dept": "STAT",
    "num": "510",
    "desc": "Prerequisite: MATH 221.",
    "credits": "3"
  },
  {
    "course_name": "Introductory Probability and Statistics II",
    "dept": "STAT",
    "num": "511",
    "desc": "Prerequisite: STAT 510.\nLaw of Large Numbers, Chebycheff’s Inequality; continuation of study of continuous variates; uniform, exponential, gamma, and beta distribution; Central Limit Theorem; distributions from normal sampling; introduction to statistical inference.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Mathematical Statistics I",
    "dept": "STAT",
    "num": "610",
    "desc": "Prerequisite: MATH 222.\nDevelopment of axiomatic probability; univariate and multivariate random variables and their probability distribution functions; conditional distributions and independent  random variables; methods of transformation for distributions of functions of random variables; convergence in distribution and probability.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Mathematical Statistics II",
    "dept": "STAT",
    "num": "611",
    "desc": "Prerequisite: STAT 610.\nEstimation of probability distribution parameters by maximum likelihood, Bayesian and bootstrap methods; minimum variance unbiased estimation based on sufficient statistics; mean squared error and consistency of estimators; confidence interval estimation; statistical tests of hypotheses by likelihood ratios; most powerful tests; distribution-free inference; applications to regression models and categorical data.",
    "credits": "3"
  },
  {
    "course_name": "Fundamental Methods of Biostatistics",
    "dept": "STAT",
    "num": "701",
    "desc": "\nA course emphasizing concepts and practice of statistical data analysis for the health sciences.  Basic techniques of descriptive and inferential statistical methods applied to health related surveys and designed experiments.  Populations and samples, parameters and statistics; sampling distributions for hypothesis testing and confidence intervals for means and proportions involving one sample, paired samples and multiple independent samples; odds ratios, risk ratios, simple linear regression.  Use of statistical software to facilitate the collection, manipulation, analysis and interpretation of  health related data.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Statistical Methods for the Sciences",
    "dept": "STAT",
    "num": "703",
    "desc": "Prerequisite: Junior standing and equivalent of college algebra.\nStatistical concepts and methods applied to experimental and survey research in the sciences; tests of hypotheses, parametric and rank tests; point estimation and confidence intervals; linear regression; correlation; one-way analysis of variance; contingency tables, chi-square tests.",
    "credits": "3"
  },
  {
    "course_name": "Regression and Analysis of Variance",
    "dept": "STAT",
    "num": "705",
    "desc": "Prerequisite: One previous statistics course.\nSimple and multiple linear regression, analysis of covariance, correlation analysis, one-, two- and three-way analysis of variance; multiple comparisons; applications including use of computers; blocking and random effects.",
    "credits": "3"
  },
  {
    "course_name": "Basic Elements of Statistical Theory",
    "dept": "STAT",
    "num": "706",
    "desc": "Prerequisite: MATH 205, 210 or 220 and STAT 325 or equivalent.\nThe mathematical representation of frequency distributions, their properties, and the theory of estimation and hypothesis testing. Elementary mathematical functions are used to illustrate theory.",
    "credits": "3"
  },
  {
    "course_name": "Sample Survey Methods",
    "dept": "STAT",
    "num": "710",
    "desc": "Prerequisite: STAT 510 or 770.\nDesign, conduct, and interpretation of sample surveys.",
    "credits": "3"
  },
  {
    "course_name": "Applied Linear Statistical Models",
    "dept": "STAT",
    "num": "713",
    "desc": "Prerequisite: Prior knowledge of matrix or linear algebra and one prior course in statistics.  A student may not receive credit for both the STAT 705 sequence and STAT 713.",
    "credits": "3"
  },
  {
    "course_name": "Nonparametric Statistics",
    "dept": "STAT",
    "num": "716",
    "desc": "Prerequisite: STAT 705 or STAT 713.\nHypothesis testing when form of population sampled is unknown: rank, sign, chi-square, and slippage tests; Kolmogorov and Smirnov type tests; confidence intervals and bands.",
    "credits": "3"
  },
  {
    "course_name": "Categorical Data Analysis",
    "dept": "STAT",
    "num": "717",
    "desc": "Prerequisite: STAT 705 or STAT 713.\nAnalysis of categorical count and proportion data. Topics include tests of association in two-way tables; measures of association; Cochran-Mantel-Haenzel tests for 3-way tables; generalized linear models; logistic regression; loglinear models.",
    "credits": "3"
  },
  {
    "course_name": "Design of Experiments",
    "dept": "STAT",
    "num": "720",
    "desc": "Prerequisite: STAT 705 or STAT 713.\nPlanning experiments so as to minimize error variance and avoid bias; Latin squares; split-plot designs; switch-back or reversal designs; incomplete block designs; efficiency.",
    "credits": "3"
  },
  {
    "course_name": "Statistical Designs for Product Development and Process Improvement",
    "dept": "STAT",
    "num": "722",
    "desc": "Prerequisite: STAT 705 or STAT 511 or STAT 713.\nA study of statistically designed experiments which have proven useful in product development and process improvement. Topics include randomization, blocking, factorial treatment structures, factional factorial designs, screening designs, and response surface methods.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the SAS Computing",
    "dept": "STAT",
    "num": "725",
    "desc": "Prerequisite: One prior course in Statistics.\nTopics may include basic environment and syntax, reading and importing data from files, writing and exporting data to files, data manipulation, basic graphics, and built-in and user-defined functions.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to R Computing",
    "dept": "STAT",
    "num": "726",
    "desc": "Prerequisite: One prior level course in Statistics.\nTopics may include basic environment and syntax, reading and importing data from files, data manipulation, basic graphics, and built-in and user-defined functions.",
    "credits": "1"
  },
  {
    "course_name": "Statistical Computing/Numerical Methods of Statistics",
    "dept": "STAT",
    "num": "727",
    "desc": "Prerequisite:  STAT 726  and (STAT 771 or STAT 511).\nTopics may include efficient programming techniques, generating data from non-standard distributions, designing simulation studies, resampling methods, creating and using functions and subroutines, parallel computing in statistics, interfacing lower-level languages (e.g., C, C++, Fortran) with data analysis software (e.g., SAS, R), computational complexity, convergence analysis of algorithms.",
    "credits": "3"
  },
  {
    "course_name": "Multivariate Statistical Methods",
    "dept": "STAT",
    "num": "730",
    "desc": "Prerequisite: STAT 705 or STAT 713.\nMultivariate analysis of variance and covariance; classification and discrimination; principal components and introductory factor analysis; canonical correlation; digital computing procedures applied to data from natural and social sciences.",
    "credits": "3"
  },
  {
    "course_name": "Bioassay",
    "dept": "STAT",
    "num": "736",
    "desc": "Prerequisite: STAT 705 or STAT 713.\nDirect assays; quantitative dose-response models; parallel line assays; slope ratio assays; experimental designs for bioassay; covariance adjustment; weighted estimates; assays based on quantal responses.",
    "credits": "2"
  },
  {
    "course_name": "Statistical Graphics",
    "dept": "STAT",
    "num": "745",
    "desc": "Prerequisite: STAT 705 or equivalent.\nVisual display of quantitative information. Statistical graphics topics to include visual perception, basic graphics construction, quantitative univariate to multivariate statistical graphics, trellis displays, introduction to smoothing and graphics, introduction to density estimation and graphics, and categorical graphics. Modern graphics software will be used.",
    "credits": "3"
  },
  {
    "course_name": "Studies in Probability and Statistics",
    "dept": "STAT",
    "num": "750",
    "desc": "Prerequisite: Instructor consent.\nStudies of topics in probability, statistics, experimental design, stochastic processes, or other topics.",
    "credits": "1-4"
  },
  {
    "course_name": "Optimization for Data Science",
    "dept": "STAT",
    "num": "760",
    "desc": "Prerequisite:  STAT 511 or STAT 771, and prior knowledge of linear algebra and matrix theory (e.g., MATH 551), and some programming knowledge (e.g., STAT 726).\nThe class presents the theory and algorithms for linear and nonlinear optimization problems with continuous variables.  Topics covered include convex analysis, first- and second-order optimality methods, duality, KKT conditions, algorithms for unconstrained optimization, linearly and nonlinearly constrained problems, and convergence rates of algorithms.  The theory and algorithms are applied to data science problems arising in machine learning, statistics, and related fields (e.g., maximizing likelihood and penalized likelihood functions, MM algorithms, EM algorithms, model selection, Sparse PCA). Students are expected to be comfortable with rigorous mathematical arguments.",
    "credits": "3"
  },
  {
    "course_name": "Discrete Optimization and Scalability for Data Science",
    "dept": "STAT",
    "num": "761",
    "desc": "Prerequisites:  (STAT 705 or STAT 713) and STAT 720 and programming knowledge (e.g. STAT 726).\nTopics covered include computational complexity, NP-hardness, data as networks, graph theoretic algorithms, exact, approximation, heuristic and online algorithms, and connections between convex and non-convex optimization problems.  The theory and algorithms are applied to data science problems arising in statistical machine learning, statistical clustering, design of experiments, observational studies, sampling, and variable selection.  Applications may be motivated using data from social networks, search engines, the stock market and elections.",
    "credits": "3"
  },
  {
    "course_name": "Applied Spatio-Temporal Statistics",
    "dept": "STAT",
    "num": "764",
    "desc": "Prerequisites: (STAT 510 or STAT 770), and (STAT 705, or STAT 713), and STAT 726 or equivalent.\nConstruction and analysis of spatial, time-series, and spatio-temporal data sets.  Topics include data generation using geographic information systems, exploratory data analysis and visualization, and descriptive and dynamic spatio-temporal statistical models.  For context, a focus will be on biological or ecological data.",
    "credits": "3"
  },
  {
    "course_name": "Applied Data Mining/Machine Learning and Predictive Analytics",
    "dept": "STAT",
    "num": "766",
    "desc": "Prerequisites: STAT 705 or STAT 713 or STAT 717, and prior computer programming proficiency on C, C++, Fortran, R, or Python (e.g., CIS 209, STAT 726).\nAddresses the complete process of building analytical tools suitable for learning from data, including automatic online data collection, feature extraction, supervised and unsupervised statistical machine learning methods, evaluation, and report writing.  Automatic retrieval of various format online data, including JSON, REST, and Streaming API, http(s), html, xml, and databases.  Statistical text processing/mining, state of the art supervised and unsupervised data mining methods, case studies and applications to business, government,social and news media data.  Methods include regularized linear and logistic regression, classification trees, nearest neighbor methods, support vector machines, naive Bayes, random forests, boosting/bagging/AdaBoost, clustering, latent Dirichlet allocation, network analysis, and topic modeling models.",
    "credits": "3"
  },
  {
    "course_name": "Applied Bayesian Modeling and Prediction",
    "dept": "STAT",
    "num": "768",
    "desc": "Prerequisites: (STAT 705 or STAT 713), and (STAT 510 or STAT 770).\nBayes rule, principles of Bayesian inference, Bayesian perspective on statistical models, posterior distribution computations using simulations, Markov Chain Monte Carlo (MCMC) (including Gibbs sampling, Metropolis-Hastings algorithm, slice sampler, hybrid forms and alternative algorithms), convergence monitoring and diagnosis, hierarchical models, model checking and model selection, and applications in the sciences using computer software such as R and WinBUGS.",
    "credits": "3"
  },
  {
    "course_name": "Theory of Statistics I",
    "dept": "STAT",
    "num": "770",
    "desc": "Prerequisite: MATH 222.\nProbability models, concepts of probability, random discrete variables, moments and moment generating functions, bivariate distributions, continuous random variables, sampling. Central Limit Theorem, characteristic functions. More emphasis on rigor and proofs than in STAT 510 and 511.",
    "credits": "3"
  },
  {
    "course_name": "Theory of Statistics II",
    "dept": "STAT",
    "num": "771",
    "desc": "Prerequisite: STAT 770.\nIntroduction to multivariate distributions; sampling distributions, derivation, and use; estimation of parameters, testing hypothesis; multiple regression and correlation; simple experimental designs; introduction to nonparametric statistics; discrimination.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Statistics",
    "dept": "STAT",
    "num": "799",
    "desc": "Prerequisite: Consent of instructor.",
    "credits": "0-3"
  },
  {
    "course_name": "Swahili I",
    "dept": "SWAH",
    "num": "101",
    "desc": "\nIntroduction to Swahili. A foundation in listening, speaking, writing, and reading the basic grammatical structures and vocabulary of Swahili. Aspects of Swahili/African culture will be introduced and highlighted as essential components toward achieving communicative competence.",
    "credits": "4"
  },
  {
    "course_name": "Swahili II",
    "dept": "SWAH",
    "num": "102",
    "desc": "Prerequisite: SWAH 101 or equivalent.\nA continuation of Swahili 101. A foundation in listening, speaking, writing, and reading the basic grammatical structures and vocabulary of Swahili. Aspects of Swahili/African culture will be introduced and highlighted as essential components toward achieving communicative competence.",
    "credits": "4"
  },
  {
    "course_name": "Swahili III",
    "dept": "SWAH",
    "num": "201",
    "desc": "Prerequisite: SWAH 102.\nContinuation of Swahili II.  Further development of functional skills.  Intensive practice of spoken and written Swahili.",
    "credits": "4"
  },
  {
    "course_name": "Swahili IV",
    "dept": "SWAH",
    "num": "202",
    "desc": "Prerequisite: SWAH 201.\nContinuation of Swahili III.  Further development of functional skills.  Intensive practice of spoken and written Swahili.",
    "credits": "4"
  },
  {
    "course_name": "Theatre Forum",
    "dept": "THTRE",
    "num": "080",
    "desc": "\nSpecial topics presentations for theatre majors.",
    "credits": "0"
  },
  {
    "course_name": "Concepts of Theatre Production",
    "dept": "THTRE",
    "num": "162",
    "desc": "\nAn orientation to the various areas of theatrical production in the rehearsal and performance process. Participation in a production onstage or behind the scenes required.",
    "credits": "1"
  },
  {
    "course_name": "Run Crew",
    "dept": "THTRE",
    "num": "211",
    "desc": "Prerequisite: concurrently enrolled with THTRE 369.\nWork on run crew (sets, props, light or sound board) for theatrical production.",
    "credits": "0-2"
  },
  {
    "course_name": "Wardrobe Crew",
    "dept": "THTRE",
    "num": "212",
    "desc": "Corequisite: THTRE 368 or may be taken alone.\nWork on wardrobe crew for a theatrical production.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to the Art of Film",
    "dept": "THTRE",
    "num": "235",
    "desc": "\nSurvey of Cinema, including history, analysis and the process of production.  Will include film screenings outside of regular class meetings.",
    "credits": "3"
  },
  {
    "course_name": "Stage Movement",
    "dept": "THTRE",
    "num": "260",
    "desc": "\nA study of the technique of stage movement and an investigation of the language of gesture.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Acting",
    "dept": "THTRE",
    "num": "261",
    "desc": "\nTheory and practice of fundamental skills and techniques of acting. Major emphasis is on freeing and training the individual’s imagination, intellect, body, and voice through designed exercise and performed scenes.",
    "credits": "3"
  },
  {
    "course_name": "Oral Interpretation of Literature",
    "dept": "THTRE",
    "num": "263",
    "desc": "\nTechniques of reading from the printed page, selecting portions from various forms of literature, including narrative poetry, essay, lyric, sonnet, nonfictional prose, scenes from plays, and selected short stories.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Improvisation I, II",
    "dept": "THTRE",
    "num": "265",
    "desc": "\nIntroduction to the techniques of improvisation with the emphasis upon practical participation.",
    "credits": "3"
  },
  {
    "course_name": "Techniques of Makeup",
    "dept": "THTRE",
    "num": "268",
    "desc": "\nTechniques of makeup for the stage.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Theatre",
    "dept": "THTRE",
    "num": "270",
    "desc": "\nA comprehensive introduction to theatre: basic elements of theatre and theatre production, theatre history, dramatic literature, multicultural theatre traditions and perspectives, and the theatre experience.",
    "credits": "3"
  },
  {
    "course_name": "Script Analysis",
    "dept": "THTRE",
    "num": "280",
    "desc": "\nExamination of the play script to develop a common vocabulary and method for analyzing a script.",
    "credits": "3"
  },
  {
    "course_name": "Vocal Expression for Actors",
    "dept": "THTRE",
    "num": "300",
    "desc": "Prerequisite: Consent of instructor.\nStudy and application of vocal techniques for stage productions; emphasis on development of the actor’s vocal mechanism.",
    "credits": "3"
  },
  {
    "course_name": "Storytelling",
    "dept": "THTRE",
    "num": "344",
    "desc": "\nTechniques of storytelling to people of all ages. History and cultural importance of storytelling. Fictional and personal storytelling will be covered.",
    "credits": "2"
  },
  {
    "course_name": "Intermediate Acting",
    "dept": "THTRE",
    "num": "361",
    "desc": "Prerequisite: THTRE 261 and consent of instructor.\nEmphasis upon expanding the actor’s capabilities through more advanced scene work and character study.",
    "credits": "3"
  },
  {
    "course_name": "Scene Painting",
    "dept": "THTRE",
    "num": "364",
    "desc": "\nPractical application of painting techniques for the stage.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Theatre Management",
    "dept": "THTRE",
    "num": "366",
    "desc": "\nNon-profit theatre management, including budgeting, marketing, box office, and development practices, plus examination of relevant history.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Technical Production",
    "dept": "THTRE",
    "num": "368",
    "desc": "\nBasic techniques, equipment and materials used in scenery construction and theatrical drafting.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Theatrical Design",
    "dept": "THTRE",
    "num": "369",
    "desc": "\nAn exploration of the four areas of stage design: sets, lights, costumes, and sound. Includes examination of relevant history and technology in these areas. Emphasis is on the design process and design development.",
    "credits": "3"
  },
  {
    "course_name": "Opera Workshop",
    "dept": "THTRE",
    "num": "475",
    "desc": "\nPrinciples and techniques of operatic and musical theatre production, with emphasis on class rehearsal and performance of selected scenes from opera and musical drama; brief survey of the history of opera.",
    "credits": "1-6"
  },
  {
    "course_name": "Honors Project",
    "dept": "THTRE",
    "num": "499",
    "desc": "",
    "credits": "3"
  },
  {
    "course_name": "Advanced Stage Movement",
    "dept": "THTRE",
    "num": "560",
    "desc": "\nStudy in the physical development of character and advanced techniques of stage movement.",
    "credits": "3"
  },
  {
    "course_name": "Stage Management",
    "dept": "THTRE",
    "num": "563",
    "desc": "\nTheory and practice of stage management in the professional and nonprofessional theatre. Emphasis is on the organization of all areas of theatre knowledge needed for the running of theatrical productions.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Directing",
    "dept": "THTRE",
    "num": "565",
    "desc": "Prerequisite: THTRE 261.\nPrinciples, processes and techniques of directing for the theatre.",
    "credits": "3"
  },
  {
    "course_name": "Rehearsal Techniques",
    "dept": "THTRE",
    "num": "566",
    "desc": "Prerequisite: Concurrent enrollment in THTRE 765 or 783 or 779.\nA laboratory course for students enrolled in performance and production classes.",
    "credits": "0-12"
  },
  {
    "course_name": "Costume Design",
    "dept": "THTRE",
    "num": "567",
    "desc": "Prerequisite: THTRE 367.\nIntroduction to the theory and practice of costume design for stage.",
    "credits": "3"
  },
  {
    "course_name": "Scene Design",
    "dept": "THTRE",
    "num": "568",
    "desc": "Prerequisite: THTRE 368 and THTRE 369.\nExamination of the role of scene design in theatre, principles and techniques of design. Development, presentation, and synthesis of design images with the scripted play.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Technical Production",
    "dept": "THTRE",
    "num": "569",
    "desc": "Prerequisite: THTRE 368.\nIndependent study in advanced technical theatre problems.",
    "credits": "3"
  },
  {
    "course_name": "History of Theatre I",
    "dept": "THTRE",
    "num": "572",
    "desc": "Prerequisite: THTRE 370.\nA survey of the development of the theatre from ancient times to 1700.",
    "credits": "3"
  },
  {
    "course_name": "History of Theatre II",
    "dept": "THTRE",
    "num": "573",
    "desc": "Prerequisite: Junior standing or consent of instructor.\nA survey of the development of the theatre from 1700 to the present.",
    "credits": "3"
  },
  {
    "course_name": "Lighting Design",
    "dept": "THTRE",
    "num": "579",
    "desc": "Prerequisite: THTRE 369.\nTheory and practice of theatrical lighting design, control systems, projection equipment, and lighting consulting. Production work with KSU Theatre season required.",
    "credits": "3"
  },
  {
    "course_name": "Music Theatre Workshop",
    "dept": "THTRE",
    "num": "580",
    "desc": "Prerequisite: MUSIC 202, two semesters of voice; THTRE 261; and DANCE 380; or consent of instructor.\nPrinciples and techniques of musical theatre production with emphasis on rehearsal and performance of selected scenes from musical theatre. Dance, music, and theatre are studied as integrated elements within the musical theatre genre. Culminates in a public performance.",
    "credits": "2"
  },
  {
    "course_name": "Senior Seminar",
    "dept": "THTRE",
    "num": "599",
    "desc": "\nStudents in their final year of study will develop skills for professional presentation and create a portfolio or audition based on the standards developed for the URTA National Unified Auditions/Interviews.",
    "credits": "3"
  },
  {
    "course_name": "Internship In Theatre",
    "dept": "THTRE",
    "num": "610",
    "desc": "Prerequisite: THTRE 261 or THTRE 368; junior standing and consent of supervising faculty member and approval of faculty.\nSupervised participation in an internship at a professional theatre.",
    "credits": "0-6"
  },
  {
    "course_name": "Topics in Theatre",
    "dept": "THTRE",
    "num": "630",
    "desc": "Prerequisite: Junior standing and consent of instructor.\nSelected topics in theatre.",
    "credits": "1-4"
  },
  {
    "course_name": "Professional Development",
    "dept": "THTRE",
    "num": "661",
    "desc": "Prerequisite: 12 hours in theatre, music, and/or dance.\nStudy of audition techniques including supervised preparation of appropriate material. Business aspects of professional theatre, including unions, contracts, and professional ethics.",
    "credits": "1"
  },
  {
    "course_name": "Playwriting",
    "dept": "THTRE",
    "num": "662",
    "desc": "\nTheoretical study and practical application of techniques of playwriting with regard to plot, characters, and production; emphasis on the one-act form.",
    "credits": "3"
  },
  {
    "course_name": "Creative Drama",
    "dept": "THTRE",
    "num": "664",
    "desc": "Prerequisite: Junior standing.\nThe development of creative imagination and personal well-being through theatre games, improvisation, storytelling, and puppetry for use in educational and recreational settings.",
    "credits": "3"
  },
  {
    "course_name": "Drama Therapy with Special Populations",
    "dept": "THTRE",
    "num": "665",
    "desc": "Prerequisite: Junior standing.\nThe therapeutic uses of drama in the development of creative imagination, self expression, and social relatedness with special populations such as clients who have developmental disabilities, physical disabilities, health issues, or are aging.",
    "credits": "3"
  },
  {
    "course_name": "Period Styles for the Theatre 1",
    "dept": "THTRE",
    "num": "667",
    "desc": "Prerequisite: THTRE 572 or concurrent enrollment.\nSurvey of historical styles of architecture, furnishings, and clothing in relation to theatrical design and the history of the theatre from the Greeks to 1800.",
    "credits": "3"
  },
  {
    "course_name": "Period Styles for the Theatre 2",
    "dept": "THTRE",
    "num": "668",
    "desc": "Prerequisite: THTRE 573 or concurrent enrollment.\nSurvey of historical styles of architecture, furnishings, and clothing in relation to theatrical design and the history of the theatre from 1800 to present.",
    "credits": "3"
  },
  {
    "course_name": "Playback Theatre",
    "dept": "THTRE",
    "num": "670",
    "desc": "\nImprovisational theatre form in which actors listen to stories told by audience and improvisationally act the story out. Students will learn playback acting forms and how to conduct a session. Playback is often used as a technique by drama therapists in performance and in therapy sessions.",
    "credits": "1-3"
  },
  {
    "course_name": "American Ethnic Theatre",
    "dept": "THTRE",
    "num": "672",
    "desc": "Prerequisite: Junior standing.\nDrama and stagecraft of ethnic groups in the United States, including the theatre of African, Asian, Hispanic, Jewish, and Native Americans.",
    "credits": "3"
  },
  {
    "course_name": "Theatre for Conflict Resolution",
    "dept": "THTRE",
    "num": "673",
    "desc": "Prerequisite: Junior standing.\nDrama and theatre techniques used to explore the nature of conflict and how to promote collaboration through action.",
    "credits": "3"
  },
  {
    "course_name": "Drama Therapy with Adolescents",
    "dept": "THTRE",
    "num": "674",
    "desc": "Prerequisite: Junior standing.\nThe therapeutic uses of drama with adolescents, including normal development, youth-at-risk, ESL, SED, and BD adolescents.",
    "credits": "3"
  },
  {
    "course_name": "Drama Therapy with Older Adults",
    "dept": "THTRE",
    "num": "675",
    "desc": "Prerequisite: Junior standing.\nThe therapeutic uses of drama with older adults, focusing on the development of life review, social relatedness, and creative self-expression in the here and now.",
    "credits": "1-3"
  },
  {
    "course_name": "Practicum in Theatre",
    "dept": "THTRE",
    "num": "710",
    "desc": "Prerequisite: THTRE 160 or 261 or 368; junior standing; consent of supervising faculty member and approval of faculty members are required.\nSupervised participation in a position of major responsibility.",
    "credits": "0-6"
  },
  {
    "course_name": "Topics in Technical Theatre",
    "dept": "THTRE",
    "num": "711",
    "desc": "Prerequisite: THTRE 368 and consent of instructor.\nSelected topics in creative techniques and investigation for technical theatre.",
    "credits": "3"
  },
  {
    "course_name": "Theatre Management",
    "dept": "THTRE",
    "num": "712",
    "desc": "\nTheatre management, promotion, finance, organization; emphasis on contract negotiations and use of facilities.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Drama Therapy",
    "dept": "THTRE",
    "num": "760",
    "desc": "Prerequisite: THTRE 664 or 665.\nStudy of theory and practice in the use of drama as therapy, including assessment and treatment, individual and group practice, and psychodrama.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Acting",
    "dept": "THTRE",
    "num": "761",
    "desc": "Prerequisite: THTRE 361 and consent of instructor.\nStudies in style, technique, and characterization.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Playwriting",
    "dept": "THTRE",
    "num": "762",
    "desc": "Prerequisite: THTRE 662.\nFurther study in the writing of drama; emphasis on problems of writing the full-length play.",
    "credits": "3"
  },
  {
    "course_name": "Early American Theatre",
    "dept": "THTRE",
    "num": "764",
    "desc": "Prerequisite: Junior standing.\nStudies in the drama and stagecraft of the colonies and the United States from the beginnings to 1900.",
    "credits": "3"
  },
  {
    "course_name": "Practice in Directing",
    "dept": "THTRE",
    "num": "765",
    "desc": "Prerequisite: Consent of instructor.\nA lecture-lab course with emphasis on directing dramatic productions under performance conditions.",
    "credits": "3"
  },
  {
    "course_name": "Creative Arts Therapies",
    "dept": "THTRE",
    "num": "770",
    "desc": "\nSurvey of five creative arts therapy modalities: drama/ psychodrama, art, poetry/bibliotherapy, music, and dance/movement. Instruction in theory and hands-on experience with each modality, as well as reading, discussion and methods for using modalities interdisciplinarily.",
    "credits": "3"
  },
  {
    "course_name": "Theatrical Design Studio",
    "dept": "THTRE",
    "num": "780",
    "desc": "Prerequisite: THTRE 567, 568, 569, or 579.\nAdvanced problems in conceptualization and realization of design, including sets, costumes, lights and technical production. Emphasis on advanced techniques in research, analysis, and production problems.",
    "credits": "0-3"
  },
  {
    "course_name": "Women in Theatre",
    "dept": "THTRE",
    "num": "782",
    "desc": "\nA history of the contributions made by women in theatre as playwrights, managers, directors, and performers; contemporary women in theatre and their experiments in expressing women’s consciousness.",
    "credits": "3"
  },
  {
    "course_name": "Practice in Acting",
    "dept": "THTRE",
    "num": "783",
    "desc": "Prerequisite: THTRE 361 and consent of instructor.\nAdvanced studies in characterization with emphasis on communicating with the director. Taught in conjunction with the Practice in Directing workshop.",
    "credits": "3"
  },
  {
    "course_name": "Psychodrama",
    "dept": "THTRE",
    "num": "784",
    "desc": "\nTheory and practice of psychodrama as a treatment modality for use in drama therapy.",
    "credits": "3"
  },
  {
    "course_name": "Sociodrama",
    "dept": "THTRE",
    "num": "785",
    "desc": "\nTheory and practice of sociodrama as a therapeutic and educational modality for use in drama therapy.",
    "credits": "3"
  },
  {
    "course_name": "Projects in Theatre",
    "dept": "THTRE",
    "num": "799",
    "desc": "Prerequisite: Junior standing and consent of instructor.\nIndividual guided work in selected area.",
    "credits": "1-4"
  },
  {
    "course_name": "Multi-rotor Flight Lab",
    "dept": "UAS",
    "num": "115",
    "desc": "\nAb initio through advanced flight training on multi-rotor unmanned aircraft, beginning with small quad-copters and progressing to larger, more complex multi-rotor platforms. This course establishes the foundation for additional training necessary to become a multi-rotor flight instructor. Students will also receive training in the regulations contained in 14 CFR Part 107 (commercial rules for small UAS), and will be required to earn their Remote Pilot Certificate with sUAS rating during the course.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Unmanned Aircraft Systems",
    "dept": "UAS",
    "num": "270",
    "desc": "\nIntroduction to the history of Unmanned Aircraft Systems and survey of current UAS platforms, terminology, challenges to airspace integration and operational theory.",
    "credits": "3"
  },
  {
    "course_name": "UAS Safety Fundamentals",
    "dept": "UAS",
    "num": "272",
    "desc": "\nIntroduction to aviation safety, with an emphasis on best practices for safe operation of unmanned aircraft systems. Topics include safety/risk assessments, human factors, crew resource management, aeronautical decision-making, risk management, and safety assurance.",
    "credits": "3"
  },
  {
    "course_name": "Small Unmanned Aircraft Maintenance I",
    "dept": "UAS",
    "num": "275",
    "desc": "Prerequisite: ECET 100.\nThis course provides students with the knowledge and skill necessary to repair and maintain both fixed- and rotary-wing aircraft during field operations and to ensure continued airworthiness throughout the service life of the aircraft. Instruction emphasizes safe practices, provide an introduction to basic shop tools and machinery used in maintaining sUAS, and develop fundamental skills in platform fabrication and the troubleshooting/repair of the circuits, subsystems and components typically found on sUAS aircraft.",
    "credits": "3"
  },
  {
    "course_name": "Small Unmanned Aircraft Maintenance II",
    "dept": "UAS",
    "num": "285",
    "desc": "Prerequisite: UAS 275.\nThis course provides students with advanced knowledge and a high level of skill in the maintenance and repair of both fixed- and rotary-wing unmanned aircraft and associated systems. The concept of continued airworthiness is emphasized. Topics include advanced techniques in the fabrication and repair of small unmanned aircraft systems and airframes, maintenance of ground support systems and principles of electronic and integrated circuit maintenance, troubleshooting and repair.",
    "credits": "3"
  },
  {
    "course_name": "Unmanned Aircraft Systems Powerplant Fundamentals",
    "dept": "UAS",
    "num": "300",
    "desc": "\nA study of the principles of operation, design features, and operating characteristics of various powerplants used in unmanned aircraft vehicles. Includes inspection procedures and operational theory of current electric, piston, hybrid, and turbine propulsion systems.",
    "credits": "3"
  },
  {
    "course_name": "Unmanned Aircraft Flight Instructor Ground School",
    "dept": "UAS",
    "num": "312",
    "desc": "Prerequisite: PPIL 113, UAS 115.\nIntended to prepare the student for the role of UAS flight instructor. Focuses on the fundamentals of flight instruction. Lecture topics cover the techniques and the procedures necessary to generate, organize and present lessons in instructional environment while building necessary skills and emphasizing aspects of instruction necessary to ensure student competencies in the areas of UAS field and flight operations.",
    "credits": "3"
  },
  {
    "course_name": "Multi-rotor Instructor Flight Lab",
    "dept": "UAS",
    "num": "314",
    "desc": "Prerequisite: PPIL 113, UAS 115.\nThis course refines advanced multi-rotor skills and provides the practical experience necessary to produce competent multi-rotor flight instructors.",
    "credits": "1"
  },
  {
    "course_name": "Command and Control Links and Circuitry",
    "dept": "UAS",
    "num": "353",
    "desc": "Prerequisite: UAS 275 or consent of instructor.\nThis course provides a detailed examination of the theory and design of UAS command and control (2C) systems and applies this knowledge to develop a thorough understanding of the principles used in the design, maintenance and repair of 2C circuits and subsystem components. Topics include design choices in component selection, circuit and overall system design concepts and troubleshooting.",
    "credits": "3"
  },
  {
    "course_name": "Unmanned Aircraft Fixed-wing Flight Lab",
    "dept": "UAS",
    "num": "357",
    "desc": "Prerequisite: UAS 314 and PPIL 114.\nProvides an introduction to the use of an external pilot (EP) console to control fixed-wing unmanned aircraft systems (UAS). In the event of a lost communications link, avionics or autopilot failure or other emergency, the external pilot is critical to human-in-the-loop operation of the UAS in effecting a successful recovery of the aircraft. This course develops the skills necessary to ensure students are capable of conducting safe EP operation of fixed-wing UAS during adverse flight conditions.",
    "credits": "2"
  },
  {
    "course_name": "Advanced Unmanned Aircraft Fixed-wing Flight Lab",
    "dept": "UAS",
    "num": "367",
    "desc": "Prerequisite: UAS 357 and UAS 312.\nThe UAS pilot-in-command (PIC), also referred to as the operator-in-command (OIC), is the person responsible for safe and successful flight operations. At times, the PIC/OIC also assumes the duties of the air vehicle operator (AVO) stationed at the ground control station. Not only must the PIC/OIC/AVO demonstrate the highest proficiency as a pilot, but also be knowledgeable in all aspects of field operations, including standard operating procedures (SOPs), applicable regulations and aircraft performance. The individual acting in this capacity is also a manager and field general, responsible for the activities of the others participating in flight operations. This course prepares the student to oversee professional flight operations. This course prepares the student to oversee professional flight operations as the PIC.",
    "credits": "2"
  },
  {
    "course_name": "Small Unmanned Aircraft Systems Design and Construction",
    "dept": "UAS",
    "num": "370",
    "desc": "Prerequisite: PPIL 113.\nTopics include: Unmanned Aircraft System platform, payload and component design and interfacing, system and vehicle maintenance, and systems integration.",
    "credits": "3"
  },
  {
    "course_name": "Small Unmanned Aircraft Design and Construction for Non-Aviators",
    "dept": "UAS",
    "num": "373",
    "desc": "Corequisite: UAS 270.\nTopics include: Unmanned Aircraft System platform, payload and component design and interfacing, system and vehicle maintenance, and systems integration. Intended for non-pilot majors and those without the FAA certifications and ratings required for UAS 370.",
    "credits": "3"
  },
  {
    "course_name": "Crew Resource Management for Unmanned Aircraft Systems",
    "dept": "UAS",
    "num": "387",
    "desc": "Prerequisite: UAS 115 and PPIL 113.\nThis course provides students majoring in unmanned aircraft systems the ability to use all available resources to ensure safe and efficient flight. During the first eight weeks of the semester, aircraft crew performance is reviewed to include the background and philosophy of crew resource management (CRM) communication, decision behavior, team building, workload management, and situational awareness. The second eight weeks of the semester is devoted to those aspects of CRM that are unique to the unmanned aircraft systems field operations and flight environments. Topics include an introduction to pilot-in-command/air vehicle operator-payload operator communications in a simulated multi-crew member flight and ground station environment.",
    "credits": "3"
  },
  {
    "course_name": "Fixed-wing Instructor Flight Lab",
    "dept": "UAS",
    "num": "417",
    "desc": "Prerequisite: UAS 367.\nThis is the culminating course intended to prepare students for roles as fixed-wing unmanned aircraft flight instructors. This course furthers develop and refine the flying skills necessary to assume control of the aircraft during adverse circumstances or unusual aircraft attitudes induced by a less experienced pilot. The fixed-wing instructor-in-training is required to demonstrate, in practice, the skills and knowledge obtained in earlier courses covering crew resource management and flight instruction as well as achievement of a high level of piloting skills. Upon successful completion of this course, the student is qualified as a K-State instructor on fixed-wing platforms and as pilot-in-command/operator-in-command during research missions authorized by the unmanned aircraft systems program.",
    "credits": "2"
  },
  {
    "course_name": "Autonomous Flight Simulation Lab",
    "dept": "UAS",
    "num": "461",
    "desc": "Prerequisite: UAS 370.\nThis course provides the student with simulation on high-end, sophisticated, proprietary autopilot systems in preparation for field operations flying aircraft equipped with similar autopilot/avionics packages.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Autopilots and Mission Planning for Non-Aviators",
    "dept": "UAS",
    "num": "463",
    "desc": "Prerequisite: UAS 373.\nFocus is on mission planning and operations within the context of the simulated environment. Students are introduced to commercial, open source and/or proprietary autopilots and are required to complete simulated training missions with the ultimate goal of demonstrating skills competency and knowledge acquisition through evaluations of proficiency (e.g., through “check-outs” or “check-rides”). Students integrate autopilots into selected fixed-wing platforms. Intended for non-UAS majors and those without the FAA certifications and ratings required for UAS 370, UAS 461 and UAS 465.",
    "credits": "3"
  },
  {
    "course_name": "Autopilot Integration",
    "dept": "UAS",
    "num": "465",
    "desc": "Prerequisite: UAS 370.\nUsing open source ground station software and commercial-off-the-shelf (COTS), open source autopilot firmware and hardware, students learn techniques for integrating autopilots into their selected fixed-wing platform and for exploring precision autonomous flight in preparation for conducting field operations to acquire remotely sensed data.",
    "credits": "2"
  },
  {
    "course_name": "Small Unmanned Aircraft Systems Payloads",
    "dept": "UAS",
    "num": "467",
    "desc": "Prerequisite: UAS 465.\nCourse content covers various types of sUAS sensor packages and appropriate applications, preparing the student to properly select sensors based on mission profile, data needs and mission objectives. Students develop, design and construct a payload for integration into previously constructed aircraft in preparation for conducting missions to obtain data for post-flight processing.",
    "credits": "3"
  },
  {
    "course_name": "Flight and Field Operations",
    "dept": "UAS",
    "num": "470",
    "desc": "Prerequisite: UAS 461 and UAS 465.\nEmphasis is on advanced unmanned aircraft systems operations in the live flight environment with a focus on safety and crew resource management. Emphasis is on experiential learning. Students are required to travel to an area designated for flight operations.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Processing Remotely Sensed Data",
    "dept": "UAS",
    "num": "474",
    "desc": "Prerequisite: UAS 461 and UAS 465; or UAS 463; or consent of instructor.\nStudents are introduced to basic theory, history, and practical applications of remote sensing technology, with an emphasis on high spatial resolution multispectral aerial imagery collected using unmanned aircraft systems. Other topics include geographic information systems, aerial image interpretation, sensor resolution, orthomosaicing, georegistration, vegetation indices, and image classification.",
    "credits": "3"
  },
  {
    "course_name": "Data Acquisition and Post-processing",
    "dept": "UAS",
    "num": "475",
    "desc": "Prerequisite: UAS 474\nStudents build upon the basic image processing skills gained in the previous course, expanding their knowledge of common aerial image data processing tasks using industry-standard software packages. Aerial data collection methodologies are introduced, including consideration of aerial mission flight parameters.",
    "credits": "3"
  },
  {
    "course_name": "Low Altitude Remote Sensing Project Development",
    "dept": "UAS",
    "num": "476",
    "desc": "Prerequisite: UAS 475\nStudents gain practical experience collecting and processing their own high resolution aerial datasets using multirotor and/or fixed-wing UAS, and are instructed in proven workflows for successful commercial UAS mapping operations. The topic of payload selection and integration will enable a project to collect data for subsequent processing.",
    "credits": "3"
  },
  {
    "course_name": "Honors First-Year Seminar",
    "dept": "UHP",
    "num": "189",
    "desc": "Prerequisite:  Admitted to the university honors program or instructor permission.\nSelected topics seminar for new members of the University Honors Program. Focal topics will vary by section, but all seminars will overview student requirements and consider potential benefits and opportunities associated with the program.",
    "credits": "1"
  },
  {
    "course_name": "Firearms, Cartridges and Ballistics",
    "dept": "WOEM",
    "num": "201",
    "desc": "Prerequisite: Available only to Wildlife and Outdoor Enterprise Management majors.\nThis course will cover the types and functions of firearms used in hunting/shooting sports to include rifles, shotguns and handguns. Basic firearms maintenance will also be covered in this course.",
    "credits": "1"
  },
  {
    "course_name": "Rifle and Handgun Range Design, Construction and Operations",
    "dept": "WOEM",
    "num": "202",
    "desc": "Prerequisite: Available only to Wildlife and Outdoor Enterprise Management majors.\nThis course covers the design and construction of rifle/handgun shooting ranges based on national standards. The course will also cover operational issues including events planning and implementation.",
    "credits": "1"
  },
  {
    "course_name": "Bowhunting Equipment and Skills",
    "dept": "WOEM",
    "num": "203",
    "desc": "Prerequisite: Available only to Wildlife and Outdoor Enterprise Management majors.\nThis course covers the bowhunting equipment currently used for hunting. Bowhunting skills to include distance estimation, shot placement, etc. are also covered in this course.",
    "credits": "1"
  },
  {
    "course_name": "Hunter Education Instructor",
    "dept": "WOEM",
    "num": "204",
    "desc": "Prerequisite: Available only to Wildlife and Outdoor Enterprise Management and Park Management and Conservation majors.\nThis course will provide information and training necessary for qualification as a certified hunter education instructor.",
    "credits": "1"
  },
  {
    "course_name": "Sporting Clays Range Development and Operations",
    "dept": "WOEM",
    "num": "205",
    "desc": "Prerequisite: Available only to Wildlife and Outdoor Enterprise Management majors.\nThis course will cover the history and present day rules of sporting clays, the development of sporting clays ranges and their ongoing operations and maintenance.",
    "credits": "1"
  },
  {
    "course_name": "Trap and Skeet Range Development and Operations",
    "dept": "WOEM",
    "num": "206",
    "desc": "Prerequisite: Available only to Wildlife and Outdoor Enterprise Management majors.\nThis course will cover the development of “trap” and “skeet” shooting ranges. Operating principles will be covered to include staffing, event planning and implementation.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Wildlife and Outdoor Enterprise Management",
    "dept": "WOEM",
    "num": "250",
    "desc": "Prerequisite: Available only to Wildlife and Outdoor Enterprise Management majors.\nThis course covers the wildlife and outdoor enterprise management business and profession in North America and worldwide.",
    "credits": "1"
  },
  {
    "course_name": "Principles & Practices of Freshwater Fishing and Guiding",
    "dept": "WOEM",
    "num": "300",
    "desc": "Prerequisite: Available only to Wildlife and Outdoor Enterprise Management majors.\nProfessional principles and practices associated with freshwater fishing in North America to include: ethics, species habitat requirements, daily and seasonal activities of each game species, methods of harvest, post- harvest handling and clientele interactions.",
    "credits": "2"
  },
  {
    "course_name": "Fauna and Flora of the Great Plains",
    "dept": "WOEM",
    "num": "350",
    "desc": "Prerequisites: BIOL 198. For WOEM and PMC majors only.\nIdentification, natural history, and distributions of fauna and flora species occurring in the Great Plains.",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research in Wildlife and Outdoor Enterprise Management",
    "dept": "WOEM",
    "num": "495",
    "desc": "Prerequisite: Instructor permission.\nUndergraduate students work with faculty mentors on projects involving various elements of research in WOEM including identifying a problem, designing and conducting experiments, interpreting and communicating the research results. The completed project must be presented at a professional forum, and students are required to write a final project report on completion of their project.",
    "credits": "0-3"
  },
  {
    "course_name": "Big Game Management",
    "dept": "WOEM",
    "num": "555",
    "desc": "Prerequisite: BIOL 198, available only to students majoring in Wildlife &amp; Outdoor Enterprise Management, Park Management &amp; Conservation, or Biology.\nProfessional principles and practices associated with hunting North American Big Game to include: ethics, species habitat requirements, daily and seasonal activity of each species, methods of harvest, post-harvest handling and clientele interactions.",
    "credits": "3"
  },
  {
    "course_name": "Upland Gamebird Management",
    "dept": "WOEM",
    "num": "560",
    "desc": "Prerequisite: BIOL 198, available only to students majoring in Wildlife and Outdoor Enterprise Management, Park Management &amp; Conservation, or Biology.\nProfessional principles and practices associated with hunting upland game birds in North America to include: ethics, laws, species’ habitat requirements, daily and seasonal activities of each species, methods of harvest, dog handling, post-harvest handling and clientele interactions.",
    "credits": "3"
  },
  {
    "course_name": "Waterfowl and Wetlands Management",
    "dept": "WOEM",
    "num": "561",
    "desc": "Prerequisite: BIOL 198, available only to students majoring in Wildlife &amp; Outdoor Enterprise Management, Park Management &amp; Conservation, or Biology.\nThis course explores the natural history of waterfowl and wetland birds and habitat management. It includes basic information on the habitat requirements, management techniques, ranges, migration patters, history, problems, diseases, and identification of the waterfowl resources of North America. Professional principles and practices associated with hunting waterfowl species in North America to include: ethics, laws, species’ habitat requirements, and daily and seasonal activities of each species, methods of harvest, dog handling, post-harvest handling and clientele interactions. Includes the following success skills: Communicates Effectively and Maintains Professional Skills and Attitudes.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Wildlife Habitat Management",
    "dept": "WOEM",
    "num": "562",
    "desc": "Prerequisite: BIOL 433.\nTheory and practice of managing terrestrial and aquatic vegetation for wildlife production.",
    "credits": "4"
  },
  {
    "course_name": "Internship for Wildlife and Outdoor Enterprise Management",
    "dept": "WOEM",
    "num": "570",
    "desc": "Prerequisite: Available only to students majoring in Wildlife &amp; Outdoor Enterprise Management.\nIntensive, paid practical experience with an approved hunting and/or shooting sports and/or fishing business.",
    "credits": "6-10"
  },
  {
    "course_name": "Problems in Wildlife and Outdoor Enterprise Management",
    "dept": "WOEM",
    "num": "590",
    "desc": "\nIndependent study and/or research project development guided by faculty in Wildlife and Outdoor Enterprise Management.",
    "credits": "0-6"
  },
  {
    "course_name": "Wildlife and Outdoor Enterprise Management Senior Seminar",
    "dept": "WOEM",
    "num": "595",
    "desc": "Prerequisite: Senior standing.  Available only to Wildlife and Outdoor Enterprise Management majors.\nThis course will be used as a capstone course for the Wildlife and Outdoor Enterprise Management curriculum; to include case studies and field experience reviews.",
    "credits": "1"
  },
  {
    "course_name": "Wildlife and Outdoor Enterprise Management Study Abroad",
    "dept": "WOEM",
    "num": "596",
    "desc": "Prerequisite: Instructor permission.\nSeminar and travel course designed to prepare students before an international study abroad experience focused on several facets of wildlife and conservation, natural resources, diseases, and land management research. Upon completion of travel, students will analyze, critique, and report their experiences. Course will focus on appropriate oral and written documentation of the experience.",
    "credits": "3"
  },
  {
    "course_name": "Human-Wildlife Conflicts",
    "dept": "WOEM",
    "num": "620",
    "desc": "Prerequisite: BIOL 433\nThis course explores the theory and practice of assessing and controlling damage done by wild and feral vertebrate animals, especially mammals and birds. Content covers the philosophical, biological, and practical basis for conducting vertebrate pest control. It includes basic information on use of traps, toxicants, repellents, exclusion and other wildlife control methods. Emphasis is on protecting agricultural crops and livestock, forest resources, and property.",
    "credits": "4"
  }
]
}
